
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dG76n", function(module, exports) {
$parcel$export(module.exports, "SearchResultsPage", function () { return $4b1dbc3aa5ecf23f$export$d52600bdf78c25ef; });

var $7VQPk = parcelRequire("7VQPk");

var $bQjAr = parcelRequire("bQjAr");

var $8LaTa = parcelRequire("8LaTa");

var $l2QYX = parcelRequire("l2QYX");

var $8Agh0 = parcelRequire("8Agh0");
const $4b1dbc3aa5ecf23f$export$d52600bdf78c25ef = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $bQjAr.default), {
        name: "search-page",
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l2QYX.default), {
                isShowTryNowLink: true,
                isShowSearchButton: false,
                productKey: "search"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8Agh0.SearchTemplate), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8LaTa.GlobalFooter), {})
        ]
    });
};

});
parcelRegister("8Agh0", function(module, exports) {
$parcel$export(module.exports, "SearchTemplate", function () { return $d0a2331a186b73df$export$b55d021038bb528d; });
/* search-template.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $k9ZIM = parcelRequire("k9ZIM");

var $9ztLs = parcelRequire("9ztLs");

var $fJP6M = parcelRequire("fJP6M");

var $kbpa7 = parcelRequire("kbpa7");

var $lpT0m = parcelRequire("lpT0m");

var $gx3aw = parcelRequire("gx3aw");

var $ea4mV = parcelRequire("ea4mV");

var $2emUn = parcelRequire("2emUn");

var $32ng3 = parcelRequire("32ng3");

var $cN0Nw = parcelRequire("cN0Nw");

var $hZ5Xs = parcelRequire("hZ5Xs");

var $fJkKo = parcelRequire("fJkKo");
parcelRequire("5TJaP");
var $aLBZ0 = parcelRequire("aLBZ0");
const $d0a2331a186b73df$var$ALGOLIA_SEARCH_INDEX_NAME_V3 = "www.atlassian.com.v3";
const $d0a2331a186b73df$var$ALGOLIA_SEARCH_INDEX_NAME_V3_2 = "www.atlassian.com.v3-2";
const $d0a2331a186b73df$var$ALGOLIA_DEV_SEARCH_INDEX_V3 = "www.atlassian.com.v3_dev";
const $d0a2331a186b73df$var$ALGOLIA_FACET_KEY_CATEGORY = "category";
const $d0a2331a186b73df$var$ALGOLIA_FACET_KEY_LOCALE = "locale";
const $d0a2331a186b73df$var$TITLE_ONLY_SEARCH_WORD_COUNT_THRESHOLD = 3;
const $d0a2331a186b73df$export$45f7e7a192bc5fa5 = [
    "All",
    "Articles",
    "Developer Resources",
    "Events",
    "Marketplace",
    "Purchasing FAQ"
];
const $d0a2331a186b73df$export$97f3b895db7ef4f3 = (numResults, latestSearchText, currFilter)=>{
    if (numResults === 0) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "wac.search.pages.num.results.zero",
        defaultMessage: "0 results for {latestSearchText}. Try again with a different term.",
        values: {
            latestSearchText: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                children: latestSearchText
            }),
            currentFilter: currFilter || "All"
        }
    });
    else if (numResults === 1) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "wac.search.pages.num.results.one",
        defaultMessage: "{numResults} result for {latestSearchText} in {currentFilter}",
        values: {
            numResults: numResults,
            latestSearchText: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                children: latestSearchText
            }),
            currentFilter: currFilter || "All"
        }
    });
    else return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "wac.search.pages.num.results.many",
        defaultMessage: "{numResults} results for {latestSearchText} in {currentFilter}",
        values: {
            numResults: numResults,
            latestSearchText: /*#__PURE__*/ (0, $7VQPk.jsx)("strong", {
                children: latestSearchText
            }),
            currentFilter: currFilter || "All"
        }
    });
};
const $d0a2331a186b73df$export$b55d021038bb528d = ()=>{
    const [numberOfHits, setTotalNumberOfHits] = (0, $1oC0p.useState)(0);
    const [hits, setHits] = (0, $1oC0p.useState)([]);
    const [searchText, setSearchText] = (0, $1oC0p.useState)("");
    const [latestSearchText, setLatestSearchText] = (0, $1oC0p.useState)("");
    const [searchState, setSearchState] = (0, $1oC0p.useState)(null);
    const [currFilter, setCurrFilter] = (0, $1oC0p.useState)("All");
    const [facetValues, setFacetValues] = (0, $1oC0p.useState)({});
    const searchHelper = (0, $1oC0p.useRef)();
    const analyticsClient = (0, $k9ZIM.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const [queryId, setQueryId] = (0, $1oC0p.useState)("");
    const [isActive, setIsActive] = (0, $1oC0p.useState)(false);
    const searchInputRef = (0, $1oC0p.useRef)(null);
    const handleFocus = ()=>setIsActive(true);
    const handleBlur = ()=>setIsActive(false);
    const handleChange = (e)=>{
        setSearchText(e.target.value);
    };
    const handleClear = ()=>{
        setSearchText("");
        setIsActive(false);
    };
    const wacAISearchSummaryExperiment = (0, $ea4mV.useExperiment)((0, $ea4mV.experiments).wacAISearchSummaryV2);
    const isAISearchSummaryEnabled = wacAISearchSummaryExperiment.type === "enrolled" && wacAISearchSummaryExperiment.value;
    const { fireUIEvent: fireUIEvent } = (0, $9ztLs.useFireAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    // Use ref to track current fireUIEvent to avoid recreating SearchHelper
    const fireUIEventRef = (0, $1oC0p.useRef)(fireUIEvent);
    fireUIEventRef.current = fireUIEvent;
    const isSearchIndexV3_2Enabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $32ng3.featureFlags).wacSearchIndexV3_2);
    const searchIndex = isSearchIndexV3_2Enabled ? $d0a2331a186b73df$var$ALGOLIA_SEARCH_INDEX_NAME_V3_2 : $d0a2331a186b73df$var$ALGOLIA_SEARCH_INDEX_NAME_V3;
    const facets = [
        $d0a2331a186b73df$var$ALGOLIA_FACET_KEY_CATEGORY,
        $d0a2331a186b73df$var$ALGOLIA_FACET_KEY_LOCALE
    ];
    (0, $2emUn.useFeatureExposed)("wac-search-indexv3", "Test");
    (0, $1oC0p.useEffect)(()=>{
        analyticsClient && createAnalyticsEvent({
            eventName: "searchText",
            eventType: "track",
            action: "loaded",
            actionSubject: "searchPage",
            actionSubjectId: "searchPageForm",
            source: "searchPage",
            eventContainer: "load",
            attributes: {
                searchText: searchText,
                product: "search",
                index: {
                    searchIndex: searchIndex
                }
            }
        }).fire();
    }, [
        analyticsClient,
        createAnalyticsEvent
    ]);
    (0, $1oC0p.useEffect)(()=>{
        var // TODO: fetch filter category names from Algolia instead of hard-coding
        _searchHelper_current;
        searchHelper.current = new (0, $fJkKo.SearchHelper)(searchIndex, facets);
        (_searchHelper_current = searchHelper.current) === null || _searchHelper_current === void 0 ? void 0 : _searchHelper_current.receiveUpdate((results)=>{
            const numberOfHits = results.nbHits;
            const localHits = results.hits.map((hit)=>{
                return (0, $dPABA._)((0, $6ogO3._)({}, hit), {
                    queryID: results.queryID
                });
            });
            const hasNextPage = results.nbPages - 1 > results.page;
            const queryId = results.queryID;
            const facetValuesResponse = results.getFacetValues($d0a2331a186b73df$var$ALGOLIA_FACET_KEY_CATEGORY, {});
            // check if this is a filtered
            const refinements = results.getRefinements() || [];
            const isUsingFilter = !!refinements.find((refinement)=>refinement.attributeName === "category");
            // don't reset filter values if an existing search is just being filtered
            if (Array.isArray(facetValuesResponse) && !isUsingFilter) {
                let newFacetValuesState = {};
                facetValuesResponse.forEach((result)=>{
                    newFacetValuesState = (0, $dPABA._)((0, $6ogO3._)({}, newFacetValuesState), {
                        [result.name]: result.count
                    });
                });
                setFacetValues(newFacetValuesState);
            }
            if (hasNextPage) setSearchState("hasMoreResult");
            else if (localHits.length === 0) setSearchState("noResult");
            else setSearchState("hasResult");
            setTotalNumberOfHits(numberOfHits);
            setHits((prevResult)=>[
                    ...prevResult,
                    ...localHits
                ]);
            setQueryId(queryId);
            // Use ref to get the current fireUIEvent function
            fireUIEventRef.current({
                eventName: "searchResultsPopulated",
                eventType: "ui",
                action: "populated",
                actionSubject: "searchResults",
                source: "searchPage",
                eventContainer: "searchResults",
                attributes: {
                    resultsCount: numberOfHits,
                    searchQuery: results.query || latestSearchText,
                    queryId: results.queryID,
                    currentFilter: currFilter,
                    product: "search",
                    index: {
                        searchIndex: searchIndex
                    }
                }
            });
        });
    // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        window.addEventListener("popstate", ()=>{
            setSearchResults();
        });
        setSearchResults();
    // Reason: Tech Debt - Disable needed to migrate from wac-ufo-segment to ufo-segment
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const setSearchResults = ()=>{
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const searchParam = params.get("q");
        const facet = params.get("f") || "";
        // if facet it present on original page load, set a facetValue so that it displays in filters
        if (facet) setFacetValues({
            [facet]: 1
        });
        if (searchParam) {
            const filter = facet ? facet : "All";
            resetState(searchParam, filter);
            triggerSearch(filter, searchParam);
            createAnalyticsEvent({
                eventName: "browserButton",
                eventType: "ui",
                action: "clicked",
                actionSubject: "browserButton",
                source: "searchPage",
                eventContainer: "browser",
                attributes: {
                    searchText: searchParam,
                    keywordSearchQuery: searchParam,
                    product: "search",
                    index: {
                        searchIndex: searchIndex
                    }
                }
            }).fire();
        }
    };
    function resetState(searchParam, filter) {
        setHits([]);
        setSearchState("loading");
        setSearchText(searchParam);
        setLatestSearchText(searchParam);
        setCurrFilter(filter);
    }
    function triggerSearch(filter, searchParam) {
        var _searchHelper_current, _searchHelper_current1, _searchHelper_current2, _searchHelper_current3, _searchHelper_current4;
        (_searchHelper_current = searchHelper.current) === null || _searchHelper_current === void 0 ? void 0 : _searchHelper_current.removeFacet($d0a2331a186b73df$var$ALGOLIA_FACET_KEY_CATEGORY);
        (_searchHelper_current1 = searchHelper.current) === null || _searchHelper_current1 === void 0 ? void 0 : _searchHelper_current1.setQuery(searchParam);
        (_searchHelper_current2 = searchHelper.current) === null || _searchHelper_current2 === void 0 ? void 0 : _searchHelper_current2.setFacet($d0a2331a186b73df$var$ALGOLIA_FACET_KEY_LOCALE, intl.locale || "en");
        if (filter && filter != "All") (_searchHelper_current3 = searchHelper.current) === null || _searchHelper_current3 === void 0 ? void 0 : _searchHelper_current3.setFacet($d0a2331a186b73df$var$ALGOLIA_FACET_KEY_CATEGORY, filter);
        if (isAISearchSummaryEnabled) {
            var _searchHelper_current5, _searchHelper_current6;
            const searchWordCount = searchParam.split(" ").length;
            if (searchWordCount > $d0a2331a186b73df$var$TITLE_ONLY_SEARCH_WORD_COUNT_THRESHOLD) (_searchHelper_current5 = searchHelper.current) === null || _searchHelper_current5 === void 0 ? void 0 : _searchHelper_current5.setQueryParameter("restrictSearchableAttributes", [
                "title"
            ]);
            else (_searchHelper_current6 = searchHelper.current) === null || _searchHelper_current6 === void 0 ? void 0 : _searchHelper_current6.removeQueryParameter("restrictSearchableAttributes");
        }
        (_searchHelper_current4 = searchHelper.current) === null || _searchHelper_current4 === void 0 ? void 0 : _searchHelper_current4.search();
    }
    function onSearch(filter) {
        if (searchText) {
            if (!filter) filter = "All";
            resetState(searchText, filter);
            triggerSearch(filter, searchText);
            setLatestSearchText(searchText);
            if (filter && filter != "All") window.history.pushState({}, "", `?q=${searchText}&f=${filter}`);
            else window.history.pushState({}, "", `?q=${searchText}`);
            createAnalyticsEvent({
                eventName: "searchText",
                eventType: "ui",
                action: "submitted",
                actionSubject: "searchInput",
                actionSubjectId: "searchPageForm",
                source: "searchPage",
                eventContainer: "searchInput",
                attributes: {
                    searchText: searchText,
                    keywordSearchQuery: searchText,
                    product: "search",
                    index: {
                        searchIndex: searchIndex
                    }
                }
            }).fire();
            if (searchInputRef.current) searchInputRef.current.blur();
        }
        setIsActive(true);
    }
    const renderClearButton = ()=>{
        if (searchText) return /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
            onClick: handleClear,
            "aria-label": "Clear search suggestions",
            "data-testid": "clear-search-button",
            className: (0, $2jatx.default)([
                "_kqswstnw _1xi24bvh _154i1ssb _t9ec1i34 _bfhk1j28 _19itglyw _syaz1hap _80omtlke _1wybf6fq _1e0c1txw _4cvr1h6o _1bah1h6o _1bsbdlk8 _4t3idlk8 _2rko1ssb"
            ]),
            style: {
                "--_k3797e": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light700"))
            },
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _1bsbyh40 _4t3idlk8 _bfhk1hlo _2rkot94y",
                        "_t9ecjyd4"
                    ]),
                    style: {
                        "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                    }
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _1bsbyh40 _4t3idlk8 _bfhk1hlo _2rkot94y",
                        "_t9eczk8b"
                    ]),
                    style: {
                        "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                    }
                })
            ]
        });
        return null;
    };
    function gotoNextPage() {
        var _searchHelper_current;
        (_searchHelper_current = searchHelper.current) === null || _searchHelper_current === void 0 ? void 0 : _searchHelper_current.goToNextPage();
    }
    function onSearchLinkClick(objectId, position) {
        var _searchHelper_current;
        const anonymousId = (0, $gx3aw.Cookie).readCookie("ajs_anonymous_id");
        let decodedAnonymousId;
        if (anonymousId) // the cookie value is URI encoded with quotes on the outside, so decode and remove them
        decodedAnonymousId = decodeURIComponent(anonymousId).replace(/['"]+/g, "");
        (_searchHelper_current = searchHelper.current) === null || _searchHelper_current === void 0 ? void 0 : _searchHelper_current.sendClickEvent({
            objectId: objectId,
            position: position,
            queryId: queryId,
            userToken: decodedAnonymousId
        });
    }
    const translated = {
        searchAtlassian: intl.formatMessage({
            id: "wac.search.pages.search.atlassian",
            defaultMessage: "Search Atlassian"
        }),
        submitSearch: intl.formatMessage({
            id: "wac.search.pages.submit",
            defaultMessage: "Submit"
        }),
        viewMore: intl.formatMessage({
            id: "wac.search.pages.view.more",
            defaultMessage: "View more"
        }),
        endOfResults: intl.formatMessage({
            id: "wac.search.pages.end.of.result",
            defaultMessage: "End of results"
        })
    };
    const filterTranslationMap = {
        "All": intl.formatMessage({
            id: "wac.search.pages.filter.all",
            defaultMessage: "All"
        }),
        "Articles": intl.formatMessage({
            id: "wac.search.pages.filter.developer.articles",
            defaultMessage: "Articles"
        }),
        "Developer Resources": intl.formatMessage({
            id: "wac.search.pages.filter.developer.resources",
            defaultMessage: "Developer Resources"
        }),
        "Events": intl.formatMessage({
            id: "wac.search.pages.filter.events",
            defaultMessage: "Events"
        }),
        "Marketplace": intl.formatMessage({
            id: "wac.search.pages.filter.marketplace",
            defaultMessage: "Marketplace"
        }),
        "Purchasing FAQ": intl.formatMessage({
            id: "wac.search.pages.filter.purchasing.faq",
            defaultMessage: "Purchasing FAQ"
        })
    };
    const searchStateWithResultAndIsNotLoading = (searchState)=>{
        return searchState && searchState != "noResult" && searchState != "loading";
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_p12f4tsx _195g1wug _1tke8stt _1e0c1txw _o5kc1h6o",
            "ais-InstantSearch"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1rjczwfg _1bah1h6o _1bsbcv93 _1u2qftgi _1rkb1sa4"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _4cvr1h6o _kqswh2mm _1bsb1osq _195ggktf _1s4p1wug"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_vchhusvi _1e0c1txw _kqswh2mm _4cvr1h6o _1bsb1osq _y4ti14y2 _otyr19bv _ik7h13el _5m7p1osq"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("input", {
                                type: "text",
                                value: searchText,
                                onChange: handleChange,
                                onFocus: handleFocus,
                                onBlur: handleBlur,
                                onKeyDown: (e)=>{
                                    if (e.key == "Enter") onSearch();
                                },
                                placeholder: intl.formatMessage({
                                    id: "wac.search.pages.placeholder",
                                    defaultMessage: "Search Keywords"
                                }),
                                "data-testid": "search-input",
                                className: (0, $2jatx.default)([
                                    "_19itglyw _4cvr1h6o _bfhk1hxd _1bsb1osq _2rko1ylp _1e0c1txw _vwz41x4e _ca0qftgi _u5f31tcg _n3tdftgi _19bv1tcg _19pkidpf _2hwxidpf _otyridpf _18u0idpf _kqswh2mm _u5f31ylp _4t3ior1b _1bah1yb4 _1o9zidpf _12ji1r31 _1qu2glyw _12y31o36 _1wyb7vkz _k48p1nn1 _syaz5k8o _ect41kw7 _1n5ddoyu _13kcdlk8 _1irci2wt _dueq7vkz _1iaezwfg _1lh2gktf _858uxxzy"
                                ]),
                                style: {
                                    "--_1ntr8rj": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark200"))
                                }
                            }),
                            renderClearButton(),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                                type: "submit",
                                onClick: ()=>onSearch(),
                                onKeyDown: (e)=>{
                                    if (e.key == "Enter") onSearch();
                                },
                                "aria-label": translated.submitSearch,
                                "data-testid": "submit-search-button",
                                className: (0, $2jatx.default)([
                                    "_1wpz1h6o _bfhk1j28 _19itglyw _4t3izwfg _1bsbzwfg _1xi219bv _kqswstnw _154i1ssb _t9ec1i34 _d0altlke",
                                    isAISearchSummaryEnabled && "_vwz419bv _12l2ftgi"
                                ]),
                                children: isAISearchSummaryEnabled ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lpT0m.default), {
                                    className: (0, $2jatx.default)([
                                        "_1bsbf6fq _4t3if6fq"
                                    ])
                                }) : /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_4t3if6fq _1bsbf6fq _2rko1ssb _19it1axk _kqswstnw _1pfhzeo2 _ahbq1lpd _bfhk1j28",
                                                isActive ? "_19it8djs _syaz17la" : "_19ityxmz _syaz1hlo"
                                            ]),
                                            style: {
                                                "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                                                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                            className: (0, $2jatx.default)([
                                                "_kqswstnw _1bsb1v6z _4t3iyh40 _bfhk1hlo _t9ecjyd4 _1pfh1v6z _ahbqftgi _2rkoyh40",
                                                isActive && "_bfhk17la"
                                            ]),
                                            style: {
                                                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                                                "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                            }
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _1e0c1txw _zulp7vkz _1n261g80 _n7zlglyw _n3td19bv _195ggktf _19pk14y2 _1rfm1wug",
                        !isAISearchSummaryEnabled && !!searchStateWithResultAndIsNotLoading(searchState) && "_n7zl5y0l"
                    ]),
                    style: {
                        "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
                    },
                    children: !!searchStateWithResultAndIsNotLoading(searchState) && Object.entries(filterTranslationMap).map(([filterName, translatedFilterName])=>(facetValues.hasOwnProperty(filterName) || filterName === "All") && /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                            onClick: ()=>{
                                onSearch(filterName);
                            },
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o _4t3i14no _ca0qftgi _u5f37vkz _n3tdftgi _19bv7vkz _2rko53f4 _1dqoglyw _bfhk150w _80omtlke",
                                currFilter == filterName && "_bfhk1t97"
                            ]),
                            style: {
                                "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
                            },
                            children: translatedFilterName
                        }, filterName))
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_195ggktf _1q51dlk8 _1bsb1osq _1rfm1wug"
                    ]),
                    children: [
                        isAISearchSummaryEnabled && latestSearchText !== "" && currFilter === "All" && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hZ5Xs.AISummary), {
                                    query: latestSearchText
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("hr", {
                                    role: "presentation",
                                    className: (0, $2jatx.default)([
                                        "_1pfh1ejb _6rth1ejb _19it5y0l"
                                    ]),
                                    style: {
                                        "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200"))
                                    }
                                })
                            ]
                        }),
                        searchState && searchState !== "loading" && $d0a2331a186b73df$export$97f3b895db7ef4f3(numberOfHits, latestSearchText, currFilter),
                        hits.map(({ objectID: objectID, title: title, description: description, url: url, queryID: queryID }, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $aLBZ0.Result), {
                                index: index,
                                title: title,
                                description: description,
                                href: url,
                                objectId: objectID,
                                queryId: queryID,
                                onSearchLinkClick: onSearchLinkClick,
                                isExperimentVariant: true
                            }, objectID)),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            children: [
                                !!searchState && searchState != "loading" && (searchState === "hasMoreResult" ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fJP6M.default), {
                                    text: translated.viewMore,
                                    inputType: "button",
                                    onClick: gotoNextPage,
                                    dataEventProps: {
                                        "data-event-component": "linkButton",
                                        "data-event-container": "supportSection",
                                        "data-product-key": "search",
                                        "data-label": "view-more",
                                        "data-event": "clicked"
                                    },
                                    "aria-label": translated.viewMore,
                                    className: (0, $2jatx.default)([
                                        "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1e0c1ule _2rko1ylp _bfhkjk2v _ca0qftgi _u5f31tcg _n3tdftgi _19bv1tcg"
                                    ]),
                                    style: {
                                        "--_1b67llw": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue700"))
                                    }
                                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_19pk10yn _y3gn1h6o"
                                    ]),
                                    children: searchState && searchState != "noResult" && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        children: translated.endOfResults
                                    })
                                })),
                                searchState && searchState == "loading" && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _1bah1h6o _1mou12am"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1bsb1x4e _4t3i1x4e _19ithovc _179r1j28 _2rko1ssb _1e0c1o8l _kqswh2mm _y44vzg4r _aetrb3bt _18postnw _eq4311qw _3mxo1v6z _13pw17la _clh31p70"
                                        ]),
                                        style: {
                                            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* Styles */ const $d0a2331a186b73df$var$containerCss = null;
const $d0a2331a186b73df$var$searchContainerCss = null;
const $d0a2331a186b73df$var$searchBarContainerCss = null;
const $d0a2331a186b73df$var$searchInputContainerCss = null;
const $d0a2331a186b73df$var$searchInputCss = null;
const $d0a2331a186b73df$var$searchSubmitCss = null;
const $d0a2331a186b73df$var$searchIconTopCss = null;
const $d0a2331a186b73df$var$searchIconBottomCss = null;
const $d0a2331a186b73df$var$searchIconDefaultColor = null;
const $d0a2331a186b73df$var$searchIconActiveColor = null;
const $d0a2331a186b73df$var$searchIconBottomActiveCss = null;
const $d0a2331a186b73df$var$clearButtonCss = null;
const $d0a2331a186b73df$var$lineCss = null;
const $d0a2331a186b73df$var$line1Css = null;
const $d0a2331a186b73df$var$line2Css = null;
const $d0a2331a186b73df$var$spinnerContainerCss = null;
const $d0a2331a186b73df$var$rotation = null;
const $d0a2331a186b73df$var$spinnerCss = null;
const $d0a2331a186b73df$var$endOfResultCss = null;
const $d0a2331a186b73df$var$filtersContainerCss = null;
const $d0a2331a186b73df$var$filtersContainerWithResultCss = null;
const $d0a2331a186b73df$var$filterButtonsCss = null;
const $d0a2331a186b73df$var$selectedFilterCss = null;
const $d0a2331a186b73df$var$buttonCss = null;
const $d0a2331a186b73df$var$resultsContainerCss = null;
const $d0a2331a186b73df$var$aiEnabledSearchIconCss = null;
const $d0a2331a186b73df$var$aiEnabledSearchButtonCss = null;

});
parcelRegister("hZ5Xs", function(module, exports) {
$parcel$export(module.exports, "AISummary", function () { return $6f547359754881bd$export$cf24cd585162fa67; });
/* ai-summary.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $awDBP = parcelRequire("awDBP");

var $iunwt = parcelRequire("iunwt");

var $diVdn = parcelRequire("diVdn");

var $1GQzX = parcelRequire("1GQzX");
const $6f547359754881bd$export$cf24cd585162fa67 = ({ query: query })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iunwt.AISummaryContextProvider), {
        query: query,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($6f547359754881bd$export$971d8645f5d80483, {})
    });
};
const $6f547359754881bd$export$971d8645f5d80483 = ()=>{
    const { isLoading: isLoading, traceResponse: traceResponse } = (0, $iunwt.useAISummaryContext)();
    const isLoadingOrTraceResponse = Boolean(isLoading || traceResponse);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpu2gc"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1GQzX.AIAnswerSearchBorder), {
            isLoading: isLoadingOrTraceResponse,
            isStreaming: !!traceResponse,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1yt4utpp _1bsb1osq _kqswh2mm"
                ]),
                children: [
                    isLoadingOrTraceResponse && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $diVdn.AISummaryLoadingAnimation), {
                        traceResponse: traceResponse
                    }),
                    !isLoadingOrTraceResponse && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $awDBP.AISummaryAnswer), {})
                ]
            })
        })
    });
};
const $6f547359754881bd$var$aiSummaryBoxStyle = null;

});
parcelRegister("awDBP", function(module, exports) {
$parcel$export(module.exports, "AISummaryAnswer", function () { return $2e6189477c513f3c$export$7df2d776cc7f9957; });
/* ai-summary-answer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $ddxTX = parcelRequire("ddxTX");

var $4WS03 = parcelRequire("4WS03");

var $3pbl1 = parcelRequire("3pbl1");

var $LlYs2 = parcelRequire("LlYs2");

var $eGGys = parcelRequire("eGGys");

var $82rWc = parcelRequire("82rWc");

var $hLJF4 = parcelRequire("hLJF4");

var $92PV0 = parcelRequire("92PV0");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $kooLp = parcelRequire("kooLp");

var $iunwt = parcelRequire("iunwt");

var $3QlBY = parcelRequire("3QlBY");

var $6t7fC = parcelRequire("6t7fC");
const $2e6189477c513f3c$var$sourceIconStyle = null;
const $2e6189477c513f3c$var$sourceIconTooltipStyle = null;
const $2e6189477c513f3c$var$SourceIcon = ({ identifier: identifier, sources: sources })=>{
    var _sources_;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleClick = ()=>{
        var _sources_sourceIndex;
        const sourceIndex = identifier - 1; // Convert 1-based citation to 0-based array index
        if (sources && ((_sources_sourceIndex = sources[sourceIndex]) === null || _sources_sourceIndex === void 0 ? void 0 : _sources_sourceIndex.url)) {
            createAnalyticsEvent({
                eventType: "ui",
                action: "clicked",
                actionSubject: "link",
                actionSubjectId: "searchAiSummaryInlineSourceLink",
                source: "searchAiSummary",
                attributes: {
                    sourceIndex: sourceIndex,
                    sourceTitle: sources[sourceIndex].title,
                    sourceUrl: sources[sourceIndex].url
                }
            }).fire();
            window.open(sources[sourceIndex].url, "_blank", "noopener,noreferrer");
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1nu9 _11ko1nu9"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hLJF4.default), {
            content: sources === null || sources === void 0 ? void 0 : (_sources_ = sources[identifier - 1]) === null || _sources_ === void 0 ? void 0 : _sources_.title,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                onClick: handleClick,
                role: "button",
                tabIndex: 0,
                onKeyDown: (event)=>{
                    if (event.key === "Enter" || event.key === " ") handleClick();
                },
                className: (0, $2jatx.default)([
                    "_19ityze2 _2rko1b66 _k48p8n31 _1wybutpp _1bsbf6fq _4t3if6fq _vwz4o7ao _1e0c1o8l _18zrt94y _y3gn1h6o _195gidpf _80omtlke _irr31ybm"
                ]),
                style: {
                    "--_o8nmkh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue500")),
                    "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
                },
                children: identifier
            })
        })
    });
};
const $2e6189477c513f3c$var$StatusComponent = (props)=>/*#__PURE__*/ (0, $7VQPk.jsx)($2e6189477c513f3c$var$SourceIcon, {
        identifier: parseInt(props.text || "1", 10),
        sources: props.sources
    });
const $2e6189477c513f3c$var$fullContent = null;
const $2e6189477c513f3c$var$defaultContent = null;
const $2e6189477c513f3c$var$blurOverlayStyle = null;
const $2e6189477c513f3c$var$blurTextStyle = null;
const $2e6189477c513f3c$var$aiSummaryFooterStyle = null;
const $2e6189477c513f3c$var$aiSummaryFooterSectionStyle = null;
const $2e6189477c513f3c$var$disclaimerTextStyle = null;
const $2e6189477c513f3c$var$FeedbackThumpsUpIcon = (iconProps, feedbackState)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($82rWc))), (0, $dPABA._)((0, $6ogO3._)({}, iconProps), {
        color: feedbackState === "thumbsUp" ? "var(--ds-icon-selected, #0C66E4)" : undefined
    }));
};
const $2e6189477c513f3c$var$FeedbackThumpsDownIcon = (iconProps, feedbackState)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eGGys))), (0, $dPABA._)((0, $6ogO3._)({}, iconProps), {
        color: feedbackState === "thumbsDown" ? "var(--ds-icon-selected, #0C66E4)" : undefined
    }));
};
const $2e6189477c513f3c$export$409c83e49353f3fb = ()=>{
    const intl = (0, $8e22h.default)();
    const href = (0, $kooLp.useLocalizedHref)("/trust/atlassian-intelligence");
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { summary: summary } = (0, $iunwt.useAISummaryContext)();
    const aiDisclaimerText = intl.formatMessage({
        id: "ai.summary.answer.footer.disclaimer",
        defaultMessage: "Uses AI. Verify results."
    });
    const handleCopy = async ()=>{
        try {
            // Remove citation markers like [1], [2], etc. from the text
            const textToCopy = summary.replace(/\[\d+\]/g, "").trim();
            await navigator.clipboard.writeText(textToCopy);
        } catch (err) {
            console.error("Failed to copy text:", err);
        }
    };
    const thumbsUpText = intl.formatMessage({
        id: "ai.summary.answer.footer.thumbsUp",
        defaultMessage: "Good response"
    });
    const thumbsDownText = intl.formatMessage({
        id: "ai.summary.answer.footer.thumbsDown",
        defaultMessage: "Bad response"
    });
    const copyText = intl.formatMessage({
        id: "ai.summary.answer.footer.copy",
        defaultMessage: "Copy"
    });
    const [feedbackState, setFeedbackState] = (0, $1oC0p.useState)(null);
    const handleFeedbackClick = (event, state)=>{
        event.preventDefault();
        setFeedbackState(state);
        createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "feedbackButton",
            actionSubjectId: "searchAiSummaryFeedbackClicked",
            source: "searchAiSummary",
            attributes: {
                feedback: state
            }
        }).fire();
    };
    (0, $1oC0p.useEffect)(()=>{
        (0, $92PV0.Tracking).autoTrackLinks(true);
    }, []);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1yb4 _1yt41b66 _13t3183y"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1y6m _zulp1b66"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($LlYs2))), {
                        color: "var(--ds-icon-subtlest, #626F86)",
                        size: "medium",
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                        text: aiDisclaimerText,
                        type: "anchor",
                        href: href,
                        "aria-label": aiDisclaimerText,
                        anchorProps: {
                            target: "_blank"
                        },
                        dataEventProps: {
                            "data-product-key": "search",
                            "data-event": "clicked",
                            "data-event-component": "linkButton",
                            "data-event-container": "searchAiSummary",
                            "data-label-english": "Uses AI"
                        },
                        className: (0, $2jatx.default)([
                            "_syaz131l _1wybdlk8"
                        ])
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1y6m _zulp1b66"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4WS03.default), {
                        appearance: "subtle",
                        icon: (iconProps)=>$2e6189477c513f3c$var$FeedbackThumpsUpIcon(iconProps, feedbackState),
                        label: thumbsUpText,
                        onClick: (event)=>handleFeedbackClick(event, "thumbsUp"),
                        isTooltipDisabled: false
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4WS03.default), {
                        appearance: "subtle",
                        icon: (iconProps)=>$2e6189477c513f3c$var$FeedbackThumpsDownIcon(iconProps, feedbackState),
                        label: thumbsDownText,
                        onClick: (event)=>handleFeedbackClick(event, "thumbsDown"),
                        isTooltipDisabled: false
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4WS03.default), {
                        appearance: "subtle",
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3pbl1))),
                        label: copyText,
                        onClick: handleCopy,
                        isTooltipDisabled: false
                    })
                ]
            })
        ]
    });
};
const $2e6189477c513f3c$var$dividerStyle = null;
const $2e6189477c513f3c$var$markdownContainerStyle = null;
const $2e6189477c513f3c$var$sourceStyle = null;
const $2e6189477c513f3c$export$7df2d776cc7f9957 = ()=>{
    const [isExpanded, setIsExpanded] = (0, $1oC0p.useState)(false);
    const [isTruncated, setIsTruncated] = (0, $1oC0p.useState)(false);
    const contentRef = (0, $1oC0p.useRef)(null);
    const intl = (0, $8e22h.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const { summary: summary, sources: sources } = (0, $iunwt.useAISummaryContext)();
    const [selected, setSelected] = (0, $1oC0p.useState)(0);
    const setTab = (0, $1oC0p.useCallback)((index)=>{
        setSelected(index);
        if (index === 1) createAnalyticsEvent({
            eventType: "ui",
            action: "clicked",
            actionSubject: "tab",
            actionSubjectId: "searchAiSummarySourcesTabClicked",
            source: "searchAiSummary"
        }).fire();
    }, [
        setSelected,
        createAnalyticsEvent
    ]);
    const statusComponent = (0, $1oC0p.useCallback)((props)=>/*#__PURE__*/ (0, $7VQPk.jsx)($2e6189477c513f3c$var$StatusComponent, (0, $dPABA._)((0, $6ogO3._)({}, props), {
            sources: sources
        })), [
        sources
    ]);
    const renderMarkdownContent = (text)=>{
        // Use the search-ai approach: encodeAdf + Atlaskit renderer
        // This handles both markdown formatting and citations properly
        return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_vt411ymi _r8atgrf3"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6t7fC.MarkdownRenderer), {
                answerString: text,
                statusComponent: statusComponent
            })
        });
    };
    (0, $1oC0p.useEffect)(()=>{
        if (!contentRef.current) return;
        const resizeObserver = new ResizeObserver(()=>{
            if (contentRef.current) {
                const wrapperHeight = contentRef.current.offsetHeight;
                const contentHeight = contentRef.current.scrollHeight;
                setIsTruncated(contentHeight > wrapperHeight);
            }
        });
        resizeObserver.observe(contentRef.current);
        return ()=>resizeObserver.disconnect();
    }, [
        summary
    ]);
    const handleToggleExpansion = ()=>{
        setIsExpanded(!isExpanded);
        createAnalyticsEvent({
            eventName: isExpanded ? "searchAiSummaryReadLessClicked" : "searchAiSummaryReadMoreClicked",
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            actionSubjectId: isExpanded ? "searchAiSummaryReadLess" : "searchAiSummaryReadMore",
            source: "searchAiSummary",
            attributes: {
                product: "search",
                labelEnglish: isExpanded ? "Read less" : "Read more"
            }
        }).fire();
    };
    const handleSourceLinkClick = (source, index)=>{
        createAnalyticsEvent({
            eventName: "searchAiSummarySourceLinkClicked",
            eventType: "ui",
            action: "clicked",
            actionSubject: "link",
            actionSubjectId: "searchAiSummarySourceLink",
            source: "searchAiSummary",
            attributes: {
                product: "search",
                sourceUrl: source.url,
                sourceTitle: source.title,
                sourceIndex: index
            }
        }).fire();
    };
    const readMoreText = intl.formatMessage({
        id: "ai.summary.answer.readMore",
        defaultMessage: "Read more"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $3QlBY.AISummaryTabs), {
                answerPanel: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        ref: contentRef,
                        className: (0, $2jatx.default)([
                            "_c71lbv7e _1reo15vq _18m915vq _kqswh2mm",
                            isExpanded && "_c71l1ns9"
                        ]),
                        children: [
                            renderMarkdownContent(summary),
                            isTruncated && !isExpanded && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_11q7b662 _1bsb1osq _1e0c1txw _1bah1y6m _kqswstnw _152tnagk _85i51b66 _1q51xy5q _syaz1fxt"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ddxTX.default), {
                                    appearance: "link",
                                    onClick: handleToggleExpansion,
                                    "aria-label": readMoreText,
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _1bah1y6m _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _k48p1nn1 _c71l1ns9 _187s16fl _v4pridpf _13t3zwfg _9oik1snc _1bnxagmp _jf4cvv82"
                                    ]),
                                    children: readMoreText
                                })
                            })
                        ]
                    })
                }),
                sourcesPanel: sources === null || sources === void 0 ? void 0 : sources.map((source, i)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1yt41bpf _k48pbfng _1joiidpf _81oiidpf"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                            text: i + 1 + ". " + source.title,
                            type: "primary",
                            href: source.url,
                            onClick: ()=>handleSourceLinkClick(source, i),
                            "aria-label": i + 1 + ". " + source.title
                        })
                    }, source.url)),
                selected: selected,
                onChange: setTab
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_179r1k0a _18s8zu5n"
                ]),
                style: {
                    "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)($2e6189477c513f3c$export$409c83e49353f3fb, {})
        ]
    });
};

});
parcelRegister("3pbl1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cbd1068d7fb082440154244857d12f2c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $27ac80630eac5da7$var$_react = $27ac80630eac5da7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $27ac80630eac5da7$var$_baseNew = $27ac80630eac5da7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $27ac80630eac5da7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Copy".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for copying data such as text, code or other objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $27ac80630eac5da7$var$CopyIcon = (props)=>/*#__PURE__*/ $27ac80630eac5da7$var$_react.default.createElement($27ac80630eac5da7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM16 6v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75V6z" clip-rule="evenodd"/>`
    }, props));
$27ac80630eac5da7$var$CopyIcon.displayName = 'CopyIcon';
var $27ac80630eac5da7$var$_default = module.exports.default = $27ac80630eac5da7$var$CopyIcon;

});

parcelRegister("eGGys", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6a6c601e24c01efd86daa4bd04d7c20b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab15ff6f4b7d97af$var$_react = $ab15ff6f4b7d97af$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ab15ff6f4b7d97af$var$_baseNew = $ab15ff6f4b7d97af$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $ab15ff6f4b7d97af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ThumbsDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting, feedback in AI.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ab15ff6f4b7d97af$var$ThumbsDownIcon = (props)=>/*#__PURE__*/ $ab15ff6f4b7d97af$var$_react.default.createElement($ab15ff6f4b7d97af$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.292 13.406a.5.5 0 0 0 .77-.15l2.438-4.69V2.5H4.128c-.492 0-.927.32-1.073.79L1.726 7.54A1.125 1.125 0 0 0 2.8 9h3.45a.75.75 0 0 1 .75.75v3.175a.5.5 0 0 0 .174.38zM12 2.5V8h2a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm-.295 7-2.313 4.45a2 2 0 0 1-3.076.596l-.118-.101a2 2 0 0 1-.698-1.519V10.5H2.8A2.625 2.625 0 0 1 .295 7.092l1.328-4.25A2.625 2.625 0 0 1 4.128 1H14a2 2 0 0 1 2 2v4.5a2 2 0 0 1-2 2z" clip-rule="evenodd"/>`
    }, props));
$ab15ff6f4b7d97af$var$ThumbsDownIcon.displayName = 'ThumbsDownIcon';
var $ab15ff6f4b7d97af$var$_default = module.exports.default = $ab15ff6f4b7d97af$var$ThumbsDownIcon;

});

parcelRegister("82rWc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a1671a6ac4d424a875e471692b3026e8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5da42e7527238080$var$_react = $5da42e7527238080$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $5da42e7527238080$var$_baseNew = $5da42e7527238080$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $5da42e7527238080$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ThumbsUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: voting options in Jira, like.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5da42e7527238080$var$ThumbsUpIcon = (props)=>/*#__PURE__*/ $5da42e7527238080$var$_react.default.createElement($5da42e7527238080$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.708 2.594a.5.5 0 0 0-.77.15L5.5 7.433V13.5h6.371c.493 0 .928-.32 1.074-.79l1.328-4.25A1.125 1.125 0 0 0 13.2 7H9.75A.75.75 0 0 1 9 6.25V3.075a.5.5 0 0 0-.175-.38zM4 13.5V8H2a.5.5 0 0 0-.5.5V13a.5.5 0 0 0 .5.5zm.295-7 2.313-4.45a2 2 0 0 1 3.076-.596l.118.101a2 2 0 0 1 .698 1.519V5.5h2.7a2.625 2.625 0 0 1 2.505 3.408l-1.328 4.25A2.625 2.625 0 0 1 11.871 15H2a2 2 0 0 1-2-2V8.5a2 2 0 0 1 2-2z" clip-rule="evenodd"/>`
    }, props));
$5da42e7527238080$var$ThumbsUpIcon.displayName = 'ThumbsUpIcon';
var $5da42e7527238080$var$_default = module.exports.default = $5da42e7527238080$var$ThumbsUpIcon;

});

parcelRegister("iunwt", function(module, exports) {
$parcel$export(module.exports, "useAISummaryContext", function () { return $6765649a771fe8e1$export$5684accc31d61e95; });
$parcel$export(module.exports, "AISummaryContextProvider", function () { return $6765649a771fe8e1$export$7d671cf75e2cfb14; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $fuLgT = parcelRequire("fuLgT");

var $eY3N6 = parcelRequire("eY3N6");
const $6765649a771fe8e1$export$d9891c14af3ce883 = "https://www.atlassian.com/gateway/api";
const $6765649a771fe8e1$export$b1cc2341c8059a01 = "9957edf0-7205-4ec3-bd4d-ff871e460fea";
const $6765649a771fe8e1$export$86c50fd667fc4af5 = "b4db6a3b-6006-37db-a214-0be400970e38";
const $6765649a771fe8e1$export$b861a2d9069d580 = "ari:cloud:help::help-center/6fe401af-9648-48b0-bd2d-9e9e572f7a26/d52415c9-03cc-4853-b033-faeb1427c757";
const $6765649a771fe8e1$var$AISummaryContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $6765649a771fe8e1$export$5684accc31d61e95 = ()=>{
    const context = (0, $1oC0p.useContext)($6765649a771fe8e1$var$AISummaryContext);
    if (!context) throw new Error("useAISummaryContext must be used within a AISummaryContextProvider");
    return context;
};
const $6765649a771fe8e1$export$7d671cf75e2cfb14 = ({ query: query, children: children })=>{
    const [summary, setSummary] = (0, $1oC0p.useState)("");
    const [sources, setSources] = (0, $1oC0p.useState)();
    const [conversationId, setConversationId] = (0, $1oC0p.useState)("");
    const [messageId, setMessageId] = (0, $1oC0p.useState)("");
    const [isLoading, setIsLoading] = (0, $1oC0p.useState)(true);
    const [traceResponse, setTraceResponse] = (0, $1oC0p.useState)(undefined);
    const [anonAuthToken, setAnonAuthToken] = (0, $1oC0p.useState)("");
    const abortControllerRef = (0, $1oC0p.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const processLine = (0, $1oC0p.useCallback)(// eslint-disable-next-line complexity
    (line)=>{
        try {
            var _parsed_message, _parsed_message1, _parsed_message2, _parsed_message3;
            const parsed = JSON.parse(line);
            if (parsed.type === "TRACE" && ((_parsed_message = parsed.message) === null || _parsed_message === void 0 ? void 0 : _parsed_message.content)) {
                // TRACE contains the initial loading messages
                let traceContent = parsed.message.content;
                if (traceContent.includes(": ")) traceContent = traceContent.split(": ")[1];
                if (traceContent.endsWith(".")) traceContent = traceContent.slice(0, -1);
                setTraceResponse(traceContent);
            } else if (parsed.type === "FINAL_RESPONSE" && (((_parsed_message1 = parsed.message) === null || _parsed_message1 === void 0 ? void 0 : _parsed_message1.sources) || ((_parsed_message2 = parsed.message) === null || _parsed_message2 === void 0 ? void 0 : _parsed_message2.message.sources))) {
                var _parsed_message4, _parsed_message_message, _parsed_message5, _parsed_message6, _parsed_message7;
                // FINAL_RESPONSE contains the entire summary, sources, and additional info LLM info
                const sourcesData = ((_parsed_message4 = parsed.message) === null || _parsed_message4 === void 0 ? void 0 : _parsed_message4.sources) || ((_parsed_message5 = parsed.message) === null || _parsed_message5 === void 0 ? void 0 : (_parsed_message_message = _parsed_message5.message) === null || _parsed_message_message === void 0 ? void 0 : _parsed_message_message.sources);
                if (!sourcesData || sourcesData.length === 0) createAnalyticsEvent({
                    eventName: "searchAiSummaryNoSources",
                    eventType: "track",
                    action: "failed",
                    actionSubject: "searchAiSummary",
                    actionSubjectId: "searchAiSummaryFinalResponseLoaded",
                    source: "searchPage",
                    attributes: {
                        query: query,
                        conversationId: conversationId
                    }
                }).fire();
                if ((_parsed_message6 = parsed.message) === null || _parsed_message6 === void 0 ? void 0 : _parsed_message6.id) setMessageId((_parsed_message7 = parsed.message) === null || _parsed_message7 === void 0 ? void 0 : _parsed_message7.message.id);
                setSources(sourcesData);
                setTraceResponse(undefined);
            } else if (parsed.type === "ANSWER_PART" && ((_parsed_message3 = parsed.message) === null || _parsed_message3 === void 0 ? void 0 : _parsed_message3.content)) {
                setSummary((prev)=>prev + parsed.message.content);
                setTraceResponse(undefined);
            }
        } catch (error) {
            console.warn("Failed to parse line as JSON:", line);
            setSummary((prev)=>prev + "\n" + line);
        }
    }, [
        createAnalyticsEvent,
        query,
        conversationId
    ]);
    // eslint-disable-next-line complexity
    const fetchAISummary = (0, $1oC0p.useCallback)(async ()=>{
        var _abortControllerRef_current;
        setIsLoading(true);
        setTraceResponse(undefined);
        setSources(undefined);
        setSummary("");
        setMessageId("");
        (_abortControllerRef_current = abortControllerRef.current) === null || _abortControllerRef_current === void 0 ? void 0 : _abortControllerRef_current.abort();
        abortControllerRef.current = new AbortController();
        // Generate a new conversation ID for each new query
        const newConversationId = (0, $fuLgT.default)();
        setConversationId(newConversationId);
        const userContext = {
            user_locale: intl.locale || "en",
            current_time: new Date().toISOString()
        };
        const queryWithUserContext = `${query} \n ${JSON.stringify(userContext)}`;
        let reader = null;
        try {
            var _abortControllerRef_current1;
            const response = await fetch(`${$6765649a771fe8e1$export$d9891c14af3ce883}/assist/csm/v2/chat/channel/${newConversationId}/message/stream`, {
                method: "POST",
                credentials: "omit",
                signal: (_abortControllerRef_current1 = abortControllerRef.current) === null || _abortControllerRef_current1 === void 0 ? void 0 : _abortControllerRef_current1.signal,
                headers: {
                    "x-cloudid": $6765649a771fe8e1$export$b1cc2341c8059a01,
                    "x-product": "csm",
                    "x-experience-id": "csm-ai",
                    "x-anonymous-auth": anonAuthToken,
                    "content-type": "application/json;charset=UTF-8"
                },
                body: JSON.stringify({
                    content: {
                        version: 1,
                        type: "doc",
                        content: [
                            {
                                type: "paragraph",
                                content: [
                                    {
                                        type: "text",
                                        text: queryWithUserContext
                                    }
                                ]
                            }
                        ]
                    },
                    recipient_agent_named_id: "atlassian_wac_agent",
                    agent_id: $6765649a771fe8e1$export$86c50fd667fc4af5,
                    mimeType: "text/adf",
                    store_message: false,
                    citations_enabled: true
                })
            });
            createAnalyticsEvent({
                eventName: "aiSummary",
                eventType: "track",
                action: "loaded",
                actionSubject: "searchAiSummary",
                actionSubjectId: "searchAiSummaryLoaded",
                source: "searchPage",
                eventContainer: "load",
                attributes: {
                    responseCode: response.status,
                    responseBodyAvailable: response.body ? true : false
                }
            }).fire();
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            if (!response.body) throw new Error("Response body is not available for streaming");
            reader = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer = "";
            while(true){
                const { done: done, value: value } = await reader.read();
                console.log("done", done);
                if (done) {
                    if (buffer.trim()) {
                        processLine(buffer.trim());
                        setIsLoading(false);
                    }
                    break;
                }
                const chunk = decoder.decode(value, {
                    stream: true
                });
                buffer += chunk;
                const lines = buffer.split("\n");
                buffer = lines.pop() || "";
                for (const line of lines){
                    const trimmedLine = line.trim();
                    if (trimmedLine) {
                        processLine(trimmedLine);
                        setIsLoading(false);
                    }
                }
            }
        } catch (error) {
            if (error instanceof DOMException && error.name === "AbortError") return;
            console.error("Error processing AI summary stream:", error);
            setSummary((prev)=>prev + "\nAtlassian Intelligence can't provide a response right now.");
        } finally{
            reader === null || reader === void 0 ? void 0 : reader.releaseLock();
            setIsLoading(false);
        }
    }, [
        processLine,
        anonAuthToken,
        query,
        intl.locale,
        createAnalyticsEvent
    ]);
    const getAnonAuthToken = async ()=>{
        const response = await fetch(`${$6765649a771fe8e1$export$d9891c14af3ce883}/assist/csm/v2/widgets/access?helpCenterAri=${$6765649a771fe8e1$export$b861a2d9069d580}`, {
            method: "GET",
            credentials: "omit",
            headers: {
                "x-cloudid": $6765649a771fe8e1$export$b1cc2341c8059a01,
                "x-product": "csm",
                "x-experience-id": "csm-ai",
                "content-type": "application/json;charset=UTF-8"
            }
        });
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        const data = await response.json();
        if (!data.hasAccess) throw new Error("User does not have access to the help center");
        setAnonAuthToken(data.anonAuthToken);
    };
    (0, $1oC0p.useEffect)(()=>{
        getAnonAuthToken().catch((error)=>{
            console.error("Error getting anonymous auth token:", error);
        });
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        if (anonAuthToken) fetchAISummary().catch((error)=>{
            console.error("Error fetching AI summary:", error);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        query,
        anonAuthToken
    ]);
    const contextValue = (0, $1oC0p.useMemo)(()=>({
            summary: summary,
            sources: sources,
            conversationId: conversationId,
            messageId: messageId,
            isLoading: isLoading,
            traceResponse: traceResponse
        }), [
        summary,
        sources,
        conversationId,
        messageId,
        isLoading,
        traceResponse
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($6765649a771fe8e1$var$AISummaryContext.Provider, {
        value: contextValue,
        children: children
    });
};

});

parcelRegister("3QlBY", function(module, exports) {
$parcel$export(module.exports, "AISummaryTabs", function () { return $a67e9bc5cb36b207$export$681e2ecfbcedbb69; });
/* ai-summary-tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $lawKK = parcelRequire("lawKK");
var $eo5T7 = parcelRequire("eo5T7");
var $9T4IS = parcelRequire("9T4IS");
var $8yRyJ = parcelRequire("8yRyJ");
const $a67e9bc5cb36b207$export$681e2ecfbcedbb69 = ({ answerPanel: answerPanel, sourcesPanel: sourcesPanel, selected: selected, onChange: onChange })=>{
    const intl = (0, $8e22h.default)();
    const answerText = intl.formatMessage({
        id: "ai.summary.tabs.answer",
        defaultMessage: "AI Answer"
    });
    const sourcesText = intl.formatMessage({
        id: "ai.summary.tabs.sources",
        defaultMessage: "Sources"
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $lawKK.default), {
        id: "ai-summary-tabs",
        selected: selected,
        onChange: onChange,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $9T4IS.default), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eo5T7.default), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_y3gn1h6o _1iqs1jhh _ect48q0o _1wyb7vkz _zg8l4jg8 _k48pl8b6 _vwz41tcg _1e0c1txw _ca0qidpf _u5f3ftgi _n3tdftgi _19bvftgi _zulp1b66"
                            ]),
                            children: answerText
                        })
                    }),
                    sourcesPanel && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eo5T7.default), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_y3gn1h6o _1iqs1jhh _ect48q0o _1wyb7vkz _zg8l4jg8 _k48pl8b6 _vwz41tcg _1e0c1txw _ca0qidpf _u5f3ftgi _n3tdftgi _19bvftgi _zulp1b66"
                            ]),
                            children: sourcesText
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8yRyJ.default), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulpv77o _1bsb1osq _1q517vkz"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        children: answerPanel
                    })
                })
            }),
            sourcesPanel && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8yRyJ.default), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _zulpv77o _1bsb1osq _1q517vkz"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        children: sourcesPanel
                    })
                })
            })
        ]
    });
};
const $a67e9bc5cb36b207$var$tabStyle = null;
const $a67e9bc5cb36b207$var$panelStyle = null;

});
parcelRegister("eo5T7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $02b3ff7b366d6fac$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $3dJ4i = parcelRequire("3dJ4i");

var $gnCSJ = parcelRequire("gnCSJ");

var $6jtA2 = parcelRequire("6jtA2");

var $6dioi = parcelRequire("6dioi");
function $02b3ff7b366d6fac$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, testId = _ref.testId;
    var _useTab = (0, $6dioi.useTab)(), onClick = _useTab.onClick, id = _useTab.id, ariaControls = _useTab['aria-controls'], ariaPosinset = _useTab['aria-posinset'], ariaSelected = _useTab['aria-selected'], ariaSetsize = _useTab['aria-setsize'], onMouseDown = _useTab.onMouseDown, onKeyDown = _useTab.onKeyDown, role = _useTab.role, tabIndex = _useTab.tabIndex;
    return (0, $3dJ4i.jsx)((0, $6jtA2.default), {
        testId: testId,
        onClick: onClick,
        id: id,
        "aria-controls": ariaControls,
        "aria-posinset": ariaPosinset,
        "aria-selected": ariaSelected,
        "aria-setsize": ariaSetsize,
        onMouseDown: onMouseDown,
        onKeyDown: onKeyDown,
        role: role,
        tabIndex: tabIndex
    }, (0, $3dJ4i.jsx)((0, $gnCSJ.default), {
        shouldTruncate: true,
        UNSAFE_style: {
            color: 'inherit'
        }
    }, children));
}

});
parcelRegister("6jtA2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $498b766e86755a82$export$2e2bcd8739ae039; });

var $i4L81 = parcelRequire("i4L81");

var $lqqfW = parcelRequire("lqqfW");

var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $jyhJE = parcelRequire("jyhJE");

var $8VPPm = parcelRequire("8VPPm");

var $eYlo4 = parcelRequire("eYlo4");
var $498b766e86755a82$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $498b766e86755a82$var$_excluded2 = [
    "className"
];
var $498b766e86755a82$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, as = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, $lqqfW.default)(_ref, $498b766e86755a82$var$_excluded);
    var Component = as;
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, $lqqfW.default)(htmlAttributes, $498b766e86755a82$var$_excluded2);
    var className = xcss && (0, $8VPPm.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $3dJ4i.jsx)(Component, (0, $i4L81.default)({
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        css: [
            $498b766e86755a82$var$baseStyles,
            backgroundColor && (0, $jyhJE.backgroundColorStylesMap)[backgroundColor],
            (0, $jyhJE.isSurfaceColorToken)(backgroundColor) && (0, $jyhJE.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $jyhJE.paddingStylesMap).padding[padding],
            paddingBlock && (0, $jyhJE.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $jyhJE.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $jyhJE.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $jyhJE.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $jyhJE.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $jyhJE.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            className
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $3dJ4i.jsx)((0, $eYlo4.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $498b766e86755a82$export$2e2bcd8739ae039 = $498b766e86755a82$export$e71c4d32a2263218;
var $498b766e86755a82$var$baseStyles = (0, $3dJ4i.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("i4L81", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d28d2871abd5aabf$export$2e2bcd8739ae039; });
function $d28d2871abd5aabf$export$2e2bcd8739ae039() {
    return $d28d2871abd5aabf$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d28d2871abd5aabf$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("jyhJE", function(module, exports) {
$parcel$export(module.exports, "dimensionMap", function () { return $e3bef327eea3b3aa$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "spaceMap", function () { return $e3bef327eea3b3aa$export$1f52408f03b1c9b4; });
$parcel$export(module.exports, "borderColorMap", function () { return $e3bef327eea3b3aa$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $e3bef327eea3b3aa$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "shadowMap", function () { return $e3bef327eea3b3aa$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "textColorMap", function () { return $e3bef327eea3b3aa$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $e3bef327eea3b3aa$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $e3bef327eea3b3aa$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $e3bef327eea3b3aa$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $e3bef327eea3b3aa$export$e615f061ca585a6c; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $e3bef327eea3b3aa$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $e3bef327eea3b3aa$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $e3bef327eea3b3aa$export$5e65a44e5b6ecadb; });

var $j7Iem = parcelRequire("j7Iem");

var $3dJ4i = parcelRequire("3dJ4i");

var $cqlqZ = parcelRequire("cqlqZ");
var $e3bef327eea3b3aa$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $e3bef327eea3b3aa$export$1f52408f03b1c9b4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $e3bef327eea3b3aa$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $e3bef327eea3b3aa$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $e3bef327eea3b3aa$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $e3bef327eea3b3aa$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $e3bef327eea3b3aa$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $e3bef327eea3b3aa$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)"
};
var $e3bef327eea3b3aa$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $e3bef327eea3b3aa$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $e3bef327eea3b3aa$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $e3bef327eea3b3aa$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $e3bef327eea3b3aa$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $e3bef327eea3b3aa$export$6cc560b4dedf3816 = {
    'font.size.050': "var(--ds-font-size-050, 11px)",
    'font.size.075': "var(--ds-font-size-075, 12px)",
    'font.size.100': "var(--ds-font-size-100, 14px)",
    'font.size.200': "var(--ds-font-size-200, 16px)",
    'font.size.300': "var(--ds-font-size-300, 20px)",
    'font.size.400': "var(--ds-font-size-400, 24px)",
    'font.size.500': "var(--ds-font-size-500, 29px)",
    'font.size.600': "var(--ds-font-size-600, 35px)"
};
var $e3bef327eea3b3aa$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
var $e3bef327eea3b3aa$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand': "var(--ds-font-family-brand, Charlie Sans)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.monospace': "var(--ds-font-family-monospace, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.sans': "var(--ds-font-family-sans, -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif)"
};
var $e3bef327eea3b3aa$export$360c29a380c1a34 = {
    'font.lineHeight.1': "var(--ds-font-lineHeight-1, 1)",
    'font.lineHeight.100': "var(--ds-font-lineHeight-100, 16px)",
    'font.lineHeight.200': "var(--ds-font-lineHeight-200, 20px)",
    'font.lineHeight.300': "var(--ds-font-lineHeight-300, 24px)",
    'font.lineHeight.400': "var(--ds-font-lineHeight-400, 28px)",
    'font.lineHeight.500': "var(--ds-font-lineHeight-500, 32px)",
    'font.lineHeight.600': "var(--ds-font-lineHeight-600, 40px)"
};
var $e3bef327eea3b3aa$export$b5bac06d7d8fd0d1 = {
    body: "var(--ds-font-body, normal 400 14px/20px var(--ds-font-family-body))",
    'body.large': "var(--ds-font-body-large, normal 400 16px/24px var(--ds-font-family-body))",
    'body.small': "var(--ds-font-body-small, normal 400 11px/20px var(--ds-font-family-body))"
};
var $e3bef327eea3b3aa$export$b27166c9cf2c9f74 = {
    ui: "var(--ds-font-ui, normal 400 14px/1 var(--ds-font-family-body))",
    'ui.small': "var(--ds-font-ui-small, normal 400 11px/1 var(--ds-font-family-body))"
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $e3bef327eea3b3aa$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $e3bef327eea3b3aa$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $3dJ4i.css)((0, $j7Iem.default)({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $e3bef327eea3b3aa$export$e615f061ca585a6c = $e3bef327eea3b3aa$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $e3bef327eea3b3aa$var$getSerializedStylesMap(spacingProperty, $e3bef327eea3b3aa$export$1f52408f03b1c9b4);
    return styleMap;
}, {});
var $e3bef327eea3b3aa$export$bf46c3f9eeafc71f = $e3bef327eea3b3aa$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $e3bef327eea3b3aa$var$getSerializedStylesMap(spacingProperty, $e3bef327eea3b3aa$export$1f52408f03b1c9b4);
    return styleMap;
}, {});
var $e3bef327eea3b3aa$export$e7af83bafe7f9e63 = $e3bef327eea3b3aa$var$getSerializedStylesMap('backgroundColor', $e3bef327eea3b3aa$export$d1d79bf68ac056bd);
var $e3bef327eea3b3aa$export$3a1bcba60b23d7f0 = $e3bef327eea3b3aa$var$getSerializedStylesMap('color', $e3bef327eea3b3aa$export$8473307aa00d6ea1);
var $e3bef327eea3b3aa$export$f7183c9e2dbc2543 = $e3bef327eea3b3aa$var$getSerializedStylesMap('fontSize', $e3bef327eea3b3aa$export$6cc560b4dedf3816);
var $e3bef327eea3b3aa$export$45f3f4fe16f9f7d5 = $e3bef327eea3b3aa$var$getSerializedStylesMap('fontWeight', $e3bef327eea3b3aa$export$303e322c6b1ed114);
var $e3bef327eea3b3aa$export$68cc305da27dbaa4 = $e3bef327eea3b3aa$var$getSerializedStylesMap('fontFamily', $e3bef327eea3b3aa$export$3c7e9587132614b4);
var $e3bef327eea3b3aa$export$8be4a21014f48eb1 = $e3bef327eea3b3aa$var$getSerializedStylesMap('lineHeight', $e3bef327eea3b3aa$export$360c29a380c1a34);
var $e3bef327eea3b3aa$export$a1962444bbf058e = $e3bef327eea3b3aa$var$getSerializedStylesMap('font', $e3bef327eea3b3aa$export$b5bac06d7d8fd0d1);
var $e3bef327eea3b3aa$export$ca3e246f24657bd6 = $e3bef327eea3b3aa$var$getSerializedStylesMap('font', $e3bef327eea3b3aa$export$b27166c9cf2c9f74);
var $e3bef327eea3b3aa$export$ff257d957d48c421 = $e3bef327eea3b3aa$var$getSerializedStylesMap((0, $cqlqZ.CURRENT_SURFACE_CSS_VAR), $e3bef327eea3b3aa$export$41a358c9c2356760);
var $e3bef327eea3b3aa$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $e3bef327eea3b3aa$export$41a358c9c2356760[color] !== undefined;
};

});
parcelRegister("cqlqZ", function(module, exports) {
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $90b88a2446292e13$export$9d7b58831ae93caa; });
var $90b88a2446292e13$export$4ef52930e33717cd = 'data-theme';
var $90b88a2446292e13$export$a00eac3f8684bcd0 = 'data-color-mode';
var $90b88a2446292e13$export$2112803007239c61 = 'data-contrast-mode';
var $90b88a2446292e13$export$352e418ed5b6193a = 'data-custom-theme';
var $90b88a2446292e13$export$2faeed762aac6741 = 'light';
var $90b88a2446292e13$export$6f0c6fb8c80fcc92 = 'ds';
var $90b88a2446292e13$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $90b88a2446292e13$export$dddac1532e822863 = "--".concat($90b88a2446292e13$export$6f0c6fb8c80fcc92, "-token-not-found");
var $90b88a2446292e13$export$9d7b58831ae93caa = "--".concat($90b88a2446292e13$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("8VPPm", function(module, exports) {
$parcel$export(module.exports, "parseXcss", function () { return $680bd972eea8a832$export$a9c84988c8f81f2d; });

var $j7Iem = parcelRequire("j7Iem");

var $byC10 = parcelRequire("byC10");

var $6SGpS = parcelRequire("6SGpS");

var $3dJ4i = parcelRequire("3dJ4i");

var $jyhJE = parcelRequire("jyhJE");

var $7t0tI = parcelRequire("7t0tI");
var $680bd972eea8a832$var$tokensMap = {
    backgroundColor: (0, $jyhJE.backgroundColorMap),
    blockSize: (0, $jyhJE.dimensionMap),
    borderColor: (0, $jyhJE.borderColorMap),
    borderRadius: (0, $jyhJE.borderRadiusMap),
    borderWidth: (0, $jyhJE.borderWidthMap),
    bottom: (0, $jyhJE.spaceMap),
    boxShadow: (0, $jyhJE.shadowMap),
    color: (0, $jyhJE.textColorMap),
    columnGap: (0, $jyhJE.spaceMap),
    gap: (0, $jyhJE.spaceMap),
    height: (0, $jyhJE.dimensionMap),
    inlineSize: (0, $jyhJE.dimensionMap),
    inset: (0, $jyhJE.spaceMap),
    insetBlock: (0, $jyhJE.spaceMap),
    insetBlockEnd: (0, $jyhJE.spaceMap),
    insetBlockStart: (0, $jyhJE.spaceMap),
    insetInline: (0, $jyhJE.spaceMap),
    insetInlineEnd: (0, $jyhJE.spaceMap),
    insetInlineStart: (0, $jyhJE.spaceMap),
    margin: (0, $jyhJE.spaceMap),
    marginBlock: (0, $jyhJE.spaceMap),
    marginBlockEnd: (0, $jyhJE.spaceMap),
    marginBlockStart: (0, $jyhJE.spaceMap),
    marginBottom: (0, $jyhJE.spaceMap),
    marginInline: (0, $jyhJE.spaceMap),
    marginInlineEnd: (0, $jyhJE.spaceMap),
    marginInlineStart: (0, $jyhJE.spaceMap),
    marginLeft: (0, $jyhJE.spaceMap),
    marginRight: (0, $jyhJE.spaceMap),
    marginTop: (0, $jyhJE.spaceMap),
    left: (0, $jyhJE.spaceMap),
    maxBlockSize: (0, $jyhJE.dimensionMap),
    maxHeight: (0, $jyhJE.dimensionMap),
    maxInlineSize: (0, $jyhJE.dimensionMap),
    maxWidth: (0, $jyhJE.dimensionMap),
    minBlockSize: (0, $jyhJE.dimensionMap),
    minHeight: (0, $jyhJE.dimensionMap),
    minInlineSize: (0, $jyhJE.dimensionMap),
    minWidth: (0, $jyhJE.dimensionMap),
    outlineOffset: (0, $jyhJE.spaceMap),
    outlineWidth: (0, $jyhJE.borderWidthMap),
    outlineColor: (0, $jyhJE.borderColorMap),
    padding: (0, $jyhJE.spaceMap),
    paddingBlock: (0, $jyhJE.spaceMap),
    paddingBlockEnd: (0, $jyhJE.spaceMap),
    paddingBlockStart: (0, $jyhJE.spaceMap),
    paddingBottom: (0, $jyhJE.spaceMap),
    paddingInline: (0, $jyhJE.spaceMap),
    paddingInlineEnd: (0, $jyhJE.spaceMap),
    paddingInlineStart: (0, $jyhJE.spaceMap),
    paddingLeft: (0, $jyhJE.spaceMap),
    paddingRight: (0, $jyhJE.spaceMap),
    paddingTop: (0, $jyhJE.spaceMap),
    right: (0, $jyhJE.spaceMap),
    rowGap: (0, $jyhJE.spaceMap),
    top: (0, $jyhJE.spaceMap),
    width: (0, $jyhJE.dimensionMap),
    zIndex: (0, $jyhJE.layerMap)
};
var $680bd972eea8a832$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $680bd972eea8a832$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $7t0tI === "undefined" ? "undefined" : (0, $6SGpS.default)($7t0tI)) === 'object' && (0, $6SGpS.default)($7t0tI.env) === 'object' && false;
};
var $680bd972eea8a832$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $680bd972eea8a832$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $680bd972eea8a832$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, $6SGpS.default)(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, $byC10.default)(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, $6SGpS.default)(value) === 'object' && $680bd972eea8a832$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($680bd972eea8a832$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($680bd972eea8a832$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $680bd972eea8a832$var$tokensMap)) return;
        var tokenValue = $680bd972eea8a832$var$tokensMap[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $680bd972eea8a832$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $680bd972eea8a832$var$transformStyles(style);
    return (0, $j7Iem.default)({}, $680bd972eea8a832$var$uniqueSymbol, (0, $3dJ4i.css)(transformedStyles));
};
var $680bd972eea8a832$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) return args.map(function(x) {
        return x && parseXcss(x);
    }).filter(Boolean);
    var styles = args[$680bd972eea8a832$var$uniqueSymbol];
    typeof $7t0tI === "undefined" || (0, $6SGpS.default)($7t0tI);
    return styles;
};
function $680bd972eea8a832$export$f6c783d06584602c(style) {
    return $680bd972eea8a832$var$baseXcss(style);
}

});

parcelRegister("eYlo4", function(module, exports) {
$parcel$export(module.exports, "SurfaceContext", function () { return $ae6742557e7cc2b0$export$1ca2a26fecb070ae; });

var $1oC0p = parcelRequire("1oC0p");
var $ae6742557e7cc2b0$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $1oC0p.createContext)('elevation.surface');
var $ae6742557e7cc2b0$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $1oC0p.useContext)($ae6742557e7cc2b0$export$1ca2a26fecb070ae);
};
$ae6742557e7cc2b0$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});



parcelRegister("8yRyJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $63bb0b7661c0db5a$export$2e2bcd8739ae039; });
/** @jsx jsx */ 
var $1oC0p = parcelRequire("1oC0p");

var $3dJ4i = parcelRequire("3dJ4i");

var $6jtA2 = parcelRequire("6jtA2");

var $6dioi = parcelRequire("6dioi");
// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ var $63bb0b7661c0db5a$var$TabPanel = function TabPanel(_ref) {
    var children = _ref.children, testId = _ref.testId;
    var _useTabPanel = (0, $6dioi.useTabPanel)(), role = _useTabPanel.role, id = _useTabPanel.id, hidden = _useTabPanel.hidden, ariaLabelledBy = _useTabPanel['aria-labelledby'], onMouseDown = _useTabPanel.onMouseDown, tabIndex = _useTabPanel.tabIndex;
    return (0, $3dJ4i.jsx)((0, $6jtA2.default), {
        testId: testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        onMouseDown: onMouseDown,
        tabIndex: tabIndex
    }, (0, $3dJ4i.jsx)((0, $1oC0p.Fragment), null, children));
};
var $63bb0b7661c0db5a$export$2e2bcd8739ae039 = $63bb0b7661c0db5a$var$TabPanel;

});


parcelRegister("6t7fC", function(module, exports) {
$parcel$export(module.exports, "MarkdownRenderer", function () { return $5eb21ac4763f1e08$export$22c2c977437cf477; });

var $6ogO3 = parcelRequire("6ogO3");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $aaxHj = parcelRequire("aaxHj");

const $5eb21ac4763f1e08$var$AkReactRenderer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).lazy(()=>(parcelRequire("icxGd")).then(({ ReactRenderer: ReactRenderer })=>({
            default: ReactRenderer
        })));
const $5eb21ac4763f1e08$var$MediaComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Fragment), {});
const $5eb21ac4763f1e08$var$MediaSingleComponent = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Fragment), {});
const $5eb21ac4763f1e08$export$22c2c977437cf477 = ({ answerString: answerString, statusComponent: statusComponent })=>{
    const docContent = (0, $1oC0p.useMemo)(()=>(0, $aaxHj.encodeAdf)(answerString, false), [
        answerString
    ]);
    const config = {
        document: docContent,
        nodeComponents: {
            status: statusComponent,
            media: $5eb21ac4763f1e08$var$MediaComponent,
            mediaSingle: $5eb21ac4763f1e08$var$MediaSingleComponent
        },
        smartLinks: {
            ssr: true
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Fragment), {}),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($5eb21ac4763f1e08$var$AkReactRenderer, (0, $6ogO3._)({}, config))
    });
};

});
parcelRegister("aaxHj", function(module, exports) {
$parcel$export(module.exports, "encodeAdf", function () { return $a5268bf7b8cf8e18$export$53ded0b846f45216; });

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $ghfnZ = parcelRequire("ghfnZ");

var $9nLCM = parcelRequire("9nLCM");

var $cnLy7 = parcelRequire("cnLy7");
const $a5268bf7b8cf8e18$export$d801201dc544181 = (content)=>{
    /*
  This try-catch is a necessary guard rail against broken content to prevent higher level
  error boundaries from displaying the error and breaking the experience.
  */ try {
        return typeof content !== "string" && "type" in content && content.type === "doc";
    } catch (e) {
        return false;
    }
};
const $a5268bf7b8cf8e18$export$a236f395afded7e0 = (content, suggestionContent)=>{
    if ($a5268bf7b8cf8e18$export$d801201dc544181(content)) {
        // Ensure the content is an array of nodes
        const updatedContent = Array.isArray(content.content) ? content.content : [
            content.content
        ];
        // Append the new paragraph node
        updatedContent.push({
            type: "paragraph",
            content: [
                {
                    type: "text",
                    text: suggestionContent
                }
            ]
        });
        // Return the updated DocNode
        return (0, $dPABA._)((0, $6ogO3._)({}, content), {
            content: updatedContent
        });
    }
    return `${content}\n\n${suggestionContent}`;
};
const $a5268bf7b8cf8e18$var$pluginConfig = {
    linkify: {
        findFilepaths: $ghfnZ.findFilepaths,
        isLinkInMatches: $ghfnZ.isLinkInMatches
    },
    smartLinks: {
        regexStorage: globalThis.localStorage
    }
};
const $a5268bf7b8cf8e18$export$3374c63d7715b4ce = new (0, $9nLCM.ADFEncoder)((schema)=>new (0, $cnLy7.AiMateMarkdownTransformer)(schema, $a5268bf7b8cf8e18$var$pluginConfig, false));
const $a5268bf7b8cf8e18$var$streamingAdfEncoder = new (0, $9nLCM.ADFEncoder)((schema)=>new (0, $cnLy7.AiMateMarkdownTransformer)(schema, $a5268bf7b8cf8e18$var$pluginConfig, true));
const $a5268bf7b8cf8e18$export$53ded0b846f45216 = (content, streaming)=>{
    if ($a5268bf7b8cf8e18$export$d801201dc544181(content)) return content;
    return streaming ? $a5268bf7b8cf8e18$var$streamingAdfEncoder.encode(content) : $a5268bf7b8cf8e18$export$3374c63d7715b4ce.encode(content);
};

});
parcelRegister("ghfnZ", function(module, exports) {
$parcel$export(module.exports, "findFilepaths", function () { return $bd9a2b33eac30f35$export$d37783fe63e2f0fe; });
$parcel$export(module.exports, "isLinkInMatches", function () { return $bd9a2b33eac30f35$export$5e652e74655163e5; });

var $eMbav = parcelRequire("eMbav");

var $eR7KT = parcelRequire("eR7KT");

var $dB7hx = parcelRequire("dB7hx");

var $03zMz = parcelRequire("03zMz");

var $jtlzE = parcelRequire("jtlzE");

var $dfHZU = parcelRequire("dfHZU");
var $bd9a2b33eac30f35$export$893fccbed37586dd = /([a-zA-Z]:|\\)([^\/:*?<>"|]+\\)?([^\/:*?<>"| ]+(?=\s?))?/gim;
var $bd9a2b33eac30f35$export$dabcc234035f6703 = /^(\$|{)/;
var $bd9a2b33eac30f35$export$4490385c12bf3d4 = /*#__PURE__*/ function() {
    function LinkMatcher() {
        (0, $eMbav.default)(this, LinkMatcher);
    }
    return (0, $eR7KT.default)(LinkMatcher, null, [
        {
            key: "create",
            value: function create() {
                var LinkMatcherRegex = /*#__PURE__*/ function() {
                    function LinkMatcherRegex() {
                        (0, $eMbav.default)(this, LinkMatcherRegex);
                    }
                    return (0, $eR7KT.default)(LinkMatcherRegex, [
                        {
                            key: "exec",
                            value: function exec(str) {
                                var stringsBySpace = str.slice(0, str.length - 1).split(' ');
                                var lastStringBeforeSpace = stringsBySpace[stringsBySpace.length - 1];
                                var isLastStringValid = lastStringBeforeSpace.length > 0;
                                if (!str.endsWith(' ') || !isLastStringValid) return null;
                                if ($bd9a2b33eac30f35$export$dabcc234035f6703.test(lastStringBeforeSpace)) return null;
                                var links = (0, $dB7hx.linkify).match(lastStringBeforeSpace);
                                if (!links || links.length === 0) return null;
                                var lastMatch = links[links.length - 1];
                                var lastLink = links[links.length - 1];
                                lastLink.input = str.substring(lastMatch.index);
                                lastLink.length = lastLink.lastIndex - lastLink.index + 1;
                                lastLink.index = str.lastIndexOf(lastStringBeforeSpace) + lastMatch.index;
                                return lastLink;
                            }
                        }
                    ]);
                }();
                return new LinkMatcherRegex();
            }
        }
    ]);
}();
function $bd9a2b33eac30f35$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    if ((0, $dB7hx.isSafeUrl)(url)) return url;
    return (0, $dB7hx.normalizeUrl)(url);
}
function $bd9a2b33eac30f35$export$5a511fa58fab15e6(schema) {
    return function(slice) {
        return (0, $dfHZU.mapSlice)(slice, function(node, parent) {
            var isAllowedInParent = !parent || parent.type !== schema.nodes.codeBlock;
            var link = node.type.schema.marks.link;
            if (link === undefined) throw new Error('Link not in schema - unable to linkify content');
            if (isAllowedInParent && node.isText && !link.isInSet(node.marks)) {
                var linkified = [];
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                var text = node.text;
                var matches = $bd9a2b33eac30f35$var$findLinkMatches(text).filter((0, $jtlzE.shouldAutoLinkifyMatch));
                var pos = 0;
                var filepaths = $bd9a2b33eac30f35$export$d37783fe63e2f0fe(text);
                matches.forEach(function(match) {
                    if ($bd9a2b33eac30f35$export$5e652e74655163e5(match.index, filepaths)) return;
                    if (match.index > 0) linkified.push(node.cut(pos, match.index));
                    linkified.push(node.cut(match.index, match.lastIndex).mark(link.create({
                        href: $bd9a2b33eac30f35$export$6535eb414fa2c8b6(match.url)
                    }).addToSet(node.marks)));
                    pos = match.lastIndex;
                });
                if (pos < text.length) linkified.push(node.cut(pos));
                return linkified;
            }
            return node;
        });
    };
}
function $bd9a2b33eac30f35$export$238a6141b3685c21(url) {
    // Remove protocol and www., if either exists
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var withoutProtocol = url.toLowerCase().replace(/^(.*):\/\//, '');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var withoutWWW = withoutProtocol.replace(/^(www\.)/, '');
    // Remove port, fragment, path, query string
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return withoutWWW.replace(/[:\/?#](.*)$/, '');
}
function $bd9a2b33eac30f35$export$336c6a47b1dfa1bc(url) {
    if (!window || !window.location) return false;
    var currentDomain = window.location.hostname;
    var linkDomain = $bd9a2b33eac30f35$export$238a6141b3685c21(url);
    return currentDomain === linkDomain;
}
/**
 * Fetch linkify matches from text
 * @param text Input text from a node
 * @returns Array of linkify matches. Returns empty array if text is empty or no matches found;
 */ function $bd9a2b33eac30f35$var$findLinkMatches(text) {
    if (text === '') return [];
    return (0, $dB7hx.linkify).match(text) || [];
}
var $bd9a2b33eac30f35$export$d37783fe63e2f0fe = function findFilepaths(text) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Creation of a copy of the RegExp is necessary as lastIndex is stored on it when we run .exec()
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var localRegExp = new RegExp($bd9a2b33eac30f35$export$893fccbed37586dd);
    var match;
    var matchesList = [];
    var maxFilepathSize = 260;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while((match = localRegExp.exec(text)) !== null){
        var start = match.index + offset;
        var end = localRegExp.lastIndex + offset;
        if (end - start > maxFilepathSize) end = start + maxFilepathSize;
         // We don't care about big strings of text that are pretending to be filepaths!!
        matchesList.push({
            startIndex: start,
            endIndex: end
        });
    }
    return matchesList;
};
var $bd9a2b33eac30f35$export$5e652e74655163e5 = function isLinkInMatches(linkStart, matchesList) {
    for(var i = 0; i < matchesList.length; i++){
        if (linkStart >= matchesList[i].startIndex && linkStart < matchesList[i].endIndex) return true;
    }
    return false;
};
function $bd9a2b33eac30f35$export$56039faad4eda709(inputMethod, url) {
    return {
        action: (0, $03zMz.ACTION).INSERTED,
        actionSubject: (0, $03zMz.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $03zMz.ACTION_SUBJECT_ID).LINK,
        attributes: {
            inputMethod: inputMethod,
            fromCurrentDomain: $bd9a2b33eac30f35$export$336c6a47b1dfa1bc(url)
        },
        eventType: (0, $03zMz.EVENT_TYPE).TRACK,
        nonPrivacySafeAttributes: {
            linkDomain: $bd9a2b33eac30f35$export$238a6141b3685c21(url)
        }
    };
}
var $bd9a2b33eac30f35$export$b7392a423e62dc8c = function canLinkBeCreatedInRange(from, to) {
    return function(state) {
        if (!state.doc.rangeHasMark(from, to, state.schema.marks.link)) {
            var $from = state.doc.resolve(from);
            var $to = state.doc.resolve(to);
            var link = state.schema.marks.link;
            if ($from.parent === $to.parent && $from.parent.isTextblock) {
                if ($from.parent.type.allowsMarkType(link)) {
                    var allowed = true;
                    state.doc.nodesBetween(from, to, function(node) {
                        allowed = allowed && !node.marks.some(function(m) {
                            return m.type.excludes(link);
                        });
                        return allowed;
                    });
                    return allowed;
                }
            }
        }
        return false;
    };
};

});
parcelRegister("eMbav", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ac1e362f0048cb10$export$2e2bcd8739ae039; });
function $ac1e362f0048cb10$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("eR7KT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ad0c07fdb0152674$export$2e2bcd8739ae039; });

var $2fDns = parcelRequire("2fDns");
function $ad0c07fdb0152674$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $2fDns.default)(o.key), o);
    }
}
function $ad0c07fdb0152674$export$2e2bcd8739ae039(e, r, t) {
    return r && $ad0c07fdb0152674$var$_defineProperties(e.prototype, r), t && $ad0c07fdb0152674$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("2fDns", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1a3b86fe79b93268$export$2e2bcd8739ae039; });

var $euchL = parcelRequire("euchL");

var $9tzbx = parcelRequire("9tzbx");
function $1a3b86fe79b93268$export$2e2bcd8739ae039(t) {
    var i = (0, $9tzbx.default)(t, "string");
    return "symbol" == (0, $euchL.default)(i) ? i : i + "";
}

});
parcelRegister("euchL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a8bd65ab580d4d8c$export$2e2bcd8739ae039; });
function $a8bd65ab580d4d8c$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $a8bd65ab580d4d8c$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a8bd65ab580d4d8c$export$2e2bcd8739ae039(o);
}

});

parcelRegister("9tzbx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6e621d84c2826547$export$2e2bcd8739ae039; });

var $euchL = parcelRequire("euchL");
function $6e621d84c2826547$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $euchL.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $euchL.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("dB7hx", function(module, exports) {
$parcel$export(module.exports, "isSafeUrl", function () { return $9e64611d4fd4d340$export$c9f92f5469372e0f; });
$parcel$export(module.exports, "linkify", function () { return $9e64611d4fd4d340$export$8ccbde94d5c7f8e7; });
$parcel$export(module.exports, "linkifyMatch", function () { return $9e64611d4fd4d340$export$6f7d7761b97f967; });
$parcel$export(module.exports, "normalizeUrl", function () { return $9e64611d4fd4d340$export$6535eb414fa2c8b6; });
$parcel$export(module.exports, "isRootRelative", function () { return $9e64611d4fd4d340$export$23579274a7a24f7b; });
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $l2qL1 = parcelRequire("l2qL1");
var $9e64611d4fd4d340$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
var $9e64611d4fd4d340$export$c9f92f5469372e0f = function isSafeUrl(url) {
    var urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $9e64611d4fd4d340$var$whitelistedURLPatterns.some(function(p) {
        return p.test(urlTrimmed);
    });
};
var $9e64611d4fd4d340$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($l2qL1)))();
$9e64611d4fd4d340$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$9e64611d4fd4d340$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
var $9e64611d4fd4d340$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$9e64611d4fd4d340$export$8ccbde94d5c7f8e7.add('tel:', $9e64611d4fd4d340$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$9e64611d4fd4d340$export$8ccbde94d5c7f8e7.add('file:', $9e64611d4fd4d340$var$urlWithoutSpacesValidator);
$9e64611d4fd4d340$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
var $9e64611d4fd4d340$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
var $9e64611d4fd4d340$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$9e64611d4fd4d340$var$tlds.push($9e64611d4fd4d340$var$tlds2Char);
$9e64611d4fd4d340$export$8ccbde94d5c7f8e7.tlds($9e64611d4fd4d340$var$tlds, false);
var $9e64611d4fd4d340$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
var $9e64611d4fd4d340$export$6f7d7761b97f967 = function linkifyMatch(text) {
    if (!$9e64611d4fd4d340$export$746d02eae03c72e1.test(text)) return [];
    var matches = [];
    var startpos = 0;
    var substr;
    while(substr = text.substr(startpos)){
        var link = (substr.match($9e64611d4fd4d340$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            var index = substr.search($9e64611d4fd4d340$export$746d02eae03c72e1);
            var start = index >= 0 ? index + startpos : index;
            var end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $9e64611d4fd4d340$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    var match = $9e64611d4fd4d340$export$6f7d7761b97f967(str);
    if (!match.length) match = $9e64611d4fd4d340$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $9e64611d4fd4d340$export$6535eb414fa2c8b6(url) {
    var match = $9e64611d4fd4d340$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $9e64611d4fd4d340$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});
parcelRegister("l2qL1", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $f50e8a5a9ba16f7e$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $f50e8a5a9ba16f7e$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $f50e8a5a9ba16f7e$var$isString(obj) {
    return $f50e8a5a9ba16f7e$var$_class(obj) === '[object String]';
}
function $f50e8a5a9ba16f7e$var$isObject(obj) {
    return $f50e8a5a9ba16f7e$var$_class(obj) === '[object Object]';
}
function $f50e8a5a9ba16f7e$var$isRegExp(obj) {
    return $f50e8a5a9ba16f7e$var$_class(obj) === '[object RegExp]';
}
function $f50e8a5a9ba16f7e$var$isFunction(obj) {
    return $f50e8a5a9ba16f7e$var$_class(obj) === '[object Function]';
}
function $f50e8a5a9ba16f7e$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $f50e8a5a9ba16f7e$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $f50e8a5a9ba16f7e$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $f50e8a5a9ba16f7e$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $f50e8a5a9ba16f7e$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $f50e8a5a9ba16f7e$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $f50e8a5a9ba16f7e$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $f50e8a5a9ba16f7e$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $f50e8a5a9ba16f7e$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $f50e8a5a9ba16f7e$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $f50e8a5a9ba16f7e$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("fFqhl"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($f50e8a5a9ba16f7e$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($f50e8a5a9ba16f7e$var$isObject(val)) {
            if ($f50e8a5a9ba16f7e$var$isRegExp(val.validate)) compiled.validate = $f50e8a5a9ba16f7e$var$createValidator(val.validate);
            else if ($f50e8a5a9ba16f7e$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($f50e8a5a9ba16f7e$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $f50e8a5a9ba16f7e$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($f50e8a5a9ba16f7e$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $f50e8a5a9ba16f7e$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($f50e8a5a9ba16f7e$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $f50e8a5a9ba16f7e$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $f50e8a5a9ba16f7e$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $f50e8a5a9ba16f7e$var$createMatch(self, shift) {
    var match = new $f50e8a5a9ba16f7e$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $f50e8a5a9ba16f7e$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $f50e8a5a9ba16f7e$var$LinkifyIt)) return new $f50e8a5a9ba16f7e$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($f50e8a5a9ba16f7e$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $f50e8a5a9ba16f7e$var$assign({}, $f50e8a5a9ba16f7e$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $f50e8a5a9ba16f7e$var$assign({}, $f50e8a5a9ba16f7e$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $f50e8a5a9ba16f7e$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $f50e8a5a9ba16f7e$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $f50e8a5a9ba16f7e$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $f50e8a5a9ba16f7e$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $f50e8a5a9ba16f7e$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $f50e8a5a9ba16f7e$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $f50e8a5a9ba16f7e$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $f50e8a5a9ba16f7e$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $f50e8a5a9ba16f7e$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $f50e8a5a9ba16f7e$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($f50e8a5a9ba16f7e$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($f50e8a5a9ba16f7e$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $f50e8a5a9ba16f7e$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $f50e8a5a9ba16f7e$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $f50e8a5a9ba16f7e$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $f50e8a5a9ba16f7e$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $f50e8a5a9ba16f7e$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $f50e8a5a9ba16f7e$var$LinkifyIt;

});
parcelRegister("fFqhl", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("cESS3")).source;
    re.src_Cc = (parcelRequire("1ladB")).source;
    re.src_Z = (parcelRequire("aKpnB")).source;
    re.src_P = (parcelRequire("9R3PW")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,4}[a-zA-Z0-9%/]|' + // github has ... in commit range links,
    // google has .... in links (issue #66)
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});
parcelRegister("cESS3", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("1ladB", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("aKpnB", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});

parcelRegister("9R3PW", function(module, exports) {
module.exports = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});




parcelRegister("03zMz", function(module, exports) {
$parcel$export(module.exports, "EVENT_TYPE", function () { return $00ac098b856ddcac$export$76a2e4c433c23bb9; });
$parcel$export(module.exports, "ACTION", function () { return $00ac098b856ddcac$export$9523889e0a5da4ba; });
$parcel$export(module.exports, "ACTION_SUBJECT", function () { return $00ac098b856ddcac$export$7525482b5931e326; });
$parcel$export(module.exports, "ACTION_SUBJECT_ID", function () { return $00ac098b856ddcac$export$9957974f8b4d8f74; });
var $00ac098b856ddcac$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $00ac098b856ddcac$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["ACTIONED"] = "actioned";
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["API_ERROR"] = "apiError";
    ACTION["API_RECEIVED"] = "apiReceived";
    ACTION["API_PURGED"] = "apiPurged";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICK"] = "click";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
    ACTION["DOUBLE_CLICKED"] = "doubleClicked";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENDED"] = "ended";
    ACTION["ENTERED"] = "entered";
    ACTION["ERROR"] = "error";
    ACTION["ERRORED"] = "errored";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FAILED_TO_INSERT"] = "failedToInsert";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["UNDO_PERFORMED"] = "undo";
    ACTION["REDO_PERFORMED"] = "redo";
    ACTION["FORMATTED"] = "formatted";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    ACTION["INITIATED"] = "initiated";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["OFFLINE_STORAGE_TOO_MANY_RETRIES_ERROR"] = "offlineStorageTooManyRetriesError";
    ACTION["OFFLINE_STORAGE_STEPS_DATABASE_ERROR"] = "offlineStorageStepsDatabaseError";
    ACTION["OFFLINE_STORAGE_RESYNC_ONLINE"] = "offlineStorageResyncOnline";
    ACTION["OFFLINE_STORAGE_BROADCAST_CHANNEL_FIRST_UPDATE"] = "offlineStorageBroadcastChannelFirstUpdate";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PRESSED"] = "pressed";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBMITTED"] = "submitted";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["TOGGLED"] = "toggled";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNHANDLED_ERROR_CAUGHT"] = "unhandledErrorCaught";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
    ACTION["RENDERED"] = "rendered";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    /**
   * @private
   * @deprecated
   *
   * This is no longer used and can be removed at a later date
   */ ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
    ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["STEPS_TRACKED"] = "stepsTracked";
    ACTION["STEPS_FILTERED"] = "stepsFiltered";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDREN"] = "getChildren";
    ACTION["GET_CHILDREN_CONTAINER"] = "getChildrenContainer";
    ACTION["MOVED"] = "moved";
    ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
    ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
    ACTION["UPLOAD_FAILED"] = "uploadFailed";
    ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    ACTION["RESIZED"] = "resized";
    ACTION["BLOCKS_DRAG_INIT"] = "blocksDragInit";
    ACTION["SINGLE_COL_LAYOUT_DETECTED"] = "singleColumLayoutDetected";
    ACTION["VIEW_MORE"] = "viewMore";
    /**
   * used in Editor AI inline suggestion for a track event when a suggestion is inserted
   * previously tracked events being used by Editor AI proactive suggestion
   *
   */ ACTION["SUGGESTION_INSERTED"] = "suggestionInserted";
    ACTION["SUGGESTION_DISMISSED"] = "suggestionDismissed";
    ACTION["SUGGESTION_VIEWED"] = "suggestionViewed";
    return ACTION;
}({});
var $00ac098b856ddcac$export$85f107b1fcc9d96f = /*#__PURE__*/ function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    INPUT_METHOD["BROWSER"] = "browser";
    INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    INPUT_METHOD["INLINE_SUGGESTION_FLOATING_TB"] = "inlineSuggestionFloatingToolbar";
    return INPUT_METHOD;
}({});
var $00ac098b856ddcac$export$9b31fa32ae3f8051 = /*#__PURE__*/ function(INSERT_MEDIA_VIA) {
    INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
    INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
    INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    return INSERT_MEDIA_VIA;
}({});
var $00ac098b856ddcac$export$81a8b7dba1aa8f75 = /*#__PURE__*/ function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    // single key, e.g. Esc, Enter
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    // combination of keys, e.g. Mod + F
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    TRIGGER_METHOD["EXTERNAL"] = "external";
    return TRIGGER_METHOD;
}({});
var $00ac098b856ddcac$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["AI_INTERACTION"] = "aiInteraction";
    ACTION_SUBJECT["AI_RESULT"] = "aiResult";
    ACTION_SUBJECT["AI_FEEDBACK"] = "aiFeedback";
    ACTION_SUBJECT["COLLAB"] = "collab";
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ACTIVITY_SESSION"] = "activitySession";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["MENTION"] = "mention";
    ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
    ACTION_SUBJECT["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
    ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
    ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
    ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
    ACTION_SUBJECT["DECORATION"] = "decoration";
    ACTION_SUBJECT["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT["EDITOR_PLUGIN_SELECTION_EXTENSION"] = "editorPluginSelectionExtension";
    ACTION_SUBJECT["AI_DEFINITIONS"] = "aiDefinitions";
    ACTION_SUBJECT["USER_PREFERENCES"] = "userPreferences";
    ACTION_SUBJECT["ALIGNMENT"] = "alignment";
    ACTION_SUBJECT["OFFLINE_EDITING"] = "offlineEditing";
    return ACTION_SUBJECT;
}({});
var $00ac098b856ddcac$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ACTIVITY"] = "activity";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
    ACTION_SUBJECT_ID["AI_INLINE_SUGGESTION"] = "aiInlineSuggestion";
    ACTION_SUBJECT_ID["AI_PANELS_BODIED_EXTENSION"] = "aiPanelsBodiedExtension";
    ACTION_SUBJECT_ID["AI_PROMPT_LINK_PICKER_BUTTON"] = "aiPromptLinkPickerButton";
    ACTION_SUBJECT_ID["AI_PROMPT_MENTION_BUTTON"] = "aiPromptMentionButton";
    ACTION_SUBJECT_ID["AI_PROACTIVE_FEEDBACK_DIALOG"] = "aiProactiveFeedbackDialog";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXPERIENCE_APPLICATION"] = "experienceApplication";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PICKER_TABLE_SIZE"] = "tableSizePicker";
    ACTION_SUBJECT_ID["DOCKED_PRIMARY_TOOLBAR"] = "dockedPrimaryToolbar";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PROACTIVE_SUGGESTION"] = "proactiveSuggestion";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RESPONSE_FEEDBACK_BUTTON"] = "responseFeedbackButton";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR_PREFERENCES"] = "selectionToolbarPreferences";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_DROPDOWN"] = "editorPluginSelectionExtensionDropdown";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_ITEM"] = "editorPluginSelectionExtensionItem";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT"] = "editorPluginSelectionExtensionComponent";
    return ACTION_SUBJECT_ID;
}({});
var $00ac098b856ddcac$export$75ef928acd21e35b = /*#__PURE__*/ function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    return FLOATING_CONTROLS_TITLE;
}({});
var $00ac098b856ddcac$export$9f0b2adf3cfd71b7 = /*#__PURE__*/ function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    return CONTENT_COMPONENT;
}({});

});

parcelRegister("jtlzE", function(module, exports) {
$parcel$export(module.exports, "shouldAutoLinkifyMatch", function () { return $e2d175e6f0eb9d1f$export$e19a09e301eaa6bb; });
/** Created by scanning the Wikipedia page for all TLDs and selecting those that are common filenames, along
 * with customer complaints */ var $e2d175e6f0eb9d1f$var$tldsToNotAutoLinkify = [
    'name',
    'zip',
    'doc',
    'mov',
    // Ensure common 2 character file extensions aren't linkified without https prefix
    'md',
    // Postscript
    'ps',
    // C++
    'cc',
    // C#
    'cs',
    // f#
    'fs',
    // Go
    'go',
    // JavaScript
    'js',
    // Perl
    'pl',
    // Perl module
    'pm',
    // Python
    'py',
    // Ruby
    'rb',
    // Rust
    'rs',
    // Bash
    'sh',
    // Typescript
    'ts',
    // C#
    'cs',
    // Visual Basic
    'vb'
];
function $e2d175e6f0eb9d1f$export$977fe75b90bdd614(url) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var startsWithHttpHttps = /^https?:\/\//.test(url);
    if (startsWithHttpHttps) return true;
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var startsWithWWW = /^www\./.test(url);
    if (startsWithWWW) return true;
    try {
        var hostname = new URL("https://".concat(url)).hostname;
        var parts = hostname.split('.');
        var tld = parts.length > 1 ? parts[parts.length - 1] : null;
        if (parts[0] === '') // If the domain is an empty string (ie the link is `.com`), it's invalid, so
        // automatically return true
        return true;
        if (!tld) return true;
        return !$e2d175e6f0eb9d1f$var$tldsToNotAutoLinkify.includes(tld);
    } catch (e) {
        return true;
    }
}
function $e2d175e6f0eb9d1f$export$e19a09e301eaa6bb(match) {
    return $e2d175e6f0eb9d1f$export$977fe75b90bdd614(match.raw);
}

});

parcelRegister("dfHZU", function(module, exports) {
$parcel$export(module.exports, "mapSlice", function () { return $9a5ece15f8f9fc10$export$d8264570c5933bbf; });

var $kiWpa = parcelRequire("kiWpa");

var $9ZwyL = parcelRequire("9ZwyL");
function $9a5ece15f8f9fc10$export$7b8536c35e9eb7d2(fragment) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return fragment.content;
}
function $9a5ece15f8f9fc10$export$81fe6b3b714fd0bf(content, callback) {
    var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var children = [];
    for(var i = 0, size = content.childCount; i < size; i++){
        var _node = content.child(i);
        var transformed = _node.isLeaf ? callback(_node, parent, i) : callback(_node.copy($9a5ece15f8f9fc10$export$81fe6b3b714fd0bf(_node.content, callback, _node)), parent, i);
        if (transformed) {
            if (transformed instanceof (0, $9ZwyL.Fragment)) children.push.apply(children, (0, $kiWpa.default)($9a5ece15f8f9fc10$export$7b8536c35e9eb7d2(transformed)));
            else if (Array.isArray(transformed)) children.push.apply(children, (0, $kiWpa.default)(transformed));
            else children.push(transformed);
        }
    }
    return (0, $9ZwyL.Fragment).fromArray(children);
}
function $9a5ece15f8f9fc10$export$d8264570c5933bbf(slice, callback) {
    var fragment = $9a5ece15f8f9fc10$export$81fe6b3b714fd0bf(slice.content, callback);
    return new (0, $9ZwyL.Slice)(fragment, slice.openStart, slice.openEnd);
}
function $9a5ece15f8f9fc10$export$c575791007f9dbd1(fragment, callback) {
    var fragmentContent = [];
    for(var i = 0; i < fragment.childCount; i++){
        var child = callback(fragment.child(i), i, fragment);
        if (Array.isArray(child)) fragmentContent.push.apply(fragmentContent, (0, $kiWpa.default)(child));
        else fragmentContent.push(child);
    }
    return (0, $9ZwyL.Fragment).fromArray(fragmentContent);
}
function $9a5ece15f8f9fc10$export$e0baa27f47733a4a(node, callback) {
    var array = [];
    for(var i = 0; i < node.childCount; i++)array.push(callback(node.child(i), i, node instanceof (0, $9ZwyL.Fragment) ? node : node.content));
    return array;
}
var $9a5ece15f8f9fc10$var$findNode = function findNode(predicate) {
    return function(slice) {
        var foundNode = null;
        slice.content.nodesBetween(0, slice.content.size, function(node) {
            if (predicate(node)) {
                foundNode = node;
                return false;
            }
            return true;
        });
        return foundNode;
    };
};
var $9a5ece15f8f9fc10$export$b6ae752d7894ad08 = function hasNode(predicate) {
    return function(slice) {
        return !!$9a5ece15f8f9fc10$var$findNode(predicate)(slice);
    };
};

});
parcelRegister("kiWpa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ec82cb1bf45af885$export$2e2bcd8739ae039; });

var $a3PXk = parcelRequire("a3PXk");

var $aqaeb = parcelRequire("aqaeb");

var $4eIz5 = parcelRequire("4eIz5");

var $aXBSc = parcelRequire("aXBSc");
function $ec82cb1bf45af885$export$2e2bcd8739ae039(r) {
    return (0, $a3PXk.default)(r) || (0, $aqaeb.default)(r) || (0, $4eIz5.default)(r) || (0, $aXBSc.default)();
}

});
parcelRegister("a3PXk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $75327c9385ab9be1$export$2e2bcd8739ae039; });

var $gEdng = parcelRequire("gEdng");
function $75327c9385ab9be1$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $gEdng.default)(r);
}

});
parcelRegister("gEdng", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c1eac1a0b4d1453c$export$2e2bcd8739ae039; });
function $c1eac1a0b4d1453c$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("aqaeb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $796444161fc7ff25$export$2e2bcd8739ae039; });
function $796444161fc7ff25$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("4eIz5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $315b09e4cb4a3bd6$export$2e2bcd8739ae039; });

var $gEdng = parcelRequire("gEdng");
function $315b09e4cb4a3bd6$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $gEdng.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $gEdng.default)(r, a) : void 0;
    }
}

});

parcelRegister("aXBSc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7faccae29d551f8c$export$2e2bcd8739ae039; });
function $7faccae29d551f8c$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("9ZwyL", function(module, exports) {
$parcel$export(module.exports, "Fragment", function () { return $74631143ca7d62be$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Slice", function () { return $74631143ca7d62be$export$b3f2e2de3a8baa1e; });
$parcel$export(module.exports, "Node", function () { return $74631143ca7d62be$export$85c928794f8d04d4; });
$parcel$export(module.exports, "MarkType", function () { return $74631143ca7d62be$export$b6a78689043c6521; });
$parcel$export(module.exports, "Schema", function () { return $74631143ca7d62be$export$19342e026b58ebb7; });
$parcel$export(module.exports, "DOMParser", function () { return $74631143ca7d62be$export$1059c6e7d2ce5669; });

var $l0GWs = parcelRequire("l0GWs");
function $74631143ca7d62be$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $74631143ca7d62be$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $74631143ca7d62be$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $74631143ca7d62be$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $74631143ca7d62be$export$ffb0004e005737fa {
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $74631143ca7d62be$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $74631143ca7d62be$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $74631143ca7d62be$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $74631143ca7d62be$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $74631143ca7d62be$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $74631143ca7d62be$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $74631143ca7d62be$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $74631143ca7d62be$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $74631143ca7d62be$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $74631143ca7d62be$var$retIndex(0, pos);
        if (pos == this.size) return $74631143ca7d62be$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $74631143ca7d62be$var$retIndex(i + 1, end);
                return $74631143ca7d62be$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $74631143ca7d62be$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $74631143ca7d62be$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $74631143ca7d62be$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $74631143ca7d62be$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $74631143ca7d62be$export$ffb0004e005737fa.empty;
        if (nodes instanceof $74631143ca7d62be$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $74631143ca7d62be$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $74631143ca7d62be$export$ffb0004e005737fa.empty = new $74631143ca7d62be$export$ffb0004e005737fa([], 0);
const $74631143ca7d62be$var$found = {
    index: 0,
    offset: 0
};
function $74631143ca7d62be$var$retIndex(index, offset) {
    $74631143ca7d62be$var$found.index = index;
    $74631143ca7d62be$var$found.offset = offset;
    return $74631143ca7d62be$var$found;
}
function $74631143ca7d62be$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$74631143ca7d62be$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$74631143ca7d62be$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $74631143ca7d62be$export$c9d15bcfc6d42044 {
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $74631143ca7d62be$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $74631143ca7d62be$export$c9d15bcfc6d42044.none;
        if (marks instanceof $74631143ca7d62be$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
}
/**
The empty set of marks.
*/ $74631143ca7d62be$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $74631143ca7d62be$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $74631143ca7d62be$export$b3f2e2de3a8baa1e {
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $74631143ca7d62be$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $74631143ca7d62be$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $74631143ca7d62be$export$b3f2e2de3a8baa1e($74631143ca7d62be$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $74631143ca7d62be$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $74631143ca7d62be$export$b3f2e2de3a8baa1e($74631143ca7d62be$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $74631143ca7d62be$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
}
/**
The empty slice.
*/ $74631143ca7d62be$export$b3f2e2de3a8baa1e.empty = new $74631143ca7d62be$export$b3f2e2de3a8baa1e($74631143ca7d62be$export$ffb0004e005737fa.empty, 0, 0);
function $74631143ca7d62be$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($74631143ca7d62be$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $74631143ca7d62be$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $74631143ca7d62be$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $74631143ca7d62be$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $74631143ca7d62be$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $74631143ca7d62be$export$6de0e778727af3f2("Inconsistent open depths");
    return $74631143ca7d62be$var$replaceOuter($from, $to, slice, 0);
}
function $74631143ca7d62be$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $74631143ca7d62be$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $74631143ca7d62be$var$close(node, $74631143ca7d62be$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $74631143ca7d62be$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $74631143ca7d62be$var$prepareSliceForReplace(slice, $from);
        return $74631143ca7d62be$var$close(node, $74631143ca7d62be$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $74631143ca7d62be$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $74631143ca7d62be$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $74631143ca7d62be$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $74631143ca7d62be$var$checkJoin(node, $after.node(depth));
    return node;
}
function $74631143ca7d62be$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $74631143ca7d62be$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $74631143ca7d62be$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$74631143ca7d62be$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $74631143ca7d62be$var$addNode($end.nodeBefore, target);
}
function $74631143ca7d62be$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $74631143ca7d62be$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $74631143ca7d62be$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $74631143ca7d62be$var$joinable($end, $to, depth + 1);
    let content = [];
    $74631143ca7d62be$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $74631143ca7d62be$var$checkJoin(openStart, openEnd);
        $74631143ca7d62be$var$addNode($74631143ca7d62be$var$close(openStart, $74631143ca7d62be$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $74631143ca7d62be$var$addNode($74631143ca7d62be$var$close(openStart, $74631143ca7d62be$var$replaceTwoWay($from, $start, depth + 1)), content);
        $74631143ca7d62be$var$addRange($start, $end, depth, content);
        if (openEnd) $74631143ca7d62be$var$addNode($74631143ca7d62be$var$close(openEnd, $74631143ca7d62be$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $74631143ca7d62be$var$addRange($to, null, depth, content);
    return new $74631143ca7d62be$export$ffb0004e005737fa(content);
}
function $74631143ca7d62be$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $74631143ca7d62be$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $74631143ca7d62be$var$joinable($from, $to, depth + 1);
        $74631143ca7d62be$var$addNode($74631143ca7d62be$var$close(type, $74631143ca7d62be$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $74631143ca7d62be$var$addRange($to, null, depth, content);
    return new $74631143ca7d62be$export$ffb0004e005737fa(content);
}
function $74631143ca7d62be$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($74631143ca7d62be$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $74631143ca7d62be$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $74631143ca7d62be$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $74631143ca7d62be$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $74631143ca7d62be$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $74631143ca7d62be$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $74631143ca7d62be$var$resolveCache.set(doc, cache = new $74631143ca7d62be$var$ResolveCache);
        let result = cache.elts[cache.i] = $74631143ca7d62be$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $74631143ca7d62be$var$resolveCacheSize;
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
}
class $74631143ca7d62be$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $74631143ca7d62be$var$resolveCacheSize = 12, $74631143ca7d62be$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $74631143ca7d62be$export$7bc461ceb770fb16 {
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
}
const $74631143ca7d62be$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $74631143ca7d62be$export$85c928794f8d04d4 {
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $74631143ca7d62be$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $74631143ca7d62be$var$emptyAttrs) && $74631143ca7d62be$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $74631143ca7d62be$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $74631143ca7d62be$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $74631143ca7d62be$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $74631143ca7d62be$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $74631143ca7d62be$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $74631143ca7d62be$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $74631143ca7d62be$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $74631143ca7d62be$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $74631143ca7d62be$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $74631143ca7d62be$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $74631143ca7d62be$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$74631143ca7d62be$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $74631143ca7d62be$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $74631143ca7d62be$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $74631143ca7d62be$export$ffb0004e005737fa.empty;
    }
}
$74631143ca7d62be$export$85c928794f8d04d4.prototype.text = undefined;
class $74631143ca7d62be$var$TextNode extends $74631143ca7d62be$export$85c928794f8d04d4 {
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $74631143ca7d62be$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $74631143ca7d62be$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $74631143ca7d62be$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
}
function $74631143ca7d62be$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $74631143ca7d62be$export$364ed450558d7ec4 {
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $74631143ca7d62be$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $74631143ca7d62be$export$364ed450558d7ec4.empty;
        let expr = $74631143ca7d62be$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $74631143ca7d62be$var$dfa($74631143ca7d62be$var$nfa(expr));
        $74631143ca7d62be$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $74631143ca7d62be$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
}
/**
@internal
*/ $74631143ca7d62be$export$364ed450558d7ec4.empty = new $74631143ca7d62be$export$364ed450558d7ec4(true);
class $74631143ca7d62be$var$TokenStream {
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
}
function $74631143ca7d62be$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($74631143ca7d62be$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $74631143ca7d62be$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($74631143ca7d62be$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $74631143ca7d62be$var$parseExprSubscript(stream) {
    let expr = $74631143ca7d62be$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $74631143ca7d62be$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $74631143ca7d62be$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $74631143ca7d62be$var$parseExprRange(stream, expr) {
    let min = $74631143ca7d62be$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $74631143ca7d62be$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $74631143ca7d62be$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $74631143ca7d62be$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $74631143ca7d62be$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $74631143ca7d62be$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $74631143ca7d62be$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $74631143ca7d62be$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $74631143ca7d62be$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($74631143ca7d62be$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $74631143ca7d62be$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($74631143ca7d62be$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $74631143ca7d62be$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $74631143ca7d62be$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($74631143ca7d62be$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $74631143ca7d62be$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $74631143ca7d62be$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $74631143ca7d62be$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $74631143ca7d62be$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $74631143ca7d62be$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $74631143ca7d62be$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $74631143ca7d62be$export$f06e977173f1857c {
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $74631143ca7d62be$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $74631143ca7d62be$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $74631143ca7d62be$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $74631143ca7d62be$export$ffb0004e005737fa.from(content), $74631143ca7d62be$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $74631143ca7d62be$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $74631143ca7d62be$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $74631143ca7d62be$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $74631143ca7d62be$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($74631143ca7d62be$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $74631143ca7d62be$export$85c928794f8d04d4(this, attrs, content.append(after), $74631143ca7d62be$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $74631143ca7d62be$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $74631143ca7d62be$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $74631143ca7d62be$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $74631143ca7d62be$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $74631143ca7d62be$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
}
function $74631143ca7d62be$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $74631143ca7d62be$var$Attribute {
    get isRequired() {
        return !this.hasDefault;
    }
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $74631143ca7d62be$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $74631143ca7d62be$export$b6a78689043c6521 {
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $74631143ca7d62be$export$c9d15bcfc6d42044(this, $74631143ca7d62be$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $74631143ca7d62be$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $74631143ca7d62be$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $74631143ca7d62be$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $74631143ca7d62be$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $74631143ca7d62be$export$c9d15bcfc6d42044(this, defaults) : null;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $74631143ca7d62be$export$19342e026b58ebb7 {
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $74631143ca7d62be$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $74631143ca7d62be$var$TextNode(type, type.defaultAttrs, text, $74631143ca7d62be$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $74631143ca7d62be$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $74631143ca7d62be$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $l0GWs.default).from(spec.nodes), instanceSpec.marks = (0, $l0GWs.default).from(spec.marks || {}), this.nodes = $74631143ca7d62be$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $74631143ca7d62be$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $74631143ca7d62be$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $74631143ca7d62be$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $74631143ca7d62be$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
}
function $74631143ca7d62be$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $74631143ca7d62be$var$isTagRule(rule) {
    return rule.tag != null;
}
function $74631143ca7d62be$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $74631143ca7d62be$export$1059c6e7d2ce5669 {
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $74631143ca7d62be$var$ParseContext(this, options, false);
        context.addAll(dom, $74631143ca7d62be$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $74631143ca7d62be$var$ParseContext(this, options, true);
        context.addAll(dom, $74631143ca7d62be$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $74631143ca7d62be$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($74631143ca7d62be$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $74631143ca7d62be$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $74631143ca7d62be$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $74631143ca7d62be$export$1059c6e7d2ce5669(schema, $74631143ca7d62be$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($74631143ca7d62be$var$isTagRule(rule)) this.tags.push(rule);
            else if ($74631143ca7d62be$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
}
const $74631143ca7d62be$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $74631143ca7d62be$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $74631143ca7d62be$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $74631143ca7d62be$var$OPT_PRESERVE_WS = 1, $74631143ca7d62be$var$OPT_PRESERVE_WS_FULL = 2, $74631143ca7d62be$var$OPT_OPEN_LEFT = 4;
function $74631143ca7d62be$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $74631143ca7d62be$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $74631143ca7d62be$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $74631143ca7d62be$var$OPT_PRESERVE_WS | $74631143ca7d62be$var$OPT_PRESERVE_WS_FULL : base & ~$74631143ca7d62be$var$OPT_OPEN_LEFT;
}
class $74631143ca7d62be$var$NodeContext {
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($74631143ca7d62be$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $74631143ca7d62be$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $74631143ca7d62be$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($74631143ca7d62be$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$74631143ca7d62be$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $74631143ca7d62be$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $74631143ca7d62be$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
}
class $74631143ca7d62be$var$ParseContext {
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $74631143ca7d62be$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $74631143ca7d62be$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($74631143ca7d62be$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $74631143ca7d62be$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $74631143ca7d62be$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($74631143ca7d62be$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $74631143ca7d62be$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $74631143ca7d62be$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $74631143ca7d62be$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $74631143ca7d62be$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $74631143ca7d62be$var$OPT_OPEN_LEFT;
        let applyMarks = $74631143ca7d62be$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $74631143ca7d62be$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $74631143ca7d62be$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $74631143ca7d62be$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $74631143ca7d62be$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $74631143ca7d62be$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $74631143ca7d62be$var$NodeContext(topNode.type, topNode.attrs, $74631143ca7d62be$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $74631143ca7d62be$var$NodeContext(null, null, $74631143ca7d62be$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $74631143ca7d62be$var$NodeContext(parser.schema.topNodeType, null, $74631143ca7d62be$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $74631143ca7d62be$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $74631143ca7d62be$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $74631143ca7d62be$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $74631143ca7d62be$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $74631143ca7d62be$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $74631143ca7d62be$export$3476b78f8f5a8b72 {
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $74631143ca7d62be$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $74631143ca7d62be$var$renderSpec($74631143ca7d62be$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $74631143ca7d62be$var$renderSpec($74631143ca7d62be$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $74631143ca7d62be$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $74631143ca7d62be$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $74631143ca7d62be$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $74631143ca7d62be$var$gatherToDOM(schema.marks);
    }
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
}
function $74631143ca7d62be$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $74631143ca7d62be$var$doc(options) {
    return options.document || window.document;
}
const $74631143ca7d62be$var$suspiciousAttributeCache = new WeakMap();
function $74631143ca7d62be$var$suspiciousAttributes(attrs) {
    let value = $74631143ca7d62be$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $74631143ca7d62be$var$suspiciousAttributeCache.set(attrs, value = $74631143ca7d62be$var$suspiciousAttributesInner(attrs));
    return value;
}
function $74631143ca7d62be$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $74631143ca7d62be$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $74631143ca7d62be$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $74631143ca7d62be$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("l0GWs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f4bae868ce132e52$export$2e2bcd8739ae039; });
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $f4bae868ce132e52$var$OrderedMap(content) {
    this.content = content;
}
$f4bae868ce132e52$var$OrderedMap.prototype = {
    constructor: $f4bae868ce132e52$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $f4bae868ce132e52$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $f4bae868ce132e52$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $f4bae868ce132e52$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $f4bae868ce132e52$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $f4bae868ce132e52$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $f4bae868ce132e52$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $f4bae868ce132e52$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $f4bae868ce132e52$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $f4bae868ce132e52$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $f4bae868ce132e52$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$f4bae868ce132e52$var$OrderedMap.from = function(value) {
    if (value instanceof $f4bae868ce132e52$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $f4bae868ce132e52$var$OrderedMap(content);
};
var $f4bae868ce132e52$export$2e2bcd8739ae039 = $f4bae868ce132e52$var$OrderedMap;

});




parcelRegister("9nLCM", function(module, exports) {
$parcel$export(module.exports, "ADFEncoder", function () { return $6d4b3448934f1576$export$bcf771b83128eae7; });
$parcel$export(module.exports, "getText", function () { return $6d4b3448934f1576$export$c72d34660a162238; });
$parcel$export(module.exports, "getEventHandler", function () { return $6d4b3448934f1576$export$eee20638634729b3; });
$parcel$export(module.exports, "findInTree", function () { return $6d4b3448934f1576$export$38b61ebf4950cd39; });

var $2871N = parcelRequire("2871N");

var $hiPA7 = parcelRequire("hiPA7");

var $doB2u = parcelRequire("doB2u");

var $kjsd0 = parcelRequire("kjsd0");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6d4b3448934f1576$var$createEncoder(parser, encoder) {
    return function(value) {
        return encoder.encode(parser.parse(value));
    };
}
var $6d4b3448934f1576$export$bcf771b83128eae7 = /*#__PURE__*/ (0, $2871N.default)(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function ADFEncoder(createTransformerWithSchema) {
    (0, $hiPA7.default)(this, ADFEncoder);
    var transformer = createTransformerWithSchema((0, $doB2u.defaultSchema));
    this.encode = $6d4b3448934f1576$var$createEncoder(transformer, new (0, $kjsd0.JSONTransformer)());
});
var $6d4b3448934f1576$export$c72d34660a162238 = function getText(node) {
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || "[".concat(typeof node.type === 'string' ? node.type : node.type.name, "]");
};
var $6d4b3448934f1576$export$eee20638634729b3 = function getEventHandler(eventHandlers, type) {
    var eventName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'onClick';
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
function $6d4b3448934f1576$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $6d4b3448934f1576$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}

});
parcelRegister("2871N", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $18d1c7bf07f60d01$export$2e2bcd8739ae039; });

var $9ScEq = parcelRequire("9ScEq");
function $18d1c7bf07f60d01$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $9ScEq.default)(o.key), o);
    }
}
function $18d1c7bf07f60d01$export$2e2bcd8739ae039(e, r, t) {
    return r && $18d1c7bf07f60d01$var$_defineProperties(e.prototype, r), t && $18d1c7bf07f60d01$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("9ScEq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $01dae2f96ee3289f$export$2e2bcd8739ae039; });

var $85tTb = parcelRequire("85tTb");

var $2HOZo = parcelRequire("2HOZo");
function $01dae2f96ee3289f$export$2e2bcd8739ae039(t) {
    var i = (0, $2HOZo.default)(t, "string");
    return "symbol" == (0, $85tTb.default)(i) ? i : i + "";
}

});
parcelRegister("85tTb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5e35f9b71e172d69$export$2e2bcd8739ae039; });
function $5e35f9b71e172d69$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $5e35f9b71e172d69$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5e35f9b71e172d69$export$2e2bcd8739ae039(o);
}

});

parcelRegister("2HOZo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1f87264d484fc126$export$2e2bcd8739ae039; });

var $85tTb = parcelRequire("85tTb");
function $1f87264d484fc126$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $85tTb.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $85tTb.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("hiPA7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c98c21262ecf70fb$export$2e2bcd8739ae039; });
function $c98c21262ecf70fb$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("doB2u", function(module, exports) {
$parcel$export(module.exports, "getSchemaBasedOnStage", function () { return $9c0a3f767b63d3d4$export$fd147e7d448dea03; });
$parcel$export(module.exports, "defaultSchema", function () { return $9c0a3f767b63d3d4$export$1db618b7b2275ea1; });

var $dWJ7u = parcelRequire("dWJ7u");

var $c8R5w = parcelRequire("c8R5w");
var $gzj4k = parcelRequire("gzj4k");
var $hLyQ0 = parcelRequire("hLyQ0");
var $aouKI = parcelRequire("aouKI");
var $llnov = parcelRequire("llnov");

var $hY9jm = parcelRequire("hY9jm");
var $9c0a3f767b63d3d4$var$getDefaultSchemaConfig = function getDefaultSchemaConfig() {
    var defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
var $9c0a3f767b63d3d4$export$e4e3ac1fa64862db = $9c0a3f767b63d3d4$var$getDefaultSchemaConfig();
var $9c0a3f767b63d3d4$export$fd147e7d448dea03 = (0, $dWJ7u.default)(function() {
    var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'final';
    var defaultSchemaConfig = $9c0a3f767b63d3d4$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $hLyQ0.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $gzj4k.multiBodiedExtension),
        extensionFrame: (0, $gzj4k.extensionFrame),
        expand: (0, $c8R5w.expandWithNestedExpand),
        listItem: (0, $aouKI.listItemWithDecisionStage0),
        table: (0, $llnov.tableWithNestedTable),
        tableRow: (0, $llnov.tableRowWithNestedTable),
        tableCell: (0, $llnov.tableCellWithNestedTable),
        tableHeader: (0, $llnov.tableHeaderWithNestedTable)
    };
    return (0, $hY9jm.createSchema)(defaultSchemaConfig);
});
var $9c0a3f767b63d3d4$export$1db618b7b2275ea1 = $9c0a3f767b63d3d4$export$fd147e7d448dea03();

});
parcelRegister("c8R5w", function(module, exports) {
$parcel$export(module.exports, "expand", function () { return $8d6f6998be02c290$export$9f77e0932fb78f72; });
$parcel$export(module.exports, "expandWithNestedExpand", function () { return $8d6f6998be02c290$export$7b80cba28d10b2c1; });
$parcel$export(module.exports, "toJSON", function () { return $8d6f6998be02c290$export$54fd2c36b5cc6731; });

var $1K2xC = parcelRequire("1K2xC");

var $izlrY = parcelRequire("izlrY");
function $8d6f6998be02c290$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8d6f6998be02c290$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8d6f6998be02c290$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1K2xC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8d6f6998be02c290$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_root_only_node
 */ function $8d6f6998be02c290$var$getExpandAttrs(domNode) {
    var dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
var $8d6f6998be02c290$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $8d6f6998be02c290$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $8d6f6998be02c290$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $8d6f6998be02c290$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $8d6f6998be02c290$var$getExpandAttrs
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
var $8d6f6998be02c290$export$9f77e0932fb78f72 = (0, $izlrY.expandWithoutNestedExpand)($8d6f6998be02c290$var$nodeSpecOptions);
var $8d6f6998be02c290$export$7b80cba28d10b2c1 = (0, $izlrY.expand)($8d6f6998be02c290$var$nodeSpecOptions);
var $8d6f6998be02c290$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return !key.startsWith('__');
        }).reduce(function(obj, key) {
            return $8d6f6998be02c290$var$_objectSpread($8d6f6998be02c290$var$_objectSpread({}, obj), {}, (0, $1K2xC.default)({}, key, node.attrs[key]));
        }, {})
    };
};

});
parcelRegister("1K2xC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $144c0eef72a15b03$export$2e2bcd8739ae039; });

var $kuiQv = parcelRequire("kuiQv");
function $144c0eef72a15b03$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $kuiQv.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("kuiQv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eea53a63dd7c16c0$export$2e2bcd8739ae039; });

var $aXYnk = parcelRequire("aXYnk");

var $lrPNE = parcelRequire("lrPNE");
function $eea53a63dd7c16c0$export$2e2bcd8739ae039(t) {
    var i = (0, $lrPNE.default)(t, "string");
    return "symbol" == (0, $aXYnk.default)(i) ? i : i + "";
}

});
parcelRegister("aXYnk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7fbe3f53414673d9$export$2e2bcd8739ae039; });
function $7fbe3f53414673d9$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $7fbe3f53414673d9$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7fbe3f53414673d9$export$2e2bcd8739ae039(o);
}

});

parcelRegister("lrPNE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f9d44cf93243bfd4$export$2e2bcd8739ae039; });

var $aXYnk = parcelRequire("aXYnk");
function $f9d44cf93243bfd4$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $aXYnk.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $aXYnk.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("izlrY", function(module, exports) {
$parcel$export(module.exports, "blockCard", function () { return $d84c226f403a92a0$export$c4c2f833baaebdb8; });
$parcel$export(module.exports, "blockquote", function () { return $d84c226f403a92a0$export$67dc04e652a298ca; });
$parcel$export(module.exports, "blockquoteLegacy", function () { return $d84c226f403a92a0$export$199922e5af8e9a6; });
$parcel$export(module.exports, "blockquoteWithoutNestedCodeblockOrMedia", function () { return $d84c226f403a92a0$export$a91509d1c739c16f; });
$parcel$export(module.exports, "blockquoteWithoutNonBodiedMacros", function () { return $d84c226f403a92a0$export$32b1dde15f5fe85b; });
$parcel$export(module.exports, "bodiedExtension", function () { return $d84c226f403a92a0$export$27903d543b563e39; });
$parcel$export(module.exports, "bulletList", function () { return $d84c226f403a92a0$export$a140c94e5ea26bee; });
$parcel$export(module.exports, "caption", function () { return $d84c226f403a92a0$export$8e3c2dfdc4f0453d; });
$parcel$export(module.exports, "codeBlock", function () { return $d84c226f403a92a0$export$7bb0d5c671655cc4; });
$parcel$export(module.exports, "confluenceJiraIssue", function () { return $d84c226f403a92a0$export$daf889beb5092f95; });
$parcel$export(module.exports, "confluenceUnsupportedBlock", function () { return $d84c226f403a92a0$export$e6e4878f43c27cab; });
$parcel$export(module.exports, "confluenceUnsupportedInline", function () { return $d84c226f403a92a0$export$3e6d667072febc87; });
$parcel$export(module.exports, "date", function () { return $d84c226f403a92a0$export$324d90190a8b822a; });
$parcel$export(module.exports, "decisionItem", function () { return $d84c226f403a92a0$export$6959e16eeff859b4; });
$parcel$export(module.exports, "decisionList", function () { return $d84c226f403a92a0$export$62d45a65fb43d95e; });
$parcel$export(module.exports, "doc", function () { return $d84c226f403a92a0$export$2a111da947c407d2; });
$parcel$export(module.exports, "embedCard", function () { return $d84c226f403a92a0$export$be4283d9a1cb1ff6; });
$parcel$export(module.exports, "emoji", function () { return $d84c226f403a92a0$export$a19185d1233fc4b2; });
$parcel$export(module.exports, "expand", function () { return $d84c226f403a92a0$export$9f77e0932fb78f72; });
$parcel$export(module.exports, "expandWithoutNestedExpand", function () { return $d84c226f403a92a0$export$63c0f3992661097b; });
$parcel$export(module.exports, "extension", function () { return $d84c226f403a92a0$export$1b45514b112dd749; });
$parcel$export(module.exports, "extensionFrameStage0", function () { return $d84c226f403a92a0$export$b555be60c7703afb; });
$parcel$export(module.exports, "hardBreak", function () { return $d84c226f403a92a0$export$371da9dd35aba193; });
$parcel$export(module.exports, "heading", function () { return $d84c226f403a92a0$export$46e4a324ac90507f; });
$parcel$export(module.exports, "image", function () { return $d84c226f403a92a0$export$5c452ff88e35e47d; });
$parcel$export(module.exports, "inlineCard", function () { return $d84c226f403a92a0$export$cbf8224b64e0d942; });
$parcel$export(module.exports, "inlineExtensionWithMarks", function () { return $d84c226f403a92a0$export$b3b1e36c2105006d; });
$parcel$export(module.exports, "layoutColumn", function () { return $d84c226f403a92a0$export$ab76e7c03cd6f650; });
$parcel$export(module.exports, "layoutSection", function () { return $d84c226f403a92a0$export$b3b6a70a7fa4a5be; });
$parcel$export(module.exports, "layoutSectionFull", function () { return $d84c226f403a92a0$export$cdae19acb0a520fd; });
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", function () { return $d84c226f403a92a0$export$206007566ca0aca5; });
$parcel$export(module.exports, "listItem", function () { return $d84c226f403a92a0$export$76c7e83ecc9cdf05; });
$parcel$export(module.exports, "listItemWithNestedDecisionStage0", function () { return $d84c226f403a92a0$export$df876f0305235056; });
$parcel$export(module.exports, "listItemWithoutNonBodiedMacros", function () { return $d84c226f403a92a0$export$171e9ff2be159af7; });
$parcel$export(module.exports, "media", function () { return $d84c226f403a92a0$export$987d49ffe1b0900f; });
$parcel$export(module.exports, "mediaGroup", function () { return $d84c226f403a92a0$export$2855e964765eac9; });
$parcel$export(module.exports, "mediaInline", function () { return $d84c226f403a92a0$export$38bab695e3f720f1; });
$parcel$export(module.exports, "mediaSingle", function () { return $d84c226f403a92a0$export$969fe3781ca15058; });
$parcel$export(module.exports, "mediaSingleCaption", function () { return $d84c226f403a92a0$export$8d067f22dc2d1254; });
$parcel$export(module.exports, "mediaSingleFull", function () { return $d84c226f403a92a0$export$7e767666f2ce108a; });
$parcel$export(module.exports, "mediaSingleWidthType", function () { return $d84c226f403a92a0$export$4bd9a38995f6bf50; });
$parcel$export(module.exports, "mention", function () { return $d84c226f403a92a0$export$db83999c14438df4; });
$parcel$export(module.exports, "multiBodiedExtensionStage0", function () { return $d84c226f403a92a0$export$750e45819f66d9d0; });
$parcel$export(module.exports, "nestedExpand", function () { return $d84c226f403a92a0$export$63cadbf5f4296627; });
$parcel$export(module.exports, "nestedExpandWithoutNonBodiedMacros", function () { return $d84c226f403a92a0$export$15ebf236772fa336; });
$parcel$export(module.exports, "orderedList", function () { return $d84c226f403a92a0$export$a5dc81035676e7a; });
$parcel$export(module.exports, "panel", function () { return $d84c226f403a92a0$export$21f42ab9b6679f44; });
$parcel$export(module.exports, "panelWithoutNestedNonBodiedMacros", function () { return $d84c226f403a92a0$export$220c665c23b9541b; });
$parcel$export(module.exports, "paragraph", function () { return $d84c226f403a92a0$export$9c206ddddb32a9b; });
$parcel$export(module.exports, "placeholder", function () { return $d84c226f403a92a0$export$c7187bbd1a7a9244; });
$parcel$export(module.exports, "rule", function () { return $d84c226f403a92a0$export$fbeb3a3956e8a3c7; });
$parcel$export(module.exports, "status", function () { return $d84c226f403a92a0$export$471f7ae5c4103ae1; });
$parcel$export(module.exports, "table", function () { return $d84c226f403a92a0$export$9852986a3ec5f6a0; });
$parcel$export(module.exports, "tableWithNestedTable", function () { return $d84c226f403a92a0$export$ce086a560a1d05f5; });
$parcel$export(module.exports, "tableCell", function () { return $d84c226f403a92a0$export$e1e720e5f4603e6a; });
$parcel$export(module.exports, "tableCellWithNestedTable", function () { return $d84c226f403a92a0$export$abf39ca178940ff3; });
$parcel$export(module.exports, "tableHeader", function () { return $d84c226f403a92a0$export$48884d2a5190dc73; });
$parcel$export(module.exports, "tableHeaderWithNestedTable", function () { return $d84c226f403a92a0$export$2a5a518232fa1a97; });
$parcel$export(module.exports, "tableRow", function () { return $d84c226f403a92a0$export$ce666bf02318c957; });
$parcel$export(module.exports, "tableRowWithNestedTable", function () { return $d84c226f403a92a0$export$7d657479499397; });
$parcel$export(module.exports, "taskItem", function () { return $d84c226f403a92a0$export$6d8b0ef52e2e6390; });
$parcel$export(module.exports, "taskList", function () { return $d84c226f403a92a0$export$375b6afcc5f4d291; });
$parcel$export(module.exports, "text", function () { return $d84c226f403a92a0$export$6f093cfa640b7166; });
$parcel$export(module.exports, "unsupportedBlock", function () { return $d84c226f403a92a0$export$44b79b0979d0f0f7; });
$parcel$export(module.exports, "unsupportedInline", function () { return $d84c226f403a92a0$export$310ebe0d80122e9b; });
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $c8Ip2 = parcelRequire("c8Ip2");
var $d84c226f403a92a0$export$c4c2f833baaebdb8 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $d84c226f403a92a0$export$67dc04e652a298ca = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    selectable: true,
    defining: true
});
var $d84c226f403a92a0$export$199922e5af8e9a6 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
var $d84c226f403a92a0$export$a91509d1c739c16f = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
var $d84c226f403a92a0$export$32b1dde15f5fe85b = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
var $d84c226f403a92a0$export$27903d543b563e39 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $d84c226f403a92a0$export$e7320d153c538837 = (0, $c8Ip2.createPMNodeSpecFactory)({
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $d84c226f403a92a0$export$a140c94e5ea26bee = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: false
});
var $d84c226f403a92a0$export$8e3c2dfdc4f0453d = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    selectable: false,
    isolating: true
});
var $d84c226f403a92a0$export$7bb0d5c671655cc4 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
var $d84c226f403a92a0$export$e4f1c66d84049f8b = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
var $d84c226f403a92a0$export$daf889beb5092f95 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
var $d84c226f403a92a0$export$e6e4878f43c27cab = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $d84c226f403a92a0$export$3e6d667072febc87 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $d84c226f403a92a0$export$324d90190a8b822a = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
var $d84c226f403a92a0$export$47988d68fe575725 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
var $d84c226f403a92a0$export$6959e16eeff859b4 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
var $d84c226f403a92a0$export$62d45a65fb43d95e = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
var $d84c226f403a92a0$export$2a111da947c407d2 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(block | codeBlock | layoutSection | blockRootOnly | expand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout'
});
var $d84c226f403a92a0$export$be4283d9a1cb1ff6 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        }
    },
    selectable: true
});
var $d84c226f403a92a0$export$a19185d1233fc4b2 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
var $d84c226f403a92a0$export$f5574b5d45fc2112 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
var $d84c226f403a92a0$export$9f77e0932fb78f72 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
var $d84c226f403a92a0$export$7e3788972005cc72 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
var $d84c226f403a92a0$export$63c0f3992661097b = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
var $d84c226f403a92a0$export$1b45514b112dd749 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $d84c226f403a92a0$export$a8baf338431a691 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $d84c226f403a92a0$export$b555be60c7703afb = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
var $d84c226f403a92a0$export$371da9dd35aba193 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        }
    },
    selectable: false,
    linebreakReplacement: true
});
var $d84c226f403a92a0$export$46e4a324ac90507f = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $d84c226f403a92a0$export$1b0c1557b234fa00 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $d84c226f403a92a0$export$85461f751c457cc2 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $d84c226f403a92a0$export$2b380a0f7e250af1 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $d84c226f403a92a0$export$5c452ff88e35e47d = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
var $d84c226f403a92a0$export$cbf8224b64e0d942 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $d84c226f403a92a0$export$2f4e72b9459914ad = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $d84c226f403a92a0$export$16b353b2649bd8d9 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $d84c226f403a92a0$export$b3b1e36c2105006d = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $d84c226f403a92a0$export$ab76e7c03cd6f650 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        }
    },
    selectable: false,
    isolating: true
});
var $d84c226f403a92a0$export$b3b6a70a7fa4a5be = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
var $d84c226f403a92a0$export$cdae19acb0a520fd = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
var $d84c226f403a92a0$export$206007566ca0aca5 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        }
    },
    isolating: true
});
var $d84c226f403a92a0$export$76c7e83ecc9cdf05 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)*',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
var $d84c226f403a92a0$export$df876f0305235056 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension)*',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    selectable: false,
    defining: true
});
var $d84c226f403a92a0$export$171e9ff2be159af7 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
var $d84c226f403a92a0$export$987d49ffe1b0900f = (0, $c8Ip2.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
var $d84c226f403a92a0$export$2855e964765eac9 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
var $d84c226f403a92a0$export$38bab695e3f720f1 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
var $d84c226f403a92a0$export$969fe3781ca15058 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
var $d84c226f403a92a0$export$8d067f22dc2d1254 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
var $d84c226f403a92a0$export$7e767666f2ce108a = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $d84c226f403a92a0$export$4bd9a38995f6bf50 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $d84c226f403a92a0$export$db83999c14438df4 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $d84c226f403a92a0$export$46f790bd65f760d0 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $d84c226f403a92a0$export$750e45819f66d9d0 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
var $d84c226f403a92a0$export$63cadbf5f4296627 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
var $d84c226f403a92a0$export$f03786aa6312d1e4 = (0, $c8Ip2.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
var $d84c226f403a92a0$export$15ebf236772fa336 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
var $d84c226f403a92a0$export$a5dc81035676e7a = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        }
    },
    selectable: false
});
var $d84c226f403a92a0$export$21f42ab9b6679f44 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
var $d84c226f403a92a0$export$220c665c23b9541b = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
var $d84c226f403a92a0$export$9c206ddddb32a9b = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $d84c226f403a92a0$export$4f98472e6dc14293 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $d84c226f403a92a0$export$ea332b61641b0588 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $d84c226f403a92a0$export$a1f41dc4901771f8 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $d84c226f403a92a0$export$c7187bbd1a7a9244 = (0, $c8Ip2.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        }
    },
    selectable: false
});
var $d84c226f403a92a0$export$fbeb3a3956e8a3c7 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'block'
});
var $d84c226f403a92a0$export$471f7ae5c4103ae1 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
var $d84c226f403a92a0$export$b6ce52be8d7a261 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
var $d84c226f403a92a0$export$9852986a3ec5f6a0 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
var $d84c226f403a92a0$export$ce086a560a1d05f5 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
var $d84c226f403a92a0$export$e1e720e5f4603e6a = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
var $d84c226f403a92a0$export$abf39ca178940ff3 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
var $d84c226f403a92a0$export$48884d2a5190dc73 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
var $d84c226f403a92a0$export$2a5a518232fa1a97 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
var $d84c226f403a92a0$export$ce666bf02318c957 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
var $d84c226f403a92a0$export$7d657479499397 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
var $d84c226f403a92a0$export$6d8b0ef52e2e6390 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
var $d84c226f403a92a0$export$375b6afcc5f4d291 = (0, $c8Ip2.createPMNodeSpecFactory)({
    content: '(taskItem | unsupportedBlock)+ (taskItem | taskList | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
var $d84c226f403a92a0$export$6f093cfa640b7166 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'inline'
});
var $d84c226f403a92a0$export$5ea06bc686c59dc2 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'inline'
});
var $d84c226f403a92a0$export$93256a4c17b33a82 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'inline'
});
var $d84c226f403a92a0$export$a12828d0f14a2762 = (0, $c8Ip2.createPMNodeSpecFactory)({});
var $d84c226f403a92a0$export$44b79b0979d0f0f7 = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
var $d84c226f403a92a0$export$310ebe0d80122e9b = (0, $c8Ip2.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("c8Ip2", function(module, exports) {
$parcel$export(module.exports, "createPMNodeSpecFactory", function () { return $8d68acd8e6abb14a$export$bf0a80f00e2b8ff6; });
$parcel$export(module.exports, "createPMMarkSpecFactory", function () { return $8d68acd8e6abb14a$export$cf5823ed4e9f4c6f; });

var $1K2xC = parcelRequire("1K2xC");
function $8d68acd8e6abb14a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8d68acd8e6abb14a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8d68acd8e6abb14a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1K2xC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8d68acd8e6abb14a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8d68acd8e6abb14a$export$bf0a80f00e2b8ff6 = function createPMNodeSpecFactory(nodeSpec) {
    return function(_ref) {
        var parseDOM = _ref.parseDOM, toDOM = _ref.toDOM, toDebugString = _ref.toDebugString;
        return $8d68acd8e6abb14a$var$_objectSpread($8d68acd8e6abb14a$var$_objectSpread($8d68acd8e6abb14a$var$_objectSpread($8d68acd8e6abb14a$var$_objectSpread({}, nodeSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};
var $8d68acd8e6abb14a$export$cf5823ed4e9f4c6f = function createPMMarkSpecFactory(markSpec) {
    return function(_ref2) {
        var parseDOM = _ref2.parseDOM, toDOM = _ref2.toDOM, toDebugString = _ref2.toDebugString;
        return $8d68acd8e6abb14a$var$_objectSpread($8d68acd8e6abb14a$var$_objectSpread($8d68acd8e6abb14a$var$_objectSpread($8d68acd8e6abb14a$var$_objectSpread({}, markSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};

});



parcelRegister("gzj4k", function(module, exports) {
$parcel$export(module.exports, "extensionFrame", function () { return $c0feb4e513c02ea1$export$4fdcae991fd743e7; });
$parcel$export(module.exports, "multiBodiedExtension", function () { return $c0feb4e513c02ea1$export$c3c04d555a8b9013; });

var $2S9L4 = parcelRequire("2S9L4");

var $izlrY = parcelRequire("izlrY");
var $c0feb4e513c02ea1$export$4fdcae991fd743e7 = (0, $izlrY.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $c0feb4e513c02ea1$export$c3c04d555a8b9013 = (0, $izlrY.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $2S9L4.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});
parcelRegister("2S9L4", function(module, exports) {
$parcel$export(module.exports, "getExtensionAttrs", function () { return $217831aad6fddc0b$export$1765e2758fc47004; });
var $217831aad6fddc0b$export$d5f21755dc782a4a = function isValidLayout(name) {
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
var $217831aad6fddc0b$export$1765e2758fc47004 = function getExtensionAttrs(dom) {
    var isInline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var extensionType = dom.getAttribute('data-extension-type');
    var extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    var attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        var rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $217831aad6fddc0b$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});


parcelRegister("hLyQ0", function(module, exports) {
$parcel$export(module.exports, "layoutSection", function () { return $cef1d981d3004543$export$b3b6a70a7fa4a5be; });
$parcel$export(module.exports, "layoutSectionWithSingleColumn", function () { return $cef1d981d3004543$export$4f9d8f623ff17117; });

var $izlrY = parcelRequire("izlrY");
var $cef1d981d3004543$export$b3b6a70a7fa4a5be = (0, $izlrY.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $cef1d981d3004543$export$cdae19acb0a520fd = (0, $izlrY.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $cef1d981d3004543$export$4f9d8f623ff17117 = (0, $izlrY.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: function getAttrs(dom) {
                var columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        var columnRuleStyle = node.attrs.columnRuleStyle;
        var attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("aouKI", function(module, exports) {
$parcel$export(module.exports, "listItem", function () { return $7914000ed4481759$export$76c7e83ecc9cdf05; });
$parcel$export(module.exports, "listItemWithTask", function () { return $7914000ed4481759$export$58dca2f0678302a4; });
$parcel$export(module.exports, "listItemWithDecisionStage0", function () { return $7914000ed4481759$export$b2cd54d5ce935ddb; });
$parcel$export(module.exports, "listItemWithoutNonBodiedMacros", function () { return $7914000ed4481759$export$171e9ff2be159af7; });

var $izlrY = parcelRequire("izlrY");
var $7914000ed4481759$export$76c7e83ecc9cdf05 = (0, $izlrY.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM: function toDOM() {
        return [
            'li',
            0
        ];
    }
});
var $7914000ed4481759$export$58dca2f0678302a4 = $7914000ed4481759$export$76c7e83ecc9cdf05;
var $7914000ed4481759$export$b2cd54d5ce935ddb = (0, $izlrY.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM: function toDOM() {
        return [
            'li',
            0
        ];
    }
});
var $7914000ed4481759$export$171e9ff2be159af7 = (0, $izlrY.listItemWithoutNonBodiedMacros)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM: function toDOM() {
        return [
            'li',
            0
        ];
    }
});

});

parcelRegister("llnov", function(module, exports) {
$parcel$export(module.exports, "tablePrefixSelector", function () { return $f89db4bab0194879$export$9cfceb893b24742a; });
$parcel$export(module.exports, "tableCellSelector", function () { return $f89db4bab0194879$export$69cb4c3f80383763; });
$parcel$export(module.exports, "tableHeaderSelector", function () { return $f89db4bab0194879$export$7b07d37d879c957f; });
$parcel$export(module.exports, "tableCellContentWrapperSelector", function () { return $f89db4bab0194879$export$8dd42a84cd52da07; });
$parcel$export(module.exports, "tableCellContentDomSelector", function () { return $f89db4bab0194879$export$5e26a5c19f0865d8; });
$parcel$export(module.exports, "getCellAttrs", function () { return $f89db4bab0194879$export$43977bde391e007; });
$parcel$export(module.exports, "getCellDomAttrs", function () { return $f89db4bab0194879$export$363c8dda799bfe9c; });
$parcel$export(module.exports, "tableBackgroundColorNames", function () { return $f89db4bab0194879$export$8cc2833b5b349a1e; });
$parcel$export(module.exports, "tableBackgroundColorPalette", function () { return $f89db4bab0194879$export$219b7f492ad209f8; });
$parcel$export(module.exports, "tableBackgroundBorderColor", function () { return $f89db4bab0194879$export$95e9c925fbf01d1c; });
$parcel$export(module.exports, "table", function () { return $f89db4bab0194879$export$9852986a3ec5f6a0; });
$parcel$export(module.exports, "tableWithCustomWidth", function () { return $f89db4bab0194879$export$90e634fbace1f0c4; });
$parcel$export(module.exports, "tableStage0", function () { return $f89db4bab0194879$export$3862de5c8c9098cf; });
$parcel$export(module.exports, "tableToJSON", function () { return $f89db4bab0194879$export$1f92a2f429e06fa8; });
$parcel$export(module.exports, "tableRow", function () { return $f89db4bab0194879$export$ce666bf02318c957; });
$parcel$export(module.exports, "tableCell", function () { return $f89db4bab0194879$export$e1e720e5f4603e6a; });
$parcel$export(module.exports, "toJSONTableCell", function () { return $f89db4bab0194879$export$2ac34c099660f1a8; });
$parcel$export(module.exports, "tableHeader", function () { return $f89db4bab0194879$export$48884d2a5190dc73; });
$parcel$export(module.exports, "toJSONTableHeader", function () { return $f89db4bab0194879$export$2af48797a1010bb1; });
$parcel$export(module.exports, "tableWithNestedTable", function () { return $f89db4bab0194879$export$ce086a560a1d05f5; });
$parcel$export(module.exports, "tableRowWithNestedTable", function () { return $f89db4bab0194879$export$7d657479499397; });
$parcel$export(module.exports, "tableCellWithNestedTable", function () { return $f89db4bab0194879$export$abf39ca178940ff3; });
$parcel$export(module.exports, "tableHeaderWithNestedTable", function () { return $f89db4bab0194879$export$2a5a518232fa1a97; });

var $1K2xC = parcelRequire("1K2xC");

var $2oMHl = parcelRequire("2oMHl");

var $agkbL = parcelRequire("agkbL");

var $jIfxG = parcelRequire("jIfxG");

var $2S7le = parcelRequire("2S7le");

var $eKBj2 = parcelRequire("eKBj2");

var $izlrY = parcelRequire("izlrY");
function $f89db4bab0194879$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f89db4bab0194879$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f89db4bab0194879$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1K2xC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f89db4bab0194879$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f89db4bab0194879$export$9cfceb893b24742a = 'pm-table';
var $f89db4bab0194879$export$69cb4c3f80383763 = "".concat($f89db4bab0194879$export$9cfceb893b24742a, "-cell-content-wrap");
var $f89db4bab0194879$export$7b07d37d879c957f = "".concat($f89db4bab0194879$export$9cfceb893b24742a, "-header-content-wrap");
var $f89db4bab0194879$export$8dd42a84cd52da07 = "".concat($f89db4bab0194879$export$9cfceb893b24742a, "-cell-nodeview-wrapper");
var $f89db4bab0194879$export$5e26a5c19f0865d8 = "".concat($f89db4bab0194879$export$9cfceb893b24742a, "-cell-nodeview-content-dom");
var $f89db4bab0194879$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $jIfxG.N20).toLocaleLowerCase();
var $f89db4bab0194879$export$43977bde391e007 = function getCellAttrs(dom) {
    var defaultValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var widthAttr = dom.getAttribute('data-colwidth');
    var width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map(function(str) {
        return Number(str);
    }) : null;
    var colspan = Number(dom.getAttribute('colspan') || 1);
    var backgroundColor = dom.style.backgroundColor;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ var dataCellBackground = dom.getAttribute('data-cell-background');
    var dataCellBackgroundHexCode = dataCellBackground && (0, $jIfxG.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $jIfxG.isRgb)(backgroundColor)) {
        var result = (0, $jIfxG.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    var backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    };
};
// these are for test only
var $f89db4bab0194879$var$testGlobalTheme;
var $f89db4bab0194879$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $f89db4bab0194879$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
var $f89db4bab0194879$var$getGlobalTheme = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($f89db4bab0194879$var$testGlobalTheme) return {
        colorMode: $f89db4bab0194879$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
var $f89db4bab0194879$var$cssVariablePattern = /^var\(--.*\)$/;
var $f89db4bab0194879$export$363c8dda799bfe9c = function getCellDomAttrs(node) {
    var attrs = {};
    var nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        var background = node.attrs.background;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        var ignored = nodeType === 'tableHeader' && background === $f89db4bab0194879$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $f89db4bab0194879$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            var color = (0, $jIfxG.isRgb)(background) && (0, $jIfxG.rgbToHex)(background) ? (0, $jIfxG.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ var tokenColor = (0, $agkbL.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = "background-color: ".concat(tokenColor, ";");
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $f89db4bab0194879$var$cssVariablePattern.test(color)) attrs.style = "background-color: ".concat(color, ";");
            else // if we have a custom color, we need to check if we are in dark mode
            if ($f89db4bab0194879$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = "background-color: ".concat((0, $eKBj2.getDarkModeLCHColor)(color), ";");
            else // if we are in light mode, we can just set the color
            attrs.style = "background-color: ".concat(background, ";");
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            attrs.colorname = $f89db4bab0194879$export$219b7f492ad209f8.get(color);
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $f89db4bab0194879$export$7b07d37d879c957f;
    else attrs.class = $f89db4bab0194879$export$69cb4c3f80383763;
    return attrs;
};
var $f89db4bab0194879$export$219b7f492ad209f8 = new Map();
var $f89db4bab0194879$export$95e9c925fbf01d1c = (0, $jIfxG.hexToRgba)((0, $jIfxG.N800), 0.12) || (0, $jIfxG.N0);
var $f89db4bab0194879$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $jIfxG.N0),
        'White'
    ],
    [
        (0, $jIfxG.B50),
        'Light blue'
    ],
    [
        (0, $jIfxG.T50),
        'Light teal'
    ],
    [
        (0, $jIfxG.G50),
        'Light green'
    ],
    [
        (0, $jIfxG.Y50),
        'Light yellow'
    ],
    [
        (0, $jIfxG.R50),
        'Light red'
    ],
    [
        (0, $jIfxG.P50),
        'Light purple'
    ],
    [
        (0, $jIfxG.N20),
        'Light gray'
    ],
    [
        (0, $jIfxG.B75),
        'Blue'
    ],
    [
        (0, $jIfxG.T75),
        'Teal'
    ],
    [
        (0, $jIfxG.G75),
        'Green'
    ],
    [
        (0, $jIfxG.Y75),
        'Yellow'
    ],
    [
        (0, $jIfxG.R75),
        'Red'
    ],
    [
        (0, $jIfxG.P75),
        'Purple'
    ],
    [
        (0, $jIfxG.N60),
        'Gray'
    ],
    [
        (0, $jIfxG.B100),
        'Dark blue'
    ],
    [
        (0, $jIfxG.T100),
        'Dark teal'
    ],
    [
        (0, $jIfxG.G200),
        'Dark green'
    ],
    [
        (0, $jIfxG.Y200),
        'Dark yellow'
    ],
    [
        (0, $jIfxG.R100),
        'Dark red'
    ],
    [
        (0, $jIfxG.P100),
        'Dark purple'
    ]
].forEach(function(_ref) {
    var _ref2 = (0, $2oMHl.default)(_ref, 2), colorValue = _ref2[0], colorName = _ref2[1];
    $f89db4bab0194879$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $f89db4bab0194879$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // table nodes with nested tables support
var $f89db4bab0194879$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: function getAttrs(node) {
                var _dom$parentElement;
                var dom = node;
                var breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $2S7le.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: Fix any, potential issue. ED-5048
var $f89db4bab0194879$var$createTableSpec = function createTableSpec() {
    return (0, $izlrY.table)($f89db4bab0194879$var$tableNodeSpecOptions);
};
var $f89db4bab0194879$export$9852986a3ec5f6a0 = $f89db4bab0194879$var$createTableSpec();
var $f89db4bab0194879$export$90e634fbace1f0c4 = $f89db4bab0194879$var$createTableSpec();
var $f89db4bab0194879$export$3862de5c8c9098cf = $f89db4bab0194879$var$createTableSpec();
var $f89db4bab0194879$var$shouldIncludeAttribute = function shouldIncludeAttribute(key, value) {
    return !key.startsWith('__') && (key !== 'localId' || !!value);
};
var $f89db4bab0194879$export$1f92a2f429e06fa8 = function tableToJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return $f89db4bab0194879$var$shouldIncludeAttribute(key, node.attrs[key]);
        }).reduce(function(obj, key) {
            return $f89db4bab0194879$var$_objectSpread($f89db4bab0194879$var$_objectSpread({}, obj), {}, (0, $1K2xC.default)({}, key, node.attrs[key]));
        }, {})
    };
};
var $f89db4bab0194879$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM: function toDOM() {
        return [
            'tr',
            0
        ];
    }
};
var $f89db4bab0194879$export$ce666bf02318c957 = (0, $izlrY.tableRow)($f89db4bab0194879$var$tableRowNodeSpecOptions);
var $f89db4bab0194879$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    }
};
var $f89db4bab0194879$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            getAttrs: function getAttrs(dom) {
                return $f89db4bab0194879$export$43977bde391e007(dom);
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'td',
            $f89db4bab0194879$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $f89db4bab0194879$export$e1e720e5f4603e6a = (0, $izlrY.tableCell)($f89db4bab0194879$var$tableCellNodeSpecOptions);
var $f89db4bab0194879$export$2ac34c099660f1a8 = function toJSONTableCell(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if ($f89db4bab0194879$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};
var $f89db4bab0194879$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: function getAttrs(dom) {
                return $f89db4bab0194879$export$43977bde391e007(dom, {
                    background: $f89db4bab0194879$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'th',
            $f89db4bab0194879$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $f89db4bab0194879$export$48884d2a5190dc73 = (0, $izlrY.tableHeader)($f89db4bab0194879$var$tableHeaderNodeSpecOptions);
var $f89db4bab0194879$export$2af48797a1010bb1 = $f89db4bab0194879$export$2ac34c099660f1a8;
var $f89db4bab0194879$export$ce086a560a1d05f5 = (0, $izlrY.tableWithNestedTable)($f89db4bab0194879$var$tableNodeSpecOptions);
var $f89db4bab0194879$export$7d657479499397 = (0, $izlrY.tableRowWithNestedTable)($f89db4bab0194879$var$tableRowNodeSpecOptions);
var $f89db4bab0194879$export$abf39ca178940ff3 = (0, $izlrY.tableCellWithNestedTable)($f89db4bab0194879$var$tableCellNodeSpecOptions);
var $f89db4bab0194879$export$2a5a518232fa1a97 = (0, $izlrY.tableHeaderWithNestedTable)($f89db4bab0194879$var$tableHeaderNodeSpecOptions);

});
parcelRegister("2oMHl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1bf3991a7cfc0bbd$export$2e2bcd8739ae039; });

var $bSqti = parcelRequire("bSqti");

var $jnHoo = parcelRequire("jnHoo");

var $dkscH = parcelRequire("dkscH");

var $6PDrp = parcelRequire("6PDrp");
function $1bf3991a7cfc0bbd$export$2e2bcd8739ae039(r, e) {
    return (0, $bSqti.default)(r) || (0, $jnHoo.default)(r, e) || (0, $dkscH.default)(r, e) || (0, $6PDrp.default)();
}

});
parcelRegister("bSqti", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8a594590113e081d$export$2e2bcd8739ae039; });
function $8a594590113e081d$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("jnHoo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e1c1d32815d9661c$export$2e2bcd8739ae039; });
function $e1c1d32815d9661c$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("dkscH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9b43054da69bbd72$export$2e2bcd8739ae039; });

var $1PQQV = parcelRequire("1PQQV");
function $9b43054da69bbd72$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $1PQQV.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $1PQQV.default)(r, a) : void 0;
    }
}

});
parcelRegister("1PQQV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $15638d456e2d239a$export$2e2bcd8739ae039; });
function $15638d456e2d239a$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("6PDrp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4f9619ae1bdef363$export$2e2bcd8739ae039; });
function $4f9619ae1bdef363$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("agkbL", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBorderPaletteColor", function () { return $778b0f13e5b75d04$export$bad3c41dd33cb4bc; });
$parcel$export(module.exports, "hexToEditorTextPaletteColor", function () { return $778b0f13e5b75d04$export$9c2f408d391feb93; });
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", function () { return $778b0f13e5b75d04$export$8b58ff1b36bb75e0; });
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", function () { return $778b0f13e5b75d04$export$a270511a0e7fd61a; });

var $3L8ZR = parcelRequire("3L8ZR");
function $778b0f13e5b75d04$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $778b0f13e5b75d04$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
var $778b0f13e5b75d04$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $778b0f13e5b75d04$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $778b0f13e5b75d04$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
var $778b0f13e5b75d04$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $778b0f13e5b75d04$export$8b58ff1b36bb75e0(hexColor) {
    var orangeToYellowEnabled = (0, $3L8ZR.default).getExperimentValue('editor_text_highlight_orange_to_yellow', 'cohort', 'control', {
        fireExperimentExposure: true
    });
    if (orangeToYellowEnabled === 'test') $778b0f13e5b75d04$export$12a518ff137dd389['#FEDEC8'] = 'var(--ds-background-accent-yellow-subtler, #F8E6A0)';
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return hexColor ? $778b0f13e5b75d04$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
var $778b0f13e5b75d04$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $778b0f13e5b75d04$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    var tokenData = hexColor ? $778b0f13e5b75d04$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
var $778b0f13e5b75d04$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: function getValue() {
            return '#DEEBFF';
        },
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: function getValue() {
            return '#B3D4FF';
        },
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: function getValue() {
            return '#4C9AFF';
        },
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: function getValue() {
            return '#E6FCFF';
        },
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: function getValue() {
            return '#B3F5FF';
        },
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: function getValue() {
            return '#79E2F2';
        },
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: function getValue() {
            return '#E3FCEF';
        },
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: function getValue() {
            return '#ABF5D1';
        },
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: function getValue() {
            return '#57D9A3';
        },
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: function getValue() {
            return '#FFFAE6';
        },
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: function getValue() {
            return '#FFF0B3';
        },
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: function getValue() {
            return '#FFC400';
        },
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: function getValue() {
            return '#FFEBE6';
        },
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: function getValue() {
            return '#FFBDAD';
        },
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: function getValue() {
            return '#FF8F73';
        },
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: function getValue() {
            return '#EAE6FF';
        },
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: function getValue() {
            return '#C0B6F2';
        },
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: function getValue() {
            return '#998DD9';
        },
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: function getValue() {
            return '#FFFFFF';
        },
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: function getValue() {
            return '#F4F5F7';
        },
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: function getValue() {
            return '#B3BAC5';
        },
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});

parcelRegister("jIfxG", function(module, exports) {
$parcel$export(module.exports, "R50", function () { return $e59e2ec11a22a8bb$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R75", function () { return $e59e2ec11a22a8bb$export$b34b069eff244586; });
$parcel$export(module.exports, "R100", function () { return $e59e2ec11a22a8bb$export$be802dd0d8b57f35; });
$parcel$export(module.exports, "R300", function () { return $e59e2ec11a22a8bb$export$4a7404f376229999; });
$parcel$export(module.exports, "R500", function () { return $e59e2ec11a22a8bb$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $e59e2ec11a22a8bb$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y75", function () { return $e59e2ec11a22a8bb$export$41060a744ab0b7ae; });
$parcel$export(module.exports, "Y200", function () { return $e59e2ec11a22a8bb$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y400", function () { return $e59e2ec11a22a8bb$export$59619663aa6500fb; });
$parcel$export(module.exports, "G50", function () { return $e59e2ec11a22a8bb$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G75", function () { return $e59e2ec11a22a8bb$export$69a3bf21b9686c2b; });
$parcel$export(module.exports, "G200", function () { return $e59e2ec11a22a8bb$export$747d86715d4175de; });
$parcel$export(module.exports, "G300", function () { return $e59e2ec11a22a8bb$export$940e1f69e873f202; });
$parcel$export(module.exports, "G500", function () { return $e59e2ec11a22a8bb$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $e59e2ec11a22a8bb$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $e59e2ec11a22a8bb$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $e59e2ec11a22a8bb$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B400", function () { return $e59e2ec11a22a8bb$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $e59e2ec11a22a8bb$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "L200", function () { return $e59e2ec11a22a8bb$export$f72948ef771f6f15; });
$parcel$export(module.exports, "N0", function () { return $e59e2ec11a22a8bb$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $e59e2ec11a22a8bb$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $e59e2ec11a22a8bb$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N60", function () { return $e59e2ec11a22a8bb$export$c2e91cbeada39b8b; });
$parcel$export(module.exports, "N80", function () { return $e59e2ec11a22a8bb$export$eaa8c8a70ac22806; });
$parcel$export(module.exports, "Neutral300", function () { return $e59e2ec11a22a8bb$export$1ae1cebe22dcedb4; });
$parcel$export(module.exports, "N300A", function () { return $e59e2ec11a22a8bb$export$13609db0e6812ab8; });
$parcel$export(module.exports, "N600", function () { return $e59e2ec11a22a8bb$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N800", function () { return $e59e2ec11a22a8bb$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N1000", function () { return $e59e2ec11a22a8bb$export$f78789c8b01753cd; });
$parcel$export(module.exports, "M200", function () { return $e59e2ec11a22a8bb$export$a19f0c33186f7767; });
$parcel$export(module.exports, "O200", function () { return $e59e2ec11a22a8bb$export$51716a84e62e022c; });
$parcel$export(module.exports, "P50", function () { return $e59e2ec11a22a8bb$export$363e4475840015bb; });
$parcel$export(module.exports, "P75", function () { return $e59e2ec11a22a8bb$export$4b0a4417ed59760f; });
$parcel$export(module.exports, "P100", function () { return $e59e2ec11a22a8bb$export$6011520a64d9a187; });
$parcel$export(module.exports, "P200", function () { return $e59e2ec11a22a8bb$export$a7175d4e9206bc80; });
$parcel$export(module.exports, "P300", function () { return $e59e2ec11a22a8bb$export$b48405b95304b5a1; });
$parcel$export(module.exports, "P500", function () { return $e59e2ec11a22a8bb$export$147899de772240ec; });
$parcel$export(module.exports, "T50", function () { return $e59e2ec11a22a8bb$export$2cf711fe14c66f06; });
$parcel$export(module.exports, "T75", function () { return $e59e2ec11a22a8bb$export$7a8f4d33f6f9772c; });
$parcel$export(module.exports, "T100", function () { return $e59e2ec11a22a8bb$export$776c9c497ef08533; });
$parcel$export(module.exports, "T200", function () { return $e59e2ec11a22a8bb$export$69cb3ca10c1e330e; });
$parcel$export(module.exports, "T300", function () { return $e59e2ec11a22a8bb$export$9dc1ef0f3f48059b; });
$parcel$export(module.exports, "T500", function () { return $e59e2ec11a22a8bb$export$6036577f95c3877e; });
$parcel$export(module.exports, "isHex", function () { return $e59e2ec11a22a8bb$export$8a9b6341a7c96bc; });
$parcel$export(module.exports, "isRgb", function () { return $e59e2ec11a22a8bb$export$e698776ec826343; });
$parcel$export(module.exports, "rgbToHex", function () { return $e59e2ec11a22a8bb$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hexToRgba", function () { return $e59e2ec11a22a8bb$export$9665a07d9187b414; });

var $2oMHl = parcelRequire("2oMHl");

var $ksCOI = parcelRequire("ksCOI");
var $e59e2ec11a22a8bb$export$4b84fd0e2c617bd = '#FFEBE6';
var $e59e2ec11a22a8bb$export$b34b069eff244586 = '#FFBDAD';
var $e59e2ec11a22a8bb$export$be802dd0d8b57f35 = '#FF8F73';
var $e59e2ec11a22a8bb$export$4a7404f376229999 = '#FF5630';
var $e59e2ec11a22a8bb$export$2010d0fb4295b346 = '#DE350B';
var $e59e2ec11a22a8bb$export$2837b5a1a71d5c02 = '#BF2600';
var $e59e2ec11a22a8bb$export$8d9596b529bbb9cf = '#FFFAE6';
var $e59e2ec11a22a8bb$export$41060a744ab0b7ae = '#FFF0B3';
var $e59e2ec11a22a8bb$export$5aae31392d72caaa = '#FFC400';
var $e59e2ec11a22a8bb$export$59619663aa6500fb = '#FF991F';
var $e59e2ec11a22a8bb$export$874739ea9e379ab6 = '#FF8B00';
var $e59e2ec11a22a8bb$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $e59e2ec11a22a8bb$export$69a3bf21b9686c2b = '#ABF5D1';
var $e59e2ec11a22a8bb$export$747d86715d4175de = '#57D9A3';
var $e59e2ec11a22a8bb$export$940e1f69e873f202 = '#36B37E';
var $e59e2ec11a22a8bb$export$a49394138f7b8e85 = '#00875A';
var $e59e2ec11a22a8bb$export$6fa04827ac68a4fb = '#006644';
var $e59e2ec11a22a8bb$export$226de0355ed012f8 = '#DEEBFF';
var $e59e2ec11a22a8bb$export$8c13c2ee36917869 = '#B3D4FF';
var $e59e2ec11a22a8bb$export$ecfc1dff386a3e7a = '#4C9AFF';
var $e59e2ec11a22a8bb$export$b3de0ae08da2ce64 = '#0052CC';
var $e59e2ec11a22a8bb$export$a6ee3d71bc067634 = '#0747A6';
var $e59e2ec11a22a8bb$export$f72948ef771f6f15 = '#D3F1A7';
var $e59e2ec11a22a8bb$export$29a4f05edc054374 = '#FFFFFF';
var $e59e2ec11a22a8bb$export$9fdfb749e33cdf97 = '#F4F5F7';
var $e59e2ec11a22a8bb$export$3e51e8f1440314ba = '#EBECF0';
var $e59e2ec11a22a8bb$export$1ce2d1575d444ceb = '#DFE1E6';
var $e59e2ec11a22a8bb$export$8754fc7e6d8b3000 = '#C1C7D0';
var $e59e2ec11a22a8bb$export$c2e91cbeada39b8b = '#B3BAC5';
var $e59e2ec11a22a8bb$export$eaa8c8a70ac22806 = '#97A0AF';
var $e59e2ec11a22a8bb$export$7c87d337fb91a97d = '#8993A4';
var $e59e2ec11a22a8bb$export$f563ee71e9ee74cd = '#6B778C';
var $e59e2ec11a22a8bb$export$e2ef2124cf4024b1 = '#5E6C84';
var $e59e2ec11a22a8bb$export$1ae1cebe22dcedb4 = '#DCDFE4';
var $e59e2ec11a22a8bb$export$13609db0e6812ab8 = '#091E4224';
var $e59e2ec11a22a8bb$export$c39c0fe0f26207ae = '#42526E';
var $e59e2ec11a22a8bb$export$7090862dc3038a9f = '#758195';
var $e59e2ec11a22a8bb$export$7d61b15e0da132af = '#172B4D';
var $e59e2ec11a22a8bb$export$f78789c8b01753cd = '#172B4D';
var $e59e2ec11a22a8bb$export$a19f0c33186f7767 = '#FDD0EC';
var $e59e2ec11a22a8bb$export$51716a84e62e022c = '#FEDEC8';
var $e59e2ec11a22a8bb$export$363e4475840015bb = '#EAE6FF';
var $e59e2ec11a22a8bb$export$4b0a4417ed59760f = '#C0B6F2';
var $e59e2ec11a22a8bb$export$6011520a64d9a187 = '#998DD9';
var $e59e2ec11a22a8bb$export$a7175d4e9206bc80 = '#DFD8FD';
var $e59e2ec11a22a8bb$export$b48405b95304b5a1 = '#6554C0';
var $e59e2ec11a22a8bb$export$c71e4279dd54a18d = '#5243AA';
var $e59e2ec11a22a8bb$export$147899de772240ec = '#403294';
var $e59e2ec11a22a8bb$export$2cf711fe14c66f06 = '#E6FCFF';
var $e59e2ec11a22a8bb$export$7a8f4d33f6f9772c = '#B3F5FF';
var $e59e2ec11a22a8bb$export$776c9c497ef08533 = '#79E2F2';
var $e59e2ec11a22a8bb$export$69cb3ca10c1e330e = '#C6EDFB';
var $e59e2ec11a22a8bb$export$9dc1ef0f3f48059b = '#00B8D9';
var $e59e2ec11a22a8bb$export$6036577f95c3877e = '#008DA6';
function $e59e2ec11a22a8bb$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($e59e2ec11a22a8bb$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map(function(c) {
            return c === '#' ? '#' : "".concat(c).concat(c);
        }).join('');
    } else if ($e59e2ec11a22a8bb$export$e698776ec826343(color)) return $e59e2ec11a22a8bb$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($ksCOI.default && $ksCOI.default[color]) color = $ksCOI.default[color];
        else if ($ksCOI && $ksCOI[color]) color = $ksCOI[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $e59e2ec11a22a8bb$export$5a544e13ad4e1fa5(color) {
    if (!$e59e2ec11a22a8bb$export$8a9b6341a7c96bc(color)) return null;
    var colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    var rgb = Number("0x".concat(colorBits.join('')));
    // eslint-disable-next-line no-bitwise
    return "rgb(".concat(rgb >> 16 & 255, ",").concat(rgb >> 8 & 255, ",").concat(rgb & 255, ")");
}
function $e59e2ec11a22a8bb$export$9665a07d9187b414(rawColor, alpha) {
    var color = $e59e2ec11a22a8bb$export$b61655071712e690(rawColor);
    if (!color) return null;
    var hex2rgb = function hex2rgb(color) {
        return color.match(/[a-z0-9]{2}/gi).map(function(hex) {
            return parseInt(hex, 16);
        });
    };
    return "rgba(".concat(hex2rgb(color).concat(alpha).join(','), ")");
}
function $e59e2ec11a22a8bb$export$34d09c4a771c46ef(value) {
    var matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        var _matches$map = matches.map(Number), _matches$map2 = (0, $2oMHl.default)(_matches$map, 3), red = _matches$map2[0], green = _matches$map2[1], blue = _matches$map2[2];
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $e59e2ec11a22a8bb$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $e59e2ec11a22a8bb$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});
parcelRegister("ksCOI", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});


parcelRegister("2S7le", function(module, exports) {
$parcel$export(module.exports, "generateUuid", function () { return $217651c5568a5411$export$1c3aefb711c3a4cc; });
$parcel$export(module.exports, "uuid", function () { return $217651c5568a5411$export$31b40729666a4ae0; });
/* eslint-disable no-bitwise */ var $217651c5568a5411$export$1c3aefb711c3a4cc = function generateUuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
/* eslint-enable no-bitwise */ var $217651c5568a5411$var$staticValue = false;
var $217651c5568a5411$export$31b40729666a4ae0 = {
    setStatic: function setStatic(value) {
        $217651c5568a5411$var$staticValue = value;
    },
    generate: function generate() {
        return $217651c5568a5411$var$staticValue || $217651c5568a5411$export$1c3aefb711c3a4cc();
    }
};

});

parcelRegister("eKBj2", function(module, exports) {
$parcel$export(module.exports, "getDarkModeLCHColor", function () { return $abd24cc29393372f$export$a5065c3b8aacaf99; });
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
var $abd24cc29393372f$var$clamp = function clamp(i, min, max) {
    return Math.round(Math.min(Math.max(i, min), max));
};
var $abd24cc29393372f$var$expandShorthandHex = function expandShorthandHex(input) {
    return input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
};
var $abd24cc29393372f$var$rgbFromHex = function rgbFromHex(input) {
    var fullHex = $abd24cc29393372f$var$expandShorthandHex(input);
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
var $abd24cc29393372f$var$rgbToHex = function rgbToHex(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    var convertComponent = function convertComponent(c) {
        var cBase16 = c.toString(16);
        return cBase16.length === 1 ? "0".concat(cBase16) : cBase16;
    };
    return "#".concat(convertComponent(r)).concat(convertComponent(g)).concat(convertComponent(b));
};
var $abd24cc29393372f$var$rgbToXyz = function rgbToXyz(rgb) {
    var convertRgbComponent = function convertRgbComponent(c) {
        return c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    };
    var convertXyzComponent = function convertXyzComponent(c) {
        return c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    };
    var r = convertRgbComponent(rgb.r / 255);
    var g = convertRgbComponent(rgb.g / 255);
    var b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
var $abd24cc29393372f$var$xyzToLab = function xyzToLab(_ref2) {
    var x = _ref2.x, y = _ref2.y, z = _ref2.z;
    return {
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    };
};
var $abd24cc29393372f$var$labToLch = function labToLch(_ref3) {
    var l = _ref3.l, a = _ref3.a, b = _ref3.b;
    var h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    var c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
var $abd24cc29393372f$var$lchToLab = function lchToLab(_ref4) {
    var l = _ref4.l, c = _ref4.c, h = _ref4.h;
    var convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
var $abd24cc29393372f$var$labToXyz = function labToXyz(_ref5) {
    var l = _ref5.l, a = _ref5.a, b = _ref5.b;
    var convertComponent = function convertComponent(c) {
        return c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    };
    var y = (l + 16) / 116;
    var x = a / 500 + y;
    var z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
var $abd24cc29393372f$var$xyzToRgb = function xyzToRgb(_ref6) {
    var x = _ref6.x, y = _ref6.y, z = _ref6.z;
    var convertComponent = function convertComponent(c) {
        return 255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    };
    return {
        r: $abd24cc29393372f$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $abd24cc29393372f$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $abd24cc29393372f$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
var $abd24cc29393372f$var$rgbToLch = function rgbToLch(rgb) {
    return $abd24cc29393372f$var$labToLch($abd24cc29393372f$var$xyzToLab($abd24cc29393372f$var$rgbToXyz(rgb)));
};
var $abd24cc29393372f$var$lchToRgb = function lchToRgb(lch) {
    return $abd24cc29393372f$var$xyzToRgb($abd24cc29393372f$var$labToXyz($abd24cc29393372f$var$lchToLab(lch)));
};
var $abd24cc29393372f$export$313b8a8fcb34c3b8 = function clampLightness(color, newPercent) {
    var rgb = $abd24cc29393372f$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    var lch = $abd24cc29393372f$var$rgbToLch(rgb);
    lch.l = $abd24cc29393372f$var$clamp(newPercent, 0, 100);
    return $abd24cc29393372f$var$rgbToHex($abd24cc29393372f$var$lchToRgb(lch));
};
var $abd24cc29393372f$var$getLightness = function getLightness(color) {
    var rgb = $abd24cc29393372f$var$rgbFromHex(color);
    if (rgb === null) return 0;
    var lch = $abd24cc29393372f$var$rgbToLch(rgb);
    return lch.l;
};
var $abd24cc29393372f$export$a5065c3b8aacaf99 = function getDarkModeLCHColor(currentBackgroundColor) {
    var lightness = $abd24cc29393372f$var$getLightness(currentBackgroundColor);
    var newLightness = Math.abs(100 - lightness);
    return $abd24cc29393372f$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});


parcelRegister("hY9jm", function(module, exports) {
$parcel$export(module.exports, "createSchema", function () { return $d14f434a6dad0b95$export$5f4ce795563f4211; });

var $6AhyM = parcelRequire("6AhyM");

var $6zkal = parcelRequire("6zkal");

var $eWMmU = parcelRequire("eWMmU");

var $7IZw3 = parcelRequire("7IZw3");
var $64ryk = parcelRequire("64ryk");
var $5y0E3 = parcelRequire("5y0E3");
var $du1Ef = parcelRequire("du1Ef");
var $fCyhW = parcelRequire("fCyhW");
var $6KaFX = parcelRequire("6KaFX");
var $d2bOL = parcelRequire("d2bOL");
var $9AQ00 = parcelRequire("9AQ00");
var $lePET = parcelRequire("lePET");
var $lcYoA = parcelRequire("lcYoA");
var $1UJ1H = parcelRequire("1UJ1H");
var $i7o0l = parcelRequire("i7o0l");
var $3n0XG = parcelRequire("3n0XG");
var $eHDJh = parcelRequire("eHDJh");
var $gT0ST = parcelRequire("gT0ST");
var $4xsNf = parcelRequire("4xsNf");
var $3bNMV = parcelRequire("3bNMV");
var $2GOu8 = parcelRequire("2GOu8");
var $1szUn = parcelRequire("1szUn");
var $auUf2 = parcelRequire("auUf2");

var $9evdV = parcelRequire("9evdV");
var $g2zs1 = parcelRequire("g2zs1");
var $87mD1 = parcelRequire("87mD1");
var $4u1lW = parcelRequire("4u1lW");
var $24dct = parcelRequire("24dct");
var $8llzT = parcelRequire("8llzT");
var $5q8t6 = parcelRequire("5q8t6");
var $7rNWp = parcelRequire("7rNWp");
var $lTHMi = parcelRequire("lTHMi");
var $jcwum = parcelRequire("jcwum");
var $bzyaF = parcelRequire("bzyaF");
var $5LXaH = parcelRequire("5LXaH");
var $hIl0H = parcelRequire("hIl0H");
var $32RUX = parcelRequire("32RUX");
var $c8R5w = parcelRequire("c8R5w");
var $4sb5F = parcelRequire("4sb5F");
var $4z0QB = parcelRequire("4z0QB");
var $622WD = parcelRequire("622WD");
var $gzj4k = parcelRequire("gzj4k");
var $kkXnq = parcelRequire("kkXnq");
var $cJx4A = parcelRequire("cJx4A");
var $aHG2H = parcelRequire("aHG2H");
var $6hyqf = parcelRequire("6hyqf");
var $jcXN3 = parcelRequire("jcXN3");
var $he0Zv = parcelRequire("he0Zv");
var $hLyQ0 = parcelRequire("hLyQ0");
var $aouKI = parcelRequire("aouKI");
var $152tK = parcelRequire("152tK");
var $9o2P2 = parcelRequire("9o2P2");
var $68vRi = parcelRequire("68vRi");
var $BhUj1 = parcelRequire("BhUj1");
var $jeN3D = parcelRequire("jeN3D");
var $iT0sU = parcelRequire("iT0sU");
var $1kM7Y = parcelRequire("1kM7Y");
var $7qWL6 = parcelRequire("7qWL6");
var $gagqt = parcelRequire("gagqt");
var $gVMuH = parcelRequire("gVMuH");
var $63CJH = parcelRequire("63CJH");
var $llnov = parcelRequire("llnov");
var $cPuFg = parcelRequire("cPuFg");
var $3XRVL = parcelRequire("3XRVL");
var $adjeP = parcelRequire("adjeP");
var $cSYOL = parcelRequire("cSYOL");
var $3X5DQ = parcelRequire("3X5DQ");
var $k7yHx = parcelRequire("k7yHx");
function $d14f434a6dad0b95$var$addItems(builtInItems, config) {
    var customSpecs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ var items = builtInItems.reduce(function(items, _ref) {
        var name = _ref.name, spec = _ref.spec;
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce(function(items, name) {
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $d14f434a6dad0b95$var$groupDeclaration(name) {
    return {
        name: "__".concat(name, "GroupDeclaration"),
        spec: {
            group: name
        }
    };
}
var $d14f434a6dad0b95$var$markGroupDeclarations = [
    $d14f434a6dad0b95$var$groupDeclaration((0, $6zkal.COLOR)),
    $d14f434a6dad0b95$var$groupDeclaration((0, $6zkal.FONT_STYLE)),
    $d14f434a6dad0b95$var$groupDeclaration((0, $6zkal.SEARCH_QUERY)),
    $d14f434a6dad0b95$var$groupDeclaration((0, $6zkal.LINK))
];
var $d14f434a6dad0b95$var$markGroupDeclarationsNames = $d14f434a6dad0b95$var$markGroupDeclarations.map(function(groupMark) {
    return groupMark.name;
});
var $d14f434a6dad0b95$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $5LXaH.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $7qWL6.paragraph)
    },
    {
        name: 'text',
        spec: (0, $adjeP.text)
    },
    {
        name: 'bulletList',
        spec: (0, $87mD1.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $1kM7Y.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $aouKI.listItemWithTask)
    },
    {
        name: 'heading',
        spec: (0, $cJx4A.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $4sb5F.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $24dct.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $4z0QB.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $gVMuH.rule)
    },
    {
        name: 'image',
        spec: (0, $aHG2H.image)
    },
    {
        name: 'mention',
        spec: (0, $jeN3D.mention)
    },
    {
        name: 'caption',
        spec: (0, $4u1lW.caption)
    },
    {
        name: 'media',
        spec: (0, $152tK.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $9o2P2.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $BhUj1.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $68vRi.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $gagqt.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $hLyQ0.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $he0Zv.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $kkXnq.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $32RUX.emoji)
    },
    {
        name: 'table',
        spec: (0, $llnov.table)
    },
    {
        name: 'tableCell',
        spec: (0, $llnov.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $llnov.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $llnov.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $8llzT.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $7rNWp.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $5q8t6.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $bzyaF.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $jcwum.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $3XRVL.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $cPuFg.taskItem)
    },
    {
        name: 'date',
        spec: (0, $lTHMi.date)
    },
    {
        name: 'status',
        spec: (0, $63CJH.status)
    },
    {
        name: 'expand',
        spec: (0, $c8R5w.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $iT0sU.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $622WD.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $jcXN3.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $g2zs1.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $gzj4k.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $gzj4k.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $6hyqf.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $9evdV.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $hIl0H.embedCard)
    },
    {
        name: 'unknownBlock',
        spec: (0, $cSYOL.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $3X5DQ.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $k7yHx.unsupportedInline)
    }
];
var $d14f434a6dad0b95$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $i7o0l.link)
    },
    {
        name: 'em',
        spec: (0, $lePET.em)
    },
    {
        name: 'strong',
        spec: (0, $eHDJh.strong)
    },
    {
        name: 'textColor',
        spec: (0, $4xsNf.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $5y0E3.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $3n0XG.strike)
    },
    {
        name: 'subsup',
        spec: (0, $gT0ST.subsup)
    },
    {
        name: 'underline',
        spec: (0, $2GOu8.underline)
    },
    {
        name: 'code',
        spec: (0, $6KaFX.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $3bNMV.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $7IZw3.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $64ryk.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $d2bOL.confluenceInlineComment)
    }
].concat($d14f434a6dad0b95$var$markGroupDeclarations, [
    {
        name: 'breakout',
        spec: (0, $fCyhW.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $9AQ00.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $lcYoA.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $1UJ1H.indentation)
    },
    {
        name: 'border',
        spec: (0, $du1Ef.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $1szUn.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $auUf2.unsupportedNodeAttribute)
    }
]);
function $d14f434a6dad0b95$export$2d0c32a809131488() {
    var nodes = $d14f434a6dad0b95$var$nodesInOrder.reduce(function(acc, _ref2) {
        var name = _ref2.name, spec = _ref2.spec;
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    var marks = $d14f434a6dad0b95$var$marksInOrder.reduce(function(acc, _ref3) {
        var name = _ref3.name, spec = _ref3.spec;
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $d14f434a6dad0b95$export$5f4ce795563f4211(config) {
    var customNodeSpecs = config.customNodeSpecs, customMarkSpecs = config.customMarkSpecs;
    var nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    var marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($d14f434a6dad0b95$var$markGroupDeclarationsNames);
    var nodes = $d14f434a6dad0b95$var$addItems($d14f434a6dad0b95$var$nodesInOrder, nodesConfig, customNodeSpecs);
    var marks = $d14f434a6dad0b95$var$addItems($d14f434a6dad0b95$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $eWMmU.sanitizeNodes)(nodes, marks);
    return new (0, $6AhyM.Schema)({
        nodes: nodes,
        marks: marks
    });
}
var $d14f434a6dad0b95$export$c77b6d30da5276a1 = true;

});
parcelRegister("6AhyM", function(module, exports) {
$parcel$export(module.exports, "Fragment", function () { return $4cb3b9e5b37fcf4e$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Schema", function () { return $4cb3b9e5b37fcf4e$export$19342e026b58ebb7; });

var $l0GWs = parcelRequire("l0GWs");
function $4cb3b9e5b37fcf4e$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $4cb3b9e5b37fcf4e$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $4cb3b9e5b37fcf4e$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $4cb3b9e5b37fcf4e$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $4cb3b9e5b37fcf4e$export$ffb0004e005737fa {
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $4cb3b9e5b37fcf4e$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $4cb3b9e5b37fcf4e$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $4cb3b9e5b37fcf4e$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $4cb3b9e5b37fcf4e$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $4cb3b9e5b37fcf4e$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $4cb3b9e5b37fcf4e$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $4cb3b9e5b37fcf4e$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $4cb3b9e5b37fcf4e$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $4cb3b9e5b37fcf4e$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $4cb3b9e5b37fcf4e$var$retIndex(0, pos);
        if (pos == this.size) return $4cb3b9e5b37fcf4e$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $4cb3b9e5b37fcf4e$var$retIndex(i + 1, end);
                return $4cb3b9e5b37fcf4e$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $4cb3b9e5b37fcf4e$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $4cb3b9e5b37fcf4e$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $4cb3b9e5b37fcf4e$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $4cb3b9e5b37fcf4e$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $4cb3b9e5b37fcf4e$export$ffb0004e005737fa.empty;
        if (nodes instanceof $4cb3b9e5b37fcf4e$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $4cb3b9e5b37fcf4e$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $4cb3b9e5b37fcf4e$export$ffb0004e005737fa.empty = new $4cb3b9e5b37fcf4e$export$ffb0004e005737fa([], 0);
const $4cb3b9e5b37fcf4e$var$found = {
    index: 0,
    offset: 0
};
function $4cb3b9e5b37fcf4e$var$retIndex(index, offset) {
    $4cb3b9e5b37fcf4e$var$found.index = index;
    $4cb3b9e5b37fcf4e$var$found.offset = offset;
    return $4cb3b9e5b37fcf4e$var$found;
}
function $4cb3b9e5b37fcf4e$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$4cb3b9e5b37fcf4e$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$4cb3b9e5b37fcf4e$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044 {
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $4cb3b9e5b37fcf4e$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044.none;
        if (marks instanceof $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
}
/**
The empty set of marks.
*/ $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $4cb3b9e5b37fcf4e$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $4cb3b9e5b37fcf4e$export$b3f2e2de3a8baa1e {
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $4cb3b9e5b37fcf4e$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $4cb3b9e5b37fcf4e$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $4cb3b9e5b37fcf4e$export$b3f2e2de3a8baa1e($4cb3b9e5b37fcf4e$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $4cb3b9e5b37fcf4e$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $4cb3b9e5b37fcf4e$export$b3f2e2de3a8baa1e($4cb3b9e5b37fcf4e$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $4cb3b9e5b37fcf4e$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
}
/**
The empty slice.
*/ $4cb3b9e5b37fcf4e$export$b3f2e2de3a8baa1e.empty = new $4cb3b9e5b37fcf4e$export$b3f2e2de3a8baa1e($4cb3b9e5b37fcf4e$export$ffb0004e005737fa.empty, 0, 0);
function $4cb3b9e5b37fcf4e$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($4cb3b9e5b37fcf4e$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $4cb3b9e5b37fcf4e$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $4cb3b9e5b37fcf4e$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $4cb3b9e5b37fcf4e$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $4cb3b9e5b37fcf4e$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $4cb3b9e5b37fcf4e$export$6de0e778727af3f2("Inconsistent open depths");
    return $4cb3b9e5b37fcf4e$var$replaceOuter($from, $to, slice, 0);
}
function $4cb3b9e5b37fcf4e$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $4cb3b9e5b37fcf4e$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $4cb3b9e5b37fcf4e$var$close(node, $4cb3b9e5b37fcf4e$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $4cb3b9e5b37fcf4e$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $4cb3b9e5b37fcf4e$var$prepareSliceForReplace(slice, $from);
        return $4cb3b9e5b37fcf4e$var$close(node, $4cb3b9e5b37fcf4e$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $4cb3b9e5b37fcf4e$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $4cb3b9e5b37fcf4e$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $4cb3b9e5b37fcf4e$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $4cb3b9e5b37fcf4e$var$checkJoin(node, $after.node(depth));
    return node;
}
function $4cb3b9e5b37fcf4e$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $4cb3b9e5b37fcf4e$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $4cb3b9e5b37fcf4e$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$4cb3b9e5b37fcf4e$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $4cb3b9e5b37fcf4e$var$addNode($end.nodeBefore, target);
}
function $4cb3b9e5b37fcf4e$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $4cb3b9e5b37fcf4e$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $4cb3b9e5b37fcf4e$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $4cb3b9e5b37fcf4e$var$joinable($end, $to, depth + 1);
    let content = [];
    $4cb3b9e5b37fcf4e$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $4cb3b9e5b37fcf4e$var$checkJoin(openStart, openEnd);
        $4cb3b9e5b37fcf4e$var$addNode($4cb3b9e5b37fcf4e$var$close(openStart, $4cb3b9e5b37fcf4e$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $4cb3b9e5b37fcf4e$var$addNode($4cb3b9e5b37fcf4e$var$close(openStart, $4cb3b9e5b37fcf4e$var$replaceTwoWay($from, $start, depth + 1)), content);
        $4cb3b9e5b37fcf4e$var$addRange($start, $end, depth, content);
        if (openEnd) $4cb3b9e5b37fcf4e$var$addNode($4cb3b9e5b37fcf4e$var$close(openEnd, $4cb3b9e5b37fcf4e$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $4cb3b9e5b37fcf4e$var$addRange($to, null, depth, content);
    return new $4cb3b9e5b37fcf4e$export$ffb0004e005737fa(content);
}
function $4cb3b9e5b37fcf4e$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $4cb3b9e5b37fcf4e$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $4cb3b9e5b37fcf4e$var$joinable($from, $to, depth + 1);
        $4cb3b9e5b37fcf4e$var$addNode($4cb3b9e5b37fcf4e$var$close(type, $4cb3b9e5b37fcf4e$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $4cb3b9e5b37fcf4e$var$addRange($to, null, depth, content);
    return new $4cb3b9e5b37fcf4e$export$ffb0004e005737fa(content);
}
function $4cb3b9e5b37fcf4e$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($4cb3b9e5b37fcf4e$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $4cb3b9e5b37fcf4e$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $4cb3b9e5b37fcf4e$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $4cb3b9e5b37fcf4e$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $4cb3b9e5b37fcf4e$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $4cb3b9e5b37fcf4e$var$resolveCache.set(doc, cache = new $4cb3b9e5b37fcf4e$var$ResolveCache);
        let result = cache.elts[cache.i] = $4cb3b9e5b37fcf4e$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $4cb3b9e5b37fcf4e$var$resolveCacheSize;
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
}
class $4cb3b9e5b37fcf4e$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $4cb3b9e5b37fcf4e$var$resolveCacheSize = 12, $4cb3b9e5b37fcf4e$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $4cb3b9e5b37fcf4e$export$7bc461ceb770fb16 {
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
}
const $4cb3b9e5b37fcf4e$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $4cb3b9e5b37fcf4e$export$85c928794f8d04d4 {
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $4cb3b9e5b37fcf4e$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $4cb3b9e5b37fcf4e$var$emptyAttrs) && $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $4cb3b9e5b37fcf4e$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $4cb3b9e5b37fcf4e$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $4cb3b9e5b37fcf4e$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $4cb3b9e5b37fcf4e$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $4cb3b9e5b37fcf4e$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $4cb3b9e5b37fcf4e$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $4cb3b9e5b37fcf4e$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $4cb3b9e5b37fcf4e$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $4cb3b9e5b37fcf4e$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $4cb3b9e5b37fcf4e$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $4cb3b9e5b37fcf4e$export$ffb0004e005737fa.empty;
    }
}
$4cb3b9e5b37fcf4e$export$85c928794f8d04d4.prototype.text = undefined;
class $4cb3b9e5b37fcf4e$var$TextNode extends $4cb3b9e5b37fcf4e$export$85c928794f8d04d4 {
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $4cb3b9e5b37fcf4e$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $4cb3b9e5b37fcf4e$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $4cb3b9e5b37fcf4e$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
}
function $4cb3b9e5b37fcf4e$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $4cb3b9e5b37fcf4e$export$364ed450558d7ec4 {
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $4cb3b9e5b37fcf4e$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $4cb3b9e5b37fcf4e$export$364ed450558d7ec4.empty;
        let expr = $4cb3b9e5b37fcf4e$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $4cb3b9e5b37fcf4e$var$dfa($4cb3b9e5b37fcf4e$var$nfa(expr));
        $4cb3b9e5b37fcf4e$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $4cb3b9e5b37fcf4e$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
}
/**
@internal
*/ $4cb3b9e5b37fcf4e$export$364ed450558d7ec4.empty = new $4cb3b9e5b37fcf4e$export$364ed450558d7ec4(true);
class $4cb3b9e5b37fcf4e$var$TokenStream {
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
}
function $4cb3b9e5b37fcf4e$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($4cb3b9e5b37fcf4e$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $4cb3b9e5b37fcf4e$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($4cb3b9e5b37fcf4e$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $4cb3b9e5b37fcf4e$var$parseExprSubscript(stream) {
    let expr = $4cb3b9e5b37fcf4e$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $4cb3b9e5b37fcf4e$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $4cb3b9e5b37fcf4e$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $4cb3b9e5b37fcf4e$var$parseExprRange(stream, expr) {
    let min = $4cb3b9e5b37fcf4e$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $4cb3b9e5b37fcf4e$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $4cb3b9e5b37fcf4e$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $4cb3b9e5b37fcf4e$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $4cb3b9e5b37fcf4e$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $4cb3b9e5b37fcf4e$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $4cb3b9e5b37fcf4e$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $4cb3b9e5b37fcf4e$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $4cb3b9e5b37fcf4e$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($4cb3b9e5b37fcf4e$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $4cb3b9e5b37fcf4e$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($4cb3b9e5b37fcf4e$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $4cb3b9e5b37fcf4e$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $4cb3b9e5b37fcf4e$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($4cb3b9e5b37fcf4e$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $4cb3b9e5b37fcf4e$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $4cb3b9e5b37fcf4e$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $4cb3b9e5b37fcf4e$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $4cb3b9e5b37fcf4e$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $4cb3b9e5b37fcf4e$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $4cb3b9e5b37fcf4e$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $4cb3b9e5b37fcf4e$export$f06e977173f1857c {
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $4cb3b9e5b37fcf4e$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $4cb3b9e5b37fcf4e$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $4cb3b9e5b37fcf4e$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $4cb3b9e5b37fcf4e$export$ffb0004e005737fa.from(content), $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $4cb3b9e5b37fcf4e$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $4cb3b9e5b37fcf4e$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $4cb3b9e5b37fcf4e$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($4cb3b9e5b37fcf4e$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $4cb3b9e5b37fcf4e$export$85c928794f8d04d4(this, attrs, content.append(after), $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $4cb3b9e5b37fcf4e$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $4cb3b9e5b37fcf4e$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $4cb3b9e5b37fcf4e$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $4cb3b9e5b37fcf4e$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
}
function $4cb3b9e5b37fcf4e$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $4cb3b9e5b37fcf4e$var$Attribute {
    get isRequired() {
        return !this.hasDefault;
    }
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $4cb3b9e5b37fcf4e$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $4cb3b9e5b37fcf4e$export$b6a78689043c6521 {
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044(this, $4cb3b9e5b37fcf4e$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $4cb3b9e5b37fcf4e$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $4cb3b9e5b37fcf4e$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $4cb3b9e5b37fcf4e$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $4cb3b9e5b37fcf4e$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044(this, defaults) : null;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $4cb3b9e5b37fcf4e$export$19342e026b58ebb7 {
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $4cb3b9e5b37fcf4e$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $4cb3b9e5b37fcf4e$var$TextNode(type, type.defaultAttrs, text, $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $4cb3b9e5b37fcf4e$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $l0GWs.default).from(spec.nodes), instanceSpec.marks = (0, $l0GWs.default).from(spec.marks || {}), this.nodes = $4cb3b9e5b37fcf4e$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $4cb3b9e5b37fcf4e$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $4cb3b9e5b37fcf4e$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $4cb3b9e5b37fcf4e$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $4cb3b9e5b37fcf4e$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
}
function $4cb3b9e5b37fcf4e$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $4cb3b9e5b37fcf4e$var$isTagRule(rule) {
    return rule.tag != null;
}
function $4cb3b9e5b37fcf4e$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $4cb3b9e5b37fcf4e$export$1059c6e7d2ce5669 {
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $4cb3b9e5b37fcf4e$var$ParseContext(this, options, false);
        context.addAll(dom, $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $4cb3b9e5b37fcf4e$var$ParseContext(this, options, true);
        context.addAll(dom, $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $4cb3b9e5b37fcf4e$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($4cb3b9e5b37fcf4e$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $4cb3b9e5b37fcf4e$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $4cb3b9e5b37fcf4e$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $4cb3b9e5b37fcf4e$export$1059c6e7d2ce5669(schema, $4cb3b9e5b37fcf4e$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($4cb3b9e5b37fcf4e$var$isTagRule(rule)) this.tags.push(rule);
            else if ($4cb3b9e5b37fcf4e$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
}
const $4cb3b9e5b37fcf4e$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $4cb3b9e5b37fcf4e$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $4cb3b9e5b37fcf4e$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $4cb3b9e5b37fcf4e$var$OPT_PRESERVE_WS = 1, $4cb3b9e5b37fcf4e$var$OPT_PRESERVE_WS_FULL = 2, $4cb3b9e5b37fcf4e$var$OPT_OPEN_LEFT = 4;
function $4cb3b9e5b37fcf4e$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $4cb3b9e5b37fcf4e$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $4cb3b9e5b37fcf4e$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $4cb3b9e5b37fcf4e$var$OPT_PRESERVE_WS | $4cb3b9e5b37fcf4e$var$OPT_PRESERVE_WS_FULL : base & ~$4cb3b9e5b37fcf4e$var$OPT_OPEN_LEFT;
}
class $4cb3b9e5b37fcf4e$var$NodeContext {
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($4cb3b9e5b37fcf4e$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $4cb3b9e5b37fcf4e$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $4cb3b9e5b37fcf4e$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($4cb3b9e5b37fcf4e$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$4cb3b9e5b37fcf4e$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $4cb3b9e5b37fcf4e$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
}
class $4cb3b9e5b37fcf4e$var$ParseContext {
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $4cb3b9e5b37fcf4e$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $4cb3b9e5b37fcf4e$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($4cb3b9e5b37fcf4e$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $4cb3b9e5b37fcf4e$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $4cb3b9e5b37fcf4e$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($4cb3b9e5b37fcf4e$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $4cb3b9e5b37fcf4e$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $4cb3b9e5b37fcf4e$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $4cb3b9e5b37fcf4e$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $4cb3b9e5b37fcf4e$var$OPT_OPEN_LEFT;
        let applyMarks = $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $4cb3b9e5b37fcf4e$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $4cb3b9e5b37fcf4e$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $4cb3b9e5b37fcf4e$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $4cb3b9e5b37fcf4e$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $4cb3b9e5b37fcf4e$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $4cb3b9e5b37fcf4e$var$NodeContext(topNode.type, topNode.attrs, $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $4cb3b9e5b37fcf4e$var$NodeContext(null, null, $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $4cb3b9e5b37fcf4e$var$NodeContext(parser.schema.topNodeType, null, $4cb3b9e5b37fcf4e$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $4cb3b9e5b37fcf4e$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $4cb3b9e5b37fcf4e$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $4cb3b9e5b37fcf4e$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $4cb3b9e5b37fcf4e$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $4cb3b9e5b37fcf4e$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $4cb3b9e5b37fcf4e$export$3476b78f8f5a8b72 {
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $4cb3b9e5b37fcf4e$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $4cb3b9e5b37fcf4e$var$renderSpec($4cb3b9e5b37fcf4e$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $4cb3b9e5b37fcf4e$var$renderSpec($4cb3b9e5b37fcf4e$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $4cb3b9e5b37fcf4e$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $4cb3b9e5b37fcf4e$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $4cb3b9e5b37fcf4e$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $4cb3b9e5b37fcf4e$var$gatherToDOM(schema.marks);
    }
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
}
function $4cb3b9e5b37fcf4e$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $4cb3b9e5b37fcf4e$var$doc(options) {
    return options.document || window.document;
}
const $4cb3b9e5b37fcf4e$var$suspiciousAttributeCache = new WeakMap();
function $4cb3b9e5b37fcf4e$var$suspiciousAttributes(attrs) {
    let value = $4cb3b9e5b37fcf4e$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $4cb3b9e5b37fcf4e$var$suspiciousAttributeCache.set(attrs, value = $4cb3b9e5b37fcf4e$var$suspiciousAttributesInner(attrs));
    return value;
}
function $4cb3b9e5b37fcf4e$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $4cb3b9e5b37fcf4e$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $4cb3b9e5b37fcf4e$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $4cb3b9e5b37fcf4e$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});

parcelRegister("6zkal", function(module, exports) {
$parcel$export(module.exports, "FONT_STYLE", function () { return $4c85a7782e45131b$export$4498a6080fed604c; });
$parcel$export(module.exports, "SEARCH_QUERY", function () { return $4c85a7782e45131b$export$f8e8a5f34f6ea725; });
$parcel$export(module.exports, "LINK", function () { return $4c85a7782e45131b$export$b395009ca7f092c7; });
$parcel$export(module.exports, "COLOR", function () { return $4c85a7782e45131b$export$9b982809044276a6; });
// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
var $4c85a7782e45131b$export$4498a6080fed604c = 'fontStyle';
var $4c85a7782e45131b$export$f8e8a5f34f6ea725 = 'searchQuery';
var $4c85a7782e45131b$export$b395009ca7f092c7 = 'link';
var $4c85a7782e45131b$export$9b982809044276a6 = 'color';
var $4c85a7782e45131b$export$470d0905851e47a1 = 'alignment';
var $4c85a7782e45131b$export$bacb7f4b06a06b22 = 'indentation';

});

parcelRegister("eWMmU", function(module, exports) {
$parcel$export(module.exports, "sanitizeNodes", function () { return $ae1c007155d99cce$export$daf54fed04c8fb77; });

var $1K2xC = parcelRequire("1K2xC");
function $ae1c007155d99cce$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ae1c007155d99cce$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ae1c007155d99cce$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1K2xC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ae1c007155d99cce$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ae1c007155d99cce$export$daf54fed04c8fb77(nodes, supportedMarks) {
    var nodeNames = Object.keys(nodes);
    nodeNames.forEach(function(nodeKey) {
        var nodeSpec = $ae1c007155d99cce$var$_objectSpread({}, nodes[nodeKey]);
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter(function(mark) {
            return !!supportedMarks[mark];
        }).join(' ');
        if (nodeSpec.content) nodeSpec.content = $ae1c007155d99cce$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $ae1c007155d99cce$var$sanitizeNodeSpecContent(nodes, rawContent) {
    var content = rawContent.replace(/\W/g, ' ');
    var contentKeys = content.split(' ');
    var unsupportedContentKeys = contentKeys.filter(function(contentKey) {
        return !$ae1c007155d99cce$var$isContentSupported(nodes, contentKey);
    });
    return unsupportedContentKeys.reduce(function(newContent, nodeName) {
        return $ae1c007155d99cce$var$sanitizedContent(newContent, nodeName);
    }, rawContent);
}
function $ae1c007155d99cce$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match(/\w/)) return '';
    var pattern = "(".concat(invalidContent, "((\\s)*\\|)+)|((\\|(\\s)*)+").concat(invalidContent, "(\\+|\\*)?)|(").concat(invalidContent, "$)|(").concat(invalidContent, "(\\+|\\*))");
    return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
}
function $ae1c007155d99cce$var$isContentSupported(nodes, contentKey) {
    var nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(var supportedKey in nodes){
        var nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});

parcelRegister("7IZw3", function(module, exports) {
$parcel$export(module.exports, "alignmentPositionMap", function () { return $59fc5c3e575e7116$export$be9cf49015769bbd; });
$parcel$export(module.exports, "alignment", function () { return $59fc5c3e575e7116$export$8e53000a4ec837; });

var $gSyow = parcelRequire("gSyow");
var $59fc5c3e575e7116$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
var $59fc5c3e575e7116$export$8e53000a4ec837 = (0, $gSyow.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: function getAttrs(dom) {
                var align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            'div',
            {
                class: "fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-".concat(mark.attrs.align),
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});
parcelRegister("gSyow", function(module, exports) {
$parcel$export(module.exports, "alignment", function () { return $c49c5e8740768c99$export$8e53000a4ec837; });
$parcel$export(module.exports, "annotation", function () { return $c49c5e8740768c99$export$8512c9afa7b24c3b; });
$parcel$export(module.exports, "backgroundColor", function () { return $c49c5e8740768c99$export$8c5a050822fd698c; });
$parcel$export(module.exports, "border", function () { return $c49c5e8740768c99$export$1edee58a52776cd9; });
$parcel$export(module.exports, "breakout", function () { return $c49c5e8740768c99$export$89015c65f1c75e3f; });
$parcel$export(module.exports, "code", function () { return $c49c5e8740768c99$export$6565f9f03506010b; });
$parcel$export(module.exports, "confluenceInlineComment", function () { return $c49c5e8740768c99$export$f3b72f8fc4684ecd; });
$parcel$export(module.exports, "dataConsumer", function () { return $c49c5e8740768c99$export$3024f02c495408d6; });
$parcel$export(module.exports, "em", function () { return $c49c5e8740768c99$export$c63c6f932822f543; });
$parcel$export(module.exports, "fragment", function () { return $c49c5e8740768c99$export$f00aeb236b6f05af; });
$parcel$export(module.exports, "indentation", function () { return $c49c5e8740768c99$export$480c699bd4ec0d86; });
$parcel$export(module.exports, "link", function () { return $c49c5e8740768c99$export$9c30223ca0a664fb; });
$parcel$export(module.exports, "strike", function () { return $c49c5e8740768c99$export$4899a95d70ec5056; });
$parcel$export(module.exports, "strong", function () { return $c49c5e8740768c99$export$59ae2c325a998f89; });
$parcel$export(module.exports, "subsup", function () { return $c49c5e8740768c99$export$b3401ee80eb31041; });
$parcel$export(module.exports, "textColor", function () { return $c49c5e8740768c99$export$32f78bffcd82ff28; });
$parcel$export(module.exports, "typeAheadQuery", function () { return $c49c5e8740768c99$export$20af3dabbb5538df; });
$parcel$export(module.exports, "underline", function () { return $c49c5e8740768c99$export$425327af25286e5e; });
$parcel$export(module.exports, "unsupportedMark", function () { return $c49c5e8740768c99$export$30d78d5eb6719bb8; });
$parcel$export(module.exports, "unsupportedNodeAttribute", function () { return $c49c5e8740768c99$export$a316dc07ff5182a2; });
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $c8Ip2 = parcelRequire("c8Ip2");
var $c49c5e8740768c99$export$8e53000a4ec837 = (0, $c8Ip2.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
var $c49c5e8740768c99$export$8512c9afa7b24c3b = (0, $c8Ip2.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
var $c49c5e8740768c99$export$8c5a050822fd698c = (0, $c8Ip2.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: 'color',
    group: 'color'
});
var $c49c5e8740768c99$export$1edee58a52776cd9 = (0, $c8Ip2.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
var $c49c5e8740768c99$export$89015c65f1c75e3f = (0, $c8Ip2.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
var $c49c5e8740768c99$export$6565f9f03506010b = (0, $c8Ip2.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
var $c49c5e8740768c99$export$f3b72f8fc4684ecd = (0, $c8Ip2.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
var $c49c5e8740768c99$export$3024f02c495408d6 = (0, $c8Ip2.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
var $c49c5e8740768c99$export$c63c6f932822f543 = (0, $c8Ip2.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $c49c5e8740768c99$export$f00aeb236b6f05af = (0, $c8Ip2.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
var $c49c5e8740768c99$export$480c699bd4ec0d86 = (0, $c8Ip2.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
var $c49c5e8740768c99$export$9c30223ca0a664fb = (0, $c8Ip2.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
var $c49c5e8740768c99$export$4899a95d70ec5056 = (0, $c8Ip2.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $c49c5e8740768c99$export$59ae2c325a998f89 = (0, $c8Ip2.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $c49c5e8740768c99$export$b3401ee80eb31041 = (0, $c8Ip2.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
var $c49c5e8740768c99$export$32f78bffcd82ff28 = (0, $c8Ip2.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
var $c49c5e8740768c99$export$20af3dabbb5538df = (0, $c8Ip2.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
var $c49c5e8740768c99$export$425327af25286e5e = (0, $c8Ip2.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $c49c5e8740768c99$export$30d78d5eb6719bb8 = (0, $c8Ip2.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
var $c49c5e8740768c99$export$a316dc07ff5182a2 = (0, $c8Ip2.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});


parcelRegister("64ryk", function(module, exports) {
$parcel$export(module.exports, "AnnotationTypes", function () { return $46b87d32ee906e0c$export$94aa2fc69ad33d19; });
$parcel$export(module.exports, "AnnotationMarkStates", function () { return $46b87d32ee906e0c$export$4bab14797673da9f; });
$parcel$export(module.exports, "buildDataAttributes", function () { return $46b87d32ee906e0c$export$93a98caa8bc6cb07; });
$parcel$export(module.exports, "annotation", function () { return $46b87d32ee906e0c$export$8512c9afa7b24c3b; });

var $1K2xC = parcelRequire("1K2xC");

var $gSyow = parcelRequire("gSyow");
function $46b87d32ee906e0c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $46b87d32ee906e0c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $46b87d32ee906e0c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1K2xC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $46b87d32ee906e0c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $46b87d32ee906e0c$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
var $46b87d32ee906e0c$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $46b87d32ee906e0c$export$93a98caa8bc6cb07(_ref) {
    var id = _ref.id, annotationType = _ref.annotationType, state = _ref.state;
    var data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return $46b87d32ee906e0c$var$_objectSpread($46b87d32ee906e0c$var$_objectSpread({}, data), {}, {
        'data-mark-annotation-state': state
    });
    return data;
}
var $46b87d32ee906e0c$export$8512c9afa7b24c3b = (0, $gSyow.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            'span',
            $46b87d32ee906e0c$var$_objectSpread({
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation'
            }, $46b87d32ee906e0c$export$93a98caa8bc6cb07({
                id: node.attrs.id,
                annotationType: node.attrs.annotationType
            })),
            0
        ];
    }
});

});

parcelRegister("5y0E3", function(module, exports) {
$parcel$export(module.exports, "backgroundColor", function () { return $40a0a0d0ad085ed8$export$8c5a050822fd698c; });

var $1K2xC = parcelRequire("1K2xC");

var $2oMHl = parcelRequire("2oMHl");

var $gSyow = parcelRequire("gSyow");

var $agkbL = parcelRequire("agkbL");

var $jIfxG = parcelRequire("jIfxG");

var $4xsNf = parcelRequire("4xsNf");

var $eKBj2 = parcelRequire("eKBj2");
/**
 * @name backgroundColor_mark
 */ var $40a0a0d0ad085ed8$var$colorArrayPalette = [
    [
        (0, $jIfxG.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $jIfxG.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $jIfxG.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $jIfxG.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $jIfxG.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $jIfxG.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
var $40a0a0d0ad085ed8$export$14ec3f21a268e497 = new Map();
$40a0a0d0ad085ed8$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $2oMHl.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $40a0a0d0ad085ed8$export$14ec3f21a268e497.set(color.toLowerCase(), label);
});
var $40a0a0d0ad085ed8$export$8c5a050822fd698c = (0, $gSyow.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $jIfxG.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $40a0a0d0ad085ed8$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $40a0a0d0ad085ed8$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $agkbL.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $4xsNf.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $eKBj2.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            (0, $1K2xC.default)({
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, 'data-background-custom-color', mark.attrs.color)
        ];
    }
});

});
parcelRegister("4xsNf", function(module, exports) {
$parcel$export(module.exports, "getGlobalTheme", function () { return $34e0943e2f4f74b1$export$813ecdf77207a053; });
$parcel$export(module.exports, "textColor", function () { return $34e0943e2f4f74b1$export$32f78bffcd82ff28; });

var $1K2xC = parcelRequire("1K2xC");

var $2oMHl = parcelRequire("2oMHl");

var $gSyow = parcelRequire("gSyow");

var $agkbL = parcelRequire("agkbL");

var $jIfxG = parcelRequire("jIfxG");

var $eKBj2 = parcelRequire("eKBj2");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
var $34e0943e2f4f74b1$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $jIfxG.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $jIfxG.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $jIfxG.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $jIfxG.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $jIfxG.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $jIfxG.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $jIfxG.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $jIfxG.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $jIfxG.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $jIfxG.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $jIfxG.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $jIfxG.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $jIfxG.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $jIfxG.N0),
        'White'
    ],
    [
        (0, $jIfxG.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $jIfxG.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $jIfxG.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $jIfxG.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $jIfxG.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $jIfxG.P50),
        'Light purple'
    ] // Lavender secret
];
var $34e0943e2f4f74b1$export$569885e57444f84a = new Map();
var $34e0943e2f4f74b1$export$81e5ed9e84fe2e28 = $34e0943e2f4f74b1$export$569885e57444f84a;
$34e0943e2f4f74b1$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $2oMHl.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $34e0943e2f4f74b1$export$569885e57444f84a.set(color.toLowerCase(), label);
});
// these are for test only
var $34e0943e2f4f74b1$var$testGlobalTheme;
var $34e0943e2f4f74b1$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $34e0943e2f4f74b1$var$testGlobalTheme = theme;
};
var $34e0943e2f4f74b1$export$813ecdf77207a053 = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($34e0943e2f4f74b1$var$testGlobalTheme) return {
        colorMode: $34e0943e2f4f74b1$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
var $34e0943e2f4f74b1$export$32f78bffcd82ff28 = (0, $gSyow.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $jIfxG.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $34e0943e2f4f74b1$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $34e0943e2f4f74b1$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $agkbL.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($34e0943e2f4f74b1$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $eKBj2.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            (0, $1K2xC.default)({
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, 'data-text-custom-color', mark.attrs.color)
        ];
    }
});

});


parcelRegister("du1Ef", function(module, exports) {
$parcel$export(module.exports, "border", function () { return $9d0f5b01d05ebc64$export$1edee58a52776cd9; });

var $2oMHl = parcelRequire("2oMHl");

var $gSyow = parcelRequire("gSyow");

var $agkbL = parcelRequire("agkbL");

var $jIfxG = parcelRequire("jIfxG");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ var $9d0f5b01d05ebc64$var$borderColorArrayPalette = [
    [
        (0, $jIfxG.N300A),
        'Subtle gray'
    ],
    [
        (0, $jIfxG.N600),
        'Gray'
    ],
    [
        (0, $jIfxG.N1000),
        'Bold gray'
    ]
];
var $9d0f5b01d05ebc64$export$e4e044c989c86ca7 = new Map();
$9d0f5b01d05ebc64$var$borderColorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $2oMHl.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $9d0f5b01d05ebc64$export$e4e044c989c86ca7.set(color.toLowerCase(), label);
});
var $9d0f5b01d05ebc64$export$1edee58a52776cd9 = (0, $gSyow.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: function getAttrs(domNode) {
                var _dom$getAttribute, _dom$getAttribute2;
                var dom = domNode;
                var color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                var size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $9d0f5b01d05ebc64$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM: function toDOM(mark, isInline) {
        var wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        var paletteColorValue = (0, $agkbL.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }
        ];
    }
});

});

parcelRegister("fCyhW", function(module, exports) {
$parcel$export(module.exports, "breakout", function () { return $b5f5009a7d441e0b$export$89015c65f1c75e3f; });

var $gSyow = parcelRequire("gSyow");
var $b5f5009a7d441e0b$var$allowedTypes = [
    'wide',
    'full-width'
];
var $b5f5009a7d441e0b$export$89015c65f1c75e3f = (0, $gSyow.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs: function getAttrs(dom) {
                var mode = dom.getAttribute('data-mode');
                var width = dom.getAttribute('data-width');
                return {
                    mode: $b5f5009a7d441e0b$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var _mark$attrs;
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("6KaFX", function(module, exports) {
$parcel$export(module.exports, "code", function () { return $4e8f51f2c44e8745$export$6565f9f03506010b; });

var $gSyow = parcelRequire("gSyow");
var $4e8f51f2c44e8745$export$6565f9f03506010b = (0, $gSyow.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("d2bOL", function(module, exports) {
$parcel$export(module.exports, "confluenceInlineComment", function () { return $97d4a10e3b7befa0$export$f3b72f8fc4684ecd; });

var $gSyow = parcelRequire("gSyow");
var $97d4a10e3b7befa0$export$f3b72f8fc4684ecd = (0, $gSyow.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("9AQ00", function(module, exports) {
$parcel$export(module.exports, "dataConsumer", function () { return $6fbfcfc3f31eeb52$export$3024f02c495408d6; });

var $1K2xC = parcelRequire("1K2xC");

var $gSyow = parcelRequire("gSyow");

var $8CoOB = parcelRequire("8CoOB");
function $6fbfcfc3f31eeb52$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6fbfcfc3f31eeb52$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6fbfcfc3f31eeb52$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1K2xC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6fbfcfc3f31eeb52$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ var $6fbfcfc3f31eeb52$var$parseDataConsumer = function parseDataConsumer(maybeValue) {
    var sources = (0, $8CoOB.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch (_unused) {
        return false;
    }
};
var $6fbfcfc3f31eeb52$export$3024f02c495408d6 = (0, $gSyow.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: function getAttrs(maybeValue) {
                return $6fbfcfc3f31eeb52$var$parseDataConsumer(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
var $6fbfcfc3f31eeb52$export$54fd2c36b5cc6731 = function toJSON(mark) {
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter(function(key) {
            return key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null;
        }).reduce(function(acc, key) {
            return $6fbfcfc3f31eeb52$var$_objectSpread($6fbfcfc3f31eeb52$var$_objectSpread({}, acc), {}, (0, $1K2xC.default)({}, key, mark.attrs[key]));
        }, {})
    };
};

});
parcelRegister("8CoOB", function(module, exports) {
$parcel$export(module.exports, "isDOMElement", function () { return $64651f23e80bc16e$export$c296e2d4365c37a5; });
var $64651f23e80bc16e$export$c296e2d4365c37a5 = function isDOMElement(maybeNode) {
    return maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;
};

});


parcelRegister("lePET", function(module, exports) {
$parcel$export(module.exports, "em", function () { return $f762fa1b6e52de96$export$c63c6f932822f543; });

var $gSyow = parcelRequire("gSyow");
/**
 * @name em_mark
 */ var $f762fa1b6e52de96$var$emDOM = [
    'em'
];
var $f762fa1b6e52de96$export$c63c6f932822f543 = (0, $gSyow.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM: function toDOM() {
        return $f762fa1b6e52de96$var$emDOM;
    }
});

});

parcelRegister("lcYoA", function(module, exports) {
$parcel$export(module.exports, "fragment", function () { return $f70991408b07c344$export$f00aeb236b6f05af; });

var $1K2xC = parcelRequire("1K2xC");

var $gSyow = parcelRequire("gSyow");

var $8CoOB = parcelRequire("8CoOB");
function $f70991408b07c344$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f70991408b07c344$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f70991408b07c344$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1K2xC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f70991408b07c344$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ var $f70991408b07c344$var$parseFragment = function parseFragment(maybeValue) {
    var _maybeValue$getAttrib;
    if (!(0, $8CoOB.isDOMElement)(maybeValue)) return false;
    var name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    var localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
var $f70991408b07c344$export$f00aeb236b6f05af = (0, $gSyow.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: function getAttrs(maybeValue) {
                return $f70991408b07c344$var$parseFragment(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
var $f70991408b07c344$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: $f70991408b07c344$var$_objectSpread({
            localId: mark.attrs.localId
        }, mark.attrs.name ? {
            name: mark.attrs.name
        } : {})
    };
};

});

parcelRegister("1UJ1H", function(module, exports) {
$parcel$export(module.exports, "indentation", function () { return $164df2b93968ef4e$export$480c699bd4ec0d86; });

var $gSyow = parcelRequire("gSyow");
var $164df2b93968ef4e$export$480c699bd4ec0d86 = (0, $gSyow.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs: function getAttrs(dom) {
                var level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("i7o0l", function(module, exports) {
$parcel$export(module.exports, "link", function () { return $d30b8040ce63f931$export$9c30223ca0a664fb; });

var $1K2xC = parcelRequire("1K2xC");

var $gSyow = parcelRequire("gSyow");

var $dB7hx = parcelRequire("dB7hx");
function $d30b8040ce63f931$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d30b8040ce63f931$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d30b8040ce63f931$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1K2xC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d30b8040ce63f931$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d30b8040ce63f931$export$b5f67017585d1431 = function getLinkAttrs(attribute) {
    return function(domNode) {
        var dom = domNode;
        var href = dom.getAttribute(attribute) || '';
        var attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $dB7hx.isSafeUrl)(href)) return false;
        if ((0, $dB7hx.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $dB7hx.normalizeUrl)(href);
        return attrs;
    };
};
var $d30b8040ce63f931$export$9c30223ca0a664fb = (0, $gSyow.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $d30b8040ce63f931$export$b5f67017585d1431('data-block-link'),
            contentElement: function contentElement(node) {
                var clone = node.cloneNode(true);
                clone.removeAttribute('data-block-link');
                clone.setAttribute('data-skip-paste', 'true');
                var wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $d30b8040ce63f931$export$b5f67017585d1431('href')
        }
    ],
    toDOM: function toDOM(node, isInline) {
        var attrs = Object.keys(node.attrs).reduce(function(attrs, key) {
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $dB7hx.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            $d30b8040ce63f931$var$_objectSpread($d30b8040ce63f931$var$_objectSpread({}, attrs), {}, (0, $1K2xC.default)((0, $1K2xC.default)({}, 'data-block-link', 'true'), "class", 'blockLink')),
            0
        ];
    }
});
var $d30b8040ce63f931$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
var $d30b8040ce63f931$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce(function(attrs, key) {
            if ($d30b8040ce63f931$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    };
};

});

parcelRegister("3n0XG", function(module, exports) {
$parcel$export(module.exports, "strike", function () { return $27444410aa09e211$export$4899a95d70ec5056; });

var $gSyow = parcelRequire("gSyow");
var $27444410aa09e211$export$4899a95d70ec5056 = (0, $gSyow.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: function getAttrs(value) {
                return value === 'line-through' && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            's'
        ];
    }
});

});

parcelRegister("eHDJh", function(module, exports) {
$parcel$export(module.exports, "strong", function () { return $ab43e6435dc21f6f$export$59ae2c325a998f89; });

var $gSyow = parcelRequire("gSyow");
/**
 * @name strong_mark
 */ var $ab43e6435dc21f6f$var$strongDOM = [
    'strong'
];
var $ab43e6435dc21f6f$export$59ae2c325a998f89 = (0, $gSyow.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs: function getAttrs(node) {
                var element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs: function getAttrs(node) {
                var element = node;
                var fontWeight = element.style.fontWeight;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return $ab43e6435dc21f6f$var$strongDOM;
    }
});

});

parcelRegister("gT0ST", function(module, exports) {
$parcel$export(module.exports, "subsup", function () { return $c4b27800ed6923b5$export$b3401ee80eb31041; });

var $gSyow = parcelRequire("gSyow");
/**
 * @name subsup_mark
 */ function $c4b27800ed6923b5$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
var $c4b27800ed6923b5$export$b3401ee80eb31041 = (0, $gSyow.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: function getAttrs(node) {
                return $c4b27800ed6923b5$var$getAttrFromVerticalAlign(node);
            }
        },
        {
            style: 'vertical-align=sub',
            getAttrs: function getAttrs(node) {
                return $c4b27800ed6923b5$var$getAttrFromVerticalAlign(node);
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("3bNMV", function(module, exports) {
$parcel$export(module.exports, "typeAheadQuery", function () { return $2529051120f238d4$export$20af3dabbb5538df; });

var $gSyow = parcelRequire("gSyow");

var $jIfxG = parcelRequire("jIfxG");
var $2529051120f238d4$export$20af3dabbb5538df = (0, $gSyow.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: "color: ".concat((0, $jIfxG.B400))
            }
        ];
    }
});

});

parcelRegister("2GOu8", function(module, exports) {
$parcel$export(module.exports, "underline", function () { return $1f56aa4e1412fb18$export$425327af25286e5e; });

var $gSyow = parcelRequire("gSyow");
var $1f56aa4e1412fb18$export$425327af25286e5e = (0, $gSyow.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: function getAttrs(value) {
                return value === 'underline' && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            'u'
        ];
    }
});

});

parcelRegister("1szUn", function(module, exports) {
$parcel$export(module.exports, "unsupportedMark", function () { return $1104429bd5fb85ee$export$30d78d5eb6719bb8; });

var $gSyow = parcelRequire("gSyow");
var $1104429bd5fb85ee$export$30d78d5eb6719bb8 = (0, $gSyow.unsupportedMark)({
    toDOM: function toDOM() {
        return [
            'span'
        ];
    }
});

});

parcelRegister("auUf2", function(module, exports) {
$parcel$export(module.exports, "unsupportedNodeAttribute", function () { return $7a485522f407734b$export$a316dc07ff5182a2; });

var $gSyow = parcelRequire("gSyow");
var $7a485522f407734b$export$a316dc07ff5182a2 = (0, $gSyow.unsupportedNodeAttribute)({
    toDOM: function toDOM() {
        return [
            'span'
        ];
    }
});

});

parcelRegister("9evdV", function(module, exports) {
$parcel$export(module.exports, "blockCard", function () { return $6b8da4377736dc7d$export$c4c2f833baaebdb8; });

var $1K2xC = parcelRequire("1K2xC");

var $izlrY = parcelRequire("izlrY");
function $6b8da4377736dc7d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6b8da4377736dc7d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6b8da4377736dc7d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1K2xC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6b8da4377736dc7d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name blockCard_node
 */ var $6b8da4377736dc7d$var$getCommonAttributesFromDom = function getCommonAttributesFromDom(dom) {
    var anchor = dom;
    var data = anchor.getAttribute('data-card-data');
    var datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
var $6b8da4377736dc7d$export$c4c2f833baaebdb8 = (0, $izlrY.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $6b8da4377736dc7d$var$_objectSpread({
                    url: anchor.getAttribute('href') || undefined
                }, $6b8da4377736dc7d$var$getCommonAttributesFromDom(dom));
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $6b8da4377736dc7d$var$_objectSpread({
                    url: anchor.getAttribute('data-card-url') || undefined
                }, $6b8da4377736dc7d$var$getCommonAttributesFromDom(dom));
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var _ref = node.attrs, url = _ref.url;
        var _ref2 = node.attrs, data = _ref2.data;
        var _ref3 = node.attrs, layout = _ref3.layout, width = _ref3.width, datasource = _ref3.datasource;
        var attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': "".concat(width)
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});

});

parcelRegister("g2zs1", function(module, exports) {
$parcel$export(module.exports, "bodiedExtension", function () { return $bad8550e0b0fe387$export$27903d543b563e39; });

var $2S9L4 = parcelRequire("2S9L4");

var $izlrY = parcelRequire("izlrY");
var $bad8550e0b0fe387$export$27903d543b563e39 = (0, $izlrY.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $2S9L4.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("87mD1", function(module, exports) {
$parcel$export(module.exports, "bulletListSelector", function () { return $5e9087afbb858162$export$5f25a39efab3b58b; });
$parcel$export(module.exports, "bulletList", function () { return $5e9087afbb858162$export$a140c94e5ea26bee; });

var $izlrY = parcelRequire("izlrY");
var $5e9087afbb858162$export$5f25a39efab3b58b = '.ak-ul';
var $5e9087afbb858162$export$a140c94e5ea26bee = (0, $izlrY.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $5e9087afbb858162$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("4u1lW", function(module, exports) {
$parcel$export(module.exports, "caption", function () { return $343b03727734ec79$export$8e3c2dfdc4f0453d; });

var $izlrY = parcelRequire("izlrY");
var $343b03727734ec79$export$8e3c2dfdc4f0453d = (0, $izlrY.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("24dct", function(module, exports) {
$parcel$export(module.exports, "codeBlock", function () { return $181631c22aedb3f5$export$7bb0d5c671655cc4; });
$parcel$export(module.exports, "toJSON", function () { return $181631c22aedb3f5$export$54fd2c36b5cc6731; });

var $6AhyM = parcelRequire("6AhyM");

var $izlrY = parcelRequire("izlrY");
/**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_node
 */ var $181631c22aedb3f5$var$getLanguageFromEditorStyle = function getLanguageFromEditorStyle(dom) {
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
var $181631c22aedb3f5$var$getLanguageFromBitbucketStyle = function getLanguageFromBitbucketStyle(dom) {
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $181631c22aedb3f5$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
var $181631c22aedb3f5$var$getLanguageFromCode = function getLanguageFromCode(dom) {
    var firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
var $181631c22aedb3f5$var$extractLanguageFromClass = function extractLanguageFromClass(className) {
    var languageRegex = /(?:^|\s)language-([^\s]+)/;
    var result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
var $181631c22aedb3f5$var$removeLastNewLine = function removeLastNewLine(dom) {
    var parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
    return dom;
};
function $181631c22aedb3f5$var$parseCodeFromHtml(node) {
    var code = '';
    node.childNodes.forEach(function(child) {
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            var tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $181631c22aedb3f5$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
var $181631c22aedb3f5$export$7bb0d5c671655cc4 = (0, $izlrY.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var language = $181631c22aedb3f5$var$getLanguageFromBitbucketStyle(dom.parentElement) || $181631c22aedb3f5$var$getLanguageFromEditorStyle(dom.parentElement) || $181631c22aedb3f5$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $181631c22aedb3f5$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: function getContent(domNode, schema) {
                var code = $181631c22aedb3f5$var$parseCodeFromHtml(domNode);
                return code ? (0, $6AhyM.Fragment).from(schema.text(code)) : (0, $6AhyM.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(dom) {
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                var lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach(function(line) {
                    return line.remove();
                });
                return {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
var $181631c22aedb3f5$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(memo, key) {
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    };
};

});

parcelRegister("8llzT", function(module, exports) {
$parcel$export(module.exports, "confluenceJiraIssue", function () { return $613105ceadfde0a0$export$daf889beb5092f95; });

var $izlrY = parcelRequire("izlrY");
var $613105ceadfde0a0$var$name = 'confluenceJiraIssue';
var $613105ceadfde0a0$export$daf889beb5092f95 = (0, $izlrY.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: "span[data-node-type=\"".concat($613105ceadfde0a0$var$name, "\"]"),
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': $613105ceadfde0a0$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("5q8t6", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedBlock", function () { return $3f25f3160814182d$export$e6e4878f43c27cab; });

var $izlrY = parcelRequire("izlrY");
var $3f25f3160814182d$var$name = 'confluenceUnsupportedBlock';
var $3f25f3160814182d$export$e6e4878f43c27cab = (0, $izlrY.confluenceUnsupportedBlock)({
    toDOM: function toDOM(node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        var attrs = {
            'data-node-type': $3f25f3160814182d$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($3f25f3160814182d$var$name, "\"]"),
            getAttrs: function getAttrs(dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("7rNWp", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedInline", function () { return $56c1cb43e3c6dd57$export$3e6d667072febc87; });

var $izlrY = parcelRequire("izlrY");
var $56c1cb43e3c6dd57$var$name = 'confluenceUnsupportedInline';
var $56c1cb43e3c6dd57$export$3e6d667072febc87 = (0, $izlrY.confluenceUnsupportedInline)({
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': $56c1cb43e3c6dd57$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($56c1cb43e3c6dd57$var$name, "\"]"),
            getAttrs: function getAttrs(dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("lTHMi", function(module, exports) {
$parcel$export(module.exports, "date", function () { return $ff10b16b31c146a4$export$324d90190a8b822a; });

var $izlrY = parcelRequire("izlrY");
var $ff10b16b31c146a4$export$324d90190a8b822a = (0, $izlrY.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: function getAttrs(dom) {
                return {
                    timestamp: dom.getAttribute('data-timestamp')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("jcwum", function(module, exports) {
$parcel$export(module.exports, "decisionItem", function () { return $dfa856de24eaf258$export$6959e16eeff859b4; });

var $2S7le = parcelRequire("2S7le");

var $izlrY = parcelRequire("izlrY");
var $dfa856de24eaf258$export$6959e16eeff859b4 = (0, $izlrY.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $2S7le.uuid).generate(),
                    state: dom.getAttribute('data-decision-state')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});

parcelRegister("bzyaF", function(module, exports) {
$parcel$export(module.exports, "decisionListSelector", function () { return $86cd78466e83e393$export$a5393ce68c2ff601; });
$parcel$export(module.exports, "decisionList", function () { return $86cd78466e83e393$export$62d45a65fb43d95e; });

var $2S7le = parcelRequire("2S7le");

var $izlrY = parcelRequire("izlrY");
/**
 * @name decisionList_node
 */ var $86cd78466e83e393$var$name = 'decisionList';
var $86cd78466e83e393$export$a5393ce68c2ff601 = "[data-node-type=\"".concat($86cd78466e83e393$var$name, "\"]");
var $86cd78466e83e393$export$62d45a65fb43d95e = (0, $izlrY.decisionList)({
    parseDOM: [
        {
            tag: "ol".concat($86cd78466e83e393$export$a5393ce68c2ff601),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $2S7le.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-node-type': $86cd78466e83e393$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("5LXaH", function(module, exports) {
$parcel$export(module.exports, "doc", function () { return $433f3dc936cec482$export$2a111da947c407d2; });

var $izlrY = parcelRequire("izlrY");
var $433f3dc936cec482$export$2a111da947c407d2 = (0, $izlrY.doc)({});

});

parcelRegister("hIl0H", function(module, exports) {
$parcel$export(module.exports, "embedCard", function () { return $ce56d7f4f146848d$export$be4283d9a1cb1ff6; });

var $izlrY = parcelRequire("izlrY");
var $ce56d7f4f146848d$export$be4283d9a1cb1ff6 = (0, $izlrY.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: function getAttrs(dom) {
                return {
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, url = _node$attrs.url, layout = _node$attrs.layout, width = _node$attrs.width, originalWidth = _node$attrs.originalWidth, originalHeight = _node$attrs.originalHeight;
        var attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("32RUX", function(module, exports) {
$parcel$export(module.exports, "emoji", function () { return $237b61f39edfd93c$export$a19185d1233fc4b2; });

var $dcCtD = parcelRequire("dcCtD");

var $izlrY = parcelRequire("izlrY");
var $237b61f39edfd93c$export$a19185d1233fc4b2 = (0, $izlrY.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $237b61f39edfd93c$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $237b61f39edfd93c$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $237b61f39edfd93c$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: function getAttrs(dom) {
                return (0, $dcCtD.acNameToEmoji)(dom.getAttribute('data-emoticon-name'));
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: function getAttrs(dom) {
                return (0, $dcCtD.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'));
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $237b61f39edfd93c$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $237b61f39edfd93c$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $237b61f39edfd93c$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, shortName = _node$attrs.shortName, id = _node$attrs.id, text = _node$attrs.text;
        var attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("dcCtD", function(module, exports) {
$parcel$export(module.exports, "acNameToEmoji", function () { return $99ca3e13f618d9b7$export$f61e93bda2a8b420; });
$parcel$export(module.exports, "acShortcutToEmoji", function () { return $99ca3e13f618d9b7$export$441f8b58f5790a68; });
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
var $99ca3e13f618d9b7$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
var $99ca3e13f618d9b7$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
var $99ca3e13f618d9b7$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ var $99ca3e13f618d9b7$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        "\uD83D\uDE42"
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        "\uD83D\uDE41"
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        "\uD83D\uDE1B"
    ],
    laugh: [
        '1f600',
        ':grinning:',
        "\uD83D\uDE00"
    ],
    wink: [
        '1f609',
        ':wink:',
        "\uD83D\uDE09"
    ],
    information: [
        '2139',
        ':information_source:',
        "\u2139"
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        "\u2705"
    ],
    cross: [
        '274c',
        ':x:',
        "\u274C"
    ],
    warning: [
        '26a0',
        ':warning:',
        "\u26A0"
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        "\u2795"
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        "\u2796"
    ],
    question: [
        '2753',
        ':question:',
        "?"
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        "\uD83D\uDC4D"
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        "\uD83D\uDC4E"
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        "\uD83D\uDCA1"
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        "\uD83D\uDC9B"
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        "\uD83D\uDEAB"
    ],
    'red-star': [
        '2764',
        ':heart:',
        "\u2764\uFE0F"
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        "\uD83D\uDC9A"
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        "\uD83D\uDC99"
    ],
    heart: [
        '2764',
        ':heart:',
        "\u2764\uFE0F"
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        "\uD83D\uDC94"
    ]
};
function $99ca3e13f618d9b7$export$f61e93bda2a8b420(acName) {
    var emojiData = $99ca3e13f618d9b7$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $99ca3e13f618d9b7$var$DEFAULT_EMOJI_ID,
        shortName: ":".concat(acName, ":"),
        text: ''
    };
}
function $99ca3e13f618d9b7$export$bc94e44ec0e7bd82(emojiId) {
    var filterEmojis = function filterEmojis(acName) {
        return $99ca3e13f618d9b7$var$acNameToEmojiMap[acName] ? $99ca3e13f618d9b7$var$acNameToEmojiMap[acName][0] === emojiId : false;
    };
    return Object.keys($99ca3e13f618d9b7$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $99ca3e13f618d9b7$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: "".concat($99ca3e13f618d9b7$var$HC_EMOTICON_PREFIX).concat(hipchatEmoticonShortName),
        shortName: ":".concat(hipchatEmoticonShortName, ":"),
        text: ''
    };
}
function $99ca3e13f618d9b7$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $99ca3e13f618d9b7$export$880a2465992fbbe(_ref) {
    var id = _ref.id, shortName = _ref.shortName;
    if ($99ca3e13f618d9b7$var$DEFAULT_EMOJI_ID === id) {
        var possibleName = $99ca3e13f618d9b7$var$getAcNameFromShortName(shortName);
        if (possibleName in $99ca3e13f618d9b7$var$acNameToEmojiMap) return possibleName;
    }
    return $99ca3e13f618d9b7$export$bc94e44ec0e7bd82(id) || $99ca3e13f618d9b7$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("4sb5F", function(module, exports) {
$parcel$export(module.exports, "blockquote", function () { return $33e2614342557355$export$67dc04e652a298ca; });
$parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", function () { return $33e2614342557355$export$c4d50234112df933; });
$parcel$export(module.exports, "extendedBlockquote", function () { return $33e2614342557355$export$70a64939da3e8455; });
$parcel$export(module.exports, "blockquoteWithList", function () { return $33e2614342557355$export$9b4686c4b9672643; });
$parcel$export(module.exports, "blockquoteWithoutNonBodiedMacros", function () { return $33e2614342557355$export$32b1dde15f5fe85b; });

var $izlrY = parcelRequire("izlrY");
/**
 * @name blockquote_node
 */ var $33e2614342557355$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM: function toDOM() {
        return [
            'blockquote',
            0
        ];
    }
};
var $33e2614342557355$export$67dc04e652a298ca = (0, $izlrY.blockquoteLegacy)($33e2614342557355$var$nodeSpecOptions);
var $33e2614342557355$export$c4d50234112df933 = (0, $izlrY.blockquoteWithoutNonBodiedMacros)($33e2614342557355$var$nodeSpecOptions);
var $33e2614342557355$export$70a64939da3e8455 = (0, $izlrY.blockquote)($33e2614342557355$var$nodeSpecOptions);
var $33e2614342557355$export$9b4686c4b9672643 = (0, $izlrY.blockquoteWithoutNestedCodeblockOrMedia)({
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM: function toDOM() {
        return [
            'blockquote',
            0
        ];
    }
});
var $33e2614342557355$export$32b1dde15f5fe85b = (0, $izlrY.blockquoteWithoutNonBodiedMacros)({
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM: function toDOM() {
        return [
            'blockquote',
            0
        ];
    }
});

});

parcelRegister("4z0QB", function(module, exports) {
$parcel$export(module.exports, "PanelType", function () { return $352b1690a3b46a74$export$969277cf61e5a7aa; });
$parcel$export(module.exports, "extendedPanel", function () { return $352b1690a3b46a74$export$ce20b13564211141; });
$parcel$export(module.exports, "panelWithoutNestedNonBodiedMacros", function () { return $352b1690a3b46a74$export$220c665c23b9541b; });

var $1K2xC = parcelRequire("1K2xC");

var $izlrY = parcelRequire("izlrY");
function $352b1690a3b46a74$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $352b1690a3b46a74$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $352b1690a3b46a74$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1K2xC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $352b1690a3b46a74$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $352b1690a3b46a74$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ var $352b1690a3b46a74$var$getDomAttrs = function getDomAttrs(nodeAttrs) {
    var attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor
    };
    return attrs;
};
var $352b1690a3b46a74$var$getParseDOMAttrs = function getParseDOMAttrs(allowCustomPanel, dom) {
    var parseDOMAttrs = {
        panelType: dom.getAttribute('data-panel-type')
    };
    if (allowCustomPanel) parseDOMAttrs = $352b1690a3b46a74$var$_objectSpread($352b1690a3b46a74$var$_objectSpread({}, parseDOMAttrs), {}, {
        panelIcon: dom.getAttribute('data-panel-icon'),
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        panelColor: dom.getAttribute('data-panel-color')
    });
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $352b1690a3b46a74$export$969277cf61e5a7aa.CUSTOM ? $352b1690a3b46a74$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
var $352b1690a3b46a74$var$createPanelNodeSpecOptions = function createPanelNodeSpecOptions(allowCustomPanel) {
    return {
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: function getAttrs(dom) {
                    return $352b1690a3b46a74$var$getParseDOMAttrs(allowCustomPanel, dom);
                }
            }
        ],
        toDOM: function toDOM(node) {
            var attrs = $352b1690a3b46a74$var$getDomAttrs(node.attrs);
            var contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    };
};
var $352b1690a3b46a74$export$ce20b13564211141 = function extendedPanel(allowCustomPanel) {
    return (0, $izlrY.panel)($352b1690a3b46a74$var$createPanelNodeSpecOptions(allowCustomPanel));
};
var $352b1690a3b46a74$export$220c665c23b9541b = function panelWithoutNestedNonBodiedMacros(allowCustomPanel) {
    return (0, $izlrY.panelWithoutNestedNonBodiedMacros)($352b1690a3b46a74$var$createPanelNodeSpecOptions(allowCustomPanel));
};

});

parcelRegister("622WD", function(module, exports) {
$parcel$export(module.exports, "extension", function () { return $464536c046b3e725$export$1b45514b112dd749; });

var $2S9L4 = parcelRequire("2S9L4");

var $izlrY = parcelRequire("izlrY");
var $464536c046b3e725$export$1b45514b112dd749 = (0, $izlrY.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $2S9L4.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("kkXnq", function(module, exports) {
$parcel$export(module.exports, "hardBreak", function () { return $ece3bbe394a29ea8$export$371da9dd35aba193; });

var $izlrY = parcelRequire("izlrY");
var $ece3bbe394a29ea8$export$371da9dd35aba193 = (0, $izlrY.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM: function toDOM() {
        return [
            'br'
        ];
    }
});

});

parcelRegister("cJx4A", function(module, exports) {
$parcel$export(module.exports, "heading", function () { return $945357a0d21fb053$export$46e4a324ac90507f; });

var $izlrY = parcelRequire("izlrY");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ var $945357a0d21fb053$var$getAttrs = function getAttrs(level) {
    return function(domNode) {
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute('data-local-id') || ((_heading$attrs = $945357a0d21fb053$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
};
var $945357a0d21fb053$export$46e4a324ac90507f = (0, $izlrY.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $945357a0d21fb053$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $945357a0d21fb053$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $945357a0d21fb053$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $945357a0d21fb053$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $945357a0d21fb053$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $945357a0d21fb053$var$getAttrs(6)
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, level = _node$attrs.level, localId = _node$attrs.localId;
        var name = 'h' + level;
        var attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});

});

parcelRegister("aHG2H", function(module, exports) {
$parcel$export(module.exports, "image", function () { return $7cae88514fef8cca$export$5c452ff88e35e47d; });

var $izlrY = parcelRequire("izlrY");
var $7cae88514fef8cca$export$5c452ff88e35e47d = (0, $izlrY.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("6hyqf", function(module, exports) {
$parcel$export(module.exports, "inlineCard", function () { return $492f082669a204ac$export$cbf8224b64e0d942; });

var $izlrY = parcelRequire("izlrY");
var $492f082669a204ac$export$cbf8224b64e0d942 = (0, $izlrY.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("jcXN3", function(module, exports) {
$parcel$export(module.exports, "inlineExtension", function () { return $dfbd8469276a7999$export$16b353b2649bd8d9; });

var $2S9L4 = parcelRequire("2S9L4");

var $izlrY = parcelRequire("izlrY");
var $dfbd8469276a7999$export$16b353b2649bd8d9 = (0, $izlrY.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            getAttrs: function getAttrs(domNode) {
                return (0, $2S9L4.getExtensionAttrs)(domNode, true);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("he0Zv", function(module, exports) {
$parcel$export(module.exports, "layoutColumn", function () { return $c8a4834459f89c39$export$ab76e7c03cd6f650; });

var $izlrY = parcelRequire("izlrY");
var $c8a4834459f89c39$export$ab76e7c03cd6f650 = (0, $izlrY.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-layout-column': 'true'
        };
        var width = node.attrs.width;
        if (width) {
            attrs['style'] = "flex-basis: ".concat(width, "%");
            attrs['data-column-width'] = "".concat(width);
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        var contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});

});

parcelRegister("152tK", function(module, exports) {
$parcel$export(module.exports, "createMediaSpec", function () { return $0c982e5447f60110$export$35bdbf5bc8caa677; });
$parcel$export(module.exports, "copyPrivateAttributes", function () { return $0c982e5447f60110$export$111130fa8968d741; });
$parcel$export(module.exports, "media", function () { return $0c982e5447f60110$export$987d49ffe1b0900f; });
$parcel$export(module.exports, "toJSON", function () { return $0c982e5447f60110$export$54fd2c36b5cc6731; });

var $jIfxG = parcelRequire("jIfxG");

var $izlrY = parcelRequire("izlrY");
var $0c982e5447f60110$export$bb3fe706be61f640 = (0, $izlrY.media)({}).attrs;
var $0c982e5447f60110$export$35bdbf5bc8caa677 = function createMediaSpec(attributes) {
    var inline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var domNodeType = inline ? 'span' : 'div';
    var nodeName = inline ? 'mediaInline' : 'media';
    var parseDOM = [
        {
            tag: "".concat(domNodeType, "[data-node-type=\"").concat(nodeName, "\"]"),
            getAttrs: function getAttrs(dom) {
                var attrs = {};
                if (attributes) Object.keys(attributes).forEach(function(k) {
                    var key = $0c982e5447f60110$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                    var value = dom.getAttribute("data-".concat(key)) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                var width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                var height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    var toDOM = function toDOM(node) {
        var attrs = {
            'data-id': node.attrs.id,
            'data-node-type': "".concat(nodeName),
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: "display: inline-block; border-radius: 3px; background: ".concat((0, $jIfxG.N30), "; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);")
        };
        $0c982e5447f60110$export$111130fa8968d741(node.attrs, attrs, function(key) {
            return "data-".concat($0c982e5447f60110$export$f84fdfb973c05bd8(key.slice(2)));
        });
        return [
            "".concat(domNodeType),
            attrs
        ];
    };
    if (inline) return (0, $izlrY.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $izlrY.media)({
        parseDOM: [].concat(parseDOM, [
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: function getAttrs(dom) {
                    return {
                        type: 'external',
                        url: dom.getAttribute('src') || '',
                        alt: dom.getAttribute('alt') || ''
                    };
                }
            }
        ]),
        toDOM: toDOM
    });
};
var $0c982e5447f60110$export$987d49ffe1b0900f = $0c982e5447f60110$export$35bdbf5bc8caa677($0c982e5447f60110$export$bb3fe706be61f640, false);
var $0c982e5447f60110$export$f84fdfb973c05bd8 = function camelCaseToKebabCase(str) {
    return str.replace(/([^A-Z]+)([A-Z])/g, function(_, x, y) {
        return "".concat(x, "-").concat(y.toLowerCase());
    });
};
var $0c982e5447f60110$export$111130fa8968d741 = function copyPrivateAttributes(from, to, map) {
    if ($0c982e5447f60110$export$987d49ffe1b0900f.attrs) Object.keys($0c982e5447f60110$export$987d49ffe1b0900f.attrs).forEach(function(key) {
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ var $0c982e5447f60110$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt'
];
var $0c982e5447f60110$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt'
];
var $0c982e5447f60110$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter(function(key) {
            return !(key[0] === '_' && key[1] === '_');
        }).reduce(function(obj, key) {
            if (node.attrs.type === 'external' && $0c982e5447f60110$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($0c982e5447f60110$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});

parcelRegister("9o2P2", function(module, exports) {
$parcel$export(module.exports, "mediaGroup", function () { return $6d588b5dd2731386$export$2855e964765eac9; });

var $izlrY = parcelRequire("izlrY");
var $6d588b5dd2731386$export$2855e964765eac9 = (0, $izlrY.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM: function toDOM() {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("68vRi", function(module, exports) {
$parcel$export(module.exports, "mediaInline", function () { return $477c33e842cae1be$export$38bab695e3f720f1; });

var $152tK = parcelRequire("152tK");

var $izlrY = parcelRequire("izlrY");
var $477c33e842cae1be$export$38bab695e3f720f1 = (0, $152tK.createMediaSpec)((0, $izlrY.mediaInline)({}).attrs, true);

});

parcelRegister("BhUj1", function(module, exports) {
$parcel$export(module.exports, "mediaSingleSpec", function () { return $070158cdf21923c6$export$5a1e124099b60c6b; });
$parcel$export(module.exports, "mediaSingle", function () { return $070158cdf21923c6$export$969fe3781ca15058; });
$parcel$export(module.exports, "mediaSingleWithCaption", function () { return $070158cdf21923c6$export$d35e6c006d4abdfb; });
$parcel$export(module.exports, "mediaSingleWithWidthType", function () { return $070158cdf21923c6$export$9c58e19811ce4cf5; });
$parcel$export(module.exports, "mediaSingleFull", function () { return $070158cdf21923c6$export$7e767666f2ce108a; });
$parcel$export(module.exports, "toJSON", function () { return $070158cdf21923c6$export$54fd2c36b5cc6731; });

var $1K2xC = parcelRequire("1K2xC");

var $gw0Uq = parcelRequire("gw0Uq");

var $8CoOB = parcelRequire("8CoOB");

var $izlrY = parcelRequire("izlrY");
function $070158cdf21923c6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $070158cdf21923c6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $070158cdf21923c6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1K2xC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $070158cdf21923c6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $070158cdf21923c6$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
var $070158cdf21923c6$export$5a1e124099b60c6b = function mediaSingleSpec(_ref) {
    var _ref$withCaption = _ref.withCaption, withCaption = _ref$withCaption === void 0 ? false : _ref$withCaption, _ref$withExtendedWidt = _ref.withExtendedWidthTypes, withExtendedWidthTypes = _ref$withExtendedWidt === void 0 ? false : _ref$withExtendedWidt;
    var getAttrs = function getAttrs(dom) {
        if (!(0, $8CoOB.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        var layout = dom.getAttribute('data-layout') || 'center';
        var width = Number(dom.getAttribute('data-width')) || null;
        var widthType = dom.getAttribute('data-width-type');
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $gw0Uq.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    var getAttrsFromNode = function getAttrsFromNode(node) {
        var _node$attrs = node.attrs, layout = _node$attrs.layout, width = _node$attrs.width;
        var attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            var widthType = node.attrs.widthType;
            return $070158cdf21923c6$var$_objectSpread($070158cdf21923c6$var$_objectSpread({}, attrs), {}, {
                'data-width-type': widthType || (0, $gw0Uq.WidthType).PERCENTAGE
            });
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $izlrY.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $izlrY.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $izlrY.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $izlrY.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
var $070158cdf21923c6$export$969fe3781ca15058 = $070158cdf21923c6$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
var $070158cdf21923c6$export$d35e6c006d4abdfb = $070158cdf21923c6$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
var $070158cdf21923c6$export$9c58e19811ce4cf5 = $070158cdf21923c6$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
var $070158cdf21923c6$export$7e767666f2ce108a = $070158cdf21923c6$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
var $070158cdf21923c6$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});
parcelRegister("gw0Uq", function(module, exports) {
$parcel$export(module.exports, "WidthType", function () { return $031a53fc0e8a082d$export$4d41558722ac7eed; });
/**
 * @description The widthType attribute is used to support fixed with media single
 */ var $031a53fc0e8a082d$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("jeN3D", function(module, exports) {
$parcel$export(module.exports, "mention", function () { return $e01560edde843a04$export$db83999c14438df4; });
$parcel$export(module.exports, "toJSON", function () { return $e01560edde843a04$export$54fd2c36b5cc6731; });

var $1K2xC = parcelRequire("1K2xC");

var $2S7le = parcelRequire("2S7le");

var $izlrY = parcelRequire("izlrY");
function $e01560edde843a04$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e01560edde843a04$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e01560edde843a04$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1K2xC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e01560edde843a04$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e01560edde843a04$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
var $e01560edde843a04$export$db83999c14438df4 = (0, $izlrY.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute('data-mention-id') || $e01560edde843a04$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $e01560edde843a04$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute('data-access-level') || $e01560edde843a04$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $2S7le.uuid).generate()
                };
                var userType = dom.getAttribute('data-user-type');
                if ($e01560edde843a04$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, id = _node$attrs.id, accessLevel = _node$attrs.accessLevel, text = _node$attrs.text, userType = _node$attrs.userType, localId = _node$attrs.localId;
        var attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
var $e01560edde843a04$var$isOptional = function isOptional(key) {
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
var $e01560edde843a04$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if ($e01560edde843a04$var$isOptional(key) && !node.attrs[key]) return obj;
            return $e01560edde843a04$var$_objectSpread($e01560edde843a04$var$_objectSpread({}, obj), {}, (0, $1K2xC.default)({}, key, node.attrs[key]));
        }, {})
    };
};

});

parcelRegister("iT0sU", function(module, exports) {
$parcel$export(module.exports, "nestedExpand", function () { return $dbfdb9703e8ab1e7$export$63cadbf5f4296627; });
$parcel$export(module.exports, "nestedExpandWithoutNonBodiedMacros", function () { return $dbfdb9703e8ab1e7$export$15ebf236772fa336; });

var $izlrY = parcelRequire("izlrY");
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $dbfdb9703e8ab1e7$var$getExpandAttrs(domNode) {
    var dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
var $dbfdb9703e8ab1e7$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: $dbfdb9703e8ab1e7$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: $dbfdb9703e8ab1e7$var$getExpandAttrs
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
var $dbfdb9703e8ab1e7$var$nestedExpandWithoutNonBodiedMacrosFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: $dbfdb9703e8ab1e7$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: $dbfdb9703e8ab1e7$var$getExpandAttrs
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
var $dbfdb9703e8ab1e7$export$63cadbf5f4296627 = (0, $izlrY.nestedExpand)($dbfdb9703e8ab1e7$var$nestedExpandFactoryOptions);
var $dbfdb9703e8ab1e7$export$15ebf236772fa336 = (0, $izlrY.nestedExpandWithoutNonBodiedMacros)($dbfdb9703e8ab1e7$var$nestedExpandWithoutNonBodiedMacrosFactoryOptions);

});

parcelRegister("1kM7Y", function(module, exports) {
$parcel$export(module.exports, "orderedListSelector", function () { return $0f8cfdd145ca7f0b$export$4e7125c7ff595be5; });
$parcel$export(module.exports, "orderedList", function () { return $0f8cfdd145ca7f0b$export$a5dc81035676e7a; });
$parcel$export(module.exports, "orderedListWithOrder", function () { return $0f8cfdd145ca7f0b$export$b9ab759e8298198f; });

var $izlrY = parcelRequire("izlrY");
var $0f8cfdd145ca7f0b$export$4e7125c7ff595be5 = '.ak-ol';
var $0f8cfdd145ca7f0b$export$a5dc81035676e7a = (0, $izlrY.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $0f8cfdd145ca7f0b$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
var $0f8cfdd145ca7f0b$var$resolveStart = function resolveStart(start) {
    var num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
var $0f8cfdd145ca7f0b$export$b9ab759e8298198f = (0, $izlrY.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    var start = $0f8cfdd145ca7f0b$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var start = $0f8cfdd145ca7f0b$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.order);
        var attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $0f8cfdd145ca7f0b$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("7qWL6", function(module, exports) {
$parcel$export(module.exports, "paragraph", function () { return $56988a60ff737ecd$export$9c206ddddb32a9b; });

var $izlrY = parcelRequire("izlrY");
var $56988a60ff737ecd$export$9c206ddddb32a9b = (0, $izlrY.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: function getAttrs(domNode) {
                var _paragraph$attrs, _paragraph$attrs$loca;
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $56988a60ff737ecd$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var name = 'p';
        var attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});

});

parcelRegister("gagqt", function(module, exports) {
$parcel$export(module.exports, "placeholder", function () { return $bc4a5264c283c526$export$c7187bbd1a7a9244; });

var $izlrY = parcelRequire("izlrY");
var $bc4a5264c283c526$export$c7187bbd1a7a9244 = (0, $izlrY.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: function getAttrs(dom) {
                return {
                    text: dom.getAttribute('data-placeholder') || $bc4a5264c283c526$export$c7187bbd1a7a9244.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var text = node.attrs.text;
        var attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("gVMuH", function(module, exports) {
$parcel$export(module.exports, "rule", function () { return $c53796264cd1cdf5$export$fbeb3a3956e8a3c7; });

var $izlrY = parcelRequire("izlrY");
/**
 * @name rule_node
 */ var $c53796264cd1cdf5$var$hrDOM = [
    'hr'
];
var $c53796264cd1cdf5$export$fbeb3a3956e8a3c7 = (0, $izlrY.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM: function toDOM() {
        return $c53796264cd1cdf5$var$hrDOM;
    }
});

});

parcelRegister("63CJH", function(module, exports) {
$parcel$export(module.exports, "status", function () { return $46911211dc19fcf0$export$471f7ae5c4103ae1; });

var $2S7le = parcelRequire("2S7le");

var $izlrY = parcelRequire("izlrY");
var $46911211dc19fcf0$export$471f7ae5c4103ae1 = (0, $izlrY.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, '').trim(),
                    color: dom.getAttribute('data-color'),
                    localId: (0, $2S7le.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, text = _node$attrs.text, color = _node$attrs.color, localId = _node$attrs.localId, style = _node$attrs.style;
        var attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("cPuFg", function(module, exports) {
$parcel$export(module.exports, "taskItem", function () { return $957208cb15354856$export$6d8b0ef52e2e6390; });

var $2S7le = parcelRequire("2S7le");

var $izlrY = parcelRequire("izlrY");
var $957208cb15354856$export$6d8b0ef52e2e6390 = (0, $izlrY.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $2S7le.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("3XRVL", function(module, exports) {
$parcel$export(module.exports, "taskListSelector", function () { return $2e30b74834532d45$export$c0ec71adb7a18fb2; });
$parcel$export(module.exports, "taskList", function () { return $2e30b74834532d45$export$375b6afcc5f4d291; });

var $2S7le = parcelRequire("2S7le");

var $izlrY = parcelRequire("izlrY");
/**
 * @name taskList_node
 */ var $2e30b74834532d45$var$name = 'actionList';
var $2e30b74834532d45$export$c0ec71adb7a18fb2 = "[data-node-type=\"".concat($2e30b74834532d45$var$name, "\"]");
var $2e30b74834532d45$export$375b6afcc5f4d291 = (0, $izlrY.taskList)({
    parseDOM: [
        {
            tag: "div".concat($2e30b74834532d45$export$c0ec71adb7a18fb2),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $2S7le.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-node-type': $2e30b74834532d45$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("adjeP", function(module, exports) {
$parcel$export(module.exports, "text", function () { return $76fa0a968d511f98$export$6f093cfa640b7166; });

var $izlrY = parcelRequire("izlrY");
var $76fa0a968d511f98$export$6f093cfa640b7166 = (0, $izlrY.text)({
    toDebugString: function() {
        return 'text_node';
    }
});

});

parcelRegister("cSYOL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9619b455e7e8d931$export$2e2bcd8739ae039; });
var $9619b455e7e8d931$var$name = 'unknownBlock';
var $9619b455e7e8d931$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM: function toDOM() {
        return [
            'div',
            {
                'data-node-type': $9619b455e7e8d931$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($9619b455e7e8d931$var$name, "\"]")
        }
    ]
};

});

parcelRegister("3X5DQ", function(module, exports) {
$parcel$export(module.exports, "unsupportedBlock", function () { return $2e0b4217421f1925$export$44b79b0979d0f0f7; });

var $izlrY = parcelRequire("izlrY");
var $2e0b4217421f1925$export$44b79b0979d0f0f7 = (0, $izlrY.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("k7yHx", function(module, exports) {
$parcel$export(module.exports, "unsupportedInline", function () { return $ea5f610b909ed2f5$export$310ebe0d80122e9b; });

var $izlrY = parcelRequire("izlrY");
var $ea5f610b909ed2f5$export$310ebe0d80122e9b = (0, $izlrY.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});



parcelRegister("kjsd0", function(module, exports) {
$parcel$export(module.exports, "JSONTransformer", function () { return $ec9b76a92812d9f7$export$98cb1d9308d0944d; });

var $hiPA7 = parcelRequire("hiPA7");

var $2871N = parcelRequire("2871N");

var $85tTb = parcelRequire("85tTb");

var $6Kejc = parcelRequire("6Kejc");

var $lUar6 = parcelRequire("lUar6");

var $NCs1g = parcelRequire("NCs1g");

var $fyWnE = parcelRequire("fyWnE");
var $9IIGI = parcelRequire("9IIGI");
var $3DDez = parcelRequire("3DDez");
var $2fgwX = parcelRequire("2fgwX");
var $iq9Qk = parcelRequire("iq9Qk");
var $ePmJY = parcelRequire("ePmJY");
var $4LvHO = parcelRequire("4LvHO");
var $1H3wm = parcelRequire("1H3wm");
var $4wcds = parcelRequire("4wcds");

var $kbSWt = parcelRequire("kbSWt");

var $2r7Em = parcelRequire("2r7Em");

var $4Piq1 = parcelRequire("4Piq1");
function $ec9b76a92812d9f7$var$_toPropertyKey(t) {
    var i = $ec9b76a92812d9f7$var$_toPrimitive(t, "string");
    return "symbol" == (0, $85tTb.default)(i) ? i : i + "";
}
function $ec9b76a92812d9f7$var$_toPrimitive(t, r) {
    if ("object" != (0, $85tTb.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $85tTb.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $ec9b76a92812d9f7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ec9b76a92812d9f7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ec9b76a92812d9f7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ec9b76a92812d9f7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ec9b76a92812d9f7$export$933e6445c497ffd5 = /*#__PURE__*/ function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
    return SchemaStage;
}({});
var $ec9b76a92812d9f7$var$isType = function isType(type) {
    return function(node) {
        return node.type.name === type;
    };
};
// Create a Set of node types that should have empty attrs removed
var $ec9b76a92812d9f7$var$NODES_WITH_EMPTY_ATTRS_REMOVAL = new Set([
    'paragraph',
    'layoutSection',
    'blockquote',
    'nestedExpand',
    'bulletList',
    'listItem',
    'orderedList',
    'rule',
    'caption',
    'tableRow',
    'media',
    'mediaSingle',
    'mediaInline'
]);
var $ec9b76a92812d9f7$var$isCodeBlock = $ec9b76a92812d9f7$var$isType('codeBlock');
var $ec9b76a92812d9f7$var$isMediaNode = $ec9b76a92812d9f7$var$isType('media');
var $ec9b76a92812d9f7$var$isMediaInline = $ec9b76a92812d9f7$var$isType('mediaInline');
var $ec9b76a92812d9f7$var$isMediaSingleNode = $ec9b76a92812d9f7$var$isType('mediaSingle');
var $ec9b76a92812d9f7$var$isMentionNode = $ec9b76a92812d9f7$var$isType('mention');
var $ec9b76a92812d9f7$var$isParagraph = $ec9b76a92812d9f7$var$isType('paragraph');
var $ec9b76a92812d9f7$var$isHeading = $ec9b76a92812d9f7$var$isType('heading');
var $ec9b76a92812d9f7$var$isTable = $ec9b76a92812d9f7$var$isType('table');
var $ec9b76a92812d9f7$var$isTableCell = $ec9b76a92812d9f7$var$isType('tableCell');
var $ec9b76a92812d9f7$var$isTableHeader = $ec9b76a92812d9f7$var$isType('tableHeader');
var $ec9b76a92812d9f7$var$isLinkMark = $ec9b76a92812d9f7$var$isType('link');
var $ec9b76a92812d9f7$var$isUnsupportedMark = $ec9b76a92812d9f7$var$isType('unsupportedMark');
var $ec9b76a92812d9f7$var$isUnsupportedNodeAttributeMark = $ec9b76a92812d9f7$var$isType('unsupportedNodeAttribute');
var $ec9b76a92812d9f7$var$isExpand = $ec9b76a92812d9f7$var$isType('expand');
var $ec9b76a92812d9f7$var$isNestedExpand = $ec9b76a92812d9f7$var$isType('nestedExpand');
var $ec9b76a92812d9f7$var$isUnsupportedNode = function isUnsupportedNode(node) {
    return $ec9b76a92812d9f7$var$isType('unsupportedBlock')(node) || $ec9b76a92812d9f7$var$isType('unsupportedInline')(node);
};
var $ec9b76a92812d9f7$var$isDataConsumer = $ec9b76a92812d9f7$var$isType('dataConsumer');
var $ec9b76a92812d9f7$var$isFragmentMark = $ec9b76a92812d9f7$var$isType('fragment');
var $ec9b76a92812d9f7$var$isHardBreak = $ec9b76a92812d9f7$var$isType('hardBreak');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var $ec9b76a92812d9f7$var$_filterNull = function filterNull(subject) {
    var output = $ec9b76a92812d9f7$var$_objectSpread({}, subject);
    // eslint-disable-next-line guard-for-in
    for(var key in output){
        var current = output[key];
        if (current === null) {
            var _output = output, unusedKey = _output[key], filteredObj = (0, $6Kejc.default)(_output, [
                key
            ].map($ec9b76a92812d9f7$var$_toPropertyKey));
            output = filteredObj;
        } else if ((0, $85tTb.default)(current) === 'object' && !Array.isArray(current)) output[key] = $ec9b76a92812d9f7$var$_filterNull(current);
    }
    return output;
};
var $ec9b76a92812d9f7$var$createDocFromContent = function createDocFromContent(content) {
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
var $ec9b76a92812d9f7$var$emptyDoc = $ec9b76a92812d9f7$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
/**
 * Transforms a Prosemirror node into a JSON representation. Compared with
 * native Prosemirror JSON, this representation ensures we have valid ADF attrs.
 *
 * @param node The Prosemirror node to transform.
 * @param mentionMap A map of mention IDs to their display names.
 * @returns The JSON representation of the node.
 */ var $ec9b76a92812d9f7$export$3a858d3babd60825 = function toJSON(node, mentionMap) {
    var obj = {
        type: node.type.name
    };
    if ($ec9b76a92812d9f7$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($ec9b76a92812d9f7$var$isMediaNode(node)) obj.attrs = (0, $4LvHO.toJSON)(node).attrs;
    else if ($ec9b76a92812d9f7$var$isMediaSingleNode(node)) obj.attrs = (0, $ePmJY.toJSON)(node).attrs;
    else if ($ec9b76a92812d9f7$var$isMediaInline(node)) obj.attrs = (0, $4LvHO.toJSON)(node).attrs;
    else if ($ec9b76a92812d9f7$var$isMentionNode(node)) obj.attrs = (0, $1H3wm.toJSON)(node).attrs;
    else if ($ec9b76a92812d9f7$var$isCodeBlock(node)) obj.attrs = (0, $fyWnE.toJSON)(node).attrs;
    else if ($ec9b76a92812d9f7$var$isTable(node)) obj.attrs = (0, $4wcds.tableToJSON)(node).attrs;
    else if ($ec9b76a92812d9f7$var$isTableCell(node)) obj.attrs = (0, $4wcds.toJSONTableCell)(node).attrs;
    else if ($ec9b76a92812d9f7$var$isTableHeader(node)) obj.attrs = (0, $4wcds.toJSONTableHeader)(node).attrs;
    else if ($ec9b76a92812d9f7$var$isExpand(node) || $ec9b76a92812d9f7$var$isNestedExpand(node)) obj.attrs = (0, $3DDez.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $ec9b76a92812d9f7$var$_filterNull(obj.attrs);
    if ($ec9b76a92812d9f7$var$isMentionNode(node) && mentionMap) {
        var _text, _obj$attrs;
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        var name = !!(mentionMap !== null && mentionMap !== void 0 && mentionMap[node.attrs.id]) ? "@".concat(mentionMap[node.attrs.id]) : '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var text = (_text = (_obj$attrs = obj.attrs) === null || _obj$attrs === void 0 ? void 0 : _obj$attrs.text) !== null && _text !== void 0 ? _text : '';
        obj.attrs = $ec9b76a92812d9f7$var$_objectSpread($ec9b76a92812d9f7$var$_objectSpread({}, obj.attrs), {}, {
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        });
    }
    if ($ec9b76a92812d9f7$var$NODES_WITH_EMPTY_ATTRS_REMOVAL.has(node.type.name) && obj.attrs && !Object.keys(obj.attrs).length || $ec9b76a92812d9f7$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach(function(child) {
        obj.content = obj.content || [];
        obj.content.push($ec9b76a92812d9f7$export$3a858d3babd60825(child, mentionMap));
    });
    if ($ec9b76a92812d9f7$var$isParagraph(node) || $ec9b76a92812d9f7$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        var parsedMarks = node.marks.map(function(mark) {
            if ($ec9b76a92812d9f7$var$isUnsupportedMark(mark)) return $ec9b76a92812d9f7$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($ec9b76a92812d9f7$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($ec9b76a92812d9f7$var$isLinkMark(mark)) return (0, $iq9Qk.toJSON)(mark);
            else if ($ec9b76a92812d9f7$var$isDataConsumer(mark)) {
                var _serialised$attrs$sou;
                var serialised = (0, $9IIGI.toJSON)(mark);
                return !serialised.attrs.sources || ((_serialised$attrs$sou = serialised.attrs.sources) === null || _serialised$attrs$sou === void 0 ? void 0 : _serialised$attrs$sou.length) === 0 ? null : serialised;
            } else if ($ec9b76a92812d9f7$var$isFragmentMark(mark)) {
                var fragmentMark = (0, $2fgwX.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter(function(maybeMark) {
            return maybeMark !== null;
        });
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = (parsedMarks === null || parsedMarks === void 0 ? void 0 : parsedMarks.length) > 0 ? parsedMarks : undefined;
        var nodeAttributeMark = node.marks.find($ec9b76a92812d9f7$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = $ec9b76a92812d9f7$var$_objectSpread({}, $ec9b76a92812d9f7$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj));
    }
    return obj;
};
var $ec9b76a92812d9f7$var$canOverrideMark = function canOverrideMark(mark, existingMarks) {
    if (existingMarks.some(function(e) {
        return mark.attrs.originalValue.type === e.type.name;
    })) return (0, $2r7Em.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
var $ec9b76a92812d9f7$var$getUnwrappedNodeAttributes = function getUnwrappedNodeAttributes(node, mark, obj) {
    var nodeAttributes = node.type.spec.attrs;
    var attributes = $ec9b76a92812d9f7$var$_objectSpread($ec9b76a92812d9f7$var$_objectSpread({}, mark.attrs.unsupported), obj.attrs);
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        var attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return $ec9b76a92812d9f7$var$_objectSpread($ec9b76a92812d9f7$var$_objectSpread({}, attributes), {}, (0, $lUar6.default)({}, key, mark.attrs.unsupported[key]));
        }
    }
    return attributes;
};
var $ec9b76a92812d9f7$export$98cb1d9308d0944d = /*#__PURE__*/ function() {
    /**
   * @param schema The current editor schema
   * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
   * mention node.attr.text values with mapped names.
   */ function JSONTransformer() {
        var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $kbSWt.defaultSchema);
        var mentionMap = arguments.length > 1 ? arguments[1] : undefined;
        (0, $hiPA7.default)(this, JSONTransformer);
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
    return (0, $2871N.default)(JSONTransformer, [
        {
            key: "encode",
            value: function encode(node) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var content = [];
                node.content.forEach(function(child) {
                    content.push((0, $4Piq1.sanitizeNode)($ec9b76a92812d9f7$export$3a858d3babd60825(child, _this.mentionMap), options));
                });
                if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($NCs1g)))(content, $ec9b76a92812d9f7$var$emptyDoc.content)) return $ec9b76a92812d9f7$var$createDocFromContent([]);
                return $ec9b76a92812d9f7$var$createDocFromContent(content);
            }
        },
        {
            key: "internalParse",
            value: function internalParse(content, schema) {
                var doc = schema.nodeFromJSON(content);
                doc.check();
                return doc;
            }
        },
        {
            key: "parse",
            value: function parse(content, stage) {
                if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
                var schema = !!stage ? (0, $kbSWt.getSchemaBasedOnStage)(stage) : this.schema;
                if (!content.content || content.content.length === 0) return this.internalParse($ec9b76a92812d9f7$var$emptyDoc, schema);
                return this.internalParse(content, schema);
            }
        },
        {
            key: "encodeNode",
            value: function encodeNode(node) {
                return (0, $4Piq1.sanitizeNode)($ec9b76a92812d9f7$export$3a858d3babd60825(node, this.mentionMap));
            }
        }
    ]);
}();

});
parcelRegister("6Kejc", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4e9223591d1e1083$export$2e2bcd8739ae039; });

var $4enAD = parcelRequire("4enAD");
function $4e9223591d1e1083$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $4enAD.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});
parcelRegister("4enAD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $314ac4ad2de85031$export$2e2bcd8739ae039; });
function $314ac4ad2de85031$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});


parcelRegister("lUar6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ff26ec52ed7d8ef0$export$2e2bcd8739ae039; });

var $9ScEq = parcelRequire("9ScEq");
function $ff26ec52ed7d8ef0$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $9ScEq.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("NCs1g", function(module, exports) {

var $l80hK = parcelRequire("l80hK");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $095267455bce4d6b$var$isEqual(value, other) {
    return $l80hK(value, other);
}
module.exports = $095267455bce4d6b$var$isEqual;

});

parcelRegister("fyWnE", function(module, exports) {
$parcel$export(module.exports, "codeBlock", function () { return $b54751280e524823$export$7bb0d5c671655cc4; });
$parcel$export(module.exports, "toJSON", function () { return $b54751280e524823$export$54fd2c36b5cc6731; });

var $lS2Ah = parcelRequire("lS2Ah");

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
/**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_node
 */ var $b54751280e524823$var$getLanguageFromEditorStyle = function getLanguageFromEditorStyle(dom) {
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
var $b54751280e524823$var$getLanguageFromBitbucketStyle = function getLanguageFromBitbucketStyle(dom) {
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $b54751280e524823$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
var $b54751280e524823$var$getLanguageFromCode = function getLanguageFromCode(dom) {
    var firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
var $b54751280e524823$var$extractLanguageFromClass = function extractLanguageFromClass(className) {
    var languageRegex = /(?:^|\s)language-([^\s]+)/;
    var result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
var $b54751280e524823$var$removeLastNewLine = function removeLastNewLine(dom) {
    var parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
    return dom;
};
function $b54751280e524823$var$parseCodeFromHtml(node) {
    var code = '';
    node.childNodes.forEach(function(child) {
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            var tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $b54751280e524823$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
var $b54751280e524823$export$7bb0d5c671655cc4 = (0, $kBUhU.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var language = $b54751280e524823$var$getLanguageFromBitbucketStyle(dom.parentElement) || $b54751280e524823$var$getLanguageFromEditorStyle(dom.parentElement) || $b54751280e524823$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $b54751280e524823$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: function getContent(domNode, schema) {
                var code = $b54751280e524823$var$parseCodeFromHtml(domNode);
                return code ? (0, $lS2Ah.Fragment).from(schema.text(code)) : (0, $lS2Ah.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(dom) {
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                var lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach(function(line) {
                    return line.remove();
                });
                return {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
var $b54751280e524823$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(memo, key) {
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    };
};
var $b54751280e524823$export$3f75de798a0b5356 = (0, $kBUhU.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var language = $b54751280e524823$var$getLanguageFromBitbucketStyle(dom.parentElement) || $b54751280e524823$var$getLanguageFromEditorStyle(dom.parentElement) || $b54751280e524823$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $b54751280e524823$var$removeLastNewLine(dom);
                return {
                    language: language,
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: function getContent(domNode, schema) {
                var code = $b54751280e524823$var$parseCodeFromHtml(domNode);
                return code ? (0, $lS2Ah.Fragment).from(schema.text(code)) : (0, $lS2Ah.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(dom) {
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                var lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach(function(line) {
                    return line.remove();
                });
                return {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});

});
parcelRegister("lS2Ah", function(module, exports) {
$parcel$export(module.exports, "Fragment", function () { return $fec0a54c21849cfb$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Schema", function () { return $fec0a54c21849cfb$export$19342e026b58ebb7; });

var $l0GWs = parcelRequire("l0GWs");
function $fec0a54c21849cfb$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $fec0a54c21849cfb$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $fec0a54c21849cfb$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $fec0a54c21849cfb$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $fec0a54c21849cfb$export$ffb0004e005737fa {
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $fec0a54c21849cfb$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $fec0a54c21849cfb$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $fec0a54c21849cfb$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $fec0a54c21849cfb$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $fec0a54c21849cfb$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $fec0a54c21849cfb$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $fec0a54c21849cfb$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $fec0a54c21849cfb$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $fec0a54c21849cfb$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $fec0a54c21849cfb$var$retIndex(0, pos);
        if (pos == this.size) return $fec0a54c21849cfb$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $fec0a54c21849cfb$var$retIndex(i + 1, end);
                return $fec0a54c21849cfb$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $fec0a54c21849cfb$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $fec0a54c21849cfb$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $fec0a54c21849cfb$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $fec0a54c21849cfb$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $fec0a54c21849cfb$export$ffb0004e005737fa.empty;
        if (nodes instanceof $fec0a54c21849cfb$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $fec0a54c21849cfb$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $fec0a54c21849cfb$export$ffb0004e005737fa.empty = new $fec0a54c21849cfb$export$ffb0004e005737fa([], 0);
const $fec0a54c21849cfb$var$found = {
    index: 0,
    offset: 0
};
function $fec0a54c21849cfb$var$retIndex(index, offset) {
    $fec0a54c21849cfb$var$found.index = index;
    $fec0a54c21849cfb$var$found.offset = offset;
    return $fec0a54c21849cfb$var$found;
}
function $fec0a54c21849cfb$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$fec0a54c21849cfb$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$fec0a54c21849cfb$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $fec0a54c21849cfb$export$c9d15bcfc6d42044 {
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $fec0a54c21849cfb$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $fec0a54c21849cfb$export$c9d15bcfc6d42044.none;
        if (marks instanceof $fec0a54c21849cfb$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
}
/**
The empty set of marks.
*/ $fec0a54c21849cfb$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $fec0a54c21849cfb$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $fec0a54c21849cfb$export$b3f2e2de3a8baa1e {
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $fec0a54c21849cfb$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $fec0a54c21849cfb$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $fec0a54c21849cfb$export$b3f2e2de3a8baa1e($fec0a54c21849cfb$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $fec0a54c21849cfb$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $fec0a54c21849cfb$export$b3f2e2de3a8baa1e($fec0a54c21849cfb$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $fec0a54c21849cfb$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
}
/**
The empty slice.
*/ $fec0a54c21849cfb$export$b3f2e2de3a8baa1e.empty = new $fec0a54c21849cfb$export$b3f2e2de3a8baa1e($fec0a54c21849cfb$export$ffb0004e005737fa.empty, 0, 0);
function $fec0a54c21849cfb$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($fec0a54c21849cfb$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $fec0a54c21849cfb$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $fec0a54c21849cfb$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $fec0a54c21849cfb$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $fec0a54c21849cfb$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $fec0a54c21849cfb$export$6de0e778727af3f2("Inconsistent open depths");
    return $fec0a54c21849cfb$var$replaceOuter($from, $to, slice, 0);
}
function $fec0a54c21849cfb$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $fec0a54c21849cfb$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $fec0a54c21849cfb$var$close(node, $fec0a54c21849cfb$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $fec0a54c21849cfb$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $fec0a54c21849cfb$var$prepareSliceForReplace(slice, $from);
        return $fec0a54c21849cfb$var$close(node, $fec0a54c21849cfb$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $fec0a54c21849cfb$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $fec0a54c21849cfb$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $fec0a54c21849cfb$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $fec0a54c21849cfb$var$checkJoin(node, $after.node(depth));
    return node;
}
function $fec0a54c21849cfb$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $fec0a54c21849cfb$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $fec0a54c21849cfb$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$fec0a54c21849cfb$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $fec0a54c21849cfb$var$addNode($end.nodeBefore, target);
}
function $fec0a54c21849cfb$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $fec0a54c21849cfb$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $fec0a54c21849cfb$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $fec0a54c21849cfb$var$joinable($end, $to, depth + 1);
    let content = [];
    $fec0a54c21849cfb$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $fec0a54c21849cfb$var$checkJoin(openStart, openEnd);
        $fec0a54c21849cfb$var$addNode($fec0a54c21849cfb$var$close(openStart, $fec0a54c21849cfb$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $fec0a54c21849cfb$var$addNode($fec0a54c21849cfb$var$close(openStart, $fec0a54c21849cfb$var$replaceTwoWay($from, $start, depth + 1)), content);
        $fec0a54c21849cfb$var$addRange($start, $end, depth, content);
        if (openEnd) $fec0a54c21849cfb$var$addNode($fec0a54c21849cfb$var$close(openEnd, $fec0a54c21849cfb$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $fec0a54c21849cfb$var$addRange($to, null, depth, content);
    return new $fec0a54c21849cfb$export$ffb0004e005737fa(content);
}
function $fec0a54c21849cfb$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $fec0a54c21849cfb$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $fec0a54c21849cfb$var$joinable($from, $to, depth + 1);
        $fec0a54c21849cfb$var$addNode($fec0a54c21849cfb$var$close(type, $fec0a54c21849cfb$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $fec0a54c21849cfb$var$addRange($to, null, depth, content);
    return new $fec0a54c21849cfb$export$ffb0004e005737fa(content);
}
function $fec0a54c21849cfb$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($fec0a54c21849cfb$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $fec0a54c21849cfb$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $fec0a54c21849cfb$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $fec0a54c21849cfb$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $fec0a54c21849cfb$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $fec0a54c21849cfb$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $fec0a54c21849cfb$var$resolveCache.set(doc, cache = new $fec0a54c21849cfb$var$ResolveCache);
        let result = cache.elts[cache.i] = $fec0a54c21849cfb$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $fec0a54c21849cfb$var$resolveCacheSize;
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
}
class $fec0a54c21849cfb$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $fec0a54c21849cfb$var$resolveCacheSize = 12, $fec0a54c21849cfb$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $fec0a54c21849cfb$export$7bc461ceb770fb16 {
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
}
const $fec0a54c21849cfb$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $fec0a54c21849cfb$export$85c928794f8d04d4 {
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $fec0a54c21849cfb$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $fec0a54c21849cfb$var$emptyAttrs) && $fec0a54c21849cfb$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $fec0a54c21849cfb$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $fec0a54c21849cfb$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $fec0a54c21849cfb$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $fec0a54c21849cfb$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $fec0a54c21849cfb$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $fec0a54c21849cfb$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $fec0a54c21849cfb$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $fec0a54c21849cfb$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $fec0a54c21849cfb$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $fec0a54c21849cfb$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $fec0a54c21849cfb$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$fec0a54c21849cfb$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $fec0a54c21849cfb$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $fec0a54c21849cfb$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $fec0a54c21849cfb$export$ffb0004e005737fa.empty;
    }
}
$fec0a54c21849cfb$export$85c928794f8d04d4.prototype.text = undefined;
class $fec0a54c21849cfb$var$TextNode extends $fec0a54c21849cfb$export$85c928794f8d04d4 {
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $fec0a54c21849cfb$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $fec0a54c21849cfb$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $fec0a54c21849cfb$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
}
function $fec0a54c21849cfb$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $fec0a54c21849cfb$export$364ed450558d7ec4 {
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $fec0a54c21849cfb$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $fec0a54c21849cfb$export$364ed450558d7ec4.empty;
        let expr = $fec0a54c21849cfb$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $fec0a54c21849cfb$var$dfa($fec0a54c21849cfb$var$nfa(expr));
        $fec0a54c21849cfb$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $fec0a54c21849cfb$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
}
/**
@internal
*/ $fec0a54c21849cfb$export$364ed450558d7ec4.empty = new $fec0a54c21849cfb$export$364ed450558d7ec4(true);
class $fec0a54c21849cfb$var$TokenStream {
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
}
function $fec0a54c21849cfb$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($fec0a54c21849cfb$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $fec0a54c21849cfb$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($fec0a54c21849cfb$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $fec0a54c21849cfb$var$parseExprSubscript(stream) {
    let expr = $fec0a54c21849cfb$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $fec0a54c21849cfb$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $fec0a54c21849cfb$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $fec0a54c21849cfb$var$parseExprRange(stream, expr) {
    let min = $fec0a54c21849cfb$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $fec0a54c21849cfb$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $fec0a54c21849cfb$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $fec0a54c21849cfb$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $fec0a54c21849cfb$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $fec0a54c21849cfb$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $fec0a54c21849cfb$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $fec0a54c21849cfb$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $fec0a54c21849cfb$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($fec0a54c21849cfb$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $fec0a54c21849cfb$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($fec0a54c21849cfb$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $fec0a54c21849cfb$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $fec0a54c21849cfb$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($fec0a54c21849cfb$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $fec0a54c21849cfb$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $fec0a54c21849cfb$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $fec0a54c21849cfb$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $fec0a54c21849cfb$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $fec0a54c21849cfb$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $fec0a54c21849cfb$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $fec0a54c21849cfb$export$f06e977173f1857c {
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $fec0a54c21849cfb$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $fec0a54c21849cfb$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $fec0a54c21849cfb$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $fec0a54c21849cfb$export$ffb0004e005737fa.from(content), $fec0a54c21849cfb$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $fec0a54c21849cfb$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $fec0a54c21849cfb$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $fec0a54c21849cfb$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $fec0a54c21849cfb$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($fec0a54c21849cfb$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $fec0a54c21849cfb$export$85c928794f8d04d4(this, attrs, content.append(after), $fec0a54c21849cfb$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $fec0a54c21849cfb$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $fec0a54c21849cfb$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $fec0a54c21849cfb$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $fec0a54c21849cfb$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $fec0a54c21849cfb$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
}
function $fec0a54c21849cfb$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $fec0a54c21849cfb$var$Attribute {
    get isRequired() {
        return !this.hasDefault;
    }
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $fec0a54c21849cfb$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $fec0a54c21849cfb$export$b6a78689043c6521 {
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $fec0a54c21849cfb$export$c9d15bcfc6d42044(this, $fec0a54c21849cfb$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $fec0a54c21849cfb$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $fec0a54c21849cfb$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $fec0a54c21849cfb$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $fec0a54c21849cfb$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $fec0a54c21849cfb$export$c9d15bcfc6d42044(this, defaults) : null;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $fec0a54c21849cfb$export$19342e026b58ebb7 {
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $fec0a54c21849cfb$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $fec0a54c21849cfb$var$TextNode(type, type.defaultAttrs, text, $fec0a54c21849cfb$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $fec0a54c21849cfb$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $fec0a54c21849cfb$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $l0GWs.default).from(spec.nodes), instanceSpec.marks = (0, $l0GWs.default).from(spec.marks || {}), this.nodes = $fec0a54c21849cfb$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $fec0a54c21849cfb$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $fec0a54c21849cfb$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $fec0a54c21849cfb$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $fec0a54c21849cfb$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
}
function $fec0a54c21849cfb$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $fec0a54c21849cfb$var$isTagRule(rule) {
    return rule.tag != null;
}
function $fec0a54c21849cfb$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $fec0a54c21849cfb$export$1059c6e7d2ce5669 {
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $fec0a54c21849cfb$var$ParseContext(this, options, false);
        context.addAll(dom, $fec0a54c21849cfb$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $fec0a54c21849cfb$var$ParseContext(this, options, true);
        context.addAll(dom, $fec0a54c21849cfb$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $fec0a54c21849cfb$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($fec0a54c21849cfb$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $fec0a54c21849cfb$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $fec0a54c21849cfb$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $fec0a54c21849cfb$export$1059c6e7d2ce5669(schema, $fec0a54c21849cfb$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($fec0a54c21849cfb$var$isTagRule(rule)) this.tags.push(rule);
            else if ($fec0a54c21849cfb$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
}
const $fec0a54c21849cfb$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $fec0a54c21849cfb$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $fec0a54c21849cfb$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $fec0a54c21849cfb$var$OPT_PRESERVE_WS = 1, $fec0a54c21849cfb$var$OPT_PRESERVE_WS_FULL = 2, $fec0a54c21849cfb$var$OPT_OPEN_LEFT = 4;
function $fec0a54c21849cfb$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $fec0a54c21849cfb$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $fec0a54c21849cfb$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $fec0a54c21849cfb$var$OPT_PRESERVE_WS | $fec0a54c21849cfb$var$OPT_PRESERVE_WS_FULL : base & ~$fec0a54c21849cfb$var$OPT_OPEN_LEFT;
}
class $fec0a54c21849cfb$var$NodeContext {
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($fec0a54c21849cfb$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $fec0a54c21849cfb$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $fec0a54c21849cfb$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($fec0a54c21849cfb$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$fec0a54c21849cfb$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $fec0a54c21849cfb$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $fec0a54c21849cfb$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
}
class $fec0a54c21849cfb$var$ParseContext {
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $fec0a54c21849cfb$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $fec0a54c21849cfb$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($fec0a54c21849cfb$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $fec0a54c21849cfb$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $fec0a54c21849cfb$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($fec0a54c21849cfb$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $fec0a54c21849cfb$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $fec0a54c21849cfb$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $fec0a54c21849cfb$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $fec0a54c21849cfb$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $fec0a54c21849cfb$var$OPT_OPEN_LEFT;
        let applyMarks = $fec0a54c21849cfb$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $fec0a54c21849cfb$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $fec0a54c21849cfb$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $fec0a54c21849cfb$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $fec0a54c21849cfb$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $fec0a54c21849cfb$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $fec0a54c21849cfb$var$NodeContext(topNode.type, topNode.attrs, $fec0a54c21849cfb$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $fec0a54c21849cfb$var$NodeContext(null, null, $fec0a54c21849cfb$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $fec0a54c21849cfb$var$NodeContext(parser.schema.topNodeType, null, $fec0a54c21849cfb$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $fec0a54c21849cfb$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $fec0a54c21849cfb$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $fec0a54c21849cfb$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $fec0a54c21849cfb$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $fec0a54c21849cfb$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $fec0a54c21849cfb$export$3476b78f8f5a8b72 {
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $fec0a54c21849cfb$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $fec0a54c21849cfb$var$renderSpec($fec0a54c21849cfb$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $fec0a54c21849cfb$var$renderSpec($fec0a54c21849cfb$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $fec0a54c21849cfb$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $fec0a54c21849cfb$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $fec0a54c21849cfb$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $fec0a54c21849cfb$var$gatherToDOM(schema.marks);
    }
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
}
function $fec0a54c21849cfb$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $fec0a54c21849cfb$var$doc(options) {
    return options.document || window.document;
}
const $fec0a54c21849cfb$var$suspiciousAttributeCache = new WeakMap();
function $fec0a54c21849cfb$var$suspiciousAttributes(attrs) {
    let value = $fec0a54c21849cfb$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $fec0a54c21849cfb$var$suspiciousAttributeCache.set(attrs, value = $fec0a54c21849cfb$var$suspiciousAttributesInner(attrs));
    return value;
}
function $fec0a54c21849cfb$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $fec0a54c21849cfb$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $fec0a54c21849cfb$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $fec0a54c21849cfb$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});

parcelRegister("kBUhU", function(module, exports) {
$parcel$export(module.exports, "blockCard", function () { return $f012ecf75ebad503$export$c4c2f833baaebdb8; });
$parcel$export(module.exports, "blockquote", function () { return $f012ecf75ebad503$export$67dc04e652a298ca; });
$parcel$export(module.exports, "blockquoteLegacy", function () { return $f012ecf75ebad503$export$199922e5af8e9a6; });
$parcel$export(module.exports, "blockTaskItem", function () { return $f012ecf75ebad503$export$16018c61064a18df; });
$parcel$export(module.exports, "bodiedExtension", function () { return $f012ecf75ebad503$export$27903d543b563e39; });
$parcel$export(module.exports, "bulletList", function () { return $f012ecf75ebad503$export$a140c94e5ea26bee; });
$parcel$export(module.exports, "caption", function () { return $f012ecf75ebad503$export$8e3c2dfdc4f0453d; });
$parcel$export(module.exports, "codeBlock", function () { return $f012ecf75ebad503$export$7bb0d5c671655cc4; });
$parcel$export(module.exports, "confluenceJiraIssue", function () { return $f012ecf75ebad503$export$daf889beb5092f95; });
$parcel$export(module.exports, "confluenceUnsupportedBlock", function () { return $f012ecf75ebad503$export$e6e4878f43c27cab; });
$parcel$export(module.exports, "confluenceUnsupportedInline", function () { return $f012ecf75ebad503$export$3e6d667072febc87; });
$parcel$export(module.exports, "date", function () { return $f012ecf75ebad503$export$324d90190a8b822a; });
$parcel$export(module.exports, "decisionItem", function () { return $f012ecf75ebad503$export$6959e16eeff859b4; });
$parcel$export(module.exports, "decisionList", function () { return $f012ecf75ebad503$export$62d45a65fb43d95e; });
$parcel$export(module.exports, "doc", function () { return $f012ecf75ebad503$export$2a111da947c407d2; });
$parcel$export(module.exports, "embedCard", function () { return $f012ecf75ebad503$export$be4283d9a1cb1ff6; });
$parcel$export(module.exports, "emoji", function () { return $f012ecf75ebad503$export$a19185d1233fc4b2; });
$parcel$export(module.exports, "expand", function () { return $f012ecf75ebad503$export$9f77e0932fb78f72; });
$parcel$export(module.exports, "extension", function () { return $f012ecf75ebad503$export$1b45514b112dd749; });
$parcel$export(module.exports, "extensionFrameStage0", function () { return $f012ecf75ebad503$export$b555be60c7703afb; });
$parcel$export(module.exports, "hardBreak", function () { return $f012ecf75ebad503$export$371da9dd35aba193; });
$parcel$export(module.exports, "heading", function () { return $f012ecf75ebad503$export$46e4a324ac90507f; });
$parcel$export(module.exports, "image", function () { return $f012ecf75ebad503$export$5c452ff88e35e47d; });
$parcel$export(module.exports, "inlineCard", function () { return $f012ecf75ebad503$export$cbf8224b64e0d942; });
$parcel$export(module.exports, "inlineExtensionWithMarks", function () { return $f012ecf75ebad503$export$b3b1e36c2105006d; });
$parcel$export(module.exports, "layoutColumn", function () { return $f012ecf75ebad503$export$ab76e7c03cd6f650; });
$parcel$export(module.exports, "layoutSection", function () { return $f012ecf75ebad503$export$b3b6a70a7fa4a5be; });
$parcel$export(module.exports, "layoutSectionFull", function () { return $f012ecf75ebad503$export$cdae19acb0a520fd; });
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", function () { return $f012ecf75ebad503$export$206007566ca0aca5; });
$parcel$export(module.exports, "listItem", function () { return $f012ecf75ebad503$export$76c7e83ecc9cdf05; });
$parcel$export(module.exports, "listItemWithNestedDecisionStage0", function () { return $f012ecf75ebad503$export$df876f0305235056; });
$parcel$export(module.exports, "media", function () { return $f012ecf75ebad503$export$987d49ffe1b0900f; });
$parcel$export(module.exports, "mediaGroup", function () { return $f012ecf75ebad503$export$2855e964765eac9; });
$parcel$export(module.exports, "mediaInline", function () { return $f012ecf75ebad503$export$38bab695e3f720f1; });
$parcel$export(module.exports, "mediaSingle", function () { return $f012ecf75ebad503$export$969fe3781ca15058; });
$parcel$export(module.exports, "mediaSingleCaption", function () { return $f012ecf75ebad503$export$8d067f22dc2d1254; });
$parcel$export(module.exports, "mediaSingleFull", function () { return $f012ecf75ebad503$export$7e767666f2ce108a; });
$parcel$export(module.exports, "mediaSingleWidthType", function () { return $f012ecf75ebad503$export$4bd9a38995f6bf50; });
$parcel$export(module.exports, "mention", function () { return $f012ecf75ebad503$export$db83999c14438df4; });
$parcel$export(module.exports, "multiBodiedExtensionStage0", function () { return $f012ecf75ebad503$export$750e45819f66d9d0; });
$parcel$export(module.exports, "nestedExpand", function () { return $f012ecf75ebad503$export$63cadbf5f4296627; });
$parcel$export(module.exports, "orderedList", function () { return $f012ecf75ebad503$export$a5dc81035676e7a; });
$parcel$export(module.exports, "panel", function () { return $f012ecf75ebad503$export$21f42ab9b6679f44; });
$parcel$export(module.exports, "paragraph", function () { return $f012ecf75ebad503$export$9c206ddddb32a9b; });
$parcel$export(module.exports, "placeholder", function () { return $f012ecf75ebad503$export$c7187bbd1a7a9244; });
$parcel$export(module.exports, "rule", function () { return $f012ecf75ebad503$export$fbeb3a3956e8a3c7; });
$parcel$export(module.exports, "status", function () { return $f012ecf75ebad503$export$471f7ae5c4103ae1; });
$parcel$export(module.exports, "syncBlockStage0", function () { return $f012ecf75ebad503$export$3782866d5d058412; });
$parcel$export(module.exports, "table", function () { return $f012ecf75ebad503$export$9852986a3ec5f6a0; });
$parcel$export(module.exports, "tableWithNestedTable", function () { return $f012ecf75ebad503$export$ce086a560a1d05f5; });
$parcel$export(module.exports, "tableCell", function () { return $f012ecf75ebad503$export$e1e720e5f4603e6a; });
$parcel$export(module.exports, "tableCellWithNestedTable", function () { return $f012ecf75ebad503$export$abf39ca178940ff3; });
$parcel$export(module.exports, "tableHeader", function () { return $f012ecf75ebad503$export$48884d2a5190dc73; });
$parcel$export(module.exports, "tableHeaderWithNestedTable", function () { return $f012ecf75ebad503$export$2a5a518232fa1a97; });
$parcel$export(module.exports, "tableRow", function () { return $f012ecf75ebad503$export$ce666bf02318c957; });
$parcel$export(module.exports, "tableRowWithNestedTable", function () { return $f012ecf75ebad503$export$7d657479499397; });
$parcel$export(module.exports, "taskItem", function () { return $f012ecf75ebad503$export$6d8b0ef52e2e6390; });
$parcel$export(module.exports, "taskList", function () { return $f012ecf75ebad503$export$375b6afcc5f4d291; });
$parcel$export(module.exports, "text", function () { return $f012ecf75ebad503$export$6f093cfa640b7166; });
$parcel$export(module.exports, "unsupportedBlock", function () { return $f012ecf75ebad503$export$44b79b0979d0f0f7; });
$parcel$export(module.exports, "unsupportedInline", function () { return $f012ecf75ebad503$export$310ebe0d80122e9b; });
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $5OqWX = parcelRequire("5OqWX");
var $f012ecf75ebad503$export$c4c2f833baaebdb8 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        },
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $f012ecf75ebad503$export$67dc04e652a298ca = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
var $f012ecf75ebad503$export$199922e5af8e9a6 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
var $f012ecf75ebad503$export$16018c61064a18df = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | extension) (paragraph | extension)*',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
var $f012ecf75ebad503$export$27903d543b563e39 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $f012ecf75ebad503$export$e7320d153c538837 = (0, $5OqWX.createPMNodeSpecFactory)({
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $f012ecf75ebad503$export$a140c94e5ea26bee = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $f012ecf75ebad503$export$8e3c2dfdc4f0453d = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
var $f012ecf75ebad503$export$7bb0d5c671655cc4 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        }
    },
    code: true,
    defining: true
});
var $f012ecf75ebad503$export$e4f1c66d84049f8b = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        }
    },
    code: true,
    defining: true
});
var $f012ecf75ebad503$export$daf889beb5092f95 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
var $f012ecf75ebad503$export$e6e4878f43c27cab = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $f012ecf75ebad503$export$3e6d667072febc87 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $f012ecf75ebad503$export$324d90190a8b822a = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$47988d68fe575725 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$6959e16eeff859b4 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
var $f012ecf75ebad503$export$62d45a65fb43d95e = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
var $f012ecf75ebad503$export$2a111da947c407d2 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(block | codeBlock | layoutSection | blockRootOnly | expand | syncBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout'
});
var $f012ecf75ebad503$export$be4283d9a1cb1ff6 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$a19185d1233fc4b2 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$f5574b5d45fc2112 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$9f77e0932fb78f72 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $f012ecf75ebad503$export$7e3788972005cc72 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $f012ecf75ebad503$export$1b45514b112dd749 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$a8baf338431a691 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$b555be60c7703afb = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
var $f012ecf75ebad503$export$371da9dd35aba193 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    linebreakReplacement: true
});
var $f012ecf75ebad503$export$46e4a324ac90507f = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $f012ecf75ebad503$export$1b0c1557b234fa00 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $f012ecf75ebad503$export$85461f751c457cc2 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $f012ecf75ebad503$export$2b380a0f7e250af1 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $f012ecf75ebad503$export$5c452ff88e35e47d = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
var $f012ecf75ebad503$export$cbf8224b64e0d942 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $f012ecf75ebad503$export$2f4e72b9459914ad = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $f012ecf75ebad503$export$16b353b2649bd8d9 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$b3b1e36c2105006d = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$ab76e7c03cd6f650 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
var $f012ecf75ebad503$export$b3b6a70a7fa4a5be = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
var $f012ecf75ebad503$export$cdae19acb0a520fd = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
var $f012ecf75ebad503$export$206007566ca0aca5 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        },
        localId: {
            default: null
        }
    },
    isolating: true
});
var $f012ecf75ebad503$export$76c7e83ecc9cdf05 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)*',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $f012ecf75ebad503$export$df876f0305235056 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension)*',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $f012ecf75ebad503$export$987d49ffe1b0900f = (0, $5OqWX.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$2855e964765eac9 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
var $f012ecf75ebad503$export$38bab695e3f720f1 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$969fe3781ca15058 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
var $f012ecf75ebad503$export$8d067f22dc2d1254 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$7e767666f2ce108a = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$4bd9a38995f6bf50 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$db83999c14438df4 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$46f790bd65f760d0 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$750e45819f66d9d0 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
var $f012ecf75ebad503$export$63cadbf5f4296627 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $f012ecf75ebad503$export$f03786aa6312d1e4 = (0, $5OqWX.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $f012ecf75ebad503$export$a5dc81035676e7a = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
var $f012ecf75ebad503$export$21f42ab9b6679f44 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$9c206ddddb32a9b = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $f012ecf75ebad503$export$4f98472e6dc14293 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $f012ecf75ebad503$export$ea332b61641b0588 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $f012ecf75ebad503$export$a1f41dc4901771f8 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $f012ecf75ebad503$export$c7187bbd1a7a9244 = (0, $5OqWX.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
var $f012ecf75ebad503$export$fbeb3a3956e8a3c7 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    }
});
var $f012ecf75ebad503$export$471f7ae5c4103ae1 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$b6ce52be8d7a261 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$3782866d5d058412 = (0, $5OqWX.createPMNodeSpecFactory)({
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$9852986a3ec5f6a0 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
var $f012ecf75ebad503$export$ce086a560a1d05f5 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
var $f012ecf75ebad503$export$e1e720e5f4603e6a = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
var $f012ecf75ebad503$export$abf39ca178940ff3 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
var $f012ecf75ebad503$export$48884d2a5190dc73 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
var $f012ecf75ebad503$export$2a5a518232fa1a97 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
var $f012ecf75ebad503$export$ce666bf02318c957 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
var $f012ecf75ebad503$export$7d657479499397 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
var $f012ecf75ebad503$export$6d8b0ef52e2e6390 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
var $f012ecf75ebad503$export$375b6afcc5f4d291 = (0, $5OqWX.createPMNodeSpecFactory)({
    content: '(taskItem | unsupportedBlock | blockTaskItem)+ (taskItem | taskList | unsupportedBlock | blockTaskItem)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
var $f012ecf75ebad503$export$6f093cfa640b7166 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline'
});
var $f012ecf75ebad503$export$5ea06bc686c59dc2 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline'
});
var $f012ecf75ebad503$export$93256a4c17b33a82 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline'
});
var $f012ecf75ebad503$export$a12828d0f14a2762 = (0, $5OqWX.createPMNodeSpecFactory)({});
var $f012ecf75ebad503$export$44b79b0979d0f0f7 = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
var $f012ecf75ebad503$export$310ebe0d80122e9b = (0, $5OqWX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("5OqWX", function(module, exports) {
$parcel$export(module.exports, "createPMNodeSpecFactory", function () { return $43b686f475d0f954$export$bf0a80f00e2b8ff6; });
$parcel$export(module.exports, "createPMMarkSpecFactory", function () { return $43b686f475d0f954$export$cf5823ed4e9f4c6f; });

var $fmkKe = parcelRequire("fmkKe");
function $43b686f475d0f954$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $43b686f475d0f954$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $43b686f475d0f954$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fmkKe.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $43b686f475d0f954$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $43b686f475d0f954$export$bf0a80f00e2b8ff6 = function createPMNodeSpecFactory(nodeSpec) {
    return function(_ref) {
        var parseDOM = _ref.parseDOM, toDOM = _ref.toDOM, toDebugString = _ref.toDebugString;
        return $43b686f475d0f954$var$_objectSpread($43b686f475d0f954$var$_objectSpread($43b686f475d0f954$var$_objectSpread($43b686f475d0f954$var$_objectSpread({}, nodeSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};
var $43b686f475d0f954$export$cf5823ed4e9f4c6f = function createPMMarkSpecFactory(markSpec) {
    return function(_ref2) {
        var parseDOM = _ref2.parseDOM, toDOM = _ref2.toDOM, toDebugString = _ref2.toDebugString;
        return $43b686f475d0f954$var$_objectSpread($43b686f475d0f954$var$_objectSpread($43b686f475d0f954$var$_objectSpread($43b686f475d0f954$var$_objectSpread({}, markSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};

});
parcelRegister("fmkKe", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b2e90091bed06ee4$export$2e2bcd8739ae039; });

var $6CnMq = parcelRequire("6CnMq");
function $b2e90091bed06ee4$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $6CnMq.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("6CnMq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4d18bcee6cb84420$export$2e2bcd8739ae039; });

var $lezAs = parcelRequire("lezAs");

var $gzsB0 = parcelRequire("gzsB0");
function $4d18bcee6cb84420$export$2e2bcd8739ae039(t) {
    var i = (0, $gzsB0.default)(t, "string");
    return "symbol" == (0, $lezAs.default)(i) ? i : i + "";
}

});
parcelRegister("lezAs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f75682a195f6e02e$export$2e2bcd8739ae039; });
function $f75682a195f6e02e$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $f75682a195f6e02e$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f75682a195f6e02e$export$2e2bcd8739ae039(o);
}

});

parcelRegister("gzsB0", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c10618c465ef494f$export$2e2bcd8739ae039; });

var $lezAs = parcelRequire("lezAs");
function $c10618c465ef494f$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $lezAs.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $lezAs.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("6BQ2f", function(module, exports) {
$parcel$export(module.exports, "uuid", function () { return $4cfe8fe52a28aa8c$export$31b40729666a4ae0; });
/* eslint-disable no-bitwise */ var $4cfe8fe52a28aa8c$export$1c3aefb711c3a4cc = function generateUuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
/* eslint-enable no-bitwise */ var $4cfe8fe52a28aa8c$var$staticValue = false;
var $4cfe8fe52a28aa8c$export$31b40729666a4ae0 = {
    setStatic: function setStatic(value) {
        $4cfe8fe52a28aa8c$var$staticValue = value;
    },
    generate: function generate() {
        return $4cfe8fe52a28aa8c$var$staticValue || $4cfe8fe52a28aa8c$export$1c3aefb711c3a4cc();
    }
};

});


parcelRegister("9IIGI", function(module, exports) {
$parcel$export(module.exports, "dataConsumer", function () { return $713ae338c10ff4b6$export$3024f02c495408d6; });
$parcel$export(module.exports, "toJSON", function () { return $713ae338c10ff4b6$export$54fd2c36b5cc6731; });

var $fmkKe = parcelRequire("fmkKe");

var $OQ9bg = parcelRequire("OQ9bg");

var $ekJ59 = parcelRequire("ekJ59");
function $713ae338c10ff4b6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $713ae338c10ff4b6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $713ae338c10ff4b6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fmkKe.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $713ae338c10ff4b6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ var $713ae338c10ff4b6$var$parseDataConsumer = function parseDataConsumer(maybeValue) {
    var sources = (0, $ekJ59.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch (_unused) {
        return false;
    }
};
var $713ae338c10ff4b6$export$3024f02c495408d6 = (0, $OQ9bg.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: function getAttrs(maybeValue) {
                return $713ae338c10ff4b6$var$parseDataConsumer(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
var $713ae338c10ff4b6$export$54fd2c36b5cc6731 = function toJSON(mark) {
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter(function(key) {
            return key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null;
        }).reduce(function(acc, key) {
            return $713ae338c10ff4b6$var$_objectSpread($713ae338c10ff4b6$var$_objectSpread({}, acc), {}, (0, $fmkKe.default)({}, key, mark.attrs[key]));
        }, {})
    };
};

});
parcelRegister("OQ9bg", function(module, exports) {
$parcel$export(module.exports, "alignment", function () { return $098d1ef316bf0b72$export$8e53000a4ec837; });
$parcel$export(module.exports, "annotation", function () { return $098d1ef316bf0b72$export$8512c9afa7b24c3b; });
$parcel$export(module.exports, "backgroundColor", function () { return $098d1ef316bf0b72$export$8c5a050822fd698c; });
$parcel$export(module.exports, "border", function () { return $098d1ef316bf0b72$export$1edee58a52776cd9; });
$parcel$export(module.exports, "breakout", function () { return $098d1ef316bf0b72$export$89015c65f1c75e3f; });
$parcel$export(module.exports, "code", function () { return $098d1ef316bf0b72$export$6565f9f03506010b; });
$parcel$export(module.exports, "confluenceInlineComment", function () { return $098d1ef316bf0b72$export$f3b72f8fc4684ecd; });
$parcel$export(module.exports, "dataConsumer", function () { return $098d1ef316bf0b72$export$3024f02c495408d6; });
$parcel$export(module.exports, "em", function () { return $098d1ef316bf0b72$export$c63c6f932822f543; });
$parcel$export(module.exports, "fragment", function () { return $098d1ef316bf0b72$export$f00aeb236b6f05af; });
$parcel$export(module.exports, "indentation", function () { return $098d1ef316bf0b72$export$480c699bd4ec0d86; });
$parcel$export(module.exports, "link", function () { return $098d1ef316bf0b72$export$9c30223ca0a664fb; });
$parcel$export(module.exports, "strike", function () { return $098d1ef316bf0b72$export$4899a95d70ec5056; });
$parcel$export(module.exports, "strong", function () { return $098d1ef316bf0b72$export$59ae2c325a998f89; });
$parcel$export(module.exports, "subsup", function () { return $098d1ef316bf0b72$export$b3401ee80eb31041; });
$parcel$export(module.exports, "textColor", function () { return $098d1ef316bf0b72$export$32f78bffcd82ff28; });
$parcel$export(module.exports, "typeAheadQuery", function () { return $098d1ef316bf0b72$export$20af3dabbb5538df; });
$parcel$export(module.exports, "underline", function () { return $098d1ef316bf0b72$export$425327af25286e5e; });
$parcel$export(module.exports, "unsupportedMark", function () { return $098d1ef316bf0b72$export$30d78d5eb6719bb8; });
$parcel$export(module.exports, "unsupportedNodeAttribute", function () { return $098d1ef316bf0b72$export$a316dc07ff5182a2; });
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $5OqWX = parcelRequire("5OqWX");
var $098d1ef316bf0b72$export$8e53000a4ec837 = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
var $098d1ef316bf0b72$export$8512c9afa7b24c3b = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
var $098d1ef316bf0b72$export$8c5a050822fd698c = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: 'color',
    group: 'color'
});
var $098d1ef316bf0b72$export$1edee58a52776cd9 = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
var $098d1ef316bf0b72$export$89015c65f1c75e3f = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
var $098d1ef316bf0b72$export$6565f9f03506010b = (0, $5OqWX.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
var $098d1ef316bf0b72$export$f3b72f8fc4684ecd = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
var $098d1ef316bf0b72$export$3024f02c495408d6 = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
var $098d1ef316bf0b72$export$c63c6f932822f543 = (0, $5OqWX.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $098d1ef316bf0b72$export$f00aeb236b6f05af = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
var $098d1ef316bf0b72$export$480c699bd4ec0d86 = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
var $098d1ef316bf0b72$export$9c30223ca0a664fb = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
var $098d1ef316bf0b72$export$4899a95d70ec5056 = (0, $5OqWX.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $098d1ef316bf0b72$export$59ae2c325a998f89 = (0, $5OqWX.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $098d1ef316bf0b72$export$b3401ee80eb31041 = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
var $098d1ef316bf0b72$export$32f78bffcd82ff28 = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
var $098d1ef316bf0b72$export$20af3dabbb5538df = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
var $098d1ef316bf0b72$export$425327af25286e5e = (0, $5OqWX.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $098d1ef316bf0b72$export$30d78d5eb6719bb8 = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
var $098d1ef316bf0b72$export$a316dc07ff5182a2 = (0, $5OqWX.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});

parcelRegister("ekJ59", function(module, exports) {
$parcel$export(module.exports, "isDOMElement", function () { return $a6f5e748c5f5e438$export$c296e2d4365c37a5; });
var $a6f5e748c5f5e438$export$c296e2d4365c37a5 = function isDOMElement(maybeNode) {
    return maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;
};

});


parcelRegister("3DDez", function(module, exports) {
$parcel$export(module.exports, "expandWithNestedExpand", function () { return $2a6372b14246c485$export$7b80cba28d10b2c1; });
$parcel$export(module.exports, "toJSON", function () { return $2a6372b14246c485$export$54fd2c36b5cc6731; });

var $fmkKe = parcelRequire("fmkKe");

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
function $2a6372b14246c485$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2a6372b14246c485$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2a6372b14246c485$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fmkKe.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2a6372b14246c485$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_root_only_node
 */ function $2a6372b14246c485$var$getExpandAttrs(domNode) {
    var dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
var $2a6372b14246c485$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $2a6372b14246c485$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $2a6372b14246c485$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $2a6372b14246c485$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $2a6372b14246c485$var$getExpandAttrs
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
var $2a6372b14246c485$export$7b80cba28d10b2c1 = (0, $kBUhU.expand)($2a6372b14246c485$var$nodeSpecOptions);
var $2a6372b14246c485$export$2ae5e7565ff9ffa6 = (0, $kBUhU.expand)({
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $2a6372b14246c485$var$getExpandAttrs(dom);
                return $2a6372b14246c485$var$_objectSpread($2a6372b14246c485$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $6BQ2f.uuid).generate()
                });
            }
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $2a6372b14246c485$var$getExpandAttrs(dom);
                return $2a6372b14246c485$var$_objectSpread($2a6372b14246c485$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $6BQ2f.uuid).generate()
                });
            }
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $2a6372b14246c485$var$getExpandAttrs(dom);
                return $2a6372b14246c485$var$_objectSpread($2a6372b14246c485$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $6BQ2f.uuid).generate()
                });
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $2a6372b14246c485$var$getExpandAttrs(dom);
                return $2a6372b14246c485$var$_objectSpread($2a6372b14246c485$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $6BQ2f.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $2a6372b14246c485$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return !key.startsWith('__');
        }).reduce(function(obj, key) {
            return $2a6372b14246c485$var$_objectSpread($2a6372b14246c485$var$_objectSpread({}, obj), {}, (0, $fmkKe.default)({}, key, node.attrs[key]));
        }, {})
    };
};

});

parcelRegister("2fgwX", function(module, exports) {
$parcel$export(module.exports, "fragment", function () { return $1a29ce1fd691cb99$export$f00aeb236b6f05af; });
$parcel$export(module.exports, "toJSON", function () { return $1a29ce1fd691cb99$export$54fd2c36b5cc6731; });

var $fmkKe = parcelRequire("fmkKe");

var $OQ9bg = parcelRequire("OQ9bg");

var $ekJ59 = parcelRequire("ekJ59");
function $1a29ce1fd691cb99$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1a29ce1fd691cb99$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1a29ce1fd691cb99$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fmkKe.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1a29ce1fd691cb99$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ var $1a29ce1fd691cb99$var$parseFragment = function parseFragment(maybeValue) {
    var _maybeValue$getAttrib;
    if (!(0, $ekJ59.isDOMElement)(maybeValue)) return false;
    var name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    var localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
var $1a29ce1fd691cb99$export$f00aeb236b6f05af = (0, $OQ9bg.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: function getAttrs(maybeValue) {
                return $1a29ce1fd691cb99$var$parseFragment(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
var $1a29ce1fd691cb99$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: $1a29ce1fd691cb99$var$_objectSpread({
            localId: mark.attrs.localId
        }, mark.attrs.name ? {
            name: mark.attrs.name
        } : {})
    };
};

});

parcelRegister("iq9Qk", function(module, exports) {
$parcel$export(module.exports, "link", function () { return $d6924a4e79658fd3$export$9c30223ca0a664fb; });
$parcel$export(module.exports, "toJSON", function () { return $d6924a4e79658fd3$export$54fd2c36b5cc6731; });

var $fmkKe = parcelRequire("fmkKe");

var $OQ9bg = parcelRequire("OQ9bg");

var $cX1iO = parcelRequire("cX1iO");
function $d6924a4e79658fd3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d6924a4e79658fd3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d6924a4e79658fd3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fmkKe.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d6924a4e79658fd3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d6924a4e79658fd3$export$b5f67017585d1431 = function getLinkAttrs(attribute) {
    return function(domNode) {
        var dom = domNode;
        var href = dom.getAttribute(attribute) || '';
        var attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $cX1iO.isSafeUrl)(href)) return false;
        if ((0, $cX1iO.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $cX1iO.normalizeUrl)(href);
        return attrs;
    };
};
var $d6924a4e79658fd3$export$9c30223ca0a664fb = (0, $OQ9bg.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $d6924a4e79658fd3$export$b5f67017585d1431('data-block-link'),
            contentElement: function contentElement(node) {
                var clone = node.cloneNode(true);
                clone.removeAttribute('data-block-link');
                clone.setAttribute('data-skip-paste', 'true');
                var wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $d6924a4e79658fd3$export$b5f67017585d1431('href')
        }
    ],
    toDOM: function toDOM(node, isInline) {
        var attrs = Object.keys(node.attrs).reduce(function(attrs, key) {
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $cX1iO.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            $d6924a4e79658fd3$var$_objectSpread($d6924a4e79658fd3$var$_objectSpread({}, attrs), {}, (0, $fmkKe.default)((0, $fmkKe.default)({}, 'data-block-link', 'true'), "class", 'blockLink')),
            0
        ];
    }
});
var $d6924a4e79658fd3$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
var $d6924a4e79658fd3$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce(function(attrs, key) {
            if ($d6924a4e79658fd3$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    };
};

});
parcelRegister("cX1iO", function(module, exports) {
$parcel$export(module.exports, "isSafeUrl", function () { return $96dc015bc0129d10$export$c9f92f5469372e0f; });
$parcel$export(module.exports, "normalizeUrl", function () { return $96dc015bc0129d10$export$6535eb414fa2c8b6; });
$parcel$export(module.exports, "isRootRelative", function () { return $96dc015bc0129d10$export$23579274a7a24f7b; });
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $l2qL1 = parcelRequire("l2qL1");
var $96dc015bc0129d10$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
var $96dc015bc0129d10$export$c9f92f5469372e0f = function isSafeUrl(url) {
    var urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $96dc015bc0129d10$var$whitelistedURLPatterns.some(function(p) {
        return p.test(urlTrimmed);
    });
};
var $96dc015bc0129d10$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($l2qL1)))();
$96dc015bc0129d10$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$96dc015bc0129d10$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
var $96dc015bc0129d10$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$96dc015bc0129d10$export$8ccbde94d5c7f8e7.add('tel:', $96dc015bc0129d10$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$96dc015bc0129d10$export$8ccbde94d5c7f8e7.add('file:', $96dc015bc0129d10$var$urlWithoutSpacesValidator);
$96dc015bc0129d10$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
var $96dc015bc0129d10$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
var $96dc015bc0129d10$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$96dc015bc0129d10$var$tlds.push($96dc015bc0129d10$var$tlds2Char);
$96dc015bc0129d10$export$8ccbde94d5c7f8e7.tlds($96dc015bc0129d10$var$tlds, false);
var $96dc015bc0129d10$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
var $96dc015bc0129d10$export$6f7d7761b97f967 = function linkifyMatch(text) {
    if (!$96dc015bc0129d10$export$746d02eae03c72e1.test(text)) return [];
    var matches = [];
    var startpos = 0;
    var substr;
    while(substr = text.substr(startpos)){
        var link = (substr.match($96dc015bc0129d10$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            var index = substr.search($96dc015bc0129d10$export$746d02eae03c72e1);
            var start = index >= 0 ? index + startpos : index;
            var end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $96dc015bc0129d10$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    var match = $96dc015bc0129d10$export$6f7d7761b97f967(str);
    if (!match.length) match = $96dc015bc0129d10$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $96dc015bc0129d10$export$6535eb414fa2c8b6(url) {
    var match = $96dc015bc0129d10$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $96dc015bc0129d10$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});


parcelRegister("ePmJY", function(module, exports) {
$parcel$export(module.exports, "mediaSingleFull", function () { return $acb777e037a21462$export$7e767666f2ce108a; });
$parcel$export(module.exports, "toJSON", function () { return $acb777e037a21462$export$54fd2c36b5cc6731; });

var $fmkKe = parcelRequire("fmkKe");

var $gOR5u = parcelRequire("gOR5u");

var $ekJ59 = parcelRequire("ekJ59");

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
function $acb777e037a21462$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $acb777e037a21462$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $acb777e037a21462$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fmkKe.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $acb777e037a21462$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $acb777e037a21462$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
var $acb777e037a21462$export$5a1e124099b60c6b = function mediaSingleSpec(_ref) {
    var _ref$withCaption = _ref.withCaption, withCaption = _ref$withCaption === void 0 ? false : _ref$withCaption, _ref$withExtendedWidt = _ref.withExtendedWidthTypes, withExtendedWidthTypes = _ref$withExtendedWidt === void 0 ? false : _ref$withExtendedWidt, _ref$generateLocalId = _ref.generateLocalId, generateLocalId = _ref$generateLocalId === void 0 ? false : _ref$generateLocalId;
    var getAttrs = function getAttrs(dom) {
        if (!(0, $ekJ59.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        var layout = dom.getAttribute('data-layout') || 'center';
        var width = Number(dom.getAttribute('data-width')) || null;
        var widthType = dom.getAttribute('data-width-type');
        if (generateLocalId) return {
            layout: layout,
            width: width,
            widthType: widthType,
            localId: (0, $6BQ2f.uuid).generate()
        };
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $gOR5u.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    var getAttrsFromNode = function getAttrsFromNode(node) {
        var _node$attrs = node.attrs, layout = _node$attrs.layout, width = _node$attrs.width;
        var attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (generateLocalId) {
            var _node$attrs2;
            attrs['data-local-id'] = (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined;
        }
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            var widthType = node.attrs.widthType;
            return $acb777e037a21462$var$_objectSpread($acb777e037a21462$var$_objectSpread({}, attrs), {}, {
                'data-width-type': widthType || (0, $gOR5u.WidthType).PERCENTAGE
            });
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $kBUhU.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $kBUhU.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $kBUhU.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $kBUhU.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
var $acb777e037a21462$export$969fe3781ca15058 = $acb777e037a21462$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
var $acb777e037a21462$export$d35e6c006d4abdfb = $acb777e037a21462$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
var $acb777e037a21462$export$9c58e19811ce4cf5 = $acb777e037a21462$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
var $acb777e037a21462$export$7e767666f2ce108a = $acb777e037a21462$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
var $acb777e037a21462$export$75376a385837c942 = $acb777e037a21462$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true,
    generateLocalId: true
});
var $acb777e037a21462$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});
parcelRegister("gOR5u", function(module, exports) {
$parcel$export(module.exports, "WidthType", function () { return $c3ea7ef3206b0fe7$export$4d41558722ac7eed; });
/**
 * @description The widthType attribute is used to support fixed with media single
 */ var $c3ea7ef3206b0fe7$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("4LvHO", function(module, exports) {
$parcel$export(module.exports, "createMediaSpec", function () { return $3784254fee0de50f$export$35bdbf5bc8caa677; });
$parcel$export(module.exports, "media", function () { return $3784254fee0de50f$export$987d49ffe1b0900f; });
$parcel$export(module.exports, "toJSON", function () { return $3784254fee0de50f$export$54fd2c36b5cc6731; });

var $fmkKe = parcelRequire("fmkKe");

var $aZMvy = parcelRequire("aZMvy");

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
function $3784254fee0de50f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3784254fee0de50f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3784254fee0de50f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fmkKe.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3784254fee0de50f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3784254fee0de50f$export$bb3fe706be61f640 = (0, $kBUhU.media)({}).attrs;
var $3784254fee0de50f$export$35bdbf5bc8caa677 = function createMediaSpec(attributes) {
    var inline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var generateLocalId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var domNodeType = inline ? 'span' : 'div';
    var nodeName = inline ? 'mediaInline' : 'media';
    var parseDOM = [
        {
            tag: "".concat(domNodeType, "[data-node-type=\"").concat(nodeName, "\"]"),
            getAttrs: function getAttrs(dom) {
                var attrs = {};
                if (attributes) Object.keys(attributes).forEach(function(k) {
                    var key = $3784254fee0de50f$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                    var value = dom.getAttribute("data-".concat(key)) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                var width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                var height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                if (generateLocalId) attrs.localId = (0, $6BQ2f.uuid).generate();
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    var toDOM = function toDOM(node) {
        var attrs = {
            'data-id': node.attrs.id,
            'data-node-type': "".concat(nodeName),
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            'data-local-id': node.attrs.localId || undefined,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: "display: inline-block; border-radius: 3px; background: ".concat((0, $aZMvy.N30), "; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);")
        };
        $3784254fee0de50f$export$111130fa8968d741(node.attrs, attrs, function(key) {
            return "data-".concat($3784254fee0de50f$export$f84fdfb973c05bd8(key.slice(2)));
        });
        return [
            "".concat(domNodeType),
            attrs
        ];
    };
    if (inline) return (0, $kBUhU.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $kBUhU.media)({
        parseDOM: [].concat(parseDOM, [
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: function getAttrs(dom) {
                    var attrs = {
                        type: 'external',
                        url: dom.getAttribute('src') || '',
                        alt: dom.getAttribute('alt') || ''
                    };
                    if (generateLocalId) attrs.localId = (0, $6BQ2f.uuid).generate();
                    return attrs;
                }
            }
        ]),
        toDOM: toDOM
    });
};
var $3784254fee0de50f$export$987d49ffe1b0900f = $3784254fee0de50f$export$35bdbf5bc8caa677($3784254fee0de50f$export$bb3fe706be61f640, false, false);
var $3784254fee0de50f$export$8446e47a4c7fd000 = $3784254fee0de50f$export$35bdbf5bc8caa677($3784254fee0de50f$var$_objectSpread($3784254fee0de50f$var$_objectSpread({}, $3784254fee0de50f$export$bb3fe706be61f640), {}, {
    localId: {
        default: (0, $6BQ2f.uuid).generate()
    }
}), false, true);
var $3784254fee0de50f$export$f84fdfb973c05bd8 = function camelCaseToKebabCase(str) {
    return str.replace(/([^A-Z]+)([A-Z])/g, function(_, x, y) {
        return "".concat(x, "-").concat(y.toLowerCase());
    });
};
var $3784254fee0de50f$export$111130fa8968d741 = function copyPrivateAttributes(from, to, map) {
    if ($3784254fee0de50f$export$987d49ffe1b0900f.attrs) Object.keys($3784254fee0de50f$export$987d49ffe1b0900f.attrs).forEach(function(key) {
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ var $3784254fee0de50f$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt',
    'localId'
];
var $3784254fee0de50f$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt',
    'localId'
];
var $3784254fee0de50f$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter(function(key) {
            return !(key[0] === '_' && key[1] === '_');
        }).reduce(function(obj, key) {
            if (node.attrs.type === 'external' && $3784254fee0de50f$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($3784254fee0de50f$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});
parcelRegister("aZMvy", function(module, exports) {
$parcel$export(module.exports, "R50", function () { return $80153a9129a945ba$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R75", function () { return $80153a9129a945ba$export$b34b069eff244586; });
$parcel$export(module.exports, "R100", function () { return $80153a9129a945ba$export$be802dd0d8b57f35; });
$parcel$export(module.exports, "R300", function () { return $80153a9129a945ba$export$4a7404f376229999; });
$parcel$export(module.exports, "R500", function () { return $80153a9129a945ba$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $80153a9129a945ba$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y75", function () { return $80153a9129a945ba$export$41060a744ab0b7ae; });
$parcel$export(module.exports, "Y200", function () { return $80153a9129a945ba$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Yellow200", function () { return $80153a9129a945ba$export$fc857b6f8771648a; });
$parcel$export(module.exports, "Y400", function () { return $80153a9129a945ba$export$59619663aa6500fb; });
$parcel$export(module.exports, "G50", function () { return $80153a9129a945ba$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G75", function () { return $80153a9129a945ba$export$69a3bf21b9686c2b; });
$parcel$export(module.exports, "G200", function () { return $80153a9129a945ba$export$747d86715d4175de; });
$parcel$export(module.exports, "G300", function () { return $80153a9129a945ba$export$940e1f69e873f202; });
$parcel$export(module.exports, "G500", function () { return $80153a9129a945ba$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $80153a9129a945ba$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $80153a9129a945ba$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $80153a9129a945ba$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B400", function () { return $80153a9129a945ba$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $80153a9129a945ba$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "L200", function () { return $80153a9129a945ba$export$f72948ef771f6f15; });
$parcel$export(module.exports, "N0", function () { return $80153a9129a945ba$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $80153a9129a945ba$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $80153a9129a945ba$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N60", function () { return $80153a9129a945ba$export$c2e91cbeada39b8b; });
$parcel$export(module.exports, "N80", function () { return $80153a9129a945ba$export$eaa8c8a70ac22806; });
$parcel$export(module.exports, "Neutral300", function () { return $80153a9129a945ba$export$1ae1cebe22dcedb4; });
$parcel$export(module.exports, "N300A", function () { return $80153a9129a945ba$export$13609db0e6812ab8; });
$parcel$export(module.exports, "N600", function () { return $80153a9129a945ba$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N800", function () { return $80153a9129a945ba$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N1000", function () { return $80153a9129a945ba$export$f78789c8b01753cd; });
$parcel$export(module.exports, "M200", function () { return $80153a9129a945ba$export$a19f0c33186f7767; });
$parcel$export(module.exports, "O200", function () { return $80153a9129a945ba$export$51716a84e62e022c; });
$parcel$export(module.exports, "P50", function () { return $80153a9129a945ba$export$363e4475840015bb; });
$parcel$export(module.exports, "P75", function () { return $80153a9129a945ba$export$4b0a4417ed59760f; });
$parcel$export(module.exports, "P100", function () { return $80153a9129a945ba$export$6011520a64d9a187; });
$parcel$export(module.exports, "P200", function () { return $80153a9129a945ba$export$a7175d4e9206bc80; });
$parcel$export(module.exports, "P300", function () { return $80153a9129a945ba$export$b48405b95304b5a1; });
$parcel$export(module.exports, "P500", function () { return $80153a9129a945ba$export$147899de772240ec; });
$parcel$export(module.exports, "T50", function () { return $80153a9129a945ba$export$2cf711fe14c66f06; });
$parcel$export(module.exports, "T75", function () { return $80153a9129a945ba$export$7a8f4d33f6f9772c; });
$parcel$export(module.exports, "T100", function () { return $80153a9129a945ba$export$776c9c497ef08533; });
$parcel$export(module.exports, "T200", function () { return $80153a9129a945ba$export$69cb3ca10c1e330e; });
$parcel$export(module.exports, "T300", function () { return $80153a9129a945ba$export$9dc1ef0f3f48059b; });
$parcel$export(module.exports, "T500", function () { return $80153a9129a945ba$export$6036577f95c3877e; });
$parcel$export(module.exports, "isHex", function () { return $80153a9129a945ba$export$8a9b6341a7c96bc; });
$parcel$export(module.exports, "isRgb", function () { return $80153a9129a945ba$export$e698776ec826343; });
$parcel$export(module.exports, "rgbToHex", function () { return $80153a9129a945ba$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hexToRgba", function () { return $80153a9129a945ba$export$9665a07d9187b414; });

var $1HFWa = parcelRequire("1HFWa");

var $ksCOI = parcelRequire("ksCOI");
var $80153a9129a945ba$export$4b84fd0e2c617bd = '#FFEBE6';
var $80153a9129a945ba$export$b34b069eff244586 = '#FFBDAD';
var $80153a9129a945ba$export$be802dd0d8b57f35 = '#FF8F73';
var $80153a9129a945ba$export$4a7404f376229999 = '#FF5630';
var $80153a9129a945ba$export$2010d0fb4295b346 = '#DE350B';
var $80153a9129a945ba$export$2837b5a1a71d5c02 = '#BF2600';
var $80153a9129a945ba$export$8d9596b529bbb9cf = '#FFFAE6';
var $80153a9129a945ba$export$41060a744ab0b7ae = '#FFF0B3';
var $80153a9129a945ba$export$5aae31392d72caaa = '#FFC400';
var $80153a9129a945ba$export$fc857b6f8771648a = '#F8E6A0';
var $80153a9129a945ba$export$59619663aa6500fb = '#FF991F';
var $80153a9129a945ba$export$874739ea9e379ab6 = '#FF8B00';
var $80153a9129a945ba$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $80153a9129a945ba$export$69a3bf21b9686c2b = '#ABF5D1';
var $80153a9129a945ba$export$747d86715d4175de = '#57D9A3';
var $80153a9129a945ba$export$940e1f69e873f202 = '#36B37E';
var $80153a9129a945ba$export$a49394138f7b8e85 = '#00875A';
var $80153a9129a945ba$export$6fa04827ac68a4fb = '#006644';
var $80153a9129a945ba$export$226de0355ed012f8 = '#DEEBFF';
var $80153a9129a945ba$export$8c13c2ee36917869 = '#B3D4FF';
var $80153a9129a945ba$export$ecfc1dff386a3e7a = '#4C9AFF';
var $80153a9129a945ba$export$b3de0ae08da2ce64 = '#0052CC';
var $80153a9129a945ba$export$a6ee3d71bc067634 = '#0747A6';
var $80153a9129a945ba$export$f72948ef771f6f15 = '#D3F1A7';
var $80153a9129a945ba$export$29a4f05edc054374 = '#FFFFFF';
var $80153a9129a945ba$export$9fdfb749e33cdf97 = '#F4F5F7';
var $80153a9129a945ba$export$3e51e8f1440314ba = '#EBECF0';
var $80153a9129a945ba$export$1ce2d1575d444ceb = '#DFE1E6';
var $80153a9129a945ba$export$8754fc7e6d8b3000 = '#C1C7D0';
var $80153a9129a945ba$export$c2e91cbeada39b8b = '#B3BAC5';
var $80153a9129a945ba$export$eaa8c8a70ac22806 = '#97A0AF';
var $80153a9129a945ba$export$7c87d337fb91a97d = '#8993A4';
var $80153a9129a945ba$export$f563ee71e9ee74cd = '#6B778C';
var $80153a9129a945ba$export$e2ef2124cf4024b1 = '#5E6C84';
var $80153a9129a945ba$export$1ae1cebe22dcedb4 = '#DCDFE4';
var $80153a9129a945ba$export$13609db0e6812ab8 = '#091E4224';
var $80153a9129a945ba$export$c39c0fe0f26207ae = '#42526E';
var $80153a9129a945ba$export$7090862dc3038a9f = '#758195';
var $80153a9129a945ba$export$7d61b15e0da132af = '#172B4D';
var $80153a9129a945ba$export$f78789c8b01753cd = '#172B4D';
var $80153a9129a945ba$export$a19f0c33186f7767 = '#FDD0EC';
var $80153a9129a945ba$export$51716a84e62e022c = '#FEDEC8';
var $80153a9129a945ba$export$363e4475840015bb = '#EAE6FF';
var $80153a9129a945ba$export$4b0a4417ed59760f = '#C0B6F2';
var $80153a9129a945ba$export$6011520a64d9a187 = '#998DD9';
var $80153a9129a945ba$export$a7175d4e9206bc80 = '#DFD8FD';
var $80153a9129a945ba$export$b48405b95304b5a1 = '#6554C0';
var $80153a9129a945ba$export$c71e4279dd54a18d = '#5243AA';
var $80153a9129a945ba$export$147899de772240ec = '#403294';
var $80153a9129a945ba$export$2cf711fe14c66f06 = '#E6FCFF';
var $80153a9129a945ba$export$7a8f4d33f6f9772c = '#B3F5FF';
var $80153a9129a945ba$export$776c9c497ef08533 = '#79E2F2';
var $80153a9129a945ba$export$69cb3ca10c1e330e = '#C6EDFB';
var $80153a9129a945ba$export$9dc1ef0f3f48059b = '#00B8D9';
var $80153a9129a945ba$export$6036577f95c3877e = '#008DA6';
function $80153a9129a945ba$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($80153a9129a945ba$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map(function(c) {
            return c === '#' ? '#' : "".concat(c).concat(c);
        }).join('');
    } else if ($80153a9129a945ba$export$e698776ec826343(color)) return $80153a9129a945ba$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($ksCOI.default && $ksCOI.default[color]) color = $ksCOI.default[color];
        else if ($ksCOI && $ksCOI[color]) color = $ksCOI[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $80153a9129a945ba$export$5a544e13ad4e1fa5(color) {
    if (!$80153a9129a945ba$export$8a9b6341a7c96bc(color)) return null;
    var colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    var rgb = Number("0x".concat(colorBits.join('')));
    // eslint-disable-next-line no-bitwise
    return "rgb(".concat(rgb >> 16 & 255, ",").concat(rgb >> 8 & 255, ",").concat(rgb & 255, ")");
}
function $80153a9129a945ba$export$9665a07d9187b414(rawColor, alpha) {
    var color = $80153a9129a945ba$export$b61655071712e690(rawColor);
    if (!color) return null;
    var hex2rgb = function hex2rgb(color) {
        return color.match(/[a-z0-9]{2}/gi).map(function(hex) {
            return parseInt(hex, 16);
        });
    };
    return "rgba(".concat(hex2rgb(color).concat(alpha).join(','), ")");
}
function $80153a9129a945ba$export$34d09c4a771c46ef(value) {
    var matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        var _matches$map = matches.map(Number), _matches$map2 = (0, $1HFWa.default)(_matches$map, 3), red = _matches$map2[0], green = _matches$map2[1], blue = _matches$map2[2];
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $80153a9129a945ba$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $80153a9129a945ba$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});
parcelRegister("1HFWa", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $13da5678d4d12a54$export$2e2bcd8739ae039; });

var $4Pwfx = parcelRequire("4Pwfx");

var $k9zN2 = parcelRequire("k9zN2");

var $9xa7A = parcelRequire("9xa7A");

var $1hW7N = parcelRequire("1hW7N");
function $13da5678d4d12a54$export$2e2bcd8739ae039(r, e) {
    return (0, $4Pwfx.default)(r) || (0, $k9zN2.default)(r, e) || (0, $9xa7A.default)(r, e) || (0, $1hW7N.default)();
}

});
parcelRegister("4Pwfx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3844f0ef9dd81b54$export$2e2bcd8739ae039; });
function $3844f0ef9dd81b54$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("k9zN2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eac0690ab9eae657$export$2e2bcd8739ae039; });
function $eac0690ab9eae657$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("9xa7A", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6f0f0c078e7dc312$export$2e2bcd8739ae039; });

var $rHiKp = parcelRequire("rHiKp");
function $6f0f0c078e7dc312$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $rHiKp.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $rHiKp.default)(r, a) : void 0;
    }
}

});
parcelRegister("rHiKp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $05341c7bbfbb2bc1$export$2e2bcd8739ae039; });
function $05341c7bbfbb2bc1$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("1hW7N", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0f047758de0ae410$export$2e2bcd8739ae039; });
function $0f047758de0ae410$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("1H3wm", function(module, exports) {
$parcel$export(module.exports, "mention", function () { return $13bc89c433dbe0f6$export$db83999c14438df4; });
$parcel$export(module.exports, "toJSON", function () { return $13bc89c433dbe0f6$export$54fd2c36b5cc6731; });

var $fmkKe = parcelRequire("fmkKe");

var $6BQ2f = parcelRequire("6BQ2f");

var $kBUhU = parcelRequire("kBUhU");
function $13bc89c433dbe0f6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $13bc89c433dbe0f6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $13bc89c433dbe0f6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fmkKe.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $13bc89c433dbe0f6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $13bc89c433dbe0f6$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
var $13bc89c433dbe0f6$export$db83999c14438df4 = (0, $kBUhU.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute('data-mention-id') || $13bc89c433dbe0f6$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $13bc89c433dbe0f6$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute('data-access-level') || $13bc89c433dbe0f6$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $6BQ2f.uuid).generate()
                };
                var userType = dom.getAttribute('data-user-type');
                if ($13bc89c433dbe0f6$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, id = _node$attrs.id, accessLevel = _node$attrs.accessLevel, text = _node$attrs.text, userType = _node$attrs.userType, localId = _node$attrs.localId;
        var attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
var $13bc89c433dbe0f6$var$isOptional = function isOptional(key) {
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
var $13bc89c433dbe0f6$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if ($13bc89c433dbe0f6$var$isOptional(key) && !node.attrs[key]) return obj;
            return $13bc89c433dbe0f6$var$_objectSpread($13bc89c433dbe0f6$var$_objectSpread({}, obj), {}, (0, $fmkKe.default)({}, key, node.attrs[key]));
        }, {})
    };
};

});

parcelRegister("4wcds", function(module, exports) {
$parcel$export(module.exports, "table", function () { return $34a3a0721ccc3dd1$export$9852986a3ec5f6a0; });
$parcel$export(module.exports, "tableToJSON", function () { return $34a3a0721ccc3dd1$export$1f92a2f429e06fa8; });
$parcel$export(module.exports, "tableRow", function () { return $34a3a0721ccc3dd1$export$ce666bf02318c957; });
$parcel$export(module.exports, "tableCell", function () { return $34a3a0721ccc3dd1$export$e1e720e5f4603e6a; });
$parcel$export(module.exports, "toJSONTableCell", function () { return $34a3a0721ccc3dd1$export$2ac34c099660f1a8; });
$parcel$export(module.exports, "tableHeader", function () { return $34a3a0721ccc3dd1$export$48884d2a5190dc73; });
$parcel$export(module.exports, "toJSONTableHeader", function () { return $34a3a0721ccc3dd1$export$2af48797a1010bb1; });
$parcel$export(module.exports, "tableWithNestedTable", function () { return $34a3a0721ccc3dd1$export$ce086a560a1d05f5; });
$parcel$export(module.exports, "tableRowWithNestedTable", function () { return $34a3a0721ccc3dd1$export$7d657479499397; });
$parcel$export(module.exports, "tableCellWithNestedTable", function () { return $34a3a0721ccc3dd1$export$abf39ca178940ff3; });
$parcel$export(module.exports, "tableHeaderWithNestedTable", function () { return $34a3a0721ccc3dd1$export$2a5a518232fa1a97; });

var $1HFWa = parcelRequire("1HFWa");

var $fmkKe = parcelRequire("fmkKe");

var $2UMkY = parcelRequire("2UMkY");

var $aZMvy = parcelRequire("aZMvy");

var $6BQ2f = parcelRequire("6BQ2f");

var $lLlF4 = parcelRequire("lLlF4");

var $kBUhU = parcelRequire("kBUhU");
function $34a3a0721ccc3dd1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $34a3a0721ccc3dd1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $34a3a0721ccc3dd1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fmkKe.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $34a3a0721ccc3dd1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $34a3a0721ccc3dd1$export$9cfceb893b24742a = 'pm-table';
var $34a3a0721ccc3dd1$export$69cb4c3f80383763 = "".concat($34a3a0721ccc3dd1$export$9cfceb893b24742a, "-cell-content-wrap");
var $34a3a0721ccc3dd1$export$7b07d37d879c957f = "".concat($34a3a0721ccc3dd1$export$9cfceb893b24742a, "-header-content-wrap");
var $34a3a0721ccc3dd1$export$8dd42a84cd52da07 = "".concat($34a3a0721ccc3dd1$export$9cfceb893b24742a, "-cell-nodeview-wrapper");
var $34a3a0721ccc3dd1$export$5e26a5c19f0865d8 = "".concat($34a3a0721ccc3dd1$export$9cfceb893b24742a, "-cell-nodeview-content-dom");
var $34a3a0721ccc3dd1$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $aZMvy.N20).toLocaleLowerCase();
var $34a3a0721ccc3dd1$export$43977bde391e007 = function getCellAttrs(dom) {
    var defaultValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var widthAttr = dom.getAttribute('data-colwidth');
    var width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map(function(str) {
        return Number(str);
    }) : null;
    var colspan = Number(dom.getAttribute('colspan') || 1);
    var backgroundColor = dom.style.backgroundColor;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ var dataCellBackground = dom.getAttribute('data-cell-background');
    var dataCellBackgroundHexCode = dataCellBackground && (0, $aZMvy.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $aZMvy.isRgb)(backgroundColor)) {
        var result = (0, $aZMvy.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    var backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    var localId = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.localId;
    return $34a3a0721ccc3dd1$var$_objectSpread({
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    }, localId && {
        localId: localId
    });
};
// these are for test only
var $34a3a0721ccc3dd1$var$testGlobalTheme;
var $34a3a0721ccc3dd1$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $34a3a0721ccc3dd1$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
var $34a3a0721ccc3dd1$var$getGlobalTheme = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($34a3a0721ccc3dd1$var$testGlobalTheme) return {
        colorMode: $34a3a0721ccc3dd1$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
var $34a3a0721ccc3dd1$var$cssVariablePattern = /^var\(--.*\)$/;
var $34a3a0721ccc3dd1$export$363c8dda799bfe9c = function getCellDomAttrs(node) {
    var _node$attrs;
    var attrs = {};
    var nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        var background = node.attrs.background;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        var ignored = nodeType === 'tableHeader' && background === $34a3a0721ccc3dd1$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $34a3a0721ccc3dd1$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            var color = (0, $aZMvy.isRgb)(background) && (0, $aZMvy.rgbToHex)(background) ? (0, $aZMvy.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ var tokenColor = (0, $2UMkY.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = "background-color: ".concat(tokenColor, ";");
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $34a3a0721ccc3dd1$var$cssVariablePattern.test(color)) attrs.style = "background-color: ".concat(color, ";");
            else // if we have a custom color, we need to check if we are in dark mode
            if ($34a3a0721ccc3dd1$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = "background-color: ".concat((0, $lLlF4.getDarkModeLCHColor)(color), ";");
            else // if we are in light mode, we can just set the color
            attrs.style = "background-color: ".concat(background, ";");
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            if (typeof color === 'string') attrs.colorname = $34a3a0721ccc3dd1$export$219b7f492ad209f8.get(color.toLowerCase());
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $34a3a0721ccc3dd1$export$7b07d37d879c957f;
    else attrs.class = $34a3a0721ccc3dd1$export$69cb4c3f80383763;
    if (node !== null && node !== void 0 && (_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.localId) attrs['data-local-id'] = node.attrs.localId;
    return attrs;
};
var $34a3a0721ccc3dd1$export$219b7f492ad209f8 = new Map();
var $34a3a0721ccc3dd1$export$95e9c925fbf01d1c = (0, $aZMvy.hexToRgba)((0, $aZMvy.N800), 0.12) || (0, $aZMvy.N0);
var $34a3a0721ccc3dd1$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $aZMvy.N0),
        'White'
    ],
    [
        (0, $aZMvy.B50),
        'Light blue'
    ],
    [
        (0, $aZMvy.T50),
        'Light teal'
    ],
    [
        (0, $aZMvy.G50),
        'Light green'
    ],
    [
        (0, $aZMvy.Y50),
        'Light yellow'
    ],
    [
        (0, $aZMvy.R50),
        'Light red'
    ],
    [
        (0, $aZMvy.P50),
        'Light purple'
    ],
    [
        (0, $aZMvy.N20),
        'Light gray'
    ],
    [
        (0, $aZMvy.B75),
        'Blue'
    ],
    [
        (0, $aZMvy.T75),
        'Teal'
    ],
    [
        (0, $aZMvy.G75),
        'Green'
    ],
    [
        (0, $aZMvy.Y75),
        'Yellow'
    ],
    [
        (0, $aZMvy.R75),
        'Red'
    ],
    [
        (0, $aZMvy.P75),
        'Purple'
    ],
    [
        (0, $aZMvy.N60),
        'Gray'
    ],
    [
        (0, $aZMvy.B100),
        'Dark blue'
    ],
    [
        (0, $aZMvy.T100),
        'Dark teal'
    ],
    [
        (0, $aZMvy.G200),
        'Dark green'
    ],
    [
        (0, $aZMvy.Y200),
        'Dark yellow'
    ],
    [
        (0, $aZMvy.R100),
        'Dark red'
    ],
    [
        (0, $aZMvy.P100),
        'Dark purple'
    ]
].forEach(function(_ref) {
    var _ref2 = (0, $1HFWa.default)(_ref, 2), colorValue = _ref2[0], colorName = _ref2[1];
    $34a3a0721ccc3dd1$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $34a3a0721ccc3dd1$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // table nodes with nested tables support
var $34a3a0721ccc3dd1$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: function getAttrs(node) {
                var _dom$parentElement;
                var dom = node;
                var breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $6BQ2f.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: Fix any, potential issue. ED-5048
var $34a3a0721ccc3dd1$var$createTableSpec = function createTableSpec() {
    return (0, $kBUhU.table)($34a3a0721ccc3dd1$var$tableNodeSpecOptions);
};
var $34a3a0721ccc3dd1$export$9852986a3ec5f6a0 = $34a3a0721ccc3dd1$var$createTableSpec();
var $34a3a0721ccc3dd1$export$90e634fbace1f0c4 = $34a3a0721ccc3dd1$var$createTableSpec();
var $34a3a0721ccc3dd1$export$3862de5c8c9098cf = $34a3a0721ccc3dd1$var$createTableSpec();
var $34a3a0721ccc3dd1$var$shouldIncludeAttribute = function shouldIncludeAttribute(key, value) {
    return !key.startsWith('__') && (key !== 'localId' || !!value);
};
var $34a3a0721ccc3dd1$export$1f92a2f429e06fa8 = function tableToJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return $34a3a0721ccc3dd1$var$shouldIncludeAttribute(key, node.attrs[key]);
        }).reduce(function(obj, key) {
            return $34a3a0721ccc3dd1$var$_objectSpread($34a3a0721ccc3dd1$var$_objectSpread({}, obj), {}, (0, $fmkKe.default)({}, key, node.attrs[key]));
        }, {})
    };
};
var $34a3a0721ccc3dd1$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM: function toDOM() {
        return [
            'tr',
            0
        ];
    }
};
var $34a3a0721ccc3dd1$export$ce666bf02318c957 = (0, $kBUhU.tableRow)($34a3a0721ccc3dd1$var$tableRowNodeSpecOptions);
var $34a3a0721ccc3dd1$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    },
    localId: {
        default: null,
        optional: true
    }
};
var $34a3a0721ccc3dd1$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            getAttrs: function getAttrs(dom) {
                return $34a3a0721ccc3dd1$export$43977bde391e007(dom);
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'td',
            $34a3a0721ccc3dd1$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $34a3a0721ccc3dd1$export$e1e720e5f4603e6a = (0, $kBUhU.tableCell)($34a3a0721ccc3dd1$var$tableCellNodeSpecOptions);
var $34a3a0721ccc3dd1$export$2ac34c099660f1a8 = function toJSONTableCell(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            // Only process keys that are defined in cellAttrs
            if ($34a3a0721ccc3dd1$var$cellAttrs[key] && $34a3a0721ccc3dd1$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};
var $34a3a0721ccc3dd1$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: function getAttrs(dom) {
                return $34a3a0721ccc3dd1$export$43977bde391e007(dom, {
                    background: $34a3a0721ccc3dd1$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'th',
            $34a3a0721ccc3dd1$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $34a3a0721ccc3dd1$export$48884d2a5190dc73 = (0, $kBUhU.tableHeader)($34a3a0721ccc3dd1$var$tableHeaderNodeSpecOptions);
var $34a3a0721ccc3dd1$export$2af48797a1010bb1 = $34a3a0721ccc3dd1$export$2ac34c099660f1a8;
var $34a3a0721ccc3dd1$export$ce086a560a1d05f5 = (0, $kBUhU.tableWithNestedTable)($34a3a0721ccc3dd1$var$tableNodeSpecOptions);
var $34a3a0721ccc3dd1$export$7d657479499397 = (0, $kBUhU.tableRowWithNestedTable)($34a3a0721ccc3dd1$var$tableRowNodeSpecOptions);
var $34a3a0721ccc3dd1$export$abf39ca178940ff3 = (0, $kBUhU.tableCellWithNestedTable)($34a3a0721ccc3dd1$var$tableCellNodeSpecOptions);
var $34a3a0721ccc3dd1$export$2a5a518232fa1a97 = (0, $kBUhU.tableHeaderWithNestedTable)($34a3a0721ccc3dd1$var$tableHeaderNodeSpecOptions);
// table nodes with localId support
var $34a3a0721ccc3dd1$var$tableRowNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'tr',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        return [
            'tr',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
};
var $34a3a0721ccc3dd1$export$c8f0853ac97552c9 = (0, $kBUhU.tableRow)($34a3a0721ccc3dd1$var$tableRowNodeSpecOptionsWithLocalId);
var $34a3a0721ccc3dd1$var$tableCellNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'td',
            getAttrs: function getAttrs(dom) {
                return $34a3a0721ccc3dd1$export$43977bde391e007(dom, {
                    localId: (0, $6BQ2f.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'td',
            $34a3a0721ccc3dd1$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $34a3a0721ccc3dd1$export$db76cfd28a574029 = (0, $kBUhU.tableCell)($34a3a0721ccc3dd1$var$tableCellNodeSpecOptionsWithLocalId);
var $34a3a0721ccc3dd1$var$tableHeaderNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: function getAttrs(dom) {
                return $34a3a0721ccc3dd1$export$43977bde391e007(dom, {
                    background: $34a3a0721ccc3dd1$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND,
                    localId: (0, $6BQ2f.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'th',
            $34a3a0721ccc3dd1$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $34a3a0721ccc3dd1$export$b82d2b1d8824143d = (0, $kBUhU.tableHeader)($34a3a0721ccc3dd1$var$tableHeaderNodeSpecOptionsWithLocalId);
var $34a3a0721ccc3dd1$export$27926e30c8a74147 = (0, $kBUhU.tableRowWithNestedTable)($34a3a0721ccc3dd1$var$tableRowNodeSpecOptionsWithLocalId);
var $34a3a0721ccc3dd1$export$e9fd700fafee293a = (0, $kBUhU.tableCellWithNestedTable)($34a3a0721ccc3dd1$var$tableCellNodeSpecOptionsWithLocalId);
var $34a3a0721ccc3dd1$export$7928c3aeb4cd2213 = (0, $kBUhU.tableHeaderWithNestedTable)($34a3a0721ccc3dd1$var$tableHeaderNodeSpecOptionsWithLocalId);

});
parcelRegister("2UMkY", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBorderPaletteColor", function () { return $21f64e82aeeb03f5$export$bad3c41dd33cb4bc; });
$parcel$export(module.exports, "hexToEditorTextPaletteColor", function () { return $21f64e82aeeb03f5$export$9c2f408d391feb93; });
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", function () { return $21f64e82aeeb03f5$export$8b58ff1b36bb75e0; });
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", function () { return $21f64e82aeeb03f5$export$a270511a0e7fd61a; });

var $9H5co = parcelRequire("9H5co");
function $21f64e82aeeb03f5$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $21f64e82aeeb03f5$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
var $21f64e82aeeb03f5$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $21f64e82aeeb03f5$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $21f64e82aeeb03f5$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
var $21f64e82aeeb03f5$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $21f64e82aeeb03f5$export$8b58ff1b36bb75e0(hexColor) {
    if ((0, $9H5co.default).getExperimentValue('platform_editor_add_orange_highlight_color', 'cohort', 'control') !== 'test') $21f64e82aeeb03f5$export$12a518ff137dd389['#FEDEC8'] = 'var(--ds-background-accent-yellow-subtler, #F8E6A0)';
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return hexColor ? $21f64e82aeeb03f5$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
var $21f64e82aeeb03f5$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Yellow - light */ '#F8E6A0': 'var(--ds-background-accent-yellow-subtler, #F8E6A0)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $21f64e82aeeb03f5$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    var tokenData = hexColor ? $21f64e82aeeb03f5$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
var $21f64e82aeeb03f5$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: function getValue() {
            return '#DEEBFF';
        },
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: function getValue() {
            return '#B3D4FF';
        },
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: function getValue() {
            return '#4C9AFF';
        },
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: function getValue() {
            return '#E6FCFF';
        },
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: function getValue() {
            return '#B3F5FF';
        },
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: function getValue() {
            return '#79E2F2';
        },
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: function getValue() {
            return '#E3FCEF';
        },
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: function getValue() {
            return '#ABF5D1';
        },
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: function getValue() {
            return '#57D9A3';
        },
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: function getValue() {
            return '#FFFAE6';
        },
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: function getValue() {
            return '#FFF0B3';
        },
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: function getValue() {
            return '#FFC400';
        },
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: function getValue() {
            return '#FFEBE6';
        },
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: function getValue() {
            return '#FFBDAD';
        },
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: function getValue() {
            return '#FF8F73';
        },
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: function getValue() {
            return '#EAE6FF';
        },
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: function getValue() {
            return '#C0B6F2';
        },
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: function getValue() {
            return '#998DD9';
        },
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: function getValue() {
            return '#FFFFFF';
        },
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: function getValue() {
            return '#F4F5F7';
        },
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: function getValue() {
            return '#B3BAC5';
        },
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});
parcelRegister("9H5co", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $70ec299851198fde$export$2e2bcd8739ae039; });

var $hiPA7 = parcelRequire("hiPA7");

var $2871N = parcelRequire("2871N");

var $lUar6 = parcelRequire("lUar6");

var $9exn0 = parcelRequire("9exn0");

var $ikbTQ = parcelRequire("ikbTQ");



var $70ec299851198fde$var$_FeatureGates;
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $70ec299851198fde$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, $hiPA7.default)(this, FeatureGates);
    }
    return (0, $2871N.default)(FeatureGates, null, [
        {
            key: "isGateExists",
            value: function isGateExists(gateName) {
                return this.client.isGateExist(gateName);
            }
        },
        {
            key: "isExperimentExists",
            value: function isExperimentExists(experimentName) {
                return this.client.isExperimentExist(experimentName);
            }
        }
    ]);
}();
$70ec299851198fde$var$_FeatureGates = $70ec299851198fde$var$FeatureGates;
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "client", new (0, $9exn0.Client)());
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "checkGate", function(gateName, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === 'function') {
            // Attempt to retrieve an override value for the feature gate
            var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
            // If an override value is found, return it immediately
            if (overrideValue !== undefined) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$70ec299851198fde$var$_FeatureGates.hasCheckGateErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred checking the feature gate from criterion override. Only the first occurrence of this error is logged.',
                gateName: gateName,
                error: error
            });
            $70ec299851198fde$var$_FeatureGates.hasCheckGateErrorOccurred = true;
        }
    }
    // Proceed with the main logic if no override is found
    return $70ec299851198fde$var$_FeatureGates.client.checkGate(gateName, options);
});
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "getExperimentValue", function(experimentName, parameterName, defaultValue, options) {
    try {
        // Check if the CRITERION override mechanism is available
        if (typeof window !== 'undefined' && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === 'function') {
            var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
            if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
        }
    } catch (error) {
        // Log the first occurrence of the error
        if (!$70ec299851198fde$var$_FeatureGates.hasGetExperimentValueErrorOccurred) {
            // eslint-disable-next-line no-console
            console.warn({
                msg: 'An error has occurred getting the experiment value from criterion override. Only the first occurrence of this error is logged.',
                experimentName: experimentName,
                defaultValue: defaultValue,
                options: options,
                error: error
            });
            $70ec299851198fde$var$_FeatureGates.hasGetExperimentValueErrorOccurred = true;
        }
        return defaultValue;
    }
    // Proceed with the main logic if no override is found
    return $70ec299851198fde$var$_FeatureGates.client.getExperimentValue(experimentName, parameterName, defaultValue, options);
});
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "initializeCalled", $70ec299851198fde$var$_FeatureGates.client.initializeCalled.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "initializeCompleted", $70ec299851198fde$var$_FeatureGates.client.initializeCompleted.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "initialize", $70ec299851198fde$var$_FeatureGates.client.initialize.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "initializeWithProvider", $70ec299851198fde$var$_FeatureGates.client.initializeWithProvider.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "initializeFromValues", $70ec299851198fde$var$_FeatureGates.client.initializeFromValues.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "manuallyLogGateExposure", $70ec299851198fde$var$_FeatureGates.client.manuallyLogGateExposure.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "getExperiment", $70ec299851198fde$var$_FeatureGates.client.getExperiment.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "manuallyLogExperimentExposure", $70ec299851198fde$var$_FeatureGates.client.manuallyLogExperimentExposure.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "manuallyLogLayerExposure", $70ec299851198fde$var$_FeatureGates.client.manuallyLogLayerExposure.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "shutdownStatsig", $70ec299851198fde$var$_FeatureGates.client.shutdownStatsig.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "overrideGate", $70ec299851198fde$var$_FeatureGates.client.overrideGate.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "clearGateOverride", $70ec299851198fde$var$_FeatureGates.client.clearGateOverride.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "overrideConfig", $70ec299851198fde$var$_FeatureGates.client.overrideConfig.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "clearConfigOverride", $70ec299851198fde$var$_FeatureGates.client.clearConfigOverride.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "setOverrides", $70ec299851198fde$var$_FeatureGates.client.setOverrides.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "getOverrides", $70ec299851198fde$var$_FeatureGates.client.getOverrides.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "clearAllOverrides", $70ec299851198fde$var$_FeatureGates.client.clearAllOverrides.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "isCurrentUser", $70ec299851198fde$var$_FeatureGates.client.isCurrentUser.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "onGateUpdated", $70ec299851198fde$var$_FeatureGates.client.onGateUpdated.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "onExperimentValueUpdated", $70ec299851198fde$var$_FeatureGates.client.onExperimentValueUpdated.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "onAnyUpdated", $70ec299851198fde$var$_FeatureGates.client.onAnyUpdated.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "updateUser", $70ec299851198fde$var$_FeatureGates.client.updateUser.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "updateUserWithProvider", $70ec299851198fde$var$_FeatureGates.client.updateUserWithProvider.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "updateUserWithValues", $70ec299851198fde$var$_FeatureGates.client.updateUserWithValues.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "getPackageVersion", $70ec299851198fde$var$_FeatureGates.client.getPackageVersion.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "getLayer", $70ec299851198fde$var$_FeatureGates.client.getLayer.bind($70ec299851198fde$var$_FeatureGates.client));
(0, $lUar6.default)($70ec299851198fde$var$FeatureGates, "getLayerValue", $70ec299851198fde$var$_FeatureGates.client.getLayerValue.bind($70ec299851198fde$var$_FeatureGates.client));
var $70ec299851198fde$var$boundFGJS = $70ec299851198fde$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== 'undefined') {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $70ec299851198fde$var$FeatureGates;
    else {
        var $70ec299851198fde$var$_boundFGJS, $70ec299851198fde$var$_boundFGJS$getPackage;
        $70ec299851198fde$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $70ec299851198fde$var$boundVersion = (($70ec299851198fde$var$_boundFGJS = $70ec299851198fde$var$boundFGJS) === null || $70ec299851198fde$var$_boundFGJS === void 0 || ($70ec299851198fde$var$_boundFGJS$getPackage = $70ec299851198fde$var$_boundFGJS.getPackageVersion) === null || $70ec299851198fde$var$_boundFGJS$getPackage === void 0 ? void 0 : $70ec299851198fde$var$_boundFGJS$getPackage.call($70ec299851198fde$var$_boundFGJS)) || '4.10.0 or earlier';
        if ($70ec299851198fde$var$boundVersion !== (0, $ikbTQ.CLIENT_VERSION)) {
            var $70ec299851198fde$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($70ec299851198fde$var$boundVersion, " when module version ").concat((0, $ikbTQ.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($70ec299851198fde$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $70ec299851198fde$export$2e2bcd8739ae039 = $70ec299851198fde$var$boundFGJS;

});
parcelRegister("9exn0", function(module, exports) {
$parcel$export(module.exports, "Client", function () { return $6b8f4e73e0f5583f$export$1f2bb630327ac4b6; });

var $6Kejc = parcelRequire("6Kejc");

var $f2kyT = parcelRequire("f2kyT");

var $ge1fS = parcelRequire("ge1fS");

var $hiPA7 = parcelRequire("hiPA7");

var $2871N = parcelRequire("2871N");

var $lUar6 = parcelRequire("lUar6");

var $dzfsB = parcelRequire("dzfsB");

var $ixyZs = parcelRequire("ixyZs");

var $ejm2K = parcelRequire("ejm2K");

var $5Hljh = parcelRequire("5Hljh");

var $9NHwM = parcelRequire("9NHwM");

var $YUUrb = parcelRequire("YUUrb");

var $hMIHi = parcelRequire("hMIHi");

var $l5iWb = parcelRequire("l5iWb");

var $9DTa6 = parcelRequire("9DTa6");

var $dxLzm = parcelRequire("dxLzm");

var $avpcy = parcelRequire("avpcy");

var $ikbTQ = parcelRequire("ikbTQ");
var $6b8f4e73e0f5583f$var$_excluded = [
    "sdkKey",
    "environment",
    "updateUserCompletionCallback",
    "perimeter"
];
function $6b8f4e73e0f5583f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6b8f4e73e0f5583f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6b8f4e73e0f5583f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6b8f4e73e0f5583f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6b8f4e73e0f5583f$var$DEFAULT_CLIENT_KEY = 'client-default-key';
// default event logging api is Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $6b8f4e73e0f5583f$var$DEFAULT_EVENT_LOGGING_API = 'https://xp.atlassian.com/v1/rgstr';
var $6b8f4e73e0f5583f$export$1f2bb630327ac4b6 = /*#__PURE__*/ function() {
    function Client() {
        var _this = this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$localStorageKey = _ref.localStorageKey, localStorageKey = _ref$localStorageKey === void 0 ? (0, $9DTa6.LOCAL_STORAGE_KEY) : _ref$localStorageKey;
        (0, $hiPA7.default)(this, Client);
        (0, $lUar6.default)(this, "initPromise", null);
        /** True if an initialize method was called and completed successfully. */ (0, $lUar6.default)(this, "initCompleted", false);
        /**
     * True if an initialize method was called and completed, meaning the client is now usable.
     * However if there was an error during initialization it may have initialized with default
     * values. Use {@link initCompleted} to check for this.
     */ (0, $lUar6.default)(this, "initWithDefaults", false);
        (0, $lUar6.default)(this, "hasCheckGateErrorOccurred", false);
        (0, $lUar6.default)(this, "hasGetExperimentErrorOccurred", false);
        (0, $lUar6.default)(this, "hasGetExperimentValueErrorOccurred", false);
        (0, $lUar6.default)(this, "hasGetLayerErrorOccurred", false);
        (0, $lUar6.default)(this, "hasGetLayerValueErrorOccurred", false);
        (0, $lUar6.default)(this, "subscriptions", new (0, $ejm2K.default)());
        (0, $lUar6.default)(this, "dataAdapter", new (0, $l5iWb.NoFetchDataAdapter)());
        /**
     * Call this if modifying the values being served by the Statsig library since it has its own
     * memoization cache which will not be updated if the values are changed outside of the library.
     */ (0, $lUar6.default)(this, "statsigValuesUpdated", function() {
            if (_this.user) // Trigger a reset of the memoize cache
            _this.statsigClient.updateUserSync(_this.user, {
                disableBackgroundCacheRefresh: true
            });
            _this.subscriptions.anyUpdated();
        });
        this.overrideAdapter = new (0, $9DTa6.PersistentOverrideAdapter)(localStorageKey);
    }
    /**
   * @description
   * This method initializes the client using a network call to fetch the bootstrap values.
   * If the client is inialized with an `analyticsWebClient`, it will send an operational event
   * to GASv3 with the following attributes:
   * - targetApp: the target app of the client
   * - clientVersion: the version of the client
   * - success: whether the initialization was successful
   * - startTime: the time when the initialization started
   * - totalTime: the total time it took to initialize the client
   * - apiKey: the api key used to initialize the client
   * @param clientOptions {ClientOptions}
   * @param identifiers {Identifiers}
   * @param customAttributes {CustomAttributes}
   * @returns {Promise<void>}
   */ return (0, $2871N.default)(Client, [
        {
            key: "initialize",
            value: function() {
                var _initialize = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var _this2 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $avpcy.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!(0, $avpcy.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    _this2.initCompleted = true;
                                    _this2.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this2.fireClientEvent(startTime, totalTime, 'initialize', _this2.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", this.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var _this3 = this;
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = (0, $avpcy.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!(0, $avpcy.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context2.abrupt("return", this.initPromise);
                            case 4:
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.provider = provider;
                                this.provider.setClientVersion((0, $ikbTQ.CLIENT_VERSION));
                                if (this.provider.setApplyUpdateCallback) this.provider.setApplyUpdateCallback(this.applyUpdateCallback.bind(this));
                                this.initPromise = this.initWithProvider(clientOptionsWithDefaults, provider, identifiers, customAttributes).then(function() {
                                    _this3.initCompleted = true;
                                    _this3.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this3.fireClientEvent(startTime, totalTime, 'initializeWithProvider', _this3.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", this.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (this.initCompleted || this.initWithDefaults) {
                        this.assertInitialized(this.statsigClient);
                        this.dataAdapter.setBootstrapData(experimentsResult.experimentValues);
                        this.dataAdapter.setData(JSON.stringify(experimentsResult.experimentValues));
                        this.statsigValuesUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn('Error when attempting to apply update', error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _analyticsWebClient, _this4 = this;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_analyticsWebClient = this.initOptions.analyticsWebClient) === null || _analyticsWebClient === void 0 || _analyticsWebClient.then(function(analyticsWebClient) {
                    var attributes = $6b8f4e73e0f5583f$var$_objectSpread({
                        targetApp: _this4.initOptions.targetApp,
                        clientVersion: (0, $ikbTQ.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: 'featureGatesClient',
                        attributes: attributes,
                        tags: [
                            'measurement'
                        ],
                        source: '@atlaskit/feature-gate-js-client'
                    });
                }).catch(function(err) {
                    if (_this4.initOptions.environment !== (0, $dxLzm.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error('Analytics web client promise did not resolve', err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var _this5 = this;
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = (0, $avpcy.getOptionsWithDefaults)(clientOptions);
                                if (!this.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!(0, $avpcy.shallowEquals)(clientOptionsWithDefaults, this.initOptions)) // eslint-disable-next-line no-console
                                console.warn('Feature Gates client already initialized with different options. New options were not applied.');
                                return _context3.abrupt("return", this.initPromise);
                            case 5:
                                // This makes sure the new Statsig client behaves like the old when bootstrap data is
                                // passed, and `has_updates` isn't specified (which happens a lot in product integration tests).
                                if (!Object.prototype.hasOwnProperty.call(initializeValues, 'has_updates')) initializeValues['has_updates'] = true;
                                startTime = performance.now();
                                this.initOptions = clientOptionsWithDefaults;
                                this.initPromise = this.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    _this5.initCompleted = true;
                                    _this5.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    _this5.fireClientEvent(startTime, totalTime, 'initializeFromValues', _this5.initCompleted);
                                });
                                return _context3.abrupt("return", this.initPromise);
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x10) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "assertInitialized",
            value: function assertInitialized(statsigClient) {
                if (!statsigClient) throw new Error('Client must be initialized before using this method');
            }
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                fetchOptionsWithDefaults = (0, $avpcy.getOptionsWithDefaults)(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $hMIHi.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref2) {
                                        var experimentValues = _ref2.experimentValues, customAttributes = _ref2.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x11, _x12, _x13) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee5(identifiers, customAttributes) {
                    var _this6 = this;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.provider) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error('Cannot update user using provider as the client was not initialised with a provider');
                            case 3:
                                _context5.next = 5;
                                return this.provider.setProfile(this.initOptions, identifiers, customAttributes);
                            case 5:
                                _context5.next = 7;
                                return this.updateUserUsingInitializeValuesProducer(function() {
                                    return _this6.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function updateUserWithProvider(_x14, _x15) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                this.assertInitialized(this.statsigClient);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 5;
                                return this.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 5:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function updateUserWithValues(_x16, _x17) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return this.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return this.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    return this.statsigClient.checkGate(gateName, {
                        disableExposureLog: !fireGateExposure
                    });
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred checking the feature gate. Only the first occurrence of this error is logged.',
                            gateName: gateName,
                            error: error
                        });
                        this.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "isGateExist",
            value: function isGateExist(gateName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var gate = this.statsigClient.getFeatureGate(gateName, {
                        disableExposureLog: true
                    });
                    return !gate.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check FeatureGate: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "isExperimentExist",
            value: function isExperimentExist(experimentName) {
                try {
                    this.assertInitialized(this.statsigClient);
                    var config = this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: true
                    });
                    return !config.details.reason.includes('Unrecognized');
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error("Error occurred when trying to check Experiment: ".concat(error));
                    // in case of error report true to avoid false positives.
                    return true;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.checkGate(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    return (0, $5Hljh.DynamicConfig).fromExperiment(this.statsigClient.getExperiment(experimentName, {
                        disableExposureLog: !fireExperimentExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            error: error
                        });
                        this.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $5Hljh.DynamicConfig)(experimentName, {}, '', {
                        time: Date.now(),
                        reason: (0, $YUUrb.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var experiment = this.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the experiment value. Only the first occurrence of this error is logged.',
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                this.statsigClient.getExperiment(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                var _this$statsigClient$g;
                this.assertInitialized(this.statsigClient);
                // This is the approach recommended in the docs
                // https://docs.statsig.com/client/javascript-sdk/#manual-exposures-
                (_this$statsigClient$g = this.statsigClient.getLayer(layerName)) === null || _this$statsigClient$g === void 0 || _this$statsigClient$g.get(parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                this.assertInitialized(this.statsigClient);
                this.statsigClient.shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                this.overrideAdapter.overrideGate(gateName, value);
                // Trigger a reset of the memoized gate value
                if (this.user) {
                    var _this$statsigClient;
                    (_this$statsigClient = this.statsigClient) === null || _this$statsigClient === void 0 || _this$statsigClient.updateUserSync(this.user, {
                        disableBackgroundCacheRefresh: true
                    });
                }
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                this.overrideAdapter.removeGateOverride(gateName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                this.overrideAdapter.overrideDynamicConfig(experimentName, values);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                this.overrideAdapter.removeDynamicConfigOverride(experimentName);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.overrideAdapter.setOverrides(overrides);
                this.statsigValuesUpdated();
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.overrideAdapter.getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                this.overrideAdapter.removeAllOverrides();
                this.statsigValuesUpdated();
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return (0, $avpcy.shallowEquals)(this.currentIdentifiers, identifiers) && (0, $avpcy.shallowEquals)(this.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var _this7 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) _this7.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onGateUpdated(gateName, wrapCallback, this.checkGate.bind(this), options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var _this8 = this;
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) _this8.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return this.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, this.getExperimentValue.bind(this), options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                return this.subscriptions.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee7(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                fromValuesClientOptions = $6b8f4e73e0f5583f$var$_objectSpread({}, clientOptions);
                                _context7.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $hMIHi.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $hMIHi.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context7.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context7.sent;
                                _yield$Promise$all2 = (0, $f2kyT.default)(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context7.next = 20;
                                break;
                            case 13:
                                _context7.prev = 13;
                                _context7.t0 = _context7["catch"](1);
                                if (_context7.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context7.next = 19;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context7.t0;
                            case 20:
                                return _context7.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 21:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x18, _x19, _x20) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee8(baseClientOptions, provider, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $6b8f4e73e0f5583f$var$_objectSpread($6b8f4e73e0f5583f$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context8.prev = 1;
                                _context8.next = 4;
                                return provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for
                                // the experiment values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client
                                // with experiment values if both requests are successful. Else an error would be thrown and
                                // handled by the catch
                                _context8.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context8.sent;
                                _yield$Promise$all4 = (0, $f2kyT.default)(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context8.next = 22;
                                break;
                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 21;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context8.t0;
                            case 22:
                                return _context8.abrupt("return", this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues));
                            case 23:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x21, _x22, _x23, _x24) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee9(clientOptions, identifiers, customAttributes) {
                    var _newClientOptions$net;
                    var initializeValues, newClientOptions, sdkKey, environment, _updateUserCompletionCallback, _perimeter, restClientOptions, statsigOptions, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                initializeValues = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {};
                                this.overrideAdapter.initFromStoredOverrides();
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                newClientOptions = (0, $avpcy.migrateInitializationOptions)(clientOptions);
                                if (!newClientOptions.sdkKey) newClientOptions.sdkKey = $6b8f4e73e0f5583f$var$DEFAULT_CLIENT_KEY;
                                if (!((_newClientOptions$net = newClientOptions.networkConfig) !== null && _newClientOptions$net !== void 0 && _newClientOptions$net.logEventUrl)) newClientOptions.networkConfig = $6b8f4e73e0f5583f$var$_objectSpread($6b8f4e73e0f5583f$var$_objectSpread({}, newClientOptions.networkConfig), {}, {
                                    logEventUrl: $6b8f4e73e0f5583f$var$DEFAULT_EVENT_LOGGING_API
                                });
                                if (newClientOptions.perimeter === (0, $dxLzm.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                newClientOptions.disableLogging = true;
                                sdkKey = newClientOptions.sdkKey, environment = newClientOptions.environment, _updateUserCompletionCallback = newClientOptions.updateUserCompletionCallback, _perimeter = newClientOptions.perimeter, restClientOptions = (0, $6Kejc.default)(newClientOptions, $6b8f4e73e0f5583f$var$_excluded);
                                this.sdkKey = sdkKey;
                                this.user = (0, $avpcy.toStatsigUser)(identifiers, customAttributes, this.sdkKey);
                                statsigOptions = $6b8f4e73e0f5583f$var$_objectSpread($6b8f4e73e0f5583f$var$_objectSpread({}, restClientOptions), {}, {
                                    environment: {
                                        tier: environment
                                    },
                                    includeCurrentPageUrlWithEvents: false,
                                    dataAdapter: this.dataAdapter,
                                    overrideAdapter: this.overrideAdapter
                                });
                                _context9.prev = 12;
                                this.statsigClient = new (0, $ixyZs.StatsigClient)(sdkKey, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData(initializeValues);
                                _context9.next = 17;
                                return this.statsigClient.initializeAsync();
                            case 17:
                                _context9.next = 29;
                                break;
                            case 19:
                                _context9.prev = 19;
                                _context9.t0 = _context9["catch"](12);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                this.statsigClient = new (0, $ixyZs.StatsigClient)($6b8f4e73e0f5583f$var$DEFAULT_CLIENT_KEY, this.user, statsigOptions);
                                this.dataAdapter.setBootstrapData();
                                _context9.next = 27;
                                return this.statsigClient.initializeAsync();
                            case 27:
                                this.initWithDefaults = true;
                                throw _context9.t0;
                            case 29:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            12,
                            19
                        ]
                    ]);
                }));
                function initFromValues(_x25, _x26, _x27) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee11(getInitializeValues, identifiers, customAttributes) {
                    var _this9 = this;
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                if (this.initPromise) {
                                    _context11.next = 3;
                                    break;
                                }
                                throw new Error('The client must be initialized before you can update the user.');
                            case 3:
                                if (!this.isCurrentUser(identifiers, customAttributes)) {
                                    _context11.next = 5;
                                    break;
                                }
                                return _context11.abrupt("return", this.initPromise);
                            case 5:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = this.initPromise;
                                _context11.prev = 6;
                                _context11.next = 9;
                                return this.initPromise;
                            case 9:
                                _context11.next = 13;
                                break;
                            case 11:
                                _context11.prev = 11;
                                _context11.t0 = _context11["catch"](6);
                            case 13:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = this.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this
                                // point. Any subsequent calls to await client.initialize() or client.updateUser()
                                // will now also await this user update.
                                this.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee10() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee10$(_context10) {
                                        while(true)switch(_context10.prev = _context10.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                _this9.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!_this9.provider) {
                                                    _context10.next = 4;
                                                    break;
                                                }
                                                _context10.next = 4;
                                                return _this9.provider.setProfile(_this9.initOptions, _this9.currentIdentifiers, _this9.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context10.stop();
                                        }
                                    }, _callee10);
                                })));
                                return _context11.abrupt("return", updateUserPromise);
                            case 17:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this, [
                        [
                            6,
                            11
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x28, _x29, _x30) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee12(initializeValuesPromise, identifiers, customAttributes) {
                    var _this$initOptions, _this$initOptions$upd;
                    var initializeValues, user, _updateUserCompletion, _ref4, errMsg, success, errorMessage;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                this.assertInitialized(this.statsigClient);
                                _context12.prev = 1;
                                _context12.next = 4;
                                return initializeValuesPromise;
                            case 4:
                                initializeValues = _context12.sent;
                                user = (0, $avpcy.toStatsigUser)(identifiers, initializeValues.customAttributesFromFetch, this.sdkKey);
                                _context12.next = 13;
                                break;
                            case 8:
                                _context12.prev = 8;
                                _context12.t0 = _context12["catch"](1);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will
                                // already invoke the callback itself.
                                errMsg = _context12.t0 instanceof Error ? _context12.t0.message : JSON.stringify(_context12.t0);
                                (_updateUserCompletion = (_ref4 = this.initOptions).updateUserCompletionCallback) === null || _updateUserCompletion === void 0 || _updateUserCompletion.call(_ref4, false, errMsg);
                                throw _context12.t0;
                            case 13:
                                success = true;
                                errorMessage = null;
                                _context12.prev = 15;
                                this.dataAdapter.setBootstrapData(initializeValues.experimentValues);
                                this.user = user;
                                _context12.next = 20;
                                return this.statsigClient.updateUserAsync(this.user);
                            case 20:
                                _context12.next = 26;
                                break;
                            case 22:
                                _context12.prev = 22;
                                _context12.t1 = _context12["catch"](15);
                                success = false;
                                errorMessage = String(_context12.t1);
                            case 26:
                                (_this$initOptions = this.initOptions) === null || _this$initOptions === void 0 || (_this$initOptions$upd = _this$initOptions.updateUserCompletionCallback) === null || _this$initOptions$upd === void 0 || _this$initOptions$upd.call(_this$initOptions, success, errorMessage);
                                if (!success) {
                                    _context12.next = 33;
                                    break;
                                }
                                this.currentIdentifiers = identifiers;
                                this.currentAttributes = customAttributes;
                                this.subscriptions.anyUpdated();
                                _context12.next = 34;
                                break;
                            case 33:
                                throw new Error('Failed to update user. An unexpected error occured.');
                            case 34:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this, [
                        [
                            1,
                            8
                        ],
                        [
                            15,
                            22
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x31, _x32, _x33) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "getPackageVersion",
            value: /**
     * @returns string version of the current package in semver style.
     */ function getPackageVersion() {
                return 0, $ikbTQ.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(/** The name of the layer */ layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    this.assertInitialized(this.statsigClient);
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    return (0, $9NHwM.Layer).fromLayer(this.statsigClient.getLayer(layerName, {
                        disableExposureLog: !fireLayerExposure
                    }));
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            error: error
                        });
                        this.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $9NHwM.Layer).fromLayer((0, $ixyZs._makeLayer)(layerName, {
                        reason: 'Error'
                    }, null));
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = this.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!this.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: 'An error has occurred getting the layer value. Only the first occurrence of this error is logged.',
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        this.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        }
    ]);
}();

});
parcelRegister("f2kyT", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $af26fe103670f62b$export$2e2bcd8739ae039; });

var $kBeVR = parcelRequire("kBeVR");

var $jlHGM = parcelRequire("jlHGM");

var $2M5HD = parcelRequire("2M5HD");

var $92XDN = parcelRequire("92XDN");
function $af26fe103670f62b$export$2e2bcd8739ae039(r, e) {
    return (0, $kBeVR.default)(r) || (0, $jlHGM.default)(r, e) || (0, $2M5HD.default)(r, e) || (0, $92XDN.default)();
}

});
parcelRegister("kBeVR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eff2d8968c4f471d$export$2e2bcd8739ae039; });
function $eff2d8968c4f471d$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("jlHGM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e161de30762dcde2$export$2e2bcd8739ae039; });
function $e161de30762dcde2$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("2M5HD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $20547cedec03f08c$export$2e2bcd8739ae039; });

var $cqWE6 = parcelRequire("cqWE6");
function $20547cedec03f08c$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $cqWE6.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $cqWE6.default)(r, a) : void 0;
    }
}

});
parcelRegister("cqWE6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $90d5678f7efec50f$export$2e2bcd8739ae039; });
function $90d5678f7efec50f$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("92XDN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $69629069d75fe9b5$export$2e2bcd8739ae039; });
function $69629069d75fe9b5$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("ge1fS", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bcfeed5cbec78347$export$2e2bcd8739ae039; });
function $bcfeed5cbec78347$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $bcfeed5cbec78347$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $bcfeed5cbec78347$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $bcfeed5cbec78347$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("dzfsB", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $9e0a895d86dc2395$var$runtime = (parcelRequire("jlUXe"))();
module.exports = $9e0a895d86dc2395$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $9e0a895d86dc2395$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $9e0a895d86dc2395$var$runtime;
    else Function("r", "regeneratorRuntime = r")($9e0a895d86dc2395$var$runtime);
}

});
parcelRegister("jlUXe", function(module, exports) {

var $fJpb9 = parcelRequire("fJpb9");

var $goRxu = parcelRequire("goRxu");

var $fySxU = parcelRequire("fySxU");

var $9ELAt = parcelRequire("9ELAt");

var $9CEVB = parcelRequire("9CEVB");

var $eZmDG = parcelRequire("eZmDG");

var $jHXhS = parcelRequire("jHXhS");
function $e16c2870a04a80f9$var$_regeneratorRuntime() {
    "use strict";
    var r = $goRxu(), e = r.m($e16c2870a04a80f9$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $jHXhS(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $e16c2870a04a80f9$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $fJpb9(r, e);
            },
            AsyncIterator: $9CEVB,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $9ELAt : $fySxU)(a(r), e, t, o, u);
            },
            keys: $eZmDG,
            values: $jHXhS
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $e16c2870a04a80f9$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fJpb9", function(module, exports) {
function $b73e96f5c6b722ef$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $b73e96f5c6b722ef$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("goRxu", function(module, exports) {

var $k6G5y = parcelRequire("k6G5y");
function $bf086afb3eac6dc3$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $k6G5y(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($k6G5y(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $k6G5y(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $k6G5y(u, "constructor", GeneratorFunctionPrototype), $k6G5y(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $k6G5y(GeneratorFunctionPrototype, o, "GeneratorFunction"), $k6G5y(u), $k6G5y(u, o, "Generator"), $k6G5y(u, n, function() {
        return this;
    }), $k6G5y(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $bf086afb3eac6dc3$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $bf086afb3eac6dc3$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("k6G5y", function(module, exports) {
function $ea350415f6bf7cd5$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $ea350415f6bf7cd5$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $ea350415f6bf7cd5$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $ea350415f6bf7cd5$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $ea350415f6bf7cd5$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fySxU", function(module, exports) {

var $9ELAt = parcelRequire("9ELAt");
function $b54457b0db388a89$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $9ELAt(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $b54457b0db388a89$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9ELAt", function(module, exports) {

var $goRxu = parcelRequire("goRxu");

var $9CEVB = parcelRequire("9CEVB");
function $707cc354f6251de6$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $9CEVB($goRxu().w(r, e, t, o), n || Promise);
}
module.exports = $707cc354f6251de6$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9CEVB", function(module, exports) {

var $fJpb9 = parcelRequire("fJpb9");

var $k6G5y = parcelRequire("k6G5y");
function $701769208f379329$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $fJpb9 ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($k6G5y($701769208f379329$var$AsyncIterator.prototype), $k6G5y($701769208f379329$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $k6G5y(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $701769208f379329$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("eZmDG", function(module, exports) {
function $ae9852d1d6b9b699$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $ae9852d1d6b9b699$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jHXhS", function(module, exports) {

var $d8DOY = parcelRequire("d8DOY");
var $e59005b646517804$var$_typeof = $d8DOY.default;
function $e59005b646517804$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($e59005b646517804$var$_typeof(e) + " is not iterable");
}
module.exports = $e59005b646517804$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("d8DOY", function(module, exports) {
function $990ae9622de09a2f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $990ae9622de09a2f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $990ae9622de09a2f$var$_typeof(o);
}
module.exports = $990ae9622de09a2f$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("ixyZs", function(module, exports) {
"use strict";
var $d7f673632d5e9b5d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d7f673632d5e9b5d$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $d7f673632d5e9b5d$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;

var $ijdh4 = parcelRequire("ijdh4");
module.exports.StatsigClient = $ijdh4.default;

$d7f673632d5e9b5d$var$__exportStar((parcelRequire("coIZN")), module.exports);
__STATSIG__ = Object.assign(Object.assign({}, __STATSIG__ !== null && __STATSIG__ !== void 0 ? __STATSIG__ : {}), {
    StatsigClient: $ijdh4.default
});
module.exports.default = __STATSIG__;

});
parcelRegister("ijdh4", function(module, exports) {
"use strict";
var $d5444c597cfece0c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $coIZN = parcelRequire("coIZN");

var $4f7AA = parcelRequire("4f7AA");

var $hqmSa = parcelRequire("hqmSa");

var $jgFRq = parcelRequire("jgFRq");

var $7Ffp3 = parcelRequire("7Ffp3");
class $d5444c597cfece0c$var$StatsigClient extends $coIZN.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient|undefined} Returns the StatsigClient instance associated with the given SDK key, or undefined if no instance is associated with the key or if no key is provided and no instances exist.
     */ static instance(sdkKey) {
        const instance = (0, $coIZN._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $d5444c597cfece0c$var$StatsigClient) return instance;
        $coIZN.Log.warn((0, $coIZN._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $d5444c597cfece0c$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $coIZN.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $d5444c597cfece0c$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        var _a;
        const startTime = performance.now();
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $coIZN.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $coIZN.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $d5444c597cfece0c$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $coIZN.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $coIZN.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $coIZN.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $coIZN.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($coIZN.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $coIZN.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $coIZN.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $coIZN.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: JSON.parse(JSON.stringify(this._user)),
            errorBoundary: this._errorBoundary,
            session: $coIZN.StatsigSession.get(this._sdkKey),
            stableID: $coIZN.StableID.get(this._sdkKey)
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $d5444c597cfece0c$var$__awaiter(this, void 0, void 0, function*() {
            if (!$coIZN.Storage.isReady()) yield $coIZN.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $coIZN.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a;
        const user = (0, $coIZN._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) $coIZN.StableID.setOverride(stableIdOverride, this._sdkKey);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $coIZN._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $coIZN._createGateExposure)(this._user, result), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $coIZN._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $coIZN._createConfigExposure)(this._user, result), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $coIZN._makeExperiment)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getExperimentOverride) === null || _b === void 0 ? void 0 : _b.call(_a, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $coIZN._createConfigExposure)(this._user, result), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $coIZN._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $coIZN._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $coIZN._createLayerParameterExposure)(this._user, result, param), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        return {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $jgFRq._makeParamStoreGetter)(this, configuration, options)
        };
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $coIZN.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $hqmSa.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $7Ffp3.StatsigEvaluationsDataAdapter(), network, options);
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($coIZN.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($coIZN.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($coIZN.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($coIZN.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($coIZN.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $4f7AA.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
}
module.exports.default = $d5444c597cfece0c$var$StatsigClient;

});
parcelRegister("coIZN", function(module, exports) {
"use strict";
var $906aa126ea60da83$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $906aa126ea60da83$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $906aa126ea60da83$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;


Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("d5Owr")).Diagnostics;
    }
});

var $5BELe = parcelRequire("5BELe");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $5BELe.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("dKfZk")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("evelF")).Storage;
    }
});

$906aa126ea60da83$var$__exportStar((parcelRequire("8yPXI")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("7BhXq")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("g6Qpu")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("8irt5")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("d5Owr")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("gB2DH")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("d9t4Z")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("j4YQP")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("iulmf")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("8th8c")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("jII1V")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("dKfZk")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("hew4l")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("84SHL")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("lg8MY")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("ls7Jz")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("b0wpb")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("fUe1j")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("98Fu0")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("a9ml1")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("ka2Xl")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("2qRcg")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("1fK3j")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("86xdf")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("6FJ2y")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("3P9ly")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("ec4Cp")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("aDzeK")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("lPICa")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("ly83U")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("6dczM")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("evelF")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("hArLP")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("ika9i")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("fcm7E")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("8Wl5a")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("hbcuF")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("82hf6")), module.exports);

$906aa126ea60da83$var$__exportStar((parcelRequire("4JZeF")), module.exports);
__STATSIG__ = Object.assign(Object.assign({}, __STATSIG__ !== null && __STATSIG__ !== void 0 ? __STATSIG__ : {}), {
    Log: (parcelRequire("dKfZk")).Log,
    SDK_VERSION: (parcelRequire("3P9ly")).SDK_VERSION
});

});
parcelRegister("8yPXI", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $63b9ce4a598ae96c$var$_a, $63b9ce4a598ae96c$var$_b, $63b9ce4a598ae96c$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $dKfZk = parcelRequire("dKfZk");
const $63b9ce4a598ae96c$var$_getStatsigGlobal = ()=>{
    return __STATSIG__ ? __STATSIG__ : $63b9ce4a598ae96c$var$statsigGlobal;
};
module.exports._getStatsigGlobal = $63b9ce4a598ae96c$var$_getStatsigGlobal;
const $63b9ce4a598ae96c$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $63b9ce4a598ae96c$var$_getStatsigGlobalFlag;
const $63b9ce4a598ae96c$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $dKfZk.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $63b9ce4a598ae96c$var$_getInstance;
const $63b9ce4a598ae96c$var$GLOBAL_KEY = '__STATSIG__';
const $63b9ce4a598ae96c$var$_window = typeof window !== 'undefined' ? window : {};
const $63b9ce4a598ae96c$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $63b9ce4a598ae96c$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $63b9ce4a598ae96c$var$statsigGlobal = ($63b9ce4a598ae96c$var$_c = ($63b9ce4a598ae96c$var$_b = ($63b9ce4a598ae96c$var$_a = $63b9ce4a598ae96c$var$_window[$63b9ce4a598ae96c$var$GLOBAL_KEY]) !== null && $63b9ce4a598ae96c$var$_a !== void 0 ? $63b9ce4a598ae96c$var$_a : $63b9ce4a598ae96c$var$_global[$63b9ce4a598ae96c$var$GLOBAL_KEY]) !== null && $63b9ce4a598ae96c$var$_b !== void 0 ? $63b9ce4a598ae96c$var$_b : $63b9ce4a598ae96c$var$_globalThis[$63b9ce4a598ae96c$var$GLOBAL_KEY]) !== null && $63b9ce4a598ae96c$var$_c !== void 0 ? $63b9ce4a598ae96c$var$_c : {
    instance: module.exports._getInstance
};
$63b9ce4a598ae96c$var$_window[$63b9ce4a598ae96c$var$GLOBAL_KEY] = $63b9ce4a598ae96c$var$statsigGlobal;
$63b9ce4a598ae96c$var$_global[$63b9ce4a598ae96c$var$GLOBAL_KEY] = $63b9ce4a598ae96c$var$statsigGlobal;
$63b9ce4a598ae96c$var$_globalThis[$63b9ce4a598ae96c$var$GLOBAL_KEY] = $63b9ce4a598ae96c$var$statsigGlobal;

});
parcelRegister("dKfZk", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $a01bf92a33aa8cb6$var$DEBUG = ' DEBUG ';
const $a01bf92a33aa8cb6$var$_INFO = '  INFO ';
const $a01bf92a33aa8cb6$var$_WARN = '  WARN ';
const $a01bf92a33aa8cb6$var$ERROR = ' ERROR ';
function $a01bf92a33aa8cb6$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $a01bf92a33aa8cb6$var$Log {
    static info(...args) {
        if ($a01bf92a33aa8cb6$var$Log.level >= module.exports.LogLevel.Info) console.info($a01bf92a33aa8cb6$var$_INFO, ...$a01bf92a33aa8cb6$var$addTag(args));
    }
    static debug(...args) {
        if ($a01bf92a33aa8cb6$var$Log.level >= module.exports.LogLevel.Debug) console.debug($a01bf92a33aa8cb6$var$DEBUG, ...$a01bf92a33aa8cb6$var$addTag(args));
    }
    static warn(...args) {
        if ($a01bf92a33aa8cb6$var$Log.level >= module.exports.LogLevel.Warn) console.warn($a01bf92a33aa8cb6$var$_WARN, ...$a01bf92a33aa8cb6$var$addTag(args));
    }
    static error(...args) {
        if ($a01bf92a33aa8cb6$var$Log.level >= module.exports.LogLevel.Error) console.error($a01bf92a33aa8cb6$var$ERROR, ...$a01bf92a33aa8cb6$var$addTag(args));
    }
}
module.exports.Log = $a01bf92a33aa8cb6$var$Log;
$a01bf92a33aa8cb6$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("d5Owr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $9882eeaa06d1417b$var$MARKER_MAP = new Map();
const $9882eeaa06d1417b$var$ACT_START = 'start';
const $9882eeaa06d1417b$var$ACT_END = 'end';
const $9882eeaa06d1417b$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $9882eeaa06d1417b$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $9882eeaa06d1417b$var$_addMarker(sdkKey, $9882eeaa06d1417b$var$_createMarker({}, $9882eeaa06d1417b$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $9882eeaa06d1417b$var$_addMarker(sdkKey, $9882eeaa06d1417b$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $9882eeaa06d1417b$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $9882eeaa06d1417b$var$_addMarker(sdkKey, $9882eeaa06d1417b$var$_createMarker(data, $9882eeaa06d1417b$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $9882eeaa06d1417b$var$_addMarker(sdkKey, $9882eeaa06d1417b$var$_createMarker(data, $9882eeaa06d1417b$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $9882eeaa06d1417b$var$_addMarker(sdkKey, $9882eeaa06d1417b$var$_createMarker({}, $9882eeaa06d1417b$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $9882eeaa06d1417b$var$_addMarker(sdkKey, $9882eeaa06d1417b$var$_createMarker(data, $9882eeaa06d1417b$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $9882eeaa06d1417b$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $9882eeaa06d1417b$var$_safeGetField(e, 'code'),
            name: $9882eeaa06d1417b$var$_safeGetField(e, 'name'),
            message: $9882eeaa06d1417b$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $9882eeaa06d1417b$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $9882eeaa06d1417b$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $9882eeaa06d1417b$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $9882eeaa06d1417b$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $9882eeaa06d1417b$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $9882eeaa06d1417b$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $9882eeaa06d1417b$var$MARKER_MAP.set(sdkKey, markers);
}
function $9882eeaa06d1417b$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("5BELe", function(module, exports) {
"use strict";
var $415006af1f66fa37$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $7BhXq = parcelRequire("7BhXq");

var $8th8c = parcelRequire("8th8c");

var $dKfZk = parcelRequire("dKfZk");

var $84SHL = parcelRequire("84SHL");

var $fUe1j = parcelRequire("fUe1j");

var $6FJ2y = parcelRequire("6FJ2y");

var $evelF = parcelRequire("evelF");

var $fcm7E = parcelRequire("fcm7E");

var $hbcuF = parcelRequire("hbcuF");
const $415006af1f66fa37$var$DEFAULT_QUEUE_SIZE = 100;
const $415006af1f66fa37$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $415006af1f66fa37$var$MAX_DEDUPER_KEYS = 1000;
const $415006af1f66fa37$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $415006af1f66fa37$var$MAX_FAILED_LOGS = 500;
const $415006af1f66fa37$var$QUICK_FLUSH_WINDOW_MS = 200;
const $415006af1f66fa37$var$EVENT_LOGGER_MAP = {};
const $415006af1f66fa37$var$RetryFailedLogsTrigger = {
    Startup: 'startup',
    GainedFocus: 'gained_focus'
};
class $415006af1f66fa37$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $415006af1f66fa37$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $415006af1f66fa37$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs($415006af1f66fa37$var$RetryFailedLogsTrigger.GainedFocus);
    }
    setLoggingDisabled(isDisabled) {
        this._isLoggingDisabled = isDisabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $415006af1f66fa37$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        this._lastExposureTimeMap = {};
    }
    start() {
        if ((0, $fUe1j._isServerEnv)()) return; // do not run in server environments
        $415006af1f66fa37$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        (0, $hbcuF._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $415006af1f66fa37$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $415006af1f66fa37$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs($415006af1f66fa37$var$RetryFailedLogsTrigger.Startup);
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $415006af1f66fa37$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $415006af1f66fa37$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $415006af1f66fa37$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $415006af1f66fa37$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$415006af1f66fa37$var$EventLogger._safeFlushAndForget(this._sdkKey), $415006af1f66fa37$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        if ((0, $fUe1j._isServerEnv)()) return false; // do not run in server environments
        if (!(0, $6FJ2y._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $7BhXq._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $415006af1f66fa37$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $415006af1f66fa37$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        var _a, _b;
        return $415006af1f66fa37$var$__awaiter(this, void 0, void 0, function*() {
            if (this._isLoggingDisabled) {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $hbcuF._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? yield this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $dKfZk.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $dKfZk.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        var _a;
        return $415006af1f66fa37$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return $415006af1f66fa37$var$__awaiter(this, void 0, void 0, function*() {
            return {
                success: yield this._network.beacon(this._getRequestData(events))
            };
        });
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$84SHL.NetworkParam.EventCount]: String(events.length)
            }
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $415006af1f66fa37$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            (0, $evelF._setObjectInStorage)(storageKey, events);
        } catch (_a) {
            $dKfZk.Log.warn('Unable to save failed logs to storage');
        }
    }
    _retryFailedLogs(trigger) {
        const storageKey = this._getStorageKey();
        (()=>$415006af1f66fa37$var$__awaiter(this, void 0, void 0, function*() {
                if (!$evelF.Storage.isReady()) yield $evelF.Storage.isReadyResolver();
                const events = (0, $evelF._getObjectFromStorage)(storageKey);
                if (!events) return;
                if (trigger === $415006af1f66fa37$var$RetryFailedLogsTrigger.Startup) $evelF.Storage.removeItem(storageKey);
                const isSuccess = yield this._sendEvents(events);
                if (isSuccess && trigger === $415006af1f66fa37$var$RetryFailedLogsTrigger.GainedFocus) $evelF.Storage.removeItem(storageKey);
            }))().catch(()=>{
            $dKfZk.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $8th8c._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $dKfZk.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $fUe1j._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $415006af1f66fa37$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $415006af1f66fa37$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $415006af1f66fa37$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._isLoggingDisabled = (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true;
        this._maxQueueSize = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _a !== void 0 ? _a : $415006af1f66fa37$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $fcm7E.UrlConfiguration($84SHL.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
}
module.exports.EventLogger = $415006af1f66fa37$var$EventLogger;

});
parcelRegister("7BhXq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $8th8c = parcelRequire("8th8c");
function $5889eb1212b9c4c9$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $8th8c._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $5889eb1212b9c4c9$var$_getUserStorageKey;
function $5889eb1212b9c4c9$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $5889eb1212b9c4c9$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $8th8c._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $5889eb1212b9c4c9$var$_getStorageKey;

});
parcelRegister("8th8c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $ika9i = parcelRequire("ika9i");
const $62ae52102e78caa5$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $62ae52102e78caa5$var$_DJB2;
const $62ae52102e78caa5$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $62ae52102e78caa5$var$_DJB2Object;
const $62ae52102e78caa5$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $ika9i._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $62ae52102e78caa5$var$_getSortedObject;

});
parcelRegister("ika9i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $d571f79d4fd57aeb$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $d571f79d4fd57aeb$var$_typeOf;
function $d571f79d4fd57aeb$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $d571f79d4fd57aeb$var$_isTypeMatch;

});



parcelRegister("84SHL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("fUe1j", function(module, exports) {

var $7t0tI = parcelRequire("7t0tI");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $b946f61b14eb9a1f$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $b946f61b14eb9a1f$var$_getWindowSafe;
const $b946f61b14eb9a1f$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $b946f61b14eb9a1f$var$_getDocumentSafe;
const $b946f61b14eb9a1f$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $7t0tI !== 'undefined' && $7t0tI.versions != null && $7t0tI.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $b946f61b14eb9a1f$var$_isServerEnv;
const $b946f61b14eb9a1f$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $b946f61b14eb9a1f$var$_addWindowEventListenerSafe;
const $b946f61b14eb9a1f$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $b946f61b14eb9a1f$var$_addDocumentEventListenerSafe;
const $b946f61b14eb9a1f$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $b946f61b14eb9a1f$var$_getCurrentPageUrlSafe;

});

parcelRegister("6FJ2y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $4db982792e9e136e$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $4db982792e9e136e$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $4db982792e9e136e$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $4db982792e9e136e$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $4db982792e9e136e$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $4db982792e9e136e$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $4db982792e9e136e$var$GATE_EXPOSURE_NAME || eventName === $4db982792e9e136e$var$CONFIG_EXPOSURE_NAME || eventName === $4db982792e9e136e$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $4db982792e9e136e$var$_isExposureEvent;
const $4db982792e9e136e$var$_createGateExposure = (user, gate)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $4db982792e9e136e$var$_createExposure($4db982792e9e136e$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, (_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : []);
};
module.exports._createGateExposure = $4db982792e9e136e$var$_createGateExposure;
const $4db982792e9e136e$var$_createConfigExposure = (user, config)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $4db982792e9e136e$var$_createExposure($4db982792e9e136e$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, (_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : []);
};
module.exports._createConfigExposure = $4db982792e9e136e$var$_createConfigExposure;
const $4db982792e9e136e$var$_createLayerParameterExposure = (user, layer, parameterName)=>{
    var _a, _b, _c, _d;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = evaluation.secondary_exposures;
    }
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_d = layer.__evaluation) === null || _d === void 0 ? void 0 : _d.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $4db982792e9e136e$var$_createExposure($4db982792e9e136e$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, secondaryExposures);
};
module.exports._createLayerParameterExposure = $4db982792e9e136e$var$_createLayerParameterExposure;
const $4db982792e9e136e$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("evelF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $dKfZk = parcelRequire("dKfZk");

var $fUe1j = parcelRequire("fUe1j");
const $a8ef173c839906cb$var$inMemoryStore = {};
const $a8ef173c839906cb$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$a8ef173c839906cb$var$inMemoryStore[key] ? $a8ef173c839906cb$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $a8ef173c839906cb$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $a8ef173c839906cb$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($a8ef173c839906cb$var$inMemoryStore)
};
let $a8ef173c839906cb$var$_localStorageProvider = null;
try {
    const win = (0, $fUe1j._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $a8ef173c839906cb$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $dKfZk.Log.warn('Failed to setup localStorageProvider.');
}
let $a8ef173c839906cb$var$_main = $a8ef173c839906cb$var$_localStorageProvider !== null && $a8ef173c839906cb$var$_localStorageProvider !== void 0 ? $a8ef173c839906cb$var$_localStorageProvider : $a8ef173c839906cb$var$_inMemoryProvider;
let $a8ef173c839906cb$var$_current = $a8ef173c839906cb$var$_main;
function $a8ef173c839906cb$var$_inMemoryBreaker(get) {
    try {
        return get();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($a8ef173c839906cb$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$a8ef173c839906cb$var$_current.isReady(),
    isReadyResolver: ()=>$a8ef173c839906cb$var$_current.isReadyResolver(),
    getProviderName: ()=>$a8ef173c839906cb$var$_current.getProviderName(),
    getItem: (key)=>$a8ef173c839906cb$var$_inMemoryBreaker(()=>$a8ef173c839906cb$var$_current.getItem(key)),
    setItem: (key, value)=>$a8ef173c839906cb$var$_current.setItem(key, value),
    removeItem: (key)=>$a8ef173c839906cb$var$_current.removeItem(key),
    getAllKeys: ()=>$a8ef173c839906cb$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $a8ef173c839906cb$var$_main = newProvider;
        $a8ef173c839906cb$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $a8ef173c839906cb$var$_current = $a8ef173c839906cb$var$_inMemoryProvider;
        else $a8ef173c839906cb$var$_current = $a8ef173c839906cb$var$_main;
    }
};
function $a8ef173c839906cb$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    return JSON.parse(value !== null && value !== void 0 ? value : 'null');
}
module.exports._getObjectFromStorage = $a8ef173c839906cb$var$_getObjectFromStorage;
function $a8ef173c839906cb$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $a8ef173c839906cb$var$_setObjectInStorage;

});

parcelRegister("fcm7E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $84SHL = parcelRequire("84SHL");
const $b109230fb1c67322$var$ENDPOINT_DNS_KEY_MAP = {
    [$84SHL.Endpoint._initialize]: 'i',
    [$84SHL.Endpoint._rgstr]: 'e',
    [$84SHL.Endpoint._download_config_specs]: 'd'
};
class $b109230fb1c67322$var$UrlConfiguration {
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $b109230fb1c67322$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $84SHL.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
}
module.exports.UrlConfiguration = $b109230fb1c67322$var$UrlConfiguration;

});

parcelRegister("hbcuF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $fUe1j = parcelRequire("fUe1j");
const $c81d27bc6c76b098$var$FOREGROUND = 'foreground';
const $c81d27bc6c76b098$var$BACKGROUND = 'background';
const $c81d27bc6c76b098$var$LISTENERS = [];
let $c81d27bc6c76b098$var$current = $c81d27bc6c76b098$var$FOREGROUND;
let $c81d27bc6c76b098$var$isUnloading = false;
const $c81d27bc6c76b098$var$_isCurrentlyVisible = ()=>{
    return $c81d27bc6c76b098$var$current === $c81d27bc6c76b098$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $c81d27bc6c76b098$var$_isCurrentlyVisible;
const $c81d27bc6c76b098$var$_isUnloading = ()=>$c81d27bc6c76b098$var$isUnloading;
module.exports._isUnloading = $c81d27bc6c76b098$var$_isUnloading;
const $c81d27bc6c76b098$var$_subscribeToVisiblityChanged = (listener)=>{
    $c81d27bc6c76b098$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $c81d27bc6c76b098$var$_subscribeToVisiblityChanged;
const $c81d27bc6c76b098$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $c81d27bc6c76b098$var$current) return;
    $c81d27bc6c76b098$var$current = visibility;
    $c81d27bc6c76b098$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $c81d27bc6c76b098$var$_notifyVisibilityChanged;
(0, $fUe1j._addWindowEventListenerSafe)('focus', ()=>{
    $c81d27bc6c76b098$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($c81d27bc6c76b098$var$FOREGROUND);
});
(0, $fUe1j._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($c81d27bc6c76b098$var$BACKGROUND));
(0, $fUe1j._addWindowEventListenerSafe)('beforeunload', ()=>{
    $c81d27bc6c76b098$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($c81d27bc6c76b098$var$BACKGROUND);
});
(0, $fUe1j._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $c81d27bc6c76b098$var$FOREGROUND : $c81d27bc6c76b098$var$BACKGROUND);
});

});


parcelRegister("3P9ly", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.12.0';
let $2c8d628c8fcb2405$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$2c8d628c8fcb2405$var$metadata,
    add: (additions)=>{
        $2c8d628c8fcb2405$var$metadata = Object.assign(Object.assign({}, $2c8d628c8fcb2405$var$metadata), additions);
    }
};

});

parcelRegister("g6Qpu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8irt5", function(module, exports) {
"use strict";
var $60a54fbf08a7efbd$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $dKfZk = parcelRequire("dKfZk");

var $ka2Xl = parcelRequire("ka2Xl");

var $6dczM = parcelRequire("6dczM");

var $evelF = parcelRequire("evelF");

var $hArLP = parcelRequire("hArLP");
const $60a54fbf08a7efbd$var$CACHE_LIMIT = 10;
class $60a54fbf08a7efbd$var$DataAdapterCore {
    attach(sdkKey, options) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $6dczM._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache) {
            this._inMemoryCache.add(cacheKey, cache);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $6dczM._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $60a54fbf08a7efbd$var$_makeDataAdapterResult('Bootstrap', data, null, normalized));
    }
    _getDataAsyncImpl(current, user, options) {
        return $60a54fbf08a7efbd$var$__awaiter(this, void 0, void 0, function*() {
            if (!$evelF.Storage.isReady()) yield $evelF.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $dKfZk.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $60a54fbf08a7efbd$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $6dczM._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }));
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $60a54fbf08a7efbd$var$__awaiter(this, void 0, void 0, function*() {
            let cachedData = null;
            if (cachedResult && this._isCachedResultValidFor204(cachedResult, user)) cachedData = cachedResult.data;
            const latest = yield this._fetchFromNetwork(cachedData, user, options);
            if (!latest) {
                $dKfZk.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $hArLP._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $ka2Xl.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $60a54fbf08a7efbd$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $60a54fbf08a7efbd$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $dKfZk.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $evelF.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($evelF.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $hArLP._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        $evelF.Storage.setItem(cacheKey, JSON.stringify(result));
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $evelF._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictable = $60a54fbf08a7efbd$var$_getEvictableKey(lastModifiedTimeMap, $60a54fbf08a7efbd$var$CACHE_LIMIT);
        if (evictable) {
            delete lastModifiedTimeMap[evictable];
            $evelF.Storage.removeItem(evictable);
        }
        (0, $evelF._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $60a54fbf08a7efbd$var$InMemoryCache();
    }
}
module.exports.DataAdapterCore = $60a54fbf08a7efbd$var$DataAdapterCore;
function $60a54fbf08a7efbd$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $6dczM._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $60a54fbf08a7efbd$var$_makeDataAdapterResult;
class $60a54fbf08a7efbd$var$InMemoryCache {
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $dKfZk.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value) {
        const oldest = $60a54fbf08a7efbd$var$_getEvictableKey(this._data, $60a54fbf08a7efbd$var$CACHE_LIMIT - 1);
        if (oldest) delete this._data[oldest];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
    constructor(){
        this._data = {};
    }
}
function $60a54fbf08a7efbd$var$_getEvictableKey(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return null;
    return keys.reduce((prevKey, currKey)=>{
        const prev = data[prevKey];
        const current = data[currKey];
        if (typeof prev === 'object' && typeof current === 'object') return current.receivedAt < prev.receivedAt ? currKey : prevKey;
        return current < prev ? currKey : prevKey;
    });
}

});
parcelRegister("ka2Xl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StableID = void 0;

var $7BhXq = parcelRequire("7BhXq");

var $dKfZk = parcelRequire("dKfZk");

var $evelF = parcelRequire("evelF");

var $8Wl5a = parcelRequire("8Wl5a");
const $ead708db837a7304$var$PROMISE_MAP = {};
module.exports.StableID = {
    get: (sdkKey)=>{
        if ($ead708db837a7304$var$PROMISE_MAP[sdkKey] == null) {
            let stableID = $ead708db837a7304$var$_loadFromStorage(sdkKey);
            if (stableID == null) {
                stableID = (0, $8Wl5a.getUUID)();
                $ead708db837a7304$var$_persistToStorage(stableID, sdkKey);
            }
            $ead708db837a7304$var$PROMISE_MAP[sdkKey] = stableID;
        }
        return $ead708db837a7304$var$PROMISE_MAP[sdkKey];
    },
    setOverride: (override, sdkKey)=>{
        $ead708db837a7304$var$PROMISE_MAP[sdkKey] = override;
        $ead708db837a7304$var$_persistToStorage(override, sdkKey);
    }
};
function $ead708db837a7304$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $7BhXq._getStorageKey)(sdkKey)}`;
}
function $ead708db837a7304$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $ead708db837a7304$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $evelF._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $dKfZk.Log.warn('Failed to save StableID');
    }
}
function $ead708db837a7304$var$_loadFromStorage(sdkKey) {
    const storageKey = $ead708db837a7304$var$_getStableIDStorageKey(sdkKey);
    return (0, $evelF._getObjectFromStorage)(storageKey);
}

});
parcelRegister("8Wl5a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $682418029ca2d969$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $682418029ca2d969$var$getUUID;

});


parcelRegister("6dczM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $8th8c = parcelRequire("8th8c");

var $dKfZk = parcelRequire("dKfZk");
function $485db65721984d8c$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $dKfZk.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $485db65721984d8c$var$_normalizeUser;
function $485db65721984d8c$var$_getFullUserHash(user) {
    return user ? (0, $8th8c._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $485db65721984d8c$var$_getFullUserHash;

});

parcelRegister("hArLP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $dKfZk = parcelRequire("dKfZk");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $ccdb5716d8feb4d0$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $dKfZk.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $ccdb5716d8feb4d0$var$_typedJsonParse;

});


parcelRegister("gB2DH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("d9t4Z", function(module, exports) {
"use strict";
var $9932ac2e709c6d75$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $dKfZk = parcelRequire("dKfZk");

var $98Fu0 = parcelRequire("98Fu0");

var $3P9ly = parcelRequire("3P9ly");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $9932ac2e709c6d75$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $9932ac2e709c6d75$var$ErrorBoundary {
    wrap(instance) {
        try {
            const obj = instance;
            $9932ac2e709c6d75$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $9932ac2e709c6d75$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $dKfZk.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$9932ac2e709c6d75$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($9932ac2e709c6d75$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $9932ac2e709c6d75$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $98Fu0.SDKType._get(this._sdkKey);
                    const statsigMetadata = $3P9ly.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $9932ac2e709c6d75$var$_getDescription(unwrapped);
                    const body = JSON.stringify(Object.assign({
                        tag: tag,
                        exception: name,
                        info: info
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    })));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: body
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
}
module.exports.ErrorBoundary = $9932ac2e709c6d75$var$ErrorBoundary;
function $9932ac2e709c6d75$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $9932ac2e709c6d75$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $9932ac2e709c6d75$var$UNKNOWN_ERROR;
    }
}
function $9932ac2e709c6d75$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}

});
parcelRegister("98Fu0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $6a750a165a816528$var$SDK_CLIENT = {};
let $6a750a165a816528$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $6a750a165a816528$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($6a750a165a816528$var$suffix !== null && $6a750a165a816528$var$suffix !== void 0 ? $6a750a165a816528$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $6a750a165a816528$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$6a750a165a816528$var$suffix || $6a750a165a816528$var$suffix === '-react') $6a750a165a816528$var$suffix = '-' + binding;
    }
};

});


parcelRegister("j4YQP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iulmf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("jII1V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hew4l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _layer: 'l',
    _paramStore: 'p'
};
const $c8bc9eb2fc5d5475$var$EXIST_KEYS = new Set([]);
const $c8bc9eb2fc5d5475$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $c8bc9eb2fc5d5475$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($c8bc9eb2fc5d5475$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($c8bc9eb2fc5d5475$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $c8bc9eb2fc5d5475$var$createMemoKey;

});

parcelRegister("lg8MY", function(module, exports) {
"use strict";
var $f7a1e8dfaa22f94f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $8yPXI = parcelRequire("8yPXI");

var $8yPXI = parcelRequire("8yPXI");

var $d5Owr = parcelRequire("d5Owr");

var $dKfZk = parcelRequire("dKfZk");

var $84SHL = parcelRequire("84SHL");

var $gDMr7 = parcelRequire("gDMr7");

var $98Fu0 = parcelRequire("98Fu0");

var $fUe1j = parcelRequire("fUe1j");

var $a9ml1 = parcelRequire("a9ml1");

var $ka2Xl = parcelRequire("ka2Xl");

var $1fK3j = parcelRequire("1fK3j");

var $3P9ly = parcelRequire("3P9ly");

var $hbcuF = parcelRequire("hbcuF");
const $f7a1e8dfaa22f94f$var$DEFAULT_TIMEOUT_MS = 10000;
const $f7a1e8dfaa22f94f$var$BACKOFF_BASE_MS = 500;
const $f7a1e8dfaa22f94f$var$BACKOFF_MAX_MS = 30000;
const $f7a1e8dfaa22f94f$var$RATE_LIMIT_WINDOW_MS = 1000;
const $f7a1e8dfaa22f94f$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $f7a1e8dfaa22f94f$var$LEAK_RATE = $f7a1e8dfaa22f94f$var$RATE_LIMIT_MAX_REQ_COUNT / $f7a1e8dfaa22f94f$var$RATE_LIMIT_WINDOW_MS;
const $f7a1e8dfaa22f94f$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $f7a1e8dfaa22f94f$var$NetworkCore {
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        return $f7a1e8dfaa22f94f$var$__awaiter(this, void 0, void 0, function*() {
            if (!$f7a1e8dfaa22f94f$var$_ensureValidSdkKey(args)) return false;
            const argsInternal = this._getInternalRequestArgs('POST', args);
            const body = yield this._getPopulatedBody(argsInternal, args.data);
            const url = yield this._getPopulatedURL(argsInternal);
            const nav = navigator;
            return nav.sendBeacon.bind(nav)(url, body);
        });
    }
    post(args) {
        return $f7a1e8dfaa22f94f$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            argsInternal.body = yield this._getPopulatedBody(argsInternal, args.data);
            if (args.isStatsigEncodable) argsInternal.body = this._attemptToEncodeString(argsInternal, argsInternal.body);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        var _a, _b, _c, _d;
        return $f7a1e8dfaa22f94f$var$__awaiter(this, void 0, void 0, function*() {
            if (!$f7a1e8dfaa22f94f$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $dKfZk.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            const abortController = typeof AbortController !== 'undefined' ? new AbortController() : null;
            const timeoutHandle = setTimeout(()=>{
                abortController === null || abortController === void 0 || abortController.abort(`Timeout of ${this._timeout}ms expired.`);
            }, this._timeout);
            const populatedUrl = yield this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $hbcuF._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    signal: abortController === null || abortController === void 0 ? void 0 : abortController.signal,
                    priority: args.priority,
                    keepalive: keepalive
                };
                $f7a1e8dfaa22f94f$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                response = yield func(populatedUrl, config);
                clearTimeout(timeoutHandle);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $f7a1e8dfaa22f94f$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $f7a1e8dfaa22f94f$var$_getErrorMessage(abortController, error);
                const timedOut = $f7a1e8dfaa22f94f$var$_didTimeout(abortController);
                $f7a1e8dfaa22f94f$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$f7a1e8dfaa22f94f$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $1fK3j.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $dKfZk.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $f7a1e8dfaa22f94f$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $f7a1e8dfaa22f94f$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $f7a1e8dfaa22f94f$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        return $f7a1e8dfaa22f94f$var$__awaiter(this, void 0, void 0, function*() {
            const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
            if (args.urlConfig.endpoint === $84SHL.Endpoint._initialize || args.urlConfig.endpoint === $84SHL.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
            const params = Object.assign({
                [$84SHL.NetworkParam.SdkKey]: args.sdkKey,
                [$84SHL.NetworkParam.SdkType]: $98Fu0.SDKType._get(args.sdkKey),
                [$84SHL.NetworkParam.SdkVersion]: $3P9ly.SDK_VERSION,
                [$84SHL.NetworkParam.Time]: String(Date.now()),
                [$84SHL.NetworkParam.SessionID]: $a9ml1.SessionID.get(args.sdkKey)
            }, args.params);
            const query = Object.keys(params).map((key)=>{
                return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
            }).join('&');
            return `${url}${query ? `?${query}` : ''}`;
        });
    }
    _getPopulatedBody(args, data) {
        return $f7a1e8dfaa22f94f$var$__awaiter(this, void 0, void 0, function*() {
            const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
            const stableID = $ka2Xl.StableID.get(sdkKey);
            const sessionID = $a9ml1.SessionID.get(sdkKey);
            const sdkType = $98Fu0.SDKType._get(sdkKey);
            return JSON.stringify(Object.assign(Object.assign({}, data), {
                statsigMetadata: Object.assign(Object.assign({}, $3P9ly.StatsigMetadataProvider.get()), {
                    stableID: stableID,
                    sessionID: sessionID,
                    sdkType: sdkType,
                    fallbackUrl: fallbackUrl
                })
            }));
        });
    }
    _attemptToEncodeString(args, input) {
        var _a, _b;
        const win = (0, $fUe1j._getWindowSafe)();
        if (this._options.disableStatsigEncoding || (0, $8yPXI._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return input;
        try {
            const result = (_a = win.btoa(input).split('').reverse().join('')) !== null && _a !== void 0 ? _a : input;
            args.params = Object.assign(Object.assign({}, (_b = args.params) !== null && _b !== void 0 ? _b : {}), {
                [$84SHL.NetworkParam.StatsigEncoded]: '1'
            });
            return result;
        } catch (_c) {
            $dKfZk.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`);
            return input;
        }
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        return Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
    }
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $f7a1e8dfaa22f94f$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $gDMr7.NetworkFallbackResolver(this._options);
    }
}
module.exports.NetworkCore = $f7a1e8dfaa22f94f$var$NetworkCore;
const $f7a1e8dfaa22f94f$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $dKfZk.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
function $f7a1e8dfaa22f94f$var$_getErrorMessage(controller, error) {
    if ((controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string') return controller.signal.reason;
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $f7a1e8dfaa22f94f$var$_didTimeout(controller) {
    const timeout = (controller === null || controller === void 0 ? void 0 : controller.signal.aborted) && typeof controller.signal.reason === 'string' && controller.signal.reason.includes('Timeout');
    return timeout || false;
}
function $f7a1e8dfaa22f94f$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $84SHL.Endpoint._initialize) return;
    $d5Owr.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $f7a1e8dfaa22f94f$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $84SHL.Endpoint._initialize) return;
    $d5Owr.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $d5Owr.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $f7a1e8dfaa22f94f$var$_exponentialBackoff(attempt) {
    return $f7a1e8dfaa22f94f$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($f7a1e8dfaa22f94f$var$BACKOFF_BASE_MS * (attempt * attempt), $f7a1e8dfaa22f94f$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("gDMr7", function(module, exports) {
"use strict";
var $c1d5dc58689c2edb$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $1brjh = parcelRequire("1brjh");

var $8th8c = parcelRequire("8th8c");

var $dKfZk = parcelRequire("dKfZk");

var $evelF = parcelRequire("evelF");
const $c1d5dc58689c2edb$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $c1d5dc58689c2edb$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $c1d5dc58689c2edb$var$NetworkFallbackResolver {
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $c1d5dc58689c2edb$var$DEFAULT_TTL_MS;
        $c1d5dc58689c2edb$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $c1d5dc58689c2edb$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0)) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $c1d5dc58689c2edb$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    getFallbackFromProvided(url) {
        const path = $c1d5dc58689c2edb$var$_extractPathFromUrl(url);
        if (path) return url.replace(path, '');
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        var _a, _b;
        return $c1d5dc58689c2edb$var$__awaiter(this, void 0, void 0, function*() {
            try {
                if (!$c1d5dc58689c2edb$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig.endpoint, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, endpoint, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            url: newUrl,
            expiryTime: Date.now() + $c1d5dc58689c2edb$var$DEFAULT_TTL_MS,
            previous: []
        };
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $c1d5dc58689c2edb$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        var _a;
        return $c1d5dc58689c2edb$var$__awaiter(this, void 0, void 0, function*() {
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $c1d5dc58689c2edb$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $1brjh._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $c1d5dc58689c2edb$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
}
module.exports.NetworkFallbackResolver = $c1d5dc58689c2edb$var$NetworkFallbackResolver;
function $c1d5dc58689c2edb$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $c1d5dc58689c2edb$var$_isDomainFailure;
function $c1d5dc58689c2edb$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $8th8c._DJB2)(sdkKey)}`;
}
function $c1d5dc58689c2edb$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $c1d5dc58689c2edb$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $evelF.Storage.removeItem(hashKey);
        return;
    }
    $evelF.Storage.setItem(hashKey, JSON.stringify(info));
}
function $c1d5dc58689c2edb$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $c1d5dc58689c2edb$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $evelF.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $dKfZk.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $c1d5dc58689c2edb$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("1brjh", function(module, exports) {
"use strict";
var $0dcc00b7304b014b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $0dcc00b7304b014b$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $0dcc00b7304b014b$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $0dcc00b7304b014b$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $0dcc00b7304b014b$var$MAX_START_LOOKUP = 200;
function $0dcc00b7304b014b$var$_fetchTxtRecords(networkFunc) {
    return $0dcc00b7304b014b$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($0dcc00b7304b014b$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $0dcc00b7304b014b$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $0dcc00b7304b014b$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $0dcc00b7304b014b$var$_fetchTxtRecords;
function $0dcc00b7304b014b$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $0dcc00b7304b014b$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $0dcc00b7304b014b$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("a9ml1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $7BhXq = parcelRequire("7BhXq");

var $dKfZk = parcelRequire("dKfZk");

var $evelF = parcelRequire("evelF");

var $8Wl5a = parcelRequire("8Wl5a");
const $763c12852b9fe6ed$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $763c12852b9fe6ed$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $763c12852b9fe6ed$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($763c12852b9fe6ed$var$PROMISE_MAP[sdkKey] == null) $763c12852b9fe6ed$var$PROMISE_MAP[sdkKey] = $763c12852b9fe6ed$var$_loadSession(sdkKey);
        const session = $763c12852b9fe6ed$var$PROMISE_MAP[sdkKey];
        return $763c12852b9fe6ed$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $763c12852b9fe6ed$var$PROMISE_MAP[sdkKey] = $763c12852b9fe6ed$var$_overrideSessionId(override, sdkKey);
    }
};
function $763c12852b9fe6ed$var$_loadSession(sdkKey) {
    let data = $763c12852b9fe6ed$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $8Wl5a.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $763c12852b9fe6ed$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $763c12852b9fe6ed$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    if ($763c12852b9fe6ed$var$_isIdle(data) || $763c12852b9fe6ed$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $8Wl5a.getUUID)();
        data.startTime = now;
    }
    data.lastUpdate = now;
    $763c12852b9fe6ed$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    const sdkKey = session.sdkKey;
    session.idleTimeoutID = $763c12852b9fe6ed$var$_createSessionTimeout(sdkKey, $763c12852b9fe6ed$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $763c12852b9fe6ed$var$_createSessionTimeout(sdkKey, $763c12852b9fe6ed$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $763c12852b9fe6ed$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $763c12852b9fe6ed$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $763c12852b9fe6ed$var$MAX_SESSION_IDLE_TIME;
}
function $763c12852b9fe6ed$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $763c12852b9fe6ed$var$MAX_SESSION_AGE;
}
function $763c12852b9fe6ed$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $7BhXq._getStorageKey)(sdkKey)}`;
}
function $763c12852b9fe6ed$var$_persistToStorage(session, sdkKey) {
    const storageKey = $763c12852b9fe6ed$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $evelF._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $dKfZk.Log.warn('Failed to save SessionID');
    }
}
function $763c12852b9fe6ed$var$_loadFromStorage(sdkKey) {
    const storageKey = $763c12852b9fe6ed$var$_getSessionIDStorageKey(sdkKey);
    return (0, $evelF._getObjectFromStorage)(storageKey);
}

});

parcelRegister("1fK3j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("ls7Jz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("b0wpb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("2qRcg", function(module, exports) {
"use strict";
var $1c57463cd8a0052d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $8yPXI = parcelRequire("8yPXI");

var $8yPXI = parcelRequire("8yPXI");

var $d9t4Z = parcelRequire("d9t4Z");

var $5BELe = parcelRequire("5BELe");

var $dKfZk = parcelRequire("dKfZk");

var $hew4l = parcelRequire("hew4l");

var $fUe1j = parcelRequire("fUe1j");

var $a9ml1 = parcelRequire("a9ml1");

var $evelF = parcelRequire("evelF");
const $1c57463cd8a0052d$var$MAX_MEMO_CACHE_SIZE = 3000;
class $1c57463cd8a0052d$var$StatsigClientBase {
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingDisabled(options.disableLogging);
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $evelF.Storage._setDisabled(options.disableStorage);
        }
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $1c57463cd8a0052d$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $dKfZk.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $hew4l.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $1c57463cd8a0052d$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
    constructor(sdkKey, adapter, network, options){
        var _a;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($dKfZk.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $evelF.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $a9ml1.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $evelF.Storage._setProvider(options.storageProvider);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $5BELe.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $d9t4Z.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options);
        this.storageProvider = $evelF.Storage;
        this._primeReadyRipcord();
        $1c57463cd8a0052d$var$_assignGlobalInstance(sdkKey, this);
    }
}
module.exports.StatsigClientBase = $1c57463cd8a0052d$var$StatsigClientBase;
function $1c57463cd8a0052d$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $fUe1j._isServerEnv)()) return;
    const statsigGlobal = (0, $8yPXI._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $dKfZk.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("86xdf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("ec4Cp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("aDzeK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("lPICa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $dKfZk = parcelRequire("dKfZk");

var $ika9i = parcelRequire("ika9i");
const $fe50f7ee99d30314$var$DEFAULT_RULE = 'default';
function $fe50f7ee99d30314$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : $fe50f7ee99d30314$var$DEFAULT_RULE,
        __evaluation: evaluation,
        value: value
    };
}
function $fe50f7ee99d30314$var$_makeFeatureGate(name, details, evaluation) {
    return $fe50f7ee99d30314$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true);
}
module.exports._makeFeatureGate = $fe50f7ee99d30314$var$_makeFeatureGate;
function $fe50f7ee99d30314$var$_makeDynamicConfig(name, details, evaluation) {
    var _a;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $fe50f7ee99d30314$var$_makeEvaluation(name, details, evaluation, value)), {
        get: $fe50f7ee99d30314$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $fe50f7ee99d30314$var$_makeDynamicConfig;
function $fe50f7ee99d30314$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $fe50f7ee99d30314$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $fe50f7ee99d30314$var$_makeExperiment;
function $fe50f7ee99d30314$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $fe50f7ee99d30314$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $fe50f7ee99d30314$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $fe50f7ee99d30314$var$_makeLayer;
function $fe50f7ee99d30314$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $fe50f7ee99d30314$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $fe50f7ee99d30314$var$_mergeOverride;
function $fe50f7ee99d30314$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $ika9i._isTypeMatch)(found, fallback)) {
            $dKfZk.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $fe50f7ee99d30314$var$_makeTypedGet;

});

parcelRegister("ly83U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("82hf6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $5d9be2ab783be511$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $5d9be2ab783be511$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});

parcelRegister("4JZeF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $373add813ab75fa7$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $373add813ab75fa7$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $373add813ab75fa7$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});


parcelRegister("4f7AA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $coIZN = parcelRequire("coIZN");
class $316e73312dc910dc$var$EvaluationStore {
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $coIZN._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        if (!result) return false;
        const values = (0, $coIZN._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        this._values = values;
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        if (values.sdk_flags) $coIZN.SDKFlags.setFlags(this._sdkKey, values.sdk_flags);
        else $coIZN.SDKFlags.setFlags(this._sdkKey, {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.feature_gates, name);
    }
    getConfig(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.dynamic_configs, name);
    }
    getLayer(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.layer_configs, name);
    }
    getParamStore(name) {
        var _a;
        return this._getDetailedStoreResult((_a = this._values) === null || _a === void 0 ? void 0 : _a.param_stores, name);
    }
    getSource() {
        return this._source;
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(lookup, name) {
        let result = null;
        if (lookup) result = lookup[name] ? lookup[name] : lookup[(0, $coIZN._DJB2)(name)];
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a;
        const stableID = $coIZN.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            if ((0, $coIZN._getFullUserHash)(user) !== (0, $coIZN._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
}
module.exports.default = $316e73312dc910dc$var$EvaluationStore;

});

parcelRegister("hqmSa", function(module, exports) {
"use strict";
var $caf69b62afa3977e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $coIZN = parcelRequire("coIZN");

var $1iI5E = parcelRequire("1iI5E");
class $caf69b62afa3977e$var$StatsigNetwork extends $coIZN.NetworkCore {
    fetchEvaluations(sdkKey, current, priority, user) {
        return $caf69b62afa3977e$var$__awaiter(this, void 0, void 0, function*() {
            const cache = current ? (0, $coIZN._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) data = Object.assign(Object.assign({}, data), {
                sinceTime: cache.time,
                previousDerivedFields: 'derived_fields' in cache ? cache.derived_fields : {},
                deltasResponseRequested: true,
                full_checksum: cache.full_checksum
            });
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        var _a, _b;
        return $caf69b62afa3977e$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $1iI5E._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._initializeUrlConfig = new $coIZN.UrlConfiguration($coIZN.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
}
module.exports.default = $caf69b62afa3977e$var$StatsigNetwork;

});
parcelRegister("1iI5E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $coIZN = parcelRequire("coIZN");
const $0f29ac44c40f129b$var$MAX_DELTAS_SORT_DEPTH = 2;
function $0f29ac44c40f129b$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $coIZN._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $0f29ac44c40f129b$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $0f29ac44c40f129b$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $coIZN._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $0f29ac44c40f129b$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $0f29ac44c40f129b$var$_resolveDeltasResponse;
function $0f29ac44c40f129b$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $0f29ac44c40f129b$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $0f29ac44c40f129b$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $0f29ac44c40f129b$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $0f29ac44c40f129b$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $0f29ac44c40f129b$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("jgFRq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $coIZN = parcelRequire("coIZN");
const $e06ffb9697fa2029$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $e06ffb9697fa2029$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $e06ffb9697fa2029$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $coIZN._isTypeMatch)(value, fallback);
}
function $e06ffb9697fa2029$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $e06ffb9697fa2029$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $e06ffb9697fa2029$var$_shouldLogExposure(options) ? undefined : $e06ffb9697fa2029$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $e06ffb9697fa2029$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $e06ffb9697fa2029$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($e06ffb9697fa2029$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($e06ffb9697fa2029$var$_shouldLogExposure(options)) client.getDynamicConfig(param.config_name);
    return value;
}
function $e06ffb9697fa2029$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $e06ffb9697fa2029$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($e06ffb9697fa2029$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($e06ffb9697fa2029$var$_shouldLogExposure(options)) client.getExperiment(param.experiment_name);
    return value;
}
function $e06ffb9697fa2029$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $e06ffb9697fa2029$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($e06ffb9697fa2029$var$_shouldReturnFallback(value, fallback)) return fallback;
    if ($e06ffb9697fa2029$var$_shouldLogExposure(options)) client.getLayer(param.layer_name).get(param.param_name);
    return value;
}
function $e06ffb9697fa2029$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $coIZN._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $e06ffb9697fa2029$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $e06ffb9697fa2029$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $e06ffb9697fa2029$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $e06ffb9697fa2029$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $e06ffb9697fa2029$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $e06ffb9697fa2029$var$_makeParamStoreGetter;

});

parcelRegister("7Ffp3", function(module, exports) {
"use strict";
var $59484f7c7e50b972$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $coIZN = parcelRequire("coIZN");

var $hqmSa = parcelRequire("hqmSa");
class $59484f7c7e50b972$var$StatsigEvaluationsDataAdapter extends $coIZN.DataAdapterCore {
    attach(sdkKey, options) {
        super.attach(sdkKey, options);
        this._network = new $hqmSa.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $coIZN._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $coIZN._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $coIZN.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options) {
        var _a;
        return $59484f7c7e50b972$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $coIZN._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$coIZN.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $coIZN._getFullUserHash)(user);
    }
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
}
module.exports.StatsigEvaluationsDataAdapter = $59484f7c7e50b972$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("ejm2K", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a6b3f05e2c6d4d08$export$2e2bcd8739ae039; });

var $hiPA7 = parcelRequire("hiPA7");

var $2871N = parcelRequire("2871N");

var $lUar6 = parcelRequire("lUar6");

var $WZI3E = parcelRequire("WZI3E");
function $a6b3f05e2c6d4d08$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a6b3f05e2c6d4d08$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a6b3f05e2c6d4d08$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a6b3f05e2c6d4d08$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a6b3f05e2c6d4d08$export$a66cbd9b2289cd78 = '@all-features';
var $a6b3f05e2c6d4d08$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, $hiPA7.default)(this, Subscriptions);
        (0, $lUar6.default)(this, "eventToValue", new Map());
        this.emitter = new (0, $WZI3E.EventEmitter2)();
    }
    return (0, $2871N.default)(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $a6b3f05e2c6d4d08$var$_objectSpread($a6b3f05e2c6d4d08$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $a6b3f05e2c6d4d08$var$_objectSpread($a6b3f05e2c6d4d08$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $a6b3f05e2c6d4d08$var$_objectSpread($a6b3f05e2c6d4d08$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $a6b3f05e2c6d4d08$var$_objectSpread($a6b3f05e2c6d4d08$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($a6b3f05e2c6d4d08$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($a6b3f05e2c6d4d08$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($a6b3f05e2c6d4d08$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $a6b3f05e2c6d4d08$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
}();

});

parcelRegister("5Hljh", function(module, exports) {
$parcel$export(module.exports, "DynamicConfig", function () { return $42617f9fadde6d7e$export$6dc24881a3d96325; });

var $85tTb = parcelRequire("85tTb");

var $hiPA7 = parcelRequire("hiPA7");

var $2871N = parcelRequire("2871N");

var $avpcy = parcelRequire("avpcy");
var $42617f9fadde6d7e$export$6dc24881a3d96325 = /*#__PURE__*/ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails) {
        var secondaryExposures = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
        var allocatedExperimentName = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
        var onDefaultValueFallback = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
        (0, $hiPA7.default)(this, DynamicConfig);
        this.value = configValue;
        this._name = configName;
        this._ruleID = ruleID;
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    return (0, $2871N.default)(DynamicConfig, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this$_onDefaultValue2;
                var val = this.getValue(key, defaultValue);
                if (val == null) return defaultValue;
                var expectedType = Array.isArray(defaultValue) ? 'array' : (0, $85tTb.default)(defaultValue);
                var actualType = Array.isArray(val) ? 'array' : (0, $85tTb.default)(val);
                if (typeGuard) {
                    var _this$_onDefaultValue;
                    if (typeGuard(val)) {
                        this.fireExposure(key);
                        return val;
                    }
                    (_this$_onDefaultValue = this._onDefaultValueFallback) === null || _this$_onDefaultValue === void 0 || _this$_onDefaultValue.call(this, this, key, expectedType, actualType);
                    return defaultValue;
                }
                if (defaultValue == null || expectedType === actualType) {
                    this.fireExposure(key);
                    return val;
                }
                (_this$_onDefaultValue2 = this._onDefaultValueFallback) === null || _this$_onDefaultValue2 === void 0 || _this$_onDefaultValue2.call(this, this, key, expectedType, actualType);
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                if (key == null) return this.value;
                if (defaultValue == null) defaultValue = null;
                if (this.value[key] == null) return defaultValue;
                this.fireExposure(key);
                return this.value[key];
            }
        },
        {
            key: "fireExposure",
            value: function fireExposure(key) {
                // Call the wrapped experiment's get method to fire exposure
                if (this.experiment) this.experiment.get(key);
            }
        }
    ], [
        {
            key: "fromExperiment",
            value: function fromExperiment(experiment) {
                var _experiment$__evaluat, _experiment$groupName;
                var config = new DynamicConfig(experiment.name, experiment.value, experiment.ruleID, (0, $avpcy.migrateEvaluationDetails)(experiment.details), (_experiment$__evaluat = experiment.__evaluation) === null || _experiment$__evaluat === void 0 ? void 0 : _experiment$__evaluat.secondary_exposures, (_experiment$groupName = experiment.groupName) !== null && _experiment$groupName !== void 0 ? _experiment$groupName : undefined);
                config.experiment = experiment;
                return config;
            }
        }
    ]);
}();

});
parcelRegister("avpcy", function(module, exports) {
$parcel$export(module.exports, "getOptionsWithDefaults", function () { return $7a6059199f1dd839$export$d119b37e5f788b43; });
$parcel$export(module.exports, "shallowEquals", function () { return $7a6059199f1dd839$export$fa1c2bbf4100b8bc; });
$parcel$export(module.exports, "toStatsigUser", function () { return $7a6059199f1dd839$export$3dad1db244472f32; });
$parcel$export(module.exports, "migrateInitializationOptions", function () { return $7a6059199f1dd839$export$202946b690d26d22; });
$parcel$export(module.exports, "migrateEvaluationDetails", function () { return $7a6059199f1dd839$export$18ad168d3dbac899; });

var $6Kejc = parcelRequire("6Kejc");

var $f2kyT = parcelRequire("f2kyT");

var $lUar6 = parcelRequire("lUar6");

var $ixyZs = parcelRequire("ixyZs");

var $84QfO = parcelRequire("84QfO");

var $YUUrb = parcelRequire("YUUrb");

var $dxLzm = parcelRequire("dxLzm");
var $7a6059199f1dd839$var$_excluded = [
    "api",
    "disableCurrentPageLogging",
    "loggingIntervalMillis",
    "loggingBufferMaxSize",
    "localMode",
    "eventLoggingApi",
    "eventLoggingApiForRetries",
    "disableLocalStorage",
    "ignoreWindowUndefined",
    "disableAllLogging",
    "initTimeoutMs",
    "disableNetworkKeepalive",
    "overrideStableID",
    "disableErrorLogging",
    "disableAutoMetricsLogging"
];
function $7a6059199f1dd839$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7a6059199f1dd839$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7a6059199f1dd839$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7a6059199f1dd839$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7a6059199f1dd839$export$d119b37e5f788b43 = function getOptionsWithDefaults(options) {
    return $7a6059199f1dd839$var$_objectSpread({
        /**
     * If more federal PerimeterTypes are added in the future, this should be updated so
     * that isFedRamp() === true always returns the strictest perimeter.
     */ perimeter: (0, $84QfO.isFedRamp)() ? (0, $dxLzm.PerimeterType).FEDRAMP_MODERATE : (0, $dxLzm.PerimeterType).COMMERCIAL
    }, options);
};
var $7a6059199f1dd839$export$fa1c2bbf4100b8bc = function shallowEquals(objectA, objectB) {
    if (!objectA && !objectB) return true;
    if (!objectA || !objectB) return false;
    var aEntries = Object.entries(objectA);
    var bEntries = Object.entries(objectB);
    if (aEntries.length !== bEntries.length) return false;
    var ascendingKeyOrder = function ascendingKeyOrder(_ref, _ref2) {
        var _ref3 = (0, $f2kyT.default)(_ref, 1), key1 = _ref3[0];
        var _ref4 = (0, $f2kyT.default)(_ref2, 1), key2 = _ref4[0];
        return key1.localeCompare(key2);
    };
    aEntries.sort(ascendingKeyOrder);
    bEntries.sort(ascendingKeyOrder);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = (0, $f2kyT.default)(aEntries[i], 2), aValue = _aEntries$i[1];
        var _bEntries$i = (0, $f2kyT.default)(bEntries[i], 2), bValue = _bEntries$i[1];
        if (aValue !== bValue) return false;
    }
    return true;
};
var $7a6059199f1dd839$export$3dad1db244472f32 = function toStatsigUser(identifiers, customAttributes, sdkKey) {
    var user = {
        customIDs: !(customAttributes !== null && customAttributes !== void 0 && customAttributes.stableID) && sdkKey ? $7a6059199f1dd839$var$_objectSpread({
            stableID: (0, $ixyZs.StableID).get(sdkKey)
        }, identifiers) : identifiers,
        custom: customAttributes
    };
    if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
    return user;
};
var $7a6059199f1dd839$export$202946b690d26d22 = function migrateInitializationOptions(options) {
    var api = options.api, disableCurrentPageLogging = options.disableCurrentPageLogging, loggingIntervalMillis = options.loggingIntervalMillis, loggingBufferMaxSize = options.loggingBufferMaxSize, localMode = options.localMode, eventLoggingApi = options.eventLoggingApi, eventLoggingApiForRetries = options.eventLoggingApiForRetries, disableLocalStorage = options.disableLocalStorage, ignoreWindowUndefined = options.ignoreWindowUndefined, disableAllLogging = options.disableAllLogging, _initTimeoutMs = options.initTimeoutMs, _disableNetworkKeepalive = options.disableNetworkKeepalive, _overrideStableID = options.overrideStableID, _disableErrorLogging = options.disableErrorLogging, _disableAutoMetricsLogging = options.disableAutoMetricsLogging, rest = (0, $6Kejc.default)(options, $7a6059199f1dd839$var$_excluded);
    return $7a6059199f1dd839$var$_objectSpread($7a6059199f1dd839$var$_objectSpread({}, rest), {}, {
        networkConfig: {
            api: api,
            logEventUrl: eventLoggingApi ? eventLoggingApi + 'rgstr' : undefined,
            logEventFallbackUrls: eventLoggingApiForRetries ? [
                eventLoggingApiForRetries
            ] : undefined,
            preventAllNetworkTraffic: localMode || !ignoreWindowUndefined && typeof window === 'undefined'
        },
        includeCurrentPageUrlWithEvents: !disableCurrentPageLogging,
        loggingIntervalMs: loggingIntervalMillis,
        loggingBufferMaxSize: loggingBufferMaxSize,
        disableStorage: disableLocalStorage === undefined ? localMode : disableLocalStorage,
        disableLogging: disableAllLogging === undefined ? localMode : disableAllLogging
    });
};
var $7a6059199f1dd839$var$evaluationReasonMappings = Object.entries((0, $YUUrb.EvaluationReason)).map(function(_ref5) {
    var _ref6 = (0, $f2kyT.default)(_ref5, 2), key = _ref6[0], value = _ref6[1];
    return [
        key.toLowerCase(),
        value
    ];
});
var $7a6059199f1dd839$export$18ad168d3dbac899 = function migrateEvaluationDetails(details) {
    var _evaluationReasonMapp, _evaluationReasonMapp2, _details$receivedAt;
    var reasonLower = details.reason.toLowerCase();
    return {
        reason: (_evaluationReasonMapp = (_evaluationReasonMapp2 = $7a6059199f1dd839$var$evaluationReasonMappings.find(function(_ref7) {
            var _ref8 = (0, $f2kyT.default)(_ref7, 1), key = _ref8[0];
            return reasonLower.includes(key);
        })) === null || _evaluationReasonMapp2 === void 0 ? void 0 : _evaluationReasonMapp2[1]) !== null && _evaluationReasonMapp !== void 0 ? _evaluationReasonMapp : (0, $YUUrb.EvaluationReason).Unknown,
        time: (_details$receivedAt = details.receivedAt) !== null && _details$receivedAt !== void 0 ? _details$receivedAt : Date.now()
    };
};

});
parcelRegister("84QfO", function(module, exports) {
$parcel$export(module.exports, "isFedRamp", function () { return $5e173b0030ccb0aa$export$64d6499adf9b2e51; });

var $bQweT = parcelRequire("bQweT");
function $5e173b0030ccb0aa$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $bQweT.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("bQweT", function(module, exports) {
$parcel$export(module.exports, "FEDRAMP_MODERATE", function () { return $89fd8f1904fc0227$export$ce553301d55c2fd8; });
var $89fd8f1904fc0227$export$ce553301d55c2fd8 = 'fedramp-moderate';
var $89fd8f1904fc0227$export$f005e2e9f707cb5f = 'commercial';
var $89fd8f1904fc0227$export$bd6b5a7802d76127 = 'fedramp-fedex';
var $89fd8f1904fc0227$export$a739cd5aac835909 = 'stg';
var $89fd8f1904fc0227$export$42dd0cdd351a4a9 = 'prod';
var $89fd8f1904fc0227$export$404582bc18fe4d9e = 'dev';

});


parcelRegister("YUUrb", function(module, exports) {
$parcel$export(module.exports, "EvaluationReason", function () { return $0b71bfb58a9a196a$export$c62558b199e46828; });
// Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigStore.ts
var $0b71bfb58a9a196a$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    EvaluationReason["Error"] = "Error";
    EvaluationReason["LocalOverride"] = "LocalOverride";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["Network"] = "Network";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["Cache"] = "Cache";
    EvaluationReason["Unknown"] = "Unknown";
    return EvaluationReason;
}({}); // Reference: https://github.com/statsig-io/js-lite/blob/main/src/StatsigSDKOptions.ts

});

parcelRegister("dxLzm", function(module, exports) {
$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $9dc341b403ce1a2a$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $9dc341b403ce1a2a$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $9dc341b403ce1a2a$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $9dc341b403ce1a2a$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $9dc341b403ce1a2a$export$42f4885608027d0c = 'non_boolean'; // Type magic to get the JSDoc comments from the Client class methods to appear on the static
 // methods in FeatureGates where the property name and function type are identical

});



parcelRegister("9NHwM", function(module, exports) {
$parcel$export(module.exports, "Layer", function () { return $722a745bda2e41b7$export$936d0764594b6eb3; });

var $85tTb = parcelRequire("85tTb");

var $hiPA7 = parcelRequire("hiPA7");

var $2871N = parcelRequire("2871N");

var $avpcy = parcelRequire("avpcy");
var $722a745bda2e41b7$export$936d0764594b6eb3 = /*#__PURE__*/ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails) {
        var logParameterFunction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        var secondaryExposures = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
        var undelegatedSecondaryExposures = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];
        var allocatedExperimentName = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : '';
        var explicitParameters = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : [];
        (0, $hiPA7.default)(this, Layer);
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : '';
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    return (0, $2871N.default)(Layer, [
        {
            key: "get",
            value: function get(key, defaultValue, typeGuard) {
                var _this = this;
                var val = this._value[key];
                if (val == null) return defaultValue;
                var logAndReturn = function logAndReturn() {
                    _this._logLayerParameterExposure(key);
                    return val;
                };
                if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
                if (defaultValue == null) return logAndReturn();
                if ((0, $85tTb.default)(val) === (0, $85tTb.default)(defaultValue) && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
                return defaultValue;
            }
        },
        {
            key: "getValue",
            value: function getValue(key, defaultValue) {
                // eslint-disable-next-line eqeqeq
                if (defaultValue == undefined) defaultValue = null;
                var val = this._value[key];
                if (val != null) this._logLayerParameterExposure(key);
                return val !== null && val !== void 0 ? val : defaultValue;
            }
        },
        {
            key: "_logLayerParameterExposure",
            value: function _logLayerParameterExposure(parameterName) {
                var _this$_logParameterFu;
                (_this$_logParameterFu = this._logParameterFunction) === null || _this$_logParameterFu === void 0 || _this$_logParameterFu.call(this, this, parameterName);
            }
        }
    ], [
        {
            key: "fromLayer",
            value: function fromLayer(layer) {
                var _layer$__evaluation, _layer$__evaluation2, _layer$__evaluation3, _layer$__evaluation4;
                var value = new Layer(layer.name, layer.__value, layer.ruleID, (0, $avpcy.migrateEvaluationDetails)(layer.details), function(_layer, parameterName) {
                    return layer.get(parameterName);
                }, (_layer$__evaluation = layer.__evaluation) === null || _layer$__evaluation === void 0 ? void 0 : _layer$__evaluation.secondary_exposures, (_layer$__evaluation2 = layer.__evaluation) === null || _layer$__evaluation2 === void 0 ? void 0 : _layer$__evaluation2.undelegated_secondary_exposures, (_layer$__evaluation3 = layer.__evaluation) === null || _layer$__evaluation3 === void 0 ? void 0 : _layer$__evaluation3.allocated_experiment_name, (_layer$__evaluation4 = layer.__evaluation) === null || _layer$__evaluation4 === void 0 ? void 0 : _layer$__evaluation4.explicit_parameters);
                return value;
            }
        }
    ]);
}();

});

parcelRegister("hMIHi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cf29974de0f90663$export$2e2bcd8739ae039; });

var $lUar6 = parcelRequire("lUar6");

var $ge1fS = parcelRequire("ge1fS");

var $hiPA7 = parcelRequire("hiPA7");

var $2871N = parcelRequire("2871N");

var $dzfsB = parcelRequire("dzfsB");

var $dxLzm = parcelRequire("dxLzm");

var $ikbTQ = parcelRequire("ikbTQ");

var $l4E6s = parcelRequire("l4E6s");
function $cf29974de0f90663$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cf29974de0f90663$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cf29974de0f90663$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cf29974de0f90663$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $cf29974de0f90663$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $cf29974de0f90663$export$250a58ecde616daa = 'https://api.atlassian.com/flags';
var $cf29974de0f90663$export$942ba04389b0d5a2 = 'https://api.stg.atlassian.com/flags';
var $cf29974de0f90663$export$f058dbf75c3bc647 = 'https://api.dev.atlassian.com/flags';
var $cf29974de0f90663$export$1a401a0da8da3565 = 'https://api.stg.atlassian-us-gov-mod.com/flags';
var $cf29974de0f90663$export$18c93900db9358a4 = 'https://api.atlassian-us-gov-mod.com/flags';
var $cf29974de0f90663$export$450bd8fb2a6d7ace = '/gateway/api/flags';
var $cf29974de0f90663$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, $hiPA7.default)(this, Fetcher);
    }
    return (0, $2871N.default)(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, 'GET', fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error('Failed to retrieve client sdk key');
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest('/api/v2/frontend/experimentValues', 'POST', fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error('Failed to retrieve experiment values');
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $l4E6s.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $l4E6s.ResponseError)('Unexpected 204 response');
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                if (useGatewayUrl) return $cf29974de0f90663$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $dxLzm.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $dxLzm.FeatureGateEnvironment).Production:
                        return $cf29974de0f90663$export$18c93900db9358a4;
                    case (0, $dxLzm.FeatureGateEnvironment).Staging:
                        return $cf29974de0f90663$export$1a401a0da8da3565;
                    default:
                        throw new Error("Invalid environment \"".concat(serviceEnv, "\" for \"").concat(perimeter, "\" perimeter"));
                }
                else if (perimeter === (0, $dxLzm.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $dxLzm.FeatureGateEnvironment).Development:
                        return $cf29974de0f90663$export$f058dbf75c3bc647;
                    case (0, $dxLzm.FeatureGateEnvironment).Staging:
                        return $cf29974de0f90663$export$942ba04389b0d5a2;
                    default:
                        return $cf29974de0f90663$export$250a58ecde616daa;
                }
                else throw new Error("Invalid perimeter \"".concat(perimeter, "\""));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $cf29974de0f90663$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $cf29974de0f90663$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'X-Client-Name': 'feature-gate-js-client',
                                        'X-Client-Version': (0, $ikbTQ.CLIENT_VERSION),
                                        'X-API-KEY': fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x10) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        }
    ]);
}();

});
parcelRegister("ikbTQ", function(module, exports) {
$parcel$export(module.exports, "CLIENT_VERSION", function () { return $d5735347f2f09d62$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $d5735347f2f09d62$export$a59f8d67326bd1cb = "4.26.5";

});

parcelRegister("l4E6s", function(module, exports) {
$parcel$export(module.exports, "ResponseError", function () { return $f5791453ceb15a51$export$286baf652d0b1206; });

var $2871N = parcelRequire("2871N");

var $hiPA7 = parcelRequire("hiPA7");

var $eDhqJ = parcelRequire("eDhqJ");

var $aDM8J = parcelRequire("aDM8J");

var $cxyvF = parcelRequire("cxyvF");

var $3rO3z = parcelRequire("3rO3z");
function $f5791453ceb15a51$var$_callSuper(t, o, e) {
    return o = (0, $aDM8J.default)(o), (0, $eDhqJ.default)(t, $f5791453ceb15a51$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $aDM8J.default)(t).constructor) : o.apply(t, e));
}
function $f5791453ceb15a51$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f5791453ceb15a51$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $f5791453ceb15a51$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    function ResponseError(message) {
        (0, $hiPA7.default)(this, ResponseError);
        return $f5791453ceb15a51$var$_callSuper(this, ResponseError, [
            message
        ]);
    }
    (0, $cxyvF.default)(ResponseError, _Error);
    return (0, $2871N.default)(ResponseError);
}(/*#__PURE__*/ (0, $3rO3z.default)(Error));

});
parcelRegister("eDhqJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $aa723a79c340cf69$export$2e2bcd8739ae039; });

var $85tTb = parcelRequire("85tTb");

var $df1RQ = parcelRequire("df1RQ");
function $aa723a79c340cf69$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $85tTb.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $df1RQ.default)(t);
}

});
parcelRegister("df1RQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9a3e1fe85263c1c2$export$2e2bcd8739ae039; });
function $9a3e1fe85263c1c2$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("aDM8J", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7bf2e37c237558d2$export$2e2bcd8739ae039; });
function $7bf2e37c237558d2$export$2e2bcd8739ae039(t) {
    return $7bf2e37c237558d2$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $7bf2e37c237558d2$export$2e2bcd8739ae039(t);
}

});

parcelRegister("cxyvF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9213560266a1a270$export$2e2bcd8739ae039; });

var $17qyB = parcelRequire("17qyB");
function $9213560266a1a270$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $17qyB.default)(t, e);
}

});
parcelRegister("17qyB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0d0b0b914deee1c5$export$2e2bcd8739ae039; });
function $0d0b0b914deee1c5$export$2e2bcd8739ae039(t, e) {
    return $0d0b0b914deee1c5$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0d0b0b914deee1c5$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("3rO3z", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $282ab8eca1b5028a$export$2e2bcd8739ae039; });

var $aDM8J = parcelRequire("aDM8J");

var $17qyB = parcelRequire("17qyB");

var $8ifhb = parcelRequire("8ifhb");

var $3c9AN = parcelRequire("3c9AN");
function $282ab8eca1b5028a$export$2e2bcd8739ae039(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return $282ab8eca1b5028a$export$2e2bcd8739ae039 = function _wrapNativeSuper(t) {
        if (null === t || !(0, $8ifhb.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, $3c9AN.default)(t, arguments, (0, $aDM8J.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, $17qyB.default)(Wrapper, t);
    }, $282ab8eca1b5028a$export$2e2bcd8739ae039(t);
}

});
parcelRegister("8ifhb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $609bdaacd5967278$export$2e2bcd8739ae039; });
function $609bdaacd5967278$export$2e2bcd8739ae039(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

});

parcelRegister("3c9AN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2539eef062e954d6$export$2e2bcd8739ae039; });

var $lr0kd = parcelRequire("lr0kd");

var $17qyB = parcelRequire("17qyB");
function $2539eef062e954d6$export$2e2bcd8739ae039(t, e, r) {
    if ((0, $lr0kd.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, $17qyB.default)(p, r.prototype), p;
}

});
parcelRegister("lr0kd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f9ac5f1f2daedc35$export$2e2bcd8739ae039; });
function $f9ac5f1f2daedc35$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f9ac5f1f2daedc35$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});





parcelRegister("l5iWb", function(module, exports) {
$parcel$export(module.exports, "NoFetchDataAdapter", function () { return $f598c12b31cbf4ff$export$55fffef3474104af; });

var $ge1fS = parcelRequire("ge1fS");

var $hiPA7 = parcelRequire("hiPA7");

var $2871N = parcelRequire("2871N");

var $eDhqJ = parcelRequire("eDhqJ");

var $aDM8J = parcelRequire("aDM8J");

var $hql6f = parcelRequire("hql6f");

var $cxyvF = parcelRequire("cxyvF");

var $lUar6 = parcelRequire("lUar6");

var $dzfsB = parcelRequire("dzfsB");

var $ixyZs = parcelRequire("ixyZs");
function $f598c12b31cbf4ff$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f598c12b31cbf4ff$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f598c12b31cbf4ff$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f598c12b31cbf4ff$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f598c12b31cbf4ff$var$_callSuper(t, o, e) {
    return o = (0, $aDM8J.default)(o), (0, $eDhqJ.default)(t, $f598c12b31cbf4ff$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $aDM8J.default)(t).constructor) : o.apply(t, e));
}
function $f598c12b31cbf4ff$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f598c12b31cbf4ff$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $f598c12b31cbf4ff$var$_superPropGet(t, o, e, r) {
    var p = (0, $hql6f.default)((0, $aDM8J.default)(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
var $f598c12b31cbf4ff$export$55fffef3474104af = /*#__PURE__*/ function(_DataAdapterCore) {
    function NoFetchDataAdapter() {
        var _this;
        (0, $hiPA7.default)(this, NoFetchDataAdapter);
        _this = $f598c12b31cbf4ff$var$_callSuper(this, NoFetchDataAdapter, [
            'NoFetchDataAdapter',
            'nofetch'
        ]);
        (0, $lUar6.default)(_this, "bootstrapResult", null);
        return _this;
    }
    /**
   * Make sure to call this **before** calling `initializeAsync` or `updateUserAsync` but
   * after the Statsig client has been created!
   */ (0, $cxyvF.default)(NoFetchDataAdapter, _DataAdapterCore);
    return (0, $2871N.default)(NoFetchDataAdapter, [
        {
            key: "setBootstrapData",
            value: function setBootstrapData(data) {
                this.bootstrapResult = data ? {
                    source: 'Bootstrap',
                    data: JSON.stringify(data),
                    receivedAt: Date.now(),
                    stableID: (0, $ixyZs.StableID).get(this._getSdkKey()),
                    fullUserHash: null
                } : null;
            }
        },
        {
            key: "prefetchData",
            value: function() {
                var _prefetchData = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee(_user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function prefetchData(_x, _x2) {
                    return _prefetchData.apply(this, arguments);
                }
                return prefetchData;
            }()
        },
        {
            key: "getDataAsync",
            value: function() {
                var _getDataAsync = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee2(_current, user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                return _context2.abrupt("return", this.bootstrapResult && $f598c12b31cbf4ff$var$_objectSpread($f598c12b31cbf4ff$var$_objectSpread({}, this.bootstrapResult), {}, {
                                    fullUserHash: (0, $ixyZs._getFullUserHash)(user)
                                }));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getDataAsync(_x3, _x4, _x5) {
                    return _getDataAsync.apply(this, arguments);
                }
                return getDataAsync;
            }()
        },
        {
            key: "getDataSync",
            value: function getDataSync(user) {
                return this.bootstrapResult && $f598c12b31cbf4ff$var$_objectSpread($f598c12b31cbf4ff$var$_objectSpread({}, this.bootstrapResult), {}, {
                    fullUserHash: (0, $ixyZs._getFullUserHash)(user)
                });
            }
        },
        {
            key: "_fetchFromNetwork",
            value: function() {
                var _fetchFromNetwork2 = (0, $ge1fS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).mark(function _callee3(_current, _user, _options) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($dzfsB))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                return _context3.abrupt("return", null);
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function _fetchFromNetwork(_x6, _x7, _x8) {
                    return _fetchFromNetwork2.apply(this, arguments);
                }
                return _fetchFromNetwork;
            }()
        },
        {
            key: "_getCacheKey",
            value: function _getCacheKey(user) {
                // Same logic as default data adapter
                // https://github.com/statsig-io/js-client-monorepo/blob/main/packages/js-client/src/StatsigEvaluationsDataAdapter.ts
                var key = (0, $ixyZs._getStorageKey)(this._getSdkKey(), user);
                return "".concat((0, $ixyZs.DataAdapterCachePrefix), ".").concat(this._cacheSuffix, ".").concat(key);
            }
        },
        {
            key: "_isCachedResultValidFor204",
            value: function _isCachedResultValidFor204(_result, _user) {
                return false;
            }
        },
        {
            key: "setDataLegacy",
            value: function setDataLegacy(data, user) {
                $f598c12b31cbf4ff$var$_superPropGet(NoFetchDataAdapter, "setData", this, 3)([
                    data,
                    user
                ]);
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                var result = $f598c12b31cbf4ff$var$_objectSpread({}, this);
                delete result._options;
                delete result._inMemoryCache;
                delete result.bootstrapResult;
                return result;
            }
        }
    ]);
}((0, $ixyZs.DataAdapterCore));

});
parcelRegister("hql6f", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $034605161834b266$export$2e2bcd8739ae039; });

var $7DtDI = parcelRequire("7DtDI");
function $034605161834b266$export$2e2bcd8739ae039() {
    return $034605161834b266$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $7DtDI.default)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $034605161834b266$export$2e2bcd8739ae039.apply(null, arguments);
}

});
parcelRegister("7DtDI", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $58f32abf1a4b899b$export$2e2bcd8739ae039; });

var $aDM8J = parcelRequire("aDM8J");
function $58f32abf1a4b899b$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $aDM8J.default)(t)););
    return t;
}

});



parcelRegister("9DTa6", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_KEY", function () { return $70528b901f7cdeb2$export$d8474cff104280f3; });
$parcel$export(module.exports, "PersistentOverrideAdapter", function () { return $70528b901f7cdeb2$export$bcb28fbac1def494; });

var $lUar6 = parcelRequire("lUar6");

var $f2kyT = parcelRequire("f2kyT");

var $hiPA7 = parcelRequire("hiPA7");

var $2871N = parcelRequire("2871N");

var $coIZN = parcelRequire("coIZN");
function $70528b901f7cdeb2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $70528b901f7cdeb2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $70528b901f7cdeb2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $70528b901f7cdeb2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $70528b901f7cdeb2$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $70528b901f7cdeb2$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $70528b901f7cdeb2$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $70528b901f7cdeb2$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $70528b901f7cdeb2$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $70528b901f7cdeb2$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $70528b901f7cdeb2$var$LOCAL_OVERRIDE_REASON = 'LocalOverride:Recognized';
var $70528b901f7cdeb2$export$d8474cff104280f3 = 'STATSIG_OVERRIDES';
var $70528b901f7cdeb2$var$LEGACY_LOCAL_STORAGE_KEY = 'STATSIG_JS_LITE_LOCAL_OVERRIDES';
var $70528b901f7cdeb2$var$makeEmptyStore = function makeEmptyStore() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
};
var $70528b901f7cdeb2$var$djb2MapKey = function djb2MapKey(hash, kind) {
    return kind + ':' + hash;
};
var $70528b901f7cdeb2$export$bcb28fbac1def494 = /*#__PURE__*/ function() {
    function PersistentOverrideAdapter(localStorageKey) {
        (0, $hiPA7.default)(this, PersistentOverrideAdapter);
        this._overrides = $70528b901f7cdeb2$var$makeEmptyStore();
        this._djb2Map = new Map();
        this._localStorageKey = localStorageKey;
    }
    return (0, $2871N.default)(PersistentOverrideAdapter, [
        {
            key: "parseStoredOverrides",
            value: function parseStoredOverrides(localStorageKey) {
                try {
                    var json = window.localStorage.getItem(localStorageKey);
                    if (!json) return $70528b901f7cdeb2$var$makeEmptyStore();
                    return JSON.parse(json);
                } catch (_unused) {
                    return $70528b901f7cdeb2$var$makeEmptyStore();
                }
            }
        },
        {
            key: "mergeOverrides",
            value: function mergeOverrides() {
                var merged = $70528b901f7cdeb2$var$makeEmptyStore();
                for(var _len = arguments.length, allOverrides = new Array(_len), _key = 0; _key < _len; _key++)allOverrides[_key] = arguments[_key];
                for(var _i = 0, _allOverrides = allOverrides; _i < _allOverrides.length; _i++){
                    var overrides = _allOverrides[_i];
                    for(var _i2 = 0, _Object$entries = Object.entries((_overrides$gates = overrides.gates) !== null && _overrides$gates !== void 0 ? _overrides$gates : {}); _i2 < _Object$entries.length; _i2++){
                        var _overrides$gates;
                        var _Object$entries$_i = (0, $f2kyT.default)(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                        merged.gates[name] = value;
                    }
                    for(var _i3 = 0, _Object$entries2 = Object.entries((_overrides$configs = overrides.configs) !== null && _overrides$configs !== void 0 ? _overrides$configs : {}); _i3 < _Object$entries2.length; _i3++){
                        var _overrides$configs;
                        var _Object$entries2$_i = (0, $f2kyT.default)(_Object$entries2[_i3], 2), _name = _Object$entries2$_i[0], _value = _Object$entries2$_i[1];
                        merged.configs[_name] = _value;
                    }
                    for(var _i4 = 0, _Object$entries3 = Object.entries((_overrides$layers = overrides.layers) !== null && _overrides$layers !== void 0 ? _overrides$layers : {}); _i4 < _Object$entries3.length; _i4++){
                        var _overrides$layers;
                        var _Object$entries3$_i = (0, $f2kyT.default)(_Object$entries3[_i4], 2), _name2 = _Object$entries3$_i[0], _value2 = _Object$entries3$_i[1];
                        merged.layers[_name2] = _value2;
                    }
                }
                return merged;
            }
        },
        {
            key: "initFromStoredOverrides",
            value: function initFromStoredOverrides() {
                var storedOverrides = this.mergeOverrides(this._overrides, this.parseStoredOverrides($70528b901f7cdeb2$var$LEGACY_LOCAL_STORAGE_KEY), this.parseStoredOverrides(this._localStorageKey));
                // Clear data from legacy local storage key now we've read from it.
                // This prevents things being stuck in there that are always read but never written to.
                try {
                    window.localStorage.removeItem($70528b901f7cdeb2$var$LEGACY_LOCAL_STORAGE_KEY);
                } catch (_unused2) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
                // In version 4.24.0 we introduced hashes in this override adapter, but had a bug which would cause
                // multiple hashes to continue being created. This code here removes these hashes since we've moved
                // to using a more reliable and easier to maintain map in `_djb2Map`.
                for(var _i5 = 0, _Object$values = Object.values(storedOverrides); _i5 < _Object$values.length; _i5++){
                    var container = _Object$values[_i5];
                    var allKeys = new Set(Object.keys(container));
                    var _iterator = $70528b901f7cdeb2$var$_createForOfIteratorHelper(allKeys), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var name = _step.value;
                            var hash = (0, $coIZN._DJB2)(name);
                            if (allKeys.has(hash)) delete container[hash];
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                this.applyOverrides(storedOverrides);
            }
        },
        {
            key: "saveOverrides",
            value: function saveOverrides() {
                try {
                    window.localStorage.setItem(this._localStorageKey, JSON.stringify(this._overrides));
                } catch (_unused3) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return this.mergeOverrides(this._overrides);
            }
        },
        {
            key: "applyOverrides",
            value: function applyOverrides(overrides) {
                var newOverrides = $70528b901f7cdeb2$var$_objectSpread($70528b901f7cdeb2$var$_objectSpread({}, $70528b901f7cdeb2$var$makeEmptyStore()), overrides);
                this._djb2Map.clear();
                for(var _i6 = 0, _Object$entries4 = Object.entries(newOverrides); _i6 < _Object$entries4.length; _i6++){
                    var _Object$entries4$_i = (0, $f2kyT.default)(_Object$entries4[_i6], 2), containerName = _Object$entries4$_i[0], container = _Object$entries4$_i[1];
                    for(var _i7 = 0, _Object$entries5 = Object.entries(container); _i7 < _Object$entries5.length; _i7++){
                        var _Object$entries5$_i = (0, $f2kyT.default)(_Object$entries5[_i7], 2), name = _Object$entries5$_i[0], value = _Object$entries5$_i[1];
                        this._djb2Map.set($70528b901f7cdeb2$var$djb2MapKey((0, $coIZN._DJB2)(name), containerName), value);
                    }
                }
                this._overrides = newOverrides;
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                this.applyOverrides(overrides);
                this.saveOverrides();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(name, value) {
                this._overrides.gates[name] = value;
                this._djb2Map.set($70528b901f7cdeb2$var$djb2MapKey((0, $coIZN._DJB2)(name), 'gates'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeGateOverride",
            value: function removeGateOverride(name) {
                delete this._overrides.gates[name];
                this._djb2Map.delete($70528b901f7cdeb2$var$djb2MapKey((0, $coIZN._DJB2)(name), 'gates'));
                this.saveOverrides();
            }
        },
        {
            key: "getGateOverride",
            value: function getGateOverride(current, _user) {
                var _this$_overrides$gate;
                var overridden = (_this$_overrides$gate = this._overrides.gates[current.name]) !== null && _this$_overrides$gate !== void 0 ? _this$_overrides$gate : this._djb2Map.get($70528b901f7cdeb2$var$djb2MapKey(current.name, 'gates'));
                if (overridden == null) return null;
                return $70528b901f7cdeb2$var$_objectSpread($70528b901f7cdeb2$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    details: $70528b901f7cdeb2$var$_objectSpread($70528b901f7cdeb2$var$_objectSpread({}, current.details), {}, {
                        reason: $70528b901f7cdeb2$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "overrideDynamicConfig",
            value: function overrideDynamicConfig(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($70528b901f7cdeb2$var$djb2MapKey((0, $coIZN._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeDynamicConfigOverride",
            value: function removeDynamicConfigOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($70528b901f7cdeb2$var$djb2MapKey((0, $coIZN._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getDynamicConfigOverride",
            value: function getDynamicConfigOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideExperiment",
            value: function overrideExperiment(name, value) {
                this._overrides.configs[name] = value;
                this._djb2Map.set($70528b901f7cdeb2$var$djb2MapKey((0, $coIZN._DJB2)(name), 'configs'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeExperimentOverride",
            value: function removeExperimentOverride(name) {
                delete this._overrides.configs[name];
                this._djb2Map.delete($70528b901f7cdeb2$var$djb2MapKey((0, $coIZN._DJB2)(name), 'configs'));
                this.saveOverrides();
            }
        },
        {
            key: "getExperimentOverride",
            value: function getExperimentOverride(current, _user) {
                return this._getConfigOverride(current, this._overrides.configs);
            }
        },
        {
            key: "overrideLayer",
            value: function overrideLayer(name, value) {
                this._overrides.layers[name] = value;
                this._djb2Map.set($70528b901f7cdeb2$var$djb2MapKey((0, $coIZN._DJB2)(name), 'layers'), value);
                this.saveOverrides();
            }
        },
        {
            key: "removeLayerOverride",
            value: function removeLayerOverride(name) {
                delete this._overrides.layers[name];
                this._djb2Map.delete($70528b901f7cdeb2$var$djb2MapKey((0, $coIZN._DJB2)(name), 'layers'));
                this.saveOverrides();
            }
        },
        {
            key: "removeAllOverrides",
            value: function removeAllOverrides() {
                this._overrides = $70528b901f7cdeb2$var$makeEmptyStore();
                try {
                    window.localStorage.removeItem(this._localStorageKey);
                } catch (_unused4) {
                // ignored - window is not defined in non-browser environments, and we don't save things there
                // (things like SSR, etc)
                }
            }
        },
        {
            key: "getLayerOverride",
            value: function getLayerOverride(current, _user) {
                var _this$_overrides$laye;
                var overridden = (_this$_overrides$laye = this._overrides.layers[current.name]) !== null && _this$_overrides$laye !== void 0 ? _this$_overrides$laye : this._djb2Map.get($70528b901f7cdeb2$var$djb2MapKey(current.name, 'layers'));
                if (overridden == null) return null;
                return $70528b901f7cdeb2$var$_objectSpread($70528b901f7cdeb2$var$_objectSpread({}, current), {}, {
                    __value: overridden,
                    get: (0, $coIZN._makeTypedGet)(current.name, overridden),
                    details: $70528b901f7cdeb2$var$_objectSpread($70528b901f7cdeb2$var$_objectSpread({}, current.details), {}, {
                        reason: $70528b901f7cdeb2$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        },
        {
            key: "_getConfigOverride",
            value: function _getConfigOverride(current, lookup) {
                var _lookup$current$name;
                var overridden = (_lookup$current$name = lookup[current.name]) !== null && _lookup$current$name !== void 0 ? _lookup$current$name : this._djb2Map.get($70528b901f7cdeb2$var$djb2MapKey(current.name, 'configs'));
                if (overridden == null) return null;
                return $70528b901f7cdeb2$var$_objectSpread($70528b901f7cdeb2$var$_objectSpread({}, current), {}, {
                    value: overridden,
                    get: (0, $coIZN._makeTypedGet)(current.name, overridden),
                    details: $70528b901f7cdeb2$var$_objectSpread($70528b901f7cdeb2$var$_objectSpread({}, current.details), {}, {
                        reason: $70528b901f7cdeb2$var$LOCAL_OVERRIDE_REASON
                    })
                });
            }
        }
    ]);
}();

});




parcelRegister("lLlF4", function(module, exports) {
$parcel$export(module.exports, "getDarkModeLCHColor", function () { return $fd7eca4049a3fec7$export$a5065c3b8aacaf99; });
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
var $fd7eca4049a3fec7$var$clamp = function clamp(i, min, max) {
    return Math.round(Math.min(Math.max(i, min), max));
};
var $fd7eca4049a3fec7$var$expandShorthandHex = function expandShorthandHex(input) {
    return input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
};
var $fd7eca4049a3fec7$var$rgbFromHex = function rgbFromHex(input) {
    var fullHex = $fd7eca4049a3fec7$var$expandShorthandHex(input);
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
var $fd7eca4049a3fec7$var$rgbToHex = function rgbToHex(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    var convertComponent = function convertComponent(c) {
        var cBase16 = c.toString(16);
        return cBase16.length === 1 ? "0".concat(cBase16) : cBase16;
    };
    return "#".concat(convertComponent(r)).concat(convertComponent(g)).concat(convertComponent(b));
};
var $fd7eca4049a3fec7$var$rgbToXyz = function rgbToXyz(rgb) {
    var convertRgbComponent = function convertRgbComponent(c) {
        return c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    };
    var convertXyzComponent = function convertXyzComponent(c) {
        return c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    };
    var r = convertRgbComponent(rgb.r / 255);
    var g = convertRgbComponent(rgb.g / 255);
    var b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
var $fd7eca4049a3fec7$var$xyzToLab = function xyzToLab(_ref2) {
    var x = _ref2.x, y = _ref2.y, z = _ref2.z;
    return {
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    };
};
var $fd7eca4049a3fec7$var$labToLch = function labToLch(_ref3) {
    var l = _ref3.l, a = _ref3.a, b = _ref3.b;
    var h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    var c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
var $fd7eca4049a3fec7$var$lchToLab = function lchToLab(_ref4) {
    var l = _ref4.l, c = _ref4.c, h = _ref4.h;
    var convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
var $fd7eca4049a3fec7$var$labToXyz = function labToXyz(_ref5) {
    var l = _ref5.l, a = _ref5.a, b = _ref5.b;
    var convertComponent = function convertComponent(c) {
        return c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    };
    var y = (l + 16) / 116;
    var x = a / 500 + y;
    var z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
var $fd7eca4049a3fec7$var$xyzToRgb = function xyzToRgb(_ref6) {
    var x = _ref6.x, y = _ref6.y, z = _ref6.z;
    var convertComponent = function convertComponent(c) {
        return 255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    };
    return {
        r: $fd7eca4049a3fec7$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $fd7eca4049a3fec7$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $fd7eca4049a3fec7$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
var $fd7eca4049a3fec7$var$rgbToLch = function rgbToLch(rgb) {
    return $fd7eca4049a3fec7$var$labToLch($fd7eca4049a3fec7$var$xyzToLab($fd7eca4049a3fec7$var$rgbToXyz(rgb)));
};
var $fd7eca4049a3fec7$var$lchToRgb = function lchToRgb(lch) {
    return $fd7eca4049a3fec7$var$xyzToRgb($fd7eca4049a3fec7$var$labToXyz($fd7eca4049a3fec7$var$lchToLab(lch)));
};
var $fd7eca4049a3fec7$export$313b8a8fcb34c3b8 = function clampLightness(color, newPercent) {
    var rgb = $fd7eca4049a3fec7$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    var lch = $fd7eca4049a3fec7$var$rgbToLch(rgb);
    lch.l = $fd7eca4049a3fec7$var$clamp(newPercent, 0, 100);
    return $fd7eca4049a3fec7$var$rgbToHex($fd7eca4049a3fec7$var$lchToRgb(lch));
};
var $fd7eca4049a3fec7$var$getLightness = function getLightness(color) {
    var rgb = $fd7eca4049a3fec7$var$rgbFromHex(color);
    if (rgb === null) return 0;
    var lch = $fd7eca4049a3fec7$var$rgbToLch(rgb);
    return lch.l;
};
var $fd7eca4049a3fec7$export$a5065c3b8aacaf99 = function getDarkModeLCHColor(currentBackgroundColor) {
    var lightness = $fd7eca4049a3fec7$var$getLightness(currentBackgroundColor);
    var newLightness = Math.abs(100 - lightness);
    return $fd7eca4049a3fec7$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});


parcelRegister("kbSWt", function(module, exports) {
$parcel$export(module.exports, "getSchemaBasedOnStage", function () { return $eb2f74121992e86c$export$fd147e7d448dea03; });
$parcel$export(module.exports, "defaultSchema", function () { return $eb2f74121992e86c$export$1db618b7b2275ea1; });

var $dWJ7u = parcelRequire("dWJ7u");

var $3DDez = parcelRequire("3DDez");
var $eLCEH = parcelRequire("eLCEH");
var $eHCHz = parcelRequire("eHCHz");
var $6YP3g = parcelRequire("6YP3g");
var $cJpLB = parcelRequire("cJpLB");
var $4wcds = parcelRequire("4wcds");

var $k7PLp = parcelRequire("k7PLp");
var $eb2f74121992e86c$var$getDefaultSchemaConfig = function getDefaultSchemaConfig() {
    var defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'blockTaskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
var $eb2f74121992e86c$export$e4e3ac1fa64862db = $eb2f74121992e86c$var$getDefaultSchemaConfig();
var $eb2f74121992e86c$export$fd147e7d448dea03 = (0, $dWJ7u.default)(function() {
    var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'final';
    var defaultSchemaConfig = $eb2f74121992e86c$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $eHCHz.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $eLCEH.multiBodiedExtension),
        extensionFrame: (0, $eLCEH.extensionFrame),
        expand: (0, $3DDez.expandWithNestedExpand),
        listItem: (0, $6YP3g.listItemWithDecisionStage0),
        table: (0, $4wcds.tableWithNestedTable),
        tableRow: (0, $4wcds.tableRowWithNestedTable),
        tableCell: (0, $4wcds.tableCellWithNestedTable),
        tableHeader: (0, $4wcds.tableHeaderWithNestedTable),
        syncBlock: (0, $cJpLB.syncBlock)
    };
    return (0, $k7PLp.createSchema)(defaultSchemaConfig);
});
var $eb2f74121992e86c$export$1db618b7b2275ea1 = $eb2f74121992e86c$export$fd147e7d448dea03();

});
parcelRegister("eLCEH", function(module, exports) {
$parcel$export(module.exports, "extensionFrame", function () { return $ac0370a394496a48$export$4fdcae991fd743e7; });
$parcel$export(module.exports, "multiBodiedExtension", function () { return $ac0370a394496a48$export$c3c04d555a8b9013; });

var $2GR0h = parcelRequire("2GR0h");

var $kBUhU = parcelRequire("kBUhU");
var $ac0370a394496a48$export$4fdcae991fd743e7 = (0, $kBUhU.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $ac0370a394496a48$export$c3c04d555a8b9013 = (0, $kBUhU.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $2GR0h.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});
parcelRegister("2GR0h", function(module, exports) {
$parcel$export(module.exports, "getExtensionAttrs", function () { return $1f589e6c6e605bbe$export$1765e2758fc47004; });
var $1f589e6c6e605bbe$export$d5f21755dc782a4a = function isValidLayout(name) {
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
var $1f589e6c6e605bbe$export$1765e2758fc47004 = function getExtensionAttrs(dom) {
    var isInline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var extensionType = dom.getAttribute('data-extension-type');
    var extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    var attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        var rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $1f589e6c6e605bbe$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});


parcelRegister("eHCHz", function(module, exports) {
$parcel$export(module.exports, "layoutSection", function () { return $ab431a2eeda26515$export$b3b6a70a7fa4a5be; });
$parcel$export(module.exports, "layoutSectionWithSingleColumn", function () { return $ab431a2eeda26515$export$4f9d8f623ff17117; });

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
var $ab431a2eeda26515$export$b3b6a70a7fa4a5be = (0, $kBUhU.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $ab431a2eeda26515$export$cdae19acb0a520fd = (0, $kBUhU.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $ab431a2eeda26515$export$4f9d8f623ff17117 = (0, $kBUhU.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: function getAttrs(dom) {
                var columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        var columnRuleStyle = node.attrs.columnRuleStyle;
        var attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $ab431a2eeda26515$export$d9d3c69a64270b13 = (0, $kBUhU.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: function getAttrs() {
                var localId = (0, $6BQ2f.uuid).generate();
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-layout-section': 'true',
            'data-local-id': localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $ab431a2eeda26515$export$64facded20dfd85c = (0, $kBUhU.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: function getAttrs(dom) {
                var columnRuleStyle = dom.getAttribute('data-column-rule-style');
                var localId = (0, $6BQ2f.uuid).generate();
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle,
                    localId: localId
                } : {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var columnRuleStyle = node.attrs.columnRuleStyle;
        var attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("6YP3g", function(module, exports) {
$parcel$export(module.exports, "listItem", function () { return $514ff277bc4bfcb0$export$76c7e83ecc9cdf05; });
$parcel$export(module.exports, "listItemWithDecisionStage0", function () { return $514ff277bc4bfcb0$export$b2cd54d5ce935ddb; });

var $6BQ2f = parcelRequire("6BQ2f");

var $kBUhU = parcelRequire("kBUhU");
var $514ff277bc4bfcb0$export$76c7e83ecc9cdf05 = (0, $kBUhU.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM: function toDOM() {
        return [
            'li',
            0
        ];
    }
});
var $514ff277bc4bfcb0$export$483d52f09158e61c = (0, $kBUhU.listItem)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            'li',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
});
var $514ff277bc4bfcb0$export$b2cd54d5ce935ddb = (0, $kBUhU.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM: function toDOM() {
        return [
            'li',
            0
        ];
    }
});
var $514ff277bc4bfcb0$export$394466eb252d967a = (0, $kBUhU.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        return [
            'li',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
});

});

parcelRegister("cJpLB", function(module, exports) {
$parcel$export(module.exports, "syncBlock", function () { return $944dacbe1a0675eb$export$faab0ca9701d7048; });

var $kBUhU = parcelRequire("kBUhU");
var $944dacbe1a0675eb$export$faab0ca9701d7048 = (0, $kBUhU.syncBlockStage0)({
    parseDOM: [
        {
            tag: 'div[data-sync-block]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute('data-local-id') || '',
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, resourceId = _node$attrs.resourceId;
        var name = 'div';
        var attrs = {
            'data-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs
        ];
    }
});

});

parcelRegister("k7PLp", function(module, exports) {
$parcel$export(module.exports, "createSchema", function () { return $ea6c9d424e7ad31d$export$5f4ce795563f4211; });

var $lS2Ah = parcelRequire("lS2Ah");

var $8nxpJ = parcelRequire("8nxpJ");

var $qsOOQ = parcelRequire("qsOOQ");

var $lViup = parcelRequire("lViup");
var $eqTLo = parcelRequire("eqTLo");
var $eDSjJ = parcelRequire("eDSjJ");
var $aeCl0 = parcelRequire("aeCl0");
var $katgg = parcelRequire("katgg");
var $jFxRM = parcelRequire("jFxRM");
var $lKBoM = parcelRequire("lKBoM");
var $9IIGI = parcelRequire("9IIGI");
var $149IY = parcelRequire("149IY");
var $2fgwX = parcelRequire("2fgwX");
var $8fG3I = parcelRequire("8fG3I");
var $iq9Qk = parcelRequire("iq9Qk");
var $ePva4 = parcelRequire("ePva4");
var $lRUiz = parcelRequire("lRUiz");
var $39DbY = parcelRequire("39DbY");
var $Zlz1l = parcelRequire("Zlz1l");
var $1dh1S = parcelRequire("1dh1S");
var $de0jf = parcelRequire("de0jf");
var $lJr9t = parcelRequire("lJr9t");
var $eLNZQ = parcelRequire("eLNZQ");

var $jfFQb = parcelRequire("jfFQb");
var $dHPQp = parcelRequire("dHPQp");
var $dBvx2 = parcelRequire("dBvx2");
var $grATT = parcelRequire("grATT");
var $wMi1h = parcelRequire("wMi1h");
var $fyWnE = parcelRequire("fyWnE");
var $5I8NU = parcelRequire("5I8NU");
var $cKqLv = parcelRequire("cKqLv");
var $dpTXx = parcelRequire("dpTXx");
var $2KJuI = parcelRequire("2KJuI");
var $aZXDV = parcelRequire("aZXDV");
var $2q06n = parcelRequire("2q06n");
var $3Jgg7 = parcelRequire("3Jgg7");
var $6fNob = parcelRequire("6fNob");
var $dHtch = parcelRequire("dHtch");
var $3DDez = parcelRequire("3DDez");
var $aR5Ot = parcelRequire("aR5Ot");
var $lda36 = parcelRequire("lda36");
var $4yVpE = parcelRequire("4yVpE");
var $eLCEH = parcelRequire("eLCEH");
var $l33q8 = parcelRequire("l33q8");
var $aTrNU = parcelRequire("aTrNU");
var $7VNHO = parcelRequire("7VNHO");
var $dBZQS = parcelRequire("dBZQS");
var $3Xv5B = parcelRequire("3Xv5B");
var $aVWaY = parcelRequire("aVWaY");
var $eHCHz = parcelRequire("eHCHz");
var $6YP3g = parcelRequire("6YP3g");
var $4LvHO = parcelRequire("4LvHO");
var $3VwoG = parcelRequire("3VwoG");
var $2QkN1 = parcelRequire("2QkN1");
var $ePmJY = parcelRequire("ePmJY");
var $1H3wm = parcelRequire("1H3wm");
var $8J4kG = parcelRequire("8J4kG");
var $jPLYd = parcelRequire("jPLYd");
var $cpq1I = parcelRequire("cpq1I");
var $78PuG = parcelRequire("78PuG");
var $hgqzw = parcelRequire("hgqzw");
var $39Ojv = parcelRequire("39Ojv");
var $cJpLB = parcelRequire("cJpLB");
var $4wcds = parcelRequire("4wcds");
var $b9bGn = parcelRequire("b9bGn");
var $g9gj0 = parcelRequire("g9gj0");
var $5ilw1 = parcelRequire("5ilw1");
var $eeCoC = parcelRequire("eeCoC");
var $73gy7 = parcelRequire("73gy7");
function $ea6c9d424e7ad31d$var$addItems(builtInItems, config) {
    var customSpecs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ var items = builtInItems.reduce(function(items, _ref) {
        var name = _ref.name, spec = _ref.spec;
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce(function(items, name) {
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $ea6c9d424e7ad31d$var$groupDeclaration(name) {
    return {
        name: "__".concat(name, "GroupDeclaration"),
        spec: {
            group: name
        }
    };
}
var $ea6c9d424e7ad31d$var$markGroupDeclarations = [
    $ea6c9d424e7ad31d$var$groupDeclaration((0, $8nxpJ.COLOR)),
    $ea6c9d424e7ad31d$var$groupDeclaration((0, $8nxpJ.FONT_STYLE)),
    $ea6c9d424e7ad31d$var$groupDeclaration((0, $8nxpJ.SEARCH_QUERY)),
    $ea6c9d424e7ad31d$var$groupDeclaration((0, $8nxpJ.LINK))
];
var $ea6c9d424e7ad31d$var$markGroupDeclarationsNames = $ea6c9d424e7ad31d$var$markGroupDeclarations.map(function(groupMark) {
    return groupMark.name;
});
var $ea6c9d424e7ad31d$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $3Jgg7.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $cpq1I.paragraph)
    },
    {
        name: 'text',
        spec: (0, $g9gj0.text)
    },
    {
        name: 'bulletList',
        spec: (0, $grATT.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $jPLYd.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $6YP3g.listItem)
    },
    {
        name: 'heading',
        spec: (0, $aTrNU.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $aR5Ot.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $fyWnE.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $lda36.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $hgqzw.rule)
    },
    {
        name: 'image',
        spec: (0, $7VNHO.image)
    },
    {
        name: 'mention',
        spec: (0, $1H3wm.mention)
    },
    {
        name: 'caption',
        spec: (0, $wMi1h.caption)
    },
    {
        name: 'media',
        spec: (0, $4LvHO.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $3VwoG.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $ePmJY.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $2QkN1.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $78PuG.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $eHCHz.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $aVWaY.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $l33q8.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $dHtch.emoji)
    },
    {
        name: 'table',
        spec: (0, $4wcds.table)
    },
    {
        name: 'tableCell',
        spec: (0, $4wcds.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $4wcds.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $4wcds.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $5I8NU.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $dpTXx.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $cKqLv.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $2q06n.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $aZXDV.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $b9bGn.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $dHPQp.taskItem)
    },
    {
        name: 'blockTaskItem',
        spec: (0, $dHPQp.blockTaskItem)
    },
    {
        name: 'date',
        spec: (0, $2KJuI.date)
    },
    {
        name: 'status',
        spec: (0, $39Ojv.status)
    },
    {
        name: 'expand',
        spec: (0, $3DDez.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $8J4kG.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $4yVpE.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $3Xv5B.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $dBvx2.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $eLCEH.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $eLCEH.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $dBZQS.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $jfFQb.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $6fNob.embedCard)
    },
    {
        name: 'syncBlock',
        spec: (0, $cJpLB.syncBlock)
    },
    {
        name: 'unknownBlock',
        spec: (0, $5ilw1.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $eeCoC.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $73gy7.unsupportedInline)
    }
];
var $ea6c9d424e7ad31d$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $iq9Qk.link)
    },
    {
        name: 'em',
        spec: (0, $149IY.em)
    },
    {
        name: 'strong',
        spec: (0, $lRUiz.strong)
    },
    {
        name: 'textColor',
        spec: (0, $Zlz1l.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $eDSjJ.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $ePva4.strike)
    },
    {
        name: 'subsup',
        spec: (0, $39DbY.subsup)
    },
    {
        name: 'underline',
        spec: (0, $de0jf.underline)
    },
    {
        name: 'code',
        spec: (0, $jFxRM.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $1dh1S.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $lViup.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $eqTLo.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $lKBoM.confluenceInlineComment)
    }
].concat($ea6c9d424e7ad31d$var$markGroupDeclarations, [
    {
        name: 'breakout',
        spec: (0, $katgg.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $9IIGI.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $2fgwX.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $8fG3I.indentation)
    },
    {
        name: 'border',
        spec: (0, $aeCl0.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $lJr9t.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $eLNZQ.unsupportedNodeAttribute)
    }
]);
function $ea6c9d424e7ad31d$export$2d0c32a809131488() {
    var nodes = $ea6c9d424e7ad31d$var$nodesInOrder.reduce(function(acc, _ref2) {
        var name = _ref2.name, spec = _ref2.spec;
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    var marks = $ea6c9d424e7ad31d$var$marksInOrder.reduce(function(acc, _ref3) {
        var name = _ref3.name, spec = _ref3.spec;
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $ea6c9d424e7ad31d$export$5f4ce795563f4211(config) {
    var customNodeSpecs = config.customNodeSpecs, customMarkSpecs = config.customMarkSpecs;
    var nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    var marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($ea6c9d424e7ad31d$var$markGroupDeclarationsNames);
    var nodes = $ea6c9d424e7ad31d$var$addItems($ea6c9d424e7ad31d$var$nodesInOrder, nodesConfig, customNodeSpecs);
    var marks = $ea6c9d424e7ad31d$var$addItems($ea6c9d424e7ad31d$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $qsOOQ.sanitizeNodes)(nodes, marks);
    return new (0, $lS2Ah.Schema)({
        nodes: nodes,
        marks: marks
    });
}
var $ea6c9d424e7ad31d$export$c77b6d30da5276a1 = true;

});
parcelRegister("8nxpJ", function(module, exports) {
$parcel$export(module.exports, "FONT_STYLE", function () { return $619a640b0a576b28$export$4498a6080fed604c; });
$parcel$export(module.exports, "SEARCH_QUERY", function () { return $619a640b0a576b28$export$f8e8a5f34f6ea725; });
$parcel$export(module.exports, "LINK", function () { return $619a640b0a576b28$export$b395009ca7f092c7; });
$parcel$export(module.exports, "COLOR", function () { return $619a640b0a576b28$export$9b982809044276a6; });
// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
var $619a640b0a576b28$export$4498a6080fed604c = 'fontStyle';
var $619a640b0a576b28$export$f8e8a5f34f6ea725 = 'searchQuery';
var $619a640b0a576b28$export$b395009ca7f092c7 = 'link';
var $619a640b0a576b28$export$9b982809044276a6 = 'color';
var $619a640b0a576b28$export$470d0905851e47a1 = 'alignment';
var $619a640b0a576b28$export$bacb7f4b06a06b22 = 'indentation';

});

parcelRegister("qsOOQ", function(module, exports) {
$parcel$export(module.exports, "sanitizeNodes", function () { return $04f8c89bec75d36a$export$daf54fed04c8fb77; });

var $fmkKe = parcelRequire("fmkKe");
function $04f8c89bec75d36a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $04f8c89bec75d36a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $04f8c89bec75d36a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fmkKe.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $04f8c89bec75d36a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $04f8c89bec75d36a$export$daf54fed04c8fb77(nodes, supportedMarks) {
    var nodeNames = Object.keys(nodes);
    nodeNames.forEach(function(nodeKey) {
        var nodeSpec = $04f8c89bec75d36a$var$_objectSpread({}, nodes[nodeKey]);
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter(function(mark) {
            return !!supportedMarks[mark];
        }).join(' ');
        if (nodeSpec.content) nodeSpec.content = $04f8c89bec75d36a$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $04f8c89bec75d36a$var$sanitizeNodeSpecContent(nodes, rawContent) {
    var content = rawContent.replace(/\W/g, ' ');
    var contentKeys = content.split(' ');
    var unsupportedContentKeys = contentKeys.filter(function(contentKey) {
        return !$04f8c89bec75d36a$var$isContentSupported(nodes, contentKey);
    });
    return unsupportedContentKeys.reduce(function(newContent, nodeName) {
        return $04f8c89bec75d36a$var$sanitizedContent(newContent, nodeName);
    }, rawContent);
}
function $04f8c89bec75d36a$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match(/\w/)) return '';
    var pattern = "(".concat(invalidContent, "((\\s)*\\|)+)|((\\|(\\s)*)+").concat(invalidContent, "(\\+|\\*)?)|(").concat(invalidContent, "$)|(").concat(invalidContent, "(\\+|\\*))");
    return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
}
function $04f8c89bec75d36a$var$isContentSupported(nodes, contentKey) {
    var nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(var supportedKey in nodes){
        var nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});

parcelRegister("lViup", function(module, exports) {
$parcel$export(module.exports, "alignment", function () { return $ff5d4378310d3090$export$8e53000a4ec837; });

var $OQ9bg = parcelRequire("OQ9bg");
var $ff5d4378310d3090$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
var $ff5d4378310d3090$export$8e53000a4ec837 = (0, $OQ9bg.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: function getAttrs(dom) {
                var align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            'div',
            {
                class: "fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-".concat(mark.attrs.align),
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});

parcelRegister("eqTLo", function(module, exports) {
$parcel$export(module.exports, "annotation", function () { return $a81ebfd802732664$export$8512c9afa7b24c3b; });

var $fmkKe = parcelRequire("fmkKe");

var $OQ9bg = parcelRequire("OQ9bg");
function $a81ebfd802732664$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a81ebfd802732664$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a81ebfd802732664$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fmkKe.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a81ebfd802732664$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a81ebfd802732664$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
var $a81ebfd802732664$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $a81ebfd802732664$export$93a98caa8bc6cb07(_ref) {
    var id = _ref.id, annotationType = _ref.annotationType, state = _ref.state;
    var data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return $a81ebfd802732664$var$_objectSpread($a81ebfd802732664$var$_objectSpread({}, data), {}, {
        'data-mark-annotation-state': state
    });
    return data;
}
var $a81ebfd802732664$export$8512c9afa7b24c3b = (0, $OQ9bg.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            'span',
            $a81ebfd802732664$var$_objectSpread({
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation'
            }, $a81ebfd802732664$export$93a98caa8bc6cb07({
                id: node.attrs.id,
                annotationType: node.attrs.annotationType
            })),
            0
        ];
    }
});

});

parcelRegister("eDSjJ", function(module, exports) {
$parcel$export(module.exports, "backgroundColor", function () { return $aa8ed7783527849f$export$8c5a050822fd698c; });

var $fmkKe = parcelRequire("fmkKe");

var $1HFWa = parcelRequire("1HFWa");

var $OQ9bg = parcelRequire("OQ9bg");

var $2UMkY = parcelRequire("2UMkY");

var $aZMvy = parcelRequire("aZMvy");

var $Zlz1l = parcelRequire("Zlz1l");

var $lLlF4 = parcelRequire("lLlF4");
/**
 * @name backgroundColor_mark
 */ // Remove this when cleaning up platform_editor_add_orange_highlight_color
var $aa8ed7783527849f$var$colorArrayPalette = [
    [
        (0, $aZMvy.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $aZMvy.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $aZMvy.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $aZMvy.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $aZMvy.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $aZMvy.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
var $aa8ed7783527849f$var$colorArrayPaletteNext = [
    [
        (0, $aZMvy.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $aZMvy.P200),
        'Purple'
    ],
    // token: color.background.accent.purple.subtler
    [
        (0, $aZMvy.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $aZMvy.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $aZMvy.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $aZMvy.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $aZMvy.T200),
        'Teal'
    ] // token: color.background.accent.teal.subtler
];
var $aa8ed7783527849f$export$14ec3f21a268e497 = new Map();
$aa8ed7783527849f$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $1HFWa.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $aa8ed7783527849f$export$14ec3f21a268e497.set(color.toLowerCase(), label);
});
var $aa8ed7783527849f$export$7ab6fa38cecaeee2 = new Map();
$aa8ed7783527849f$var$colorArrayPaletteNext.forEach(function(_ref3) {
    var _ref4 = (0, $1HFWa.default)(_ref3, 2), color = _ref4[0], label = _ref4[1];
    return $aa8ed7783527849f$export$7ab6fa38cecaeee2.set(color.toLowerCase(), label);
});
var $aa8ed7783527849f$export$8c5a050822fd698c = (0, $OQ9bg.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $aZMvy.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $aa8ed7783527849f$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $aa8ed7783527849f$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $2UMkY.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $Zlz1l.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $lLlF4.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            (0, $fmkKe.default)({
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, 'data-background-custom-color', mark.attrs.color)
        ];
    }
});

});
parcelRegister("Zlz1l", function(module, exports) {
$parcel$export(module.exports, "getGlobalTheme", function () { return $0b866cc042f3effc$export$813ecdf77207a053; });
$parcel$export(module.exports, "textColor", function () { return $0b866cc042f3effc$export$32f78bffcd82ff28; });

var $fmkKe = parcelRequire("fmkKe");

var $1HFWa = parcelRequire("1HFWa");

var $OQ9bg = parcelRequire("OQ9bg");

var $2UMkY = parcelRequire("2UMkY");

var $aZMvy = parcelRequire("aZMvy");

var $lLlF4 = parcelRequire("lLlF4");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
var $0b866cc042f3effc$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $aZMvy.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $aZMvy.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $aZMvy.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $aZMvy.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $aZMvy.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $aZMvy.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $aZMvy.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $aZMvy.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $aZMvy.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $aZMvy.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $aZMvy.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $aZMvy.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $aZMvy.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $aZMvy.N0),
        'White'
    ],
    [
        (0, $aZMvy.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $aZMvy.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $aZMvy.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $aZMvy.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $aZMvy.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $aZMvy.P50),
        'Light purple'
    ] // Lavender secret
];
var $0b866cc042f3effc$export$569885e57444f84a = new Map();
var $0b866cc042f3effc$export$81e5ed9e84fe2e28 = $0b866cc042f3effc$export$569885e57444f84a;
$0b866cc042f3effc$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $1HFWa.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $0b866cc042f3effc$export$569885e57444f84a.set(color.toLowerCase(), label);
});
// these are for test only
var $0b866cc042f3effc$var$testGlobalTheme;
var $0b866cc042f3effc$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $0b866cc042f3effc$var$testGlobalTheme = theme;
};
var $0b866cc042f3effc$export$813ecdf77207a053 = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($0b866cc042f3effc$var$testGlobalTheme) return {
        colorMode: $0b866cc042f3effc$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
var $0b866cc042f3effc$export$32f78bffcd82ff28 = (0, $OQ9bg.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $aZMvy.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $0b866cc042f3effc$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $0b866cc042f3effc$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $2UMkY.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($0b866cc042f3effc$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $lLlF4.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            (0, $fmkKe.default)({
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, 'data-text-custom-color', mark.attrs.color)
        ];
    }
});

});


parcelRegister("aeCl0", function(module, exports) {
$parcel$export(module.exports, "border", function () { return $7738f34574ff31cd$export$1edee58a52776cd9; });

var $1HFWa = parcelRequire("1HFWa");

var $OQ9bg = parcelRequire("OQ9bg");

var $2UMkY = parcelRequire("2UMkY");

var $aZMvy = parcelRequire("aZMvy");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ var $7738f34574ff31cd$var$borderColorArrayPalette = [
    [
        (0, $aZMvy.N300A),
        'Subtle gray'
    ],
    [
        (0, $aZMvy.N600),
        'Gray'
    ],
    [
        (0, $aZMvy.N1000),
        'Bold gray'
    ]
];
var $7738f34574ff31cd$export$e4e044c989c86ca7 = new Map();
$7738f34574ff31cd$var$borderColorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $1HFWa.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $7738f34574ff31cd$export$e4e044c989c86ca7.set(color.toLowerCase(), label);
});
var $7738f34574ff31cd$export$1edee58a52776cd9 = (0, $OQ9bg.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: function getAttrs(domNode) {
                var _dom$getAttribute, _dom$getAttribute2;
                var dom = domNode;
                var color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                var size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $7738f34574ff31cd$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM: function toDOM(mark, isInline) {
        var wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        var paletteColorValue = (0, $2UMkY.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }
        ];
    }
});

});

parcelRegister("katgg", function(module, exports) {
$parcel$export(module.exports, "breakout", function () { return $eaeb7080edf270d8$export$89015c65f1c75e3f; });

var $OQ9bg = parcelRequire("OQ9bg");
var $eaeb7080edf270d8$var$allowedTypes = [
    'wide',
    'full-width'
];
var $eaeb7080edf270d8$export$89015c65f1c75e3f = (0, $OQ9bg.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs: function getAttrs(dom) {
                var mode = dom.getAttribute('data-mode');
                var width = dom.getAttribute('data-width');
                return {
                    mode: $eaeb7080edf270d8$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var _mark$attrs;
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("jFxRM", function(module, exports) {
$parcel$export(module.exports, "code", function () { return $e51c1dd89f868438$export$6565f9f03506010b; });

var $OQ9bg = parcelRequire("OQ9bg");
var $e51c1dd89f868438$export$6565f9f03506010b = (0, $OQ9bg.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("lKBoM", function(module, exports) {
$parcel$export(module.exports, "confluenceInlineComment", function () { return $fd5ae774e492cbd0$export$f3b72f8fc4684ecd; });

var $OQ9bg = parcelRequire("OQ9bg");
var $fd5ae774e492cbd0$export$f3b72f8fc4684ecd = (0, $OQ9bg.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("149IY", function(module, exports) {
$parcel$export(module.exports, "em", function () { return $0c6db53f9b172194$export$c63c6f932822f543; });

var $OQ9bg = parcelRequire("OQ9bg");
/**
 * @name em_mark
 */ var $0c6db53f9b172194$var$emDOM = [
    'em'
];
var $0c6db53f9b172194$export$c63c6f932822f543 = (0, $OQ9bg.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM: function toDOM() {
        return $0c6db53f9b172194$var$emDOM;
    }
});

});

parcelRegister("8fG3I", function(module, exports) {
$parcel$export(module.exports, "indentation", function () { return $60205976bca5c29c$export$480c699bd4ec0d86; });

var $OQ9bg = parcelRequire("OQ9bg");
var $60205976bca5c29c$export$480c699bd4ec0d86 = (0, $OQ9bg.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs: function getAttrs(dom) {
                var level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("ePva4", function(module, exports) {
$parcel$export(module.exports, "strike", function () { return $acbe001eb860a86f$export$4899a95d70ec5056; });

var $OQ9bg = parcelRequire("OQ9bg");
var $acbe001eb860a86f$export$4899a95d70ec5056 = (0, $OQ9bg.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: function getAttrs(value) {
                return value === 'line-through' && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            's'
        ];
    }
});

});

parcelRegister("lRUiz", function(module, exports) {
$parcel$export(module.exports, "strong", function () { return $feba37ec3f8aad5d$export$59ae2c325a998f89; });

var $OQ9bg = parcelRequire("OQ9bg");
/**
 * @name strong_mark
 */ var $feba37ec3f8aad5d$var$strongDOM = [
    'strong'
];
var $feba37ec3f8aad5d$export$59ae2c325a998f89 = (0, $OQ9bg.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs: function getAttrs(node) {
                var element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs: function getAttrs(node) {
                var element = node;
                var fontWeight = element.style.fontWeight;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return $feba37ec3f8aad5d$var$strongDOM;
    }
});

});

parcelRegister("39DbY", function(module, exports) {
$parcel$export(module.exports, "subsup", function () { return $24c09d1d6ea6d075$export$b3401ee80eb31041; });

var $OQ9bg = parcelRequire("OQ9bg");
/**
 * @name subsup_mark
 */ function $24c09d1d6ea6d075$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
var $24c09d1d6ea6d075$export$b3401ee80eb31041 = (0, $OQ9bg.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: function getAttrs(node) {
                return $24c09d1d6ea6d075$var$getAttrFromVerticalAlign(node);
            }
        },
        {
            style: 'vertical-align=sub',
            getAttrs: function getAttrs(node) {
                return $24c09d1d6ea6d075$var$getAttrFromVerticalAlign(node);
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("1dh1S", function(module, exports) {
$parcel$export(module.exports, "typeAheadQuery", function () { return $0e2437049c3b0f36$export$20af3dabbb5538df; });

var $OQ9bg = parcelRequire("OQ9bg");

var $aZMvy = parcelRequire("aZMvy");
var $0e2437049c3b0f36$export$20af3dabbb5538df = (0, $OQ9bg.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: "color: ".concat((0, $aZMvy.B400))
            }
        ];
    }
});

});

parcelRegister("de0jf", function(module, exports) {
$parcel$export(module.exports, "underline", function () { return $9a0cd29a25afdc99$export$425327af25286e5e; });

var $OQ9bg = parcelRequire("OQ9bg");
var $9a0cd29a25afdc99$export$425327af25286e5e = (0, $OQ9bg.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: function getAttrs(value) {
                return value === 'underline' && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            'u'
        ];
    }
});

});

parcelRegister("lJr9t", function(module, exports) {
$parcel$export(module.exports, "unsupportedMark", function () { return $fd22dcbfd05bcd11$export$30d78d5eb6719bb8; });

var $OQ9bg = parcelRequire("OQ9bg");
var $fd22dcbfd05bcd11$export$30d78d5eb6719bb8 = (0, $OQ9bg.unsupportedMark)({
    toDOM: function toDOM() {
        return [
            'span'
        ];
    }
});

});

parcelRegister("eLNZQ", function(module, exports) {
$parcel$export(module.exports, "unsupportedNodeAttribute", function () { return $ac0c3cb7d961af14$export$a316dc07ff5182a2; });

var $OQ9bg = parcelRequire("OQ9bg");
var $ac0c3cb7d961af14$export$a316dc07ff5182a2 = (0, $OQ9bg.unsupportedNodeAttribute)({
    toDOM: function toDOM() {
        return [
            'span'
        ];
    }
});

});

parcelRegister("jfFQb", function(module, exports) {
$parcel$export(module.exports, "blockCard", function () { return $e03fdfbd636871f3$export$c4c2f833baaebdb8; });

var $fmkKe = parcelRequire("fmkKe");

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
function $e03fdfbd636871f3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e03fdfbd636871f3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e03fdfbd636871f3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fmkKe.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e03fdfbd636871f3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name blockCard_node
 */ var $e03fdfbd636871f3$var$getCommonAttributesFromDom = function getCommonAttributesFromDom(dom) {
    var anchor = dom;
    var data = anchor.getAttribute('data-card-data');
    var datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
var $e03fdfbd636871f3$export$c4c2f833baaebdb8 = (0, $kBUhU.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $e03fdfbd636871f3$var$_objectSpread({
                    url: anchor.getAttribute('href') || undefined
                }, $e03fdfbd636871f3$var$getCommonAttributesFromDom(dom));
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $e03fdfbd636871f3$var$_objectSpread({
                    url: anchor.getAttribute('data-card-url') || undefined
                }, $e03fdfbd636871f3$var$getCommonAttributesFromDom(dom));
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var _ref = node.attrs, url = _ref.url;
        var _ref2 = node.attrs, data = _ref2.data;
        var _ref3 = node.attrs, layout = _ref3.layout, width = _ref3.width, datasource = _ref3.datasource;
        var attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': "".concat(width)
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});
var $e03fdfbd636871f3$export$9894f24949f094e5 = (0, $kBUhU.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $e03fdfbd636871f3$var$_objectSpread($e03fdfbd636871f3$var$_objectSpread({
                    url: anchor.getAttribute('href') || undefined
                }, $e03fdfbd636871f3$var$getCommonAttributesFromDom(dom)), {}, {
                    localId: (0, $6BQ2f.uuid).generate()
                });
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $e03fdfbd636871f3$var$_objectSpread($e03fdfbd636871f3$var$_objectSpread({
                    url: anchor.getAttribute('data-card-url') || undefined
                }, $e03fdfbd636871f3$var$getCommonAttributesFromDom(dom)), {}, {
                    localId: (0, $6BQ2f.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2, _node$attrs3;
        var _ref4 = node.attrs, url = _ref4.url;
        var _ref5 = node.attrs, data = _ref5.data;
        var _ref6 = node.attrs, layout = _ref6.layout, width = _ref6.width, datasource = _ref6.datasource;
        var attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': "".concat(width),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.url) || ' '
        ];
    }
});

});

parcelRegister("dHPQp", function(module, exports) {
$parcel$export(module.exports, "taskItem", function () { return $9fa781b495273e5b$export$6d8b0ef52e2e6390; });
$parcel$export(module.exports, "blockTaskItem", function () { return $9fa781b495273e5b$export$16018c61064a18df; });

var $6BQ2f = parcelRequire("6BQ2f");

var $kBUhU = parcelRequire("kBUhU");
var $9fa781b495273e5b$export$6d8b0ef52e2e6390 = (0, $kBUhU.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $6BQ2f.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $9fa781b495273e5b$export$16018c61064a18df = (0, $kBUhU.blockTaskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-is-block]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $6BQ2f.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2 = node.attrs, localId = _node$attrs2.localId, state = _node$attrs2.state;
        var attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO',
            'data-task-is-block': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("dBvx2", function(module, exports) {
$parcel$export(module.exports, "bodiedExtension", function () { return $9e7730a4b2106468$export$27903d543b563e39; });

var $2GR0h = parcelRequire("2GR0h");

var $kBUhU = parcelRequire("kBUhU");
var $9e7730a4b2106468$export$27903d543b563e39 = (0, $kBUhU.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $2GR0h.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("grATT", function(module, exports) {
$parcel$export(module.exports, "bulletList", function () { return $bf8bca9abf8d97db$export$a140c94e5ea26bee; });

var $6BQ2f = parcelRequire("6BQ2f");

var $kBUhU = parcelRequire("kBUhU");
var $bf8bca9abf8d97db$export$5f25a39efab3b58b = '.ak-ul';
var $bf8bca9abf8d97db$export$a140c94e5ea26bee = (0, $kBUhU.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $bf8bca9abf8d97db$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});
var $bf8bca9abf8d97db$export$dfd406053b2bab40 = (0, $kBUhU.bulletList)({
    parseDOM: [
        {
            tag: 'ul',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            class: $bf8bca9abf8d97db$export$5f25a39efab3b58b.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("wMi1h", function(module, exports) {
$parcel$export(module.exports, "caption", function () { return $06287297074aca32$export$8e3c2dfdc4f0453d; });

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
var $06287297074aca32$export$8e3c2dfdc4f0453d = (0, $kBUhU.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});
var $06287297074aca32$export$b5d01ee303c467aa = (0, $kBUhU.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-caption': 'true',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("5I8NU", function(module, exports) {
$parcel$export(module.exports, "confluenceJiraIssue", function () { return $4287e418276ba27e$export$daf889beb5092f95; });

var $kBUhU = parcelRequire("kBUhU");
var $4287e418276ba27e$var$name = 'confluenceJiraIssue';
var $4287e418276ba27e$export$daf889beb5092f95 = (0, $kBUhU.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: "span[data-node-type=\"".concat($4287e418276ba27e$var$name, "\"]"),
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': $4287e418276ba27e$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("cKqLv", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedBlock", function () { return $947e8aef475ca4d4$export$e6e4878f43c27cab; });

var $kBUhU = parcelRequire("kBUhU");
var $947e8aef475ca4d4$var$name = 'confluenceUnsupportedBlock';
var $947e8aef475ca4d4$export$e6e4878f43c27cab = (0, $kBUhU.confluenceUnsupportedBlock)({
    toDOM: function toDOM(node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        var attrs = {
            'data-node-type': $947e8aef475ca4d4$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($947e8aef475ca4d4$var$name, "\"]"),
            getAttrs: function getAttrs(dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("dpTXx", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedInline", function () { return $9c49048265b07d88$export$3e6d667072febc87; });

var $kBUhU = parcelRequire("kBUhU");
var $9c49048265b07d88$var$name = 'confluenceUnsupportedInline';
var $9c49048265b07d88$export$3e6d667072febc87 = (0, $kBUhU.confluenceUnsupportedInline)({
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': $9c49048265b07d88$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($9c49048265b07d88$var$name, "\"]"),
            getAttrs: function getAttrs(dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("2KJuI", function(module, exports) {
$parcel$export(module.exports, "date", function () { return $20132aea72923886$export$324d90190a8b822a; });

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
var $20132aea72923886$export$324d90190a8b822a = (0, $kBUhU.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: function getAttrs(dom) {
                return {
                    timestamp: dom.getAttribute('data-timestamp')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});
var $20132aea72923886$export$a6a035390e3921b2 = (0, $kBUhU.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: function getAttrs(dom) {
                return {
                    timestamp: dom.getAttribute('data-timestamp'),
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("aZXDV", function(module, exports) {
$parcel$export(module.exports, "decisionItem", function () { return $801dddbb6e0d9d35$export$6959e16eeff859b4; });

var $6BQ2f = parcelRequire("6BQ2f");

var $kBUhU = parcelRequire("kBUhU");
var $801dddbb6e0d9d35$export$6959e16eeff859b4 = (0, $kBUhU.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $6BQ2f.uuid).generate(),
                    state: dom.getAttribute('data-decision-state')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});

parcelRegister("2q06n", function(module, exports) {
$parcel$export(module.exports, "decisionList", function () { return $1c2e16afbd841b4f$export$62d45a65fb43d95e; });

var $6BQ2f = parcelRequire("6BQ2f");

var $kBUhU = parcelRequire("kBUhU");
/**
 * @name decisionList_node
 */ var $1c2e16afbd841b4f$var$name = 'decisionList';
var $1c2e16afbd841b4f$export$a5393ce68c2ff601 = "[data-node-type=\"".concat($1c2e16afbd841b4f$var$name, "\"]");
var $1c2e16afbd841b4f$export$62d45a65fb43d95e = (0, $kBUhU.decisionList)({
    parseDOM: [
        {
            tag: "ol".concat($1c2e16afbd841b4f$export$a5393ce68c2ff601),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-node-type': $1c2e16afbd841b4f$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("3Jgg7", function(module, exports) {
$parcel$export(module.exports, "doc", function () { return $2b722fc6cb2eb975$export$2a111da947c407d2; });

var $kBUhU = parcelRequire("kBUhU");
var $2b722fc6cb2eb975$export$2a111da947c407d2 = (0, $kBUhU.doc)({});

});

parcelRegister("6fNob", function(module, exports) {
$parcel$export(module.exports, "embedCard", function () { return $48da746e37eea934$export$be4283d9a1cb1ff6; });

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
var $48da746e37eea934$export$be4283d9a1cb1ff6 = (0, $kBUhU.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: function getAttrs(dom) {
                return {
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, url = _node$attrs.url, layout = _node$attrs.layout, width = _node$attrs.width, originalWidth = _node$attrs.originalWidth, originalHeight = _node$attrs.originalHeight;
        var attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});
var $48da746e37eea934$export$36734475a7f6fd3e = (0, $kBUhU.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: function getAttrs(dom) {
                return {
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null,
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3;
        var _node$attrs2 = node.attrs, url = _node$attrs2.url, layout = _node$attrs2.layout, width = _node$attrs2.width, originalWidth = _node$attrs2.originalWidth, originalHeight = _node$attrs2.originalHeight;
        var attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId) || undefined
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("dHtch", function(module, exports) {
$parcel$export(module.exports, "emoji", function () { return $9f95f07164466464$export$a19185d1233fc4b2; });

var $fmkKe = parcelRequire("fmkKe");

var $axSHw = parcelRequire("axSHw");

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
function $9f95f07164466464$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9f95f07164466464$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9f95f07164466464$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fmkKe.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9f95f07164466464$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9f95f07164466464$export$a19185d1233fc4b2 = (0, $kBUhU.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: function getAttrs(dom) {
                return (0, $axSHw.acNameToEmoji)(dom.getAttribute('data-emoticon-name'));
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: function getAttrs(dom) {
                return (0, $axSHw.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'));
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, shortName = _node$attrs.shortName, id = _node$attrs.id, text = _node$attrs.text;
        var attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
var $9f95f07164466464$export$ebb3b3c7a0ac9936 = (0, $kBUhU.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: function getAttrs(dom) {
                var attrs = (0, $axSHw.acNameToEmoji)(dom.getAttribute('data-emoticon-name'));
                return $9f95f07164466464$var$_objectSpread($9f95f07164466464$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $6BQ2f.uuid).generate()
                });
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: function getAttrs(dom) {
                var attrs = (0, $axSHw.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'));
                return $9f95f07164466464$var$_objectSpread($9f95f07164466464$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $6BQ2f.uuid).generate()
                });
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $9f95f07164466464$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3;
        var _node$attrs2 = node.attrs, shortName = _node$attrs2.shortName, id = _node$attrs2.id, text = _node$attrs2.text;
        var attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("axSHw", function(module, exports) {
$parcel$export(module.exports, "acNameToEmoji", function () { return $7ad76af1549a6439$export$f61e93bda2a8b420; });
$parcel$export(module.exports, "acShortcutToEmoji", function () { return $7ad76af1549a6439$export$441f8b58f5790a68; });
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
var $7ad76af1549a6439$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
var $7ad76af1549a6439$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
var $7ad76af1549a6439$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ var $7ad76af1549a6439$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        "\uD83D\uDE42"
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        "\uD83D\uDE41"
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        "\uD83D\uDE1B"
    ],
    laugh: [
        '1f600',
        ':grinning:',
        "\uD83D\uDE00"
    ],
    wink: [
        '1f609',
        ':wink:',
        "\uD83D\uDE09"
    ],
    information: [
        '2139',
        ':information_source:',
        "\u2139"
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        "\u2705"
    ],
    cross: [
        '274c',
        ':x:',
        "\u274C"
    ],
    warning: [
        '26a0',
        ':warning:',
        "\u26A0"
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        "\u2795"
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        "\u2796"
    ],
    question: [
        '2753',
        ':question:',
        "?"
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        "\uD83D\uDC4D"
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        "\uD83D\uDC4E"
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        "\uD83D\uDCA1"
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        "\uD83D\uDC9B"
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        "\uD83D\uDEAB"
    ],
    'red-star': [
        '2764',
        ':heart:',
        "\u2764\uFE0F"
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        "\uD83D\uDC9A"
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        "\uD83D\uDC99"
    ],
    heart: [
        '2764',
        ':heart:',
        "\u2764\uFE0F"
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        "\uD83D\uDC94"
    ]
};
function $7ad76af1549a6439$export$f61e93bda2a8b420(acName) {
    var emojiData = $7ad76af1549a6439$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $7ad76af1549a6439$var$DEFAULT_EMOJI_ID,
        shortName: ":".concat(acName, ":"),
        text: ''
    };
}
function $7ad76af1549a6439$export$bc94e44ec0e7bd82(emojiId) {
    var filterEmojis = function filterEmojis(acName) {
        return $7ad76af1549a6439$var$acNameToEmojiMap[acName] ? $7ad76af1549a6439$var$acNameToEmojiMap[acName][0] === emojiId : false;
    };
    return Object.keys($7ad76af1549a6439$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $7ad76af1549a6439$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: "".concat($7ad76af1549a6439$var$HC_EMOTICON_PREFIX).concat(hipchatEmoticonShortName),
        shortName: ":".concat(hipchatEmoticonShortName, ":"),
        text: ''
    };
}
function $7ad76af1549a6439$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $7ad76af1549a6439$export$880a2465992fbbe(_ref) {
    var id = _ref.id, shortName = _ref.shortName;
    if ($7ad76af1549a6439$var$DEFAULT_EMOJI_ID === id) {
        var possibleName = $7ad76af1549a6439$var$getAcNameFromShortName(shortName);
        if (possibleName in $7ad76af1549a6439$var$acNameToEmojiMap) return possibleName;
    }
    return $7ad76af1549a6439$export$bc94e44ec0e7bd82(id) || $7ad76af1549a6439$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("aR5Ot", function(module, exports) {
$parcel$export(module.exports, "extendedBlockquote", function () { return $7e735cffb94e92ad$export$70a64939da3e8455; });

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
/**
 * @name blockquote_node
 */ var $7e735cffb94e92ad$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM: function toDOM() {
        return [
            'blockquote',
            0
        ];
    }
};
var $7e735cffb94e92ad$export$67dc04e652a298ca = (0, $kBUhU.blockquoteLegacy)($7e735cffb94e92ad$var$nodeSpecOptions);
var $7e735cffb94e92ad$export$70a64939da3e8455 = (0, $kBUhU.blockquote)($7e735cffb94e92ad$var$nodeSpecOptions);
var $7e735cffb94e92ad$var$nodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'blockquote',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            'blockquote',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
};
var $7e735cffb94e92ad$export$950ebf43f3364a0f = (0, $kBUhU.blockquote)($7e735cffb94e92ad$var$nodeSpecOptionsWithLocalId);

});

parcelRegister("lda36", function(module, exports) {
$parcel$export(module.exports, "extendedPanel", function () { return $f7129b68d5729e85$export$ce20b13564211141; });

var $fmkKe = parcelRequire("fmkKe");

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
function $f7129b68d5729e85$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f7129b68d5729e85$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f7129b68d5729e85$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fmkKe.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f7129b68d5729e85$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f7129b68d5729e85$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ var $f7129b68d5729e85$var$getDomAttrs = function getDomAttrs(nodeAttrs) {
    var attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor,
        'data-local-id': (nodeAttrs === null || nodeAttrs === void 0 ? void 0 : nodeAttrs.localId) || undefined
    };
    return attrs;
};
var $f7129b68d5729e85$var$getParseDOMAttrs = function getParseDOMAttrs(allowCustomPanel, dom, generateLocalId) {
    var parseDOMAttrs = {
        panelType: dom.getAttribute('data-panel-type')
    };
    if (generateLocalId) parseDOMAttrs.localId = (0, $6BQ2f.uuid).generate();
    if (allowCustomPanel) parseDOMAttrs = $f7129b68d5729e85$var$_objectSpread($f7129b68d5729e85$var$_objectSpread({}, parseDOMAttrs), {}, {
        panelIcon: dom.getAttribute('data-panel-icon'),
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        panelColor: dom.getAttribute('data-panel-color')
    });
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $f7129b68d5729e85$export$969277cf61e5a7aa.CUSTOM ? $f7129b68d5729e85$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
var $f7129b68d5729e85$var$createPanelNodeSpecOptions = function createPanelNodeSpecOptions(allowCustomPanel, generateLocalId) {
    return {
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: function getAttrs(dom) {
                    return $f7129b68d5729e85$var$getParseDOMAttrs(allowCustomPanel, dom, generateLocalId);
                }
            }
        ],
        toDOM: function toDOM(node) {
            var attrs = $f7129b68d5729e85$var$getDomAttrs(node.attrs);
            var contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    };
};
var $f7129b68d5729e85$export$ce20b13564211141 = function extendedPanel(allowCustomPanel) {
    return (0, $kBUhU.panel)($f7129b68d5729e85$var$createPanelNodeSpecOptions(allowCustomPanel));
};
var $f7129b68d5729e85$export$855c3c67c9c9ebaf = function extendedPanelWithLocalId(allowCustomPanel) {
    return (0, $kBUhU.panel)($f7129b68d5729e85$var$createPanelNodeSpecOptions(allowCustomPanel, true));
};

});

parcelRegister("4yVpE", function(module, exports) {
$parcel$export(module.exports, "extension", function () { return $3526df607b0b4ee6$export$1b45514b112dd749; });

var $2GR0h = parcelRequire("2GR0h");

var $kBUhU = parcelRequire("kBUhU");
var $3526df607b0b4ee6$export$1b45514b112dd749 = (0, $kBUhU.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $2GR0h.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("l33q8", function(module, exports) {
$parcel$export(module.exports, "hardBreak", function () { return $f52c880409f7bf31$export$371da9dd35aba193; });

var $kBUhU = parcelRequire("kBUhU");
var $f52c880409f7bf31$export$371da9dd35aba193 = (0, $kBUhU.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM: function toDOM() {
        return [
            'br'
        ];
    }
});

});

parcelRegister("aTrNU", function(module, exports) {
$parcel$export(module.exports, "heading", function () { return $7ee49bb676798a43$export$46e4a324ac90507f; });

var $kBUhU = parcelRequire("kBUhU");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ var $7ee49bb676798a43$var$getAttrs = function getAttrs(level) {
    return function(domNode) {
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute('data-local-id') || ((_heading$attrs = $7ee49bb676798a43$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
};
var $7ee49bb676798a43$export$46e4a324ac90507f = (0, $kBUhU.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $7ee49bb676798a43$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $7ee49bb676798a43$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $7ee49bb676798a43$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $7ee49bb676798a43$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $7ee49bb676798a43$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $7ee49bb676798a43$var$getAttrs(6)
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, level = _node$attrs.level, localId = _node$attrs.localId;
        var name = 'h' + level;
        var attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});

});

parcelRegister("7VNHO", function(module, exports) {
$parcel$export(module.exports, "image", function () { return $5c6469c2f55f0d70$export$5c452ff88e35e47d; });

var $kBUhU = parcelRequire("kBUhU");
var $5c6469c2f55f0d70$export$5c452ff88e35e47d = (0, $kBUhU.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("dBZQS", function(module, exports) {
$parcel$export(module.exports, "inlineCard", function () { return $9e8eb58be9f16dec$export$cbf8224b64e0d942; });

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
var $9e8eb58be9f16dec$export$cbf8224b64e0d942 = (0, $kBUhU.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});
var $9e8eb58be9f16dec$export$7ed775fc743eadd1 = (0, $kBUhU.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("3Xv5B", function(module, exports) {
$parcel$export(module.exports, "inlineExtension", function () { return $2e1eff7ccb57379f$export$16b353b2649bd8d9; });

var $2GR0h = parcelRequire("2GR0h");

var $kBUhU = parcelRequire("kBUhU");
var $2e1eff7ccb57379f$export$16b353b2649bd8d9 = (0, $kBUhU.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            getAttrs: function getAttrs(domNode) {
                return (0, $2GR0h.getExtensionAttrs)(domNode, true);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("aVWaY", function(module, exports) {
$parcel$export(module.exports, "layoutColumn", function () { return $7f5c5acfbe01ff0f$export$ab76e7c03cd6f650; });

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
var $7f5c5acfbe01ff0f$export$ab76e7c03cd6f650 = (0, $kBUhU.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-layout-column': 'true'
        };
        var width = node.attrs.width;
        if (width) {
            attrs['style'] = "flex-basis: ".concat(width, "%");
            attrs['data-column-width'] = "".concat(width);
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        var contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});
var $7f5c5acfbe01ff0f$export$b2e27d292505bac2 = (0, $kBUhU.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined,
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-layout-column': 'true',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        var width = node.attrs.width;
        if (width) {
            attrs['style'] = "flex-basis: ".concat(width, "%");
            attrs['data-column-width'] = "".concat(width);
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        var contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});

});

parcelRegister("3VwoG", function(module, exports) {
$parcel$export(module.exports, "mediaGroup", function () { return $2dbfd35fc907caf1$export$2855e964765eac9; });

var $kBUhU = parcelRequire("kBUhU");
var $2dbfd35fc907caf1$export$2855e964765eac9 = (0, $kBUhU.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM: function toDOM() {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("2QkN1", function(module, exports) {
$parcel$export(module.exports, "mediaInline", function () { return $21209080a47eb4ea$export$38bab695e3f720f1; });

var $fmkKe = parcelRequire("fmkKe");

var $4LvHO = parcelRequire("4LvHO");

var $6BQ2f = parcelRequire("6BQ2f");

var $kBUhU = parcelRequire("kBUhU");
function $21209080a47eb4ea$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $21209080a47eb4ea$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $21209080a47eb4ea$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fmkKe.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $21209080a47eb4ea$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $21209080a47eb4ea$export$38bab695e3f720f1 = (0, $4LvHO.createMediaSpec)((0, $kBUhU.mediaInline)({}).attrs, true);
var $21209080a47eb4ea$export$aea8e9c496505c61 = (0, $4LvHO.createMediaSpec)($21209080a47eb4ea$var$_objectSpread($21209080a47eb4ea$var$_objectSpread({}, (0, $kBUhU.mediaInline)({}).attrs), {}, {
    localId: {
        default: (0, $6BQ2f.uuid).generate()
    }
}), true, true);

});

parcelRegister("8J4kG", function(module, exports) {
$parcel$export(module.exports, "nestedExpand", function () { return $65a5e3155290e500$export$63cadbf5f4296627; });

var $iaC1B = parcelRequire("iaC1B");

var $fmkKe = parcelRequire("fmkKe");

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
function $65a5e3155290e500$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $65a5e3155290e500$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $65a5e3155290e500$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $fmkKe.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $65a5e3155290e500$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $65a5e3155290e500$var$getExpandAttrs(domNode, generateLocalId) {
    var dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true,
        localId: generateLocalId ? (0, $6BQ2f.uuid).generate() : undefined
    };
}
var $65a5e3155290e500$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $65a5e3155290e500$var$getExpandAttrs(domNode, false);
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $65a5e3155290e500$var$getExpandAttrs(domNode, false);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
var $65a5e3155290e500$export$63cadbf5f4296627 = (0, $kBUhU.nestedExpand)($65a5e3155290e500$var$nestedExpandFactoryOptions);
var $65a5e3155290e500$export$b854197485aa1fa0 = (0, $kBUhU.nestedExpand)($65a5e3155290e500$var$_objectSpread($65a5e3155290e500$var$_objectSpread({}, $65a5e3155290e500$var$nestedExpandFactoryOptions), {}, {
    parseDOM: [].concat((0, $iaC1B.default)($65a5e3155290e500$var$nestedExpandFactoryOptions.parseDOM), [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $65a5e3155290e500$var$getExpandAttrs(domNode, true);
            }
        },
        {
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $65a5e3155290e500$var$getExpandAttrs(domNode, true);
            }
        }
    ])
}));

});
parcelRegister("iaC1B", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d3a6a81e8d8a0866$export$2e2bcd8739ae039; });

var $kAyk5 = parcelRequire("kAyk5");

var $95lje = parcelRequire("95lje");

var $9xa7A = parcelRequire("9xa7A");

var $8Ga0L = parcelRequire("8Ga0L");
function $d3a6a81e8d8a0866$export$2e2bcd8739ae039(r) {
    return (0, $kAyk5.default)(r) || (0, $95lje.default)(r) || (0, $9xa7A.default)(r) || (0, $8Ga0L.default)();
}

});
parcelRegister("kAyk5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $efd1cb48bab529f8$export$2e2bcd8739ae039; });

var $rHiKp = parcelRequire("rHiKp");
function $efd1cb48bab529f8$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $rHiKp.default)(r);
}

});

parcelRegister("95lje", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $69d51c39e9f15f79$export$2e2bcd8739ae039; });
function $69d51c39e9f15f79$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("8Ga0L", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $651a0303ad5f8279$export$2e2bcd8739ae039; });
function $651a0303ad5f8279$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("jPLYd", function(module, exports) {
$parcel$export(module.exports, "orderedListWithOrder", function () { return $e707fda66fee1b79$export$b9ab759e8298198f; });

var $6BQ2f = parcelRequire("6BQ2f");

var $kBUhU = parcelRequire("kBUhU");
var $e707fda66fee1b79$export$4e7125c7ff595be5 = '.ak-ol';
var $e707fda66fee1b79$export$a5dc81035676e7a = (0, $kBUhU.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $e707fda66fee1b79$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
var $e707fda66fee1b79$export$8157adc5747ec436 = (0, $kBUhU.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            class: $e707fda66fee1b79$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
var $e707fda66fee1b79$var$resolveStart = function resolveStart(start) {
    var num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
var $e707fda66fee1b79$export$b9ab759e8298198f = (0, $kBUhU.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    var start = $e707fda66fee1b79$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        var start = $e707fda66fee1b79$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.order);
        var attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $e707fda66fee1b79$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
var $e707fda66fee1b79$export$2ea3505d41d7525d = (0, $kBUhU.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var startDOMAttr = dom.getAttribute('start');
                var localId = (0, $6BQ2f.uuid).generate();
                if (startDOMAttr) {
                    var start = $e707fda66fee1b79$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start,
                        localId: localId
                    };
                }
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3, _node$attrs4;
        var start = $e707fda66fee1b79$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.order);
        var attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $e707fda66fee1b79$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("cpq1I", function(module, exports) {
$parcel$export(module.exports, "paragraph", function () { return $908c022e683468b3$export$9c206ddddb32a9b; });

var $kBUhU = parcelRequire("kBUhU");
var $908c022e683468b3$export$9c206ddddb32a9b = (0, $kBUhU.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: function getAttrs(domNode) {
                var _paragraph$attrs, _paragraph$attrs$loca;
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $908c022e683468b3$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var name = 'p';
        var attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});

});

parcelRegister("78PuG", function(module, exports) {
$parcel$export(module.exports, "placeholder", function () { return $5331395b952df92f$export$c7187bbd1a7a9244; });

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
var $5331395b952df92f$export$c7187bbd1a7a9244 = (0, $kBUhU.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: function getAttrs(dom) {
                return {
                    text: dom.getAttribute('data-placeholder') || $5331395b952df92f$export$c7187bbd1a7a9244.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var text = node.attrs.text;
        var attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
var $5331395b952df92f$export$6205248609a8f7a0 = (0, $kBUhU.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: function getAttrs(dom) {
                return {
                    text: dom.getAttribute('data-placeholder') || $5331395b952df92f$export$c7187bbd1a7a9244.attrs.text.default,
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var text = node.attrs.text;
        var attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("hgqzw", function(module, exports) {
$parcel$export(module.exports, "rule", function () { return $c9188ae87aa1e1ed$export$fbeb3a3956e8a3c7; });

var $kBUhU = parcelRequire("kBUhU");

var $6BQ2f = parcelRequire("6BQ2f");
/**
 * @name rule_node
 */ var $c9188ae87aa1e1ed$var$hrDOM = [
    'hr'
];
var $c9188ae87aa1e1ed$export$fbeb3a3956e8a3c7 = (0, $kBUhU.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM: function toDOM() {
        return $c9188ae87aa1e1ed$var$hrDOM;
    }
});
var $c9188ae87aa1e1ed$export$bf3ef6fb6ad90e7 = (0, $kBUhU.rule)({
    parseDOM: [
        {
            tag: 'hr',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            'hr',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            }
        ];
    }
});

});

parcelRegister("39Ojv", function(module, exports) {
$parcel$export(module.exports, "status", function () { return $24c93d9e61f3e2b6$export$471f7ae5c4103ae1; });

var $6BQ2f = parcelRequire("6BQ2f");

var $kBUhU = parcelRequire("kBUhU");
var $24c93d9e61f3e2b6$export$471f7ae5c4103ae1 = (0, $kBUhU.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, '').trim(),
                    color: dom.getAttribute('data-color'),
                    localId: (0, $6BQ2f.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, text = _node$attrs.text, color = _node$attrs.color, localId = _node$attrs.localId, style = _node$attrs.style;
        var attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("b9bGn", function(module, exports) {
$parcel$export(module.exports, "taskList", function () { return $81d998e1d172348e$export$375b6afcc5f4d291; });

var $6BQ2f = parcelRequire("6BQ2f");

var $kBUhU = parcelRequire("kBUhU");
/**
 * @name taskList_node
 */ var $81d998e1d172348e$var$name = 'actionList';
var $81d998e1d172348e$export$c0ec71adb7a18fb2 = "[data-node-type=\"".concat($81d998e1d172348e$var$name, "\"]");
var $81d998e1d172348e$export$375b6afcc5f4d291 = (0, $kBUhU.taskList)({
    parseDOM: [
        {
            tag: "div".concat($81d998e1d172348e$export$c0ec71adb7a18fb2),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $6BQ2f.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-node-type': $81d998e1d172348e$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("g9gj0", function(module, exports) {
$parcel$export(module.exports, "text", function () { return $bc1a228e1703a1bb$export$6f093cfa640b7166; });

var $kBUhU = parcelRequire("kBUhU");
var $bc1a228e1703a1bb$export$6f093cfa640b7166 = (0, $kBUhU.text)({
    toDebugString: function() {
        return 'text_node';
    }
});

});

parcelRegister("5ilw1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3daf52bbf5da6047$export$2e2bcd8739ae039; });
var $3daf52bbf5da6047$var$name = 'unknownBlock';
var $3daf52bbf5da6047$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM: function toDOM() {
        return [
            'div',
            {
                'data-node-type': $3daf52bbf5da6047$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($3daf52bbf5da6047$var$name, "\"]")
        }
    ]
};

});

parcelRegister("eeCoC", function(module, exports) {
$parcel$export(module.exports, "unsupportedBlock", function () { return $a5d0282d12e1d6da$export$44b79b0979d0f0f7; });

var $kBUhU = parcelRequire("kBUhU");
var $a5d0282d12e1d6da$export$44b79b0979d0f0f7 = (0, $kBUhU.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("73gy7", function(module, exports) {
$parcel$export(module.exports, "unsupportedInline", function () { return $5225a68da8c45c4b$export$310ebe0d80122e9b; });

var $kBUhU = parcelRequire("kBUhU");
var $5225a68da8c45c4b$export$310ebe0d80122e9b = (0, $kBUhU.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});



parcelRegister("2r7Em", function(module, exports) {
$parcel$export(module.exports, "markOverrideRuleFor", function () { return $1c6409831f371e87$export$28e4e3c024cce988; });
var $1c6409831f371e87$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: function canOverrideUnsupportedMark() {
        return true;
    }
};
var $1c6409831f371e87$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: function canOverrideUnsupportedMark() {
        return false;
    }
};
var $1c6409831f371e87$export$28e4e3c024cce988 = function markOverrideRuleFor(type) {
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $1c6409831f371e87$var$defaultAllowOverrideBehaviour;
        default:
            return $1c6409831f371e87$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});

parcelRegister("4Piq1", function(module, exports) {
$parcel$export(module.exports, "sanitizeNode", function () { return $383a366aac9dc2cb$export$48b382180baf8e88; });

var $lUar6 = parcelRequire("lUar6");

var $ansGl = parcelRequire("ansGl");

var $em8IR = parcelRequire("em8IR");

var $fdwQ2 = parcelRequire("fdwQ2");
function $383a366aac9dc2cb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $383a366aac9dc2cb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $383a366aac9dc2cb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $383a366aac9dc2cb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $383a366aac9dc2cb$var$hasNestedTable = function hasNestedTable(tableCellNode) {
    var _tableCellNode$conten;
    return (_tableCellNode$conten = tableCellNode.content) === null || _tableCellNode$conten === void 0 ? void 0 : _tableCellNode$conten.some(function(node) {
        return (node === null || node === void 0 ? void 0 : node.type) === 'table';
    });
};
function $383a366aac9dc2cb$export$48b382180baf8e88(json) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$keepNestedTa = options.keepNestedTables, keepNestedTables = _options$keepNestedTa === void 0 ? false : _options$keepNestedTa;
    var sanitizedJSON = (0, $em8IR.traverse)(json, {
        text: function text(node) {
            if (!node || !Array.isArray(node.marks)) return node;
            return $383a366aac9dc2cb$var$_objectSpread($383a366aac9dc2cb$var$_objectSpread({}, node), {}, {
                marks: node.marks.filter(function(mark) {
                    return mark.type !== 'typeAheadQuery';
                })
            });
        },
        status: function status(node) {
            if (node.attrs && !!node.attrs.text) return (0, $fdwQ2.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: function caption(node) {
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: function tableCell(node) {
            if ($383a366aac9dc2cb$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $ansGl.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        tableHeader: function tableHeader(node) {
            if ($383a366aac9dc2cb$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $ansGl.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        emoji: (0, $fdwQ2.removeNonAnnotationMarks),
        mention: (0, $fdwQ2.removeNonAnnotationMarks),
        date: (0, $fdwQ2.removeNonAnnotationMarks),
        hardBreak: (0, $fdwQ2.removeMarks),
        inlineCard: (0, $fdwQ2.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("ansGl", function(module, exports) {
$parcel$export(module.exports, "transformNestedTablesIncomingDocument", function () { return $78e24cfe69c0e04a$export$18544d0b5f43e4a1; });
$parcel$export(module.exports, "transformNestedTableNodeOutgoingDocument", function () { return $78e24cfe69c0e04a$export$8a334a7d9fe120ec; });

var $lUar6 = parcelRequire("lUar6");

var $em8IR = parcelRequire("em8IR");

var $i8z2E = parcelRequire("i8z2E");

var $9NJGe = parcelRequire("9NJGe");
function $78e24cfe69c0e04a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $78e24cfe69c0e04a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $78e24cfe69c0e04a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $78e24cfe69c0e04a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $78e24cfe69c0e04a$var$NESTED_TABLE_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $78e24cfe69c0e04a$var$NESTED_TABLE_EXTENSION_KEY = 'nested-table';
var $78e24cfe69c0e04a$export$f45e7335ec874bfe = function isNestedTableExtension(extensionNode) {
    var _extensionNode$attrs, _extensionNode$attrs2;
    return ((_extensionNode$attrs = extensionNode.attrs) === null || _extensionNode$attrs === void 0 ? void 0 : _extensionNode$attrs.extensionType) === $78e24cfe69c0e04a$var$NESTED_TABLE_EXTENSION_TYPE && ((_extensionNode$attrs2 = extensionNode.attrs) === null || _extensionNode$attrs2 === void 0 ? void 0 : _extensionNode$attrs2.extensionKey) === $78e24cfe69c0e04a$var$NESTED_TABLE_EXTENSION_KEY;
};
var $78e24cfe69c0e04a$var$transformNestedTableExtension = function transformNestedTableExtension(nestedTableExtension) {
    var _nestedTableExtension;
    // No content - drop the extension node
    if (!((_nestedTableExtension = nestedTableExtension.attrs) !== null && _nestedTableExtension !== void 0 && (_nestedTableExtension = _nestedTableExtension.parameters) !== null && _nestedTableExtension !== void 0 && _nestedTableExtension.adf)) return false;
    try {
        var _nestedTableExtension2;
        var adf = JSON.parse((_nestedTableExtension2 = nestedTableExtension.attrs) === null || _nestedTableExtension2 === void 0 || (_nestedTableExtension2 = _nestedTableExtension2.parameters) === null || _nestedTableExtension2 === void 0 ? void 0 : _nestedTableExtension2.adf);
        if (!adf.content || adf.content.length === 0) return false;
        return adf.content[0];
    } catch (e) {
        throw new (0, $9NJGe.NodeNestingTransformError)('Failed to parse nested table content');
    }
};
// TODO: EDITOR-806 - Remove when cleaning feature gate platform_editor_nested_table_extension_comment_fix
function $78e24cfe69c0e04a$var$isInsideBodiedExtension(parent) {
    var _parent$parent;
    if (parent.node === undefined) return false;
    if (parent.node.type === 'bodiedExtension') return true;
    if (parent !== null && parent !== void 0 && (_parent$parent = parent.parent) !== null && _parent$parent !== void 0 && _parent$parent.node) return $78e24cfe69c0e04a$var$isInsideBodiedExtension(parent.parent);
    return false;
}
var $78e24cfe69c0e04a$export$18544d0b5f43e4a1 = function transformNestedTablesIncomingDocument(adf) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var isTransformed = false;
    var transformedAdf = (0, $em8IR.traverse)(adf, {
        extension: function extension(node, parent) {
            if ($78e24cfe69c0e04a$export$f45e7335ec874bfe(node)) {
                // TODO: EDITOR-806 - Remove this block when cleaning feature gate platform_editor_nested_table_extension_comment_fix
                // Bodied extensions in renderer use their own nested renderer to render the content.
                // This results in the document being validated/transformed twice, once with untransformed content and again with transformed content.
                // Since the untransformed content is valid ADF (table as extension in table) but the transformed content is not valid ADF, (table in table)
                // we need to skip transforming nested tables inside bodied extensions in renderer on the first pass or else it will fail validation and render an unsupported block.
                if (options.environment === 'renderer' && $78e24cfe69c0e04a$var$isInsideBodiedExtension(parent) && !options.disableNestedRendererTreatment) return undefined;
                isTransformed = true;
                return $78e24cfe69c0e04a$var$transformNestedTableExtension(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
var $78e24cfe69c0e04a$export$8a334a7d9fe120ec = function transformNestedTableNodeOutgoingDocument(tableCellNode) {
    try {
        var _tableCellNode$conten;
        return $78e24cfe69c0e04a$var$_objectSpread($78e24cfe69c0e04a$var$_objectSpread({}, tableCellNode), {}, {
            content: (_tableCellNode$conten = tableCellNode.content) === null || _tableCellNode$conten === void 0 ? void 0 : _tableCellNode$conten.map(function(childNode) {
                // wrap nested table in an extension node
                if ((childNode === null || childNode === void 0 ? void 0 : childNode.type) === 'table') return (0, $i8z2E.extension)({
                    extensionType: $78e24cfe69c0e04a$var$NESTED_TABLE_EXTENSION_TYPE,
                    extensionKey: $78e24cfe69c0e04a$var$NESTED_TABLE_EXTENSION_KEY,
                    parameters: {
                        adf: JSON.stringify({
                            type: 'doc',
                            version: 1,
                            content: [
                                childNode
                            ]
                        })
                    }
                });
                return childNode;
            })
        });
    } catch (e) {
        throw new (0, $9NJGe.NodeNestingTransformError)('Failed to encode nested table node');
    }
};

});
parcelRegister("em8IR", function(module, exports) {
$parcel$export(module.exports, "traverse", function () { return $a739e2e765600197$export$df3f009e3d155b20; });

var $lUar6 = parcelRequire("lUar6");
function $a739e2e765600197$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a739e2e765600197$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a739e2e765600197$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a739e2e765600197$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a739e2e765600197$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $a739e2e765600197$export$df3f009e3d155b20(adf, visitors) {
    if (!$a739e2e765600197$export$735cfea22ce30f58(visitors)) throw new Error("Visitors are not valid: \"".concat(Object.keys(visitors).join(', '), "\""));
    return $a739e2e765600197$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $a739e2e765600197$var$traverseNode(adfNode, parent, visitors, index, depth) {
    var visitor = visitors[adfNode.type] || visitors['any'];
    var newNode = $a739e2e765600197$var$_objectSpread({}, adfNode);
    if (visitor) {
        var processedNode = visitor($a739e2e765600197$var$_objectSpread({}, newNode), parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce(function(acc, node, idx) {
        if (!node) return acc;
        var processedNode = $a739e2e765600197$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});

parcelRegister("i8z2E", function(module, exports) {
$parcel$export(module.exports, "extension", function () { return $d34427ef78a6caa0$export$1b45514b112dd749; });
var $d34427ef78a6caa0$export$1b45514b112dd749 = function extension(attrs) {
    return {
        type: 'extension',
        attrs: attrs
    };
};

});

parcelRegister("9NJGe", function(module, exports) {
$parcel$export(module.exports, "NodeNestingTransformError", function () { return $722c1fc4ea611957$export$3d8e8d2182f13924; });

var $2871N = parcelRequire("2871N");

var $hiPA7 = parcelRequire("hiPA7");

var $eDhqJ = parcelRequire("eDhqJ");

var $aDM8J = parcelRequire("aDM8J");

var $cxyvF = parcelRequire("cxyvF");

var $3rO3z = parcelRequire("3rO3z");
function $722c1fc4ea611957$var$_callSuper(t, o, e) {
    return o = (0, $aDM8J.default)(o), (0, $eDhqJ.default)(t, $722c1fc4ea611957$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $aDM8J.default)(t).constructor) : o.apply(t, e));
}
function $722c1fc4ea611957$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($722c1fc4ea611957$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $722c1fc4ea611957$export$3d8e8d2182f13924 = /*#__PURE__*/ function(_Error) {
    /**
   * @param message - Error message - Do not use any UGC in this message
   */ function NodeNestingTransformError(message) {
        var _this;
        (0, $hiPA7.default)(this, NodeNestingTransformError);
        _this = $722c1fc4ea611957$var$_callSuper(this, NodeNestingTransformError, [
            message
        ]);
        _this.name = 'NodeNestingTransformError';
        return _this;
    }
    (0, $cxyvF.default)(NodeNestingTransformError, _Error);
    return (0, $2871N.default)(NodeNestingTransformError);
}(/*#__PURE__*/ (0, $3rO3z.default)(Error));

});


parcelRegister("fdwQ2", function(module, exports) {
$parcel$export(module.exports, "removeMarks", function () { return $b1418aed8c93afe7$export$9bf001d8ef76e497; });
$parcel$export(module.exports, "removeNonAnnotationMarks", function () { return $b1418aed8c93afe7$export$8cae9126fc577085; });

var $lUar6 = parcelRequire("lUar6");
function $b1418aed8c93afe7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b1418aed8c93afe7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b1418aed8c93afe7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $lUar6.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b1418aed8c93afe7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b1418aed8c93afe7$export$9bf001d8ef76e497(node) {
    var newNode = $b1418aed8c93afe7$var$_objectSpread({}, node);
    delete newNode.marks;
    return newNode;
}
function $b1418aed8c93afe7$export$8cae9126fc577085(node) {
    var newNode = $b1418aed8c93afe7$var$_objectSpread({}, node);
    if (node.marks) newNode.marks = node.marks.filter(function(mark) {
        return mark.type === 'annotation';
    });
    return newNode;
}

});




parcelRegister("cnLy7", function(module, exports) {
$parcel$export(module.exports, "AiMateMarkdownTransformer", function () { return $903c84572a6a35e9$export$614853bf2169db97; });

var $eVBqw = parcelRequire("eVBqw");

var $aHrBh = parcelRequire("aHrBh");

var $i9V20 = parcelRequire("i9V20");

var $hCepl = parcelRequire("hCepl");

var $37Imi = parcelRequire("37Imi");

var $b60TI = parcelRequire("b60TI");

var $8DNPl = parcelRequire("8DNPl");

var $2CJiD = parcelRequire("2CJiD");

var $2S3V5 = parcelRequire("2S3V5");

var $9ZwyL = parcelRequire("9ZwyL");

var $39c3M = parcelRequire("39c3M");

var $d6iF4 = parcelRequire("d6iF4");

var $l1YGC = parcelRequire("l1YGC");

var $1o1tc = parcelRequire("1o1tc");

var $hubVA = parcelRequire("hubVA");

var $lNotn = parcelRequire("lNotn");

var $9Pv4k = parcelRequire("9Pv4k");

var $6oSt6 = parcelRequire("6oSt6");

var $eDDZa = parcelRequire("eDDZa");
function $903c84572a6a35e9$var$_callSuper(t, o, e) {
    return o = (0, $hCepl.default)(o), (0, $i9V20.default)(t, $903c84572a6a35e9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $hCepl.default)(t).constructor) : o.apply(t, e));
}
function $903c84572a6a35e9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($903c84572a6a35e9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $903c84572a6a35e9$export$614853bf2169db97 = /*#__PURE__*/ function(_MarkdownTransformer) {
    function AiMateMarkdownTransformer(schema, pluginConfig, streaming) {
        var _this;
        (0, $eVBqw.default)(this, AiMateMarkdownTransformer);
        _this = $903c84572a6a35e9$var$_callSuper(this, AiMateMarkdownTransformer);
        var md = (0, (/*@__PURE__*/$parcel$interopDefault($b60TI)))('zero', {
            html: false
        });
        md.enable([
            // Process html entity - &#123;, &#xAF;, &quot;, ...
            'entity',
            // Process escaped chars and hardbreaks
            'escape',
            'newline'
        ]);
        (0, $eDDZa.enableSchemaPlugins)(md, schema);
        // enable modified version of linkify plugin
        // @see https://product-fabric.atlassian.net/browse/ED-3097
        md.use((0, $1o1tc.createLinkifyPlugin)(pluginConfig.linkify));
        md.use((0, $d6iF4.default));
        if ((0, $39c3M.fg)('rovo_enable_data_sculptor')) md.use((0, $l1YGC.default));
        // Convert links with Linking Platform supported URLs to Smart Links
        if (!streaming && (schema.nodes.inlineCard || schema.nodes.blockCard || schema.nodes.embedCard)) md.use((0, $9Pv4k.createSmartLinksPlugin)(pluginConfig.smartLinks));
        // Convert links matching people directory URLs to mentions
        if (schema.nodes.mention) md.use((0, $lNotn.default));
        // Table support
        if (schema.nodes.table) md.use((0, $8DNPl.markdownItTable));
        // Image support
        if (schema.nodes.media && schema.nodes.mediaSingle) md.use((0, $hubVA.default));
        var filter = (0, $eDDZa.filterSchemaMapping)(schema, (0, $6oSt6.mdToPmSchema));
        _this.parser = new (0, $2S3V5.MarkdownParser)(schema, md, filter);
        return _this;
    }
    (0, $37Imi.default)(AiMateMarkdownTransformer, _MarkdownTransformer);
    return (0, $aHrBh.default)(AiMateMarkdownTransformer, [
        {
            key: "parse",
            value: function parse(content) {
                var node = this.parser.parse(content);
                if (!node) return new (0, $9ZwyL.Node)();
                return node;
            }
        }
    ]);
}((0, $2CJiD.MarkdownTransformer));

});
parcelRegister("eVBqw", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ade36bb8c9fd99cd$export$2e2bcd8739ae039; });
function $ade36bb8c9fd99cd$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("aHrBh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7ca3546604f73913$export$2e2bcd8739ae039; });

var $8L8Rk = parcelRequire("8L8Rk");
function $7ca3546604f73913$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $8L8Rk.default)(o.key), o);
    }
}
function $7ca3546604f73913$export$2e2bcd8739ae039(e, r, t) {
    return r && $7ca3546604f73913$var$_defineProperties(e.prototype, r), t && $7ca3546604f73913$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("8L8Rk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $660995c46c15179a$export$2e2bcd8739ae039; });

var $i6sgL = parcelRequire("i6sgL");

var $6iSLq = parcelRequire("6iSLq");
function $660995c46c15179a$export$2e2bcd8739ae039(t) {
    var i = (0, $6iSLq.default)(t, "string");
    return "symbol" == (0, $i6sgL.default)(i) ? i : i + "";
}

});
parcelRegister("i6sgL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0366b0600e45ee3d$export$2e2bcd8739ae039; });
function $0366b0600e45ee3d$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $0366b0600e45ee3d$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0366b0600e45ee3d$export$2e2bcd8739ae039(o);
}

});

parcelRegister("6iSLq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $496ee777f5e42e54$export$2e2bcd8739ae039; });

var $i6sgL = parcelRequire("i6sgL");
function $496ee777f5e42e54$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $i6sgL.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $i6sgL.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("i9V20", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d3854e8286ab50a6$export$2e2bcd8739ae039; });

var $i6sgL = parcelRequire("i6sgL");

var $gytk3 = parcelRequire("gytk3");
function $d3854e8286ab50a6$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $i6sgL.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $gytk3.default)(t);
}

});
parcelRegister("gytk3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c0d6912a0f1b6a39$export$2e2bcd8739ae039; });
function $c0d6912a0f1b6a39$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});


parcelRegister("hCepl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cd312958d817112b$export$2e2bcd8739ae039; });
function $cd312958d817112b$export$2e2bcd8739ae039(t) {
    return $cd312958d817112b$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $cd312958d817112b$export$2e2bcd8739ae039(t);
}

});

parcelRegister("37Imi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $24646f37efb338b9$export$2e2bcd8739ae039; });

var $1drQo = parcelRequire("1drQo");
function $24646f37efb338b9$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $1drQo.default)(t, e);
}

});
parcelRegister("1drQo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0e2c9a9c14a7502e$export$2e2bcd8739ae039; });
function $0e2c9a9c14a7502e$export$2e2bcd8739ae039(t, e) {
    return $0e2c9a9c14a7502e$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0e2c9a9c14a7502e$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("b60TI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dFevk"));

});
parcelRegister("dFevk", function(module, exports) {
// Main parser class
'use strict';

var $iKXJl = parcelRequire("iKXJl");

var $54Xje = parcelRequire("54Xje");

var $1BM1a = parcelRequire("1BM1a");

var $70xzc = parcelRequire("70xzc");

var $9bpP3 = parcelRequire("9bpP3");

var $2VcQp = parcelRequire("2VcQp");

var $eD8sl = parcelRequire("eD8sl");

var $fpTlz = parcelRequire("fpTlz");

var $2yQCr = parcelRequire("2yQCr");



var $9f2a5aedf925c0fb$var$config = {
    default: (parcelRequire("49x3M")),
    zero: (parcelRequire("7OSSd")),
    commonmark: (parcelRequire("fpgSy"))
};
////////////////////////////////////////////////////////////////////////////////
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
var $9f2a5aedf925c0fb$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
var $9f2a5aedf925c0fb$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $9f2a5aedf925c0fb$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    var str = url.trim().toLowerCase();
    return $9f2a5aedf925c0fb$var$BAD_PROTO_RE.test(str) ? $9f2a5aedf925c0fb$var$GOOD_DATA_RE.test(str) ? true : false : true;
}
////////////////////////////////////////////////////////////////////////////////
var $9f2a5aedf925c0fb$var$RECODE_HOSTNAME_FOR = [
    'http:',
    'https:',
    'mailto:'
];
function $9f2a5aedf925c0fb$var$normalizeLink(url) {
    var parsed = $fpTlz.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $9f2a5aedf925c0fb$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $2yQCr.toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $fpTlz.encode($fpTlz.format(parsed));
}
function $9f2a5aedf925c0fb$var$normalizeLinkText(url) {
    var parsed = $fpTlz.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $9f2a5aedf925c0fb$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $2yQCr.toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $fpTlz.decode($fpTlz.format(parsed), $fpTlz.decode.defaultChars + '%');
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre class="hljs"><code>' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $9f2a5aedf925c0fb$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $9f2a5aedf925c0fb$var$MarkdownIt)) return new $9f2a5aedf925c0fb$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$iKXJl.isString(presetName)) {
            options = presetName || {};
            presetName = 'default';
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new $2VcQp();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new $9bpP3();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new $70xzc();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/ this.renderer = new $1BM1a();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/ this.linkify = new $eD8sl();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $9f2a5aedf925c0fb$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $9f2a5aedf925c0fb$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $9f2a5aedf925c0fb$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
   **/ this.utils = $iKXJl;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $iKXJl.assign({}, $54Xje);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $9f2a5aedf925c0fb$var$MarkdownIt.prototype.set = function(options) {
    $iKXJl.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $9f2a5aedf925c0fb$var$MarkdownIt.prototype.configure = function(presets) {
    var self = this, presetName;
    if ($iKXJl.isString(presets)) {
        presetName = presets;
        presets = $9f2a5aedf925c0fb$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error('Wrong `markdown-it` preset, can\'t be empty');
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $9f2a5aedf925c0fb$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $9f2a5aedf925c0fb$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $9f2a5aedf925c0fb$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    var args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $9f2a5aedf925c0fb$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== 'string') throw new Error('Input data should be a String');
    var state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $9f2a5aedf925c0fb$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $9f2a5aedf925c0fb$var$MarkdownIt.prototype.parseInline = function(src, env) {
    var state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $9f2a5aedf925c0fb$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
module.exports = $9f2a5aedf925c0fb$var$MarkdownIt;

});
parcelRegister("iKXJl", function(module, exports) {
$parcel$export(module.exports, "lib", function () { return $da7adb13d3c9792a$export$16c08b91f883959a; }, function (v) { return $da7adb13d3c9792a$export$16c08b91f883959a = v; });
$parcel$export(module.exports, "assign", function () { return $da7adb13d3c9792a$export$e6e34fd1f2686227; }, function (v) { return $da7adb13d3c9792a$export$e6e34fd1f2686227 = v; });
$parcel$export(module.exports, "isString", function () { return $da7adb13d3c9792a$export$844ec244b1367d54; }, function (v) { return $da7adb13d3c9792a$export$844ec244b1367d54 = v; });
$parcel$export(module.exports, "has", function () { return $da7adb13d3c9792a$export$a4f4bb6b1453fff5; }, function (v) { return $da7adb13d3c9792a$export$a4f4bb6b1453fff5 = v; });
$parcel$export(module.exports, "unescapeMd", function () { return $da7adb13d3c9792a$export$5ccde1ea0c14bb03; }, function (v) { return $da7adb13d3c9792a$export$5ccde1ea0c14bb03 = v; });
$parcel$export(module.exports, "unescapeAll", function () { return $da7adb13d3c9792a$export$db8a17c6655f7e2c; }, function (v) { return $da7adb13d3c9792a$export$db8a17c6655f7e2c = v; });
$parcel$export(module.exports, "isValidEntityCode", function () { return $da7adb13d3c9792a$export$644a8f5b13b2a36d; }, function (v) { return $da7adb13d3c9792a$export$644a8f5b13b2a36d = v; });
$parcel$export(module.exports, "fromCodePoint", function () { return $da7adb13d3c9792a$export$73bfc63873071f74; }, function (v) { return $da7adb13d3c9792a$export$73bfc63873071f74 = v; });
$parcel$export(module.exports, "escapeHtml", function () { return $da7adb13d3c9792a$export$4cf11838cdc2a8a8; }, function (v) { return $da7adb13d3c9792a$export$4cf11838cdc2a8a8 = v; });
$parcel$export(module.exports, "arrayReplaceAt", function () { return $da7adb13d3c9792a$export$f78478f71955b6bc; }, function (v) { return $da7adb13d3c9792a$export$f78478f71955b6bc = v; });
$parcel$export(module.exports, "isSpace", function () { return $da7adb13d3c9792a$export$1d5ccafae59b4926; }, function (v) { return $da7adb13d3c9792a$export$1d5ccafae59b4926 = v; });
$parcel$export(module.exports, "isWhiteSpace", function () { return $da7adb13d3c9792a$export$3c52dd84024ae72c; }, function (v) { return $da7adb13d3c9792a$export$3c52dd84024ae72c = v; });
$parcel$export(module.exports, "isMdAsciiPunct", function () { return $da7adb13d3c9792a$export$829a0d33ae4e744; }, function (v) { return $da7adb13d3c9792a$export$829a0d33ae4e744 = v; });
$parcel$export(module.exports, "isPunctChar", function () { return $da7adb13d3c9792a$export$4888a643af800fc1; }, function (v) { return $da7adb13d3c9792a$export$4888a643af800fc1 = v; });
$parcel$export(module.exports, "escapeRE", function () { return $da7adb13d3c9792a$export$bc616c8f7dc20d5d; }, function (v) { return $da7adb13d3c9792a$export$bc616c8f7dc20d5d = v; });
$parcel$export(module.exports, "normalizeReference", function () { return $da7adb13d3c9792a$export$20ef46802c8744b; }, function (v) { return $da7adb13d3c9792a$export$20ef46802c8744b = v; });
// Utilities
//
////////////////////////////////////////////////////////////////////////////////
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
var $da7adb13d3c9792a$export$16c08b91f883959a;
var $da7adb13d3c9792a$export$e6e34fd1f2686227;
var $da7adb13d3c9792a$export$844ec244b1367d54;
var $da7adb13d3c9792a$export$a4f4bb6b1453fff5;
var $da7adb13d3c9792a$export$5ccde1ea0c14bb03;
var $da7adb13d3c9792a$export$db8a17c6655f7e2c;
var $da7adb13d3c9792a$export$644a8f5b13b2a36d;
var $da7adb13d3c9792a$export$73bfc63873071f74;
// exports.replaceEntities     = replaceEntities;
var $da7adb13d3c9792a$export$4cf11838cdc2a8a8;
var $da7adb13d3c9792a$export$f78478f71955b6bc;
var $da7adb13d3c9792a$export$1d5ccafae59b4926;
var $da7adb13d3c9792a$export$3c52dd84024ae72c;
var $da7adb13d3c9792a$export$829a0d33ae4e744;
var $da7adb13d3c9792a$export$4888a643af800fc1;
var $da7adb13d3c9792a$export$bc616c8f7dc20d5d;
var $da7adb13d3c9792a$export$20ef46802c8744b;
'use strict';
function $da7adb13d3c9792a$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $da7adb13d3c9792a$var$isString(obj) {
    return $da7adb13d3c9792a$var$_class(obj) === '[object String]';
}
var $da7adb13d3c9792a$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $da7adb13d3c9792a$var$has(object, key) {
    return $da7adb13d3c9792a$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $da7adb13d3c9792a$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== 'object') throw new TypeError(source + 'must be object');
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $da7adb13d3c9792a$var$arrayReplaceAt(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
////////////////////////////////////////////////////////////////////////////////
function $da7adb13d3c9792a$var$isValidEntityCode(c) {
    /*eslint no-bitwise:0*/ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $da7adb13d3c9792a$var$fromCodePoint(c) {
    /*eslint no-bitwise:0*/ if (c > 0xffff) {
        c -= 0x10000;
        var surrogate1 = 0xd800 + (c >> 10), surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
var $da7adb13d3c9792a$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
var $da7adb13d3c9792a$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
var $da7adb13d3c9792a$var$UNESCAPE_ALL_RE = new RegExp($da7adb13d3c9792a$var$UNESCAPE_MD_RE.source + '|' + $da7adb13d3c9792a$var$ENTITY_RE.source, 'gi');
var $da7adb13d3c9792a$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;

var $kwuCU = parcelRequire("kwuCU");
function $da7adb13d3c9792a$var$replaceEntityPattern(match, name) {
    var code;
    if ($da7adb13d3c9792a$var$has($kwuCU, name)) return $kwuCU[name];
    if (name.charCodeAt(0) === 0x23 /* # */  && $da7adb13d3c9792a$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($da7adb13d3c9792a$var$isValidEntityCode(code)) return $da7adb13d3c9792a$var$fromCodePoint(code);
    }
    return match;
}
/*function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
}*/ function $da7adb13d3c9792a$var$unescapeMd(str) {
    if (str.indexOf('\\') < 0) return str;
    return str.replace($da7adb13d3c9792a$var$UNESCAPE_MD_RE, '$1');
}
function $da7adb13d3c9792a$var$unescapeAll(str) {
    if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) return str;
    return str.replace($da7adb13d3c9792a$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $da7adb13d3c9792a$var$replaceEntityPattern(match, entity);
    });
}
////////////////////////////////////////////////////////////////////////////////
var $da7adb13d3c9792a$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
var $da7adb13d3c9792a$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var $da7adb13d3c9792a$var$HTML_REPLACEMENTS = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
};
function $da7adb13d3c9792a$var$replaceUnsafeChar(ch) {
    return $da7adb13d3c9792a$var$HTML_REPLACEMENTS[ch];
}
function $da7adb13d3c9792a$var$escapeHtml(str) {
    if ($da7adb13d3c9792a$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($da7adb13d3c9792a$var$HTML_ESCAPE_REPLACE_RE, $da7adb13d3c9792a$var$replaceUnsafeChar);
    return str;
}
////////////////////////////////////////////////////////////////////////////////
var $da7adb13d3c9792a$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $da7adb13d3c9792a$var$escapeRE(str) {
    return str.replace($da7adb13d3c9792a$var$REGEXP_ESCAPE_RE, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
function $da7adb13d3c9792a$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $da7adb13d3c9792a$var$isWhiteSpace(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}

var $9R3PW = parcelRequire("9R3PW");
// Currently without astral characters support.
function $da7adb13d3c9792a$var$isPunctChar(ch) {
    return $9R3PW.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $da7adb13d3c9792a$var$isMdAsciiPunct(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $da7adb13d3c9792a$var$normalizeReference(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, ' ');
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
$da7adb13d3c9792a$export$16c08b91f883959a = {};

$da7adb13d3c9792a$export$16c08b91f883959a.mdurl = (parcelRequire("fpTlz"));

$da7adb13d3c9792a$export$16c08b91f883959a.ucmicro = (parcelRequire("9CsYT"));
$da7adb13d3c9792a$export$e6e34fd1f2686227 = $da7adb13d3c9792a$var$assign;
$da7adb13d3c9792a$export$844ec244b1367d54 = $da7adb13d3c9792a$var$isString;
$da7adb13d3c9792a$export$a4f4bb6b1453fff5 = $da7adb13d3c9792a$var$has;
$da7adb13d3c9792a$export$5ccde1ea0c14bb03 = $da7adb13d3c9792a$var$unescapeMd;
$da7adb13d3c9792a$export$db8a17c6655f7e2c = $da7adb13d3c9792a$var$unescapeAll;
$da7adb13d3c9792a$export$644a8f5b13b2a36d = $da7adb13d3c9792a$var$isValidEntityCode;
$da7adb13d3c9792a$export$73bfc63873071f74 = $da7adb13d3c9792a$var$fromCodePoint;
$da7adb13d3c9792a$export$4cf11838cdc2a8a8 = $da7adb13d3c9792a$var$escapeHtml;
$da7adb13d3c9792a$export$f78478f71955b6bc = $da7adb13d3c9792a$var$arrayReplaceAt;
$da7adb13d3c9792a$export$1d5ccafae59b4926 = $da7adb13d3c9792a$var$isSpace;
$da7adb13d3c9792a$export$3c52dd84024ae72c = $da7adb13d3c9792a$var$isWhiteSpace;
$da7adb13d3c9792a$export$829a0d33ae4e744 = $da7adb13d3c9792a$var$isMdAsciiPunct;
$da7adb13d3c9792a$export$4888a643af800fc1 = $da7adb13d3c9792a$var$isPunctChar;
$da7adb13d3c9792a$export$bc616c8f7dc20d5d = $da7adb13d3c9792a$var$escapeRE;
$da7adb13d3c9792a$export$20ef46802c8744b = $da7adb13d3c9792a$var$normalizeReference;

});
parcelRegister("kwuCU", function(module, exports) {
// HTML5 entities map: { name -> utf16string }
//
'use strict';

/*eslint quotes:0*/ module.exports = (parcelRequire("XUcfm"));

});
parcelRegister("XUcfm", function(module, exports) {
module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Abreve":"\u0102","abreve":"\u0103","ac":"\u223E","acd":"\u223F","acE":"\u223E\u0333","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","Acy":"\u0410","acy":"\u0430","AElig":"\xc6","aelig":"\xe6","af":"\u2061","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\xc0","agrave":"\xe0","alefsym":"\u2135","aleph":"\u2135","Alpha":"\u0391","alpha":"\u03B1","Amacr":"\u0100","amacr":"\u0101","amalg":"\u2A3F","amp":"&","AMP":"&","andand":"\u2A55","And":"\u2A53","and":"\u2227","andd":"\u2A5C","andslope":"\u2A58","andv":"\u2A5A","ang":"\u2220","ange":"\u29A4","angle":"\u2220","angmsdaa":"\u29A8","angmsdab":"\u29A9","angmsdac":"\u29AA","angmsdad":"\u29AB","angmsdae":"\u29AC","angmsdaf":"\u29AD","angmsdag":"\u29AE","angmsdah":"\u29AF","angmsd":"\u2221","angrt":"\u221F","angrtvb":"\u22BE","angrtvbd":"\u299D","angsph":"\u2222","angst":"\xc5","angzarr":"\u237C","Aogon":"\u0104","aogon":"\u0105","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"\u2A6F","ap":"\u2248","apE":"\u2A70","ape":"\u224A","apid":"\u224B","apos":"\'","ApplyFunction":"\u2061","approx":"\u2248","approxeq":"\u224A","Aring":"\xc5","aring":"\xe5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"\u2254","ast":"*","asymp":"\u2248","asympeq":"\u224D","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","awconint":"\u2233","awint":"\u2A11","backcong":"\u224C","backepsilon":"\u03F6","backprime":"\u2035","backsim":"\u223D","backsimeq":"\u22CD","Backslash":"\u2216","Barv":"\u2AE7","barvee":"\u22BD","barwed":"\u2305","Barwed":"\u2306","barwedge":"\u2305","bbrk":"\u23B5","bbrktbrk":"\u23B6","bcong":"\u224C","Bcy":"\u0411","bcy":"\u0431","bdquo":"\u201E","becaus":"\u2235","because":"\u2235","Because":"\u2235","bemptyv":"\u29B0","bepsi":"\u03F6","bernou":"\u212C","Bernoullis":"\u212C","Beta":"\u0392","beta":"\u03B2","beth":"\u2136","between":"\u226C","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"\u22C2","bigcirc":"\u25EF","bigcup":"\u22C3","bigodot":"\u2A00","bigoplus":"\u2A01","bigotimes":"\u2A02","bigsqcup":"\u2A06","bigstar":"\u2605","bigtriangledown":"\u25BD","bigtriangleup":"\u25B3","biguplus":"\u2A04","bigvee":"\u22C1","bigwedge":"\u22C0","bkarow":"\u290D","blacklozenge":"\u29EB","blacksquare":"\u25AA","blacktriangle":"\u25B4","blacktriangledown":"\u25BE","blacktriangleleft":"\u25C2","blacktriangleright":"\u25B8","blank":"\u2423","blk12":"\u2592","blk14":"\u2591","blk34":"\u2593","block":"\u2588","bne":"=\u20E5","bnequiv":"\u2261\u20E5","bNot":"\u2AED","bnot":"\u2310","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"\u22A5","bottom":"\u22A5","bowtie":"\u22C8","boxbox":"\u29C9","boxdl":"\u2510","boxdL":"\u2555","boxDl":"\u2556","boxDL":"\u2557","boxdr":"\u250C","boxdR":"\u2552","boxDr":"\u2553","boxDR":"\u2554","boxh":"\u2500","boxH":"\u2550","boxhd":"\u252C","boxHd":"\u2564","boxhD":"\u2565","boxHD":"\u2566","boxhu":"\u2534","boxHu":"\u2567","boxhU":"\u2568","boxHU":"\u2569","boxminus":"\u229F","boxplus":"\u229E","boxtimes":"\u22A0","boxul":"\u2518","boxuL":"\u255B","boxUl":"\u255C","boxUL":"\u255D","boxur":"\u2514","boxuR":"\u2558","boxUr":"\u2559","boxUR":"\u255A","boxv":"\u2502","boxV":"\u2551","boxvh":"\u253C","boxvH":"\u256A","boxVh":"\u256B","boxVH":"\u256C","boxvl":"\u2524","boxvL":"\u2561","boxVl":"\u2562","boxVL":"\u2563","boxvr":"\u251C","boxvR":"\u255E","boxVr":"\u255F","boxVR":"\u2560","bprime":"\u2035","breve":"\u02D8","Breve":"\u02D8","brvbar":"\xa6","bscr":"\uD835\uDCB7","Bscr":"\u212C","bsemi":"\u204F","bsim":"\u223D","bsime":"\u22CD","bsolb":"\u29C5","bsol":"\\\\","bsolhsub":"\u27C8","bull":"\u2022","bullet":"\u2022","bump":"\u224E","bumpE":"\u2AAE","bumpe":"\u224F","Bumpeq":"\u224E","bumpeq":"\u224F","Cacute":"\u0106","cacute":"\u0107","capand":"\u2A44","capbrcup":"\u2A49","capcap":"\u2A4B","cap":"\u2229","Cap":"\u22D2","capcup":"\u2A47","capdot":"\u2A40","CapitalDifferentialD":"\u2145","caps":"\u2229\uFE00","caret":"\u2041","caron":"\u02C7","Cayleys":"\u212D","ccaps":"\u2A4D","Ccaron":"\u010C","ccaron":"\u010D","Ccedil":"\xc7","ccedil":"\xe7","Ccirc":"\u0108","ccirc":"\u0109","Cconint":"\u2230","ccups":"\u2A4C","ccupssm":"\u2A50","Cdot":"\u010A","cdot":"\u010B","cedil":"\xb8","Cedilla":"\xb8","cemptyv":"\u29B2","cent":"\xa2","centerdot":"\xb7","CenterDot":"\xb7","cfr":"\uD835\uDD20","Cfr":"\u212D","CHcy":"\u0427","chcy":"\u0447","check":"\u2713","checkmark":"\u2713","Chi":"\u03A7","chi":"\u03C7","circ":"\u02C6","circeq":"\u2257","circlearrowleft":"\u21BA","circlearrowright":"\u21BB","circledast":"\u229B","circledcirc":"\u229A","circleddash":"\u229D","CircleDot":"\u2299","circledR":"\xae","circledS":"\u24C8","CircleMinus":"\u2296","CirclePlus":"\u2295","CircleTimes":"\u2297","cir":"\u25CB","cirE":"\u29C3","cire":"\u2257","cirfnint":"\u2A10","cirmid":"\u2AEF","cirscir":"\u29C2","ClockwiseContourIntegral":"\u2232","CloseCurlyDoubleQuote":"\u201D","CloseCurlyQuote":"\u2019","clubs":"\u2663","clubsuit":"\u2663","colon":":","Colon":"\u2237","Colone":"\u2A74","colone":"\u2254","coloneq":"\u2254","comma":",","commat":"@","comp":"\u2201","compfn":"\u2218","complement":"\u2201","complexes":"\u2102","cong":"\u2245","congdot":"\u2A6D","Congruent":"\u2261","conint":"\u222E","Conint":"\u222F","ContourIntegral":"\u222E","copf":"\uD835\uDD54","Copf":"\u2102","coprod":"\u2210","Coproduct":"\u2210","copy":"\xa9","COPY":"\xa9","copysr":"\u2117","CounterClockwiseContourIntegral":"\u2233","crarr":"\u21B5","cross":"\u2717","Cross":"\u2A2F","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"\u2ACF","csube":"\u2AD1","csup":"\u2AD0","csupe":"\u2AD2","ctdot":"\u22EF","cudarrl":"\u2938","cudarrr":"\u2935","cuepr":"\u22DE","cuesc":"\u22DF","cularr":"\u21B6","cularrp":"\u293D","cupbrcap":"\u2A48","cupcap":"\u2A46","CupCap":"\u224D","cup":"\u222A","Cup":"\u22D3","cupcup":"\u2A4A","cupdot":"\u228D","cupor":"\u2A45","cups":"\u222A\uFE00","curarr":"\u21B7","curarrm":"\u293C","curlyeqprec":"\u22DE","curlyeqsucc":"\u22DF","curlyvee":"\u22CE","curlywedge":"\u22CF","curren":"\xa4","curvearrowleft":"\u21B6","curvearrowright":"\u21B7","cuvee":"\u22CE","cuwed":"\u22CF","cwconint":"\u2232","cwint":"\u2231","cylcty":"\u232D","dagger":"\u2020","Dagger":"\u2021","daleth":"\u2138","darr":"\u2193","Darr":"\u21A1","dArr":"\u21D3","dash":"\u2010","Dashv":"\u2AE4","dashv":"\u22A3","dbkarow":"\u290F","dblac":"\u02DD","Dcaron":"\u010E","dcaron":"\u010F","Dcy":"\u0414","dcy":"\u0434","ddagger":"\u2021","ddarr":"\u21CA","DD":"\u2145","dd":"\u2146","DDotrahd":"\u2911","ddotseq":"\u2A77","deg":"\xb0","Del":"\u2207","Delta":"\u0394","delta":"\u03B4","demptyv":"\u29B1","dfisht":"\u297F","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"\u2965","dharl":"\u21C3","dharr":"\u21C2","DiacriticalAcute":"\xb4","DiacriticalDot":"\u02D9","DiacriticalDoubleAcute":"\u02DD","DiacriticalGrave":"`","DiacriticalTilde":"\u02DC","diam":"\u22C4","diamond":"\u22C4","Diamond":"\u22C4","diamondsuit":"\u2666","diams":"\u2666","die":"\xa8","DifferentialD":"\u2146","digamma":"\u03DD","disin":"\u22F2","div":"\xf7","divide":"\xf7","divideontimes":"\u22C7","divonx":"\u22C7","DJcy":"\u0402","djcy":"\u0452","dlcorn":"\u231E","dlcrop":"\u230D","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\xa8","dot":"\u02D9","DotDot":"\u20DC","doteq":"\u2250","doteqdot":"\u2251","DotEqual":"\u2250","dotminus":"\u2238","dotplus":"\u2214","dotsquare":"\u22A1","doublebarwedge":"\u2306","DoubleContourIntegral":"\u222F","DoubleDot":"\xa8","DoubleDownArrow":"\u21D3","DoubleLeftArrow":"\u21D0","DoubleLeftRightArrow":"\u21D4","DoubleLeftTee":"\u2AE4","DoubleLongLeftArrow":"\u27F8","DoubleLongLeftRightArrow":"\u27FA","DoubleLongRightArrow":"\u27F9","DoubleRightArrow":"\u21D2","DoubleRightTee":"\u22A8","DoubleUpArrow":"\u21D1","DoubleUpDownArrow":"\u21D5","DoubleVerticalBar":"\u2225","DownArrowBar":"\u2913","downarrow":"\u2193","DownArrow":"\u2193","Downarrow":"\u21D3","DownArrowUpArrow":"\u21F5","DownBreve":"\u0311","downdownarrows":"\u21CA","downharpoonleft":"\u21C3","downharpoonright":"\u21C2","DownLeftRightVector":"\u2950","DownLeftTeeVector":"\u295E","DownLeftVectorBar":"\u2956","DownLeftVector":"\u21BD","DownRightTeeVector":"\u295F","DownRightVectorBar":"\u2957","DownRightVector":"\u21C1","DownTeeArrow":"\u21A7","DownTee":"\u22A4","drbkarow":"\u2910","drcorn":"\u231F","drcrop":"\u230C","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"\u0405","dscy":"\u0455","dsol":"\u29F6","Dstrok":"\u0110","dstrok":"\u0111","dtdot":"\u22F1","dtri":"\u25BF","dtrif":"\u25BE","duarr":"\u21F5","duhar":"\u296F","dwangle":"\u29A6","DZcy":"\u040F","dzcy":"\u045F","dzigrarr":"\u27FF","Eacute":"\xc9","eacute":"\xe9","easter":"\u2A6E","Ecaron":"\u011A","ecaron":"\u011B","Ecirc":"\xca","ecirc":"\xea","ecir":"\u2256","ecolon":"\u2255","Ecy":"\u042D","ecy":"\u044D","eDDot":"\u2A77","Edot":"\u0116","edot":"\u0117","eDot":"\u2251","ee":"\u2147","efDot":"\u2252","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"\u2A9A","Egrave":"\xc8","egrave":"\xe8","egs":"\u2A96","egsdot":"\u2A98","el":"\u2A99","Element":"\u2208","elinters":"\u23E7","ell":"\u2113","els":"\u2A95","elsdot":"\u2A97","Emacr":"\u0112","emacr":"\u0113","empty":"\u2205","emptyset":"\u2205","EmptySmallSquare":"\u25FB","emptyv":"\u2205","EmptyVerySmallSquare":"\u25AB","emsp13":"\u2004","emsp14":"\u2005","emsp":"\u2003","ENG":"\u014A","eng":"\u014B","ensp":"\u2002","Eogon":"\u0118","eogon":"\u0119","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"\u22D5","eparsl":"\u29E3","eplus":"\u2A71","epsi":"\u03B5","Epsilon":"\u0395","epsilon":"\u03B5","epsiv":"\u03F5","eqcirc":"\u2256","eqcolon":"\u2255","eqsim":"\u2242","eqslantgtr":"\u2A96","eqslantless":"\u2A95","Equal":"\u2A75","equals":"=","EqualTilde":"\u2242","equest":"\u225F","Equilibrium":"\u21CC","equiv":"\u2261","equivDD":"\u2A78","eqvparsl":"\u29E5","erarr":"\u2971","erDot":"\u2253","escr":"\u212F","Escr":"\u2130","esdot":"\u2250","Esim":"\u2A73","esim":"\u2242","Eta":"\u0397","eta":"\u03B7","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","euro":"\u20AC","excl":"!","exist":"\u2203","Exists":"\u2203","expectation":"\u2130","exponentiale":"\u2147","ExponentialE":"\u2147","fallingdotseq":"\u2252","Fcy":"\u0424","fcy":"\u0444","female":"\u2640","ffilig":"\uFB03","fflig":"\uFB00","ffllig":"\uFB04","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"\uFB01","FilledSmallSquare":"\u25FC","FilledVerySmallSquare":"\u25AA","fjlig":"fj","flat":"\u266D","fllig":"\uFB02","fltns":"\u25B1","fnof":"\u0192","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"\u2200","ForAll":"\u2200","fork":"\u22D4","forkv":"\u2AD9","Fouriertrf":"\u2131","fpartint":"\u2A0D","frac12":"\xbd","frac13":"\u2153","frac14":"\xbc","frac15":"\u2155","frac16":"\u2159","frac18":"\u215B","frac23":"\u2154","frac25":"\u2156","frac34":"\xbe","frac35":"\u2157","frac38":"\u215C","frac45":"\u2158","frac56":"\u215A","frac58":"\u215D","frac78":"\u215E","frasl":"\u2044","frown":"\u2322","fscr":"\uD835\uDCBB","Fscr":"\u2131","gacute":"\u01F5","Gamma":"\u0393","gamma":"\u03B3","Gammad":"\u03DC","gammad":"\u03DD","gap":"\u2A86","Gbreve":"\u011E","gbreve":"\u011F","Gcedil":"\u0122","Gcirc":"\u011C","gcirc":"\u011D","Gcy":"\u0413","gcy":"\u0433","Gdot":"\u0120","gdot":"\u0121","ge":"\u2265","gE":"\u2267","gEl":"\u2A8C","gel":"\u22DB","geq":"\u2265","geqq":"\u2267","geqslant":"\u2A7E","gescc":"\u2AA9","ges":"\u2A7E","gesdot":"\u2A80","gesdoto":"\u2A82","gesdotol":"\u2A84","gesl":"\u22DB\uFE00","gesles":"\u2A94","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"\u226B","Gg":"\u22D9","ggg":"\u22D9","gimel":"\u2137","GJcy":"\u0403","gjcy":"\u0453","gla":"\u2AA5","gl":"\u2277","glE":"\u2A92","glj":"\u2AA4","gnap":"\u2A8A","gnapprox":"\u2A8A","gne":"\u2A88","gnE":"\u2269","gneq":"\u2A88","gneqq":"\u2269","gnsim":"\u22E7","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"\u2265","GreaterEqualLess":"\u22DB","GreaterFullEqual":"\u2267","GreaterGreater":"\u2AA2","GreaterLess":"\u2277","GreaterSlantEqual":"\u2A7E","GreaterTilde":"\u2273","Gscr":"\uD835\uDCA2","gscr":"\u210A","gsim":"\u2273","gsime":"\u2A8E","gsiml":"\u2A90","gtcc":"\u2AA7","gtcir":"\u2A7A","gt":">","GT":">","Gt":"\u226B","gtdot":"\u22D7","gtlPar":"\u2995","gtquest":"\u2A7C","gtrapprox":"\u2A86","gtrarr":"\u2978","gtrdot":"\u22D7","gtreqless":"\u22DB","gtreqqless":"\u2A8C","gtrless":"\u2277","gtrsim":"\u2273","gvertneqq":"\u2269\uFE00","gvnE":"\u2269\uFE00","Hacek":"\u02C7","hairsp":"\u200A","half":"\xbd","hamilt":"\u210B","HARDcy":"\u042A","hardcy":"\u044A","harrcir":"\u2948","harr":"\u2194","hArr":"\u21D4","harrw":"\u21AD","Hat":"^","hbar":"\u210F","Hcirc":"\u0124","hcirc":"\u0125","hearts":"\u2665","heartsuit":"\u2665","hellip":"\u2026","hercon":"\u22B9","hfr":"\uD835\uDD25","Hfr":"\u210C","HilbertSpace":"\u210B","hksearow":"\u2925","hkswarow":"\u2926","hoarr":"\u21FF","homtht":"\u223B","hookleftarrow":"\u21A9","hookrightarrow":"\u21AA","hopf":"\uD835\uDD59","Hopf":"\u210D","horbar":"\u2015","HorizontalLine":"\u2500","hscr":"\uD835\uDCBD","Hscr":"\u210B","hslash":"\u210F","Hstrok":"\u0126","hstrok":"\u0127","HumpDownHump":"\u224E","HumpEqual":"\u224F","hybull":"\u2043","hyphen":"\u2010","Iacute":"\xcd","iacute":"\xed","ic":"\u2063","Icirc":"\xce","icirc":"\xee","Icy":"\u0418","icy":"\u0438","Idot":"\u0130","IEcy":"\u0415","iecy":"\u0435","iexcl":"\xa1","iff":"\u21D4","ifr":"\uD835\uDD26","Ifr":"\u2111","Igrave":"\xcc","igrave":"\xec","ii":"\u2148","iiiint":"\u2A0C","iiint":"\u222D","iinfin":"\u29DC","iiota":"\u2129","IJlig":"\u0132","ijlig":"\u0133","Imacr":"\u012A","imacr":"\u012B","image":"\u2111","ImaginaryI":"\u2148","imagline":"\u2110","imagpart":"\u2111","imath":"\u0131","Im":"\u2111","imof":"\u22B7","imped":"\u01B5","Implies":"\u21D2","incare":"\u2105","in":"\u2208","infin":"\u221E","infintie":"\u29DD","inodot":"\u0131","intcal":"\u22BA","int":"\u222B","Int":"\u222C","integers":"\u2124","Integral":"\u222B","intercal":"\u22BA","Intersection":"\u22C2","intlarhk":"\u2A17","intprod":"\u2A3C","InvisibleComma":"\u2063","InvisibleTimes":"\u2062","IOcy":"\u0401","iocy":"\u0451","Iogon":"\u012E","iogon":"\u012F","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"\u0399","iota":"\u03B9","iprod":"\u2A3C","iquest":"\xbf","iscr":"\uD835\uDCBE","Iscr":"\u2110","isin":"\u2208","isindot":"\u22F5","isinE":"\u22F9","isins":"\u22F4","isinsv":"\u22F3","isinv":"\u2208","it":"\u2062","Itilde":"\u0128","itilde":"\u0129","Iukcy":"\u0406","iukcy":"\u0456","Iuml":"\xcf","iuml":"\xef","Jcirc":"\u0134","jcirc":"\u0135","Jcy":"\u0419","jcy":"\u0439","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"\u0237","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"\u0408","jsercy":"\u0458","Jukcy":"\u0404","jukcy":"\u0454","Kappa":"\u039A","kappa":"\u03BA","kappav":"\u03F0","Kcedil":"\u0136","kcedil":"\u0137","Kcy":"\u041A","kcy":"\u043A","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"\u0138","KHcy":"\u0425","khcy":"\u0445","KJcy":"\u040C","kjcy":"\u045C","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"\u21DA","Lacute":"\u0139","lacute":"\u013A","laemptyv":"\u29B4","lagran":"\u2112","Lambda":"\u039B","lambda":"\u03BB","lang":"\u27E8","Lang":"\u27EA","langd":"\u2991","langle":"\u27E8","lap":"\u2A85","Laplacetrf":"\u2112","laquo":"\xab","larrb":"\u21E4","larrbfs":"\u291F","larr":"\u2190","Larr":"\u219E","lArr":"\u21D0","larrfs":"\u291D","larrhk":"\u21A9","larrlp":"\u21AB","larrpl":"\u2939","larrsim":"\u2973","larrtl":"\u21A2","latail":"\u2919","lAtail":"\u291B","lat":"\u2AAB","late":"\u2AAD","lates":"\u2AAD\uFE00","lbarr":"\u290C","lBarr":"\u290E","lbbrk":"\u2772","lbrace":"{","lbrack":"[","lbrke":"\u298B","lbrksld":"\u298F","lbrkslu":"\u298D","Lcaron":"\u013D","lcaron":"\u013E","Lcedil":"\u013B","lcedil":"\u013C","lceil":"\u2308","lcub":"{","Lcy":"\u041B","lcy":"\u043B","ldca":"\u2936","ldquo":"\u201C","ldquor":"\u201E","ldrdhar":"\u2967","ldrushar":"\u294B","ldsh":"\u21B2","le":"\u2264","lE":"\u2266","LeftAngleBracket":"\u27E8","LeftArrowBar":"\u21E4","leftarrow":"\u2190","LeftArrow":"\u2190","Leftarrow":"\u21D0","LeftArrowRightArrow":"\u21C6","leftarrowtail":"\u21A2","LeftCeiling":"\u2308","LeftDoubleBracket":"\u27E6","LeftDownTeeVector":"\u2961","LeftDownVectorBar":"\u2959","LeftDownVector":"\u21C3","LeftFloor":"\u230A","leftharpoondown":"\u21BD","leftharpoonup":"\u21BC","leftleftarrows":"\u21C7","leftrightarrow":"\u2194","LeftRightArrow":"\u2194","Leftrightarrow":"\u21D4","leftrightarrows":"\u21C6","leftrightharpoons":"\u21CB","leftrightsquigarrow":"\u21AD","LeftRightVector":"\u294E","LeftTeeArrow":"\u21A4","LeftTee":"\u22A3","LeftTeeVector":"\u295A","leftthreetimes":"\u22CB","LeftTriangleBar":"\u29CF","LeftTriangle":"\u22B2","LeftTriangleEqual":"\u22B4","LeftUpDownVector":"\u2951","LeftUpTeeVector":"\u2960","LeftUpVectorBar":"\u2958","LeftUpVector":"\u21BF","LeftVectorBar":"\u2952","LeftVector":"\u21BC","lEg":"\u2A8B","leg":"\u22DA","leq":"\u2264","leqq":"\u2266","leqslant":"\u2A7D","lescc":"\u2AA8","les":"\u2A7D","lesdot":"\u2A7F","lesdoto":"\u2A81","lesdotor":"\u2A83","lesg":"\u22DA\uFE00","lesges":"\u2A93","lessapprox":"\u2A85","lessdot":"\u22D6","lesseqgtr":"\u22DA","lesseqqgtr":"\u2A8B","LessEqualGreater":"\u22DA","LessFullEqual":"\u2266","LessGreater":"\u2276","lessgtr":"\u2276","LessLess":"\u2AA1","lesssim":"\u2272","LessSlantEqual":"\u2A7D","LessTilde":"\u2272","lfisht":"\u297C","lfloor":"\u230A","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"\u2276","lgE":"\u2A91","lHar":"\u2962","lhard":"\u21BD","lharu":"\u21BC","lharul":"\u296A","lhblk":"\u2584","LJcy":"\u0409","ljcy":"\u0459","llarr":"\u21C7","ll":"\u226A","Ll":"\u22D8","llcorner":"\u231E","Lleftarrow":"\u21DA","llhard":"\u296B","lltri":"\u25FA","Lmidot":"\u013F","lmidot":"\u0140","lmoustache":"\u23B0","lmoust":"\u23B0","lnap":"\u2A89","lnapprox":"\u2A89","lne":"\u2A87","lnE":"\u2268","lneq":"\u2A87","lneqq":"\u2268","lnsim":"\u22E6","loang":"\u27EC","loarr":"\u21FD","lobrk":"\u27E6","longleftarrow":"\u27F5","LongLeftArrow":"\u27F5","Longleftarrow":"\u27F8","longleftrightarrow":"\u27F7","LongLeftRightArrow":"\u27F7","Longleftrightarrow":"\u27FA","longmapsto":"\u27FC","longrightarrow":"\u27F6","LongRightArrow":"\u27F6","Longrightarrow":"\u27F9","looparrowleft":"\u21AB","looparrowright":"\u21AC","lopar":"\u2985","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"\u2A2D","lotimes":"\u2A34","lowast":"\u2217","lowbar":"_","LowerLeftArrow":"\u2199","LowerRightArrow":"\u2198","loz":"\u25CA","lozenge":"\u25CA","lozf":"\u29EB","lpar":"(","lparlt":"\u2993","lrarr":"\u21C6","lrcorner":"\u231F","lrhar":"\u21CB","lrhard":"\u296D","lrm":"\u200E","lrtri":"\u22BF","lsaquo":"\u2039","lscr":"\uD835\uDCC1","Lscr":"\u2112","lsh":"\u21B0","Lsh":"\u21B0","lsim":"\u2272","lsime":"\u2A8D","lsimg":"\u2A8F","lsqb":"[","lsquo":"\u2018","lsquor":"\u201A","Lstrok":"\u0141","lstrok":"\u0142","ltcc":"\u2AA6","ltcir":"\u2A79","lt":"<","LT":"<","Lt":"\u226A","ltdot":"\u22D6","lthree":"\u22CB","ltimes":"\u22C9","ltlarr":"\u2976","ltquest":"\u2A7B","ltri":"\u25C3","ltrie":"\u22B4","ltrif":"\u25C2","ltrPar":"\u2996","lurdshar":"\u294A","luruhar":"\u2966","lvertneqq":"\u2268\uFE00","lvnE":"\u2268\uFE00","macr":"\xaf","male":"\u2642","malt":"\u2720","maltese":"\u2720","Map":"\u2905","map":"\u21A6","mapsto":"\u21A6","mapstodown":"\u21A7","mapstoleft":"\u21A4","mapstoup":"\u21A5","marker":"\u25AE","mcomma":"\u2A29","Mcy":"\u041C","mcy":"\u043C","mdash":"\u2014","mDDot":"\u223A","measuredangle":"\u2221","MediumSpace":"\u205F","Mellintrf":"\u2133","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"\u2127","micro":"\xb5","midast":"*","midcir":"\u2AF0","mid":"\u2223","middot":"\xb7","minusb":"\u229F","minus":"\u2212","minusd":"\u2238","minusdu":"\u2A2A","MinusPlus":"\u2213","mlcp":"\u2ADB","mldr":"\u2026","mnplus":"\u2213","models":"\u22A7","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"\u2213","mscr":"\uD835\uDCC2","Mscr":"\u2133","mstpos":"\u223E","Mu":"\u039C","mu":"\u03BC","multimap":"\u22B8","mumap":"\u22B8","nabla":"\u2207","Nacute":"\u0143","nacute":"\u0144","nang":"\u2220\u20D2","nap":"\u2249","napE":"\u2A70\u0338","napid":"\u224B\u0338","napos":"\u0149","napprox":"\u2249","natural":"\u266E","naturals":"\u2115","natur":"\u266E","nbsp":"\xa0","nbump":"\u224E\u0338","nbumpe":"\u224F\u0338","ncap":"\u2A43","Ncaron":"\u0147","ncaron":"\u0148","Ncedil":"\u0145","ncedil":"\u0146","ncong":"\u2247","ncongdot":"\u2A6D\u0338","ncup":"\u2A42","Ncy":"\u041D","ncy":"\u043D","ndash":"\u2013","nearhk":"\u2924","nearr":"\u2197","neArr":"\u21D7","nearrow":"\u2197","ne":"\u2260","nedot":"\u2250\u0338","NegativeMediumSpace":"\u200B","NegativeThickSpace":"\u200B","NegativeThinSpace":"\u200B","NegativeVeryThinSpace":"\u200B","nequiv":"\u2262","nesear":"\u2928","nesim":"\u2242\u0338","NestedGreaterGreater":"\u226B","NestedLessLess":"\u226A","NewLine":"\\n","nexist":"\u2204","nexists":"\u2204","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"\u2267\u0338","nge":"\u2271","ngeq":"\u2271","ngeqq":"\u2267\u0338","ngeqslant":"\u2A7E\u0338","nges":"\u2A7E\u0338","nGg":"\u22D9\u0338","ngsim":"\u2275","nGt":"\u226B\u20D2","ngt":"\u226F","ngtr":"\u226F","nGtv":"\u226B\u0338","nharr":"\u21AE","nhArr":"\u21CE","nhpar":"\u2AF2","ni":"\u220B","nis":"\u22FC","nisd":"\u22FA","niv":"\u220B","NJcy":"\u040A","njcy":"\u045A","nlarr":"\u219A","nlArr":"\u21CD","nldr":"\u2025","nlE":"\u2266\u0338","nle":"\u2270","nleftarrow":"\u219A","nLeftarrow":"\u21CD","nleftrightarrow":"\u21AE","nLeftrightarrow":"\u21CE","nleq":"\u2270","nleqq":"\u2266\u0338","nleqslant":"\u2A7D\u0338","nles":"\u2A7D\u0338","nless":"\u226E","nLl":"\u22D8\u0338","nlsim":"\u2274","nLt":"\u226A\u20D2","nlt":"\u226E","nltri":"\u22EA","nltrie":"\u22EC","nLtv":"\u226A\u0338","nmid":"\u2224","NoBreak":"\u2060","NonBreakingSpace":"\xa0","nopf":"\uD835\uDD5F","Nopf":"\u2115","Not":"\u2AEC","not":"\xac","NotCongruent":"\u2262","NotCupCap":"\u226D","NotDoubleVerticalBar":"\u2226","NotElement":"\u2209","NotEqual":"\u2260","NotEqualTilde":"\u2242\u0338","NotExists":"\u2204","NotGreater":"\u226F","NotGreaterEqual":"\u2271","NotGreaterFullEqual":"\u2267\u0338","NotGreaterGreater":"\u226B\u0338","NotGreaterLess":"\u2279","NotGreaterSlantEqual":"\u2A7E\u0338","NotGreaterTilde":"\u2275","NotHumpDownHump":"\u224E\u0338","NotHumpEqual":"\u224F\u0338","notin":"\u2209","notindot":"\u22F5\u0338","notinE":"\u22F9\u0338","notinva":"\u2209","notinvb":"\u22F7","notinvc":"\u22F6","NotLeftTriangleBar":"\u29CF\u0338","NotLeftTriangle":"\u22EA","NotLeftTriangleEqual":"\u22EC","NotLess":"\u226E","NotLessEqual":"\u2270","NotLessGreater":"\u2278","NotLessLess":"\u226A\u0338","NotLessSlantEqual":"\u2A7D\u0338","NotLessTilde":"\u2274","NotNestedGreaterGreater":"\u2AA2\u0338","NotNestedLessLess":"\u2AA1\u0338","notni":"\u220C","notniva":"\u220C","notnivb":"\u22FE","notnivc":"\u22FD","NotPrecedes":"\u2280","NotPrecedesEqual":"\u2AAF\u0338","NotPrecedesSlantEqual":"\u22E0","NotReverseElement":"\u220C","NotRightTriangleBar":"\u29D0\u0338","NotRightTriangle":"\u22EB","NotRightTriangleEqual":"\u22ED","NotSquareSubset":"\u228F\u0338","NotSquareSubsetEqual":"\u22E2","NotSquareSuperset":"\u2290\u0338","NotSquareSupersetEqual":"\u22E3","NotSubset":"\u2282\u20D2","NotSubsetEqual":"\u2288","NotSucceeds":"\u2281","NotSucceedsEqual":"\u2AB0\u0338","NotSucceedsSlantEqual":"\u22E1","NotSucceedsTilde":"\u227F\u0338","NotSuperset":"\u2283\u20D2","NotSupersetEqual":"\u2289","NotTilde":"\u2241","NotTildeEqual":"\u2244","NotTildeFullEqual":"\u2247","NotTildeTilde":"\u2249","NotVerticalBar":"\u2224","nparallel":"\u2226","npar":"\u2226","nparsl":"\u2AFD\u20E5","npart":"\u2202\u0338","npolint":"\u2A14","npr":"\u2280","nprcue":"\u22E0","nprec":"\u2280","npreceq":"\u2AAF\u0338","npre":"\u2AAF\u0338","nrarrc":"\u2933\u0338","nrarr":"\u219B","nrArr":"\u21CF","nrarrw":"\u219D\u0338","nrightarrow":"\u219B","nRightarrow":"\u21CF","nrtri":"\u22EB","nrtrie":"\u22ED","nsc":"\u2281","nsccue":"\u22E1","nsce":"\u2AB0\u0338","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"\u2224","nshortparallel":"\u2226","nsim":"\u2241","nsime":"\u2244","nsimeq":"\u2244","nsmid":"\u2224","nspar":"\u2226","nsqsube":"\u22E2","nsqsupe":"\u22E3","nsub":"\u2284","nsubE":"\u2AC5\u0338","nsube":"\u2288","nsubset":"\u2282\u20D2","nsubseteq":"\u2288","nsubseteqq":"\u2AC5\u0338","nsucc":"\u2281","nsucceq":"\u2AB0\u0338","nsup":"\u2285","nsupE":"\u2AC6\u0338","nsupe":"\u2289","nsupset":"\u2283\u20D2","nsupseteq":"\u2289","nsupseteqq":"\u2AC6\u0338","ntgl":"\u2279","Ntilde":"\xd1","ntilde":"\xf1","ntlg":"\u2278","ntriangleleft":"\u22EA","ntrianglelefteq":"\u22EC","ntriangleright":"\u22EB","ntrianglerighteq":"\u22ED","Nu":"\u039D","nu":"\u03BD","num":"#","numero":"\u2116","numsp":"\u2007","nvap":"\u224D\u20D2","nvdash":"\u22AC","nvDash":"\u22AD","nVdash":"\u22AE","nVDash":"\u22AF","nvge":"\u2265\u20D2","nvgt":">\u20D2","nvHarr":"\u2904","nvinfin":"\u29DE","nvlArr":"\u2902","nvle":"\u2264\u20D2","nvlt":"<\u20D2","nvltrie":"\u22B4\u20D2","nvrArr":"\u2903","nvrtrie":"\u22B5\u20D2","nvsim":"\u223C\u20D2","nwarhk":"\u2923","nwarr":"\u2196","nwArr":"\u21D6","nwarrow":"\u2196","nwnear":"\u2927","Oacute":"\xd3","oacute":"\xf3","oast":"\u229B","Ocirc":"\xd4","ocirc":"\xf4","ocir":"\u229A","Ocy":"\u041E","ocy":"\u043E","odash":"\u229D","Odblac":"\u0150","odblac":"\u0151","odiv":"\u2A38","odot":"\u2299","odsold":"\u29BC","OElig":"\u0152","oelig":"\u0153","ofcir":"\u29BF","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"\u02DB","Ograve":"\xd2","ograve":"\xf2","ogt":"\u29C1","ohbar":"\u29B5","ohm":"\u03A9","oint":"\u222E","olarr":"\u21BA","olcir":"\u29BE","olcross":"\u29BB","oline":"\u203E","olt":"\u29C0","Omacr":"\u014C","omacr":"\u014D","Omega":"\u03A9","omega":"\u03C9","Omicron":"\u039F","omicron":"\u03BF","omid":"\u29B6","ominus":"\u2296","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"\u29B7","OpenCurlyDoubleQuote":"\u201C","OpenCurlyQuote":"\u2018","operp":"\u29B9","oplus":"\u2295","orarr":"\u21BB","Or":"\u2A54","or":"\u2228","ord":"\u2A5D","order":"\u2134","orderof":"\u2134","ordf":"\xaa","ordm":"\xba","origof":"\u22B6","oror":"\u2A56","orslope":"\u2A57","orv":"\u2A5B","oS":"\u24C8","Oscr":"\uD835\uDCAA","oscr":"\u2134","Oslash":"\xd8","oslash":"\xf8","osol":"\u2298","Otilde":"\xd5","otilde":"\xf5","otimesas":"\u2A36","Otimes":"\u2A37","otimes":"\u2297","Ouml":"\xd6","ouml":"\xf6","ovbar":"\u233D","OverBar":"\u203E","OverBrace":"\u23DE","OverBracket":"\u23B4","OverParenthesis":"\u23DC","para":"\xb6","parallel":"\u2225","par":"\u2225","parsim":"\u2AF3","parsl":"\u2AFD","part":"\u2202","PartialD":"\u2202","Pcy":"\u041F","pcy":"\u043F","percnt":"%","period":".","permil":"\u2030","perp":"\u22A5","pertenk":"\u2031","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"\u03A6","phi":"\u03C6","phiv":"\u03D5","phmmat":"\u2133","phone":"\u260E","Pi":"\u03A0","pi":"\u03C0","pitchfork":"\u22D4","piv":"\u03D6","planck":"\u210F","planckh":"\u210E","plankv":"\u210F","plusacir":"\u2A23","plusb":"\u229E","pluscir":"\u2A22","plus":"+","plusdo":"\u2214","plusdu":"\u2A25","pluse":"\u2A72","PlusMinus":"\xb1","plusmn":"\xb1","plussim":"\u2A26","plustwo":"\u2A27","pm":"\xb1","Poincareplane":"\u210C","pointint":"\u2A15","popf":"\uD835\uDD61","Popf":"\u2119","pound":"\xa3","prap":"\u2AB7","Pr":"\u2ABB","pr":"\u227A","prcue":"\u227C","precapprox":"\u2AB7","prec":"\u227A","preccurlyeq":"\u227C","Precedes":"\u227A","PrecedesEqual":"\u2AAF","PrecedesSlantEqual":"\u227C","PrecedesTilde":"\u227E","preceq":"\u2AAF","precnapprox":"\u2AB9","precneqq":"\u2AB5","precnsim":"\u22E8","pre":"\u2AAF","prE":"\u2AB3","precsim":"\u227E","prime":"\u2032","Prime":"\u2033","primes":"\u2119","prnap":"\u2AB9","prnE":"\u2AB5","prnsim":"\u22E8","prod":"\u220F","Product":"\u220F","profalar":"\u232E","profline":"\u2312","profsurf":"\u2313","prop":"\u221D","Proportional":"\u221D","Proportion":"\u2237","propto":"\u221D","prsim":"\u227E","prurel":"\u22B0","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"\u03A8","psi":"\u03C8","puncsp":"\u2008","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"\u2A0C","qopf":"\uD835\uDD62","Qopf":"\u211A","qprime":"\u2057","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"\u210D","quatint":"\u2A16","quest":"?","questeq":"\u225F","quot":"\\"","QUOT":"\\"","rAarr":"\u21DB","race":"\u223D\u0331","Racute":"\u0154","racute":"\u0155","radic":"\u221A","raemptyv":"\u29B3","rang":"\u27E9","Rang":"\u27EB","rangd":"\u2992","range":"\u29A5","rangle":"\u27E9","raquo":"\xbb","rarrap":"\u2975","rarrb":"\u21E5","rarrbfs":"\u2920","rarrc":"\u2933","rarr":"\u2192","Rarr":"\u21A0","rArr":"\u21D2","rarrfs":"\u291E","rarrhk":"\u21AA","rarrlp":"\u21AC","rarrpl":"\u2945","rarrsim":"\u2974","Rarrtl":"\u2916","rarrtl":"\u21A3","rarrw":"\u219D","ratail":"\u291A","rAtail":"\u291C","ratio":"\u2236","rationals":"\u211A","rbarr":"\u290D","rBarr":"\u290F","RBarr":"\u2910","rbbrk":"\u2773","rbrace":"}","rbrack":"]","rbrke":"\u298C","rbrksld":"\u298E","rbrkslu":"\u2990","Rcaron":"\u0158","rcaron":"\u0159","Rcedil":"\u0156","rcedil":"\u0157","rceil":"\u2309","rcub":"}","Rcy":"\u0420","rcy":"\u0440","rdca":"\u2937","rdldhar":"\u2969","rdquo":"\u201D","rdquor":"\u201D","rdsh":"\u21B3","real":"\u211C","realine":"\u211B","realpart":"\u211C","reals":"\u211D","Re":"\u211C","rect":"\u25AD","reg":"\xae","REG":"\xae","ReverseElement":"\u220B","ReverseEquilibrium":"\u21CB","ReverseUpEquilibrium":"\u296F","rfisht":"\u297D","rfloor":"\u230B","rfr":"\uD835\uDD2F","Rfr":"\u211C","rHar":"\u2964","rhard":"\u21C1","rharu":"\u21C0","rharul":"\u296C","Rho":"\u03A1","rho":"\u03C1","rhov":"\u03F1","RightAngleBracket":"\u27E9","RightArrowBar":"\u21E5","rightarrow":"\u2192","RightArrow":"\u2192","Rightarrow":"\u21D2","RightArrowLeftArrow":"\u21C4","rightarrowtail":"\u21A3","RightCeiling":"\u2309","RightDoubleBracket":"\u27E7","RightDownTeeVector":"\u295D","RightDownVectorBar":"\u2955","RightDownVector":"\u21C2","RightFloor":"\u230B","rightharpoondown":"\u21C1","rightharpoonup":"\u21C0","rightleftarrows":"\u21C4","rightleftharpoons":"\u21CC","rightrightarrows":"\u21C9","rightsquigarrow":"\u219D","RightTeeArrow":"\u21A6","RightTee":"\u22A2","RightTeeVector":"\u295B","rightthreetimes":"\u22CC","RightTriangleBar":"\u29D0","RightTriangle":"\u22B3","RightTriangleEqual":"\u22B5","RightUpDownVector":"\u294F","RightUpTeeVector":"\u295C","RightUpVectorBar":"\u2954","RightUpVector":"\u21BE","RightVectorBar":"\u2953","RightVector":"\u21C0","ring":"\u02DA","risingdotseq":"\u2253","rlarr":"\u21C4","rlhar":"\u21CC","rlm":"\u200F","rmoustache":"\u23B1","rmoust":"\u23B1","rnmid":"\u2AEE","roang":"\u27ED","roarr":"\u21FE","robrk":"\u27E7","ropar":"\u2986","ropf":"\uD835\uDD63","Ropf":"\u211D","roplus":"\u2A2E","rotimes":"\u2A35","RoundImplies":"\u2970","rpar":")","rpargt":"\u2994","rppolint":"\u2A12","rrarr":"\u21C9","Rrightarrow":"\u21DB","rsaquo":"\u203A","rscr":"\uD835\uDCC7","Rscr":"\u211B","rsh":"\u21B1","Rsh":"\u21B1","rsqb":"]","rsquo":"\u2019","rsquor":"\u2019","rthree":"\u22CC","rtimes":"\u22CA","rtri":"\u25B9","rtrie":"\u22B5","rtrif":"\u25B8","rtriltri":"\u29CE","RuleDelayed":"\u29F4","ruluhar":"\u2968","rx":"\u211E","Sacute":"\u015A","sacute":"\u015B","sbquo":"\u201A","scap":"\u2AB8","Scaron":"\u0160","scaron":"\u0161","Sc":"\u2ABC","sc":"\u227B","sccue":"\u227D","sce":"\u2AB0","scE":"\u2AB4","Scedil":"\u015E","scedil":"\u015F","Scirc":"\u015C","scirc":"\u015D","scnap":"\u2ABA","scnE":"\u2AB6","scnsim":"\u22E9","scpolint":"\u2A13","scsim":"\u227F","Scy":"\u0421","scy":"\u0441","sdotb":"\u22A1","sdot":"\u22C5","sdote":"\u2A66","searhk":"\u2925","searr":"\u2198","seArr":"\u21D8","searrow":"\u2198","sect":"\xa7","semi":";","seswar":"\u2929","setminus":"\u2216","setmn":"\u2216","sext":"\u2736","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"\u2322","sharp":"\u266F","SHCHcy":"\u0429","shchcy":"\u0449","SHcy":"\u0428","shcy":"\u0448","ShortDownArrow":"\u2193","ShortLeftArrow":"\u2190","shortmid":"\u2223","shortparallel":"\u2225","ShortRightArrow":"\u2192","ShortUpArrow":"\u2191","shy":"\xad","Sigma":"\u03A3","sigma":"\u03C3","sigmaf":"\u03C2","sigmav":"\u03C2","sim":"\u223C","simdot":"\u2A6A","sime":"\u2243","simeq":"\u2243","simg":"\u2A9E","simgE":"\u2AA0","siml":"\u2A9D","simlE":"\u2A9F","simne":"\u2246","simplus":"\u2A24","simrarr":"\u2972","slarr":"\u2190","SmallCircle":"\u2218","smallsetminus":"\u2216","smashp":"\u2A33","smeparsl":"\u29E4","smid":"\u2223","smile":"\u2323","smt":"\u2AAA","smte":"\u2AAC","smtes":"\u2AAC\uFE00","SOFTcy":"\u042C","softcy":"\u044C","solbar":"\u233F","solb":"\u29C4","sol":"/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"\u2660","spadesuit":"\u2660","spar":"\u2225","sqcap":"\u2293","sqcaps":"\u2293\uFE00","sqcup":"\u2294","sqcups":"\u2294\uFE00","Sqrt":"\u221A","sqsub":"\u228F","sqsube":"\u2291","sqsubset":"\u228F","sqsubseteq":"\u2291","sqsup":"\u2290","sqsupe":"\u2292","sqsupset":"\u2290","sqsupseteq":"\u2292","square":"\u25A1","Square":"\u25A1","SquareIntersection":"\u2293","SquareSubset":"\u228F","SquareSubsetEqual":"\u2291","SquareSuperset":"\u2290","SquareSupersetEqual":"\u2292","SquareUnion":"\u2294","squarf":"\u25AA","squ":"\u25A1","squf":"\u25AA","srarr":"\u2192","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"\u2216","ssmile":"\u2323","sstarf":"\u22C6","Star":"\u22C6","star":"\u2606","starf":"\u2605","straightepsilon":"\u03F5","straightphi":"\u03D5","strns":"\xaf","sub":"\u2282","Sub":"\u22D0","subdot":"\u2ABD","subE":"\u2AC5","sube":"\u2286","subedot":"\u2AC3","submult":"\u2AC1","subnE":"\u2ACB","subne":"\u228A","subplus":"\u2ABF","subrarr":"\u2979","subset":"\u2282","Subset":"\u22D0","subseteq":"\u2286","subseteqq":"\u2AC5","SubsetEqual":"\u2286","subsetneq":"\u228A","subsetneqq":"\u2ACB","subsim":"\u2AC7","subsub":"\u2AD5","subsup":"\u2AD3","succapprox":"\u2AB8","succ":"\u227B","succcurlyeq":"\u227D","Succeeds":"\u227B","SucceedsEqual":"\u2AB0","SucceedsSlantEqual":"\u227D","SucceedsTilde":"\u227F","succeq":"\u2AB0","succnapprox":"\u2ABA","succneqq":"\u2AB6","succnsim":"\u22E9","succsim":"\u227F","SuchThat":"\u220B","sum":"\u2211","Sum":"\u2211","sung":"\u266A","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","sup":"\u2283","Sup":"\u22D1","supdot":"\u2ABE","supdsub":"\u2AD8","supE":"\u2AC6","supe":"\u2287","supedot":"\u2AC4","Superset":"\u2283","SupersetEqual":"\u2287","suphsol":"\u27C9","suphsub":"\u2AD7","suplarr":"\u297B","supmult":"\u2AC2","supnE":"\u2ACC","supne":"\u228B","supplus":"\u2AC0","supset":"\u2283","Supset":"\u22D1","supseteq":"\u2287","supseteqq":"\u2AC6","supsetneq":"\u228B","supsetneqq":"\u2ACC","supsim":"\u2AC8","supsub":"\u2AD4","supsup":"\u2AD6","swarhk":"\u2926","swarr":"\u2199","swArr":"\u21D9","swarrow":"\u2199","swnwar":"\u292A","szlig":"\xdf","Tab":"\\t","target":"\u2316","Tau":"\u03A4","tau":"\u03C4","tbrk":"\u23B4","Tcaron":"\u0164","tcaron":"\u0165","Tcedil":"\u0162","tcedil":"\u0163","Tcy":"\u0422","tcy":"\u0442","tdot":"\u20DB","telrec":"\u2315","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"\u2234","therefore":"\u2234","Therefore":"\u2234","Theta":"\u0398","theta":"\u03B8","thetasym":"\u03D1","thetav":"\u03D1","thickapprox":"\u2248","thicksim":"\u223C","ThickSpace":"\u205F\u200A","ThinSpace":"\u2009","thinsp":"\u2009","thkap":"\u2248","thksim":"\u223C","THORN":"\xde","thorn":"\xfe","tilde":"\u02DC","Tilde":"\u223C","TildeEqual":"\u2243","TildeFullEqual":"\u2245","TildeTilde":"\u2248","timesbar":"\u2A31","timesb":"\u22A0","times":"\xd7","timesd":"\u2A30","tint":"\u222D","toea":"\u2928","topbot":"\u2336","topcir":"\u2AF1","top":"\u22A4","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"\u2ADA","tosa":"\u2929","tprime":"\u2034","trade":"\u2122","TRADE":"\u2122","triangle":"\u25B5","triangledown":"\u25BF","triangleleft":"\u25C3","trianglelefteq":"\u22B4","triangleq":"\u225C","triangleright":"\u25B9","trianglerighteq":"\u22B5","tridot":"\u25EC","trie":"\u225C","triminus":"\u2A3A","TripleDot":"\u20DB","triplus":"\u2A39","trisb":"\u29CD","tritime":"\u2A3B","trpezium":"\u23E2","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"\u0426","tscy":"\u0446","TSHcy":"\u040B","tshcy":"\u045B","Tstrok":"\u0166","tstrok":"\u0167","twixt":"\u226C","twoheadleftarrow":"\u219E","twoheadrightarrow":"\u21A0","Uacute":"\xda","uacute":"\xfa","uarr":"\u2191","Uarr":"\u219F","uArr":"\u21D1","Uarrocir":"\u2949","Ubrcy":"\u040E","ubrcy":"\u045E","Ubreve":"\u016C","ubreve":"\u016D","Ucirc":"\xdb","ucirc":"\xfb","Ucy":"\u0423","ucy":"\u0443","udarr":"\u21C5","Udblac":"\u0170","udblac":"\u0171","udhar":"\u296E","ufisht":"\u297E","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\xd9","ugrave":"\xf9","uHar":"\u2963","uharl":"\u21BF","uharr":"\u21BE","uhblk":"\u2580","ulcorn":"\u231C","ulcorner":"\u231C","ulcrop":"\u230F","ultri":"\u25F8","Umacr":"\u016A","umacr":"\u016B","uml":"\xa8","UnderBar":"_","UnderBrace":"\u23DF","UnderBracket":"\u23B5","UnderParenthesis":"\u23DD","Union":"\u22C3","UnionPlus":"\u228E","Uogon":"\u0172","uogon":"\u0173","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"\u2912","uparrow":"\u2191","UpArrow":"\u2191","Uparrow":"\u21D1","UpArrowDownArrow":"\u21C5","updownarrow":"\u2195","UpDownArrow":"\u2195","Updownarrow":"\u21D5","UpEquilibrium":"\u296E","upharpoonleft":"\u21BF","upharpoonright":"\u21BE","uplus":"\u228E","UpperLeftArrow":"\u2196","UpperRightArrow":"\u2197","upsi":"\u03C5","Upsi":"\u03D2","upsih":"\u03D2","Upsilon":"\u03A5","upsilon":"\u03C5","UpTeeArrow":"\u21A5","UpTee":"\u22A5","upuparrows":"\u21C8","urcorn":"\u231D","urcorner":"\u231D","urcrop":"\u230E","Uring":"\u016E","uring":"\u016F","urtri":"\u25F9","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"\u22F0","Utilde":"\u0168","utilde":"\u0169","utri":"\u25B5","utrif":"\u25B4","uuarr":"\u21C8","Uuml":"\xdc","uuml":"\xfc","uwangle":"\u29A7","vangrt":"\u299C","varepsilon":"\u03F5","varkappa":"\u03F0","varnothing":"\u2205","varphi":"\u03D5","varpi":"\u03D6","varpropto":"\u221D","varr":"\u2195","vArr":"\u21D5","varrho":"\u03F1","varsigma":"\u03C2","varsubsetneq":"\u228A\uFE00","varsubsetneqq":"\u2ACB\uFE00","varsupsetneq":"\u228B\uFE00","varsupsetneqq":"\u2ACC\uFE00","vartheta":"\u03D1","vartriangleleft":"\u22B2","vartriangleright":"\u22B3","vBar":"\u2AE8","Vbar":"\u2AEB","vBarv":"\u2AE9","Vcy":"\u0412","vcy":"\u0432","vdash":"\u22A2","vDash":"\u22A8","Vdash":"\u22A9","VDash":"\u22AB","Vdashl":"\u2AE6","veebar":"\u22BB","vee":"\u2228","Vee":"\u22C1","veeeq":"\u225A","vellip":"\u22EE","verbar":"|","Verbar":"\u2016","vert":"|","Vert":"\u2016","VerticalBar":"\u2223","VerticalLine":"|","VerticalSeparator":"\u2758","VerticalTilde":"\u2240","VeryThinSpace":"\u200A","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"\u22B2","vnsub":"\u2282\u20D2","vnsup":"\u2283\u20D2","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"\u221D","vrtri":"\u22B3","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"\u2ACB\uFE00","vsubne":"\u228A\uFE00","vsupnE":"\u2ACC\uFE00","vsupne":"\u228B\uFE00","Vvdash":"\u22AA","vzigzag":"\u299A","Wcirc":"\u0174","wcirc":"\u0175","wedbar":"\u2A5F","wedge":"\u2227","Wedge":"\u22C0","wedgeq":"\u2259","weierp":"\u2118","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"\u2118","wr":"\u2240","wreath":"\u2240","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"\u22C2","xcirc":"\u25EF","xcup":"\u22C3","xdtri":"\u25BD","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"\u27F7","xhArr":"\u27FA","Xi":"\u039E","xi":"\u03BE","xlarr":"\u27F5","xlArr":"\u27F8","xmap":"\u27FC","xnis":"\u22FB","xodot":"\u2A00","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"\u2A01","xotime":"\u2A02","xrarr":"\u27F6","xrArr":"\u27F9","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"\u2A06","xuplus":"\u2A04","xutri":"\u25B3","xvee":"\u22C1","xwedge":"\u22C0","Yacute":"\xdd","yacute":"\xfd","YAcy":"\u042F","yacy":"\u044F","Ycirc":"\u0176","ycirc":"\u0177","Ycy":"\u042B","ycy":"\u044B","yen":"\xa5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"\u0407","yicy":"\u0457","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"\u042E","yucy":"\u044E","yuml":"\xff","Yuml":"\u0178","Zacute":"\u0179","zacute":"\u017A","Zcaron":"\u017D","zcaron":"\u017E","Zcy":"\u0417","zcy":"\u0437","Zdot":"\u017B","zdot":"\u017C","zeetrf":"\u2128","ZeroWidthSpace":"\u200B","Zeta":"\u0396","zeta":"\u03B6","zfr":"\uD835\uDD37","Zfr":"\u2128","ZHcy":"\u0416","zhcy":"\u0436","zigrarr":"\u21DD","zopf":"\uD835\uDD6B","Zopf":"\u2124","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"\u200D","zwnj":"\u200C"}');

});


parcelRegister("fpTlz", function(module, exports) {
$parcel$export(module.exports, "encode", function () { return $b3941f8ca64c8581$export$c564cdbbe6da493; }, function (v) { return $b3941f8ca64c8581$export$c564cdbbe6da493 = v; });
$parcel$export(module.exports, "decode", function () { return $b3941f8ca64c8581$export$2f872c0f2117be69; }, function (v) { return $b3941f8ca64c8581$export$2f872c0f2117be69 = v; });
$parcel$export(module.exports, "format", function () { return $b3941f8ca64c8581$export$d9468344d3651243; }, function (v) { return $b3941f8ca64c8581$export$d9468344d3651243 = v; });
$parcel$export(module.exports, "parse", function () { return $b3941f8ca64c8581$export$98e6a39c04603d36; }, function (v) { return $b3941f8ca64c8581$export$98e6a39c04603d36 = v; });
var $b3941f8ca64c8581$export$c564cdbbe6da493;
var $b3941f8ca64c8581$export$2f872c0f2117be69;
var $b3941f8ca64c8581$export$d9468344d3651243;
var $b3941f8ca64c8581$export$98e6a39c04603d36;
'use strict';

$b3941f8ca64c8581$export$c564cdbbe6da493 = (parcelRequire("c0kXm"));

$b3941f8ca64c8581$export$2f872c0f2117be69 = (parcelRequire("jmBH6"));

$b3941f8ca64c8581$export$d9468344d3651243 = (parcelRequire("b3Sxu"));

$b3941f8ca64c8581$export$98e6a39c04603d36 = (parcelRequire("7o7Ks"));

});
parcelRegister("c0kXm", function(module, exports) {
'use strict';
var $8bd5bda493efd16a$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $8bd5bda493efd16a$var$getEncodeCache(exclude) {
    var i, ch, cache = $8bd5bda493efd16a$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $8bd5bda493efd16a$var$encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $8bd5bda493efd16a$var$encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = '';
    if (typeof exclude !== 'string') {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $8bd5bda493efd16a$var$encode.defaultChars;
    }
    if (typeof keepEscaped === 'undefined') keepEscaped = true;
    cache = $8bd5bda493efd16a$var$getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += '%EF%BF%BD';
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$8bd5bda493efd16a$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$8bd5bda493efd16a$var$encode.componentChars = "-_.!~*'()";
module.exports = $8bd5bda493efd16a$var$encode;

});

parcelRegister("jmBH6", function(module, exports) {
'use strict';
/* eslint-disable no-bitwise */ var $e18d4fb19942fb6b$var$decodeCache = {};
function $e18d4fb19942fb6b$var$getDecodeCache(exclude) {
    var i, ch, cache = $e18d4fb19942fb6b$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $e18d4fb19942fb6b$var$decodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(i = 0; i < exclude.length; i++){
        ch = exclude.charCodeAt(i);
        cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $e18d4fb19942fb6b$var$decode(string, exclude) {
    var cache;
    if (typeof exclude !== 'string') exclude = $e18d4fb19942fb6b$var$decode.defaultChars;
    cache = $e18d4fb19942fb6b$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        var i, l, b1, b2, b3, b4, chr, result = '';
        for(i = 0, l = seq.length; i < l; i += 3){
            b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += '\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += '\ufffd\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += '\ufffd\ufffd\ufffd\ufffd';
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += '\ufffd';
        }
        return result;
    });
}
$e18d4fb19942fb6b$var$decode.defaultChars = ';/?:@&=+$,#';
$e18d4fb19942fb6b$var$decode.componentChars = '';
module.exports = $e18d4fb19942fb6b$var$decode;

});

parcelRegister("b3Sxu", function(module, exports) {
'use strict';
module.exports = function format(url) {
    var result = '';
    result += url.protocol || '';
    result += url.slashes ? '//' : '';
    result += url.auth ? url.auth + '@' : '';
    if (url.hostname && url.hostname.indexOf(':') !== -1) // ipv6 address
    result += '[' + url.hostname + ']';
    else result += url.hostname || '';
    result += url.port ? ':' + url.port : '';
    result += url.pathname || '';
    result += url.search || '';
    result += url.hash || '';
    return result;
};

});

parcelRegister("7o7Ks", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $5610c8f16a54b366$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var $5610c8f16a54b366$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $5610c8f16a54b366$var$portPattern = /:[0-9]*$/, // Special case for a simple path URL
$5610c8f16a54b366$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
$5610c8f16a54b366$var$delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
$5610c8f16a54b366$var$unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat($5610c8f16a54b366$var$delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
$5610c8f16a54b366$var$autoEscape = [
    '\''
].concat($5610c8f16a54b366$var$unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
$5610c8f16a54b366$var$nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat($5610c8f16a54b366$var$autoEscape), $5610c8f16a54b366$var$hostEndingChars = [
    '/',
    '?',
    '#'
], $5610c8f16a54b366$var$hostnameMaxLen = 255, $5610c8f16a54b366$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, $5610c8f16a54b366$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
/* eslint-disable no-script-url */ // protocols that never have a hostname.
$5610c8f16a54b366$var$hostlessProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that always contain a // bit.
$5610c8f16a54b366$var$slashedProtocol = {
    'http': true,
    'https': true,
    'ftp': true,
    'gopher': true,
    'file': true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};
/* eslint-enable no-script-url */ function $5610c8f16a54b366$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $5610c8f16a54b366$var$Url) return url;
    var u = new $5610c8f16a54b366$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$5610c8f16a54b366$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    var i, l, lowerProto, hec, slashes, rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = $5610c8f16a54b366$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    var proto = $5610c8f16a54b366$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && $5610c8f16a54b366$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$5610c8f16a54b366$var$hostlessProtocol[proto] && (slashes || proto && !$5610c8f16a54b366$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(i = 0; i < $5610c8f16a54b366$var$hostEndingChars.length; i++){
            hec = rest.indexOf($5610c8f16a54b366$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(i = 0; i < $5610c8f16a54b366$var$nonHostChars.length; i++){
            hec = rest.indexOf($5610c8f16a54b366$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ':') hostEnd--;
        var host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match($5610c8f16a54b366$var$hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($5610c8f16a54b366$var$hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match($5610c8f16a54b366$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $5610c8f16a54b366$var$hostnameMaxLen) this.hostname = '';
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($5610c8f16a54b366$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '';
    return this;
};
$5610c8f16a54b366$var$Url.prototype.parseHost = function(host) {
    var port = $5610c8f16a54b366$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
module.exports = $5610c8f16a54b366$var$urlParse;

});


parcelRegister("9CsYT", function(module, exports) {
$parcel$export(module.exports, "Any", function () { return $700e24b8b8f9b2b9$export$b24b633b1364b94b; }, function (v) { return $700e24b8b8f9b2b9$export$b24b633b1364b94b = v; });
$parcel$export(module.exports, "Cc", function () { return $700e24b8b8f9b2b9$export$15dafbac7aec8a57; }, function (v) { return $700e24b8b8f9b2b9$export$15dafbac7aec8a57 = v; });
$parcel$export(module.exports, "Cf", function () { return $700e24b8b8f9b2b9$export$239cff0cce87eb56; }, function (v) { return $700e24b8b8f9b2b9$export$239cff0cce87eb56 = v; });
$parcel$export(module.exports, "P", function () { return $700e24b8b8f9b2b9$export$56c0d5a1e737357d; }, function (v) { return $700e24b8b8f9b2b9$export$56c0d5a1e737357d = v; });
$parcel$export(module.exports, "Z", function () { return $700e24b8b8f9b2b9$export$dc98b0b04f4c7758; }, function (v) { return $700e24b8b8f9b2b9$export$dc98b0b04f4c7758 = v; });
var $700e24b8b8f9b2b9$export$b24b633b1364b94b;
var $700e24b8b8f9b2b9$export$15dafbac7aec8a57;
var $700e24b8b8f9b2b9$export$239cff0cce87eb56;
var $700e24b8b8f9b2b9$export$56c0d5a1e737357d;
var $700e24b8b8f9b2b9$export$dc98b0b04f4c7758;
'use strict';

$700e24b8b8f9b2b9$export$b24b633b1364b94b = (parcelRequire("cESS3"));

$700e24b8b8f9b2b9$export$15dafbac7aec8a57 = (parcelRequire("1ladB"));

$700e24b8b8f9b2b9$export$239cff0cce87eb56 = (parcelRequire("h0cxb"));

$700e24b8b8f9b2b9$export$56c0d5a1e737357d = (parcelRequire("9R3PW"));

$700e24b8b8f9b2b9$export$dc98b0b04f4c7758 = (parcelRequire("aKpnB"));

});
parcelRegister("h0cxb", function(module, exports) {
module.exports = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});



parcelRegister("54Xje", function(module, exports) {
$parcel$export(module.exports, "parseLinkLabel", function () { return $3b2b5505febdb817$export$2a2c8612930e58d0; }, function (v) { return $3b2b5505febdb817$export$2a2c8612930e58d0 = v; });
$parcel$export(module.exports, "parseLinkDestination", function () { return $3b2b5505febdb817$export$22bd24080f95f2b3; }, function (v) { return $3b2b5505febdb817$export$22bd24080f95f2b3 = v; });
$parcel$export(module.exports, "parseLinkTitle", function () { return $3b2b5505febdb817$export$89650c5477a69db9; }, function (v) { return $3b2b5505febdb817$export$89650c5477a69db9 = v; });
// Just a shortcut for bulk export
var $3b2b5505febdb817$export$2a2c8612930e58d0;
var $3b2b5505febdb817$export$22bd24080f95f2b3;
var $3b2b5505febdb817$export$89650c5477a69db9;
'use strict';

$3b2b5505febdb817$export$2a2c8612930e58d0 = (parcelRequire("2x9eu"));

$3b2b5505febdb817$export$22bd24080f95f2b3 = (parcelRequire("1wv2d"));

$3b2b5505febdb817$export$89650c5477a69db9 = (parcelRequire("1kG7L"));

});
parcelRegister("2x9eu", function(module, exports) {
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
'use strict';
module.exports = function parseLinkLabel(state, start, disableNested) {
    var level, found, marker, prevPos, labelEnd = -1, max = state.posMax, oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
};

});

parcelRegister("1wv2d", function(module, exports) {
// Parse link destination
//
'use strict';

var $iKXJl = parcelRequire("iKXJl");
var $11c0da781010e204$require$unescapeAll = $iKXJl.unescapeAll;
module.exports = function parseLinkDestination(str, start, max) {
    var code, level, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = $11c0da781010e204$require$unescapeAll(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = $11c0da781010e204$require$unescapeAll(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
};

});

parcelRegister("1kG7L", function(module, exports) {
// Parse link title
//
'use strict';

var $iKXJl = parcelRequire("iKXJl");
var $0f8855b34e97e87b$require$unescapeAll = $iKXJl.unescapeAll;
module.exports = function parseLinkTitle(str, start, max) {
    var code, marker, lines = 0, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (pos >= max) return result;
    marker = str.charCodeAt(pos);
    if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return result;
    pos++;
    // if opening marker is "(", switch it to closing marker ")"
    if (marker === 0x28) marker = 0x29;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === marker) {
            result.pos = pos + 1;
            result.lines = lines;
            result.str = $0f8855b34e97e87b$require$unescapeAll(str.slice(start + 1, pos));
            result.ok = true;
            return result;
        } else if (code === 0x28 /* ( */  && marker === 0x29 /* ) */ ) return result;
        else if (code === 0x0A) lines++;
        else if (code === 0x5C /* \ */  && pos + 1 < max) {
            pos++;
            if (str.charCodeAt(pos) === 0x0A) lines++;
        }
        pos++;
    }
    return result;
};

});


parcelRegister("1BM1a", function(module, exports) {
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ 'use strict';

var $iKXJl = parcelRequire("iKXJl");
var $12be7e800b470b9a$require$assign = $iKXJl.assign;

var $iKXJl = parcelRequire("iKXJl");
var $12be7e800b470b9a$require$unescapeAll = $iKXJl.unescapeAll;

var $iKXJl = parcelRequire("iKXJl");
var $12be7e800b470b9a$require$escapeHtml = $iKXJl.escapeHtml;
////////////////////////////////////////////////////////////////////////////////
var $12be7e800b470b9a$var$default_rules = {};
$12be7e800b470b9a$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<code' + slf.renderAttrs(token) + '>' + $12be7e800b470b9a$require$escapeHtml(token.content) + '</code>';
};
$12be7e800b470b9a$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<pre' + slf.renderAttrs(token) + '><code>' + $12be7e800b470b9a$require$escapeHtml(tokens[idx].content) + '</code></pre>\n';
};
$12be7e800b470b9a$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    var token = tokens[idx], info = token.info ? $12be7e800b470b9a$require$unescapeAll(token.info).trim() : '', langName = '', langAttrs = '', highlighted, i, arr, tmpAttrs, tmpToken;
    if (info) {
        arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join('');
    }
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || $12be7e800b470b9a$require$escapeHtml(token.content);
    else highlighted = $12be7e800b470b9a$require$escapeHtml(token.content);
    if (highlighted.indexOf('<pre') === 0) return highlighted + '\n';
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        i = token.attrIndex('class');
        tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            'class',
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        tmpToken = {
            attrs: tmpAttrs
        };
        return '<pre><code' + slf.renderAttrs(tmpToken) + '>' + highlighted + '</code></pre>\n';
    }
    return '<pre><code' + slf.renderAttrs(token) + '>' + highlighted + '</code></pre>\n';
};
$12be7e800b470b9a$var$default_rules.image = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex('alt')][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$12be7e800b470b9a$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
$12be7e800b470b9a$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
};
$12be7e800b470b9a$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return $12be7e800b470b9a$require$escapeHtml(tokens[idx].content);
};
$12be7e800b470b9a$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$12be7e800b470b9a$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $12be7e800b470b9a$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/ this.rules = $12be7e800b470b9a$require$assign({}, $12be7e800b470b9a$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $12be7e800b470b9a$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    var i, l, result;
    if (!token.attrs) return '';
    result = '';
    for(i = 0, l = token.attrs.length; i < l; i++)result += ' ' + $12be7e800b470b9a$require$escapeHtml(token.attrs[i][0]) + '="' + $12be7e800b470b9a$require$escapeHtml(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $12be7e800b470b9a$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    var nextToken, result = '', needLf = false, token = tokens[idx];
    // Tight list paragraphs
    if (token.hidden) return '';
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += '\n';
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? '</' : '<') + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += ' /';
    // Check if we need to add a newline after this tag
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                nextToken = tokens[idx + 1];
                if (nextToken.type === 'inline' || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? '>\n' : '>';
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $12be7e800b470b9a$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    var type, result = '', rules = this.rules;
    for(var i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $12be7e800b470b9a$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    var result = '';
    for(var i = 0, len = tokens.length; i < len; i++){
        if (tokens[i].type === 'text') result += tokens[i].content;
        else if (tokens[i].type === 'image') result += this.renderInlineAsText(tokens[i].children, options, env);
        else if (tokens[i].type === 'softbreak') result += '\n';
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $12be7e800b470b9a$var$Renderer.prototype.render = function(tokens, options, env) {
    var i, len, type, result = '', rules = this.rules;
    for(i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (type === 'inline') result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
module.exports = $12be7e800b470b9a$var$Renderer;

});

parcelRegister("70xzc", function(module, exports) {
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ 'use strict';

var $i6wAI = parcelRequire("i6wAI");







var $51a292279bd4eb60$var$_rules = [
    [
        'normalize',
        (parcelRequire("hOorw"))
    ],
    [
        'block',
        (parcelRequire("gNqny"))
    ],
    [
        'inline',
        (parcelRequire("grur0"))
    ],
    [
        'linkify',
        (parcelRequire("g1LbI"))
    ],
    [
        'replacements',
        (parcelRequire("buwRg"))
    ],
    [
        'smartquotes',
        (parcelRequire("8Vg8Y"))
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        'text_join',
        (parcelRequire("lbjuW"))
    ]
];
/**
 * new Core()
 **/ function $51a292279bd4eb60$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new $i6wAI();
    for(var i = 0; i < $51a292279bd4eb60$var$_rules.length; i++)this.ruler.push($51a292279bd4eb60$var$_rules[i][0], $51a292279bd4eb60$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $51a292279bd4eb60$var$Core.prototype.process = function(state) {
    var i, l, rules;
    rules = this.ruler.getRules('');
    for(i = 0, l = rules.length; i < l; i++)rules[i](state);
};

$51a292279bd4eb60$var$Core.prototype.State = (parcelRequire("b056z"));
module.exports = $51a292279bd4eb60$var$Core;

});
parcelRegister("i6wAI", function(module, exports) {
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ 'use strict';
/**
 * new Ruler()
 **/ function $d2e21172d7f1da68$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
////////////////////////////////////////////////////////////////////////////////
// Helper methods, should not be used directly
// Find rule index by name
//
$d2e21172d7f1da68$var$Ruler.prototype.__find__ = function(name) {
    for(var i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$d2e21172d7f1da68$var$Ruler.prototype.__compile__ = function() {
    var self = this;
    var chains = [
        ''
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $d2e21172d7f1da68$var$Ruler.prototype.at = function(name, fn, options) {
    var index = this.__find__(name);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $d2e21172d7f1da68$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    var index = this.__find__(beforeName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $d2e21172d7f1da68$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    var index = this.__find__(afterName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $d2e21172d7f1da68$var$Ruler.prototype.push = function(ruleName, fn, options) {
    var opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $d2e21172d7f1da68$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and enable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $d2e21172d7f1da68$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $d2e21172d7f1da68$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and disable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $d2e21172d7f1da68$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
module.exports = $d2e21172d7f1da68$var$Ruler;

});

parcelRegister("hOorw", function(module, exports) {
// Normalize input string
'use strict';
// https://spec.commonmark.org/0.29/#line-ending
var $cf7a11025307e7cc$var$NEWLINES_RE = /\r\n?|\n/g;
var $cf7a11025307e7cc$var$NULL_RE = /\0/g;
module.exports = function normalize(state) {
    var str;
    // Normalize newlines
    str = state.src.replace($cf7a11025307e7cc$var$NEWLINES_RE, '\n');
    // Replace NULL characters
    str = str.replace($cf7a11025307e7cc$var$NULL_RE, '\uFFFD');
    state.src = str;
};

});

parcelRegister("gNqny", function(module, exports) {
'use strict';
module.exports = function block(state) {
    var token;
    if (state.inlineMode) {
        token = new state.Token('inline', '', 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
};

});

parcelRegister("grur0", function(module, exports) {
'use strict';
module.exports = function inline(state) {
    var tokens = state.tokens, tok, i, l;
    // Parse inlines
    for(i = 0, l = tokens.length; i < l; i++){
        tok = tokens[i];
        if (tok.type === 'inline') state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
};

});

parcelRegister("g1LbI", function(module, exports) {
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//
'use strict';

var $iKXJl = parcelRequire("iKXJl");
var $bab157e381baff83$require$arrayReplaceAt = $iKXJl.arrayReplaceAt;
function $bab157e381baff83$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $bab157e381baff83$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
module.exports = function linkify(state) {
    var i, j, l, tokens, token, currentToken, nodes, ln, text, pos, lastPos, level, htmlLinkLevel, url, fullUrl, urlText, blockTokens = state.tokens, links;
    if (!state.md.options.linkify) return;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        tokens = blockTokens[j].children;
        htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(i = tokens.length - 1; i >= 0; i--){
            currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($bab157e381baff83$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($bab157e381baff83$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {
                text = currentToken.content;
                links = state.md.linkify.match(text);
                // Now split string to nodes
                nodes = [];
                level = currentToken.level;
                lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === 'text_special') links = links.slice(1);
                for(ln = 0; ln < links.length; ln++){
                    url = links[ln].url;
                    fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    pos = links[ln].index;
                    if (pos > lastPos) {
                        token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $bab157e381baff83$require$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};

});

parcelRegister("buwRg", function(module, exports) {
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
'use strict';
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
var $85dbfbf9d3b46f16$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
var $85dbfbf9d3b46f16$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
var $85dbfbf9d3b46f16$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
var $85dbfbf9d3b46f16$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $85dbfbf9d3b46f16$var$replaceFn(match, name) {
    return $85dbfbf9d3b46f16$var$SCOPED_ABBR[name.toLowerCase()];
}
function $85dbfbf9d3b46f16$var$replace_scoped(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) token.content = token.content.replace($85dbfbf9d3b46f16$var$SCOPED_ABBR_RE, $85dbfbf9d3b46f16$var$replaceFn);
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $85dbfbf9d3b46f16$var$replace_rare(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) {
            if ($85dbfbf9d3b46f16$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, '$1\u2014')// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, '$1\u2013').replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, '$1\u2013');
        }
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
module.exports = function replace(state) {
    var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline') continue;
        if ($85dbfbf9d3b46f16$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $85dbfbf9d3b46f16$var$replace_scoped(state.tokens[blkIdx].children);
        if ($85dbfbf9d3b46f16$var$RARE_RE.test(state.tokens[blkIdx].content)) $85dbfbf9d3b46f16$var$replace_rare(state.tokens[blkIdx].children);
    }
};

});

parcelRegister("8Vg8Y", function(module, exports) {
// Convert straight quotation marks to typographic ones
//
'use strict';

var $iKXJl = parcelRequire("iKXJl");
var $67f02b6c93c6247b$require$isWhiteSpace = $iKXJl.isWhiteSpace;

var $iKXJl = parcelRequire("iKXJl");
var $67f02b6c93c6247b$require$isPunctChar = $iKXJl.isPunctChar;

var $iKXJl = parcelRequire("iKXJl");
var $67f02b6c93c6247b$require$isMdAsciiPunct = $iKXJl.isMdAsciiPunct;
var $67f02b6c93c6247b$var$QUOTE_TEST_RE = /['"]/;
var $67f02b6c93c6247b$var$QUOTE_RE = /['"]/g;
var $67f02b6c93c6247b$var$APOSTROPHE = '\u2019'; /* ’ */ 
function $67f02b6c93c6247b$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $67f02b6c93c6247b$var$process_inlines(tokens, state) {
    var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar, isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace, canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;
    stack = [];
    for(i = 0; i < tokens.length; i++){
        token = tokens[i];
        thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== 'text') continue;
        text = token.content;
        pos = 0;
        max = text.length;
        /*eslint no-labels:0,block-scoped-var:0*/ OUTER: while(pos < max){
            $67f02b6c93c6247b$var$QUOTE_RE.lastIndex = pos;
            t = $67f02b6c93c6247b$var$QUOTE_RE.exec(text);
            if (!t) break;
            canOpen = canClose = true;
            pos = t.index + 1;
            isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            isLastPunctChar = $67f02b6c93c6247b$require$isMdAsciiPunct(lastChar) || $67f02b6c93c6247b$require$isPunctChar(String.fromCharCode(lastChar));
            isNextPunctChar = $67f02b6c93c6247b$require$isMdAsciiPunct(nextChar) || $67f02b6c93c6247b$require$isPunctChar(String.fromCharCode(nextChar));
            isLastWhiteSpace = $67f02b6c93c6247b$require$isWhiteSpace(lastChar);
            isNextWhiteSpace = $67f02b6c93c6247b$require$isWhiteSpace(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $67f02b6c93c6247b$var$replaceAt(token.content, t.index, $67f02b6c93c6247b$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $67f02b6c93c6247b$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $67f02b6c93c6247b$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $67f02b6c93c6247b$var$replaceAt(token.content, t.index, $67f02b6c93c6247b$var$APOSTROPHE);
        }
    }
}
module.exports = function smartquotes(state) {
    /*eslint max-depth:0*/ var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline' || !$67f02b6c93c6247b$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $67f02b6c93c6247b$var$process_inlines(state.tokens[blkIdx].children, state);
    }
};

});

parcelRegister("lbjuW", function(module, exports) {
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
'use strict';
module.exports = function text_join(state) {
    var j, l, tokens, curr, max, last, blockTokens = state.tokens;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline') continue;
        tokens = blockTokens[j].children;
        max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === 'text_special') tokens[curr].type = 'text';
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
};

});

parcelRegister("b056z", function(module, exports) {
// Core state object
//
'use strict';

var $3coOC = parcelRequire("3coOC");
function $8023a78bc44e7916$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md; // link to parser instance
}
// re-export Token class to use in core rules
$8023a78bc44e7916$var$StateCore.prototype.Token = $3coOC;
module.exports = $8023a78bc44e7916$var$StateCore;

});
parcelRegister("3coOC", function(module, exports) {
// Token class
'use strict';
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $2545bdee23b691a9$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = '';
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = '';
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = '';
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $2545bdee23b691a9$var$Token.prototype.attrIndex = function attrIndex(name) {
    var attrs, i, len;
    if (!this.attrs) return -1;
    attrs = this.attrs;
    for(i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $2545bdee23b691a9$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $2545bdee23b691a9$var$Token.prototype.attrSet = function attrSet(name, value) {
    var idx = this.attrIndex(name), attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $2545bdee23b691a9$var$Token.prototype.attrGet = function attrGet(name) {
    var idx = this.attrIndex(name), value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $2545bdee23b691a9$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    var idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
};
module.exports = $2545bdee23b691a9$var$Token;

});



parcelRegister("9bpP3", function(module, exports) {
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ 'use strict';

var $i6wAI = parcelRequire("i6wAI");











var $6af92bef44d51bde$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        'table',
        (parcelRequire("3CppC")),
        [
            'paragraph',
            'reference'
        ]
    ],
    [
        'code',
        (parcelRequire("gMLpz"))
    ],
    [
        'fence',
        (parcelRequire("jOsbA")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'blockquote',
        (parcelRequire("3cAHs")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'hr',
        (parcelRequire("jRhkH")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'list',
        (parcelRequire("fpUe4")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'reference',
        (parcelRequire("ggd1z"))
    ],
    [
        'html_block',
        (parcelRequire("1zFME")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'heading',
        (parcelRequire("in72E")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'lheading',
        (parcelRequire("evIHV"))
    ],
    [
        'paragraph',
        (parcelRequire("fFml6"))
    ]
];
/**
 * new ParserBlock()
 **/ function $6af92bef44d51bde$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new $i6wAI();
    for(var i = 0; i < $6af92bef44d51bde$var$_rules.length; i++)this.ruler.push($6af92bef44d51bde$var$_rules[i][0], $6af92bef44d51bde$var$_rules[i][1], {
        alt: ($6af92bef44d51bde$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$6af92bef44d51bde$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    var ok, i, prevLine, rules = this.ruler.getRules(''), len = rules.length, line = startLine, hasEmptyLines = false, maxNesting = state.md.options.maxNesting;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        prevLine = state.line;
        for(i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error('none of the block rules matched');
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $6af92bef44d51bde$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    var state;
    if (!src) return;
    state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};

$6af92bef44d51bde$var$ParserBlock.prototype.State = (parcelRequire("55h9q"));
module.exports = $6af92bef44d51bde$var$ParserBlock;

});
parcelRegister("3CppC", function(module, exports) {
// GFM table, https://github.github.com/gfm/#tables-extension-
'use strict';

var $iKXJl = parcelRequire("iKXJl");
var $2a28a20d785dbd43$require$isSpace = $iKXJl.isSpace;
function $2a28a20d785dbd43$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.tShift[line], max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $2a28a20d785dbd43$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, isEscaped = false, lastPos = 0, current = '';
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = '';
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, l, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines, oldParentType, terminate, terminatorRules, firstCh, secondCh;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !$2a28a20d785dbd43$require$isSpace(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && $2a28a20d785dbd43$require$isSpace(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !$2a28a20d785dbd43$require$isSpace(ch)) return false;
        pos++;
    }
    lineText = $2a28a20d785dbd43$var$getLine(state, startLine + 1);
    columns = lineText.split('|');
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $2a28a20d785dbd43$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $2a28a20d785dbd43$var$escapedSplit(lineText);
    if (columns.length && columns[0] === '') columns.shift();
    if (columns.length && columns[columns.length - 1] === '') columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    oldParentType = state.parentType;
    state.parentType = 'table';
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    token = state.push('table_open', 'table', 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    token = state.push('thead_open', 'thead', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    token = state.push('tr_open', 'tr', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push('th_open', 'th', 1);
        if (aligns[i]) token.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.children = [];
        token = state.push('th_close', 'th', -1);
    }
    token = state.push('tr_close', 'tr', -1);
    token = state.push('thead_close', 'thead', -1);
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $2a28a20d785dbd43$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $2a28a20d785dbd43$var$escapedSplit(lineText);
        if (columns.length && columns[0] === '') columns.shift();
        if (columns.length && columns[columns.length - 1] === '') columns.pop();
        if (nextLine === startLine + 2) {
            token = state.push('tbody_open', 'tbody', 1);
            token.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        token = state.push('tr_open', 'tr', 1);
        token.map = [
            nextLine,
            nextLine + 1
        ];
        for(i = 0; i < columnCount; i++){
            token = state.push('td_open', 'td', 1);
            if (aligns[i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[i]
                ]
            ];
            token = state.push('inline', '', 0);
            token.content = columns[i] ? columns[i].trim() : '';
            token.children = [];
            token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
    }
    if (tbodyLines) {
        token = state.push('tbody_close', 'tbody', -1);
        tbodyLines[1] = nextLine;
    }
    token = state.push('table_close', 'table', -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
};

});

parcelRegister("gMLpz", function(module, exports) {
// Code block (4 spaces padded)
'use strict';
module.exports = function code(state, startLine, endLine /*, silent*/ ) {
    var nextLine, last, token;
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    last = nextLine = startLine + 1;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    token = state.push('code_block', 'code', 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("jOsbA", function(module, exports) {
// fences (``` lang, ~~~ lang)
'use strict';
module.exports = function fence(state, startLine, endLine, silent) {
    var marker, len, params, nextLine, mem, token, markup, haveEndMarker = false, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    mem = pos;
    pos = state.skipChars(pos, marker);
    len = pos - mem;
    if (len < 3) return false;
    markup = state.src.slice(mem, pos);
    params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    nextLine = startLine;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    token = state.push('fence', 'code', 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("3cAHs", function(module, exports) {
// Block quotes
'use strict';

var $iKXJl = parcelRequire("iKXJl");
var $254ef5eb609471c4$require$isSpace = $iKXJl.isSpace;
module.exports = function blockquote(state, startLine, endLine, silent) {
    var adjustTab, ch, i, initial, l, lastLineEmpty, lines, nextLine, offset, oldBMarks, oldBSCount, oldIndent, oldParentType, oldSCount, oldTShift, spaceAfterMarker, terminate, terminatorRules, token, isOutdented, oldLineMax = state.lineMax, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    oldBMarks = [];
    oldBSCount = [];
    oldSCount = [];
    oldTShift = [];
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    oldParentType = state.parentType;
    state.parentType = 'blockquote';
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            initial = state.sCount[nextLine] + 1;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                ch = state.src.charCodeAt(pos);
                if ($254ef5eb609471c4$require$isSpace(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    oldIndent = state.blkIndent;
    state.blkIndent = 0;
    token = state.push('blockquote_open', 'blockquote', 1);
    token.markup = '>';
    token.map = lines = [
        startLine,
        0
    ];
    state.md.block.tokenize(state, startLine, nextLine);
    token = state.push('blockquote_close', 'blockquote', -1);
    token.markup = '>';
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
};

});

parcelRegister("jRhkH", function(module, exports) {
// Horizontal rule
'use strict';

var $iKXJl = parcelRequire("iKXJl");
var $e750698004e7972d$require$isSpace = $iKXJl.isSpace;
module.exports = function hr(state, startLine, endLine, silent) {
    var marker, cnt, ch, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    cnt = 1;
    while(pos < max){
        ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !$e750698004e7972d$require$isSpace(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    token = state.push('hr', 'hr', 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
};

});

parcelRegister("fpUe4", function(module, exports) {
// Lists
'use strict';

var $iKXJl = parcelRequire("iKXJl");
var $b394ce1e46afa2a8$require$isSpace = $iKXJl.isSpace;
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $b394ce1e46afa2a8$var$skipBulletListMarker(state, startLine) {
    var marker, pos, max, ch;
    pos = state.bMarks[startLine] + state.tShift[startLine];
    max = state.eMarks[startLine];
    marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$b394ce1e46afa2a8$require$isSpace(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $b394ce1e46afa2a8$var$skipOrderedListMarker(state, startLine) {
    var ch, start = state.bMarks[startLine] + state.tShift[startLine], pos = start, max = state.eMarks[startLine];
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$b394ce1e46afa2a8$require$isSpace(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $b394ce1e46afa2a8$var$markTightParagraphs(state, idx) {
    var i, l, level = state.level + 2;
    for(i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
module.exports = function list(state, startLine, endLine, silent) {
    var ch, contentStart, i, indent, indentAfterMarker, initial, isOrdered, itemLines, l, listLines, listTokIdx, markerCharCode, markerValue, max, offset, oldListIndent, oldParentType, oldSCount, oldTShift, oldTight, pos, posAfterMarker, prevEmptyEnd, start, terminate, terminatorRules, token, nextLine = startLine, isTerminatingParagraph = false, tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === 'paragraph') // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    if ((posAfterMarker = $b394ce1e46afa2a8$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $b394ce1e46afa2a8$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push('ordered_list_open', 'ol', 1);
        if (markerValue !== 1) token.attrs = [
            [
                'start',
                markerValue
            ]
        ];
    } else token = state.push('bullet_list_open', 'ul', 1);
    token.map = listLines = [
        nextLine,
        0
    ];
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    prevEmptyEnd = false;
    terminatorRules = state.md.block.ruler.getRules('list');
    oldParentType = state.parentType;
    state.parentType = 'list';
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        while(pos < max){
            ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        contentStart = pos;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push('list_item_open', 'li', 1);
        token.markup = String.fromCharCode(markerCharCode);
        token.map = itemLines = [
            nextLine,
            0
        ];
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        oldTight = state.tight;
        oldTShift = state.tShift[nextLine];
        oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push('list_item_close', 'li', -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $b394ce1e46afa2a8$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $b394ce1e46afa2a8$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push('ordered_list_close', 'ol', -1);
    else token = state.push('bullet_list_close', 'ul', -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $b394ce1e46afa2a8$var$markTightParagraphs(state, listTokIdx);
    return true;
};

});

parcelRegister("ggd1z", function(module, exports) {
'use strict';

var $iKXJl = parcelRequire("iKXJl");
var $030e118593d03c75$require$normalizeReference = $iKXJl.normalizeReference;

var $iKXJl = parcelRequire("iKXJl");
var $030e118593d03c75$require$isSpace = $iKXJl.isSpace;
module.exports = function reference(state, startLine, _endLine, silent) {
    var ch, destEndPos, destEndLineNo, endLine, href, i, l, label, labelEnd, oldParentType, res, start, str, terminate, terminatorRules, title, lines = 0, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine], nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    // Simple check to quickly interrupt scan on [link](url) at the start of line.
    // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
    while(++pos < max)if (state.src.charCodeAt(pos) === 0x5D /* ] */  && state.src.charCodeAt(pos - 1) !== 0x5C /* \ */ ) {
        if (pos + 1 === max) return false;
        if (state.src.charCodeAt(pos + 1) !== 0x3A /* : */ ) return false;
        break;
    }
    endLine = state.lineMax;
    // jump line-by-line until empty one or EOF
    terminatorRules = state.md.block.ruler.getRules('reference');
    oldParentType = state.parentType;
    state.parentType = 'reference';
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    max = str.length;
    for(pos = 1; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) lines++;
        else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) lines++;
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($030e118593d03c75$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    res = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!res.ok) return false;
    href = state.md.normalizeLink(res.str);
    if (!state.md.validateLink(href)) return false;
    pos = res.pos;
    lines += res.lines;
    // save cursor state, we could require to rollback later
    destEndPos = pos;
    destEndLineNo = lines;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    start = pos;
    for(; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($030e118593d03c75$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    res = state.md.helpers.parseLinkTitle(str, pos, max);
    if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;
        lines += res.lines;
    } else {
        title = '';
        pos = destEndPos;
        lines = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        ch = str.charCodeAt(pos);
        if (!$030e118593d03c75$require$isSpace(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = '';
            pos = destEndPos;
            lines = destEndLineNo;
            while(pos < max){
                ch = str.charCodeAt(pos);
                if (!$030e118593d03c75$require$isSpace(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    label = $030e118593d03c75$require$normalizeReference(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /*istanbul ignore if*/ if (silent) return true;
    if (typeof state.env.references === 'undefined') state.env.references = {};
    if (typeof state.env.references[label] === 'undefined') state.env.references[label] = {
        title: title,
        href: href
    };
    state.parentType = oldParentType;
    state.line = startLine + lines + 1;
    return true;
};

});

parcelRegister("1zFME", function(module, exports) {
// HTML block
'use strict';

var $6kA1q = parcelRequire("6kA1q");

var $iJoKj = parcelRequire("iJoKj");
var $125978b084e2d7d3$require$HTML_OPEN_CLOSE_TAG_RE = $iJoKj.HTML_OPEN_CLOSE_TAG_RE;
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var $125978b084e2d7d3$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp('^</?(' + $6kA1q.join('|') + ')(?=(\\s|/?>|$))', 'i'),
        /^$/,
        true
    ],
    [
        new RegExp($125978b084e2d7d3$require$HTML_OPEN_CLOSE_TAG_RE.source + '\\s*$'),
        /^$/,
        false
    ]
];
module.exports = function html_block(state, startLine, endLine, silent) {
    var i, nextLine, token, lineText, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    lineText = state.src.slice(pos, max);
    for(i = 0; i < $125978b084e2d7d3$var$HTML_SEQUENCES.length; i++){
        if ($125978b084e2d7d3$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $125978b084e2d7d3$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $125978b084e2d7d3$var$HTML_SEQUENCES[i][2];
    nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$125978b084e2d7d3$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($125978b084e2d7d3$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    token = state.push('html_block', '', 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
};

});
parcelRegister("6kA1q", function(module, exports) {
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks
'use strict';
module.exports = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'section',
    'source',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];

});

parcelRegister("iJoKj", function(module, exports) {
$parcel$export(module.exports, "HTML_TAG_RE", function () { return $da2fa002c5ffa353$export$6db61d2c3a16e419; }, function (v) { return $da2fa002c5ffa353$export$6db61d2c3a16e419 = v; });
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", function () { return $da2fa002c5ffa353$export$cd48660d06f74639; }, function (v) { return $da2fa002c5ffa353$export$cd48660d06f74639 = v; });
// Regexps to match html elements
var $da2fa002c5ffa353$export$6db61d2c3a16e419;
var $da2fa002c5ffa353$export$cd48660d06f74639;
'use strict';
var $da2fa002c5ffa353$var$attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
var $da2fa002c5ffa353$var$unquoted = '[^"\'=<>`\\x00-\\x20]+';
var $da2fa002c5ffa353$var$single_quoted = "'[^']*'";
var $da2fa002c5ffa353$var$double_quoted = '"[^"]*"';
var $da2fa002c5ffa353$var$attr_value = '(?:' + $da2fa002c5ffa353$var$unquoted + '|' + $da2fa002c5ffa353$var$single_quoted + '|' + $da2fa002c5ffa353$var$double_quoted + ')';
var $da2fa002c5ffa353$var$attribute = '(?:\\s+' + $da2fa002c5ffa353$var$attr_name + '(?:\\s*=\\s*' + $da2fa002c5ffa353$var$attr_value + ')?)';
var $da2fa002c5ffa353$var$open_tag = '<[A-Za-z][A-Za-z0-9\\-]*' + $da2fa002c5ffa353$var$attribute + '*\\s*\\/?>';
var $da2fa002c5ffa353$var$close_tag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
var $da2fa002c5ffa353$var$comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
var $da2fa002c5ffa353$var$processing = '<[?][\\s\\S]*?[?]>';
var $da2fa002c5ffa353$var$declaration = '<![A-Z]+\\s+[^>]*>';
var $da2fa002c5ffa353$var$cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
var $da2fa002c5ffa353$var$HTML_TAG_RE = new RegExp('^(?:' + $da2fa002c5ffa353$var$open_tag + '|' + $da2fa002c5ffa353$var$close_tag + '|' + $da2fa002c5ffa353$var$comment + '|' + $da2fa002c5ffa353$var$processing + '|' + $da2fa002c5ffa353$var$declaration + '|' + $da2fa002c5ffa353$var$cdata + ')');
var $da2fa002c5ffa353$var$HTML_OPEN_CLOSE_TAG_RE = new RegExp('^(?:' + $da2fa002c5ffa353$var$open_tag + '|' + $da2fa002c5ffa353$var$close_tag + ')');
$da2fa002c5ffa353$export$6db61d2c3a16e419 = $da2fa002c5ffa353$var$HTML_TAG_RE;
$da2fa002c5ffa353$export$cd48660d06f74639 = $da2fa002c5ffa353$var$HTML_OPEN_CLOSE_TAG_RE;

});


parcelRegister("in72E", function(module, exports) {
// heading (#, ##, ...)
'use strict';

var $iKXJl = parcelRequire("iKXJl");
var $d5ffd65484947898$require$isSpace = $iKXJl.isSpace;
module.exports = function heading(state, startLine, endLine, silent) {
    var ch, level, tmp, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !$d5ffd65484947898$require$isSpace(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    tmp = state.skipCharsBack(max, 0x23, pos); // #
    if (tmp > pos && $d5ffd65484947898$require$isSpace(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = '########'.slice(0, level);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = state.src.slice(pos, max).trim();
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = '########'.slice(0, level);
    return true;
};

});

parcelRegister("evIHV", function(module, exports) {
// lheading (---, ===)
'use strict';
module.exports = function lheading(state, startLine, endLine /*, silent*/ ) {
    var content, terminate, i, l, token, pos, max, level, marker, nextLine = startLine + 1, oldParentType, terminatorRules = state.md.block.ruler.getRules('paragraph');
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    oldParentType = state.parentType;
    state.parentType = 'paragraph'; // use paragraph to match terminatorRules
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            pos = state.bMarks[nextLine] + state.tShift[nextLine];
            max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = String.fromCharCode(marker);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line - 1
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("fFml6", function(module, exports) {
// Paragraph
'use strict';
module.exports = function paragraph(state, startLine, endLine) {
    var content, terminate, i, l, token, oldParentType, nextLine = startLine + 1, terminatorRules = state.md.block.ruler.getRules('paragraph');
    oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("55h9q", function(module, exports) {
// Parser state class
'use strict';

var $3coOC = parcelRequire("3coOC");

var $iKXJl = parcelRequire("iKXJl");
var $3b3ab9390b8e1bcd$require$isSpace = $iKXJl.isSpace;
function $3b3ab9390b8e1bcd$var$StateBlock(src, md, env, tokens) {
    var ch, s, start, pos, len, indent, offset, indent_found;
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = []; // line begin offsets for fast jumps
    this.eMarks = []; // line end offsets for fast jumps
    this.tShift = []; // offsets of the first non-space characters (tabs not expanded)
    this.sCount = []; // indents for each line (tabs expanded)
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    this.blkIndent = 0; // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.line = 0; // line index in src
    this.lineMax = 0; // lines count
    this.tight = false; // loose/tight mode for lists
    this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)
    this.listIndent = -1; // indent of the current list block (-1 if there isn't any)
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = 'root';
    this.level = 0;
    // renderer
    this.result = '';
    // Create caches
    // Generate markers.
    s = this.src;
    indent_found = false;
    for(start = pos = indent = offset = 0, len = s.length; pos < len; pos++){
        ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ($3b3ab9390b8e1bcd$require$isSpace(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1; // don't count last fake line
}
// Push new token to "stream".
//
$3b3ab9390b8e1bcd$var$StateBlock.prototype.push = function(type, tag, nesting) {
    var token = new $3coOC(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level--; // closing tag
    token.level = this.level;
    if (nesting > 0) this.level++; // opening tag
    this.tokens.push(token);
    return token;
};
$3b3ab9390b8e1bcd$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$3b3ab9390b8e1bcd$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(var max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$3b3ab9390b8e1bcd$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    var ch;
    for(var max = this.src.length; pos < max; pos++){
        ch = this.src.charCodeAt(pos);
        if (!$3b3ab9390b8e1bcd$require$isSpace(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$3b3ab9390b8e1bcd$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!$3b3ab9390b8e1bcd$require$isSpace(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$3b3ab9390b8e1bcd$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(var max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$3b3ab9390b8e1bcd$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$3b3ab9390b8e1bcd$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    var i, lineIndent, ch, first, last, queue, lineStart, line = begin;
    if (begin >= end) return '';
    queue = new Array(end - begin);
    for(i = 0; line < end; line++, i++){
        lineIndent = 0;
        lineStart = first = this.bMarks[line];
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            ch = this.src.charCodeAt(first);
            if ($3b3ab9390b8e1bcd$require$isSpace(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join('');
};
// re-export Token class to use in block rules
$3b3ab9390b8e1bcd$var$StateBlock.prototype.Token = $3coOC;
module.exports = $3b3ab9390b8e1bcd$var$StateBlock;

});


parcelRegister("2VcQp", function(module, exports) {
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ 'use strict';

var $i6wAI = parcelRequire("i6wAI");












////////////////////////////////////////////////////////////////////////////////
// Parser rules
var $220ade3ae1bece86$var$_rules = [
    [
        'text',
        (parcelRequire("ph3EK"))
    ],
    [
        'linkify',
        (parcelRequire("awXHI"))
    ],
    [
        'newline',
        (parcelRequire("1uW4v"))
    ],
    [
        'escape',
        (parcelRequire("fK103"))
    ],
    [
        'backticks',
        (parcelRequire("jHi5L"))
    ],
    [
        'strikethrough',
        (parcelRequire("b7zru")).tokenize
    ],
    [
        'emphasis',
        (parcelRequire("fVLlP")).tokenize
    ],
    [
        'link',
        (parcelRequire("6JaQq"))
    ],
    [
        'image',
        (parcelRequire("ayc2e"))
    ],
    [
        'autolink',
        (parcelRequire("9fBK4"))
    ],
    [
        'html_inline',
        (parcelRequire("hEFZj"))
    ],
    [
        'entity',
        (parcelRequire("1OuUd"))
    ]
];




// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
var $220ade3ae1bece86$var$_rules2 = [
    [
        'balance_pairs',
        (parcelRequire("aeOLv"))
    ],
    [
        'strikethrough',
        (parcelRequire("b7zru")).postProcess
    ],
    [
        'emphasis',
        (parcelRequire("fVLlP")).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        'fragments_join',
        (parcelRequire("4jGFu"))
    ]
];
/**
 * new ParserInline()
 **/ function $220ade3ae1bece86$var$ParserInline() {
    var i;
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new $i6wAI();
    for(i = 0; i < $220ade3ae1bece86$var$_rules.length; i++)this.ruler.push($220ade3ae1bece86$var$_rules[i][0], $220ade3ae1bece86$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new $i6wAI();
    for(i = 0; i < $220ade3ae1bece86$var$_rules2.length; i++)this.ruler2.push($220ade3ae1bece86$var$_rules2[i][0], $220ade3ae1bece86$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$220ade3ae1bece86$var$ParserInline.prototype.skipToken = function(state) {
    var ok, i, pos = state.pos, rules = this.ruler.getRules(''), len = rules.length, maxNesting = state.md.options.maxNesting, cache = state.cache;
    if (typeof cache[pos] !== 'undefined') {
        state.pos = cache[pos];
        return;
    }
    if (state.level < maxNesting) for(i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$220ade3ae1bece86$var$ParserInline.prototype.tokenize = function(state) {
    var ok, i, prevPos, rules = this.ruler.getRules(''), len = rules.length, end = state.posMax, maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        prevPos = state.pos;
        if (state.level < maxNesting) for(i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $220ade3ae1bece86$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    var i, rules, len;
    var state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    rules = this.ruler2.getRules('');
    len = rules.length;
    for(i = 0; i < len; i++)rules[i](state);
};

$220ade3ae1bece86$var$ParserInline.prototype.State = (parcelRequire("1iTpN"));
module.exports = $220ade3ae1bece86$var$ParserInline;

});
parcelRegister("ph3EK", function(module, exports) {
// Skip text characters for text token, place those to pending buffer
// and increment current pos
'use strict';
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $04bf9145940c7481$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
module.exports = function text(state, silent) {
    var pos = state.pos;
    while(pos < state.posMax && !$04bf9145940c7481$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
}; // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParcerInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
};*/ 

});

parcelRegister("awXHI", function(module, exports) {
// Process links like https://example.org/
'use strict';
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
var $7aab3483a3302e13$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
module.exports = function linkify(state, silent) {
    var pos, max, match, proto, link, url, fullUrl, token;
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    pos = state.pos;
    max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    match = state.pending.match($7aab3483a3302e13$var$SCHEME_RE);
    if (!match) return false;
    proto = match[1];
    link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, '');
    fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        token = state.push('link_open', 'a', 1);
        token.attrs = [
            [
                'href',
                fullUrl
            ]
        ];
        token.markup = 'linkify';
        token.info = 'auto';
        token = state.push('text', '', 0);
        token.content = state.md.normalizeLinkText(url);
        token = state.push('link_close', 'a', -1);
        token.markup = 'linkify';
        token.info = 'auto';
    }
    state.pos += url.length - proto.length;
    return true;
};

});

parcelRegister("1uW4v", function(module, exports) {
// Proceess '\n'
'use strict';

var $iKXJl = parcelRequire("iKXJl");
var $1175a3a209e63bc6$require$isSpace = $iKXJl.isSpace;
module.exports = function newline(state, silent) {
    var pmax, max, ws, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    pmax = state.pending.length - 1;
    max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push('hardbreak', 'br', 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && $1175a3a209e63bc6$require$isSpace(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
};

});

parcelRegister("fK103", function(module, exports) {
// Process escaped chars and hardbreaks
'use strict';

var $iKXJl = parcelRequire("iKXJl");
var $b75bed7666e79792$require$isSpace = $iKXJl.isSpace;
var $b75bed7666e79792$var$ESCAPED = [];
for(var $b75bed7666e79792$var$i = 0; $b75bed7666e79792$var$i < 256; $b75bed7666e79792$var$i++)$b75bed7666e79792$var$ESCAPED.push(0);
'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function(ch) {
    $b75bed7666e79792$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
module.exports = function escape(state, silent) {
    var ch1, ch2, origStr, escapedStr, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push('hardbreak', 'br', 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!$b75bed7666e79792$require$isSpace(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    origStr = '\\' + escapedStr;
    if (!silent) {
        token = state.push('text_special', '', 0);
        if (ch1 < 256 && $b75bed7666e79792$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = 'escape';
    }
    state.pos = pos + 1;
    return true;
};

});

parcelRegister("jHi5L", function(module, exports) {
// Parse backticks
'use strict';
module.exports = function backtick(state, silent) {
    var start, max, marker, token, matchStart, matchEnd, openerLength, closerLength, pos = state.pos, ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    start = pos;
    pos++;
    max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    marker = state.src.slice(start, pos);
    openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    matchEnd = pos;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf('`', matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                token = state.push('code_inline', 'code', 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, ' ').replace(/^ (.+) $/, '$1');
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
};

});

parcelRegister("b7zru", function(module, exports) {
$parcel$export(module.exports, "tokenize", function () { return $818bd74322ebd0a9$export$660b2ee2d4fb4eff; }, function (v) { return $818bd74322ebd0a9$export$660b2ee2d4fb4eff = v; });
$parcel$export(module.exports, "postProcess", function () { return $818bd74322ebd0a9$export$7b804a0e0ce836d9; }, function (v) { return $818bd74322ebd0a9$export$7b804a0e0ce836d9 = v; });
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $818bd74322ebd0a9$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $818bd74322ebd0a9$export$7b804a0e0ce836d9;
'use strict';
$818bd74322ebd0a9$export$660b2ee2d4fb4eff = function strikethrough(state, silent) {
    var i, scanned, token, len, ch, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    scanned = state.scanDelims(state.pos, true);
    len = scanned.length;
    ch = String.fromCharCode(marker);
    if (len < 2) return false;
    if (len % 2) {
        token = state.push('text', '', 0);
        token.content = ch;
        len--;
    }
    for(i = 0; i < len; i += 2){
        token = state.push('text', '', 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $818bd74322ebd0a9$var$postProcess(state, delimiters) {
    var i, j, startDelim, endDelim, token, loneMarkers = [], max = delimiters.length;
    for(i = 0; i < max; i++){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = 's_open';
        token.tag = 's';
        token.nesting = 1;
        token.markup = '~~';
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = 's_close';
        token.tag = 's';
        token.nesting = -1;
        token.markup = '~~';
        token.content = '';
        if (state.tokens[endDelim.token - 1].type === 'text' && state.tokens[endDelim.token - 1].content === '~') loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        i = loneMarkers.pop();
        j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === 's_close')j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
$818bd74322ebd0a9$export$7b804a0e0ce836d9 = function strikethrough(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $818bd74322ebd0a9$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $818bd74322ebd0a9$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("fVLlP", function(module, exports) {
$parcel$export(module.exports, "tokenize", function () { return $b990e8d497a3acd8$export$660b2ee2d4fb4eff; }, function (v) { return $b990e8d497a3acd8$export$660b2ee2d4fb4eff = v; });
$parcel$export(module.exports, "postProcess", function () { return $b990e8d497a3acd8$export$7b804a0e0ce836d9; }, function (v) { return $b990e8d497a3acd8$export$7b804a0e0ce836d9 = v; });
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $b990e8d497a3acd8$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $b990e8d497a3acd8$export$7b804a0e0ce836d9;
'use strict';
$b990e8d497a3acd8$export$660b2ee2d4fb4eff = function emphasis(state, silent) {
    var i, scanned, token, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(i = 0; i < scanned.length; i++){
        token = state.push('text', '', 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            // Char code of the starting marker (number).
            //
            marker: marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $b990e8d497a3acd8$var$postProcess(state, delimiters) {
    var i, startDelim, endDelim, token, ch, isStrong, max = delimiters.length;
    for(i = max - 1; i >= 0; i--){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        ch = String.fromCharCode(startDelim.marker);
        token = state.tokens[startDelim.token];
        token.type = isStrong ? 'strong_open' : 'em_open';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = 1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = isStrong ? 'strong_close' : 'em_close';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = -1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = '';
            state.tokens[delimiters[startDelim.end + 1].token].content = '';
            i--;
        }
    }
}
$b990e8d497a3acd8$export$7b804a0e0ce836d9 = function emphasis(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $b990e8d497a3acd8$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $b990e8d497a3acd8$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("6JaQq", function(module, exports) {
// Process [link](<to> "stuff")
'use strict';

var $iKXJl = parcelRequire("iKXJl");
var $4e5f5b8a497f924c$require$normalizeReference = $iKXJl.normalizeReference;

var $iKXJl = parcelRequire("iKXJl");
var $4e5f5b8a497f924c$require$isSpace = $iKXJl.isSpace;
module.exports = function link(state, silent) {
    var attrs, code, label, labelEnd, labelStart, pos, res, ref, token, href = '', title = '', oldPos = state.pos, max = state.posMax, start = state.pos, parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 1;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$4e5f5b8a497f924c$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$4e5f5b8a497f924c$require$isSpace(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!$4e5f5b8a497f924c$require$isSpace(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$4e5f5b8a497f924c$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        token = state.push('link_open', 'a', 1);
        token.attrs = attrs = [
            [
                'href',
                href
            ]
        ];
        if (title) attrs.push([
            'title',
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        token = state.push('link_close', 'a', -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("ayc2e", function(module, exports) {
// Process ![image](<src> "title")
'use strict';

var $iKXJl = parcelRequire("iKXJl");
var $7ae66a40bd7f7e89$require$normalizeReference = $iKXJl.normalizeReference;

var $iKXJl = parcelRequire("iKXJl");
var $7ae66a40bd7f7e89$require$isSpace = $iKXJl.isSpace;
module.exports = function image(state, silent) {
    var attrs, code, content, label, labelEnd, labelStart, pos, ref, res, title, token, tokens, start, href = '', oldPos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 2;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$7ae66a40bd7f7e89$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$7ae66a40bd7f7e89$require$isSpace(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$7ae66a40bd7f7e89$require$isSpace(code) && code !== 0x0A) break;
            }
        } else title = '';
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$7ae66a40bd7f7e89$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        state.md.inline.parse(content, state.md, state.env, tokens = []);
        token = state.push('image', 'img', 0);
        token.attrs = attrs = [
            [
                'src',
                href
            ],
            [
                'alt',
                ''
            ]
        ];
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            'title',
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("9fBK4", function(module, exports) {
// Process autolinks '<protocol:...>'
'use strict';
/*eslint max-len:0*/ var $6bc2ca94ab86b298$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
var $6bc2ca94ab86b298$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/;
module.exports = function autolink(state, silent) {
    var url, fullUrl, token, ch, start, max, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    start = state.pos;
    max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    url = state.src.slice(start + 1, pos);
    if ($6bc2ca94ab86b298$var$AUTOLINK_RE.test(url)) {
        fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($6bc2ca94ab86b298$var$EMAIL_RE.test(url)) {
        fullUrl = state.md.normalizeLink('mailto:' + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
};

});

parcelRegister("hEFZj", function(module, exports) {
// Process html tags
'use strict';

var $iJoKj = parcelRequire("iJoKj");
var $cda6be06a107a9b2$require$HTML_TAG_RE = $iJoKj.HTML_TAG_RE;
function $cda6be06a107a9b2$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $cda6be06a107a9b2$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $cda6be06a107a9b2$var$isLetter(ch) {
    /*eslint no-bitwise:0*/ var lc = ch | 0x20; // to lower case
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
module.exports = function html_inline(state, silent) {
    var ch, match, max, token, pos = state.pos;
    if (!state.md.options.html) return false;
    // Check start
    max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$cda6be06a107a9b2$var$isLetter(ch)) return false;
    match = state.src.slice(pos).match($cda6be06a107a9b2$require$HTML_TAG_RE);
    if (!match) return false;
    if (!silent) {
        token = state.push('html_inline', '', 0);
        token.content = match[0];
        if ($cda6be06a107a9b2$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($cda6be06a107a9b2$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
};

});

parcelRegister("1OuUd", function(module, exports) {
// Process html entity - &#123;, &#xAF;, &quot;, ...
'use strict';

var $kwuCU = parcelRequire("kwuCU");

var $iKXJl = parcelRequire("iKXJl");
var $15226f2be1cb1f7a$require$has = $iKXJl.has;

var $iKXJl = parcelRequire("iKXJl");
var $15226f2be1cb1f7a$require$isValidEntityCode = $iKXJl.isValidEntityCode;

var $iKXJl = parcelRequire("iKXJl");
var $15226f2be1cb1f7a$require$fromCodePoint = $iKXJl.fromCodePoint;
var $15226f2be1cb1f7a$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
var $15226f2be1cb1f7a$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
module.exports = function entity(state, silent) {
    var ch, code, match, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        match = state.src.slice(pos).match($15226f2be1cb1f7a$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                token = state.push('text_special', '', 0);
                token.content = $15226f2be1cb1f7a$require$isValidEntityCode(code) ? $15226f2be1cb1f7a$require$fromCodePoint(code) : $15226f2be1cb1f7a$require$fromCodePoint(0xFFFD);
                token.markup = match[0];
                token.info = 'entity';
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        match = state.src.slice(pos).match($15226f2be1cb1f7a$var$NAMED_RE);
        if (match) {
            if ($15226f2be1cb1f7a$require$has($kwuCU, match[1])) {
                if (!silent) {
                    token = state.push('text_special', '', 0);
                    token.content = $kwuCU[match[1]];
                    token.markup = match[0];
                    token.info = 'entity';
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
};

});

parcelRegister("aeOLv", function(module, exports) {
// For each opening emphasis-like marker find a matching closing one
//
'use strict';
function $7742971a01535f29$var$processDelimiters(delimiters) {
    var closerIdx, openerIdx, closer, opener, minOpenerIdx, newMinOpenerIdx, isOddMatch, lastJump, openersBottom = {}, max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    var headerIdx = 0;
    var lastTokenIdx = -2; // needs any value lower than -1
    var jumps = [];
    for(closerIdx = 0; closerIdx < max; closerIdx++){
        closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        openerIdx = headerIdx - jumps[headerIdx] - 1;
        newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
module.exports = function link_pairs(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $7742971a01535f29$var$processDelimiters(state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $7742971a01535f29$var$processDelimiters(tokens_meta[curr].delimiters);
};

});

parcelRegister("4jGFu", function(module, exports) {
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
'use strict';
module.exports = function fragments_join(state) {
    var curr, last, level = 0, tokens = state.tokens, max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level--; // closing tag
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++; // opening tag
        if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
};

});

parcelRegister("1iTpN", function(module, exports) {
// Inline parser state
'use strict';

var $3coOC = parcelRequire("3coOC");

var $iKXJl = parcelRequire("iKXJl");
var $0f327524c6ab5a2a$require$isWhiteSpace = $iKXJl.isWhiteSpace;

var $iKXJl = parcelRequire("iKXJl");
var $0f327524c6ab5a2a$require$isPunctChar = $iKXJl.isPunctChar;

var $iKXJl = parcelRequire("iKXJl");
var $0f327524c6ab5a2a$require$isMdAsciiPunct = $iKXJl.isMdAsciiPunct;
function $0f327524c6ab5a2a$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = '';
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$0f327524c6ab5a2a$var$StateInline.prototype.pushPending = function() {
    var token = new $3coOC('text', '', 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = '';
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$0f327524c6ab5a2a$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    var token = new $3coOC(type, tag, nesting);
    var token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$0f327524c6ab5a2a$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    var pos = start, lastChar, nextChar, count, can_open, can_close, isLastWhiteSpace, isLastPunctChar, isNextWhiteSpace, isNextPunctChar, left_flanking = true, right_flanking = true, max = this.posMax, marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    count = pos - start;
    // treat end of the line as a whitespace
    nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    isLastPunctChar = $0f327524c6ab5a2a$require$isMdAsciiPunct(lastChar) || $0f327524c6ab5a2a$require$isPunctChar(String.fromCharCode(lastChar));
    isNextPunctChar = $0f327524c6ab5a2a$require$isMdAsciiPunct(nextChar) || $0f327524c6ab5a2a$require$isPunctChar(String.fromCharCode(nextChar));
    isLastWhiteSpace = $0f327524c6ab5a2a$require$isWhiteSpace(lastChar);
    isNextWhiteSpace = $0f327524c6ab5a2a$require$isWhiteSpace(nextChar);
    if (isNextWhiteSpace) left_flanking = false;
    else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) left_flanking = false;
    }
    if (isLastWhiteSpace) right_flanking = false;
    else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) right_flanking = false;
    }
    if (!canSplitWord) {
        can_open = left_flanking && (!right_flanking || isLastPunctChar);
        can_close = right_flanking && (!left_flanking || isNextPunctChar);
    } else {
        can_open = left_flanking;
        can_close = right_flanking;
    }
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$0f327524c6ab5a2a$var$StateInline.prototype.Token = $3coOC;
module.exports = $0f327524c6ab5a2a$var$StateInline;

});


parcelRegister("eD8sl", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $aa6b4473a4760636$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $aa6b4473a4760636$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $aa6b4473a4760636$var$isString(obj) {
    return $aa6b4473a4760636$var$_class(obj) === '[object String]';
}
function $aa6b4473a4760636$var$isObject(obj) {
    return $aa6b4473a4760636$var$_class(obj) === '[object Object]';
}
function $aa6b4473a4760636$var$isRegExp(obj) {
    return $aa6b4473a4760636$var$_class(obj) === '[object RegExp]';
}
function $aa6b4473a4760636$var$isFunction(obj) {
    return $aa6b4473a4760636$var$_class(obj) === '[object Function]';
}
function $aa6b4473a4760636$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $aa6b4473a4760636$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $aa6b4473a4760636$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $aa6b4473a4760636$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $aa6b4473a4760636$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $aa6b4473a4760636$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $aa6b4473a4760636$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $aa6b4473a4760636$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $aa6b4473a4760636$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $aa6b4473a4760636$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $aa6b4473a4760636$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("ajoX5"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($aa6b4473a4760636$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($aa6b4473a4760636$var$isObject(val)) {
            if ($aa6b4473a4760636$var$isRegExp(val.validate)) compiled.validate = $aa6b4473a4760636$var$createValidator(val.validate);
            else if ($aa6b4473a4760636$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($aa6b4473a4760636$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $aa6b4473a4760636$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($aa6b4473a4760636$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $aa6b4473a4760636$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($aa6b4473a4760636$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.schema_at_start = RegExp('^' + self.re.schema_search.source, 'i');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $aa6b4473a4760636$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $aa6b4473a4760636$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $aa6b4473a4760636$var$createMatch(self, shift) {
    var match = new $aa6b4473a4760636$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $aa6b4473a4760636$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $aa6b4473a4760636$var$LinkifyIt)) return new $aa6b4473a4760636$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($aa6b4473a4760636$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $aa6b4473a4760636$var$assign({}, $aa6b4473a4760636$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $aa6b4473a4760636$var$assign({}, $aa6b4473a4760636$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $aa6b4473a4760636$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $aa6b4473a4760636$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $aa6b4473a4760636$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $aa6b4473a4760636$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $aa6b4473a4760636$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $aa6b4473a4760636$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $aa6b4473a4760636$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $aa6b4473a4760636$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $aa6b4473a4760636$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $aa6b4473a4760636$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($aa6b4473a4760636$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($aa6b4473a4760636$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $aa6b4473a4760636$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    var m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    var len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $aa6b4473a4760636$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $aa6b4473a4760636$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $aa6b4473a4760636$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $aa6b4473a4760636$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $aa6b4473a4760636$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $aa6b4473a4760636$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $aa6b4473a4760636$var$LinkifyIt;

});
parcelRegister("ajoX5", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    opts = opts || {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("cESS3")).source;
    re.src_Cc = (parcelRequire("1ladB")).source;
    re.src_Z = (parcelRequire("aKpnB")).source;
    re.src_P = (parcelRequire("9R3PW")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')' + '(?!' + (opts['---'] ? '-(?!--)|' : '-|') + '_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-])|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]|$)|' + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + '|$)|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + '|$)|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]|$)|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]|$)' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});


parcelRegister("2yQCr", function(module, exports) {
$parcel$export(module.exports, "toUnicode", function () { return $1dd792ce46503ff1$export$110c810e8727e62b; });
$parcel$export(module.exports, "toASCII", function () { return $1dd792ce46503ff1$export$69111c4ea6e0c4a0; });
'use strict';
/** Highest positive signed 32-bit float value */ const $1dd792ce46503ff1$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $1dd792ce46503ff1$var$base = 36;
const $1dd792ce46503ff1$var$tMin = 1;
const $1dd792ce46503ff1$var$tMax = 26;
const $1dd792ce46503ff1$var$skew = 38;
const $1dd792ce46503ff1$var$damp = 700;
const $1dd792ce46503ff1$var$initialBias = 72;
const $1dd792ce46503ff1$var$initialN = 128; // 0x80
const $1dd792ce46503ff1$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $1dd792ce46503ff1$var$regexPunycode = /^xn--/;
const $1dd792ce46503ff1$var$regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const $1dd792ce46503ff1$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $1dd792ce46503ff1$var$errors = {
    'overflow': 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
/** Convenience shortcuts */ const $1dd792ce46503ff1$var$baseMinusTMin = $1dd792ce46503ff1$var$base - $1dd792ce46503ff1$var$tMin;
const $1dd792ce46503ff1$var$floor = Math.floor;
const $1dd792ce46503ff1$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $1dd792ce46503ff1$var$error(type) {
    throw new RangeError($1dd792ce46503ff1$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $1dd792ce46503ff1$var$map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function $1dd792ce46503ff1$var$mapDomain(domain, callback) {
    const parts = domain.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace($1dd792ce46503ff1$var$regexSeparators, '\x2E');
    const labels = domain.split('.');
    const encoded = $1dd792ce46503ff1$var$map(labels, callback).join('.');
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $1dd792ce46503ff1$export$c1700176c90f250f(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $1dd792ce46503ff1$export$f999239d9b149395 = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $1dd792ce46503ff1$var$basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return $1dd792ce46503ff1$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $1dd792ce46503ff1$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $1dd792ce46503ff1$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $1dd792ce46503ff1$var$floor(delta / $1dd792ce46503ff1$var$damp) : delta >> 1;
    delta += $1dd792ce46503ff1$var$floor(delta / numPoints);
    for(; delta > $1dd792ce46503ff1$var$baseMinusTMin * $1dd792ce46503ff1$var$tMax >> 1; k += $1dd792ce46503ff1$var$base)delta = $1dd792ce46503ff1$var$floor(delta / $1dd792ce46503ff1$var$baseMinusTMin);
    return $1dd792ce46503ff1$var$floor(k + ($1dd792ce46503ff1$var$baseMinusTMin + 1) * delta / (delta + $1dd792ce46503ff1$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $1dd792ce46503ff1$export$2f872c0f2117be69 = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $1dd792ce46503ff1$var$initialN;
    let bias = $1dd792ce46503ff1$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($1dd792ce46503ff1$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $1dd792ce46503ff1$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = $1dd792ce46503ff1$var$base;; k += $1dd792ce46503ff1$var$base){
            if (index >= inputLength) $1dd792ce46503ff1$var$error('invalid-input');
            const digit = $1dd792ce46503ff1$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $1dd792ce46503ff1$var$base) $1dd792ce46503ff1$var$error('invalid-input');
            if (digit > $1dd792ce46503ff1$var$floor(($1dd792ce46503ff1$var$maxInt - i) / w)) $1dd792ce46503ff1$var$error('overflow');
            i += digit * w;
            const t = k <= bias ? $1dd792ce46503ff1$var$tMin : k >= bias + $1dd792ce46503ff1$var$tMax ? $1dd792ce46503ff1$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $1dd792ce46503ff1$var$base - t;
            if (w > $1dd792ce46503ff1$var$floor($1dd792ce46503ff1$var$maxInt / baseMinusT)) $1dd792ce46503ff1$var$error('overflow');
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $1dd792ce46503ff1$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($1dd792ce46503ff1$var$floor(i / out) > $1dd792ce46503ff1$var$maxInt - n) $1dd792ce46503ff1$var$error('overflow');
        n += $1dd792ce46503ff1$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $1dd792ce46503ff1$export$c564cdbbe6da493 = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $1dd792ce46503ff1$export$c1700176c90f250f(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = $1dd792ce46503ff1$var$initialN;
    let delta = 0;
    let bias = $1dd792ce46503ff1$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($1dd792ce46503ff1$var$stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($1dd792ce46503ff1$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $1dd792ce46503ff1$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $1dd792ce46503ff1$var$floor(($1dd792ce46503ff1$var$maxInt - delta) / handledCPCountPlusOne)) $1dd792ce46503ff1$var$error('overflow');
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $1dd792ce46503ff1$var$maxInt) $1dd792ce46503ff1$var$error('overflow');
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $1dd792ce46503ff1$var$base;; k += $1dd792ce46503ff1$var$base){
                    const t = k <= bias ? $1dd792ce46503ff1$var$tMin : k >= bias + $1dd792ce46503ff1$var$tMax ? $1dd792ce46503ff1$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $1dd792ce46503ff1$var$base - t;
                    output.push($1dd792ce46503ff1$var$stringFromCharCode($1dd792ce46503ff1$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $1dd792ce46503ff1$var$floor(qMinusT / baseMinusT);
                }
                output.push($1dd792ce46503ff1$var$stringFromCharCode($1dd792ce46503ff1$var$digitToBasic(q, 0)));
                bias = $1dd792ce46503ff1$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join('');
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $1dd792ce46503ff1$export$110c810e8727e62b = function(input) {
    return $1dd792ce46503ff1$var$mapDomain(input, function(string) {
        return $1dd792ce46503ff1$var$regexPunycode.test(string) ? $1dd792ce46503ff1$export$2f872c0f2117be69(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $1dd792ce46503ff1$export$69111c4ea6e0c4a0 = function(input) {
    return $1dd792ce46503ff1$var$mapDomain(input, function(string) {
        return $1dd792ce46503ff1$var$regexNonASCII.test(string) ? 'xn--' + $1dd792ce46503ff1$export$c564cdbbe6da493(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $1dd792ce46503ff1$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ 'version': '2.3.1',
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ 'ucs2': {
        'decode': $1dd792ce46503ff1$export$c1700176c90f250f,
        'encode': $1dd792ce46503ff1$export$f999239d9b149395
    },
    'decode': $1dd792ce46503ff1$export$2f872c0f2117be69,
    'encode': $1dd792ce46503ff1$export$c564cdbbe6da493,
    'toASCII': $1dd792ce46503ff1$export$69111c4ea6e0c4a0,
    'toUnicode': $1dd792ce46503ff1$export$110c810e8727e62b
};
var $1dd792ce46503ff1$export$2e2bcd8739ae039 = $1dd792ce46503ff1$var$punycode;

});

parcelRegister("49x3M", function(module, exports) {
// markdown-it default options
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 100 // Internal protection, recursion limit
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRegister("7OSSd", function(module, exports) {
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'text'
            ],
            rules2: [
                'balance_pairs',
                'fragments_join'
            ]
        }
    }
};

});

parcelRegister("fpgSy", function(module, exports) {
// Commonmark default options
'use strict';
module.exports = {
    options: {
        html: true,
        xhtmlOut: true,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'blockquote',
                'code',
                'fence',
                'heading',
                'hr',
                'html_block',
                'lheading',
                'list',
                'reference',
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'autolink',
                'backticks',
                'emphasis',
                'entity',
                'escape',
                'html_inline',
                'image',
                'link',
                'newline',
                'text'
            ],
            rules2: [
                'balance_pairs',
                'emphasis',
                'fragments_join'
            ]
        }
    }
};

});



parcelRegister("8DNPl", function(module, exports) {
$parcel$export(module.exports, "markdownItTable", function () { return $64a89dddf0ec0648$export$26a6b72a65821214; });

var $V4BUS = parcelRequire("V4BUS");
var $64a89dddf0ec0648$export$26a6b72a65821214 = function markdownItTable(md, options) {
    md.block.ruler.before('paragraph', 'table', (0, (/*@__PURE__*/$parcel$interopDefault($V4BUS))), {
        alt: [
            'paragraph',
            'reference'
        ]
    });
};

});
parcelRegister("V4BUS", function(module, exports) {
// Copied from https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/table.js
function $0ab8e68bcf9107a9$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
function $0ab8e68bcf9107a9$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.blkIndent, max = state.eMarks[line];
    return state.src.substr(pos, max - pos);
}
function $0ab8e68bcf9107a9$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, escapes = 0, lastPos = 0, backTicked = false, lastBackTick = 0;
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x60 /* ` */ ) {
            if (backTicked) {
                // make \` close code sequence, but not open it;
                // the reason is: `\` is correct code block
                backTicked = false;
                lastBackTick = pos;
            } else if (escapes % 2 === 0) {
                backTicked = true;
                lastBackTick = pos;
            }
        } else if (ch === 0x7c /* | */  && escapes % 2 === 0 && !backTicked) {
            result.push(str.substring(lastPos, pos));
            lastPos = pos + 1;
        }
        if (ch === 0x5c /* \ */ ) escapes++;
        else escapes = 0;
        pos++;
        // If there was an un-closed backtick, go back to just after
        // the last backtick, but as if it was a normal character
        if (pos === max && backTicked) {
            backTicked = false;
            pos = lastBackTick + 1;
        }
        ch = str.charCodeAt(pos);
    }
    result.push(str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    ch = state.src.charCodeAt(pos++);
    if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */ ) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */  && !$0ab8e68bcf9107a9$var$isSpace(ch)) return false;
        pos++;
    }
    lineText = $0ab8e68bcf9107a9$var$getLine(state, startLine + 1);
    columns = lineText.split('|');
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3a /* : */ ) aligns.push(t.charCodeAt(0) === 0x3a /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3a /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $0ab8e68bcf9107a9$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $0ab8e68bcf9107a9$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
    // header row will define an amount of columns in the entire table,
    // and align row shouldn't be smaller than that (the rest of the rows can)
    columnCount = columns.length;
    if (columnCount > aligns.length) return false;
    if (silent) return true;
    token = state.push('table_open', 'table', 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    // token     = state.push('thead_open', 'thead', 1);
    // token.map = [ startLine, startLine + 1 ];
    token = state.push('tr_open', 'tr', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push('th_open', 'th', 1);
        token.map = [
            startLine,
            startLine + 1
        ];
        if (aligns[i]) token.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        token = state.push('paragraph_open', 'p', 1);
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.map = [
            startLine,
            startLine + 1
        ];
        token.children = [];
        token = state.push('paragraph_close', 'p', -1);
        token = state.push('th_close', 'th', -1);
    }
    token = state.push('tr_close', 'tr', -1);
    // token     = state.push('thead_close', 'thead', -1);
    // token     = state.push('tbody_open', 'tbody', 1);
    token.map = tbodyLines = [
        startLine + 2,
        0
    ];
    var oldLineMax = state.lineMax;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        lineText = $0ab8e68bcf9107a9$var$getLine(state, nextLine).trim();
        if (lineText.indexOf('|') === -1) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $0ab8e68bcf9107a9$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
        token = state.push('tr_open', 'tr', 1);
        for(var _i = 0, offset = 1; _i < columns.length; _i++){
            token = state.push('td_open', 'td', 1);
            if (aligns[_i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[_i]
                ]
            ];
            // https://github.com/markdown-it/markdown-it/blob/e6f19eab4204122e85e4a342e0c1c8486ff40c2d/lib/rules_block/state_block.js#L25
            // bMarks => line begin offsets for fast jumps
            // eMarks => line end offsets for fast jumps
            // tShift => offsets of the first non-space characters (tabs not expanded)
            // sCount => indents for each line (tabs expanded)
            // Move bMarks when first char is ' ' for > to work
            var shift = columns[_i][0] === ' ' || /^(\d+\.|\*|-)$/.test(columns[_i].trim()) ? 1 : 0;
            state.bMarks[nextLine] += offset + shift;
            offset = (columns[_i] || '').length + (shift ? 0 : 1);
            state.eMarks[nextLine] = state.bMarks[nextLine] + offset - 1;
            state.lineMax = 1;
            state.md.block.tokenize(state, nextLine, nextLine + 1);
            token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
    }
    // token = state.push('tbody_close', 'tbody', -1);
    state.lineMax = oldLineMax;
    token = state.push('table_close', 'table', -1);
    tableLines[1] = tbodyLines[1] = nextLine;
    state.line = nextLine;
    return true;
};

});


parcelRegister("2CJiD", function(module, exports) {
$parcel$export(module.exports, "MarkdownTransformer", function () { return $1e9244ea0a7c6336$export$267fd7ead7cc4561; });

var $eVBqw = parcelRequire("eVBqw");

var $aHrBh = parcelRequire("aHrBh");

var $3Oe51 = parcelRequire("3Oe51");

var $b60TI = parcelRequire("b60TI");

var $8DNPl = parcelRequire("8DNPl");

var $2S3V5 = parcelRequire("2S3V5");

var $cl834 = parcelRequire("cl834");
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $1e9244ea0a7c6336$var$filterMdToPmSchemaMapping(schema, map) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(map).reduce(function(newMap, key) {
        var value = map[key];
        var block = value.block || value.node;
        var mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
}
var $1e9244ea0a7c6336$var$pmSchemaToMdMapping = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
var $1e9244ea0a7c6336$var$mdToPmMapping = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: function attrs(tok) {
            return {
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            };
        }
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: function attrs(tok) {
            return {
                level: +tok.tag.slice(1)
            };
        }
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    ordered_list: {
        block: 'orderedList',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: function attrs(tok) {
            return {
                order: typeof tok.attrGet('start') === 'number' ? tok.attrGet('start') : 1
            };
        }
    },
    code_inline: {
        mark: 'code'
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: function attrs(tok) {
            return {
                language: tok.info && tok.info.trim() || null
            };
        }
    },
    media_single: {
        block: 'mediaSingle',
        attrs: function attrs() {
            return {};
        }
    },
    media: {
        node: 'media',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: function attrs(tok) {
            return {
                url: tok.attrGet('url'),
                alt: tok.attrGet('alt'),
                type: 'external'
            };
        }
    },
    emoji: {
        node: 'emoji',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: function attrs(tok) {
            return {
                shortName: ":".concat(tok.markup, ":"),
                text: tok.content
            };
        }
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: function attrs(tok) {
            return {
                state: tok.meta
            };
        }
    }
};
var $1e9244ea0a7c6336$var$md = (0, (/*@__PURE__*/$parcel$interopDefault($b60TI)))('zero', {
    html: false
});
$1e9244ea0a7c6336$var$md.enable([
    // Process html entity - &#123;, &#xAF;, &quot;, ...
    'entity',
    // Process escaped chars and hardbreaks
    'escape'
]);
var $1e9244ea0a7c6336$export$267fd7ead7cc4561 = /*#__PURE__*/ function() {
    function MarkdownTransformer() {
        var schema = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $3Oe51.defaultSchema);
        var tokenizer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $1e9244ea0a7c6336$var$md;
        (0, $eVBqw.default)(this, MarkdownTransformer);
        // Enable markdown plugins based on schema
        [
            'nodes',
            'marks'
        ].forEach(function(key) {
            for(var idx in $1e9244ea0a7c6336$var$pmSchemaToMdMapping[key])if (schema[key][idx]) tokenizer.enable($1e9244ea0a7c6336$var$pmSchemaToMdMapping[key][idx]);
        });
        if (schema.nodes.table) tokenizer.use((0, $8DNPl.markdownItTable));
        if (schema.nodes.media && schema.nodes.mediaSingle) tokenizer.use((0, $cl834.markdownItMedia));
        this.markdownParser = new (0, $2S3V5.MarkdownParser)(schema, tokenizer, $1e9244ea0a7c6336$var$filterMdToPmSchemaMapping(schema, $1e9244ea0a7c6336$var$mdToPmMapping));
    }
    return (0, $aHrBh.default)(MarkdownTransformer, [
        {
            key: "encode",
            value: function encode(_node) {
                throw new Error('This is not implemented yet');
            }
        },
        {
            key: "parse",
            value: function parse(content) {
                return this.markdownParser.parse(content);
            }
        }
    ]);
}();

});
parcelRegister("3Oe51", function(module, exports) {
$parcel$export(module.exports, "defaultSchema", function () { return $2c60f6a0499aab60$export$1db618b7b2275ea1; });

var $dWJ7u = parcelRequire("dWJ7u");

var $9xf1B = parcelRequire("9xf1B");
var $3054C = parcelRequire("3054C");
var $ksaMs = parcelRequire("ksaMs");
var $apXau = parcelRequire("apXau");
var $hrTcF = parcelRequire("hrTcF");
var $3FYQW = parcelRequire("3FYQW");

var $5Lxm0 = parcelRequire("5Lxm0");
var $2c60f6a0499aab60$var$getDefaultSchemaConfig = function getDefaultSchemaConfig() {
    var defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'blockTaskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
var $2c60f6a0499aab60$export$e4e3ac1fa64862db = $2c60f6a0499aab60$var$getDefaultSchemaConfig();
var $2c60f6a0499aab60$export$fd147e7d448dea03 = (0, $dWJ7u.default)(function() {
    var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'final';
    var defaultSchemaConfig = $2c60f6a0499aab60$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $ksaMs.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $3054C.multiBodiedExtension),
        extensionFrame: (0, $3054C.extensionFrame),
        expand: (0, $9xf1B.expandWithNestedExpand),
        listItem: (0, $apXau.listItemWithDecisionStage0),
        table: (0, $3FYQW.tableWithNestedTable),
        tableRow: (0, $3FYQW.tableRowWithNestedTable),
        tableCell: (0, $3FYQW.tableCellWithNestedTable),
        tableHeader: (0, $3FYQW.tableHeaderWithNestedTable),
        syncBlock: (0, $hrTcF.syncBlock)
    };
    return (0, $5Lxm0.createSchema)(defaultSchemaConfig);
});
var $2c60f6a0499aab60$export$1db618b7b2275ea1 = $2c60f6a0499aab60$export$fd147e7d448dea03();

});
parcelRegister("9xf1B", function(module, exports) {
$parcel$export(module.exports, "expandWithNestedExpand", function () { return $6f12d9bf1a28622e$export$7b80cba28d10b2c1; });

var $1YMOy = parcelRequire("1YMOy");

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
function $6f12d9bf1a28622e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6f12d9bf1a28622e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6f12d9bf1a28622e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6f12d9bf1a28622e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_root_only_node
 */ function $6f12d9bf1a28622e$var$getExpandAttrs(domNode) {
    var dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
var $6f12d9bf1a28622e$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $6f12d9bf1a28622e$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $6f12d9bf1a28622e$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $6f12d9bf1a28622e$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $6f12d9bf1a28622e$var$getExpandAttrs
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
var $6f12d9bf1a28622e$export$7b80cba28d10b2c1 = (0, $35i9Y.expand)($6f12d9bf1a28622e$var$nodeSpecOptions);
var $6f12d9bf1a28622e$export$2ae5e7565ff9ffa6 = (0, $35i9Y.expand)({
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $6f12d9bf1a28622e$var$getExpandAttrs(dom);
                return $6f12d9bf1a28622e$var$_objectSpread($6f12d9bf1a28622e$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $dS3bo.uuid).generate()
                });
            }
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $6f12d9bf1a28622e$var$getExpandAttrs(dom);
                return $6f12d9bf1a28622e$var$_objectSpread($6f12d9bf1a28622e$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $dS3bo.uuid).generate()
                });
            }
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $6f12d9bf1a28622e$var$getExpandAttrs(dom);
                return $6f12d9bf1a28622e$var$_objectSpread($6f12d9bf1a28622e$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $dS3bo.uuid).generate()
                });
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: function getAttrs(dom) {
                var attrs = $6f12d9bf1a28622e$var$getExpandAttrs(dom);
                return $6f12d9bf1a28622e$var$_objectSpread($6f12d9bf1a28622e$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $dS3bo.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $6f12d9bf1a28622e$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return !key.startsWith('__');
        }).reduce(function(obj, key) {
            return $6f12d9bf1a28622e$var$_objectSpread($6f12d9bf1a28622e$var$_objectSpread({}, obj), {}, (0, $1YMOy.default)({}, key, node.attrs[key]));
        }, {})
    };
};

});
parcelRegister("1YMOy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $17114290c3c2ce63$export$2e2bcd8739ae039; });

var $gNNM1 = parcelRequire("gNNM1");
function $17114290c3c2ce63$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $gNNM1.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("gNNM1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c3b7d4eb62afc6d0$export$2e2bcd8739ae039; });

var $cRu6R = parcelRequire("cRu6R");

var $kpKm5 = parcelRequire("kpKm5");
function $c3b7d4eb62afc6d0$export$2e2bcd8739ae039(t) {
    var i = (0, $kpKm5.default)(t, "string");
    return "symbol" == (0, $cRu6R.default)(i) ? i : i + "";
}

});
parcelRegister("cRu6R", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $95d1ca6ae7d094db$export$2e2bcd8739ae039; });
function $95d1ca6ae7d094db$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $95d1ca6ae7d094db$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $95d1ca6ae7d094db$export$2e2bcd8739ae039(o);
}

});

parcelRegister("kpKm5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $edca199bb1be9b55$export$2e2bcd8739ae039; });

var $cRu6R = parcelRequire("cRu6R");
function $edca199bb1be9b55$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $cRu6R.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $cRu6R.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("35i9Y", function(module, exports) {
$parcel$export(module.exports, "blockCard", function () { return $23efece627ba86e3$export$c4c2f833baaebdb8; });
$parcel$export(module.exports, "blockquote", function () { return $23efece627ba86e3$export$67dc04e652a298ca; });
$parcel$export(module.exports, "blockquoteLegacy", function () { return $23efece627ba86e3$export$199922e5af8e9a6; });
$parcel$export(module.exports, "blockTaskItem", function () { return $23efece627ba86e3$export$16018c61064a18df; });
$parcel$export(module.exports, "bodiedExtension", function () { return $23efece627ba86e3$export$27903d543b563e39; });
$parcel$export(module.exports, "bulletList", function () { return $23efece627ba86e3$export$a140c94e5ea26bee; });
$parcel$export(module.exports, "caption", function () { return $23efece627ba86e3$export$8e3c2dfdc4f0453d; });
$parcel$export(module.exports, "codeBlock", function () { return $23efece627ba86e3$export$7bb0d5c671655cc4; });
$parcel$export(module.exports, "confluenceJiraIssue", function () { return $23efece627ba86e3$export$daf889beb5092f95; });
$parcel$export(module.exports, "confluenceUnsupportedBlock", function () { return $23efece627ba86e3$export$e6e4878f43c27cab; });
$parcel$export(module.exports, "confluenceUnsupportedInline", function () { return $23efece627ba86e3$export$3e6d667072febc87; });
$parcel$export(module.exports, "date", function () { return $23efece627ba86e3$export$324d90190a8b822a; });
$parcel$export(module.exports, "decisionItem", function () { return $23efece627ba86e3$export$6959e16eeff859b4; });
$parcel$export(module.exports, "decisionList", function () { return $23efece627ba86e3$export$62d45a65fb43d95e; });
$parcel$export(module.exports, "doc", function () { return $23efece627ba86e3$export$2a111da947c407d2; });
$parcel$export(module.exports, "embedCard", function () { return $23efece627ba86e3$export$be4283d9a1cb1ff6; });
$parcel$export(module.exports, "emoji", function () { return $23efece627ba86e3$export$a19185d1233fc4b2; });
$parcel$export(module.exports, "expand", function () { return $23efece627ba86e3$export$9f77e0932fb78f72; });
$parcel$export(module.exports, "extension", function () { return $23efece627ba86e3$export$1b45514b112dd749; });
$parcel$export(module.exports, "extensionFrameStage0", function () { return $23efece627ba86e3$export$b555be60c7703afb; });
$parcel$export(module.exports, "hardBreak", function () { return $23efece627ba86e3$export$371da9dd35aba193; });
$parcel$export(module.exports, "heading", function () { return $23efece627ba86e3$export$46e4a324ac90507f; });
$parcel$export(module.exports, "image", function () { return $23efece627ba86e3$export$5c452ff88e35e47d; });
$parcel$export(module.exports, "inlineCard", function () { return $23efece627ba86e3$export$cbf8224b64e0d942; });
$parcel$export(module.exports, "inlineExtensionWithMarks", function () { return $23efece627ba86e3$export$b3b1e36c2105006d; });
$parcel$export(module.exports, "layoutColumn", function () { return $23efece627ba86e3$export$ab76e7c03cd6f650; });
$parcel$export(module.exports, "layoutSection", function () { return $23efece627ba86e3$export$b3b6a70a7fa4a5be; });
$parcel$export(module.exports, "layoutSectionFull", function () { return $23efece627ba86e3$export$cdae19acb0a520fd; });
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", function () { return $23efece627ba86e3$export$206007566ca0aca5; });
$parcel$export(module.exports, "listItem", function () { return $23efece627ba86e3$export$76c7e83ecc9cdf05; });
$parcel$export(module.exports, "listItemWithNestedDecisionStage0", function () { return $23efece627ba86e3$export$df876f0305235056; });
$parcel$export(module.exports, "media", function () { return $23efece627ba86e3$export$987d49ffe1b0900f; });
$parcel$export(module.exports, "mediaGroup", function () { return $23efece627ba86e3$export$2855e964765eac9; });
$parcel$export(module.exports, "mediaInline", function () { return $23efece627ba86e3$export$38bab695e3f720f1; });
$parcel$export(module.exports, "mediaSingle", function () { return $23efece627ba86e3$export$969fe3781ca15058; });
$parcel$export(module.exports, "mediaSingleCaption", function () { return $23efece627ba86e3$export$8d067f22dc2d1254; });
$parcel$export(module.exports, "mediaSingleFull", function () { return $23efece627ba86e3$export$7e767666f2ce108a; });
$parcel$export(module.exports, "mediaSingleWidthType", function () { return $23efece627ba86e3$export$4bd9a38995f6bf50; });
$parcel$export(module.exports, "mention", function () { return $23efece627ba86e3$export$db83999c14438df4; });
$parcel$export(module.exports, "multiBodiedExtensionStage0", function () { return $23efece627ba86e3$export$750e45819f66d9d0; });
$parcel$export(module.exports, "nestedExpand", function () { return $23efece627ba86e3$export$63cadbf5f4296627; });
$parcel$export(module.exports, "orderedList", function () { return $23efece627ba86e3$export$a5dc81035676e7a; });
$parcel$export(module.exports, "panel", function () { return $23efece627ba86e3$export$21f42ab9b6679f44; });
$parcel$export(module.exports, "paragraph", function () { return $23efece627ba86e3$export$9c206ddddb32a9b; });
$parcel$export(module.exports, "placeholder", function () { return $23efece627ba86e3$export$c7187bbd1a7a9244; });
$parcel$export(module.exports, "rule", function () { return $23efece627ba86e3$export$fbeb3a3956e8a3c7; });
$parcel$export(module.exports, "status", function () { return $23efece627ba86e3$export$471f7ae5c4103ae1; });
$parcel$export(module.exports, "syncBlockStage0", function () { return $23efece627ba86e3$export$3782866d5d058412; });
$parcel$export(module.exports, "table", function () { return $23efece627ba86e3$export$9852986a3ec5f6a0; });
$parcel$export(module.exports, "tableWithNestedTable", function () { return $23efece627ba86e3$export$ce086a560a1d05f5; });
$parcel$export(module.exports, "tableCell", function () { return $23efece627ba86e3$export$e1e720e5f4603e6a; });
$parcel$export(module.exports, "tableCellWithNestedTable", function () { return $23efece627ba86e3$export$abf39ca178940ff3; });
$parcel$export(module.exports, "tableHeader", function () { return $23efece627ba86e3$export$48884d2a5190dc73; });
$parcel$export(module.exports, "tableHeaderWithNestedTable", function () { return $23efece627ba86e3$export$2a5a518232fa1a97; });
$parcel$export(module.exports, "tableRow", function () { return $23efece627ba86e3$export$ce666bf02318c957; });
$parcel$export(module.exports, "tableRowWithNestedTable", function () { return $23efece627ba86e3$export$7d657479499397; });
$parcel$export(module.exports, "taskItem", function () { return $23efece627ba86e3$export$6d8b0ef52e2e6390; });
$parcel$export(module.exports, "taskList", function () { return $23efece627ba86e3$export$375b6afcc5f4d291; });
$parcel$export(module.exports, "text", function () { return $23efece627ba86e3$export$6f093cfa640b7166; });
$parcel$export(module.exports, "unsupportedBlock", function () { return $23efece627ba86e3$export$44b79b0979d0f0f7; });
$parcel$export(module.exports, "unsupportedInline", function () { return $23efece627ba86e3$export$310ebe0d80122e9b; });
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $31mbR = parcelRequire("31mbR");
var $23efece627ba86e3$export$c4c2f833baaebdb8 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        },
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $23efece627ba86e3$export$67dc04e652a298ca = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
var $23efece627ba86e3$export$199922e5af8e9a6 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
var $23efece627ba86e3$export$16018c61064a18df = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | extension) (paragraph | extension)*',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
var $23efece627ba86e3$export$27903d543b563e39 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $23efece627ba86e3$export$e7320d153c538837 = (0, $31mbR.createPMNodeSpecFactory)({
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $23efece627ba86e3$export$a140c94e5ea26bee = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $23efece627ba86e3$export$8e3c2dfdc4f0453d = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
var $23efece627ba86e3$export$7bb0d5c671655cc4 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        }
    },
    code: true,
    defining: true
});
var $23efece627ba86e3$export$e4f1c66d84049f8b = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        }
    },
    code: true,
    defining: true
});
var $23efece627ba86e3$export$daf889beb5092f95 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
var $23efece627ba86e3$export$e6e4878f43c27cab = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $23efece627ba86e3$export$3e6d667072febc87 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $23efece627ba86e3$export$324d90190a8b822a = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$47988d68fe575725 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$6959e16eeff859b4 = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
var $23efece627ba86e3$export$62d45a65fb43d95e = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
var $23efece627ba86e3$export$2a111da947c407d2 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(block | codeBlock | layoutSection | blockRootOnly | expand | syncBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout'
});
var $23efece627ba86e3$export$be4283d9a1cb1ff6 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$a19185d1233fc4b2 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$f5574b5d45fc2112 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$9f77e0932fb78f72 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $23efece627ba86e3$export$7e3788972005cc72 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $23efece627ba86e3$export$1b45514b112dd749 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$a8baf338431a691 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$b555be60c7703afb = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
var $23efece627ba86e3$export$371da9dd35aba193 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    linebreakReplacement: true
});
var $23efece627ba86e3$export$46e4a324ac90507f = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $23efece627ba86e3$export$1b0c1557b234fa00 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $23efece627ba86e3$export$85461f751c457cc2 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $23efece627ba86e3$export$2b380a0f7e250af1 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $23efece627ba86e3$export$5c452ff88e35e47d = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
var $23efece627ba86e3$export$cbf8224b64e0d942 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $23efece627ba86e3$export$2f4e72b9459914ad = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $23efece627ba86e3$export$16b353b2649bd8d9 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$b3b1e36c2105006d = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$ab76e7c03cd6f650 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
var $23efece627ba86e3$export$b3b6a70a7fa4a5be = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
var $23efece627ba86e3$export$cdae19acb0a520fd = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
var $23efece627ba86e3$export$206007566ca0aca5 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        },
        localId: {
            default: null
        }
    },
    isolating: true
});
var $23efece627ba86e3$export$76c7e83ecc9cdf05 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)*',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $23efece627ba86e3$export$df876f0305235056 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension)*',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $23efece627ba86e3$export$987d49ffe1b0900f = (0, $31mbR.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$2855e964765eac9 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
var $23efece627ba86e3$export$38bab695e3f720f1 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$969fe3781ca15058 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
var $23efece627ba86e3$export$8d067f22dc2d1254 = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$7e767666f2ce108a = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$4bd9a38995f6bf50 = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$db83999c14438df4 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$46f790bd65f760d0 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$750e45819f66d9d0 = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
var $23efece627ba86e3$export$63cadbf5f4296627 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $23efece627ba86e3$export$f03786aa6312d1e4 = (0, $31mbR.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
var $23efece627ba86e3$export$a5dc81035676e7a = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
var $23efece627ba86e3$export$21f42ab9b6679f44 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$9c206ddddb32a9b = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $23efece627ba86e3$export$4f98472e6dc14293 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $23efece627ba86e3$export$ea332b61641b0588 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $23efece627ba86e3$export$a1f41dc4901771f8 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $23efece627ba86e3$export$c7187bbd1a7a9244 = (0, $31mbR.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
var $23efece627ba86e3$export$fbeb3a3956e8a3c7 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    }
});
var $23efece627ba86e3$export$471f7ae5c4103ae1 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$b6ce52be8d7a261 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$3782866d5d058412 = (0, $31mbR.createPMNodeSpecFactory)({
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$9852986a3ec5f6a0 = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
var $23efece627ba86e3$export$ce086a560a1d05f5 = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
var $23efece627ba86e3$export$e1e720e5f4603e6a = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
var $23efece627ba86e3$export$abf39ca178940ff3 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
var $23efece627ba86e3$export$48884d2a5190dc73 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
var $23efece627ba86e3$export$2a5a518232fa1a97 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
var $23efece627ba86e3$export$ce666bf02318c957 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
var $23efece627ba86e3$export$7d657479499397 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
var $23efece627ba86e3$export$6d8b0ef52e2e6390 = (0, $31mbR.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
var $23efece627ba86e3$export$375b6afcc5f4d291 = (0, $31mbR.createPMNodeSpecFactory)({
    content: '(taskItem | unsupportedBlock | blockTaskItem)+ (taskItem | taskList | unsupportedBlock | blockTaskItem)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
var $23efece627ba86e3$export$6f093cfa640b7166 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline'
});
var $23efece627ba86e3$export$5ea06bc686c59dc2 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline'
});
var $23efece627ba86e3$export$93256a4c17b33a82 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline'
});
var $23efece627ba86e3$export$a12828d0f14a2762 = (0, $31mbR.createPMNodeSpecFactory)({});
var $23efece627ba86e3$export$44b79b0979d0f0f7 = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
var $23efece627ba86e3$export$310ebe0d80122e9b = (0, $31mbR.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("31mbR", function(module, exports) {
$parcel$export(module.exports, "createPMNodeSpecFactory", function () { return $2332ada103068f8a$export$bf0a80f00e2b8ff6; });
$parcel$export(module.exports, "createPMMarkSpecFactory", function () { return $2332ada103068f8a$export$cf5823ed4e9f4c6f; });

var $1YMOy = parcelRequire("1YMOy");
function $2332ada103068f8a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2332ada103068f8a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2332ada103068f8a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2332ada103068f8a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2332ada103068f8a$export$bf0a80f00e2b8ff6 = function createPMNodeSpecFactory(nodeSpec) {
    return function(_ref) {
        var parseDOM = _ref.parseDOM, toDOM = _ref.toDOM, toDebugString = _ref.toDebugString;
        return $2332ada103068f8a$var$_objectSpread($2332ada103068f8a$var$_objectSpread($2332ada103068f8a$var$_objectSpread($2332ada103068f8a$var$_objectSpread({}, nodeSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};
var $2332ada103068f8a$export$cf5823ed4e9f4c6f = function createPMMarkSpecFactory(markSpec) {
    return function(_ref2) {
        var parseDOM = _ref2.parseDOM, toDOM = _ref2.toDOM, toDebugString = _ref2.toDebugString;
        return $2332ada103068f8a$var$_objectSpread($2332ada103068f8a$var$_objectSpread($2332ada103068f8a$var$_objectSpread($2332ada103068f8a$var$_objectSpread({}, markSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};

});


parcelRegister("dS3bo", function(module, exports) {
$parcel$export(module.exports, "uuid", function () { return $a192c98d694ef953$export$31b40729666a4ae0; });
/* eslint-disable no-bitwise */ var $a192c98d694ef953$export$1c3aefb711c3a4cc = function generateUuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
/* eslint-enable no-bitwise */ var $a192c98d694ef953$var$staticValue = false;
var $a192c98d694ef953$export$31b40729666a4ae0 = {
    setStatic: function setStatic(value) {
        $a192c98d694ef953$var$staticValue = value;
    },
    generate: function generate() {
        return $a192c98d694ef953$var$staticValue || $a192c98d694ef953$export$1c3aefb711c3a4cc();
    }
};

});


parcelRegister("3054C", function(module, exports) {
$parcel$export(module.exports, "extensionFrame", function () { return $22f54eaf8db333c9$export$4fdcae991fd743e7; });
$parcel$export(module.exports, "multiBodiedExtension", function () { return $22f54eaf8db333c9$export$c3c04d555a8b9013; });

var $dAkqA = parcelRequire("dAkqA");

var $35i9Y = parcelRequire("35i9Y");
var $22f54eaf8db333c9$export$4fdcae991fd743e7 = (0, $35i9Y.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $22f54eaf8db333c9$export$c3c04d555a8b9013 = (0, $35i9Y.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $dAkqA.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});
parcelRegister("dAkqA", function(module, exports) {
$parcel$export(module.exports, "getExtensionAttrs", function () { return $9e3e7bab9459f5d1$export$1765e2758fc47004; });
var $9e3e7bab9459f5d1$export$d5f21755dc782a4a = function isValidLayout(name) {
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
var $9e3e7bab9459f5d1$export$1765e2758fc47004 = function getExtensionAttrs(dom) {
    var isInline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var extensionType = dom.getAttribute('data-extension-type');
    var extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    var attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        var rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $9e3e7bab9459f5d1$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});


parcelRegister("ksaMs", function(module, exports) {
$parcel$export(module.exports, "layoutSection", function () { return $ee3ec8fb99054185$export$b3b6a70a7fa4a5be; });
$parcel$export(module.exports, "layoutSectionWithSingleColumn", function () { return $ee3ec8fb99054185$export$4f9d8f623ff17117; });

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
var $ee3ec8fb99054185$export$b3b6a70a7fa4a5be = (0, $35i9Y.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $ee3ec8fb99054185$export$cdae19acb0a520fd = (0, $35i9Y.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $ee3ec8fb99054185$export$4f9d8f623ff17117 = (0, $35i9Y.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: function getAttrs(dom) {
                var columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        var columnRuleStyle = node.attrs.columnRuleStyle;
        var attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $ee3ec8fb99054185$export$d9d3c69a64270b13 = (0, $35i9Y.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: function getAttrs() {
                var localId = (0, $dS3bo.uuid).generate();
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-layout-section': 'true',
            'data-local-id': localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $ee3ec8fb99054185$export$64facded20dfd85c = (0, $35i9Y.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: function getAttrs(dom) {
                var columnRuleStyle = dom.getAttribute('data-column-rule-style');
                var localId = (0, $dS3bo.uuid).generate();
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle,
                    localId: localId
                } : {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var columnRuleStyle = node.attrs.columnRuleStyle;
        var attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("apXau", function(module, exports) {
$parcel$export(module.exports, "listItem", function () { return $795a22c358c656bf$export$76c7e83ecc9cdf05; });
$parcel$export(module.exports, "listItemWithDecisionStage0", function () { return $795a22c358c656bf$export$b2cd54d5ce935ddb; });

var $dS3bo = parcelRequire("dS3bo");

var $35i9Y = parcelRequire("35i9Y");
var $795a22c358c656bf$export$76c7e83ecc9cdf05 = (0, $35i9Y.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM: function toDOM() {
        return [
            'li',
            0
        ];
    }
});
var $795a22c358c656bf$export$483d52f09158e61c = (0, $35i9Y.listItem)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            'li',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
});
var $795a22c358c656bf$export$b2cd54d5ce935ddb = (0, $35i9Y.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM: function toDOM() {
        return [
            'li',
            0
        ];
    }
});
var $795a22c358c656bf$export$394466eb252d967a = (0, $35i9Y.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        return [
            'li',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
});

});

parcelRegister("hrTcF", function(module, exports) {
$parcel$export(module.exports, "syncBlock", function () { return $cb3fc77d09e387b2$export$faab0ca9701d7048; });

var $35i9Y = parcelRequire("35i9Y");
var $cb3fc77d09e387b2$export$faab0ca9701d7048 = (0, $35i9Y.syncBlockStage0)({
    parseDOM: [
        {
            tag: 'div[data-sync-block]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute('data-local-id') || '',
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, resourceId = _node$attrs.resourceId;
        var name = 'div';
        var attrs = {
            'data-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs
        ];
    }
});

});

parcelRegister("3FYQW", function(module, exports) {
$parcel$export(module.exports, "table", function () { return $2ad467912c49affd$export$9852986a3ec5f6a0; });
$parcel$export(module.exports, "tableRow", function () { return $2ad467912c49affd$export$ce666bf02318c957; });
$parcel$export(module.exports, "tableCell", function () { return $2ad467912c49affd$export$e1e720e5f4603e6a; });
$parcel$export(module.exports, "tableHeader", function () { return $2ad467912c49affd$export$48884d2a5190dc73; });
$parcel$export(module.exports, "tableWithNestedTable", function () { return $2ad467912c49affd$export$ce086a560a1d05f5; });
$parcel$export(module.exports, "tableRowWithNestedTable", function () { return $2ad467912c49affd$export$7d657479499397; });
$parcel$export(module.exports, "tableCellWithNestedTable", function () { return $2ad467912c49affd$export$abf39ca178940ff3; });
$parcel$export(module.exports, "tableHeaderWithNestedTable", function () { return $2ad467912c49affd$export$2a5a518232fa1a97; });

var $a8Fwx = parcelRequire("a8Fwx");

var $1YMOy = parcelRequire("1YMOy");

var $kgm12 = parcelRequire("kgm12");

var $3G1IB = parcelRequire("3G1IB");

var $dS3bo = parcelRequire("dS3bo");

var $7VJss = parcelRequire("7VJss");

var $35i9Y = parcelRequire("35i9Y");
function $2ad467912c49affd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2ad467912c49affd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2ad467912c49affd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2ad467912c49affd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2ad467912c49affd$export$9cfceb893b24742a = 'pm-table';
var $2ad467912c49affd$export$69cb4c3f80383763 = "".concat($2ad467912c49affd$export$9cfceb893b24742a, "-cell-content-wrap");
var $2ad467912c49affd$export$7b07d37d879c957f = "".concat($2ad467912c49affd$export$9cfceb893b24742a, "-header-content-wrap");
var $2ad467912c49affd$export$8dd42a84cd52da07 = "".concat($2ad467912c49affd$export$9cfceb893b24742a, "-cell-nodeview-wrapper");
var $2ad467912c49affd$export$5e26a5c19f0865d8 = "".concat($2ad467912c49affd$export$9cfceb893b24742a, "-cell-nodeview-content-dom");
var $2ad467912c49affd$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $3G1IB.N20).toLocaleLowerCase();
var $2ad467912c49affd$export$43977bde391e007 = function getCellAttrs(dom) {
    var defaultValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var widthAttr = dom.getAttribute('data-colwidth');
    var width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map(function(str) {
        return Number(str);
    }) : null;
    var colspan = Number(dom.getAttribute('colspan') || 1);
    var backgroundColor = dom.style.backgroundColor;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ var dataCellBackground = dom.getAttribute('data-cell-background');
    var dataCellBackgroundHexCode = dataCellBackground && (0, $3G1IB.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $3G1IB.isRgb)(backgroundColor)) {
        var result = (0, $3G1IB.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    var backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    var localId = defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.localId;
    return $2ad467912c49affd$var$_objectSpread({
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    }, localId && {
        localId: localId
    });
};
// these are for test only
var $2ad467912c49affd$var$testGlobalTheme;
var $2ad467912c49affd$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $2ad467912c49affd$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
var $2ad467912c49affd$var$getGlobalTheme = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($2ad467912c49affd$var$testGlobalTheme) return {
        colorMode: $2ad467912c49affd$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
var $2ad467912c49affd$var$cssVariablePattern = /^var\(--.*\)$/;
var $2ad467912c49affd$export$363c8dda799bfe9c = function getCellDomAttrs(node) {
    var _node$attrs;
    var attrs = {};
    var nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        var background = node.attrs.background;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        var ignored = nodeType === 'tableHeader' && background === $2ad467912c49affd$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $2ad467912c49affd$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            var color = (0, $3G1IB.isRgb)(background) && (0, $3G1IB.rgbToHex)(background) ? (0, $3G1IB.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ var tokenColor = (0, $kgm12.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = "background-color: ".concat(tokenColor, ";");
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $2ad467912c49affd$var$cssVariablePattern.test(color)) attrs.style = "background-color: ".concat(color, ";");
            else // if we have a custom color, we need to check if we are in dark mode
            if ($2ad467912c49affd$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = "background-color: ".concat((0, $7VJss.getDarkModeLCHColor)(color), ";");
            else // if we are in light mode, we can just set the color
            attrs.style = "background-color: ".concat(background, ";");
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            if (typeof color === 'string') attrs.colorname = $2ad467912c49affd$export$219b7f492ad209f8.get(color.toLowerCase());
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $2ad467912c49affd$export$7b07d37d879c957f;
    else attrs.class = $2ad467912c49affd$export$69cb4c3f80383763;
    if (node !== null && node !== void 0 && (_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.localId) attrs['data-local-id'] = node.attrs.localId;
    return attrs;
};
var $2ad467912c49affd$export$219b7f492ad209f8 = new Map();
var $2ad467912c49affd$export$95e9c925fbf01d1c = (0, $3G1IB.hexToRgba)((0, $3G1IB.N800), 0.12) || (0, $3G1IB.N0);
var $2ad467912c49affd$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $3G1IB.N0),
        'White'
    ],
    [
        (0, $3G1IB.B50),
        'Light blue'
    ],
    [
        (0, $3G1IB.T50),
        'Light teal'
    ],
    [
        (0, $3G1IB.G50),
        'Light green'
    ],
    [
        (0, $3G1IB.Y50),
        'Light yellow'
    ],
    [
        (0, $3G1IB.R50),
        'Light red'
    ],
    [
        (0, $3G1IB.P50),
        'Light purple'
    ],
    [
        (0, $3G1IB.N20),
        'Light gray'
    ],
    [
        (0, $3G1IB.B75),
        'Blue'
    ],
    [
        (0, $3G1IB.T75),
        'Teal'
    ],
    [
        (0, $3G1IB.G75),
        'Green'
    ],
    [
        (0, $3G1IB.Y75),
        'Yellow'
    ],
    [
        (0, $3G1IB.R75),
        'Red'
    ],
    [
        (0, $3G1IB.P75),
        'Purple'
    ],
    [
        (0, $3G1IB.N60),
        'Gray'
    ],
    [
        (0, $3G1IB.B100),
        'Dark blue'
    ],
    [
        (0, $3G1IB.T100),
        'Dark teal'
    ],
    [
        (0, $3G1IB.G200),
        'Dark green'
    ],
    [
        (0, $3G1IB.Y200),
        'Dark yellow'
    ],
    [
        (0, $3G1IB.R100),
        'Dark red'
    ],
    [
        (0, $3G1IB.P100),
        'Dark purple'
    ]
].forEach(function(_ref) {
    var _ref2 = (0, $a8Fwx.default)(_ref, 2), colorValue = _ref2[0], colorName = _ref2[1];
    $2ad467912c49affd$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $2ad467912c49affd$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // table nodes with nested tables support
var $2ad467912c49affd$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: function getAttrs(node) {
                var _dom$parentElement;
                var dom = node;
                var breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $dS3bo.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: Fix any, potential issue. ED-5048
var $2ad467912c49affd$var$createTableSpec = function createTableSpec() {
    return (0, $35i9Y.table)($2ad467912c49affd$var$tableNodeSpecOptions);
};
var $2ad467912c49affd$export$9852986a3ec5f6a0 = $2ad467912c49affd$var$createTableSpec();
var $2ad467912c49affd$export$90e634fbace1f0c4 = $2ad467912c49affd$var$createTableSpec();
var $2ad467912c49affd$export$3862de5c8c9098cf = $2ad467912c49affd$var$createTableSpec();
var $2ad467912c49affd$var$shouldIncludeAttribute = function shouldIncludeAttribute(key, value) {
    return !key.startsWith('__') && (key !== 'localId' || !!value);
};
var $2ad467912c49affd$export$1f92a2f429e06fa8 = function tableToJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return $2ad467912c49affd$var$shouldIncludeAttribute(key, node.attrs[key]);
        }).reduce(function(obj, key) {
            return $2ad467912c49affd$var$_objectSpread($2ad467912c49affd$var$_objectSpread({}, obj), {}, (0, $1YMOy.default)({}, key, node.attrs[key]));
        }, {})
    };
};
var $2ad467912c49affd$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM: function toDOM() {
        return [
            'tr',
            0
        ];
    }
};
var $2ad467912c49affd$export$ce666bf02318c957 = (0, $35i9Y.tableRow)($2ad467912c49affd$var$tableRowNodeSpecOptions);
var $2ad467912c49affd$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    },
    localId: {
        default: null,
        optional: true
    }
};
var $2ad467912c49affd$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            getAttrs: function getAttrs(dom) {
                return $2ad467912c49affd$export$43977bde391e007(dom);
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'td',
            $2ad467912c49affd$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $2ad467912c49affd$export$e1e720e5f4603e6a = (0, $35i9Y.tableCell)($2ad467912c49affd$var$tableCellNodeSpecOptions);
var $2ad467912c49affd$export$2ac34c099660f1a8 = function toJSONTableCell(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            // Only process keys that are defined in cellAttrs
            if ($2ad467912c49affd$var$cellAttrs[key] && $2ad467912c49affd$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};
var $2ad467912c49affd$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: function getAttrs(dom) {
                return $2ad467912c49affd$export$43977bde391e007(dom, {
                    background: $2ad467912c49affd$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'th',
            $2ad467912c49affd$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $2ad467912c49affd$export$48884d2a5190dc73 = (0, $35i9Y.tableHeader)($2ad467912c49affd$var$tableHeaderNodeSpecOptions);
var $2ad467912c49affd$export$2af48797a1010bb1 = $2ad467912c49affd$export$2ac34c099660f1a8;
var $2ad467912c49affd$export$ce086a560a1d05f5 = (0, $35i9Y.tableWithNestedTable)($2ad467912c49affd$var$tableNodeSpecOptions);
var $2ad467912c49affd$export$7d657479499397 = (0, $35i9Y.tableRowWithNestedTable)($2ad467912c49affd$var$tableRowNodeSpecOptions);
var $2ad467912c49affd$export$abf39ca178940ff3 = (0, $35i9Y.tableCellWithNestedTable)($2ad467912c49affd$var$tableCellNodeSpecOptions);
var $2ad467912c49affd$export$2a5a518232fa1a97 = (0, $35i9Y.tableHeaderWithNestedTable)($2ad467912c49affd$var$tableHeaderNodeSpecOptions);
// table nodes with localId support
var $2ad467912c49affd$var$tableRowNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'tr',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        return [
            'tr',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
            },
            0
        ];
    }
};
var $2ad467912c49affd$export$c8f0853ac97552c9 = (0, $35i9Y.tableRow)($2ad467912c49affd$var$tableRowNodeSpecOptionsWithLocalId);
var $2ad467912c49affd$var$tableCellNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'td',
            getAttrs: function getAttrs(dom) {
                return $2ad467912c49affd$export$43977bde391e007(dom, {
                    localId: (0, $dS3bo.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'td',
            $2ad467912c49affd$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $2ad467912c49affd$export$db76cfd28a574029 = (0, $35i9Y.tableCell)($2ad467912c49affd$var$tableCellNodeSpecOptionsWithLocalId);
var $2ad467912c49affd$var$tableHeaderNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: function getAttrs(dom) {
                return $2ad467912c49affd$export$43977bde391e007(dom, {
                    background: $2ad467912c49affd$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND,
                    localId: (0, $dS3bo.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'th',
            $2ad467912c49affd$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $2ad467912c49affd$export$b82d2b1d8824143d = (0, $35i9Y.tableHeader)($2ad467912c49affd$var$tableHeaderNodeSpecOptionsWithLocalId);
var $2ad467912c49affd$export$27926e30c8a74147 = (0, $35i9Y.tableRowWithNestedTable)($2ad467912c49affd$var$tableRowNodeSpecOptionsWithLocalId);
var $2ad467912c49affd$export$e9fd700fafee293a = (0, $35i9Y.tableCellWithNestedTable)($2ad467912c49affd$var$tableCellNodeSpecOptionsWithLocalId);
var $2ad467912c49affd$export$7928c3aeb4cd2213 = (0, $35i9Y.tableHeaderWithNestedTable)($2ad467912c49affd$var$tableHeaderNodeSpecOptionsWithLocalId);

});
parcelRegister("a8Fwx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $761adc7af991f88e$export$2e2bcd8739ae039; });

var $6TIGk = parcelRequire("6TIGk");

var $h4oTR = parcelRequire("h4oTR");

var $aDOnL = parcelRequire("aDOnL");

var $IMZcM = parcelRequire("IMZcM");
function $761adc7af991f88e$export$2e2bcd8739ae039(r, e) {
    return (0, $6TIGk.default)(r) || (0, $h4oTR.default)(r, e) || (0, $aDOnL.default)(r, e) || (0, $IMZcM.default)();
}

});
parcelRegister("6TIGk", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $505a89fc679046e7$export$2e2bcd8739ae039; });
function $505a89fc679046e7$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("h4oTR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c6d62003dce8e1d7$export$2e2bcd8739ae039; });
function $c6d62003dce8e1d7$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("aDOnL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $7bf4a0c19a8656b6$export$2e2bcd8739ae039; });

var $adcIJ = parcelRequire("adcIJ");
function $7bf4a0c19a8656b6$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $adcIJ.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $adcIJ.default)(r, a) : void 0;
    }
}

});
parcelRegister("adcIJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $76f4fc4ff68fc185$export$2e2bcd8739ae039; });
function $76f4fc4ff68fc185$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("IMZcM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $086a1bcf86769106$export$2e2bcd8739ae039; });
function $086a1bcf86769106$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("kgm12", function(module, exports) {
$parcel$export(module.exports, "hexToEditorBorderPaletteColor", function () { return $ec06612857ba08d1$export$bad3c41dd33cb4bc; });
$parcel$export(module.exports, "hexToEditorTextPaletteColor", function () { return $ec06612857ba08d1$export$9c2f408d391feb93; });
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", function () { return $ec06612857ba08d1$export$8b58ff1b36bb75e0; });
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", function () { return $ec06612857ba08d1$export$a270511a0e7fd61a; });

var $3L8ZR = parcelRequire("3L8ZR");
function $ec06612857ba08d1$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $ec06612857ba08d1$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
var $ec06612857ba08d1$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $ec06612857ba08d1$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $ec06612857ba08d1$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
var $ec06612857ba08d1$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $ec06612857ba08d1$export$8b58ff1b36bb75e0(hexColor) {
    if ((0, $3L8ZR.default).getExperimentValue('platform_editor_add_orange_highlight_color', 'cohort', 'control') !== 'test') $ec06612857ba08d1$export$12a518ff137dd389['#FEDEC8'] = 'var(--ds-background-accent-yellow-subtler, #F8E6A0)';
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return hexColor ? $ec06612857ba08d1$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
var $ec06612857ba08d1$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Yellow - light */ '#F8E6A0': 'var(--ds-background-accent-yellow-subtler, #F8E6A0)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $ec06612857ba08d1$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    var tokenData = hexColor ? $ec06612857ba08d1$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
var $ec06612857ba08d1$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: function getValue() {
            return '#DEEBFF';
        },
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: function getValue() {
            return '#B3D4FF';
        },
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: function getValue() {
            return '#4C9AFF';
        },
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: function getValue() {
            return '#E6FCFF';
        },
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: function getValue() {
            return '#B3F5FF';
        },
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: function getValue() {
            return '#79E2F2';
        },
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: function getValue() {
            return '#E3FCEF';
        },
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: function getValue() {
            return '#ABF5D1';
        },
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: function getValue() {
            return '#57D9A3';
        },
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: function getValue() {
            return '#FFFAE6';
        },
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: function getValue() {
            return '#FFF0B3';
        },
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: function getValue() {
            return '#FFC400';
        },
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: function getValue() {
            return '#FFEBE6';
        },
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: function getValue() {
            return '#FFBDAD';
        },
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: function getValue() {
            return '#FF8F73';
        },
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: function getValue() {
            return '#EAE6FF';
        },
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: function getValue() {
            return '#C0B6F2';
        },
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: function getValue() {
            return '#998DD9';
        },
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: function getValue() {
            return '#FFFFFF';
        },
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: function getValue() {
            return '#F4F5F7';
        },
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: function getValue() {
            return '#B3BAC5';
        },
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});

parcelRegister("3G1IB", function(module, exports) {
$parcel$export(module.exports, "R50", function () { return $2ad6a09437b3da0a$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R75", function () { return $2ad6a09437b3da0a$export$b34b069eff244586; });
$parcel$export(module.exports, "R100", function () { return $2ad6a09437b3da0a$export$be802dd0d8b57f35; });
$parcel$export(module.exports, "R300", function () { return $2ad6a09437b3da0a$export$4a7404f376229999; });
$parcel$export(module.exports, "R500", function () { return $2ad6a09437b3da0a$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $2ad6a09437b3da0a$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y75", function () { return $2ad6a09437b3da0a$export$41060a744ab0b7ae; });
$parcel$export(module.exports, "Y200", function () { return $2ad6a09437b3da0a$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Yellow200", function () { return $2ad6a09437b3da0a$export$fc857b6f8771648a; });
$parcel$export(module.exports, "Y400", function () { return $2ad6a09437b3da0a$export$59619663aa6500fb; });
$parcel$export(module.exports, "G50", function () { return $2ad6a09437b3da0a$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G75", function () { return $2ad6a09437b3da0a$export$69a3bf21b9686c2b; });
$parcel$export(module.exports, "G200", function () { return $2ad6a09437b3da0a$export$747d86715d4175de; });
$parcel$export(module.exports, "G300", function () { return $2ad6a09437b3da0a$export$940e1f69e873f202; });
$parcel$export(module.exports, "G500", function () { return $2ad6a09437b3da0a$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $2ad6a09437b3da0a$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $2ad6a09437b3da0a$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $2ad6a09437b3da0a$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B400", function () { return $2ad6a09437b3da0a$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $2ad6a09437b3da0a$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "L200", function () { return $2ad6a09437b3da0a$export$f72948ef771f6f15; });
$parcel$export(module.exports, "N0", function () { return $2ad6a09437b3da0a$export$29a4f05edc054374; });
$parcel$export(module.exports, "N20", function () { return $2ad6a09437b3da0a$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $2ad6a09437b3da0a$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N60", function () { return $2ad6a09437b3da0a$export$c2e91cbeada39b8b; });
$parcel$export(module.exports, "N80", function () { return $2ad6a09437b3da0a$export$eaa8c8a70ac22806; });
$parcel$export(module.exports, "Neutral300", function () { return $2ad6a09437b3da0a$export$1ae1cebe22dcedb4; });
$parcel$export(module.exports, "N300A", function () { return $2ad6a09437b3da0a$export$13609db0e6812ab8; });
$parcel$export(module.exports, "N600", function () { return $2ad6a09437b3da0a$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N800", function () { return $2ad6a09437b3da0a$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N1000", function () { return $2ad6a09437b3da0a$export$f78789c8b01753cd; });
$parcel$export(module.exports, "M200", function () { return $2ad6a09437b3da0a$export$a19f0c33186f7767; });
$parcel$export(module.exports, "O200", function () { return $2ad6a09437b3da0a$export$51716a84e62e022c; });
$parcel$export(module.exports, "P50", function () { return $2ad6a09437b3da0a$export$363e4475840015bb; });
$parcel$export(module.exports, "P75", function () { return $2ad6a09437b3da0a$export$4b0a4417ed59760f; });
$parcel$export(module.exports, "P100", function () { return $2ad6a09437b3da0a$export$6011520a64d9a187; });
$parcel$export(module.exports, "P200", function () { return $2ad6a09437b3da0a$export$a7175d4e9206bc80; });
$parcel$export(module.exports, "P300", function () { return $2ad6a09437b3da0a$export$b48405b95304b5a1; });
$parcel$export(module.exports, "P500", function () { return $2ad6a09437b3da0a$export$147899de772240ec; });
$parcel$export(module.exports, "T50", function () { return $2ad6a09437b3da0a$export$2cf711fe14c66f06; });
$parcel$export(module.exports, "T75", function () { return $2ad6a09437b3da0a$export$7a8f4d33f6f9772c; });
$parcel$export(module.exports, "T100", function () { return $2ad6a09437b3da0a$export$776c9c497ef08533; });
$parcel$export(module.exports, "T200", function () { return $2ad6a09437b3da0a$export$69cb3ca10c1e330e; });
$parcel$export(module.exports, "T300", function () { return $2ad6a09437b3da0a$export$9dc1ef0f3f48059b; });
$parcel$export(module.exports, "T500", function () { return $2ad6a09437b3da0a$export$6036577f95c3877e; });
$parcel$export(module.exports, "isHex", function () { return $2ad6a09437b3da0a$export$8a9b6341a7c96bc; });
$parcel$export(module.exports, "isRgb", function () { return $2ad6a09437b3da0a$export$e698776ec826343; });
$parcel$export(module.exports, "rgbToHex", function () { return $2ad6a09437b3da0a$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hexToRgba", function () { return $2ad6a09437b3da0a$export$9665a07d9187b414; });

var $a8Fwx = parcelRequire("a8Fwx");

var $ksCOI = parcelRequire("ksCOI");
var $2ad6a09437b3da0a$export$4b84fd0e2c617bd = '#FFEBE6';
var $2ad6a09437b3da0a$export$b34b069eff244586 = '#FFBDAD';
var $2ad6a09437b3da0a$export$be802dd0d8b57f35 = '#FF8F73';
var $2ad6a09437b3da0a$export$4a7404f376229999 = '#FF5630';
var $2ad6a09437b3da0a$export$2010d0fb4295b346 = '#DE350B';
var $2ad6a09437b3da0a$export$2837b5a1a71d5c02 = '#BF2600';
var $2ad6a09437b3da0a$export$8d9596b529bbb9cf = '#FFFAE6';
var $2ad6a09437b3da0a$export$41060a744ab0b7ae = '#FFF0B3';
var $2ad6a09437b3da0a$export$5aae31392d72caaa = '#FFC400';
var $2ad6a09437b3da0a$export$fc857b6f8771648a = '#F8E6A0';
var $2ad6a09437b3da0a$export$59619663aa6500fb = '#FF991F';
var $2ad6a09437b3da0a$export$874739ea9e379ab6 = '#FF8B00';
var $2ad6a09437b3da0a$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $2ad6a09437b3da0a$export$69a3bf21b9686c2b = '#ABF5D1';
var $2ad6a09437b3da0a$export$747d86715d4175de = '#57D9A3';
var $2ad6a09437b3da0a$export$940e1f69e873f202 = '#36B37E';
var $2ad6a09437b3da0a$export$a49394138f7b8e85 = '#00875A';
var $2ad6a09437b3da0a$export$6fa04827ac68a4fb = '#006644';
var $2ad6a09437b3da0a$export$226de0355ed012f8 = '#DEEBFF';
var $2ad6a09437b3da0a$export$8c13c2ee36917869 = '#B3D4FF';
var $2ad6a09437b3da0a$export$ecfc1dff386a3e7a = '#4C9AFF';
var $2ad6a09437b3da0a$export$b3de0ae08da2ce64 = '#0052CC';
var $2ad6a09437b3da0a$export$a6ee3d71bc067634 = '#0747A6';
var $2ad6a09437b3da0a$export$f72948ef771f6f15 = '#D3F1A7';
var $2ad6a09437b3da0a$export$29a4f05edc054374 = '#FFFFFF';
var $2ad6a09437b3da0a$export$9fdfb749e33cdf97 = '#F4F5F7';
var $2ad6a09437b3da0a$export$3e51e8f1440314ba = '#EBECF0';
var $2ad6a09437b3da0a$export$1ce2d1575d444ceb = '#DFE1E6';
var $2ad6a09437b3da0a$export$8754fc7e6d8b3000 = '#C1C7D0';
var $2ad6a09437b3da0a$export$c2e91cbeada39b8b = '#B3BAC5';
var $2ad6a09437b3da0a$export$eaa8c8a70ac22806 = '#97A0AF';
var $2ad6a09437b3da0a$export$7c87d337fb91a97d = '#8993A4';
var $2ad6a09437b3da0a$export$f563ee71e9ee74cd = '#6B778C';
var $2ad6a09437b3da0a$export$e2ef2124cf4024b1 = '#5E6C84';
var $2ad6a09437b3da0a$export$1ae1cebe22dcedb4 = '#DCDFE4';
var $2ad6a09437b3da0a$export$13609db0e6812ab8 = '#091E4224';
var $2ad6a09437b3da0a$export$c39c0fe0f26207ae = '#42526E';
var $2ad6a09437b3da0a$export$7090862dc3038a9f = '#758195';
var $2ad6a09437b3da0a$export$7d61b15e0da132af = '#172B4D';
var $2ad6a09437b3da0a$export$f78789c8b01753cd = '#172B4D';
var $2ad6a09437b3da0a$export$a19f0c33186f7767 = '#FDD0EC';
var $2ad6a09437b3da0a$export$51716a84e62e022c = '#FEDEC8';
var $2ad6a09437b3da0a$export$363e4475840015bb = '#EAE6FF';
var $2ad6a09437b3da0a$export$4b0a4417ed59760f = '#C0B6F2';
var $2ad6a09437b3da0a$export$6011520a64d9a187 = '#998DD9';
var $2ad6a09437b3da0a$export$a7175d4e9206bc80 = '#DFD8FD';
var $2ad6a09437b3da0a$export$b48405b95304b5a1 = '#6554C0';
var $2ad6a09437b3da0a$export$c71e4279dd54a18d = '#5243AA';
var $2ad6a09437b3da0a$export$147899de772240ec = '#403294';
var $2ad6a09437b3da0a$export$2cf711fe14c66f06 = '#E6FCFF';
var $2ad6a09437b3da0a$export$7a8f4d33f6f9772c = '#B3F5FF';
var $2ad6a09437b3da0a$export$776c9c497ef08533 = '#79E2F2';
var $2ad6a09437b3da0a$export$69cb3ca10c1e330e = '#C6EDFB';
var $2ad6a09437b3da0a$export$9dc1ef0f3f48059b = '#00B8D9';
var $2ad6a09437b3da0a$export$6036577f95c3877e = '#008DA6';
function $2ad6a09437b3da0a$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($2ad6a09437b3da0a$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map(function(c) {
            return c === '#' ? '#' : "".concat(c).concat(c);
        }).join('');
    } else if ($2ad6a09437b3da0a$export$e698776ec826343(color)) return $2ad6a09437b3da0a$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($ksCOI.default && $ksCOI.default[color]) color = $ksCOI.default[color];
        else if ($ksCOI && $ksCOI[color]) color = $ksCOI[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $2ad6a09437b3da0a$export$5a544e13ad4e1fa5(color) {
    if (!$2ad6a09437b3da0a$export$8a9b6341a7c96bc(color)) return null;
    var colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    var rgb = Number("0x".concat(colorBits.join('')));
    // eslint-disable-next-line no-bitwise
    return "rgb(".concat(rgb >> 16 & 255, ",").concat(rgb >> 8 & 255, ",").concat(rgb & 255, ")");
}
function $2ad6a09437b3da0a$export$9665a07d9187b414(rawColor, alpha) {
    var color = $2ad6a09437b3da0a$export$b61655071712e690(rawColor);
    if (!color) return null;
    var hex2rgb = function hex2rgb(color) {
        return color.match(/[a-z0-9]{2}/gi).map(function(hex) {
            return parseInt(hex, 16);
        });
    };
    return "rgba(".concat(hex2rgb(color).concat(alpha).join(','), ")");
}
function $2ad6a09437b3da0a$export$34d09c4a771c46ef(value) {
    var matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        var _matches$map = matches.map(Number), _matches$map2 = (0, $a8Fwx.default)(_matches$map, 3), red = _matches$map2[0], green = _matches$map2[1], blue = _matches$map2[2];
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $2ad6a09437b3da0a$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $2ad6a09437b3da0a$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});

parcelRegister("7VJss", function(module, exports) {
$parcel$export(module.exports, "getDarkModeLCHColor", function () { return $5c611e43c5f31b88$export$a5065c3b8aacaf99; });
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
var $5c611e43c5f31b88$var$clamp = function clamp(i, min, max) {
    return Math.round(Math.min(Math.max(i, min), max));
};
var $5c611e43c5f31b88$var$expandShorthandHex = function expandShorthandHex(input) {
    return input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
};
var $5c611e43c5f31b88$var$rgbFromHex = function rgbFromHex(input) {
    var fullHex = $5c611e43c5f31b88$var$expandShorthandHex(input);
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
var $5c611e43c5f31b88$var$rgbToHex = function rgbToHex(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    var convertComponent = function convertComponent(c) {
        var cBase16 = c.toString(16);
        return cBase16.length === 1 ? "0".concat(cBase16) : cBase16;
    };
    return "#".concat(convertComponent(r)).concat(convertComponent(g)).concat(convertComponent(b));
};
var $5c611e43c5f31b88$var$rgbToXyz = function rgbToXyz(rgb) {
    var convertRgbComponent = function convertRgbComponent(c) {
        return c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    };
    var convertXyzComponent = function convertXyzComponent(c) {
        return c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    };
    var r = convertRgbComponent(rgb.r / 255);
    var g = convertRgbComponent(rgb.g / 255);
    var b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
var $5c611e43c5f31b88$var$xyzToLab = function xyzToLab(_ref2) {
    var x = _ref2.x, y = _ref2.y, z = _ref2.z;
    return {
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    };
};
var $5c611e43c5f31b88$var$labToLch = function labToLch(_ref3) {
    var l = _ref3.l, a = _ref3.a, b = _ref3.b;
    var h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    var c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
var $5c611e43c5f31b88$var$lchToLab = function lchToLab(_ref4) {
    var l = _ref4.l, c = _ref4.c, h = _ref4.h;
    var convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
var $5c611e43c5f31b88$var$labToXyz = function labToXyz(_ref5) {
    var l = _ref5.l, a = _ref5.a, b = _ref5.b;
    var convertComponent = function convertComponent(c) {
        return c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    };
    var y = (l + 16) / 116;
    var x = a / 500 + y;
    var z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
var $5c611e43c5f31b88$var$xyzToRgb = function xyzToRgb(_ref6) {
    var x = _ref6.x, y = _ref6.y, z = _ref6.z;
    var convertComponent = function convertComponent(c) {
        return 255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    };
    return {
        r: $5c611e43c5f31b88$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $5c611e43c5f31b88$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $5c611e43c5f31b88$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
var $5c611e43c5f31b88$var$rgbToLch = function rgbToLch(rgb) {
    return $5c611e43c5f31b88$var$labToLch($5c611e43c5f31b88$var$xyzToLab($5c611e43c5f31b88$var$rgbToXyz(rgb)));
};
var $5c611e43c5f31b88$var$lchToRgb = function lchToRgb(lch) {
    return $5c611e43c5f31b88$var$xyzToRgb($5c611e43c5f31b88$var$labToXyz($5c611e43c5f31b88$var$lchToLab(lch)));
};
var $5c611e43c5f31b88$export$313b8a8fcb34c3b8 = function clampLightness(color, newPercent) {
    var rgb = $5c611e43c5f31b88$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    var lch = $5c611e43c5f31b88$var$rgbToLch(rgb);
    lch.l = $5c611e43c5f31b88$var$clamp(newPercent, 0, 100);
    return $5c611e43c5f31b88$var$rgbToHex($5c611e43c5f31b88$var$lchToRgb(lch));
};
var $5c611e43c5f31b88$var$getLightness = function getLightness(color) {
    var rgb = $5c611e43c5f31b88$var$rgbFromHex(color);
    if (rgb === null) return 0;
    var lch = $5c611e43c5f31b88$var$rgbToLch(rgb);
    return lch.l;
};
var $5c611e43c5f31b88$export$a5065c3b8aacaf99 = function getDarkModeLCHColor(currentBackgroundColor) {
    var lightness = $5c611e43c5f31b88$var$getLightness(currentBackgroundColor);
    var newLightness = Math.abs(100 - lightness);
    return $5c611e43c5f31b88$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});


parcelRegister("5Lxm0", function(module, exports) {
$parcel$export(module.exports, "createSchema", function () { return $432b36f2c37c930f$export$5f4ce795563f4211; });

var $cENKH = parcelRequire("cENKH");

var $h4D0i = parcelRequire("h4D0i");

var $hZivE = parcelRequire("hZivE");

var $1cB6t = parcelRequire("1cB6t");
var $3TKhC = parcelRequire("3TKhC");
var $9kZG1 = parcelRequire("9kZG1");
var $8Y0bD = parcelRequire("8Y0bD");
var $c5ZSc = parcelRequire("c5ZSc");
var $eMlDB = parcelRequire("eMlDB");
var $jeuXu = parcelRequire("jeuXu");
var $cHw09 = parcelRequire("cHw09");
var $j0vam = parcelRequire("j0vam");
var $fU1Bq = parcelRequire("fU1Bq");
var $6d2bd = parcelRequire("6d2bd");
var $ajG4R = parcelRequire("ajG4R");
var $fKtA4 = parcelRequire("fKtA4");
var $iZbsN = parcelRequire("iZbsN");
var $f623j = parcelRequire("f623j");
var $1U0rY = parcelRequire("1U0rY");
var $dV25i = parcelRequire("dV25i");
var $5TYds = parcelRequire("5TYds");
var $5uc46 = parcelRequire("5uc46");
var $2BisJ = parcelRequire("2BisJ");

var $6mMzQ = parcelRequire("6mMzQ");
var $5sacJ = parcelRequire("5sacJ");
var $DFUIs = parcelRequire("DFUIs");
var $9RUN2 = parcelRequire("9RUN2");
var $claEk = parcelRequire("claEk");
var $8eXsH = parcelRequire("8eXsH");
var $a7fGe = parcelRequire("a7fGe");
var $dDXbH = parcelRequire("dDXbH");
var $9YFvh = parcelRequire("9YFvh");
var $7C5L2 = parcelRequire("7C5L2");
var $g4DXa = parcelRequire("g4DXa");
var $bLcwV = parcelRequire("bLcwV");
var $7NNlE = parcelRequire("7NNlE");
var $ibsHe = parcelRequire("ibsHe");
var $73CSr = parcelRequire("73CSr");
var $9xf1B = parcelRequire("9xf1B");
var $cbmTE = parcelRequire("cbmTE");
var $2cUVb = parcelRequire("2cUVb");
var $d9aBX = parcelRequire("d9aBX");
var $3054C = parcelRequire("3054C");
var $g8K3J = parcelRequire("g8K3J");
var $kF1fR = parcelRequire("kF1fR");
var $8kQDF = parcelRequire("8kQDF");
var $fRQyu = parcelRequire("fRQyu");
var $bqFdW = parcelRequire("bqFdW");
var $dfjwm = parcelRequire("dfjwm");
var $ksaMs = parcelRequire("ksaMs");
var $apXau = parcelRequire("apXau");
var $dDMCS = parcelRequire("dDMCS");
var $gDmwP = parcelRequire("gDmwP");
var $akl9R = parcelRequire("akl9R");
var $6x4c2 = parcelRequire("6x4c2");
var $jPkEj = parcelRequire("jPkEj");
var $8Cmqn = parcelRequire("8Cmqn");
var $hPlli = parcelRequire("hPlli");
var $enD9G = parcelRequire("enD9G");
var $lDmie = parcelRequire("lDmie");
var $2KjdB = parcelRequire("2KjdB");
var $9DZID = parcelRequire("9DZID");
var $hrTcF = parcelRequire("hrTcF");
var $3FYQW = parcelRequire("3FYQW");
var $iaDy5 = parcelRequire("iaDy5");
var $4VC0J = parcelRequire("4VC0J");
var $sM3wy = parcelRequire("sM3wy");
var $lztMS = parcelRequire("lztMS");
var $lbKeT = parcelRequire("lbKeT");
function $432b36f2c37c930f$var$addItems(builtInItems, config) {
    var customSpecs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ var items = builtInItems.reduce(function(items, _ref) {
        var name = _ref.name, spec = _ref.spec;
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce(function(items, name) {
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $432b36f2c37c930f$var$groupDeclaration(name) {
    return {
        name: "__".concat(name, "GroupDeclaration"),
        spec: {
            group: name
        }
    };
}
var $432b36f2c37c930f$var$markGroupDeclarations = [
    $432b36f2c37c930f$var$groupDeclaration((0, $h4D0i.COLOR)),
    $432b36f2c37c930f$var$groupDeclaration((0, $h4D0i.FONT_STYLE)),
    $432b36f2c37c930f$var$groupDeclaration((0, $h4D0i.SEARCH_QUERY)),
    $432b36f2c37c930f$var$groupDeclaration((0, $h4D0i.LINK))
];
var $432b36f2c37c930f$var$markGroupDeclarationsNames = $432b36f2c37c930f$var$markGroupDeclarations.map(function(groupMark) {
    return groupMark.name;
});
var $432b36f2c37c930f$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $7NNlE.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $enD9G.paragraph)
    },
    {
        name: 'text',
        spec: (0, $4VC0J.text)
    },
    {
        name: 'bulletList',
        spec: (0, $9RUN2.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $hPlli.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $apXau.listItem)
    },
    {
        name: 'heading',
        spec: (0, $kF1fR.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $cbmTE.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $8eXsH.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $2cUVb.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $2KjdB.rule)
    },
    {
        name: 'image',
        spec: (0, $8kQDF.image)
    },
    {
        name: 'mention',
        spec: (0, $jPkEj.mention)
    },
    {
        name: 'caption',
        spec: (0, $claEk.caption)
    },
    {
        name: 'media',
        spec: (0, $dDMCS.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $gDmwP.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $6x4c2.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $akl9R.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $lDmie.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $ksaMs.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $dfjwm.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $g8K3J.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $73CSr.emoji)
    },
    {
        name: 'table',
        spec: (0, $3FYQW.table)
    },
    {
        name: 'tableCell',
        spec: (0, $3FYQW.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $3FYQW.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $3FYQW.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $a7fGe.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $9YFvh.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $dDXbH.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $bLcwV.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $g4DXa.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $iaDy5.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $5sacJ.taskItem)
    },
    {
        name: 'blockTaskItem',
        spec: (0, $5sacJ.blockTaskItem)
    },
    {
        name: 'date',
        spec: (0, $7C5L2.date)
    },
    {
        name: 'status',
        spec: (0, $9DZID.status)
    },
    {
        name: 'expand',
        spec: (0, $9xf1B.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $8Cmqn.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $d9aBX.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $bqFdW.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $DFUIs.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $3054C.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $3054C.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $fRQyu.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $6mMzQ.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $ibsHe.embedCard)
    },
    {
        name: 'syncBlock',
        spec: (0, $hrTcF.syncBlock)
    },
    {
        name: 'unknownBlock',
        spec: (0, $sM3wy.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $lztMS.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $lbKeT.unsupportedInline)
    }
];
var $432b36f2c37c930f$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $ajG4R.link)
    },
    {
        name: 'em',
        spec: (0, $j0vam.em)
    },
    {
        name: 'strong',
        spec: (0, $iZbsN.strong)
    },
    {
        name: 'textColor',
        spec: (0, $1U0rY.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $9kZG1.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $fKtA4.strike)
    },
    {
        name: 'subsup',
        spec: (0, $f623j.subsup)
    },
    {
        name: 'underline',
        spec: (0, $5TYds.underline)
    },
    {
        name: 'code',
        spec: (0, $eMlDB.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $dV25i.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $1cB6t.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $3TKhC.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $jeuXu.confluenceInlineComment)
    }
].concat($432b36f2c37c930f$var$markGroupDeclarations, [
    {
        name: 'breakout',
        spec: (0, $c5ZSc.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $cHw09.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $fU1Bq.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $6d2bd.indentation)
    },
    {
        name: 'border',
        spec: (0, $8Y0bD.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $5uc46.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $2BisJ.unsupportedNodeAttribute)
    }
]);
function $432b36f2c37c930f$export$2d0c32a809131488() {
    var nodes = $432b36f2c37c930f$var$nodesInOrder.reduce(function(acc, _ref2) {
        var name = _ref2.name, spec = _ref2.spec;
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    var marks = $432b36f2c37c930f$var$marksInOrder.reduce(function(acc, _ref3) {
        var name = _ref3.name, spec = _ref3.spec;
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $432b36f2c37c930f$export$5f4ce795563f4211(config) {
    var customNodeSpecs = config.customNodeSpecs, customMarkSpecs = config.customMarkSpecs;
    var nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    var marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($432b36f2c37c930f$var$markGroupDeclarationsNames);
    var nodes = $432b36f2c37c930f$var$addItems($432b36f2c37c930f$var$nodesInOrder, nodesConfig, customNodeSpecs);
    var marks = $432b36f2c37c930f$var$addItems($432b36f2c37c930f$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $hZivE.sanitizeNodes)(nodes, marks);
    return new (0, $cENKH.Schema)({
        nodes: nodes,
        marks: marks
    });
}
var $432b36f2c37c930f$export$c77b6d30da5276a1 = true;

});
parcelRegister("cENKH", function(module, exports) {
$parcel$export(module.exports, "Fragment", function () { return $936fd032dba44608$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Schema", function () { return $936fd032dba44608$export$19342e026b58ebb7; });

var $l0GWs = parcelRequire("l0GWs");
function $936fd032dba44608$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $936fd032dba44608$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $936fd032dba44608$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $936fd032dba44608$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $936fd032dba44608$export$ffb0004e005737fa {
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $936fd032dba44608$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $936fd032dba44608$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $936fd032dba44608$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $936fd032dba44608$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $936fd032dba44608$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $936fd032dba44608$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $936fd032dba44608$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $936fd032dba44608$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $936fd032dba44608$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $936fd032dba44608$var$retIndex(0, pos);
        if (pos == this.size) return $936fd032dba44608$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $936fd032dba44608$var$retIndex(i + 1, end);
                return $936fd032dba44608$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $936fd032dba44608$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $936fd032dba44608$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $936fd032dba44608$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $936fd032dba44608$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $936fd032dba44608$export$ffb0004e005737fa.empty;
        if (nodes instanceof $936fd032dba44608$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $936fd032dba44608$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $936fd032dba44608$export$ffb0004e005737fa.empty = new $936fd032dba44608$export$ffb0004e005737fa([], 0);
const $936fd032dba44608$var$found = {
    index: 0,
    offset: 0
};
function $936fd032dba44608$var$retIndex(index, offset) {
    $936fd032dba44608$var$found.index = index;
    $936fd032dba44608$var$found.offset = offset;
    return $936fd032dba44608$var$found;
}
function $936fd032dba44608$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$936fd032dba44608$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$936fd032dba44608$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $936fd032dba44608$export$c9d15bcfc6d42044 {
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $936fd032dba44608$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $936fd032dba44608$export$c9d15bcfc6d42044.none;
        if (marks instanceof $936fd032dba44608$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
}
/**
The empty set of marks.
*/ $936fd032dba44608$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $936fd032dba44608$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $936fd032dba44608$export$b3f2e2de3a8baa1e {
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $936fd032dba44608$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $936fd032dba44608$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $936fd032dba44608$export$b3f2e2de3a8baa1e($936fd032dba44608$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $936fd032dba44608$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $936fd032dba44608$export$b3f2e2de3a8baa1e($936fd032dba44608$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $936fd032dba44608$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
}
/**
The empty slice.
*/ $936fd032dba44608$export$b3f2e2de3a8baa1e.empty = new $936fd032dba44608$export$b3f2e2de3a8baa1e($936fd032dba44608$export$ffb0004e005737fa.empty, 0, 0);
function $936fd032dba44608$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($936fd032dba44608$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $936fd032dba44608$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $936fd032dba44608$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $936fd032dba44608$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $936fd032dba44608$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $936fd032dba44608$export$6de0e778727af3f2("Inconsistent open depths");
    return $936fd032dba44608$var$replaceOuter($from, $to, slice, 0);
}
function $936fd032dba44608$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $936fd032dba44608$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $936fd032dba44608$var$close(node, $936fd032dba44608$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $936fd032dba44608$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $936fd032dba44608$var$prepareSliceForReplace(slice, $from);
        return $936fd032dba44608$var$close(node, $936fd032dba44608$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $936fd032dba44608$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $936fd032dba44608$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $936fd032dba44608$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $936fd032dba44608$var$checkJoin(node, $after.node(depth));
    return node;
}
function $936fd032dba44608$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $936fd032dba44608$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $936fd032dba44608$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$936fd032dba44608$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $936fd032dba44608$var$addNode($end.nodeBefore, target);
}
function $936fd032dba44608$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $936fd032dba44608$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $936fd032dba44608$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $936fd032dba44608$var$joinable($end, $to, depth + 1);
    let content = [];
    $936fd032dba44608$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $936fd032dba44608$var$checkJoin(openStart, openEnd);
        $936fd032dba44608$var$addNode($936fd032dba44608$var$close(openStart, $936fd032dba44608$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $936fd032dba44608$var$addNode($936fd032dba44608$var$close(openStart, $936fd032dba44608$var$replaceTwoWay($from, $start, depth + 1)), content);
        $936fd032dba44608$var$addRange($start, $end, depth, content);
        if (openEnd) $936fd032dba44608$var$addNode($936fd032dba44608$var$close(openEnd, $936fd032dba44608$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $936fd032dba44608$var$addRange($to, null, depth, content);
    return new $936fd032dba44608$export$ffb0004e005737fa(content);
}
function $936fd032dba44608$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $936fd032dba44608$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $936fd032dba44608$var$joinable($from, $to, depth + 1);
        $936fd032dba44608$var$addNode($936fd032dba44608$var$close(type, $936fd032dba44608$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $936fd032dba44608$var$addRange($to, null, depth, content);
    return new $936fd032dba44608$export$ffb0004e005737fa(content);
}
function $936fd032dba44608$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($936fd032dba44608$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $936fd032dba44608$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $936fd032dba44608$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $936fd032dba44608$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $936fd032dba44608$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $936fd032dba44608$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $936fd032dba44608$var$resolveCache.set(doc, cache = new $936fd032dba44608$var$ResolveCache);
        let result = cache.elts[cache.i] = $936fd032dba44608$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $936fd032dba44608$var$resolveCacheSize;
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
}
class $936fd032dba44608$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $936fd032dba44608$var$resolveCacheSize = 12, $936fd032dba44608$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $936fd032dba44608$export$7bc461ceb770fb16 {
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
}
const $936fd032dba44608$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $936fd032dba44608$export$85c928794f8d04d4 {
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $936fd032dba44608$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $936fd032dba44608$var$emptyAttrs) && $936fd032dba44608$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $936fd032dba44608$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $936fd032dba44608$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $936fd032dba44608$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $936fd032dba44608$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $936fd032dba44608$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $936fd032dba44608$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $936fd032dba44608$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $936fd032dba44608$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $936fd032dba44608$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $936fd032dba44608$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $936fd032dba44608$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$936fd032dba44608$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $936fd032dba44608$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $936fd032dba44608$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $936fd032dba44608$export$ffb0004e005737fa.empty;
    }
}
$936fd032dba44608$export$85c928794f8d04d4.prototype.text = undefined;
class $936fd032dba44608$var$TextNode extends $936fd032dba44608$export$85c928794f8d04d4 {
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $936fd032dba44608$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $936fd032dba44608$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $936fd032dba44608$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
}
function $936fd032dba44608$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $936fd032dba44608$export$364ed450558d7ec4 {
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $936fd032dba44608$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $936fd032dba44608$export$364ed450558d7ec4.empty;
        let expr = $936fd032dba44608$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $936fd032dba44608$var$dfa($936fd032dba44608$var$nfa(expr));
        $936fd032dba44608$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $936fd032dba44608$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
}
/**
@internal
*/ $936fd032dba44608$export$364ed450558d7ec4.empty = new $936fd032dba44608$export$364ed450558d7ec4(true);
class $936fd032dba44608$var$TokenStream {
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
}
function $936fd032dba44608$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($936fd032dba44608$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $936fd032dba44608$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($936fd032dba44608$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $936fd032dba44608$var$parseExprSubscript(stream) {
    let expr = $936fd032dba44608$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $936fd032dba44608$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $936fd032dba44608$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $936fd032dba44608$var$parseExprRange(stream, expr) {
    let min = $936fd032dba44608$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $936fd032dba44608$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $936fd032dba44608$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $936fd032dba44608$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $936fd032dba44608$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $936fd032dba44608$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $936fd032dba44608$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $936fd032dba44608$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $936fd032dba44608$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($936fd032dba44608$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $936fd032dba44608$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($936fd032dba44608$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $936fd032dba44608$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $936fd032dba44608$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($936fd032dba44608$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $936fd032dba44608$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $936fd032dba44608$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $936fd032dba44608$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $936fd032dba44608$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $936fd032dba44608$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $936fd032dba44608$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $936fd032dba44608$export$f06e977173f1857c {
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $936fd032dba44608$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $936fd032dba44608$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $936fd032dba44608$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $936fd032dba44608$export$ffb0004e005737fa.from(content), $936fd032dba44608$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $936fd032dba44608$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $936fd032dba44608$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $936fd032dba44608$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $936fd032dba44608$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($936fd032dba44608$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $936fd032dba44608$export$85c928794f8d04d4(this, attrs, content.append(after), $936fd032dba44608$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $936fd032dba44608$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $936fd032dba44608$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $936fd032dba44608$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $936fd032dba44608$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $936fd032dba44608$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
}
function $936fd032dba44608$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $936fd032dba44608$var$Attribute {
    get isRequired() {
        return !this.hasDefault;
    }
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $936fd032dba44608$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $936fd032dba44608$export$b6a78689043c6521 {
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $936fd032dba44608$export$c9d15bcfc6d42044(this, $936fd032dba44608$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $936fd032dba44608$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $936fd032dba44608$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $936fd032dba44608$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $936fd032dba44608$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $936fd032dba44608$export$c9d15bcfc6d42044(this, defaults) : null;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $936fd032dba44608$export$19342e026b58ebb7 {
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $936fd032dba44608$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $936fd032dba44608$var$TextNode(type, type.defaultAttrs, text, $936fd032dba44608$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $936fd032dba44608$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $936fd032dba44608$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $l0GWs.default).from(spec.nodes), instanceSpec.marks = (0, $l0GWs.default).from(spec.marks || {}), this.nodes = $936fd032dba44608$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $936fd032dba44608$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $936fd032dba44608$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $936fd032dba44608$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $936fd032dba44608$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
}
function $936fd032dba44608$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $936fd032dba44608$var$isTagRule(rule) {
    return rule.tag != null;
}
function $936fd032dba44608$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $936fd032dba44608$export$1059c6e7d2ce5669 {
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $936fd032dba44608$var$ParseContext(this, options, false);
        context.addAll(dom, $936fd032dba44608$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $936fd032dba44608$var$ParseContext(this, options, true);
        context.addAll(dom, $936fd032dba44608$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $936fd032dba44608$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($936fd032dba44608$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $936fd032dba44608$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $936fd032dba44608$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $936fd032dba44608$export$1059c6e7d2ce5669(schema, $936fd032dba44608$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($936fd032dba44608$var$isTagRule(rule)) this.tags.push(rule);
            else if ($936fd032dba44608$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
}
const $936fd032dba44608$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $936fd032dba44608$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $936fd032dba44608$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $936fd032dba44608$var$OPT_PRESERVE_WS = 1, $936fd032dba44608$var$OPT_PRESERVE_WS_FULL = 2, $936fd032dba44608$var$OPT_OPEN_LEFT = 4;
function $936fd032dba44608$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $936fd032dba44608$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $936fd032dba44608$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $936fd032dba44608$var$OPT_PRESERVE_WS | $936fd032dba44608$var$OPT_PRESERVE_WS_FULL : base & ~$936fd032dba44608$var$OPT_OPEN_LEFT;
}
class $936fd032dba44608$var$NodeContext {
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($936fd032dba44608$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $936fd032dba44608$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $936fd032dba44608$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($936fd032dba44608$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$936fd032dba44608$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $936fd032dba44608$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $936fd032dba44608$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
}
class $936fd032dba44608$var$ParseContext {
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $936fd032dba44608$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $936fd032dba44608$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($936fd032dba44608$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $936fd032dba44608$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $936fd032dba44608$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($936fd032dba44608$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $936fd032dba44608$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $936fd032dba44608$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $936fd032dba44608$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $936fd032dba44608$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $936fd032dba44608$var$OPT_OPEN_LEFT;
        let applyMarks = $936fd032dba44608$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $936fd032dba44608$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $936fd032dba44608$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $936fd032dba44608$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $936fd032dba44608$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $936fd032dba44608$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $936fd032dba44608$var$NodeContext(topNode.type, topNode.attrs, $936fd032dba44608$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $936fd032dba44608$var$NodeContext(null, null, $936fd032dba44608$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $936fd032dba44608$var$NodeContext(parser.schema.topNodeType, null, $936fd032dba44608$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $936fd032dba44608$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $936fd032dba44608$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $936fd032dba44608$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $936fd032dba44608$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $936fd032dba44608$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $936fd032dba44608$export$3476b78f8f5a8b72 {
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $936fd032dba44608$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $936fd032dba44608$var$renderSpec($936fd032dba44608$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $936fd032dba44608$var$renderSpec($936fd032dba44608$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $936fd032dba44608$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $936fd032dba44608$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $936fd032dba44608$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $936fd032dba44608$var$gatherToDOM(schema.marks);
    }
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
}
function $936fd032dba44608$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $936fd032dba44608$var$doc(options) {
    return options.document || window.document;
}
const $936fd032dba44608$var$suspiciousAttributeCache = new WeakMap();
function $936fd032dba44608$var$suspiciousAttributes(attrs) {
    let value = $936fd032dba44608$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $936fd032dba44608$var$suspiciousAttributeCache.set(attrs, value = $936fd032dba44608$var$suspiciousAttributesInner(attrs));
    return value;
}
function $936fd032dba44608$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $936fd032dba44608$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $936fd032dba44608$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $936fd032dba44608$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});

parcelRegister("h4D0i", function(module, exports) {
$parcel$export(module.exports, "FONT_STYLE", function () { return $c6e110b7b18bfe47$export$4498a6080fed604c; });
$parcel$export(module.exports, "SEARCH_QUERY", function () { return $c6e110b7b18bfe47$export$f8e8a5f34f6ea725; });
$parcel$export(module.exports, "LINK", function () { return $c6e110b7b18bfe47$export$b395009ca7f092c7; });
$parcel$export(module.exports, "COLOR", function () { return $c6e110b7b18bfe47$export$9b982809044276a6; });
// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
var $c6e110b7b18bfe47$export$4498a6080fed604c = 'fontStyle';
var $c6e110b7b18bfe47$export$f8e8a5f34f6ea725 = 'searchQuery';
var $c6e110b7b18bfe47$export$b395009ca7f092c7 = 'link';
var $c6e110b7b18bfe47$export$9b982809044276a6 = 'color';
var $c6e110b7b18bfe47$export$470d0905851e47a1 = 'alignment';
var $c6e110b7b18bfe47$export$bacb7f4b06a06b22 = 'indentation';

});

parcelRegister("hZivE", function(module, exports) {
$parcel$export(module.exports, "sanitizeNodes", function () { return $d1867dc494bd6c56$export$daf54fed04c8fb77; });

var $1YMOy = parcelRequire("1YMOy");
function $d1867dc494bd6c56$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d1867dc494bd6c56$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d1867dc494bd6c56$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d1867dc494bd6c56$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d1867dc494bd6c56$export$daf54fed04c8fb77(nodes, supportedMarks) {
    var nodeNames = Object.keys(nodes);
    nodeNames.forEach(function(nodeKey) {
        var nodeSpec = $d1867dc494bd6c56$var$_objectSpread({}, nodes[nodeKey]);
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter(function(mark) {
            return !!supportedMarks[mark];
        }).join(' ');
        if (nodeSpec.content) nodeSpec.content = $d1867dc494bd6c56$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $d1867dc494bd6c56$var$sanitizeNodeSpecContent(nodes, rawContent) {
    var content = rawContent.replace(/\W/g, ' ');
    var contentKeys = content.split(' ');
    var unsupportedContentKeys = contentKeys.filter(function(contentKey) {
        return !$d1867dc494bd6c56$var$isContentSupported(nodes, contentKey);
    });
    return unsupportedContentKeys.reduce(function(newContent, nodeName) {
        return $d1867dc494bd6c56$var$sanitizedContent(newContent, nodeName);
    }, rawContent);
}
function $d1867dc494bd6c56$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match(/\w/)) return '';
    var pattern = "(".concat(invalidContent, "((\\s)*\\|)+)|((\\|(\\s)*)+").concat(invalidContent, "(\\+|\\*)?)|(").concat(invalidContent, "$)|(").concat(invalidContent, "(\\+|\\*))");
    return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
}
function $d1867dc494bd6c56$var$isContentSupported(nodes, contentKey) {
    var nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(var supportedKey in nodes){
        var nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});

parcelRegister("1cB6t", function(module, exports) {
$parcel$export(module.exports, "alignment", function () { return $0e03b16b0c9376a4$export$8e53000a4ec837; });

var $eNjcd = parcelRequire("eNjcd");
var $0e03b16b0c9376a4$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
var $0e03b16b0c9376a4$export$8e53000a4ec837 = (0, $eNjcd.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: function getAttrs(dom) {
                var align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            'div',
            {
                class: "fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-".concat(mark.attrs.align),
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});
parcelRegister("eNjcd", function(module, exports) {
$parcel$export(module.exports, "alignment", function () { return $ac548837e97a5aca$export$8e53000a4ec837; });
$parcel$export(module.exports, "annotation", function () { return $ac548837e97a5aca$export$8512c9afa7b24c3b; });
$parcel$export(module.exports, "backgroundColor", function () { return $ac548837e97a5aca$export$8c5a050822fd698c; });
$parcel$export(module.exports, "border", function () { return $ac548837e97a5aca$export$1edee58a52776cd9; });
$parcel$export(module.exports, "breakout", function () { return $ac548837e97a5aca$export$89015c65f1c75e3f; });
$parcel$export(module.exports, "code", function () { return $ac548837e97a5aca$export$6565f9f03506010b; });
$parcel$export(module.exports, "confluenceInlineComment", function () { return $ac548837e97a5aca$export$f3b72f8fc4684ecd; });
$parcel$export(module.exports, "dataConsumer", function () { return $ac548837e97a5aca$export$3024f02c495408d6; });
$parcel$export(module.exports, "em", function () { return $ac548837e97a5aca$export$c63c6f932822f543; });
$parcel$export(module.exports, "fragment", function () { return $ac548837e97a5aca$export$f00aeb236b6f05af; });
$parcel$export(module.exports, "indentation", function () { return $ac548837e97a5aca$export$480c699bd4ec0d86; });
$parcel$export(module.exports, "link", function () { return $ac548837e97a5aca$export$9c30223ca0a664fb; });
$parcel$export(module.exports, "strike", function () { return $ac548837e97a5aca$export$4899a95d70ec5056; });
$parcel$export(module.exports, "strong", function () { return $ac548837e97a5aca$export$59ae2c325a998f89; });
$parcel$export(module.exports, "subsup", function () { return $ac548837e97a5aca$export$b3401ee80eb31041; });
$parcel$export(module.exports, "textColor", function () { return $ac548837e97a5aca$export$32f78bffcd82ff28; });
$parcel$export(module.exports, "typeAheadQuery", function () { return $ac548837e97a5aca$export$20af3dabbb5538df; });
$parcel$export(module.exports, "underline", function () { return $ac548837e97a5aca$export$425327af25286e5e; });
$parcel$export(module.exports, "unsupportedMark", function () { return $ac548837e97a5aca$export$30d78d5eb6719bb8; });
$parcel$export(module.exports, "unsupportedNodeAttribute", function () { return $ac548837e97a5aca$export$a316dc07ff5182a2; });
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $31mbR = parcelRequire("31mbR");
var $ac548837e97a5aca$export$8e53000a4ec837 = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
var $ac548837e97a5aca$export$8512c9afa7b24c3b = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
var $ac548837e97a5aca$export$8c5a050822fd698c = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: 'color',
    group: 'color'
});
var $ac548837e97a5aca$export$1edee58a52776cd9 = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
var $ac548837e97a5aca$export$89015c65f1c75e3f = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
var $ac548837e97a5aca$export$6565f9f03506010b = (0, $31mbR.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
var $ac548837e97a5aca$export$f3b72f8fc4684ecd = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
var $ac548837e97a5aca$export$3024f02c495408d6 = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
var $ac548837e97a5aca$export$c63c6f932822f543 = (0, $31mbR.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $ac548837e97a5aca$export$f00aeb236b6f05af = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
var $ac548837e97a5aca$export$480c699bd4ec0d86 = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
var $ac548837e97a5aca$export$9c30223ca0a664fb = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
var $ac548837e97a5aca$export$4899a95d70ec5056 = (0, $31mbR.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $ac548837e97a5aca$export$59ae2c325a998f89 = (0, $31mbR.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $ac548837e97a5aca$export$b3401ee80eb31041 = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
var $ac548837e97a5aca$export$32f78bffcd82ff28 = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
var $ac548837e97a5aca$export$20af3dabbb5538df = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
var $ac548837e97a5aca$export$425327af25286e5e = (0, $31mbR.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $ac548837e97a5aca$export$30d78d5eb6719bb8 = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
var $ac548837e97a5aca$export$a316dc07ff5182a2 = (0, $31mbR.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});


parcelRegister("3TKhC", function(module, exports) {
$parcel$export(module.exports, "annotation", function () { return $2d6a690adc10bcf4$export$8512c9afa7b24c3b; });

var $1YMOy = parcelRequire("1YMOy");

var $eNjcd = parcelRequire("eNjcd");
function $2d6a690adc10bcf4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2d6a690adc10bcf4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2d6a690adc10bcf4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2d6a690adc10bcf4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $2d6a690adc10bcf4$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
var $2d6a690adc10bcf4$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $2d6a690adc10bcf4$export$93a98caa8bc6cb07(_ref) {
    var id = _ref.id, annotationType = _ref.annotationType, state = _ref.state;
    var data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return $2d6a690adc10bcf4$var$_objectSpread($2d6a690adc10bcf4$var$_objectSpread({}, data), {}, {
        'data-mark-annotation-state': state
    });
    return data;
}
var $2d6a690adc10bcf4$export$8512c9afa7b24c3b = (0, $eNjcd.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            'span',
            $2d6a690adc10bcf4$var$_objectSpread({
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation'
            }, $2d6a690adc10bcf4$export$93a98caa8bc6cb07({
                id: node.attrs.id,
                annotationType: node.attrs.annotationType
            })),
            0
        ];
    }
});

});

parcelRegister("9kZG1", function(module, exports) {
$parcel$export(module.exports, "backgroundColor", function () { return $6cc5d303e3007389$export$8c5a050822fd698c; });

var $1YMOy = parcelRequire("1YMOy");

var $a8Fwx = parcelRequire("a8Fwx");

var $eNjcd = parcelRequire("eNjcd");

var $kgm12 = parcelRequire("kgm12");

var $3G1IB = parcelRequire("3G1IB");

var $1U0rY = parcelRequire("1U0rY");

var $7VJss = parcelRequire("7VJss");
/**
 * @name backgroundColor_mark
 */ // Remove this when cleaning up platform_editor_add_orange_highlight_color
var $6cc5d303e3007389$var$colorArrayPalette = [
    [
        (0, $3G1IB.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $3G1IB.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $3G1IB.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $3G1IB.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $3G1IB.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $3G1IB.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
var $6cc5d303e3007389$var$colorArrayPaletteNext = [
    [
        (0, $3G1IB.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $3G1IB.P200),
        'Purple'
    ],
    // token: color.background.accent.purple.subtler
    [
        (0, $3G1IB.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $3G1IB.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $3G1IB.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $3G1IB.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $3G1IB.T200),
        'Teal'
    ] // token: color.background.accent.teal.subtler
];
var $6cc5d303e3007389$export$14ec3f21a268e497 = new Map();
$6cc5d303e3007389$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $a8Fwx.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $6cc5d303e3007389$export$14ec3f21a268e497.set(color.toLowerCase(), label);
});
var $6cc5d303e3007389$export$7ab6fa38cecaeee2 = new Map();
$6cc5d303e3007389$var$colorArrayPaletteNext.forEach(function(_ref3) {
    var _ref4 = (0, $a8Fwx.default)(_ref3, 2), color = _ref4[0], label = _ref4[1];
    return $6cc5d303e3007389$export$7ab6fa38cecaeee2.set(color.toLowerCase(), label);
});
var $6cc5d303e3007389$export$8c5a050822fd698c = (0, $eNjcd.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $3G1IB.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $6cc5d303e3007389$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $6cc5d303e3007389$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $kgm12.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $1U0rY.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $7VJss.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            (0, $1YMOy.default)({
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, 'data-background-custom-color', mark.attrs.color)
        ];
    }
});

});
parcelRegister("1U0rY", function(module, exports) {
$parcel$export(module.exports, "getGlobalTheme", function () { return $162b5ecc8c87e88c$export$813ecdf77207a053; });
$parcel$export(module.exports, "textColor", function () { return $162b5ecc8c87e88c$export$32f78bffcd82ff28; });

var $1YMOy = parcelRequire("1YMOy");

var $a8Fwx = parcelRequire("a8Fwx");

var $eNjcd = parcelRequire("eNjcd");

var $kgm12 = parcelRequire("kgm12");

var $3G1IB = parcelRequire("3G1IB");

var $7VJss = parcelRequire("7VJss");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
var $162b5ecc8c87e88c$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $3G1IB.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $3G1IB.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $3G1IB.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $3G1IB.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $3G1IB.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $3G1IB.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $3G1IB.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $3G1IB.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $3G1IB.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $3G1IB.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $3G1IB.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $3G1IB.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $3G1IB.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $3G1IB.N0),
        'White'
    ],
    [
        (0, $3G1IB.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $3G1IB.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $3G1IB.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $3G1IB.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $3G1IB.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $3G1IB.P50),
        'Light purple'
    ] // Lavender secret
];
var $162b5ecc8c87e88c$export$569885e57444f84a = new Map();
var $162b5ecc8c87e88c$export$81e5ed9e84fe2e28 = $162b5ecc8c87e88c$export$569885e57444f84a;
$162b5ecc8c87e88c$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $a8Fwx.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $162b5ecc8c87e88c$export$569885e57444f84a.set(color.toLowerCase(), label);
});
// these are for test only
var $162b5ecc8c87e88c$var$testGlobalTheme;
var $162b5ecc8c87e88c$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $162b5ecc8c87e88c$var$testGlobalTheme = theme;
};
var $162b5ecc8c87e88c$export$813ecdf77207a053 = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($162b5ecc8c87e88c$var$testGlobalTheme) return {
        colorMode: $162b5ecc8c87e88c$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
var $162b5ecc8c87e88c$export$32f78bffcd82ff28 = (0, $eNjcd.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $3G1IB.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $162b5ecc8c87e88c$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $162b5ecc8c87e88c$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $kgm12.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($162b5ecc8c87e88c$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $7VJss.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            (0, $1YMOy.default)({
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, 'data-text-custom-color', mark.attrs.color)
        ];
    }
});

});


parcelRegister("8Y0bD", function(module, exports) {
$parcel$export(module.exports, "border", function () { return $6874126355b0c2f4$export$1edee58a52776cd9; });

var $a8Fwx = parcelRequire("a8Fwx");

var $eNjcd = parcelRequire("eNjcd");

var $kgm12 = parcelRequire("kgm12");

var $3G1IB = parcelRequire("3G1IB");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ var $6874126355b0c2f4$var$borderColorArrayPalette = [
    [
        (0, $3G1IB.N300A),
        'Subtle gray'
    ],
    [
        (0, $3G1IB.N600),
        'Gray'
    ],
    [
        (0, $3G1IB.N1000),
        'Bold gray'
    ]
];
var $6874126355b0c2f4$export$e4e044c989c86ca7 = new Map();
$6874126355b0c2f4$var$borderColorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $a8Fwx.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $6874126355b0c2f4$export$e4e044c989c86ca7.set(color.toLowerCase(), label);
});
var $6874126355b0c2f4$export$1edee58a52776cd9 = (0, $eNjcd.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: function getAttrs(domNode) {
                var _dom$getAttribute, _dom$getAttribute2;
                var dom = domNode;
                var color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                var size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $6874126355b0c2f4$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM: function toDOM(mark, isInline) {
        var wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        var paletteColorValue = (0, $kgm12.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }
        ];
    }
});

});

parcelRegister("c5ZSc", function(module, exports) {
$parcel$export(module.exports, "breakout", function () { return $8ce5f264af4bb2a2$export$89015c65f1c75e3f; });

var $eNjcd = parcelRequire("eNjcd");
var $8ce5f264af4bb2a2$var$allowedTypes = [
    'wide',
    'full-width'
];
var $8ce5f264af4bb2a2$export$89015c65f1c75e3f = (0, $eNjcd.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs: function getAttrs(dom) {
                var mode = dom.getAttribute('data-mode');
                var width = dom.getAttribute('data-width');
                return {
                    mode: $8ce5f264af4bb2a2$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var _mark$attrs;
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("eMlDB", function(module, exports) {
$parcel$export(module.exports, "code", function () { return $ac2655321a3e5a7f$export$6565f9f03506010b; });

var $eNjcd = parcelRequire("eNjcd");
var $ac2655321a3e5a7f$export$6565f9f03506010b = (0, $eNjcd.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("jeuXu", function(module, exports) {
$parcel$export(module.exports, "confluenceInlineComment", function () { return $e00756dd5729901d$export$f3b72f8fc4684ecd; });

var $eNjcd = parcelRequire("eNjcd");
var $e00756dd5729901d$export$f3b72f8fc4684ecd = (0, $eNjcd.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("cHw09", function(module, exports) {
$parcel$export(module.exports, "dataConsumer", function () { return $93f252fbc5d45318$export$3024f02c495408d6; });

var $1YMOy = parcelRequire("1YMOy");

var $eNjcd = parcelRequire("eNjcd");

var $bsB7c = parcelRequire("bsB7c");
function $93f252fbc5d45318$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $93f252fbc5d45318$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $93f252fbc5d45318$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $93f252fbc5d45318$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ var $93f252fbc5d45318$var$parseDataConsumer = function parseDataConsumer(maybeValue) {
    var sources = (0, $bsB7c.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch (_unused) {
        return false;
    }
};
var $93f252fbc5d45318$export$3024f02c495408d6 = (0, $eNjcd.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: function getAttrs(maybeValue) {
                return $93f252fbc5d45318$var$parseDataConsumer(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
var $93f252fbc5d45318$export$54fd2c36b5cc6731 = function toJSON(mark) {
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter(function(key) {
            return key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null;
        }).reduce(function(acc, key) {
            return $93f252fbc5d45318$var$_objectSpread($93f252fbc5d45318$var$_objectSpread({}, acc), {}, (0, $1YMOy.default)({}, key, mark.attrs[key]));
        }, {})
    };
};

});
parcelRegister("bsB7c", function(module, exports) {
$parcel$export(module.exports, "isDOMElement", function () { return $857f198744e4168b$export$c296e2d4365c37a5; });
var $857f198744e4168b$export$c296e2d4365c37a5 = function isDOMElement(maybeNode) {
    return maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;
};

});


parcelRegister("j0vam", function(module, exports) {
$parcel$export(module.exports, "em", function () { return $dd66315b456cacf4$export$c63c6f932822f543; });

var $eNjcd = parcelRequire("eNjcd");
/**
 * @name em_mark
 */ var $dd66315b456cacf4$var$emDOM = [
    'em'
];
var $dd66315b456cacf4$export$c63c6f932822f543 = (0, $eNjcd.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM: function toDOM() {
        return $dd66315b456cacf4$var$emDOM;
    }
});

});

parcelRegister("fU1Bq", function(module, exports) {
$parcel$export(module.exports, "fragment", function () { return $b93d5436393175dd$export$f00aeb236b6f05af; });

var $1YMOy = parcelRequire("1YMOy");

var $eNjcd = parcelRequire("eNjcd");

var $bsB7c = parcelRequire("bsB7c");
function $b93d5436393175dd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b93d5436393175dd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b93d5436393175dd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b93d5436393175dd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ var $b93d5436393175dd$var$parseFragment = function parseFragment(maybeValue) {
    var _maybeValue$getAttrib;
    if (!(0, $bsB7c.isDOMElement)(maybeValue)) return false;
    var name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    var localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
var $b93d5436393175dd$export$f00aeb236b6f05af = (0, $eNjcd.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: function getAttrs(maybeValue) {
                return $b93d5436393175dd$var$parseFragment(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
var $b93d5436393175dd$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: $b93d5436393175dd$var$_objectSpread({
            localId: mark.attrs.localId
        }, mark.attrs.name ? {
            name: mark.attrs.name
        } : {})
    };
};

});

parcelRegister("6d2bd", function(module, exports) {
$parcel$export(module.exports, "indentation", function () { return $4855a5d5320667fb$export$480c699bd4ec0d86; });

var $eNjcd = parcelRequire("eNjcd");
var $4855a5d5320667fb$export$480c699bd4ec0d86 = (0, $eNjcd.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs: function getAttrs(dom) {
                var level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("ajG4R", function(module, exports) {
$parcel$export(module.exports, "link", function () { return $782c516d5c6f031c$export$9c30223ca0a664fb; });

var $1YMOy = parcelRequire("1YMOy");

var $eNjcd = parcelRequire("eNjcd");

var $a4pR9 = parcelRequire("a4pR9");
function $782c516d5c6f031c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $782c516d5c6f031c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $782c516d5c6f031c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $782c516d5c6f031c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $782c516d5c6f031c$export$b5f67017585d1431 = function getLinkAttrs(attribute) {
    return function(domNode) {
        var dom = domNode;
        var href = dom.getAttribute(attribute) || '';
        var attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $a4pR9.isSafeUrl)(href)) return false;
        if ((0, $a4pR9.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $a4pR9.normalizeUrl)(href);
        return attrs;
    };
};
var $782c516d5c6f031c$export$9c30223ca0a664fb = (0, $eNjcd.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $782c516d5c6f031c$export$b5f67017585d1431('data-block-link'),
            contentElement: function contentElement(node) {
                var clone = node.cloneNode(true);
                clone.removeAttribute('data-block-link');
                clone.setAttribute('data-skip-paste', 'true');
                var wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $782c516d5c6f031c$export$b5f67017585d1431('href')
        }
    ],
    toDOM: function toDOM(node, isInline) {
        var attrs = Object.keys(node.attrs).reduce(function(attrs, key) {
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $a4pR9.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            $782c516d5c6f031c$var$_objectSpread($782c516d5c6f031c$var$_objectSpread({}, attrs), {}, (0, $1YMOy.default)((0, $1YMOy.default)({}, 'data-block-link', 'true'), "class", 'blockLink')),
            0
        ];
    }
});
var $782c516d5c6f031c$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
var $782c516d5c6f031c$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce(function(attrs, key) {
            if ($782c516d5c6f031c$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    };
};

});
parcelRegister("a4pR9", function(module, exports) {
$parcel$export(module.exports, "isSafeUrl", function () { return $754e559ef30256ef$export$c9f92f5469372e0f; });
$parcel$export(module.exports, "normalizeUrl", function () { return $754e559ef30256ef$export$6535eb414fa2c8b6; });
$parcel$export(module.exports, "isRootRelative", function () { return $754e559ef30256ef$export$23579274a7a24f7b; });
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $6G09S = parcelRequire("6G09S");
var $754e559ef30256ef$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
var $754e559ef30256ef$export$c9f92f5469372e0f = function isSafeUrl(url) {
    var urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $754e559ef30256ef$var$whitelistedURLPatterns.some(function(p) {
        return p.test(urlTrimmed);
    });
};
var $754e559ef30256ef$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($6G09S)))();
$754e559ef30256ef$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$754e559ef30256ef$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
var $754e559ef30256ef$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$754e559ef30256ef$export$8ccbde94d5c7f8e7.add('tel:', $754e559ef30256ef$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$754e559ef30256ef$export$8ccbde94d5c7f8e7.add('file:', $754e559ef30256ef$var$urlWithoutSpacesValidator);
$754e559ef30256ef$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
var $754e559ef30256ef$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
var $754e559ef30256ef$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$754e559ef30256ef$var$tlds.push($754e559ef30256ef$var$tlds2Char);
$754e559ef30256ef$export$8ccbde94d5c7f8e7.tlds($754e559ef30256ef$var$tlds, false);
var $754e559ef30256ef$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
var $754e559ef30256ef$export$6f7d7761b97f967 = function linkifyMatch(text) {
    if (!$754e559ef30256ef$export$746d02eae03c72e1.test(text)) return [];
    var matches = [];
    var startpos = 0;
    var substr;
    while(substr = text.substr(startpos)){
        var link = (substr.match($754e559ef30256ef$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            var index = substr.search($754e559ef30256ef$export$746d02eae03c72e1);
            var start = index >= 0 ? index + startpos : index;
            var end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $754e559ef30256ef$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    var match = $754e559ef30256ef$export$6f7d7761b97f967(str);
    if (!match.length) match = $754e559ef30256ef$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $754e559ef30256ef$export$6535eb414fa2c8b6(url) {
    var match = $754e559ef30256ef$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $754e559ef30256ef$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});
parcelRegister("6G09S", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $4dc6c9c6046af9b2$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $4dc6c9c6046af9b2$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $4dc6c9c6046af9b2$var$isString(obj) {
    return $4dc6c9c6046af9b2$var$_class(obj) === '[object String]';
}
function $4dc6c9c6046af9b2$var$isObject(obj) {
    return $4dc6c9c6046af9b2$var$_class(obj) === '[object Object]';
}
function $4dc6c9c6046af9b2$var$isRegExp(obj) {
    return $4dc6c9c6046af9b2$var$_class(obj) === '[object RegExp]';
}
function $4dc6c9c6046af9b2$var$isFunction(obj) {
    return $4dc6c9c6046af9b2$var$_class(obj) === '[object Function]';
}
function $4dc6c9c6046af9b2$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $4dc6c9c6046af9b2$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $4dc6c9c6046af9b2$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $4dc6c9c6046af9b2$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $4dc6c9c6046af9b2$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $4dc6c9c6046af9b2$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $4dc6c9c6046af9b2$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $4dc6c9c6046af9b2$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $4dc6c9c6046af9b2$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $4dc6c9c6046af9b2$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $4dc6c9c6046af9b2$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("lX4sA"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($4dc6c9c6046af9b2$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($4dc6c9c6046af9b2$var$isObject(val)) {
            if ($4dc6c9c6046af9b2$var$isRegExp(val.validate)) compiled.validate = $4dc6c9c6046af9b2$var$createValidator(val.validate);
            else if ($4dc6c9c6046af9b2$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($4dc6c9c6046af9b2$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $4dc6c9c6046af9b2$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($4dc6c9c6046af9b2$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $4dc6c9c6046af9b2$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($4dc6c9c6046af9b2$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $4dc6c9c6046af9b2$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $4dc6c9c6046af9b2$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $4dc6c9c6046af9b2$var$createMatch(self, shift) {
    var match = new $4dc6c9c6046af9b2$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $4dc6c9c6046af9b2$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $4dc6c9c6046af9b2$var$LinkifyIt)) return new $4dc6c9c6046af9b2$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($4dc6c9c6046af9b2$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $4dc6c9c6046af9b2$var$assign({}, $4dc6c9c6046af9b2$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $4dc6c9c6046af9b2$var$assign({}, $4dc6c9c6046af9b2$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $4dc6c9c6046af9b2$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $4dc6c9c6046af9b2$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $4dc6c9c6046af9b2$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $4dc6c9c6046af9b2$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $4dc6c9c6046af9b2$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $4dc6c9c6046af9b2$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $4dc6c9c6046af9b2$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $4dc6c9c6046af9b2$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $4dc6c9c6046af9b2$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $4dc6c9c6046af9b2$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($4dc6c9c6046af9b2$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($4dc6c9c6046af9b2$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $4dc6c9c6046af9b2$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $4dc6c9c6046af9b2$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $4dc6c9c6046af9b2$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $4dc6c9c6046af9b2$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $4dc6c9c6046af9b2$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $4dc6c9c6046af9b2$var$LinkifyIt;

});
parcelRegister("lX4sA", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("cESS3")).source;
    re.src_Cc = (parcelRequire("1ladB")).source;
    re.src_Z = (parcelRequire("aKpnB")).source;
    re.src_P = (parcelRequire("9R3PW")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,4}[a-zA-Z0-9%/]|' + // github has ... in commit range links,
    // google has .... in links (issue #66)
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});




parcelRegister("fKtA4", function(module, exports) {
$parcel$export(module.exports, "strike", function () { return $b772190722700a02$export$4899a95d70ec5056; });

var $eNjcd = parcelRequire("eNjcd");
var $b772190722700a02$export$4899a95d70ec5056 = (0, $eNjcd.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: function getAttrs(value) {
                return value === 'line-through' && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            's'
        ];
    }
});

});

parcelRegister("iZbsN", function(module, exports) {
$parcel$export(module.exports, "strong", function () { return $dd26d0eba92e8259$export$59ae2c325a998f89; });

var $eNjcd = parcelRequire("eNjcd");
/**
 * @name strong_mark
 */ var $dd26d0eba92e8259$var$strongDOM = [
    'strong'
];
var $dd26d0eba92e8259$export$59ae2c325a998f89 = (0, $eNjcd.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs: function getAttrs(node) {
                var element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs: function getAttrs(node) {
                var element = node;
                var fontWeight = element.style.fontWeight;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return $dd26d0eba92e8259$var$strongDOM;
    }
});

});

parcelRegister("f623j", function(module, exports) {
$parcel$export(module.exports, "subsup", function () { return $afd9021b965aa1b5$export$b3401ee80eb31041; });

var $eNjcd = parcelRequire("eNjcd");
/**
 * @name subsup_mark
 */ function $afd9021b965aa1b5$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
var $afd9021b965aa1b5$export$b3401ee80eb31041 = (0, $eNjcd.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: function getAttrs(node) {
                return $afd9021b965aa1b5$var$getAttrFromVerticalAlign(node);
            }
        },
        {
            style: 'vertical-align=sub',
            getAttrs: function getAttrs(node) {
                return $afd9021b965aa1b5$var$getAttrFromVerticalAlign(node);
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("dV25i", function(module, exports) {
$parcel$export(module.exports, "typeAheadQuery", function () { return $a2223727e58f5604$export$20af3dabbb5538df; });

var $eNjcd = parcelRequire("eNjcd");

var $3G1IB = parcelRequire("3G1IB");
var $a2223727e58f5604$export$20af3dabbb5538df = (0, $eNjcd.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: "color: ".concat((0, $3G1IB.B400))
            }
        ];
    }
});

});

parcelRegister("5TYds", function(module, exports) {
$parcel$export(module.exports, "underline", function () { return $44c0cc736738f4c1$export$425327af25286e5e; });

var $eNjcd = parcelRequire("eNjcd");
var $44c0cc736738f4c1$export$425327af25286e5e = (0, $eNjcd.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: function getAttrs(value) {
                return value === 'underline' && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            'u'
        ];
    }
});

});

parcelRegister("5uc46", function(module, exports) {
$parcel$export(module.exports, "unsupportedMark", function () { return $3fe91cf72a678f19$export$30d78d5eb6719bb8; });

var $eNjcd = parcelRequire("eNjcd");
var $3fe91cf72a678f19$export$30d78d5eb6719bb8 = (0, $eNjcd.unsupportedMark)({
    toDOM: function toDOM() {
        return [
            'span'
        ];
    }
});

});

parcelRegister("2BisJ", function(module, exports) {
$parcel$export(module.exports, "unsupportedNodeAttribute", function () { return $1e4d5bb5c5fcab67$export$a316dc07ff5182a2; });

var $eNjcd = parcelRequire("eNjcd");
var $1e4d5bb5c5fcab67$export$a316dc07ff5182a2 = (0, $eNjcd.unsupportedNodeAttribute)({
    toDOM: function toDOM() {
        return [
            'span'
        ];
    }
});

});

parcelRegister("6mMzQ", function(module, exports) {
$parcel$export(module.exports, "blockCard", function () { return $4a2a7a9409534959$export$c4c2f833baaebdb8; });

var $1YMOy = parcelRequire("1YMOy");

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
function $4a2a7a9409534959$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4a2a7a9409534959$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4a2a7a9409534959$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4a2a7a9409534959$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name blockCard_node
 */ var $4a2a7a9409534959$var$getCommonAttributesFromDom = function getCommonAttributesFromDom(dom) {
    var anchor = dom;
    var data = anchor.getAttribute('data-card-data');
    var datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
var $4a2a7a9409534959$export$c4c2f833baaebdb8 = (0, $35i9Y.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $4a2a7a9409534959$var$_objectSpread({
                    url: anchor.getAttribute('href') || undefined
                }, $4a2a7a9409534959$var$getCommonAttributesFromDom(dom));
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $4a2a7a9409534959$var$_objectSpread({
                    url: anchor.getAttribute('data-card-url') || undefined
                }, $4a2a7a9409534959$var$getCommonAttributesFromDom(dom));
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var _ref = node.attrs, url = _ref.url;
        var _ref2 = node.attrs, data = _ref2.data;
        var _ref3 = node.attrs, layout = _ref3.layout, width = _ref3.width, datasource = _ref3.datasource;
        var attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': "".concat(width)
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});
var $4a2a7a9409534959$export$9894f24949f094e5 = (0, $35i9Y.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $4a2a7a9409534959$var$_objectSpread($4a2a7a9409534959$var$_objectSpread({
                    url: anchor.getAttribute('href') || undefined
                }, $4a2a7a9409534959$var$getCommonAttributesFromDom(dom)), {}, {
                    localId: (0, $dS3bo.uuid).generate()
                });
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $4a2a7a9409534959$var$_objectSpread($4a2a7a9409534959$var$_objectSpread({
                    url: anchor.getAttribute('data-card-url') || undefined
                }, $4a2a7a9409534959$var$getCommonAttributesFromDom(dom)), {}, {
                    localId: (0, $dS3bo.uuid).generate()
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2, _node$attrs3;
        var _ref4 = node.attrs, url = _ref4.url;
        var _ref5 = node.attrs, data = _ref5.data;
        var _ref6 = node.attrs, layout = _ref6.layout, width = _ref6.width, datasource = _ref6.datasource;
        var attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': "".concat(width),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.url) || ' '
        ];
    }
});

});

parcelRegister("5sacJ", function(module, exports) {
$parcel$export(module.exports, "taskItem", function () { return $3f877ba8351ab5ec$export$6d8b0ef52e2e6390; });
$parcel$export(module.exports, "blockTaskItem", function () { return $3f877ba8351ab5ec$export$16018c61064a18df; });

var $dS3bo = parcelRequire("dS3bo");

var $35i9Y = parcelRequire("35i9Y");
var $3f877ba8351ab5ec$export$6d8b0ef52e2e6390 = (0, $35i9Y.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $dS3bo.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $3f877ba8351ab5ec$export$16018c61064a18df = (0, $35i9Y.blockTaskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-is-block]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $dS3bo.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2 = node.attrs, localId = _node$attrs2.localId, state = _node$attrs2.state;
        var attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO',
            'data-task-is-block': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("DFUIs", function(module, exports) {
$parcel$export(module.exports, "bodiedExtension", function () { return $077427d5d739f894$export$27903d543b563e39; });

var $dAkqA = parcelRequire("dAkqA");

var $35i9Y = parcelRequire("35i9Y");
var $077427d5d739f894$export$27903d543b563e39 = (0, $35i9Y.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $dAkqA.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("9RUN2", function(module, exports) {
$parcel$export(module.exports, "bulletList", function () { return $72f51d961bf3ef29$export$a140c94e5ea26bee; });

var $dS3bo = parcelRequire("dS3bo");

var $35i9Y = parcelRequire("35i9Y");
var $72f51d961bf3ef29$export$5f25a39efab3b58b = '.ak-ul';
var $72f51d961bf3ef29$export$a140c94e5ea26bee = (0, $35i9Y.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $72f51d961bf3ef29$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});
var $72f51d961bf3ef29$export$dfd406053b2bab40 = (0, $35i9Y.bulletList)({
    parseDOM: [
        {
            tag: 'ul',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            class: $72f51d961bf3ef29$export$5f25a39efab3b58b.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("claEk", function(module, exports) {
$parcel$export(module.exports, "caption", function () { return $8fbfb4f1a6a559d8$export$8e3c2dfdc4f0453d; });

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
var $8fbfb4f1a6a559d8$export$8e3c2dfdc4f0453d = (0, $35i9Y.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});
var $8fbfb4f1a6a559d8$export$b5d01ee303c467aa = (0, $35i9Y.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-caption': 'true',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("8eXsH", function(module, exports) {
$parcel$export(module.exports, "codeBlock", function () { return $5ffdc16f21b215ff$export$7bb0d5c671655cc4; });

var $cENKH = parcelRequire("cENKH");

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
/**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_node
 */ var $5ffdc16f21b215ff$var$getLanguageFromEditorStyle = function getLanguageFromEditorStyle(dom) {
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
var $5ffdc16f21b215ff$var$getLanguageFromBitbucketStyle = function getLanguageFromBitbucketStyle(dom) {
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $5ffdc16f21b215ff$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
var $5ffdc16f21b215ff$var$getLanguageFromCode = function getLanguageFromCode(dom) {
    var firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
var $5ffdc16f21b215ff$var$extractLanguageFromClass = function extractLanguageFromClass(className) {
    var languageRegex = /(?:^|\s)language-([^\s]+)/;
    var result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
var $5ffdc16f21b215ff$var$removeLastNewLine = function removeLastNewLine(dom) {
    var parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
    return dom;
};
function $5ffdc16f21b215ff$var$parseCodeFromHtml(node) {
    var code = '';
    node.childNodes.forEach(function(child) {
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            var tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $5ffdc16f21b215ff$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
var $5ffdc16f21b215ff$export$7bb0d5c671655cc4 = (0, $35i9Y.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var language = $5ffdc16f21b215ff$var$getLanguageFromBitbucketStyle(dom.parentElement) || $5ffdc16f21b215ff$var$getLanguageFromEditorStyle(dom.parentElement) || $5ffdc16f21b215ff$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $5ffdc16f21b215ff$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: function getContent(domNode, schema) {
                var code = $5ffdc16f21b215ff$var$parseCodeFromHtml(domNode);
                return code ? (0, $cENKH.Fragment).from(schema.text(code)) : (0, $cENKH.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(dom) {
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                var lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach(function(line) {
                    return line.remove();
                });
                return {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
var $5ffdc16f21b215ff$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(memo, key) {
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    };
};
var $5ffdc16f21b215ff$export$3f75de798a0b5356 = (0, $35i9Y.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var language = $5ffdc16f21b215ff$var$getLanguageFromBitbucketStyle(dom.parentElement) || $5ffdc16f21b215ff$var$getLanguageFromEditorStyle(dom.parentElement) || $5ffdc16f21b215ff$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $5ffdc16f21b215ff$var$removeLastNewLine(dom);
                return {
                    language: language,
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: function getContent(domNode, schema) {
                var code = $5ffdc16f21b215ff$var$parseCodeFromHtml(domNode);
                return code ? (0, $cENKH.Fragment).from(schema.text(code)) : (0, $cENKH.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(dom) {
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                var lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach(function(line) {
                    return line.remove();
                });
                return {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});

});

parcelRegister("a7fGe", function(module, exports) {
$parcel$export(module.exports, "confluenceJiraIssue", function () { return $75d6b89b18c397cd$export$daf889beb5092f95; });

var $35i9Y = parcelRequire("35i9Y");
var $75d6b89b18c397cd$var$name = 'confluenceJiraIssue';
var $75d6b89b18c397cd$export$daf889beb5092f95 = (0, $35i9Y.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: "span[data-node-type=\"".concat($75d6b89b18c397cd$var$name, "\"]"),
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': $75d6b89b18c397cd$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("dDXbH", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedBlock", function () { return $9eecd44da753db19$export$e6e4878f43c27cab; });

var $35i9Y = parcelRequire("35i9Y");
var $9eecd44da753db19$var$name = 'confluenceUnsupportedBlock';
var $9eecd44da753db19$export$e6e4878f43c27cab = (0, $35i9Y.confluenceUnsupportedBlock)({
    toDOM: function toDOM(node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        var attrs = {
            'data-node-type': $9eecd44da753db19$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($9eecd44da753db19$var$name, "\"]"),
            getAttrs: function getAttrs(dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("9YFvh", function(module, exports) {
$parcel$export(module.exports, "confluenceUnsupportedInline", function () { return $7439e963684b03ca$export$3e6d667072febc87; });

var $35i9Y = parcelRequire("35i9Y");
var $7439e963684b03ca$var$name = 'confluenceUnsupportedInline';
var $7439e963684b03ca$export$3e6d667072febc87 = (0, $35i9Y.confluenceUnsupportedInline)({
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': $7439e963684b03ca$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($7439e963684b03ca$var$name, "\"]"),
            getAttrs: function getAttrs(dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("7C5L2", function(module, exports) {
$parcel$export(module.exports, "date", function () { return $58b08c5f85b5b872$export$324d90190a8b822a; });

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
var $58b08c5f85b5b872$export$324d90190a8b822a = (0, $35i9Y.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: function getAttrs(dom) {
                return {
                    timestamp: dom.getAttribute('data-timestamp')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});
var $58b08c5f85b5b872$export$a6a035390e3921b2 = (0, $35i9Y.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: function getAttrs(dom) {
                return {
                    timestamp: dom.getAttribute('data-timestamp'),
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("g4DXa", function(module, exports) {
$parcel$export(module.exports, "decisionItem", function () { return $bb3c02f2190f0044$export$6959e16eeff859b4; });

var $dS3bo = parcelRequire("dS3bo");

var $35i9Y = parcelRequire("35i9Y");
var $bb3c02f2190f0044$export$6959e16eeff859b4 = (0, $35i9Y.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $dS3bo.uuid).generate(),
                    state: dom.getAttribute('data-decision-state')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});

parcelRegister("bLcwV", function(module, exports) {
$parcel$export(module.exports, "decisionList", function () { return $88fdcdb5247a3d7c$export$62d45a65fb43d95e; });

var $dS3bo = parcelRequire("dS3bo");

var $35i9Y = parcelRequire("35i9Y");
/**
 * @name decisionList_node
 */ var $88fdcdb5247a3d7c$var$name = 'decisionList';
var $88fdcdb5247a3d7c$export$a5393ce68c2ff601 = "[data-node-type=\"".concat($88fdcdb5247a3d7c$var$name, "\"]");
var $88fdcdb5247a3d7c$export$62d45a65fb43d95e = (0, $35i9Y.decisionList)({
    parseDOM: [
        {
            tag: "ol".concat($88fdcdb5247a3d7c$export$a5393ce68c2ff601),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-node-type': $88fdcdb5247a3d7c$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("7NNlE", function(module, exports) {
$parcel$export(module.exports, "doc", function () { return $5ae3638b1287f2e1$export$2a111da947c407d2; });

var $35i9Y = parcelRequire("35i9Y");
var $5ae3638b1287f2e1$export$2a111da947c407d2 = (0, $35i9Y.doc)({});

});

parcelRegister("ibsHe", function(module, exports) {
$parcel$export(module.exports, "embedCard", function () { return $d3cf83934b8d3362$export$be4283d9a1cb1ff6; });

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
var $d3cf83934b8d3362$export$be4283d9a1cb1ff6 = (0, $35i9Y.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: function getAttrs(dom) {
                return {
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, url = _node$attrs.url, layout = _node$attrs.layout, width = _node$attrs.width, originalWidth = _node$attrs.originalWidth, originalHeight = _node$attrs.originalHeight;
        var attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});
var $d3cf83934b8d3362$export$36734475a7f6fd3e = (0, $35i9Y.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: function getAttrs(dom) {
                return {
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null,
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3;
        var _node$attrs2 = node.attrs, url = _node$attrs2.url, layout = _node$attrs2.layout, width = _node$attrs2.width, originalWidth = _node$attrs2.originalWidth, originalHeight = _node$attrs2.originalHeight;
        var attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId) || undefined
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("73CSr", function(module, exports) {
$parcel$export(module.exports, "emoji", function () { return $5236f85f20935fc1$export$a19185d1233fc4b2; });

var $1YMOy = parcelRequire("1YMOy");

var $eHwH7 = parcelRequire("eHwH7");

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
function $5236f85f20935fc1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5236f85f20935fc1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5236f85f20935fc1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5236f85f20935fc1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5236f85f20935fc1$export$a19185d1233fc4b2 = (0, $35i9Y.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: function getAttrs(dom) {
                return (0, $eHwH7.acNameToEmoji)(dom.getAttribute('data-emoticon-name'));
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: function getAttrs(dom) {
                return (0, $eHwH7.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'));
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, shortName = _node$attrs.shortName, id = _node$attrs.id, text = _node$attrs.text;
        var attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
var $5236f85f20935fc1$export$ebb3b3c7a0ac9936 = (0, $35i9Y.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: function getAttrs(dom) {
                var attrs = (0, $eHwH7.acNameToEmoji)(dom.getAttribute('data-emoticon-name'));
                return $5236f85f20935fc1$var$_objectSpread($5236f85f20935fc1$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $dS3bo.uuid).generate()
                });
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: function getAttrs(dom) {
                var attrs = (0, $eHwH7.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'));
                return $5236f85f20935fc1$var$_objectSpread($5236f85f20935fc1$var$_objectSpread({}, attrs), {}, {
                    localId: (0, $dS3bo.uuid).generate()
                });
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $5236f85f20935fc1$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3;
        var _node$attrs2 = node.attrs, shortName = _node$attrs2.shortName, id = _node$attrs2.id, text = _node$attrs2.text;
        var attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("eHwH7", function(module, exports) {
$parcel$export(module.exports, "acNameToEmoji", function () { return $ab3e714c84617cb4$export$f61e93bda2a8b420; });
$parcel$export(module.exports, "acShortcutToEmoji", function () { return $ab3e714c84617cb4$export$441f8b58f5790a68; });
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
var $ab3e714c84617cb4$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
var $ab3e714c84617cb4$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
var $ab3e714c84617cb4$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ var $ab3e714c84617cb4$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        "\uD83D\uDE42"
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        "\uD83D\uDE41"
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        "\uD83D\uDE1B"
    ],
    laugh: [
        '1f600',
        ':grinning:',
        "\uD83D\uDE00"
    ],
    wink: [
        '1f609',
        ':wink:',
        "\uD83D\uDE09"
    ],
    information: [
        '2139',
        ':information_source:',
        "\u2139"
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        "\u2705"
    ],
    cross: [
        '274c',
        ':x:',
        "\u274C"
    ],
    warning: [
        '26a0',
        ':warning:',
        "\u26A0"
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        "\u2795"
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        "\u2796"
    ],
    question: [
        '2753',
        ':question:',
        "?"
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        "\uD83D\uDC4D"
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        "\uD83D\uDC4E"
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        "\uD83D\uDCA1"
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        "\uD83D\uDC9B"
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        "\uD83D\uDEAB"
    ],
    'red-star': [
        '2764',
        ':heart:',
        "\u2764\uFE0F"
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        "\uD83D\uDC9A"
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        "\uD83D\uDC99"
    ],
    heart: [
        '2764',
        ':heart:',
        "\u2764\uFE0F"
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        "\uD83D\uDC94"
    ]
};
function $ab3e714c84617cb4$export$f61e93bda2a8b420(acName) {
    var emojiData = $ab3e714c84617cb4$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $ab3e714c84617cb4$var$DEFAULT_EMOJI_ID,
        shortName: ":".concat(acName, ":"),
        text: ''
    };
}
function $ab3e714c84617cb4$export$bc94e44ec0e7bd82(emojiId) {
    var filterEmojis = function filterEmojis(acName) {
        return $ab3e714c84617cb4$var$acNameToEmojiMap[acName] ? $ab3e714c84617cb4$var$acNameToEmojiMap[acName][0] === emojiId : false;
    };
    return Object.keys($ab3e714c84617cb4$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $ab3e714c84617cb4$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: "".concat($ab3e714c84617cb4$var$HC_EMOTICON_PREFIX).concat(hipchatEmoticonShortName),
        shortName: ":".concat(hipchatEmoticonShortName, ":"),
        text: ''
    };
}
function $ab3e714c84617cb4$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $ab3e714c84617cb4$export$880a2465992fbbe(_ref) {
    var id = _ref.id, shortName = _ref.shortName;
    if ($ab3e714c84617cb4$var$DEFAULT_EMOJI_ID === id) {
        var possibleName = $ab3e714c84617cb4$var$getAcNameFromShortName(shortName);
        if (possibleName in $ab3e714c84617cb4$var$acNameToEmojiMap) return possibleName;
    }
    return $ab3e714c84617cb4$export$bc94e44ec0e7bd82(id) || $ab3e714c84617cb4$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("cbmTE", function(module, exports) {
$parcel$export(module.exports, "extendedBlockquote", function () { return $8de845e3a37e9954$export$70a64939da3e8455; });

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
/**
 * @name blockquote_node
 */ var $8de845e3a37e9954$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM: function toDOM() {
        return [
            'blockquote',
            0
        ];
    }
};
var $8de845e3a37e9954$export$67dc04e652a298ca = (0, $35i9Y.blockquoteLegacy)($8de845e3a37e9954$var$nodeSpecOptions);
var $8de845e3a37e9954$export$70a64939da3e8455 = (0, $35i9Y.blockquote)($8de845e3a37e9954$var$nodeSpecOptions);
var $8de845e3a37e9954$var$nodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'blockquote',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            'blockquote',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            },
            0
        ];
    }
};
var $8de845e3a37e9954$export$950ebf43f3364a0f = (0, $35i9Y.blockquote)($8de845e3a37e9954$var$nodeSpecOptionsWithLocalId);

});

parcelRegister("2cUVb", function(module, exports) {
$parcel$export(module.exports, "extendedPanel", function () { return $19b8db2a3bf05110$export$ce20b13564211141; });

var $1YMOy = parcelRequire("1YMOy");

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
function $19b8db2a3bf05110$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $19b8db2a3bf05110$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $19b8db2a3bf05110$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $19b8db2a3bf05110$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $19b8db2a3bf05110$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ var $19b8db2a3bf05110$var$getDomAttrs = function getDomAttrs(nodeAttrs) {
    var attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor,
        'data-local-id': (nodeAttrs === null || nodeAttrs === void 0 ? void 0 : nodeAttrs.localId) || undefined
    };
    return attrs;
};
var $19b8db2a3bf05110$var$getParseDOMAttrs = function getParseDOMAttrs(allowCustomPanel, dom, generateLocalId) {
    var parseDOMAttrs = {
        panelType: dom.getAttribute('data-panel-type')
    };
    if (generateLocalId) parseDOMAttrs.localId = (0, $dS3bo.uuid).generate();
    if (allowCustomPanel) parseDOMAttrs = $19b8db2a3bf05110$var$_objectSpread($19b8db2a3bf05110$var$_objectSpread({}, parseDOMAttrs), {}, {
        panelIcon: dom.getAttribute('data-panel-icon'),
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        panelColor: dom.getAttribute('data-panel-color')
    });
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $19b8db2a3bf05110$export$969277cf61e5a7aa.CUSTOM ? $19b8db2a3bf05110$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
var $19b8db2a3bf05110$var$createPanelNodeSpecOptions = function createPanelNodeSpecOptions(allowCustomPanel, generateLocalId) {
    return {
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: function getAttrs(dom) {
                    return $19b8db2a3bf05110$var$getParseDOMAttrs(allowCustomPanel, dom, generateLocalId);
                }
            }
        ],
        toDOM: function toDOM(node) {
            var attrs = $19b8db2a3bf05110$var$getDomAttrs(node.attrs);
            var contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    };
};
var $19b8db2a3bf05110$export$ce20b13564211141 = function extendedPanel(allowCustomPanel) {
    return (0, $35i9Y.panel)($19b8db2a3bf05110$var$createPanelNodeSpecOptions(allowCustomPanel));
};
var $19b8db2a3bf05110$export$855c3c67c9c9ebaf = function extendedPanelWithLocalId(allowCustomPanel) {
    return (0, $35i9Y.panel)($19b8db2a3bf05110$var$createPanelNodeSpecOptions(allowCustomPanel, true));
};

});

parcelRegister("d9aBX", function(module, exports) {
$parcel$export(module.exports, "extension", function () { return $992458d03bc20d69$export$1b45514b112dd749; });

var $dAkqA = parcelRequire("dAkqA");

var $35i9Y = parcelRequire("35i9Y");
var $992458d03bc20d69$export$1b45514b112dd749 = (0, $35i9Y.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $dAkqA.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("g8K3J", function(module, exports) {
$parcel$export(module.exports, "hardBreak", function () { return $bc011f153b1c0b0e$export$371da9dd35aba193; });

var $35i9Y = parcelRequire("35i9Y");
var $bc011f153b1c0b0e$export$371da9dd35aba193 = (0, $35i9Y.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM: function toDOM() {
        return [
            'br'
        ];
    }
});

});

parcelRegister("kF1fR", function(module, exports) {
$parcel$export(module.exports, "heading", function () { return $f0a89c2e76efee47$export$46e4a324ac90507f; });

var $35i9Y = parcelRequire("35i9Y");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ var $f0a89c2e76efee47$var$getAttrs = function getAttrs(level) {
    return function(domNode) {
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute('data-local-id') || ((_heading$attrs = $f0a89c2e76efee47$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
};
var $f0a89c2e76efee47$export$46e4a324ac90507f = (0, $35i9Y.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $f0a89c2e76efee47$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $f0a89c2e76efee47$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $f0a89c2e76efee47$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $f0a89c2e76efee47$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $f0a89c2e76efee47$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $f0a89c2e76efee47$var$getAttrs(6)
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, level = _node$attrs.level, localId = _node$attrs.localId;
        var name = 'h' + level;
        var attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});

});

parcelRegister("8kQDF", function(module, exports) {
$parcel$export(module.exports, "image", function () { return $611905f11179a3b7$export$5c452ff88e35e47d; });

var $35i9Y = parcelRequire("35i9Y");
var $611905f11179a3b7$export$5c452ff88e35e47d = (0, $35i9Y.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("fRQyu", function(module, exports) {
$parcel$export(module.exports, "inlineCard", function () { return $b8d492a5d8e4d913$export$cbf8224b64e0d942; });

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
var $b8d492a5d8e4d913$export$cbf8224b64e0d942 = (0, $35i9Y.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});
var $b8d492a5d8e4d913$export$7ed775fc743eadd1 = (0, $35i9Y.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("bqFdW", function(module, exports) {
$parcel$export(module.exports, "inlineExtension", function () { return $8522199dc9f3c632$export$16b353b2649bd8d9; });

var $dAkqA = parcelRequire("dAkqA");

var $35i9Y = parcelRequire("35i9Y");
var $8522199dc9f3c632$export$16b353b2649bd8d9 = (0, $35i9Y.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            getAttrs: function getAttrs(domNode) {
                return (0, $dAkqA.getExtensionAttrs)(domNode, true);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("dfjwm", function(module, exports) {
$parcel$export(module.exports, "layoutColumn", function () { return $9a4bd18d8a6db577$export$ab76e7c03cd6f650; });

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
var $9a4bd18d8a6db577$export$ab76e7c03cd6f650 = (0, $35i9Y.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-layout-column': 'true'
        };
        var width = node.attrs.width;
        if (width) {
            attrs['style'] = "flex-basis: ".concat(width, "%");
            attrs['data-column-width'] = "".concat(width);
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        var contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});
var $9a4bd18d8a6db577$export$b2e27d292505bac2 = (0, $35i9Y.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined,
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-layout-column': 'true',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        var width = node.attrs.width;
        if (width) {
            attrs['style'] = "flex-basis: ".concat(width, "%");
            attrs['data-column-width'] = "".concat(width);
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        var contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});

});

parcelRegister("dDMCS", function(module, exports) {
$parcel$export(module.exports, "createMediaSpec", function () { return $9ee4a306504d16fe$export$35bdbf5bc8caa677; });
$parcel$export(module.exports, "media", function () { return $9ee4a306504d16fe$export$987d49ffe1b0900f; });

var $1YMOy = parcelRequire("1YMOy");

var $3G1IB = parcelRequire("3G1IB");

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
function $9ee4a306504d16fe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9ee4a306504d16fe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9ee4a306504d16fe$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9ee4a306504d16fe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $9ee4a306504d16fe$export$bb3fe706be61f640 = (0, $35i9Y.media)({}).attrs;
var $9ee4a306504d16fe$export$35bdbf5bc8caa677 = function createMediaSpec(attributes) {
    var inline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var generateLocalId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var domNodeType = inline ? 'span' : 'div';
    var nodeName = inline ? 'mediaInline' : 'media';
    var parseDOM = [
        {
            tag: "".concat(domNodeType, "[data-node-type=\"").concat(nodeName, "\"]"),
            getAttrs: function getAttrs(dom) {
                var attrs = {};
                if (attributes) Object.keys(attributes).forEach(function(k) {
                    var key = $9ee4a306504d16fe$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                    var value = dom.getAttribute("data-".concat(key)) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                var width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                var height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                if (generateLocalId) attrs.localId = (0, $dS3bo.uuid).generate();
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    var toDOM = function toDOM(node) {
        var attrs = {
            'data-id': node.attrs.id,
            'data-node-type': "".concat(nodeName),
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            'data-local-id': node.attrs.localId || undefined,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: "display: inline-block; border-radius: 3px; background: ".concat((0, $3G1IB.N30), "; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);")
        };
        $9ee4a306504d16fe$export$111130fa8968d741(node.attrs, attrs, function(key) {
            return "data-".concat($9ee4a306504d16fe$export$f84fdfb973c05bd8(key.slice(2)));
        });
        return [
            "".concat(domNodeType),
            attrs
        ];
    };
    if (inline) return (0, $35i9Y.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $35i9Y.media)({
        parseDOM: [].concat(parseDOM, [
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: function getAttrs(dom) {
                    var attrs = {
                        type: 'external',
                        url: dom.getAttribute('src') || '',
                        alt: dom.getAttribute('alt') || ''
                    };
                    if (generateLocalId) attrs.localId = (0, $dS3bo.uuid).generate();
                    return attrs;
                }
            }
        ]),
        toDOM: toDOM
    });
};
var $9ee4a306504d16fe$export$987d49ffe1b0900f = $9ee4a306504d16fe$export$35bdbf5bc8caa677($9ee4a306504d16fe$export$bb3fe706be61f640, false, false);
var $9ee4a306504d16fe$export$8446e47a4c7fd000 = $9ee4a306504d16fe$export$35bdbf5bc8caa677($9ee4a306504d16fe$var$_objectSpread($9ee4a306504d16fe$var$_objectSpread({}, $9ee4a306504d16fe$export$bb3fe706be61f640), {}, {
    localId: {
        default: (0, $dS3bo.uuid).generate()
    }
}), false, true);
var $9ee4a306504d16fe$export$f84fdfb973c05bd8 = function camelCaseToKebabCase(str) {
    return str.replace(/([^A-Z]+)([A-Z])/g, function(_, x, y) {
        return "".concat(x, "-").concat(y.toLowerCase());
    });
};
var $9ee4a306504d16fe$export$111130fa8968d741 = function copyPrivateAttributes(from, to, map) {
    if ($9ee4a306504d16fe$export$987d49ffe1b0900f.attrs) Object.keys($9ee4a306504d16fe$export$987d49ffe1b0900f.attrs).forEach(function(key) {
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ var $9ee4a306504d16fe$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt',
    'localId'
];
var $9ee4a306504d16fe$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt',
    'localId'
];
var $9ee4a306504d16fe$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter(function(key) {
            return !(key[0] === '_' && key[1] === '_');
        }).reduce(function(obj, key) {
            if (node.attrs.type === 'external' && $9ee4a306504d16fe$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($9ee4a306504d16fe$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});

parcelRegister("gDmwP", function(module, exports) {
$parcel$export(module.exports, "mediaGroup", function () { return $c1c1c38dc1e45d75$export$2855e964765eac9; });

var $35i9Y = parcelRequire("35i9Y");
var $c1c1c38dc1e45d75$export$2855e964765eac9 = (0, $35i9Y.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM: function toDOM() {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("akl9R", function(module, exports) {
$parcel$export(module.exports, "mediaInline", function () { return $784c2f294259f8e8$export$38bab695e3f720f1; });

var $1YMOy = parcelRequire("1YMOy");

var $dDMCS = parcelRequire("dDMCS");

var $dS3bo = parcelRequire("dS3bo");

var $35i9Y = parcelRequire("35i9Y");
function $784c2f294259f8e8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $784c2f294259f8e8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $784c2f294259f8e8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $784c2f294259f8e8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $784c2f294259f8e8$export$38bab695e3f720f1 = (0, $dDMCS.createMediaSpec)((0, $35i9Y.mediaInline)({}).attrs, true);
var $784c2f294259f8e8$export$aea8e9c496505c61 = (0, $dDMCS.createMediaSpec)($784c2f294259f8e8$var$_objectSpread($784c2f294259f8e8$var$_objectSpread({}, (0, $35i9Y.mediaInline)({}).attrs), {}, {
    localId: {
        default: (0, $dS3bo.uuid).generate()
    }
}), true, true);

});

parcelRegister("6x4c2", function(module, exports) {
$parcel$export(module.exports, "mediaSingleFull", function () { return $4c1913d77641c620$export$7e767666f2ce108a; });

var $1YMOy = parcelRequire("1YMOy");

var $5bIoc = parcelRequire("5bIoc");

var $bsB7c = parcelRequire("bsB7c");

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
function $4c1913d77641c620$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4c1913d77641c620$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4c1913d77641c620$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4c1913d77641c620$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4c1913d77641c620$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
var $4c1913d77641c620$export$5a1e124099b60c6b = function mediaSingleSpec(_ref) {
    var _ref$withCaption = _ref.withCaption, withCaption = _ref$withCaption === void 0 ? false : _ref$withCaption, _ref$withExtendedWidt = _ref.withExtendedWidthTypes, withExtendedWidthTypes = _ref$withExtendedWidt === void 0 ? false : _ref$withExtendedWidt, _ref$generateLocalId = _ref.generateLocalId, generateLocalId = _ref$generateLocalId === void 0 ? false : _ref$generateLocalId;
    var getAttrs = function getAttrs(dom) {
        if (!(0, $bsB7c.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        var layout = dom.getAttribute('data-layout') || 'center';
        var width = Number(dom.getAttribute('data-width')) || null;
        var widthType = dom.getAttribute('data-width-type');
        if (generateLocalId) return {
            layout: layout,
            width: width,
            widthType: widthType,
            localId: (0, $dS3bo.uuid).generate()
        };
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $5bIoc.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    var getAttrsFromNode = function getAttrsFromNode(node) {
        var _node$attrs = node.attrs, layout = _node$attrs.layout, width = _node$attrs.width;
        var attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (generateLocalId) {
            var _node$attrs2;
            attrs['data-local-id'] = (node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId) || undefined;
        }
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            var widthType = node.attrs.widthType;
            return $4c1913d77641c620$var$_objectSpread($4c1913d77641c620$var$_objectSpread({}, attrs), {}, {
                'data-width-type': widthType || (0, $5bIoc.WidthType).PERCENTAGE
            });
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $35i9Y.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $35i9Y.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $35i9Y.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $35i9Y.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
var $4c1913d77641c620$export$969fe3781ca15058 = $4c1913d77641c620$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
var $4c1913d77641c620$export$d35e6c006d4abdfb = $4c1913d77641c620$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
var $4c1913d77641c620$export$9c58e19811ce4cf5 = $4c1913d77641c620$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
var $4c1913d77641c620$export$7e767666f2ce108a = $4c1913d77641c620$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
var $4c1913d77641c620$export$75376a385837c942 = $4c1913d77641c620$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true,
    generateLocalId: true
});
var $4c1913d77641c620$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});
parcelRegister("5bIoc", function(module, exports) {
$parcel$export(module.exports, "WidthType", function () { return $3c706999eecfd957$export$4d41558722ac7eed; });
/**
 * @description The widthType attribute is used to support fixed with media single
 */ var $3c706999eecfd957$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("jPkEj", function(module, exports) {
$parcel$export(module.exports, "mention", function () { return $e6f2cc405ace1bdb$export$db83999c14438df4; });

var $1YMOy = parcelRequire("1YMOy");

var $dS3bo = parcelRequire("dS3bo");

var $35i9Y = parcelRequire("35i9Y");
function $e6f2cc405ace1bdb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e6f2cc405ace1bdb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e6f2cc405ace1bdb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e6f2cc405ace1bdb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e6f2cc405ace1bdb$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
var $e6f2cc405ace1bdb$export$db83999c14438df4 = (0, $35i9Y.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute('data-mention-id') || $e6f2cc405ace1bdb$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $e6f2cc405ace1bdb$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute('data-access-level') || $e6f2cc405ace1bdb$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $dS3bo.uuid).generate()
                };
                var userType = dom.getAttribute('data-user-type');
                if ($e6f2cc405ace1bdb$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, id = _node$attrs.id, accessLevel = _node$attrs.accessLevel, text = _node$attrs.text, userType = _node$attrs.userType, localId = _node$attrs.localId;
        var attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
var $e6f2cc405ace1bdb$var$isOptional = function isOptional(key) {
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
var $e6f2cc405ace1bdb$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if ($e6f2cc405ace1bdb$var$isOptional(key) && !node.attrs[key]) return obj;
            return $e6f2cc405ace1bdb$var$_objectSpread($e6f2cc405ace1bdb$var$_objectSpread({}, obj), {}, (0, $1YMOy.default)({}, key, node.attrs[key]));
        }, {})
    };
};

});

parcelRegister("8Cmqn", function(module, exports) {
$parcel$export(module.exports, "nestedExpand", function () { return $646344591aea69f6$export$63cadbf5f4296627; });

var $jVI1z = parcelRequire("jVI1z");

var $1YMOy = parcelRequire("1YMOy");

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
function $646344591aea69f6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $646344591aea69f6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $646344591aea69f6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1YMOy.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $646344591aea69f6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $646344591aea69f6$var$getExpandAttrs(domNode, generateLocalId) {
    var dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true,
        localId: generateLocalId ? (0, $dS3bo.uuid).generate() : undefined
    };
}
var $646344591aea69f6$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $646344591aea69f6$var$getExpandAttrs(domNode, false);
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $646344591aea69f6$var$getExpandAttrs(domNode, false);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
var $646344591aea69f6$export$63cadbf5f4296627 = (0, $35i9Y.nestedExpand)($646344591aea69f6$var$nestedExpandFactoryOptions);
var $646344591aea69f6$export$b854197485aa1fa0 = (0, $35i9Y.nestedExpand)($646344591aea69f6$var$_objectSpread($646344591aea69f6$var$_objectSpread({}, $646344591aea69f6$var$nestedExpandFactoryOptions), {}, {
    parseDOM: [].concat((0, $jVI1z.default)($646344591aea69f6$var$nestedExpandFactoryOptions.parseDOM), [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $646344591aea69f6$var$getExpandAttrs(domNode, true);
            }
        },
        {
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: function getAttrs(domNode) {
                return $646344591aea69f6$var$getExpandAttrs(domNode, true);
            }
        }
    ])
}));

});
parcelRegister("jVI1z", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e8257d8263c032c9$export$2e2bcd8739ae039; });

var $bBmTF = parcelRequire("bBmTF");

var $bfQa9 = parcelRequire("bfQa9");

var $aDOnL = parcelRequire("aDOnL");

var $ka7Ss = parcelRequire("ka7Ss");
function $e8257d8263c032c9$export$2e2bcd8739ae039(r) {
    return (0, $bBmTF.default)(r) || (0, $bfQa9.default)(r) || (0, $aDOnL.default)(r) || (0, $ka7Ss.default)();
}

});
parcelRegister("bBmTF", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8724e93d75a1e517$export$2e2bcd8739ae039; });

var $adcIJ = parcelRequire("adcIJ");
function $8724e93d75a1e517$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $adcIJ.default)(r);
}

});

parcelRegister("bfQa9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $83198ed64f6a54f6$export$2e2bcd8739ae039; });
function $83198ed64f6a54f6$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("ka7Ss", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $eadada18eb2da881$export$2e2bcd8739ae039; });
function $eadada18eb2da881$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("hPlli", function(module, exports) {
$parcel$export(module.exports, "orderedListWithOrder", function () { return $cfa7c14363a46fe0$export$b9ab759e8298198f; });

var $dS3bo = parcelRequire("dS3bo");

var $35i9Y = parcelRequire("35i9Y");
var $cfa7c14363a46fe0$export$4e7125c7ff595be5 = '.ak-ol';
var $cfa7c14363a46fe0$export$a5dc81035676e7a = (0, $35i9Y.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $cfa7c14363a46fe0$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
var $cfa7c14363a46fe0$export$8157adc5747ec436 = (0, $35i9Y.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var attrs = {
            class: $cfa7c14363a46fe0$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
var $cfa7c14363a46fe0$var$resolveStart = function resolveStart(start) {
    var num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
var $cfa7c14363a46fe0$export$b9ab759e8298198f = (0, $35i9Y.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    var start = $cfa7c14363a46fe0$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs2;
        var start = $cfa7c14363a46fe0$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.order);
        var attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $cfa7c14363a46fe0$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
var $cfa7c14363a46fe0$export$2ea3505d41d7525d = (0, $35i9Y.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var startDOMAttr = dom.getAttribute('start');
                var localId = (0, $dS3bo.uuid).generate();
                if (startDOMAttr) {
                    var start = $cfa7c14363a46fe0$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start,
                        localId: localId
                    };
                }
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs3, _node$attrs4;
        var start = $cfa7c14363a46fe0$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.order);
        var attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $cfa7c14363a46fe0$export$4e7125c7ff595be5.substr(1),
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs4 = node.attrs) === null || _node$attrs4 === void 0 ? void 0 : _node$attrs4.localId) || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("enD9G", function(module, exports) {
$parcel$export(module.exports, "paragraph", function () { return $a78196104b203737$export$9c206ddddb32a9b; });

var $35i9Y = parcelRequire("35i9Y");
var $a78196104b203737$export$9c206ddddb32a9b = (0, $35i9Y.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: function getAttrs(domNode) {
                var _paragraph$attrs, _paragraph$attrs$loca;
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $a78196104b203737$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var name = 'p';
        var attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});

});

parcelRegister("lDmie", function(module, exports) {
$parcel$export(module.exports, "placeholder", function () { return $fbfe886ce576a491$export$c7187bbd1a7a9244; });

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
var $fbfe886ce576a491$export$c7187bbd1a7a9244 = (0, $35i9Y.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: function getAttrs(dom) {
                return {
                    text: dom.getAttribute('data-placeholder') || $fbfe886ce576a491$export$c7187bbd1a7a9244.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var text = node.attrs.text;
        var attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
var $fbfe886ce576a491$export$6205248609a8f7a0 = (0, $35i9Y.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: function getAttrs(dom) {
                return {
                    text: dom.getAttribute('data-placeholder') || $fbfe886ce576a491$export$c7187bbd1a7a9244.attrs.text.default,
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var text = node.attrs.text;
        var attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true',
            'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("2KjdB", function(module, exports) {
$parcel$export(module.exports, "rule", function () { return $1ffec90825b7f118$export$fbeb3a3956e8a3c7; });

var $35i9Y = parcelRequire("35i9Y");

var $dS3bo = parcelRequire("dS3bo");
/**
 * @name rule_node
 */ var $1ffec90825b7f118$var$hrDOM = [
    'hr'
];
var $1ffec90825b7f118$export$fbeb3a3956e8a3c7 = (0, $35i9Y.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM: function toDOM() {
        return $1ffec90825b7f118$var$hrDOM;
    }
});
var $1ffec90825b7f118$export$bf3ef6fb6ad90e7 = (0, $35i9Y.rule)({
    parseDOM: [
        {
            tag: 'hr',
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        return [
            'hr',
            {
                'data-local-id': (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId) || undefined
            }
        ];
    }
});

});

parcelRegister("9DZID", function(module, exports) {
$parcel$export(module.exports, "status", function () { return $7057a1aab71a3024$export$471f7ae5c4103ae1; });

var $dS3bo = parcelRequire("dS3bo");

var $35i9Y = parcelRequire("35i9Y");
var $7057a1aab71a3024$export$471f7ae5c4103ae1 = (0, $35i9Y.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, '').trim(),
                    color: dom.getAttribute('data-color'),
                    localId: (0, $dS3bo.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, text = _node$attrs.text, color = _node$attrs.color, localId = _node$attrs.localId, style = _node$attrs.style;
        var attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("iaDy5", function(module, exports) {
$parcel$export(module.exports, "taskList", function () { return $d3a7d6ba5e7a5d98$export$375b6afcc5f4d291; });

var $dS3bo = parcelRequire("dS3bo");

var $35i9Y = parcelRequire("35i9Y");
/**
 * @name taskList_node
 */ var $d3a7d6ba5e7a5d98$var$name = 'actionList';
var $d3a7d6ba5e7a5d98$export$c0ec71adb7a18fb2 = "[data-node-type=\"".concat($d3a7d6ba5e7a5d98$var$name, "\"]");
var $d3a7d6ba5e7a5d98$export$375b6afcc5f4d291 = (0, $35i9Y.taskList)({
    parseDOM: [
        {
            tag: "div".concat($d3a7d6ba5e7a5d98$export$c0ec71adb7a18fb2),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $dS3bo.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-node-type': $d3a7d6ba5e7a5d98$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("4VC0J", function(module, exports) {
$parcel$export(module.exports, "text", function () { return $3969f872877a616f$export$6f093cfa640b7166; });

var $35i9Y = parcelRequire("35i9Y");
var $3969f872877a616f$export$6f093cfa640b7166 = (0, $35i9Y.text)({
    toDebugString: function() {
        return 'text_node';
    }
});

});

parcelRegister("sM3wy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0567e4875b407b0d$export$2e2bcd8739ae039; });
var $0567e4875b407b0d$var$name = 'unknownBlock';
var $0567e4875b407b0d$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM: function toDOM() {
        return [
            'div',
            {
                'data-node-type': $0567e4875b407b0d$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($0567e4875b407b0d$var$name, "\"]")
        }
    ]
};

});

parcelRegister("lztMS", function(module, exports) {
$parcel$export(module.exports, "unsupportedBlock", function () { return $fb43f9027f07863c$export$44b79b0979d0f0f7; });

var $35i9Y = parcelRequire("35i9Y");
var $fb43f9027f07863c$export$44b79b0979d0f0f7 = (0, $35i9Y.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("lbKeT", function(module, exports) {
$parcel$export(module.exports, "unsupportedInline", function () { return $f6ce7e325beda109$export$310ebe0d80122e9b; });

var $35i9Y = parcelRequire("35i9Y");
var $f6ce7e325beda109$export$310ebe0d80122e9b = (0, $35i9Y.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});



parcelRegister("2S3V5", function(module, exports) {
$parcel$export(module.exports, "MarkdownParser", function () { return $2173aa47d974df23$export$a64f782182dea128; });

var $fkJXG = parcelRequire("fkJXG");
parcelRequire("kM3zU");
var $9oaol = parcelRequire("9oaol");
/**
Document schema for the data model used by CommonMark.
*/ const $2173aa47d974df23$export$4902baddc787debb = new (0, $fkJXG.Schema)({
    nodes: {
        doc: {
            content: "block+"
        },
        paragraph: {
            content: "inline*",
            group: "block",
            parseDOM: [
                {
                    tag: "p"
                }
            ],
            toDOM () {
                return [
                    "p",
                    0
                ];
            }
        },
        blockquote: {
            content: "block+",
            group: "block",
            parseDOM: [
                {
                    tag: "blockquote"
                }
            ],
            toDOM () {
                return [
                    "blockquote",
                    0
                ];
            }
        },
        horizontal_rule: {
            group: "block",
            parseDOM: [
                {
                    tag: "hr"
                }
            ],
            toDOM () {
                return [
                    "div",
                    [
                        "hr"
                    ]
                ];
            }
        },
        heading: {
            attrs: {
                level: {
                    default: 1
                }
            },
            content: "(text | image)*",
            group: "block",
            defining: true,
            parseDOM: [
                {
                    tag: "h1",
                    attrs: {
                        level: 1
                    }
                },
                {
                    tag: "h2",
                    attrs: {
                        level: 2
                    }
                },
                {
                    tag: "h3",
                    attrs: {
                        level: 3
                    }
                },
                {
                    tag: "h4",
                    attrs: {
                        level: 4
                    }
                },
                {
                    tag: "h5",
                    attrs: {
                        level: 5
                    }
                },
                {
                    tag: "h6",
                    attrs: {
                        level: 6
                    }
                }
            ],
            toDOM (node) {
                return [
                    "h" + node.attrs.level,
                    0
                ];
            }
        },
        code_block: {
            content: "text*",
            group: "block",
            code: true,
            defining: true,
            marks: "",
            attrs: {
                params: {
                    default: ""
                }
            },
            parseDOM: [
                {
                    tag: "pre",
                    preserveWhitespace: "full",
                    getAttrs: (node)=>({
                            params: node.getAttribute("data-params") || ""
                        })
                }
            ],
            toDOM (node) {
                return [
                    "pre",
                    node.attrs.params ? {
                        "data-params": node.attrs.params
                    } : {},
                    [
                        "code",
                        0
                    ]
                ];
            }
        },
        ordered_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                order: {
                    default: 1
                },
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ol",
                    getAttrs (dom) {
                        return {
                            order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1,
                            tight: dom.hasAttribute("data-tight")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "ol",
                    {
                        start: node.attrs.order == 1 ? null : node.attrs.order,
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        bullet_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ul",
                    getAttrs: (dom)=>({
                            tight: dom.hasAttribute("data-tight")
                        })
                }
            ],
            toDOM (node) {
                return [
                    "ul",
                    {
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        list_item: {
            content: "block+",
            defining: true,
            parseDOM: [
                {
                    tag: "li"
                }
            ],
            toDOM () {
                return [
                    "li",
                    0
                ];
            }
        },
        text: {
            group: "inline"
        },
        image: {
            inline: true,
            attrs: {
                src: {},
                alt: {
                    default: null
                },
                title: {
                    default: null
                }
            },
            group: "inline",
            draggable: true,
            parseDOM: [
                {
                    tag: "img[src]",
                    getAttrs (dom) {
                        return {
                            src: dom.getAttribute("src"),
                            title: dom.getAttribute("title"),
                            alt: dom.getAttribute("alt")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "img",
                    node.attrs
                ];
            }
        },
        hard_break: {
            inline: true,
            group: "inline",
            selectable: false,
            parseDOM: [
                {
                    tag: "br"
                }
            ],
            toDOM () {
                return [
                    "br"
                ];
            }
        }
    },
    marks: {
        em: {
            parseDOM: [
                {
                    tag: "i"
                },
                {
                    tag: "em"
                },
                {
                    style: "font-style=italic"
                },
                {
                    style: "font-style=normal",
                    clearMark: (m)=>m.type.name == "em"
                }
            ],
            toDOM () {
                return [
                    "em"
                ];
            }
        },
        strong: {
            parseDOM: [
                {
                    tag: "strong"
                },
                {
                    tag: "b",
                    getAttrs: (node)=>node.style.fontWeight != "normal" && null
                },
                {
                    style: "font-weight=400",
                    clearMark: (m)=>m.type.name == "strong"
                },
                {
                    style: "font-weight",
                    getAttrs: (value)=>/^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
                }
            ],
            toDOM () {
                return [
                    "strong"
                ];
            }
        },
        link: {
            attrs: {
                href: {},
                title: {
                    default: null
                }
            },
            inclusive: false,
            parseDOM: [
                {
                    tag: "a[href]",
                    getAttrs (dom) {
                        return {
                            href: dom.getAttribute("href"),
                            title: dom.getAttribute("title")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "a",
                    node.attrs
                ];
            }
        },
        code: {
            parseDOM: [
                {
                    tag: "code"
                }
            ],
            toDOM () {
                return [
                    "code"
                ];
            }
        }
    }
});
// @ts-ignore
function $2173aa47d974df23$var$maybeMerge(a, b) {
    if (a.isText && b.isText && (0, $fkJXG.Mark).sameSet(a.marks, b.marks)) return a.withText(a.text + b.text);
}
// Object used to track the context of a running parse.
class $2173aa47d974df23$var$MarkdownParseState {
    top() {
        return this.stack[this.stack.length - 1];
    }
    push(elt) {
        if (this.stack.length) this.top().content.push(elt);
    }
    // Adds the given text to the current position in the document,
    // using the current marks as styling.
    addText(text) {
        if (!text) return;
        let top = this.top(), nodes = top.content, last = nodes[nodes.length - 1];
        let node = this.schema.text(text, top.marks), merged;
        if (last && (merged = $2173aa47d974df23$var$maybeMerge(last, node))) nodes[nodes.length - 1] = merged;
        else nodes.push(node);
    }
    // Adds the given mark to the set of active marks.
    openMark(mark) {
        let top = this.top();
        top.marks = mark.addToSet(top.marks);
    }
    // Removes the given mark from the set of active marks.
    closeMark(mark) {
        let top = this.top();
        top.marks = mark.removeFromSet(top.marks);
    }
    parseTokens(toks) {
        for(let i = 0; i < toks.length; i++){
            let tok = toks[i];
            let handler = this.tokenHandlers[tok.type];
            if (!handler) throw new Error("Token type `" + tok.type + "` not supported by Markdown parser");
            handler(this, tok, toks, i);
        }
    }
    // Add a node at the current position.
    addNode(type, attrs, content) {
        let top = this.top();
        let node = type.createAndFill(attrs, content, top ? top.marks : []);
        if (!node) return null;
        this.push(node);
        return node;
    }
    // Wrap subsequent content in a node of the given type.
    openNode(type, attrs) {
        this.stack.push({
            type: type,
            attrs: attrs,
            content: [],
            marks: (0, $fkJXG.Mark).none
        });
    }
    // Close and return the node that is currently on top of the stack.
    closeNode() {
        let info = this.stack.pop();
        return this.addNode(info.type, info.attrs, info.content);
    }
    constructor(schema, tokenHandlers){
        this.schema = schema;
        this.tokenHandlers = tokenHandlers;
        this.stack = [
            {
                type: schema.topNodeType,
                attrs: null,
                content: [],
                marks: (0, $fkJXG.Mark).none
            }
        ];
    }
}
function $2173aa47d974df23$var$attrs(spec, token, tokens, i) {
    if (spec.getAttrs) return spec.getAttrs(token, tokens, i);
    else if (spec.attrs instanceof Function) return spec.attrs(token);
    else return spec.attrs;
}
// Code content is represented as a single token with a `content`
// property in Markdown-it.
function $2173aa47d974df23$var$noCloseToken(spec, type) {
    return spec.noCloseToken || type == "code_inline" || type == "code_block" || type == "fence";
}
function $2173aa47d974df23$var$withoutTrailingNewline(str) {
    return str[str.length - 1] == "\n" ? str.slice(0, str.length - 1) : str;
}
function $2173aa47d974df23$var$noOp() {}
function $2173aa47d974df23$var$tokenHandlers(schema, tokens) {
    let handlers = Object.create(null);
    for(let type in tokens){
        let spec = tokens[type];
        if (spec.block) {
            let nodeType = schema.nodeType(spec.block);
            if ($2173aa47d974df23$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openNode(nodeType, $2173aa47d974df23$var$attrs(spec, tok, tokens, i));
                state.addText($2173aa47d974df23$var$withoutTrailingNewline(tok.content));
                state.closeNode();
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openNode(nodeType, $2173aa47d974df23$var$attrs(spec, tok, tokens, i));
                handlers[type + "_close"] = (state)=>state.closeNode();
            }
        } else if (spec.node) {
            let nodeType = schema.nodeType(spec.node);
            handlers[type] = (state, tok, tokens, i)=>state.addNode(nodeType, $2173aa47d974df23$var$attrs(spec, tok, tokens, i));
        } else if (spec.mark) {
            let markType = schema.marks[spec.mark];
            if ($2173aa47d974df23$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openMark(markType.create($2173aa47d974df23$var$attrs(spec, tok, tokens, i)));
                state.addText($2173aa47d974df23$var$withoutTrailingNewline(tok.content));
                state.closeMark(markType);
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openMark(markType.create($2173aa47d974df23$var$attrs(spec, tok, tokens, i)));
                handlers[type + "_close"] = (state)=>state.closeMark(markType);
            }
        } else if (spec.ignore) {
            if ($2173aa47d974df23$var$noCloseToken(spec, type)) handlers[type] = $2173aa47d974df23$var$noOp;
            else {
                handlers[type + "_open"] = $2173aa47d974df23$var$noOp;
                handlers[type + "_close"] = $2173aa47d974df23$var$noOp;
            }
        } else throw new RangeError("Unrecognized parsing spec " + JSON.stringify(spec));
    }
    handlers.text = (state, tok)=>state.addText(tok.content);
    handlers.inline = (state, tok)=>state.parseTokens(tok.children);
    handlers.softbreak = handlers.softbreak || ((state)=>state.addText(" "));
    return handlers;
}
/**
A configuration of a Markdown parser. Such a parser uses
[markdown-it](https://github.com/markdown-it/markdown-it) to
tokenize a file, and then runs the custom rules it is given over
the tokens to create a ProseMirror document tree.
*/ class $2173aa47d974df23$export$a64f782182dea128 {
    /**
    Parse a string as [CommonMark](http://commonmark.org/) markup,
    and create a ProseMirror document as prescribed by this parser's
    rules.
    
    The second argument, when given, is passed through to the
    [Markdown
    parser](https://markdown-it.github.io/markdown-it/#MarkdownIt.parse).
    */ parse(text, markdownEnv = {}) {
        let state = new $2173aa47d974df23$var$MarkdownParseState(this.schema, this.tokenHandlers), doc;
        state.parseTokens(this.tokenizer.parse(text, markdownEnv));
        do doc = state.closeNode();
        while (state.stack.length);
        return doc || this.schema.topNodeType.createAndFill();
    }
    /**
    Create a parser with the given configuration. You can configure
    the markdown-it parser to parse the dialect you want, and provide
    a description of the ProseMirror entities those tokens map to in
    the `tokens` object, which maps token names to descriptions of
    what to do with them. Such a description is an object, and may
    have the following properties:
    */ constructor(/**
    The parser's document schema.
    */ schema, /**
    This parser's markdown-it tokenizer.
    */ tokenizer, /**
    The value of the `tokens` object used to construct this
    parser. Can be useful to copy and modify to base other parsers
    on.
    */ tokens){
        this.schema = schema;
        this.tokenizer = tokenizer;
        this.tokens = tokens;
        this.tokenHandlers = $2173aa47d974df23$var$tokenHandlers(schema, tokens);
    }
}
function $2173aa47d974df23$var$listIsTight(tokens, i) {
    while(++i < tokens.length)if (tokens[i].type != "list_item_open") return tokens[i].hidden;
    return false;
}
/**
A parser parsing unextended [CommonMark](http://commonmark.org/),
without inline HTML, and producing a document in the basic schema.
*/ const $2173aa47d974df23$export$7517583227ad0cb8 = new $2173aa47d974df23$export$a64f782182dea128($2173aa47d974df23$export$4902baddc787debb, (0, $9oaol.default)("commonmark", {
    html: false
}), {
    blockquote: {
        block: "blockquote"
    },
    paragraph: {
        block: "paragraph"
    },
    list_item: {
        block: "list_item"
    },
    bullet_list: {
        block: "bullet_list",
        getAttrs: (_, tokens, i)=>({
                tight: $2173aa47d974df23$var$listIsTight(tokens, i)
            })
    },
    ordered_list: {
        block: "ordered_list",
        getAttrs: (tok, tokens, i)=>({
                order: +tok.attrGet("start") || 1,
                tight: $2173aa47d974df23$var$listIsTight(tokens, i)
            })
    },
    heading: {
        block: "heading",
        getAttrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    code_block: {
        block: "code_block",
        noCloseToken: true
    },
    fence: {
        block: "code_block",
        getAttrs: (tok)=>({
                params: tok.info || ""
            }),
        noCloseToken: true
    },
    hr: {
        node: "horizontal_rule"
    },
    image: {
        node: "image",
        getAttrs: (tok)=>({
                src: tok.attrGet("src"),
                title: tok.attrGet("title") || null,
                alt: tok.children[0] && tok.children[0].content || null
            })
    },
    hardbreak: {
        node: "hard_break"
    },
    em: {
        mark: "em"
    },
    strong: {
        mark: "strong"
    },
    link: {
        mark: "link",
        getAttrs: (tok)=>({
                href: tok.attrGet("href"),
                title: tok.attrGet("title") || null
            })
    },
    code_inline: {
        mark: "code",
        noCloseToken: true
    }
});
const $2173aa47d974df23$var$blankMark = {
    open: "",
    close: "",
    mixable: true
};
/**
A specification for serializing a ProseMirror document as
Markdown/CommonMark text.
*/ class $2173aa47d974df23$export$ae9f6f04acb6c60c {
    /**
    Serialize the content of the given node to
    [CommonMark](http://commonmark.org/).
    */ serialize(content, options = {}) {
        options = Object.assign({}, this.options, options);
        let state = new $2173aa47d974df23$export$61055fa707e69319(this.nodes, this.marks, options);
        state.renderContent(content);
        return state.out;
    }
    /**
    Construct a serializer with the given configuration. The `nodes`
    object should map node names in a given schema to function that
    take a serializer state and such a node, and serialize the node.
    */ constructor(/**
    The node serializer functions for this serializer.
    */ nodes, /**
    The mark serializer info.
    */ marks, options = {}){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
    }
}
/**
A serializer for the [basic schema](https://prosemirror.net/docs/ref/#schema).
*/ const $2173aa47d974df23$export$f996452ca6e9a0ae = new $2173aa47d974df23$export$ae9f6f04acb6c60c({
    blockquote (state, node) {
        state.wrapBlock("> ", null, node, ()=>state.renderContent(node));
    },
    code_block (state, node) {
        // Make sure the front matter fences are longer than any dash sequence within it
        const backticks = node.textContent.match(/`{3,}/gm);
        const fence = backticks ? backticks.sort().slice(-1)[0] + "`" : "```";
        state.write(fence + (node.attrs.params || "") + "\n");
        state.text(node.textContent, false);
        // Add a newline to the current content before adding closing marker
        state.write("\n");
        state.write(fence);
        state.closeBlock(node);
    },
    heading (state, node) {
        state.write(state.repeat("#", node.attrs.level) + " ");
        state.renderInline(node, false);
        state.closeBlock(node);
    },
    horizontal_rule (state, node) {
        state.write(node.attrs.markup || "---");
        state.closeBlock(node);
    },
    bullet_list (state, node) {
        state.renderList(node, "  ", ()=>(node.attrs.bullet || "*") + " ");
    },
    ordered_list (state, node) {
        let start = node.attrs.order || 1;
        let maxW = String(start + node.childCount - 1).length;
        let space = state.repeat(" ", maxW + 2);
        state.renderList(node, space, (i)=>{
            let nStr = String(start + i);
            return state.repeat(" ", maxW - nStr.length) + nStr + ". ";
        });
    },
    list_item (state, node) {
        state.renderContent(node);
    },
    paragraph (state, node) {
        state.renderInline(node);
        state.closeBlock(node);
    },
    image (state, node) {
        state.write("![" + state.esc(node.attrs.alt || "") + "](" + node.attrs.src.replace(/[\(\)]/g, "\\$&") + (node.attrs.title ? ' "' + node.attrs.title.replace(/"/g, '\\"') + '"' : "") + ")");
    },
    hard_break (state, node, parent, index) {
        for(let i = index + 1; i < parent.childCount; i++)if (parent.child(i).type != node.type) {
            state.write("\\\n");
            return;
        }
    },
    text (state, node) {
        state.text(node.text, !state.inAutolink);
    }
}, {
    em: {
        open: "*",
        close: "*",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: "**",
        close: "**",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open (state, mark, parent, index) {
            state.inAutolink = $2173aa47d974df23$var$isPlainURL(mark, parent, index);
            return state.inAutolink ? "<" : "[";
        },
        close (state, mark, parent, index) {
            let { inAutolink: inAutolink } = state;
            state.inAutolink = undefined;
            return inAutolink ? ">" : "](" + mark.attrs.href.replace(/[\(\)"]/g, "\\$&") + (mark.attrs.title ? ` "${mark.attrs.title.replace(/"/g, '\\"')}"` : "") + ")";
        },
        mixable: true
    },
    code: {
        open (_state, _mark, parent, index) {
            return $2173aa47d974df23$var$backticksFor(parent.child(index), -1);
        },
        close (_state, _mark, parent, index) {
            return $2173aa47d974df23$var$backticksFor(parent.child(index - 1), 1);
        },
        escape: false
    }
});
function $2173aa47d974df23$var$backticksFor(node, side) {
    let ticks = /`+/g, m, len = 0;
    if (node.isText) while(m = ticks.exec(node.text))len = Math.max(len, m[0].length);
    let result = len > 0 && side > 0 ? " `" : "`";
    for(let i = 0; i < len; i++)result += "`";
    if (len > 0 && side < 0) result += " ";
    return result;
}
function $2173aa47d974df23$var$isPlainURL(link, parent, index) {
    if (link.attrs.title || !/^\w+:/.test(link.attrs.href)) return false;
    let content = parent.child(index);
    if (!content.isText || content.text != link.attrs.href || content.marks[content.marks.length - 1] != link) return false;
    return index == parent.childCount - 1 || !link.isInSet(parent.child(index + 1).marks);
}
/**
This is an object used to track state and expose
methods related to markdown serialization. Instances are passed to
node and mark serialization methods (see `toMarkdown`).
*/ class $2173aa47d974df23$export$61055fa707e69319 {
    /**
    @internal
    */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += "\n";
            if (size > 1) {
                let delimMin = this.delim;
                let trim = /\s+$/.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + "\n";
            }
            this.closed = null;
        }
    }
    /**
    @internal
    */ getMark(name) {
        let info = this.marks[name];
        if (!info) {
            if (this.options.strict !== false) throw new Error(`Mark type \`${name}\` not supported by Markdown renderer`);
            info = $2173aa47d974df23$var$blankMark;
        }
        return info;
    }
    /**
    Render a block, prefixing each line with `delim`, and the first
    line in `firstDelim`. `node` should be the node that is closed at
    the end of the block, and `f` is a function that renders the
    content of the block.
    */ wrapBlock(delim, firstDelim, node, f) {
        let old = this.delim;
        this.write(firstDelim != null ? firstDelim : delim);
        this.delim += delim;
        f();
        this.delim = old;
        this.closeBlock(node);
    }
    /**
    @internal
    */ atBlank() {
        return /(^|\n)$/.test(this.out);
    }
    /**
    Ensure the current content ends with a newline.
    */ ensureNewLine() {
        if (!this.atBlank()) this.out += "\n";
    }
    /**
    Prepare the state for writing output (closing closed paragraphs,
    adding delimiters, and so on), and then optionally add content
    (unescaped) to the output.
    */ write(content) {
        this.flushClose();
        if (this.delim && this.atBlank()) this.out += this.delim;
        if (content) this.out += content;
    }
    /**
    Close the block for the given node.
    */ closeBlock(node) {
        this.closed = node;
    }
    /**
    Add the given text to the document. When escape is not `false`,
    it will be escaped.
    */ text(text, escape = true) {
        let lines = text.split("\n");
        for(let i = 0; i < lines.length; i++){
            this.write();
            // Escape exclamation marks in front of links
            if (!escape && lines[i][0] == "[" && /(^|[^\\])\!$/.test(this.out)) this.out = this.out.slice(0, this.out.length - 1) + "\\!";
            this.out += escape ? this.esc(lines[i], this.atBlockStart) : lines[i];
            if (i != lines.length - 1) this.out += "\n";
        }
    }
    /**
    Render the given node as a block.
    */ render(node, parent, index) {
        if (this.nodes[node.type.name]) this.nodes[node.type.name](this, node, parent, index);
        else {
            if (this.options.strict !== false) throw new Error("Token type `" + node.type.name + "` not supported by Markdown renderer");
            else if (!node.type.isLeaf) {
                if (node.type.inlineContent) this.renderInline(node);
                else this.renderContent(node);
                if (node.isBlock) this.closeBlock(node);
            }
        }
    }
    /**
    Render the contents of `parent` as block nodes.
    */ renderContent(parent) {
        parent.forEach((node, _, i)=>this.render(node, parent, i));
    }
    /**
    Render the contents of `parent` as inline content.
    */ renderInline(parent, fromBlockStart = true) {
        this.atBlockStart = fromBlockStart;
        let active = [], trailing = "";
        let progress = (node, offset, index)=>{
            let marks = node ? node.marks : [];
            // Remove marks from `hard_break` that are the last node inside
            // that mark to prevent parser edge cases with new lines just
            // before closing marks.
            if (node && node.type.name === this.options.hardBreakNodeName) marks = marks.filter((m)=>{
                if (index + 1 == parent.childCount) return false;
                let next = parent.child(index + 1);
                return m.isInSet(next.marks) && (!next.isText || /\S/.test(next.text));
            });
            let leading = trailing;
            trailing = "";
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && !mark.isInSet(active);
            })) {
                let [_, lead, rest] = /^(\s*)(.*)$/m.exec(node.text);
                if (lead) {
                    leading += lead;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            if (node && node.isText && marks.some((mark)=>{
                let info = this.getMark(mark.type.name);
                return info && info.expelEnclosingWhitespace && (index == parent.childCount - 1 || !mark.isInSet(parent.child(index + 1).marks));
            })) {
                let [_, rest, trail] = /^(.*?)(\s*)$/m.exec(node.text);
                if (trail) {
                    trailing = trail;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            let inner = marks.length ? marks[marks.length - 1] : null;
            let noEsc = inner && this.getMark(inner.type.name).escape === false;
            let len = marks.length - (noEsc ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            outer: for(let i = 0; i < len; i++){
                let mark = marks[i];
                if (!this.getMark(mark.type.name).mixable) break;
                for(let j = 0; j < active.length; j++){
                    let other = active[j];
                    if (!this.getMark(other.type.name).mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            if (node) {
                while(active.length < len){
                    let add = marks[active.length];
                    active.push(add);
                    this.text(this.markString(add, true, parent, index), false);
                    this.atBlockStart = false;
                }
                // Render the node. Special case code marks, since their content
                // may not be escaped.
                if (noEsc && node.isText) this.text(this.markString(inner, true, parent, index) + node.text + this.markString(inner, false, parent, index + 1), false);
                else this.render(node, parent, index);
                this.atBlockStart = false;
            }
            // After the first non-empty text node is rendered, the end of output
            // is no longer at block start.
            //
            // FIXME: If a non-text node writes something to the output for this
            // block, the end of output is also no longer at block start. But how
            // can we detect that?
            if ((node === null || node === void 0 ? void 0 : node.isText) && node.nodeSize > 0) this.atBlockStart = false;
        };
        parent.forEach(progress);
        progress(null, 0, parent.childCount);
        this.atBlockStart = false;
    }
    /**
    Render a node's content as a list. `delim` should be the extra
    indentation added to all lines except the first in an item,
    `firstDelim` is a function going from an item index to a
    delimiter for the first line of the item.
    */ renderList(node, delim, firstDelim) {
        if (this.closed && this.closed.type == node.type) this.flushClose(3);
        else if (this.inTightList) this.flushClose(1);
        let isTight = typeof node.attrs.tight != "undefined" ? node.attrs.tight : this.options.tightLists;
        let prevTight = this.inTightList;
        this.inTightList = isTight;
        node.forEach((child, _, i)=>{
            if (i && isTight) this.flushClose(1);
            this.wrapBlock(delim, firstDelim(i), node, ()=>this.render(child, node, i));
        });
        this.inTightList = prevTight;
    }
    /**
    Escape the given string so that it can safely appear in Markdown
    content. If `startOfLine` is true, also escape characters that
    have special meaning only at the start of the line.
    */ esc(str, startOfLine = false) {
        str = str.replace(/[`*\\~\[\]_]/g, (m, i)=>m == "_" && i > 0 && i + 1 < str.length && str[i - 1].match(/\w/) && str[i + 1].match(/\w/) ? m : "\\" + m);
        if (startOfLine) str = str.replace(/^(\+[ ]|[\-*>])/, "\\$&").replace(/^(\s*)(#{1,6})(\s|$)/, '$1\\$2$3').replace(/^(\s*\d+)\.\s/, "$1\\. ");
        if (this.options.escapeExtraCharacters) str = str.replace(this.options.escapeExtraCharacters, "\\$&");
        return str;
    }
    /**
    @internal
    */ quote(str) {
        let wrap = str.indexOf('"') == -1 ? '""' : str.indexOf("'") == -1 ? "''" : "()";
        return wrap[0] + str + wrap[1];
    }
    /**
    Repeat the given string `n` times.
    */ repeat(str, n) {
        let out = "";
        for(let i = 0; i < n; i++)out += str;
        return out;
    }
    /**
    Get the markdown string for a given opening or closing mark.
    */ markString(mark, open, parent, index) {
        let info = this.getMark(mark.type.name);
        let value = open ? info.open : info.close;
        return typeof value == "string" ? value : value(this, mark, parent, index);
    }
    /**
    Get leading and trailing whitespace from a string. Values of
    leading or trailing property of the return object will be undefined
    if there is no match.
    */ getEnclosingWhitespace(text) {
        return {
            leading: (text.match(/^(\s+)/) || [
                undefined
            ])[0],
            trailing: (text.match(/(\s+)$/) || [
                undefined
            ])[0]
        };
    }
    /**
    @internal
    */ constructor(/**
    @internal
    */ nodes, /**
    @internal
    */ marks, /**
    The options passed to the serializer.
    */ options){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
        /**
        @internal
        */ this.delim = "";
        /**
        @internal
        */ this.out = "";
        /**
        @internal
        */ this.closed = null;
        /**
        @internal
        */ this.inAutolink = undefined;
        /**
        @internal
        */ this.atBlockStart = false;
        /**
        @internal
        */ this.inTightList = false;
        if (typeof this.options.tightLists == "undefined") this.options.tightLists = false;
        if (typeof this.options.hardBreakNodeName == "undefined") this.options.hardBreakNodeName = "hard_break";
    }
}

});
parcelRegister("fkJXG", function(module, exports) {
$parcel$export(module.exports, "Mark", function () { return $b29c6048411acd6f$export$c9d15bcfc6d42044; });
$parcel$export(module.exports, "Schema", function () { return $b29c6048411acd6f$export$19342e026b58ebb7; });

var $l0GWs = parcelRequire("l0GWs");
function $b29c6048411acd6f$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $b29c6048411acd6f$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $b29c6048411acd6f$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $b29c6048411acd6f$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $b29c6048411acd6f$export$ffb0004e005737fa {
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $b29c6048411acd6f$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $b29c6048411acd6f$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $b29c6048411acd6f$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $b29c6048411acd6f$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $b29c6048411acd6f$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $b29c6048411acd6f$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $b29c6048411acd6f$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $b29c6048411acd6f$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $b29c6048411acd6f$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $b29c6048411acd6f$var$retIndex(0, pos);
        if (pos == this.size) return $b29c6048411acd6f$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $b29c6048411acd6f$var$retIndex(i + 1, end);
                return $b29c6048411acd6f$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $b29c6048411acd6f$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $b29c6048411acd6f$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $b29c6048411acd6f$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $b29c6048411acd6f$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $b29c6048411acd6f$export$ffb0004e005737fa.empty;
        if (nodes instanceof $b29c6048411acd6f$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $b29c6048411acd6f$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $b29c6048411acd6f$export$ffb0004e005737fa.empty = new $b29c6048411acd6f$export$ffb0004e005737fa([], 0);
const $b29c6048411acd6f$var$found = {
    index: 0,
    offset: 0
};
function $b29c6048411acd6f$var$retIndex(index, offset) {
    $b29c6048411acd6f$var$found.index = index;
    $b29c6048411acd6f$var$found.offset = offset;
    return $b29c6048411acd6f$var$found;
}
function $b29c6048411acd6f$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$b29c6048411acd6f$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$b29c6048411acd6f$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $b29c6048411acd6f$export$c9d15bcfc6d42044 {
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $b29c6048411acd6f$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $b29c6048411acd6f$export$c9d15bcfc6d42044.none;
        if (marks instanceof $b29c6048411acd6f$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
}
/**
The empty set of marks.
*/ $b29c6048411acd6f$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $b29c6048411acd6f$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $b29c6048411acd6f$export$b3f2e2de3a8baa1e {
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $b29c6048411acd6f$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $b29c6048411acd6f$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $b29c6048411acd6f$export$b3f2e2de3a8baa1e($b29c6048411acd6f$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $b29c6048411acd6f$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $b29c6048411acd6f$export$b3f2e2de3a8baa1e($b29c6048411acd6f$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $b29c6048411acd6f$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
}
/**
The empty slice.
*/ $b29c6048411acd6f$export$b3f2e2de3a8baa1e.empty = new $b29c6048411acd6f$export$b3f2e2de3a8baa1e($b29c6048411acd6f$export$ffb0004e005737fa.empty, 0, 0);
function $b29c6048411acd6f$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($b29c6048411acd6f$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $b29c6048411acd6f$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $b29c6048411acd6f$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $b29c6048411acd6f$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $b29c6048411acd6f$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $b29c6048411acd6f$export$6de0e778727af3f2("Inconsistent open depths");
    return $b29c6048411acd6f$var$replaceOuter($from, $to, slice, 0);
}
function $b29c6048411acd6f$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $b29c6048411acd6f$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $b29c6048411acd6f$var$close(node, $b29c6048411acd6f$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $b29c6048411acd6f$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $b29c6048411acd6f$var$prepareSliceForReplace(slice, $from);
        return $b29c6048411acd6f$var$close(node, $b29c6048411acd6f$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $b29c6048411acd6f$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $b29c6048411acd6f$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $b29c6048411acd6f$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $b29c6048411acd6f$var$checkJoin(node, $after.node(depth));
    return node;
}
function $b29c6048411acd6f$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $b29c6048411acd6f$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $b29c6048411acd6f$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$b29c6048411acd6f$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $b29c6048411acd6f$var$addNode($end.nodeBefore, target);
}
function $b29c6048411acd6f$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $b29c6048411acd6f$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $b29c6048411acd6f$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $b29c6048411acd6f$var$joinable($end, $to, depth + 1);
    let content = [];
    $b29c6048411acd6f$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $b29c6048411acd6f$var$checkJoin(openStart, openEnd);
        $b29c6048411acd6f$var$addNode($b29c6048411acd6f$var$close(openStart, $b29c6048411acd6f$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $b29c6048411acd6f$var$addNode($b29c6048411acd6f$var$close(openStart, $b29c6048411acd6f$var$replaceTwoWay($from, $start, depth + 1)), content);
        $b29c6048411acd6f$var$addRange($start, $end, depth, content);
        if (openEnd) $b29c6048411acd6f$var$addNode($b29c6048411acd6f$var$close(openEnd, $b29c6048411acd6f$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $b29c6048411acd6f$var$addRange($to, null, depth, content);
    return new $b29c6048411acd6f$export$ffb0004e005737fa(content);
}
function $b29c6048411acd6f$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $b29c6048411acd6f$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $b29c6048411acd6f$var$joinable($from, $to, depth + 1);
        $b29c6048411acd6f$var$addNode($b29c6048411acd6f$var$close(type, $b29c6048411acd6f$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $b29c6048411acd6f$var$addRange($to, null, depth, content);
    return new $b29c6048411acd6f$export$ffb0004e005737fa(content);
}
function $b29c6048411acd6f$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($b29c6048411acd6f$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $b29c6048411acd6f$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $b29c6048411acd6f$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $b29c6048411acd6f$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $b29c6048411acd6f$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $b29c6048411acd6f$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $b29c6048411acd6f$var$resolveCache.set(doc, cache = new $b29c6048411acd6f$var$ResolveCache);
        let result = cache.elts[cache.i] = $b29c6048411acd6f$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $b29c6048411acd6f$var$resolveCacheSize;
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
}
class $b29c6048411acd6f$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $b29c6048411acd6f$var$resolveCacheSize = 12, $b29c6048411acd6f$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $b29c6048411acd6f$export$7bc461ceb770fb16 {
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
}
const $b29c6048411acd6f$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](https://prosemirror.net/docs/guide/#doc) for more information.
*/ class $b29c6048411acd6f$export$85c928794f8d04d4 {
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $b29c6048411acd6f$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $b29c6048411acd6f$var$emptyAttrs) && $b29c6048411acd6f$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $b29c6048411acd6f$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $b29c6048411acd6f$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $b29c6048411acd6f$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $b29c6048411acd6f$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $b29c6048411acd6f$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $b29c6048411acd6f$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $b29c6048411acd6f$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $b29c6048411acd6f$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $b29c6048411acd6f$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $b29c6048411acd6f$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $b29c6048411acd6f$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$b29c6048411acd6f$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $b29c6048411acd6f$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $b29c6048411acd6f$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $b29c6048411acd6f$export$ffb0004e005737fa.empty;
    }
}
$b29c6048411acd6f$export$85c928794f8d04d4.prototype.text = undefined;
class $b29c6048411acd6f$var$TextNode extends $b29c6048411acd6f$export$85c928794f8d04d4 {
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $b29c6048411acd6f$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $b29c6048411acd6f$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $b29c6048411acd6f$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
}
function $b29c6048411acd6f$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $b29c6048411acd6f$export$364ed450558d7ec4 {
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $b29c6048411acd6f$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $b29c6048411acd6f$export$364ed450558d7ec4.empty;
        let expr = $b29c6048411acd6f$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $b29c6048411acd6f$var$dfa($b29c6048411acd6f$var$nfa(expr));
        $b29c6048411acd6f$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $b29c6048411acd6f$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
}
/**
@internal
*/ $b29c6048411acd6f$export$364ed450558d7ec4.empty = new $b29c6048411acd6f$export$364ed450558d7ec4(true);
class $b29c6048411acd6f$var$TokenStream {
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
}
function $b29c6048411acd6f$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($b29c6048411acd6f$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $b29c6048411acd6f$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($b29c6048411acd6f$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $b29c6048411acd6f$var$parseExprSubscript(stream) {
    let expr = $b29c6048411acd6f$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $b29c6048411acd6f$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $b29c6048411acd6f$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $b29c6048411acd6f$var$parseExprRange(stream, expr) {
    let min = $b29c6048411acd6f$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $b29c6048411acd6f$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $b29c6048411acd6f$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $b29c6048411acd6f$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $b29c6048411acd6f$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $b29c6048411acd6f$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $b29c6048411acd6f$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $b29c6048411acd6f$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $b29c6048411acd6f$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($b29c6048411acd6f$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $b29c6048411acd6f$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($b29c6048411acd6f$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $b29c6048411acd6f$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $b29c6048411acd6f$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($b29c6048411acd6f$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $b29c6048411acd6f$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $b29c6048411acd6f$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $b29c6048411acd6f$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $b29c6048411acd6f$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $b29c6048411acd6f$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $b29c6048411acd6f$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $b29c6048411acd6f$export$f06e977173f1857c {
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $b29c6048411acd6f$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $b29c6048411acd6f$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $b29c6048411acd6f$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $b29c6048411acd6f$export$ffb0004e005737fa.from(content), $b29c6048411acd6f$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $b29c6048411acd6f$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $b29c6048411acd6f$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $b29c6048411acd6f$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $b29c6048411acd6f$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($b29c6048411acd6f$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $b29c6048411acd6f$export$85c928794f8d04d4(this, attrs, content.append(after), $b29c6048411acd6f$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $b29c6048411acd6f$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $b29c6048411acd6f$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $b29c6048411acd6f$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $b29c6048411acd6f$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $b29c6048411acd6f$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
}
function $b29c6048411acd6f$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $b29c6048411acd6f$var$Attribute {
    get isRequired() {
        return !this.hasDefault;
    }
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $b29c6048411acd6f$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $b29c6048411acd6f$export$b6a78689043c6521 {
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $b29c6048411acd6f$export$c9d15bcfc6d42044(this, $b29c6048411acd6f$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $b29c6048411acd6f$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $b29c6048411acd6f$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $b29c6048411acd6f$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $b29c6048411acd6f$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $b29c6048411acd6f$export$c9d15bcfc6d42044(this, defaults) : null;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $b29c6048411acd6f$export$19342e026b58ebb7 {
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $b29c6048411acd6f$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $b29c6048411acd6f$var$TextNode(type, type.defaultAttrs, text, $b29c6048411acd6f$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $b29c6048411acd6f$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $b29c6048411acd6f$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $l0GWs.default).from(spec.nodes), instanceSpec.marks = (0, $l0GWs.default).from(spec.marks || {}), this.nodes = $b29c6048411acd6f$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $b29c6048411acd6f$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $b29c6048411acd6f$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $b29c6048411acd6f$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $b29c6048411acd6f$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
}
function $b29c6048411acd6f$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $b29c6048411acd6f$var$isTagRule(rule) {
    return rule.tag != null;
}
function $b29c6048411acd6f$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $b29c6048411acd6f$export$1059c6e7d2ce5669 {
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $b29c6048411acd6f$var$ParseContext(this, options, false);
        context.addAll(dom, $b29c6048411acd6f$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $b29c6048411acd6f$var$ParseContext(this, options, true);
        context.addAll(dom, $b29c6048411acd6f$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $b29c6048411acd6f$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($b29c6048411acd6f$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $b29c6048411acd6f$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $b29c6048411acd6f$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $b29c6048411acd6f$export$1059c6e7d2ce5669(schema, $b29c6048411acd6f$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($b29c6048411acd6f$var$isTagRule(rule)) this.tags.push(rule);
            else if ($b29c6048411acd6f$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
}
const $b29c6048411acd6f$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $b29c6048411acd6f$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $b29c6048411acd6f$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $b29c6048411acd6f$var$OPT_PRESERVE_WS = 1, $b29c6048411acd6f$var$OPT_PRESERVE_WS_FULL = 2, $b29c6048411acd6f$var$OPT_OPEN_LEFT = 4;
function $b29c6048411acd6f$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $b29c6048411acd6f$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $b29c6048411acd6f$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $b29c6048411acd6f$var$OPT_PRESERVE_WS | $b29c6048411acd6f$var$OPT_PRESERVE_WS_FULL : base & ~$b29c6048411acd6f$var$OPT_OPEN_LEFT;
}
class $b29c6048411acd6f$var$NodeContext {
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($b29c6048411acd6f$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $b29c6048411acd6f$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $b29c6048411acd6f$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($b29c6048411acd6f$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$b29c6048411acd6f$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $b29c6048411acd6f$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $b29c6048411acd6f$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
}
class $b29c6048411acd6f$var$ParseContext {
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $b29c6048411acd6f$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $b29c6048411acd6f$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks, !/\S/.test(value));
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($b29c6048411acd6f$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $b29c6048411acd6f$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $b29c6048411acd6f$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($b29c6048411acd6f$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks, true);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks, dom.nodeName == "BR")) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks, false));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks, cautious) {
        let route, sync;
        for(let depth = this.open, penalty = 0; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length + penalty)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) {
                if (cautious) break;
                penalty += 2;
            }
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks, cautious) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks, cautious);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $b29c6048411acd6f$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $b29c6048411acd6f$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks, false);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $b29c6048411acd6f$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $b29c6048411acd6f$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $b29c6048411acd6f$var$OPT_OPEN_LEFT;
        let applyMarks = $b29c6048411acd6f$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $b29c6048411acd6f$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $b29c6048411acd6f$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $b29c6048411acd6f$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $b29c6048411acd6f$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $b29c6048411acd6f$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $b29c6048411acd6f$var$NodeContext(topNode.type, topNode.attrs, $b29c6048411acd6f$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $b29c6048411acd6f$var$NodeContext(null, null, $b29c6048411acd6f$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $b29c6048411acd6f$var$NodeContext(parser.schema.topNodeType, null, $b29c6048411acd6f$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $b29c6048411acd6f$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $b29c6048411acd6f$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $b29c6048411acd6f$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $b29c6048411acd6f$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $b29c6048411acd6f$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $b29c6048411acd6f$export$3476b78f8f5a8b72 {
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $b29c6048411acd6f$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $b29c6048411acd6f$var$renderSpec($b29c6048411acd6f$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $b29c6048411acd6f$var$renderSpec($b29c6048411acd6f$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $b29c6048411acd6f$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $b29c6048411acd6f$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $b29c6048411acd6f$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $b29c6048411acd6f$var$gatherToDOM(schema.marks);
    }
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
}
function $b29c6048411acd6f$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $b29c6048411acd6f$var$doc(options) {
    return options.document || window.document;
}
const $b29c6048411acd6f$var$suspiciousAttributeCache = new WeakMap();
function $b29c6048411acd6f$var$suspiciousAttributes(attrs) {
    let value = $b29c6048411acd6f$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $b29c6048411acd6f$var$suspiciousAttributeCache.set(attrs, value = $b29c6048411acd6f$var$suspiciousAttributesInner(attrs));
    return value;
}
function $b29c6048411acd6f$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $b29c6048411acd6f$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $b29c6048411acd6f$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $b29c6048411acd6f$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});

parcelRegister("kM3zU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return (parcelRequire("9oaol")).default; });

var $9oaol = parcelRequire("9oaol");

});
parcelRegister("9oaol", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6d5e6a7e59b40032$export$2e2bcd8739ae039; });
// Main parser class

var $jAdKh = parcelRequire("jAdKh");

var $3Y2pZ = parcelRequire("3Y2pZ");

var $dI9QD = parcelRequire("dI9QD");

var $8zulA = parcelRequire("8zulA");

var $hORCU = parcelRequire("hORCU");

var $8Bjz2 = parcelRequire("8Bjz2");

var $bikvB = parcelRequire("bikvB");
parcelRequire("8afOB");
var $lhbnv = parcelRequire("lhbnv");
var $PcDb4 = parcelRequire("PcDb4");
var $6qrCN = parcelRequire("6qrCN");
var $7Vk0b = parcelRequire("7Vk0b");

var $fEiZX = parcelRequire("fEiZX");

var $hGp75 = parcelRequire("hGp75");

var $3glcq = parcelRequire("3glcq");

var $iZlew = parcelRequire("iZlew");
const $6d5e6a7e59b40032$var$config = {
    default: (0, $hGp75.default),
    zero: (0, $3glcq.default),
    commonmark: (0, $iZlew.default)
};
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
const $6d5e6a7e59b40032$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
const $6d5e6a7e59b40032$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $6d5e6a7e59b40032$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    const str = url.trim().toLowerCase();
    return $6d5e6a7e59b40032$var$BAD_PROTO_RE.test(str) ? $6d5e6a7e59b40032$var$GOOD_DATA_RE.test(str) : true;
}
const $6d5e6a7e59b40032$var$RECODE_HOSTNAME_FOR = [
    'http:',
    'https:',
    'mailto:'
];
function $6d5e6a7e59b40032$var$normalizeLink(url) {
    const parsed = $7Vk0b.default(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $6d5e6a7e59b40032$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, $fEiZX.default).toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $PcDb4.default($6qrCN.default(parsed));
}
function $6d5e6a7e59b40032$var$normalizeLinkText(url) {
    const parsed = $7Vk0b.default(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $6d5e6a7e59b40032$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, $fEiZX.default).toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $lhbnv.default($6qrCN.default(parsed), $lhbnv.default.defaultChars + '%');
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.mjs) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.mjs) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.mjs) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.mjs) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>` or `<code>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre><code class="hljs">' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre><code class="hljs">' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $6d5e6a7e59b40032$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $6d5e6a7e59b40032$var$MarkdownIt)) return new $6d5e6a7e59b40032$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$jAdKh.isString(presetName)) {
            options = presetName || {};
            presetName = 'default';
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new (0, $8Bjz2.default)();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new (0, $hORCU.default)();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new (0, $8zulA.default)();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.mjs).
   **/ this.renderer = new (0, $dI9QD.default)();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.mjs)
   * rule.
   **/ this.linkify = new (0, $bikvB.default)();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $6d5e6a7e59b40032$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $6d5e6a7e59b40032$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $6d5e6a7e59b40032$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.mjs).
   **/ this.utils = $jAdKh;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $jAdKh.assign({}, $3Y2pZ);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $6d5e6a7e59b40032$var$MarkdownIt.prototype.set = function(options) {
    $jAdKh.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $6d5e6a7e59b40032$var$MarkdownIt.prototype.configure = function(presets) {
    const self = this;
    if ($jAdKh.isString(presets)) {
        const presetName = presets;
        presets = $6d5e6a7e59b40032$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error('Wrong `markdown-it` preset, can\'t be empty');
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $6d5e6a7e59b40032$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $6d5e6a7e59b40032$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $6d5e6a7e59b40032$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    const args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $6d5e6a7e59b40032$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== 'string') throw new Error('Input data should be a String');
    const state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $6d5e6a7e59b40032$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $6d5e6a7e59b40032$var$MarkdownIt.prototype.parseInline = function(src, env) {
    const state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $6d5e6a7e59b40032$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
var $6d5e6a7e59b40032$export$2e2bcd8739ae039 = $6d5e6a7e59b40032$var$MarkdownIt;

});
parcelRegister("jAdKh", function(module, exports) {
$parcel$export(module.exports, "isString", function () { return $e41c0aad11182ec3$export$844ec244b1367d54; });
$parcel$export(module.exports, "has", function () { return $e41c0aad11182ec3$export$a4f4bb6b1453fff5; });
$parcel$export(module.exports, "assign", function () { return $e41c0aad11182ec3$export$e6e34fd1f2686227; });
$parcel$export(module.exports, "arrayReplaceAt", function () { return $e41c0aad11182ec3$export$f78478f71955b6bc; });
$parcel$export(module.exports, "isValidEntityCode", function () { return $e41c0aad11182ec3$export$644a8f5b13b2a36d; });
$parcel$export(module.exports, "fromCodePoint", function () { return $e41c0aad11182ec3$export$73bfc63873071f74; });
$parcel$export(module.exports, "unescapeMd", function () { return $e41c0aad11182ec3$export$5ccde1ea0c14bb03; });
$parcel$export(module.exports, "unescapeAll", function () { return $e41c0aad11182ec3$export$db8a17c6655f7e2c; });
$parcel$export(module.exports, "escapeHtml", function () { return $e41c0aad11182ec3$export$4cf11838cdc2a8a8; });
$parcel$export(module.exports, "escapeRE", function () { return $e41c0aad11182ec3$export$bc616c8f7dc20d5d; });
$parcel$export(module.exports, "isSpace", function () { return $e41c0aad11182ec3$export$1d5ccafae59b4926; });
$parcel$export(module.exports, "isWhiteSpace", function () { return $e41c0aad11182ec3$export$3c52dd84024ae72c; });
$parcel$export(module.exports, "isPunctChar", function () { return $e41c0aad11182ec3$export$4888a643af800fc1; });
$parcel$export(module.exports, "isMdAsciiPunct", function () { return $e41c0aad11182ec3$export$829a0d33ae4e744; });
$parcel$export(module.exports, "normalizeReference", function () { return $e41c0aad11182ec3$export$20ef46802c8744b; });
$parcel$export(module.exports, "lib", function () { return $e41c0aad11182ec3$export$16c08b91f883959a; });
// Utilities
//

var $8afOB = parcelRequire("8afOB");
parcelRequire("8djVQ");
var $9GUSE = parcelRequire("9GUSE");
var $dYwW3 = parcelRequire("dYwW3");
var $8djVQ = parcelRequire("8djVQ");
parcelRequire("fyijY");
var $9i7QI = parcelRequire("9i7QI");
function $e41c0aad11182ec3$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $e41c0aad11182ec3$export$844ec244b1367d54(obj) {
    return $e41c0aad11182ec3$var$_class(obj) === '[object String]';
}
const $e41c0aad11182ec3$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $e41c0aad11182ec3$export$a4f4bb6b1453fff5(object, key) {
    return $e41c0aad11182ec3$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $e41c0aad11182ec3$export$e6e34fd1f2686227(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== 'object') throw new TypeError(source + 'must be object');
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $e41c0aad11182ec3$export$f78478f71955b6bc(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
function $e41c0aad11182ec3$export$644a8f5b13b2a36d(c) {
    /* eslint no-bitwise:0 */ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $e41c0aad11182ec3$export$73bfc63873071f74(c) {
    /* eslint no-bitwise:0 */ if (c > 0xffff) {
        c -= 0x10000;
        const surrogate1 = 0xd800 + (c >> 10);
        const surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
const $e41c0aad11182ec3$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g;
const $e41c0aad11182ec3$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
const $e41c0aad11182ec3$var$UNESCAPE_ALL_RE = new RegExp($e41c0aad11182ec3$var$UNESCAPE_MD_RE.source + '|' + $e41c0aad11182ec3$var$ENTITY_RE.source, 'gi');
const $e41c0aad11182ec3$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function $e41c0aad11182ec3$var$replaceEntityPattern(match, name) {
    if (name.charCodeAt(0) === 0x23 /* # */  && $e41c0aad11182ec3$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        const code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($e41c0aad11182ec3$export$644a8f5b13b2a36d(code)) return $e41c0aad11182ec3$export$73bfc63873071f74(code);
        return match;
    }
    const decoded = (0, $9i7QI.decodeHTML)(match);
    if (decoded !== match) return decoded;
    return match;
}
/* function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
} */ function $e41c0aad11182ec3$export$5ccde1ea0c14bb03(str) {
    if (str.indexOf('\\') < 0) return str;
    return str.replace($e41c0aad11182ec3$var$UNESCAPE_MD_RE, '$1');
}
function $e41c0aad11182ec3$export$db8a17c6655f7e2c(str) {
    if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) return str;
    return str.replace($e41c0aad11182ec3$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $e41c0aad11182ec3$var$replaceEntityPattern(match, entity);
    });
}
const $e41c0aad11182ec3$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
const $e41c0aad11182ec3$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
const $e41c0aad11182ec3$var$HTML_REPLACEMENTS = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
};
function $e41c0aad11182ec3$var$replaceUnsafeChar(ch) {
    return $e41c0aad11182ec3$var$HTML_REPLACEMENTS[ch];
}
function $e41c0aad11182ec3$export$4cf11838cdc2a8a8(str) {
    if ($e41c0aad11182ec3$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($e41c0aad11182ec3$var$HTML_ESCAPE_REPLACE_RE, $e41c0aad11182ec3$var$replaceUnsafeChar);
    return str;
}
const $e41c0aad11182ec3$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $e41c0aad11182ec3$export$bc616c8f7dc20d5d(str) {
    return str.replace($e41c0aad11182ec3$var$REGEXP_ESCAPE_RE, '\\$&');
}
function $e41c0aad11182ec3$export$1d5ccafae59b4926(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $e41c0aad11182ec3$export$3c52dd84024ae72c(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}
/* eslint-disable max-len */ // Currently without astral characters support.
function $e41c0aad11182ec3$export$4888a643af800fc1(ch) {
    return $9GUSE.default.test(ch) || $dYwW3.default.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $e41c0aad11182ec3$export$829a0d33ae4e744(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $e41c0aad11182ec3$export$20ef46802c8744b(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, ' ');
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
const $e41c0aad11182ec3$export$16c08b91f883959a = {
    mdurl: $8afOB,
    ucmicro: $8djVQ
};

});
parcelRegister("8afOB", function(module, exports) {
$parcel$export(module.exports, "decode", function () { return (parcelRequire("lhbnv")).default; });
$parcel$export(module.exports, "encode", function () { return (parcelRequire("PcDb4")).default; });
$parcel$export(module.exports, "format", function () { return (parcelRequire("6qrCN")).default; });
$parcel$export(module.exports, "parse", function () { return (parcelRequire("7Vk0b")).default; });

var $lhbnv = parcelRequire("lhbnv");

var $PcDb4 = parcelRequire("PcDb4");

var $6qrCN = parcelRequire("6qrCN");

var $7Vk0b = parcelRequire("7Vk0b");

});
parcelRegister("lhbnv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f7d402f929b6a126$export$2e2bcd8739ae039; });
/* eslint-disable no-bitwise */ const $f7d402f929b6a126$var$decodeCache = {};
function $f7d402f929b6a126$var$getDecodeCache(exclude) {
    let cache = $f7d402f929b6a126$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $f7d402f929b6a126$var$decodeCache[exclude] = [];
    for(let i = 0; i < 128; i++){
        const ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(let i = 0; i < exclude.length; i++){
        const ch = exclude.charCodeAt(i);
        cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $f7d402f929b6a126$var$decode(string, exclude) {
    if (typeof exclude !== 'string') exclude = $f7d402f929b6a126$var$decode.defaultChars;
    const cache = $f7d402f929b6a126$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        let result = '';
        for(let i = 0, l = seq.length; i < l; i += 3){
            const b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    const chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += '\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                const b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    const chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += '\ufffd\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                const b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                const b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    let chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += '\ufffd\ufffd\ufffd\ufffd';
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += '\ufffd';
        }
        return result;
    });
}
$f7d402f929b6a126$var$decode.defaultChars = ';/?:@&=+$,#';
$f7d402f929b6a126$var$decode.componentChars = '';
var $f7d402f929b6a126$export$2e2bcd8739ae039 = $f7d402f929b6a126$var$decode;

});

parcelRegister("PcDb4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $099e8fc492ec7acf$export$2e2bcd8739ae039; });
const $099e8fc492ec7acf$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $099e8fc492ec7acf$var$getEncodeCache(exclude) {
    let cache = $099e8fc492ec7acf$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $099e8fc492ec7acf$var$encodeCache[exclude] = [];
    for(let i = 0; i < 128; i++){
        const ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
    for(let i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $099e8fc492ec7acf$var$encode(string, exclude, keepEscaped) {
    if (typeof exclude !== 'string') {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $099e8fc492ec7acf$var$encode.defaultChars;
    }
    if (typeof keepEscaped === 'undefined') keepEscaped = true;
    const cache = $099e8fc492ec7acf$var$getEncodeCache(exclude);
    let result = '';
    for(let i = 0, l = string.length; i < l; i++){
        const code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                const nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += '%EF%BF%BD';
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$099e8fc492ec7acf$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$099e8fc492ec7acf$var$encode.componentChars = "-_.!~*'()";
var $099e8fc492ec7acf$export$2e2bcd8739ae039 = $099e8fc492ec7acf$var$encode;

});

parcelRegister("6qrCN", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4ada99764cddadd0$export$2e2bcd8739ae039; });
function $4ada99764cddadd0$export$2e2bcd8739ae039(url) {
    let result = '';
    result += url.protocol || '';
    result += url.slashes ? '//' : '';
    result += url.auth ? url.auth + '@' : '';
    if (url.hostname && url.hostname.indexOf(':') !== -1) // ipv6 address
    result += '[' + url.hostname + ']';
    else result += url.hostname || '';
    result += url.port ? ':' + url.port : '';
    result += url.pathname || '';
    result += url.search || '';
    result += url.hash || '';
    return result;
}

});

parcelRegister("7Vk0b", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5c4d5f44d8dac639$export$2e2bcd8739ae039; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $5c4d5f44d8dac639$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
const $5c4d5f44d8dac639$var$protocolPattern = /^([a-z0-9.+-]+:)/i;
const $5c4d5f44d8dac639$var$portPattern = /:[0-9]*$/;
// Special case for a simple path URL
/* eslint-disable-next-line no-useless-escape */ const $5c4d5f44d8dac639$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/;
// RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
const $5c4d5f44d8dac639$var$delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
];
// RFC 2396: characters not allowed for various reasons.
const $5c4d5f44d8dac639$var$unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat($5c4d5f44d8dac639$var$delims);
// Allowed by RFCs, but cause of XSS attacks.  Always escape these.
const $5c4d5f44d8dac639$var$autoEscape = [
    '\''
].concat($5c4d5f44d8dac639$var$unwise);
// Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
const $5c4d5f44d8dac639$var$nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat($5c4d5f44d8dac639$var$autoEscape);
const $5c4d5f44d8dac639$var$hostEndingChars = [
    '/',
    '?',
    '#'
];
const $5c4d5f44d8dac639$var$hostnameMaxLen = 255;
const $5c4d5f44d8dac639$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/;
const $5c4d5f44d8dac639$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/;
// protocols that can allow "unsafe" and "unwise" chars.
// protocols that never have a hostname.
const $5c4d5f44d8dac639$var$hostlessProtocol = {
    javascript: true,
    'javascript:': true
};
// protocols that always contain a // bit.
const $5c4d5f44d8dac639$var$slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};
function $5c4d5f44d8dac639$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $5c4d5f44d8dac639$var$Url) return url;
    const u = new $5c4d5f44d8dac639$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$5c4d5f44d8dac639$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    let lowerProto, hec, slashes;
    let rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        const simplePath = $5c4d5f44d8dac639$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    let proto = $5c4d5f44d8dac639$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    /* eslint-disable-next-line no-useless-escape */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && $5c4d5f44d8dac639$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$5c4d5f44d8dac639$var$hostlessProtocol[proto] && (slashes || proto && !$5c4d5f44d8dac639$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        let hostEnd = -1;
        for(let i = 0; i < $5c4d5f44d8dac639$var$hostEndingChars.length; i++){
            hec = rest.indexOf($5c4d5f44d8dac639$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        let auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(let i = 0; i < $5c4d5f44d8dac639$var$nonHostChars.length; i++){
            hec = rest.indexOf($5c4d5f44d8dac639$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ':') hostEnd--;
        const host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        const ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            const hostparts = this.hostname.split(/\./);
            for(let i = 0, l = hostparts.length; i < l; i++){
                const part = hostparts[i];
                if (!part) continue;
                if (!part.match($5c4d5f44d8dac639$var$hostnamePartPattern)) {
                    let newpart = '';
                    for(let j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($5c4d5f44d8dac639$var$hostnamePartPattern)) {
                        const validParts = hostparts.slice(0, i);
                        const notHost = hostparts.slice(i + 1);
                        const bit = part.match($5c4d5f44d8dac639$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $5c4d5f44d8dac639$var$hostnameMaxLen) this.hostname = '';
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    const hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    const qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($5c4d5f44d8dac639$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '';
    return this;
};
$5c4d5f44d8dac639$var$Url.prototype.parseHost = function(host) {
    let port = $5c4d5f44d8dac639$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
var $5c4d5f44d8dac639$export$2e2bcd8739ae039 = $5c4d5f44d8dac639$var$urlParse;

});


parcelRegister("8djVQ", function(module, exports) {
$parcel$export(module.exports, "Any", function () { return (parcelRequire("ioVOV")).default; });
$parcel$export(module.exports, "Cc", function () { return (parcelRequire("7ZsNi")).default; });
$parcel$export(module.exports, "Cf", function () { return (parcelRequire("lf7tL")).default; });
$parcel$export(module.exports, "P", function () { return (parcelRequire("9GUSE")).default; });
$parcel$export(module.exports, "S", function () { return (parcelRequire("dYwW3")).default; });
$parcel$export(module.exports, "Z", function () { return (parcelRequire("1GVtv")).default; });

var $ioVOV = parcelRequire("ioVOV");

var $7ZsNi = parcelRequire("7ZsNi");

var $lf7tL = parcelRequire("lf7tL");

var $9GUSE = parcelRequire("9GUSE");

var $dYwW3 = parcelRequire("dYwW3");

var $1GVtv = parcelRequire("1GVtv");

});
parcelRegister("ioVOV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d65751d28666c205$export$2e2bcd8739ae039; });
var $d65751d28666c205$export$2e2bcd8739ae039 = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("7ZsNi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5d1490d77285b6f9$export$2e2bcd8739ae039; });
var $5d1490d77285b6f9$export$2e2bcd8739ae039 = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("lf7tL", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f770cce01c154783$export$2e2bcd8739ae039; });
var $f770cce01c154783$export$2e2bcd8739ae039 = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});

parcelRegister("9GUSE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $70e42890993670cf$export$2e2bcd8739ae039; });
var $70e42890993670cf$export$2e2bcd8739ae039 = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});

parcelRegister("dYwW3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a2ca6d3d33e6bf9b$export$2e2bcd8739ae039; });
var $a2ca6d3d33e6bf9b$export$2e2bcd8739ae039 = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/;

});

parcelRegister("1GVtv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $13b64c0197223edc$export$2e2bcd8739ae039; });
var $13b64c0197223edc$export$2e2bcd8739ae039 = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});


parcelRegister("fyijY", function(module, exports) {
$parcel$export(module.exports, "decodeHTML", function () { return (parcelRequire("9i7QI")).decodeHTML; });

var $9i7QI = parcelRequire("9i7QI");

var $8lOYC = parcelRequire("8lOYC");

var $h82ow = parcelRequire("h82ow");
var $b5283e321449c041$export$b8c86583d9718b50;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})($b5283e321449c041$export$b8c86583d9718b50 || ($b5283e321449c041$export$b8c86583d9718b50 = {}));
var $b5283e321449c041$export$1851b20d614eb756;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})($b5283e321449c041$export$1851b20d614eb756 || ($b5283e321449c041$export$1851b20d614eb756 = {}));
function $b5283e321449c041$export$2f872c0f2117be69(data, options = $b5283e321449c041$export$b8c86583d9718b50.XML) {
    const level = typeof options === "number" ? options : options.level;
    if (level === $b5283e321449c041$export$b8c86583d9718b50.HTML) {
        const mode = typeof options === "object" ? options.mode : undefined;
        return (0, $9i7QI.decodeHTML)(data, mode);
    }
    return (0, $9i7QI.decodeXML)(data);
}
function $b5283e321449c041$export$c94669f4c7d36be4(data, options = $b5283e321449c041$export$b8c86583d9718b50.XML) {
    var _a;
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = (0, $9i7QI.DecodingMode).Strict;
    return $b5283e321449c041$export$2f872c0f2117be69(data, opts);
}
function $b5283e321449c041$export$c564cdbbe6da493(data, options = $b5283e321449c041$export$b8c86583d9718b50.XML) {
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === $b5283e321449c041$export$1851b20d614eb756.UTF8) return (0, $h82ow.escapeUTF8)(data);
    if (opts.mode === $b5283e321449c041$export$1851b20d614eb756.Attribute) return (0, $h82ow.escapeAttribute)(data);
    if (opts.mode === $b5283e321449c041$export$1851b20d614eb756.Text) return (0, $h82ow.escapeText)(data);
    if (opts.level === $b5283e321449c041$export$b8c86583d9718b50.HTML) {
        if (opts.mode === $b5283e321449c041$export$1851b20d614eb756.ASCII) return (0, $8lOYC.encodeNonAsciiHTML)(data);
        return (0, $8lOYC.encodeHTML)(data);
    }
    // ASCII and Extensive are equivalent
    return (0, $h82ow.encodeXML)(data);
}

});
parcelRegister("9i7QI", function(module, exports) {
$parcel$export(module.exports, "DecodingMode", function () { return $6c3be22c80aecac7$export$8c8f129ce60f53c; });
$parcel$export(module.exports, "decodeHTML", function () { return $6c3be22c80aecac7$export$f045cb747ce77a19; });
$parcel$export(module.exports, "decodeXML", function () { return $6c3be22c80aecac7$export$88e3b9643a8bd06e; });

var $j3h6Q = parcelRequire("j3h6Q");

var $7Ui2N = parcelRequire("7Ui2N");

var $fJ3ZX = parcelRequire("fJ3ZX");
var $6c3be22c80aecac7$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($6c3be22c80aecac7$var$CharCodes || ($6c3be22c80aecac7$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const $6c3be22c80aecac7$var$TO_LOWER_BIT = 32;
var $6c3be22c80aecac7$export$6a4325c613e0faec;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($6c3be22c80aecac7$export$6a4325c613e0faec || ($6c3be22c80aecac7$export$6a4325c613e0faec = {}));
function $6c3be22c80aecac7$var$isNumber(code) {
    return code >= $6c3be22c80aecac7$var$CharCodes.ZERO && code <= $6c3be22c80aecac7$var$CharCodes.NINE;
}
function $6c3be22c80aecac7$var$isHexadecimalCharacter(code) {
    return code >= $6c3be22c80aecac7$var$CharCodes.UPPER_A && code <= $6c3be22c80aecac7$var$CharCodes.UPPER_F || code >= $6c3be22c80aecac7$var$CharCodes.LOWER_A && code <= $6c3be22c80aecac7$var$CharCodes.LOWER_F;
}
function $6c3be22c80aecac7$var$isAsciiAlphaNumeric(code) {
    return code >= $6c3be22c80aecac7$var$CharCodes.UPPER_A && code <= $6c3be22c80aecac7$var$CharCodes.UPPER_Z || code >= $6c3be22c80aecac7$var$CharCodes.LOWER_A && code <= $6c3be22c80aecac7$var$CharCodes.LOWER_Z || $6c3be22c80aecac7$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $6c3be22c80aecac7$var$isEntityInAttributeInvalidEnd(code) {
    return code === $6c3be22c80aecac7$var$CharCodes.EQUALS || $6c3be22c80aecac7$var$isAsciiAlphaNumeric(code);
}
var $6c3be22c80aecac7$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($6c3be22c80aecac7$var$EntityDecoderState || ($6c3be22c80aecac7$var$EntityDecoderState = {}));
var $6c3be22c80aecac7$export$8c8f129ce60f53c;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($6c3be22c80aecac7$export$8c8f129ce60f53c || ($6c3be22c80aecac7$export$8c8f129ce60f53c = {}));
class $6c3be22c80aecac7$export$15263a93ff7ec8ba {
    /** Resets the instance to make it reusable. */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $6c3be22c80aecac7$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(str, offset) {
        switch(this.state){
            case $6c3be22c80aecac7$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $6c3be22c80aecac7$var$CharCodes.NUM) {
                    this.state = $6c3be22c80aecac7$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $6c3be22c80aecac7$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $6c3be22c80aecac7$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $6c3be22c80aecac7$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $6c3be22c80aecac7$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $6c3be22c80aecac7$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericStart(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $6c3be22c80aecac7$var$TO_LOWER_BIT) === $6c3be22c80aecac7$var$CharCodes.LOWER_X) {
            this.state = $6c3be22c80aecac7$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $6c3be22c80aecac7$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    }
    addToNumericResult(str, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($6c3be22c80aecac7$var$isNumber(char) || $6c3be22c80aecac7$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($6c3be22c80aecac7$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $6c3be22c80aecac7$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $6c3be22c80aecac7$export$8c8f129ce60f53c.Strict) return 0;
        this.emitCodePoint((0, $fJ3ZX.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $6c3be22c80aecac7$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(str, offset) {
        const { decodeTree: decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & $6c3be22c80aecac7$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            const char = str.charCodeAt(offset);
            this.treeIndex = $6c3be22c80aecac7$export$44c08d99945e6276(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $6c3be22c80aecac7$export$8c8f129ce60f53c.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $6c3be22c80aecac7$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $6c3be22c80aecac7$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $6c3be22c80aecac7$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $6c3be22c80aecac7$export$8c8f129ce60f53c.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        var _a;
        const { result: result, decodeTree: decodeTree } = this;
        const valueLength = (decodeTree[result] & $6c3be22c80aecac7$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree: decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$6c3be22c80aecac7$export$6a4325c613e0faec.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ end() {
        var _a;
        switch(this.state){
            case $6c3be22c80aecac7$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $6c3be22c80aecac7$export$8c8f129ce60f53c.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $6c3be22c80aecac7$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $6c3be22c80aecac7$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $6c3be22c80aecac7$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $6c3be22c80aecac7$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    }
    constructor(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $6c3be22c80aecac7$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $6c3be22c80aecac7$export$8c8f129ce60f53c.Strict;
    }
}
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $6c3be22c80aecac7$var$getDecoder(decodeTree) {
    let ret = "";
    const decoder = new $6c3be22c80aecac7$export$15263a93ff7ec8ba(decodeTree, (str)=>ret += (0, $fJ3ZX.fromCodePoint)(str));
    return function decodeWithTrie(str, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
function $6c3be22c80aecac7$export$44c08d99945e6276(decodeTree, current, nodeIdx, char) {
    const branchCount = (current & $6c3be22c80aecac7$export$6a4325c613e0faec.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & $6c3be22c80aecac7$export$6a4325c613e0faec.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIdx;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
const $6c3be22c80aecac7$var$htmlDecoder = $6c3be22c80aecac7$var$getDecoder((0, $j3h6Q.default));
const $6c3be22c80aecac7$var$xmlDecoder = $6c3be22c80aecac7$var$getDecoder((0, $7Ui2N.default));
function $6c3be22c80aecac7$export$f045cb747ce77a19(str, mode = $6c3be22c80aecac7$export$8c8f129ce60f53c.Legacy) {
    return $6c3be22c80aecac7$var$htmlDecoder(str, mode);
}
function $6c3be22c80aecac7$export$49f5e8089adb006a(str) {
    return $6c3be22c80aecac7$var$htmlDecoder(str, $6c3be22c80aecac7$export$8c8f129ce60f53c.Attribute);
}
function $6c3be22c80aecac7$export$da52f4371b3f37de(str) {
    return $6c3be22c80aecac7$var$htmlDecoder(str, $6c3be22c80aecac7$export$8c8f129ce60f53c.Strict);
}
function $6c3be22c80aecac7$export$88e3b9643a8bd06e(str) {
    return $6c3be22c80aecac7$var$xmlDecoder(str, $6c3be22c80aecac7$export$8c8f129ce60f53c.Strict);
}

});
parcelRegister("j3h6Q", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ddeb91b5ddfb9405$export$2e2bcd8739ae039; });
// Generated using scripts/write-decode-map.ts
var $ddeb91b5ddfb9405$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("7Ui2N", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5c1bc29187a584dd$export$2e2bcd8739ae039; });
// Generated using scripts/write-decode-map.ts
var $5c1bc29187a584dd$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("fJ3ZX", function(module, exports) {
$parcel$export(module.exports, "fromCodePoint", function () { return $b72e28f1e48a721c$export$73bfc63873071f74; });
$parcel$export(module.exports, "replaceCodePoint", function () { return $b72e28f1e48a721c$export$b978ab756102108a; });
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $b72e28f1e48a721c$var$_a;
const $b72e28f1e48a721c$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
const $b72e28f1e48a721c$export$73bfc63873071f74 = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($b72e28f1e48a721c$var$_a = String.fromCodePoint) !== null && $b72e28f1e48a721c$var$_a !== void 0 ? $b72e28f1e48a721c$var$_a : function(codePoint) {
    let output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function $b72e28f1e48a721c$export$b978ab756102108a(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $b72e28f1e48a721c$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
function $b72e28f1e48a721c$export$2e2bcd8739ae039(codePoint) {
    return $b72e28f1e48a721c$export$73bfc63873071f74($b72e28f1e48a721c$export$b978ab756102108a(codePoint));
}

});


parcelRegister("8lOYC", function(module, exports) {
$parcel$export(module.exports, "encodeHTML", function () { return $6147d3d29ddd075c$export$f9d6449b9af28dc1; });
$parcel$export(module.exports, "encodeNonAsciiHTML", function () { return $6147d3d29ddd075c$export$e6e86c76506f1190; });

var $7Zx4d = parcelRequire("7Zx4d");

var $h82ow = parcelRequire("h82ow");
const $6147d3d29ddd075c$var$htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function $6147d3d29ddd075c$export$f9d6449b9af28dc1(data) {
    return $6147d3d29ddd075c$var$encodeHTMLTrieRe($6147d3d29ddd075c$var$htmlReplacer, data);
}
function $6147d3d29ddd075c$export$e6e86c76506f1190(data) {
    return $6147d3d29ddd075c$var$encodeHTMLTrieRe((0, $h82ow.xmlReplacer), data);
}
function $6147d3d29ddd075c$var$encodeHTMLTrieRe(regExp, str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = regExp.exec(str)) !== null){
        const i = match.index;
        ret += str.substring(lastIdx, i);
        const char = str.charCodeAt(i);
        let next = (0, $7Zx4d.default).get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                const nextChar = str.charCodeAt(i + 1);
                const value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        } else {
            const cp = (0, $h82ow.getCodePoint)(str, i);
            ret += `&#x${cp.toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}

});
parcelRegister("7Zx4d", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $5d17e1547aea90db$export$2e2bcd8739ae039; });
// Generated using scripts/write-encode-map.ts
function $5d17e1547aea90db$var$restoreDiff(arr) {
    for(let i = 1; i < arr.length; i++)arr[i][0] += arr[i - 1][0] + 1;
    return arr;
}
var // prettier-ignore
$5d17e1547aea90db$export$2e2bcd8739ae039 = new Map(/* #__PURE__ */ $5d17e1547aea90db$var$restoreDiff([
    [
        9,
        "&Tab;"
    ],
    [
        0,
        "&NewLine;"
    ],
    [
        22,
        "&excl;"
    ],
    [
        0,
        "&quot;"
    ],
    [
        0,
        "&num;"
    ],
    [
        0,
        "&dollar;"
    ],
    [
        0,
        "&percnt;"
    ],
    [
        0,
        "&amp;"
    ],
    [
        0,
        "&apos;"
    ],
    [
        0,
        "&lpar;"
    ],
    [
        0,
        "&rpar;"
    ],
    [
        0,
        "&ast;"
    ],
    [
        0,
        "&plus;"
    ],
    [
        0,
        "&comma;"
    ],
    [
        1,
        "&period;"
    ],
    [
        0,
        "&sol;"
    ],
    [
        10,
        "&colon;"
    ],
    [
        0,
        "&semi;"
    ],
    [
        0,
        {
            v: "&lt;",
            n: 8402,
            o: "&nvlt;"
        }
    ],
    [
        0,
        {
            v: "&equals;",
            n: 8421,
            o: "&bne;"
        }
    ],
    [
        0,
        {
            v: "&gt;",
            n: 8402,
            o: "&nvgt;"
        }
    ],
    [
        0,
        "&quest;"
    ],
    [
        0,
        "&commat;"
    ],
    [
        26,
        "&lbrack;"
    ],
    [
        0,
        "&bsol;"
    ],
    [
        0,
        "&rbrack;"
    ],
    [
        0,
        "&Hat;"
    ],
    [
        0,
        "&lowbar;"
    ],
    [
        0,
        "&DiacriticalGrave;"
    ],
    [
        5,
        {
            n: 106,
            o: "&fjlig;"
        }
    ],
    [
        20,
        "&lbrace;"
    ],
    [
        0,
        "&verbar;"
    ],
    [
        0,
        "&rbrace;"
    ],
    [
        34,
        "&nbsp;"
    ],
    [
        0,
        "&iexcl;"
    ],
    [
        0,
        "&cent;"
    ],
    [
        0,
        "&pound;"
    ],
    [
        0,
        "&curren;"
    ],
    [
        0,
        "&yen;"
    ],
    [
        0,
        "&brvbar;"
    ],
    [
        0,
        "&sect;"
    ],
    [
        0,
        "&die;"
    ],
    [
        0,
        "&copy;"
    ],
    [
        0,
        "&ordf;"
    ],
    [
        0,
        "&laquo;"
    ],
    [
        0,
        "&not;"
    ],
    [
        0,
        "&shy;"
    ],
    [
        0,
        "&circledR;"
    ],
    [
        0,
        "&macr;"
    ],
    [
        0,
        "&deg;"
    ],
    [
        0,
        "&PlusMinus;"
    ],
    [
        0,
        "&sup2;"
    ],
    [
        0,
        "&sup3;"
    ],
    [
        0,
        "&acute;"
    ],
    [
        0,
        "&micro;"
    ],
    [
        0,
        "&para;"
    ],
    [
        0,
        "&centerdot;"
    ],
    [
        0,
        "&cedil;"
    ],
    [
        0,
        "&sup1;"
    ],
    [
        0,
        "&ordm;"
    ],
    [
        0,
        "&raquo;"
    ],
    [
        0,
        "&frac14;"
    ],
    [
        0,
        "&frac12;"
    ],
    [
        0,
        "&frac34;"
    ],
    [
        0,
        "&iquest;"
    ],
    [
        0,
        "&Agrave;"
    ],
    [
        0,
        "&Aacute;"
    ],
    [
        0,
        "&Acirc;"
    ],
    [
        0,
        "&Atilde;"
    ],
    [
        0,
        "&Auml;"
    ],
    [
        0,
        "&angst;"
    ],
    [
        0,
        "&AElig;"
    ],
    [
        0,
        "&Ccedil;"
    ],
    [
        0,
        "&Egrave;"
    ],
    [
        0,
        "&Eacute;"
    ],
    [
        0,
        "&Ecirc;"
    ],
    [
        0,
        "&Euml;"
    ],
    [
        0,
        "&Igrave;"
    ],
    [
        0,
        "&Iacute;"
    ],
    [
        0,
        "&Icirc;"
    ],
    [
        0,
        "&Iuml;"
    ],
    [
        0,
        "&ETH;"
    ],
    [
        0,
        "&Ntilde;"
    ],
    [
        0,
        "&Ograve;"
    ],
    [
        0,
        "&Oacute;"
    ],
    [
        0,
        "&Ocirc;"
    ],
    [
        0,
        "&Otilde;"
    ],
    [
        0,
        "&Ouml;"
    ],
    [
        0,
        "&times;"
    ],
    [
        0,
        "&Oslash;"
    ],
    [
        0,
        "&Ugrave;"
    ],
    [
        0,
        "&Uacute;"
    ],
    [
        0,
        "&Ucirc;"
    ],
    [
        0,
        "&Uuml;"
    ],
    [
        0,
        "&Yacute;"
    ],
    [
        0,
        "&THORN;"
    ],
    [
        0,
        "&szlig;"
    ],
    [
        0,
        "&agrave;"
    ],
    [
        0,
        "&aacute;"
    ],
    [
        0,
        "&acirc;"
    ],
    [
        0,
        "&atilde;"
    ],
    [
        0,
        "&auml;"
    ],
    [
        0,
        "&aring;"
    ],
    [
        0,
        "&aelig;"
    ],
    [
        0,
        "&ccedil;"
    ],
    [
        0,
        "&egrave;"
    ],
    [
        0,
        "&eacute;"
    ],
    [
        0,
        "&ecirc;"
    ],
    [
        0,
        "&euml;"
    ],
    [
        0,
        "&igrave;"
    ],
    [
        0,
        "&iacute;"
    ],
    [
        0,
        "&icirc;"
    ],
    [
        0,
        "&iuml;"
    ],
    [
        0,
        "&eth;"
    ],
    [
        0,
        "&ntilde;"
    ],
    [
        0,
        "&ograve;"
    ],
    [
        0,
        "&oacute;"
    ],
    [
        0,
        "&ocirc;"
    ],
    [
        0,
        "&otilde;"
    ],
    [
        0,
        "&ouml;"
    ],
    [
        0,
        "&div;"
    ],
    [
        0,
        "&oslash;"
    ],
    [
        0,
        "&ugrave;"
    ],
    [
        0,
        "&uacute;"
    ],
    [
        0,
        "&ucirc;"
    ],
    [
        0,
        "&uuml;"
    ],
    [
        0,
        "&yacute;"
    ],
    [
        0,
        "&thorn;"
    ],
    [
        0,
        "&yuml;"
    ],
    [
        0,
        "&Amacr;"
    ],
    [
        0,
        "&amacr;"
    ],
    [
        0,
        "&Abreve;"
    ],
    [
        0,
        "&abreve;"
    ],
    [
        0,
        "&Aogon;"
    ],
    [
        0,
        "&aogon;"
    ],
    [
        0,
        "&Cacute;"
    ],
    [
        0,
        "&cacute;"
    ],
    [
        0,
        "&Ccirc;"
    ],
    [
        0,
        "&ccirc;"
    ],
    [
        0,
        "&Cdot;"
    ],
    [
        0,
        "&cdot;"
    ],
    [
        0,
        "&Ccaron;"
    ],
    [
        0,
        "&ccaron;"
    ],
    [
        0,
        "&Dcaron;"
    ],
    [
        0,
        "&dcaron;"
    ],
    [
        0,
        "&Dstrok;"
    ],
    [
        0,
        "&dstrok;"
    ],
    [
        0,
        "&Emacr;"
    ],
    [
        0,
        "&emacr;"
    ],
    [
        2,
        "&Edot;"
    ],
    [
        0,
        "&edot;"
    ],
    [
        0,
        "&Eogon;"
    ],
    [
        0,
        "&eogon;"
    ],
    [
        0,
        "&Ecaron;"
    ],
    [
        0,
        "&ecaron;"
    ],
    [
        0,
        "&Gcirc;"
    ],
    [
        0,
        "&gcirc;"
    ],
    [
        0,
        "&Gbreve;"
    ],
    [
        0,
        "&gbreve;"
    ],
    [
        0,
        "&Gdot;"
    ],
    [
        0,
        "&gdot;"
    ],
    [
        0,
        "&Gcedil;"
    ],
    [
        1,
        "&Hcirc;"
    ],
    [
        0,
        "&hcirc;"
    ],
    [
        0,
        "&Hstrok;"
    ],
    [
        0,
        "&hstrok;"
    ],
    [
        0,
        "&Itilde;"
    ],
    [
        0,
        "&itilde;"
    ],
    [
        0,
        "&Imacr;"
    ],
    [
        0,
        "&imacr;"
    ],
    [
        2,
        "&Iogon;"
    ],
    [
        0,
        "&iogon;"
    ],
    [
        0,
        "&Idot;"
    ],
    [
        0,
        "&imath;"
    ],
    [
        0,
        "&IJlig;"
    ],
    [
        0,
        "&ijlig;"
    ],
    [
        0,
        "&Jcirc;"
    ],
    [
        0,
        "&jcirc;"
    ],
    [
        0,
        "&Kcedil;"
    ],
    [
        0,
        "&kcedil;"
    ],
    [
        0,
        "&kgreen;"
    ],
    [
        0,
        "&Lacute;"
    ],
    [
        0,
        "&lacute;"
    ],
    [
        0,
        "&Lcedil;"
    ],
    [
        0,
        "&lcedil;"
    ],
    [
        0,
        "&Lcaron;"
    ],
    [
        0,
        "&lcaron;"
    ],
    [
        0,
        "&Lmidot;"
    ],
    [
        0,
        "&lmidot;"
    ],
    [
        0,
        "&Lstrok;"
    ],
    [
        0,
        "&lstrok;"
    ],
    [
        0,
        "&Nacute;"
    ],
    [
        0,
        "&nacute;"
    ],
    [
        0,
        "&Ncedil;"
    ],
    [
        0,
        "&ncedil;"
    ],
    [
        0,
        "&Ncaron;"
    ],
    [
        0,
        "&ncaron;"
    ],
    [
        0,
        "&napos;"
    ],
    [
        0,
        "&ENG;"
    ],
    [
        0,
        "&eng;"
    ],
    [
        0,
        "&Omacr;"
    ],
    [
        0,
        "&omacr;"
    ],
    [
        2,
        "&Odblac;"
    ],
    [
        0,
        "&odblac;"
    ],
    [
        0,
        "&OElig;"
    ],
    [
        0,
        "&oelig;"
    ],
    [
        0,
        "&Racute;"
    ],
    [
        0,
        "&racute;"
    ],
    [
        0,
        "&Rcedil;"
    ],
    [
        0,
        "&rcedil;"
    ],
    [
        0,
        "&Rcaron;"
    ],
    [
        0,
        "&rcaron;"
    ],
    [
        0,
        "&Sacute;"
    ],
    [
        0,
        "&sacute;"
    ],
    [
        0,
        "&Scirc;"
    ],
    [
        0,
        "&scirc;"
    ],
    [
        0,
        "&Scedil;"
    ],
    [
        0,
        "&scedil;"
    ],
    [
        0,
        "&Scaron;"
    ],
    [
        0,
        "&scaron;"
    ],
    [
        0,
        "&Tcedil;"
    ],
    [
        0,
        "&tcedil;"
    ],
    [
        0,
        "&Tcaron;"
    ],
    [
        0,
        "&tcaron;"
    ],
    [
        0,
        "&Tstrok;"
    ],
    [
        0,
        "&tstrok;"
    ],
    [
        0,
        "&Utilde;"
    ],
    [
        0,
        "&utilde;"
    ],
    [
        0,
        "&Umacr;"
    ],
    [
        0,
        "&umacr;"
    ],
    [
        0,
        "&Ubreve;"
    ],
    [
        0,
        "&ubreve;"
    ],
    [
        0,
        "&Uring;"
    ],
    [
        0,
        "&uring;"
    ],
    [
        0,
        "&Udblac;"
    ],
    [
        0,
        "&udblac;"
    ],
    [
        0,
        "&Uogon;"
    ],
    [
        0,
        "&uogon;"
    ],
    [
        0,
        "&Wcirc;"
    ],
    [
        0,
        "&wcirc;"
    ],
    [
        0,
        "&Ycirc;"
    ],
    [
        0,
        "&ycirc;"
    ],
    [
        0,
        "&Yuml;"
    ],
    [
        0,
        "&Zacute;"
    ],
    [
        0,
        "&zacute;"
    ],
    [
        0,
        "&Zdot;"
    ],
    [
        0,
        "&zdot;"
    ],
    [
        0,
        "&Zcaron;"
    ],
    [
        0,
        "&zcaron;"
    ],
    [
        19,
        "&fnof;"
    ],
    [
        34,
        "&imped;"
    ],
    [
        63,
        "&gacute;"
    ],
    [
        65,
        "&jmath;"
    ],
    [
        142,
        "&circ;"
    ],
    [
        0,
        "&caron;"
    ],
    [
        16,
        "&breve;"
    ],
    [
        0,
        "&DiacriticalDot;"
    ],
    [
        0,
        "&ring;"
    ],
    [
        0,
        "&ogon;"
    ],
    [
        0,
        "&DiacriticalTilde;"
    ],
    [
        0,
        "&dblac;"
    ],
    [
        51,
        "&DownBreve;"
    ],
    [
        127,
        "&Alpha;"
    ],
    [
        0,
        "&Beta;"
    ],
    [
        0,
        "&Gamma;"
    ],
    [
        0,
        "&Delta;"
    ],
    [
        0,
        "&Epsilon;"
    ],
    [
        0,
        "&Zeta;"
    ],
    [
        0,
        "&Eta;"
    ],
    [
        0,
        "&Theta;"
    ],
    [
        0,
        "&Iota;"
    ],
    [
        0,
        "&Kappa;"
    ],
    [
        0,
        "&Lambda;"
    ],
    [
        0,
        "&Mu;"
    ],
    [
        0,
        "&Nu;"
    ],
    [
        0,
        "&Xi;"
    ],
    [
        0,
        "&Omicron;"
    ],
    [
        0,
        "&Pi;"
    ],
    [
        0,
        "&Rho;"
    ],
    [
        1,
        "&Sigma;"
    ],
    [
        0,
        "&Tau;"
    ],
    [
        0,
        "&Upsilon;"
    ],
    [
        0,
        "&Phi;"
    ],
    [
        0,
        "&Chi;"
    ],
    [
        0,
        "&Psi;"
    ],
    [
        0,
        "&ohm;"
    ],
    [
        7,
        "&alpha;"
    ],
    [
        0,
        "&beta;"
    ],
    [
        0,
        "&gamma;"
    ],
    [
        0,
        "&delta;"
    ],
    [
        0,
        "&epsi;"
    ],
    [
        0,
        "&zeta;"
    ],
    [
        0,
        "&eta;"
    ],
    [
        0,
        "&theta;"
    ],
    [
        0,
        "&iota;"
    ],
    [
        0,
        "&kappa;"
    ],
    [
        0,
        "&lambda;"
    ],
    [
        0,
        "&mu;"
    ],
    [
        0,
        "&nu;"
    ],
    [
        0,
        "&xi;"
    ],
    [
        0,
        "&omicron;"
    ],
    [
        0,
        "&pi;"
    ],
    [
        0,
        "&rho;"
    ],
    [
        0,
        "&sigmaf;"
    ],
    [
        0,
        "&sigma;"
    ],
    [
        0,
        "&tau;"
    ],
    [
        0,
        "&upsi;"
    ],
    [
        0,
        "&phi;"
    ],
    [
        0,
        "&chi;"
    ],
    [
        0,
        "&psi;"
    ],
    [
        0,
        "&omega;"
    ],
    [
        7,
        "&thetasym;"
    ],
    [
        0,
        "&Upsi;"
    ],
    [
        2,
        "&phiv;"
    ],
    [
        0,
        "&piv;"
    ],
    [
        5,
        "&Gammad;"
    ],
    [
        0,
        "&digamma;"
    ],
    [
        18,
        "&kappav;"
    ],
    [
        0,
        "&rhov;"
    ],
    [
        3,
        "&epsiv;"
    ],
    [
        0,
        "&backepsilon;"
    ],
    [
        10,
        "&IOcy;"
    ],
    [
        0,
        "&DJcy;"
    ],
    [
        0,
        "&GJcy;"
    ],
    [
        0,
        "&Jukcy;"
    ],
    [
        0,
        "&DScy;"
    ],
    [
        0,
        "&Iukcy;"
    ],
    [
        0,
        "&YIcy;"
    ],
    [
        0,
        "&Jsercy;"
    ],
    [
        0,
        "&LJcy;"
    ],
    [
        0,
        "&NJcy;"
    ],
    [
        0,
        "&TSHcy;"
    ],
    [
        0,
        "&KJcy;"
    ],
    [
        1,
        "&Ubrcy;"
    ],
    [
        0,
        "&DZcy;"
    ],
    [
        0,
        "&Acy;"
    ],
    [
        0,
        "&Bcy;"
    ],
    [
        0,
        "&Vcy;"
    ],
    [
        0,
        "&Gcy;"
    ],
    [
        0,
        "&Dcy;"
    ],
    [
        0,
        "&IEcy;"
    ],
    [
        0,
        "&ZHcy;"
    ],
    [
        0,
        "&Zcy;"
    ],
    [
        0,
        "&Icy;"
    ],
    [
        0,
        "&Jcy;"
    ],
    [
        0,
        "&Kcy;"
    ],
    [
        0,
        "&Lcy;"
    ],
    [
        0,
        "&Mcy;"
    ],
    [
        0,
        "&Ncy;"
    ],
    [
        0,
        "&Ocy;"
    ],
    [
        0,
        "&Pcy;"
    ],
    [
        0,
        "&Rcy;"
    ],
    [
        0,
        "&Scy;"
    ],
    [
        0,
        "&Tcy;"
    ],
    [
        0,
        "&Ucy;"
    ],
    [
        0,
        "&Fcy;"
    ],
    [
        0,
        "&KHcy;"
    ],
    [
        0,
        "&TScy;"
    ],
    [
        0,
        "&CHcy;"
    ],
    [
        0,
        "&SHcy;"
    ],
    [
        0,
        "&SHCHcy;"
    ],
    [
        0,
        "&HARDcy;"
    ],
    [
        0,
        "&Ycy;"
    ],
    [
        0,
        "&SOFTcy;"
    ],
    [
        0,
        "&Ecy;"
    ],
    [
        0,
        "&YUcy;"
    ],
    [
        0,
        "&YAcy;"
    ],
    [
        0,
        "&acy;"
    ],
    [
        0,
        "&bcy;"
    ],
    [
        0,
        "&vcy;"
    ],
    [
        0,
        "&gcy;"
    ],
    [
        0,
        "&dcy;"
    ],
    [
        0,
        "&iecy;"
    ],
    [
        0,
        "&zhcy;"
    ],
    [
        0,
        "&zcy;"
    ],
    [
        0,
        "&icy;"
    ],
    [
        0,
        "&jcy;"
    ],
    [
        0,
        "&kcy;"
    ],
    [
        0,
        "&lcy;"
    ],
    [
        0,
        "&mcy;"
    ],
    [
        0,
        "&ncy;"
    ],
    [
        0,
        "&ocy;"
    ],
    [
        0,
        "&pcy;"
    ],
    [
        0,
        "&rcy;"
    ],
    [
        0,
        "&scy;"
    ],
    [
        0,
        "&tcy;"
    ],
    [
        0,
        "&ucy;"
    ],
    [
        0,
        "&fcy;"
    ],
    [
        0,
        "&khcy;"
    ],
    [
        0,
        "&tscy;"
    ],
    [
        0,
        "&chcy;"
    ],
    [
        0,
        "&shcy;"
    ],
    [
        0,
        "&shchcy;"
    ],
    [
        0,
        "&hardcy;"
    ],
    [
        0,
        "&ycy;"
    ],
    [
        0,
        "&softcy;"
    ],
    [
        0,
        "&ecy;"
    ],
    [
        0,
        "&yucy;"
    ],
    [
        0,
        "&yacy;"
    ],
    [
        1,
        "&iocy;"
    ],
    [
        0,
        "&djcy;"
    ],
    [
        0,
        "&gjcy;"
    ],
    [
        0,
        "&jukcy;"
    ],
    [
        0,
        "&dscy;"
    ],
    [
        0,
        "&iukcy;"
    ],
    [
        0,
        "&yicy;"
    ],
    [
        0,
        "&jsercy;"
    ],
    [
        0,
        "&ljcy;"
    ],
    [
        0,
        "&njcy;"
    ],
    [
        0,
        "&tshcy;"
    ],
    [
        0,
        "&kjcy;"
    ],
    [
        1,
        "&ubrcy;"
    ],
    [
        0,
        "&dzcy;"
    ],
    [
        7074,
        "&ensp;"
    ],
    [
        0,
        "&emsp;"
    ],
    [
        0,
        "&emsp13;"
    ],
    [
        0,
        "&emsp14;"
    ],
    [
        1,
        "&numsp;"
    ],
    [
        0,
        "&puncsp;"
    ],
    [
        0,
        "&ThinSpace;"
    ],
    [
        0,
        "&hairsp;"
    ],
    [
        0,
        "&NegativeMediumSpace;"
    ],
    [
        0,
        "&zwnj;"
    ],
    [
        0,
        "&zwj;"
    ],
    [
        0,
        "&lrm;"
    ],
    [
        0,
        "&rlm;"
    ],
    [
        0,
        "&dash;"
    ],
    [
        2,
        "&ndash;"
    ],
    [
        0,
        "&mdash;"
    ],
    [
        0,
        "&horbar;"
    ],
    [
        0,
        "&Verbar;"
    ],
    [
        1,
        "&lsquo;"
    ],
    [
        0,
        "&CloseCurlyQuote;"
    ],
    [
        0,
        "&lsquor;"
    ],
    [
        1,
        "&ldquo;"
    ],
    [
        0,
        "&CloseCurlyDoubleQuote;"
    ],
    [
        0,
        "&bdquo;"
    ],
    [
        1,
        "&dagger;"
    ],
    [
        0,
        "&Dagger;"
    ],
    [
        0,
        "&bull;"
    ],
    [
        2,
        "&nldr;"
    ],
    [
        0,
        "&hellip;"
    ],
    [
        9,
        "&permil;"
    ],
    [
        0,
        "&pertenk;"
    ],
    [
        0,
        "&prime;"
    ],
    [
        0,
        "&Prime;"
    ],
    [
        0,
        "&tprime;"
    ],
    [
        0,
        "&backprime;"
    ],
    [
        3,
        "&lsaquo;"
    ],
    [
        0,
        "&rsaquo;"
    ],
    [
        3,
        "&oline;"
    ],
    [
        2,
        "&caret;"
    ],
    [
        1,
        "&hybull;"
    ],
    [
        0,
        "&frasl;"
    ],
    [
        10,
        "&bsemi;"
    ],
    [
        7,
        "&qprime;"
    ],
    [
        7,
        {
            v: "&MediumSpace;",
            n: 8202,
            o: "&ThickSpace;"
        }
    ],
    [
        0,
        "&NoBreak;"
    ],
    [
        0,
        "&af;"
    ],
    [
        0,
        "&InvisibleTimes;"
    ],
    [
        0,
        "&ic;"
    ],
    [
        72,
        "&euro;"
    ],
    [
        46,
        "&tdot;"
    ],
    [
        0,
        "&DotDot;"
    ],
    [
        37,
        "&complexes;"
    ],
    [
        2,
        "&incare;"
    ],
    [
        4,
        "&gscr;"
    ],
    [
        0,
        "&hamilt;"
    ],
    [
        0,
        "&Hfr;"
    ],
    [
        0,
        "&Hopf;"
    ],
    [
        0,
        "&planckh;"
    ],
    [
        0,
        "&hbar;"
    ],
    [
        0,
        "&imagline;"
    ],
    [
        0,
        "&Ifr;"
    ],
    [
        0,
        "&lagran;"
    ],
    [
        0,
        "&ell;"
    ],
    [
        1,
        "&naturals;"
    ],
    [
        0,
        "&numero;"
    ],
    [
        0,
        "&copysr;"
    ],
    [
        0,
        "&weierp;"
    ],
    [
        0,
        "&Popf;"
    ],
    [
        0,
        "&Qopf;"
    ],
    [
        0,
        "&realine;"
    ],
    [
        0,
        "&real;"
    ],
    [
        0,
        "&reals;"
    ],
    [
        0,
        "&rx;"
    ],
    [
        3,
        "&trade;"
    ],
    [
        1,
        "&integers;"
    ],
    [
        2,
        "&mho;"
    ],
    [
        0,
        "&zeetrf;"
    ],
    [
        0,
        "&iiota;"
    ],
    [
        2,
        "&bernou;"
    ],
    [
        0,
        "&Cayleys;"
    ],
    [
        1,
        "&escr;"
    ],
    [
        0,
        "&Escr;"
    ],
    [
        0,
        "&Fouriertrf;"
    ],
    [
        1,
        "&Mellintrf;"
    ],
    [
        0,
        "&order;"
    ],
    [
        0,
        "&alefsym;"
    ],
    [
        0,
        "&beth;"
    ],
    [
        0,
        "&gimel;"
    ],
    [
        0,
        "&daleth;"
    ],
    [
        12,
        "&CapitalDifferentialD;"
    ],
    [
        0,
        "&dd;"
    ],
    [
        0,
        "&ee;"
    ],
    [
        0,
        "&ii;"
    ],
    [
        10,
        "&frac13;"
    ],
    [
        0,
        "&frac23;"
    ],
    [
        0,
        "&frac15;"
    ],
    [
        0,
        "&frac25;"
    ],
    [
        0,
        "&frac35;"
    ],
    [
        0,
        "&frac45;"
    ],
    [
        0,
        "&frac16;"
    ],
    [
        0,
        "&frac56;"
    ],
    [
        0,
        "&frac18;"
    ],
    [
        0,
        "&frac38;"
    ],
    [
        0,
        "&frac58;"
    ],
    [
        0,
        "&frac78;"
    ],
    [
        49,
        "&larr;"
    ],
    [
        0,
        "&ShortUpArrow;"
    ],
    [
        0,
        "&rarr;"
    ],
    [
        0,
        "&darr;"
    ],
    [
        0,
        "&harr;"
    ],
    [
        0,
        "&updownarrow;"
    ],
    [
        0,
        "&nwarr;"
    ],
    [
        0,
        "&nearr;"
    ],
    [
        0,
        "&LowerRightArrow;"
    ],
    [
        0,
        "&LowerLeftArrow;"
    ],
    [
        0,
        "&nlarr;"
    ],
    [
        0,
        "&nrarr;"
    ],
    [
        1,
        {
            v: "&rarrw;",
            n: 824,
            o: "&nrarrw;"
        }
    ],
    [
        0,
        "&Larr;"
    ],
    [
        0,
        "&Uarr;"
    ],
    [
        0,
        "&Rarr;"
    ],
    [
        0,
        "&Darr;"
    ],
    [
        0,
        "&larrtl;"
    ],
    [
        0,
        "&rarrtl;"
    ],
    [
        0,
        "&LeftTeeArrow;"
    ],
    [
        0,
        "&mapstoup;"
    ],
    [
        0,
        "&map;"
    ],
    [
        0,
        "&DownTeeArrow;"
    ],
    [
        1,
        "&hookleftarrow;"
    ],
    [
        0,
        "&hookrightarrow;"
    ],
    [
        0,
        "&larrlp;"
    ],
    [
        0,
        "&looparrowright;"
    ],
    [
        0,
        "&harrw;"
    ],
    [
        0,
        "&nharr;"
    ],
    [
        1,
        "&lsh;"
    ],
    [
        0,
        "&rsh;"
    ],
    [
        0,
        "&ldsh;"
    ],
    [
        0,
        "&rdsh;"
    ],
    [
        1,
        "&crarr;"
    ],
    [
        0,
        "&cularr;"
    ],
    [
        0,
        "&curarr;"
    ],
    [
        2,
        "&circlearrowleft;"
    ],
    [
        0,
        "&circlearrowright;"
    ],
    [
        0,
        "&leftharpoonup;"
    ],
    [
        0,
        "&DownLeftVector;"
    ],
    [
        0,
        "&RightUpVector;"
    ],
    [
        0,
        "&LeftUpVector;"
    ],
    [
        0,
        "&rharu;"
    ],
    [
        0,
        "&DownRightVector;"
    ],
    [
        0,
        "&dharr;"
    ],
    [
        0,
        "&dharl;"
    ],
    [
        0,
        "&RightArrowLeftArrow;"
    ],
    [
        0,
        "&udarr;"
    ],
    [
        0,
        "&LeftArrowRightArrow;"
    ],
    [
        0,
        "&leftleftarrows;"
    ],
    [
        0,
        "&upuparrows;"
    ],
    [
        0,
        "&rightrightarrows;"
    ],
    [
        0,
        "&ddarr;"
    ],
    [
        0,
        "&leftrightharpoons;"
    ],
    [
        0,
        "&Equilibrium;"
    ],
    [
        0,
        "&nlArr;"
    ],
    [
        0,
        "&nhArr;"
    ],
    [
        0,
        "&nrArr;"
    ],
    [
        0,
        "&DoubleLeftArrow;"
    ],
    [
        0,
        "&DoubleUpArrow;"
    ],
    [
        0,
        "&DoubleRightArrow;"
    ],
    [
        0,
        "&dArr;"
    ],
    [
        0,
        "&DoubleLeftRightArrow;"
    ],
    [
        0,
        "&DoubleUpDownArrow;"
    ],
    [
        0,
        "&nwArr;"
    ],
    [
        0,
        "&neArr;"
    ],
    [
        0,
        "&seArr;"
    ],
    [
        0,
        "&swArr;"
    ],
    [
        0,
        "&lAarr;"
    ],
    [
        0,
        "&rAarr;"
    ],
    [
        1,
        "&zigrarr;"
    ],
    [
        6,
        "&larrb;"
    ],
    [
        0,
        "&rarrb;"
    ],
    [
        15,
        "&DownArrowUpArrow;"
    ],
    [
        7,
        "&loarr;"
    ],
    [
        0,
        "&roarr;"
    ],
    [
        0,
        "&hoarr;"
    ],
    [
        0,
        "&forall;"
    ],
    [
        0,
        "&comp;"
    ],
    [
        0,
        {
            v: "&part;",
            n: 824,
            o: "&npart;"
        }
    ],
    [
        0,
        "&exist;"
    ],
    [
        0,
        "&nexist;"
    ],
    [
        0,
        "&empty;"
    ],
    [
        1,
        "&Del;"
    ],
    [
        0,
        "&Element;"
    ],
    [
        0,
        "&NotElement;"
    ],
    [
        1,
        "&ni;"
    ],
    [
        0,
        "&notni;"
    ],
    [
        2,
        "&prod;"
    ],
    [
        0,
        "&coprod;"
    ],
    [
        0,
        "&sum;"
    ],
    [
        0,
        "&minus;"
    ],
    [
        0,
        "&MinusPlus;"
    ],
    [
        0,
        "&dotplus;"
    ],
    [
        1,
        "&Backslash;"
    ],
    [
        0,
        "&lowast;"
    ],
    [
        0,
        "&compfn;"
    ],
    [
        1,
        "&radic;"
    ],
    [
        2,
        "&prop;"
    ],
    [
        0,
        "&infin;"
    ],
    [
        0,
        "&angrt;"
    ],
    [
        0,
        {
            v: "&ang;",
            n: 8402,
            o: "&nang;"
        }
    ],
    [
        0,
        "&angmsd;"
    ],
    [
        0,
        "&angsph;"
    ],
    [
        0,
        "&mid;"
    ],
    [
        0,
        "&nmid;"
    ],
    [
        0,
        "&DoubleVerticalBar;"
    ],
    [
        0,
        "&NotDoubleVerticalBar;"
    ],
    [
        0,
        "&and;"
    ],
    [
        0,
        "&or;"
    ],
    [
        0,
        {
            v: "&cap;",
            n: 65024,
            o: "&caps;"
        }
    ],
    [
        0,
        {
            v: "&cup;",
            n: 65024,
            o: "&cups;"
        }
    ],
    [
        0,
        "&int;"
    ],
    [
        0,
        "&Int;"
    ],
    [
        0,
        "&iiint;"
    ],
    [
        0,
        "&conint;"
    ],
    [
        0,
        "&Conint;"
    ],
    [
        0,
        "&Cconint;"
    ],
    [
        0,
        "&cwint;"
    ],
    [
        0,
        "&ClockwiseContourIntegral;"
    ],
    [
        0,
        "&awconint;"
    ],
    [
        0,
        "&there4;"
    ],
    [
        0,
        "&becaus;"
    ],
    [
        0,
        "&ratio;"
    ],
    [
        0,
        "&Colon;"
    ],
    [
        0,
        "&dotminus;"
    ],
    [
        1,
        "&mDDot;"
    ],
    [
        0,
        "&homtht;"
    ],
    [
        0,
        {
            v: "&sim;",
            n: 8402,
            o: "&nvsim;"
        }
    ],
    [
        0,
        {
            v: "&backsim;",
            n: 817,
            o: "&race;"
        }
    ],
    [
        0,
        {
            v: "&ac;",
            n: 819,
            o: "&acE;"
        }
    ],
    [
        0,
        "&acd;"
    ],
    [
        0,
        "&VerticalTilde;"
    ],
    [
        0,
        "&NotTilde;"
    ],
    [
        0,
        {
            v: "&eqsim;",
            n: 824,
            o: "&nesim;"
        }
    ],
    [
        0,
        "&sime;"
    ],
    [
        0,
        "&NotTildeEqual;"
    ],
    [
        0,
        "&cong;"
    ],
    [
        0,
        "&simne;"
    ],
    [
        0,
        "&ncong;"
    ],
    [
        0,
        "&ap;"
    ],
    [
        0,
        "&nap;"
    ],
    [
        0,
        "&ape;"
    ],
    [
        0,
        {
            v: "&apid;",
            n: 824,
            o: "&napid;"
        }
    ],
    [
        0,
        "&backcong;"
    ],
    [
        0,
        {
            v: "&asympeq;",
            n: 8402,
            o: "&nvap;"
        }
    ],
    [
        0,
        {
            v: "&bump;",
            n: 824,
            o: "&nbump;"
        }
    ],
    [
        0,
        {
            v: "&bumpe;",
            n: 824,
            o: "&nbumpe;"
        }
    ],
    [
        0,
        {
            v: "&doteq;",
            n: 824,
            o: "&nedot;"
        }
    ],
    [
        0,
        "&doteqdot;"
    ],
    [
        0,
        "&efDot;"
    ],
    [
        0,
        "&erDot;"
    ],
    [
        0,
        "&Assign;"
    ],
    [
        0,
        "&ecolon;"
    ],
    [
        0,
        "&ecir;"
    ],
    [
        0,
        "&circeq;"
    ],
    [
        1,
        "&wedgeq;"
    ],
    [
        0,
        "&veeeq;"
    ],
    [
        1,
        "&triangleq;"
    ],
    [
        2,
        "&equest;"
    ],
    [
        0,
        "&ne;"
    ],
    [
        0,
        {
            v: "&Congruent;",
            n: 8421,
            o: "&bnequiv;"
        }
    ],
    [
        0,
        "&nequiv;"
    ],
    [
        1,
        {
            v: "&le;",
            n: 8402,
            o: "&nvle;"
        }
    ],
    [
        0,
        {
            v: "&ge;",
            n: 8402,
            o: "&nvge;"
        }
    ],
    [
        0,
        {
            v: "&lE;",
            n: 824,
            o: "&nlE;"
        }
    ],
    [
        0,
        {
            v: "&gE;",
            n: 824,
            o: "&ngE;"
        }
    ],
    [
        0,
        {
            v: "&lnE;",
            n: 65024,
            o: "&lvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&gnE;",
            n: 65024,
            o: "&gvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&ll;",
            n: new Map(/* #__PURE__ */ $5d17e1547aea90db$var$restoreDiff([
                [
                    824,
                    "&nLtv;"
                ],
                [
                    7577,
                    "&nLt;"
                ]
            ]))
        }
    ],
    [
        0,
        {
            v: "&gg;",
            n: new Map(/* #__PURE__ */ $5d17e1547aea90db$var$restoreDiff([
                [
                    824,
                    "&nGtv;"
                ],
                [
                    7577,
                    "&nGt;"
                ]
            ]))
        }
    ],
    [
        0,
        "&between;"
    ],
    [
        0,
        "&NotCupCap;"
    ],
    [
        0,
        "&nless;"
    ],
    [
        0,
        "&ngt;"
    ],
    [
        0,
        "&nle;"
    ],
    [
        0,
        "&nge;"
    ],
    [
        0,
        "&lesssim;"
    ],
    [
        0,
        "&GreaterTilde;"
    ],
    [
        0,
        "&nlsim;"
    ],
    [
        0,
        "&ngsim;"
    ],
    [
        0,
        "&LessGreater;"
    ],
    [
        0,
        "&gl;"
    ],
    [
        0,
        "&NotLessGreater;"
    ],
    [
        0,
        "&NotGreaterLess;"
    ],
    [
        0,
        "&pr;"
    ],
    [
        0,
        "&sc;"
    ],
    [
        0,
        "&prcue;"
    ],
    [
        0,
        "&sccue;"
    ],
    [
        0,
        "&PrecedesTilde;"
    ],
    [
        0,
        {
            v: "&scsim;",
            n: 824,
            o: "&NotSucceedsTilde;"
        }
    ],
    [
        0,
        "&NotPrecedes;"
    ],
    [
        0,
        "&NotSucceeds;"
    ],
    [
        0,
        {
            v: "&sub;",
            n: 8402,
            o: "&NotSubset;"
        }
    ],
    [
        0,
        {
            v: "&sup;",
            n: 8402,
            o: "&NotSuperset;"
        }
    ],
    [
        0,
        "&nsub;"
    ],
    [
        0,
        "&nsup;"
    ],
    [
        0,
        "&sube;"
    ],
    [
        0,
        "&supe;"
    ],
    [
        0,
        "&NotSubsetEqual;"
    ],
    [
        0,
        "&NotSupersetEqual;"
    ],
    [
        0,
        {
            v: "&subne;",
            n: 65024,
            o: "&varsubsetneq;"
        }
    ],
    [
        0,
        {
            v: "&supne;",
            n: 65024,
            o: "&varsupsetneq;"
        }
    ],
    [
        1,
        "&cupdot;"
    ],
    [
        0,
        "&UnionPlus;"
    ],
    [
        0,
        {
            v: "&sqsub;",
            n: 824,
            o: "&NotSquareSubset;"
        }
    ],
    [
        0,
        {
            v: "&sqsup;",
            n: 824,
            o: "&NotSquareSuperset;"
        }
    ],
    [
        0,
        "&sqsube;"
    ],
    [
        0,
        "&sqsupe;"
    ],
    [
        0,
        {
            v: "&sqcap;",
            n: 65024,
            o: "&sqcaps;"
        }
    ],
    [
        0,
        {
            v: "&sqcup;",
            n: 65024,
            o: "&sqcups;"
        }
    ],
    [
        0,
        "&CirclePlus;"
    ],
    [
        0,
        "&CircleMinus;"
    ],
    [
        0,
        "&CircleTimes;"
    ],
    [
        0,
        "&osol;"
    ],
    [
        0,
        "&CircleDot;"
    ],
    [
        0,
        "&circledcirc;"
    ],
    [
        0,
        "&circledast;"
    ],
    [
        1,
        "&circleddash;"
    ],
    [
        0,
        "&boxplus;"
    ],
    [
        0,
        "&boxminus;"
    ],
    [
        0,
        "&boxtimes;"
    ],
    [
        0,
        "&dotsquare;"
    ],
    [
        0,
        "&RightTee;"
    ],
    [
        0,
        "&dashv;"
    ],
    [
        0,
        "&DownTee;"
    ],
    [
        0,
        "&bot;"
    ],
    [
        1,
        "&models;"
    ],
    [
        0,
        "&DoubleRightTee;"
    ],
    [
        0,
        "&Vdash;"
    ],
    [
        0,
        "&Vvdash;"
    ],
    [
        0,
        "&VDash;"
    ],
    [
        0,
        "&nvdash;"
    ],
    [
        0,
        "&nvDash;"
    ],
    [
        0,
        "&nVdash;"
    ],
    [
        0,
        "&nVDash;"
    ],
    [
        0,
        "&prurel;"
    ],
    [
        1,
        "&LeftTriangle;"
    ],
    [
        0,
        "&RightTriangle;"
    ],
    [
        0,
        {
            v: "&LeftTriangleEqual;",
            n: 8402,
            o: "&nvltrie;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleEqual;",
            n: 8402,
            o: "&nvrtrie;"
        }
    ],
    [
        0,
        "&origof;"
    ],
    [
        0,
        "&imof;"
    ],
    [
        0,
        "&multimap;"
    ],
    [
        0,
        "&hercon;"
    ],
    [
        0,
        "&intcal;"
    ],
    [
        0,
        "&veebar;"
    ],
    [
        1,
        "&barvee;"
    ],
    [
        0,
        "&angrtvb;"
    ],
    [
        0,
        "&lrtri;"
    ],
    [
        0,
        "&bigwedge;"
    ],
    [
        0,
        "&bigvee;"
    ],
    [
        0,
        "&bigcap;"
    ],
    [
        0,
        "&bigcup;"
    ],
    [
        0,
        "&diam;"
    ],
    [
        0,
        "&sdot;"
    ],
    [
        0,
        "&sstarf;"
    ],
    [
        0,
        "&divideontimes;"
    ],
    [
        0,
        "&bowtie;"
    ],
    [
        0,
        "&ltimes;"
    ],
    [
        0,
        "&rtimes;"
    ],
    [
        0,
        "&leftthreetimes;"
    ],
    [
        0,
        "&rightthreetimes;"
    ],
    [
        0,
        "&backsimeq;"
    ],
    [
        0,
        "&curlyvee;"
    ],
    [
        0,
        "&curlywedge;"
    ],
    [
        0,
        "&Sub;"
    ],
    [
        0,
        "&Sup;"
    ],
    [
        0,
        "&Cap;"
    ],
    [
        0,
        "&Cup;"
    ],
    [
        0,
        "&fork;"
    ],
    [
        0,
        "&epar;"
    ],
    [
        0,
        "&lessdot;"
    ],
    [
        0,
        "&gtdot;"
    ],
    [
        0,
        {
            v: "&Ll;",
            n: 824,
            o: "&nLl;"
        }
    ],
    [
        0,
        {
            v: "&Gg;",
            n: 824,
            o: "&nGg;"
        }
    ],
    [
        0,
        {
            v: "&leg;",
            n: 65024,
            o: "&lesg;"
        }
    ],
    [
        0,
        {
            v: "&gel;",
            n: 65024,
            o: "&gesl;"
        }
    ],
    [
        2,
        "&cuepr;"
    ],
    [
        0,
        "&cuesc;"
    ],
    [
        0,
        "&NotPrecedesSlantEqual;"
    ],
    [
        0,
        "&NotSucceedsSlantEqual;"
    ],
    [
        0,
        "&NotSquareSubsetEqual;"
    ],
    [
        0,
        "&NotSquareSupersetEqual;"
    ],
    [
        2,
        "&lnsim;"
    ],
    [
        0,
        "&gnsim;"
    ],
    [
        0,
        "&precnsim;"
    ],
    [
        0,
        "&scnsim;"
    ],
    [
        0,
        "&nltri;"
    ],
    [
        0,
        "&NotRightTriangle;"
    ],
    [
        0,
        "&nltrie;"
    ],
    [
        0,
        "&NotRightTriangleEqual;"
    ],
    [
        0,
        "&vellip;"
    ],
    [
        0,
        "&ctdot;"
    ],
    [
        0,
        "&utdot;"
    ],
    [
        0,
        "&dtdot;"
    ],
    [
        0,
        "&disin;"
    ],
    [
        0,
        "&isinsv;"
    ],
    [
        0,
        "&isins;"
    ],
    [
        0,
        {
            v: "&isindot;",
            n: 824,
            o: "&notindot;"
        }
    ],
    [
        0,
        "&notinvc;"
    ],
    [
        0,
        "&notinvb;"
    ],
    [
        1,
        {
            v: "&isinE;",
            n: 824,
            o: "&notinE;"
        }
    ],
    [
        0,
        "&nisd;"
    ],
    [
        0,
        "&xnis;"
    ],
    [
        0,
        "&nis;"
    ],
    [
        0,
        "&notnivc;"
    ],
    [
        0,
        "&notnivb;"
    ],
    [
        6,
        "&barwed;"
    ],
    [
        0,
        "&Barwed;"
    ],
    [
        1,
        "&lceil;"
    ],
    [
        0,
        "&rceil;"
    ],
    [
        0,
        "&LeftFloor;"
    ],
    [
        0,
        "&rfloor;"
    ],
    [
        0,
        "&drcrop;"
    ],
    [
        0,
        "&dlcrop;"
    ],
    [
        0,
        "&urcrop;"
    ],
    [
        0,
        "&ulcrop;"
    ],
    [
        0,
        "&bnot;"
    ],
    [
        1,
        "&profline;"
    ],
    [
        0,
        "&profsurf;"
    ],
    [
        1,
        "&telrec;"
    ],
    [
        0,
        "&target;"
    ],
    [
        5,
        "&ulcorn;"
    ],
    [
        0,
        "&urcorn;"
    ],
    [
        0,
        "&dlcorn;"
    ],
    [
        0,
        "&drcorn;"
    ],
    [
        2,
        "&frown;"
    ],
    [
        0,
        "&smile;"
    ],
    [
        9,
        "&cylcty;"
    ],
    [
        0,
        "&profalar;"
    ],
    [
        7,
        "&topbot;"
    ],
    [
        6,
        "&ovbar;"
    ],
    [
        1,
        "&solbar;"
    ],
    [
        60,
        "&angzarr;"
    ],
    [
        51,
        "&lmoustache;"
    ],
    [
        0,
        "&rmoustache;"
    ],
    [
        2,
        "&OverBracket;"
    ],
    [
        0,
        "&bbrk;"
    ],
    [
        0,
        "&bbrktbrk;"
    ],
    [
        37,
        "&OverParenthesis;"
    ],
    [
        0,
        "&UnderParenthesis;"
    ],
    [
        0,
        "&OverBrace;"
    ],
    [
        0,
        "&UnderBrace;"
    ],
    [
        2,
        "&trpezium;"
    ],
    [
        4,
        "&elinters;"
    ],
    [
        59,
        "&blank;"
    ],
    [
        164,
        "&circledS;"
    ],
    [
        55,
        "&boxh;"
    ],
    [
        1,
        "&boxv;"
    ],
    [
        9,
        "&boxdr;"
    ],
    [
        3,
        "&boxdl;"
    ],
    [
        3,
        "&boxur;"
    ],
    [
        3,
        "&boxul;"
    ],
    [
        3,
        "&boxvr;"
    ],
    [
        7,
        "&boxvl;"
    ],
    [
        7,
        "&boxhd;"
    ],
    [
        7,
        "&boxhu;"
    ],
    [
        7,
        "&boxvh;"
    ],
    [
        19,
        "&boxH;"
    ],
    [
        0,
        "&boxV;"
    ],
    [
        0,
        "&boxdR;"
    ],
    [
        0,
        "&boxDr;"
    ],
    [
        0,
        "&boxDR;"
    ],
    [
        0,
        "&boxdL;"
    ],
    [
        0,
        "&boxDl;"
    ],
    [
        0,
        "&boxDL;"
    ],
    [
        0,
        "&boxuR;"
    ],
    [
        0,
        "&boxUr;"
    ],
    [
        0,
        "&boxUR;"
    ],
    [
        0,
        "&boxuL;"
    ],
    [
        0,
        "&boxUl;"
    ],
    [
        0,
        "&boxUL;"
    ],
    [
        0,
        "&boxvR;"
    ],
    [
        0,
        "&boxVr;"
    ],
    [
        0,
        "&boxVR;"
    ],
    [
        0,
        "&boxvL;"
    ],
    [
        0,
        "&boxVl;"
    ],
    [
        0,
        "&boxVL;"
    ],
    [
        0,
        "&boxHd;"
    ],
    [
        0,
        "&boxhD;"
    ],
    [
        0,
        "&boxHD;"
    ],
    [
        0,
        "&boxHu;"
    ],
    [
        0,
        "&boxhU;"
    ],
    [
        0,
        "&boxHU;"
    ],
    [
        0,
        "&boxvH;"
    ],
    [
        0,
        "&boxVh;"
    ],
    [
        0,
        "&boxVH;"
    ],
    [
        19,
        "&uhblk;"
    ],
    [
        3,
        "&lhblk;"
    ],
    [
        3,
        "&block;"
    ],
    [
        8,
        "&blk14;"
    ],
    [
        0,
        "&blk12;"
    ],
    [
        0,
        "&blk34;"
    ],
    [
        13,
        "&square;"
    ],
    [
        8,
        "&blacksquare;"
    ],
    [
        0,
        "&EmptyVerySmallSquare;"
    ],
    [
        1,
        "&rect;"
    ],
    [
        0,
        "&marker;"
    ],
    [
        2,
        "&fltns;"
    ],
    [
        1,
        "&bigtriangleup;"
    ],
    [
        0,
        "&blacktriangle;"
    ],
    [
        0,
        "&triangle;"
    ],
    [
        2,
        "&blacktriangleright;"
    ],
    [
        0,
        "&rtri;"
    ],
    [
        3,
        "&bigtriangledown;"
    ],
    [
        0,
        "&blacktriangledown;"
    ],
    [
        0,
        "&dtri;"
    ],
    [
        2,
        "&blacktriangleleft;"
    ],
    [
        0,
        "&ltri;"
    ],
    [
        6,
        "&loz;"
    ],
    [
        0,
        "&cir;"
    ],
    [
        32,
        "&tridot;"
    ],
    [
        2,
        "&bigcirc;"
    ],
    [
        8,
        "&ultri;"
    ],
    [
        0,
        "&urtri;"
    ],
    [
        0,
        "&lltri;"
    ],
    [
        0,
        "&EmptySmallSquare;"
    ],
    [
        0,
        "&FilledSmallSquare;"
    ],
    [
        8,
        "&bigstar;"
    ],
    [
        0,
        "&star;"
    ],
    [
        7,
        "&phone;"
    ],
    [
        49,
        "&female;"
    ],
    [
        1,
        "&male;"
    ],
    [
        29,
        "&spades;"
    ],
    [
        2,
        "&clubs;"
    ],
    [
        1,
        "&hearts;"
    ],
    [
        0,
        "&diamondsuit;"
    ],
    [
        3,
        "&sung;"
    ],
    [
        2,
        "&flat;"
    ],
    [
        0,
        "&natural;"
    ],
    [
        0,
        "&sharp;"
    ],
    [
        163,
        "&check;"
    ],
    [
        3,
        "&cross;"
    ],
    [
        8,
        "&malt;"
    ],
    [
        21,
        "&sext;"
    ],
    [
        33,
        "&VerticalSeparator;"
    ],
    [
        25,
        "&lbbrk;"
    ],
    [
        0,
        "&rbbrk;"
    ],
    [
        84,
        "&bsolhsub;"
    ],
    [
        0,
        "&suphsol;"
    ],
    [
        28,
        "&LeftDoubleBracket;"
    ],
    [
        0,
        "&RightDoubleBracket;"
    ],
    [
        0,
        "&lang;"
    ],
    [
        0,
        "&rang;"
    ],
    [
        0,
        "&Lang;"
    ],
    [
        0,
        "&Rang;"
    ],
    [
        0,
        "&loang;"
    ],
    [
        0,
        "&roang;"
    ],
    [
        7,
        "&longleftarrow;"
    ],
    [
        0,
        "&longrightarrow;"
    ],
    [
        0,
        "&longleftrightarrow;"
    ],
    [
        0,
        "&DoubleLongLeftArrow;"
    ],
    [
        0,
        "&DoubleLongRightArrow;"
    ],
    [
        0,
        "&DoubleLongLeftRightArrow;"
    ],
    [
        1,
        "&longmapsto;"
    ],
    [
        2,
        "&dzigrarr;"
    ],
    [
        258,
        "&nvlArr;"
    ],
    [
        0,
        "&nvrArr;"
    ],
    [
        0,
        "&nvHarr;"
    ],
    [
        0,
        "&Map;"
    ],
    [
        6,
        "&lbarr;"
    ],
    [
        0,
        "&bkarow;"
    ],
    [
        0,
        "&lBarr;"
    ],
    [
        0,
        "&dbkarow;"
    ],
    [
        0,
        "&drbkarow;"
    ],
    [
        0,
        "&DDotrahd;"
    ],
    [
        0,
        "&UpArrowBar;"
    ],
    [
        0,
        "&DownArrowBar;"
    ],
    [
        2,
        "&Rarrtl;"
    ],
    [
        2,
        "&latail;"
    ],
    [
        0,
        "&ratail;"
    ],
    [
        0,
        "&lAtail;"
    ],
    [
        0,
        "&rAtail;"
    ],
    [
        0,
        "&larrfs;"
    ],
    [
        0,
        "&rarrfs;"
    ],
    [
        0,
        "&larrbfs;"
    ],
    [
        0,
        "&rarrbfs;"
    ],
    [
        2,
        "&nwarhk;"
    ],
    [
        0,
        "&nearhk;"
    ],
    [
        0,
        "&hksearow;"
    ],
    [
        0,
        "&hkswarow;"
    ],
    [
        0,
        "&nwnear;"
    ],
    [
        0,
        "&nesear;"
    ],
    [
        0,
        "&seswar;"
    ],
    [
        0,
        "&swnwar;"
    ],
    [
        8,
        {
            v: "&rarrc;",
            n: 824,
            o: "&nrarrc;"
        }
    ],
    [
        1,
        "&cudarrr;"
    ],
    [
        0,
        "&ldca;"
    ],
    [
        0,
        "&rdca;"
    ],
    [
        0,
        "&cudarrl;"
    ],
    [
        0,
        "&larrpl;"
    ],
    [
        2,
        "&curarrm;"
    ],
    [
        0,
        "&cularrp;"
    ],
    [
        7,
        "&rarrpl;"
    ],
    [
        2,
        "&harrcir;"
    ],
    [
        0,
        "&Uarrocir;"
    ],
    [
        0,
        "&lurdshar;"
    ],
    [
        0,
        "&ldrushar;"
    ],
    [
        2,
        "&LeftRightVector;"
    ],
    [
        0,
        "&RightUpDownVector;"
    ],
    [
        0,
        "&DownLeftRightVector;"
    ],
    [
        0,
        "&LeftUpDownVector;"
    ],
    [
        0,
        "&LeftVectorBar;"
    ],
    [
        0,
        "&RightVectorBar;"
    ],
    [
        0,
        "&RightUpVectorBar;"
    ],
    [
        0,
        "&RightDownVectorBar;"
    ],
    [
        0,
        "&DownLeftVectorBar;"
    ],
    [
        0,
        "&DownRightVectorBar;"
    ],
    [
        0,
        "&LeftUpVectorBar;"
    ],
    [
        0,
        "&LeftDownVectorBar;"
    ],
    [
        0,
        "&LeftTeeVector;"
    ],
    [
        0,
        "&RightTeeVector;"
    ],
    [
        0,
        "&RightUpTeeVector;"
    ],
    [
        0,
        "&RightDownTeeVector;"
    ],
    [
        0,
        "&DownLeftTeeVector;"
    ],
    [
        0,
        "&DownRightTeeVector;"
    ],
    [
        0,
        "&LeftUpTeeVector;"
    ],
    [
        0,
        "&LeftDownTeeVector;"
    ],
    [
        0,
        "&lHar;"
    ],
    [
        0,
        "&uHar;"
    ],
    [
        0,
        "&rHar;"
    ],
    [
        0,
        "&dHar;"
    ],
    [
        0,
        "&luruhar;"
    ],
    [
        0,
        "&ldrdhar;"
    ],
    [
        0,
        "&ruluhar;"
    ],
    [
        0,
        "&rdldhar;"
    ],
    [
        0,
        "&lharul;"
    ],
    [
        0,
        "&llhard;"
    ],
    [
        0,
        "&rharul;"
    ],
    [
        0,
        "&lrhard;"
    ],
    [
        0,
        "&udhar;"
    ],
    [
        0,
        "&duhar;"
    ],
    [
        0,
        "&RoundImplies;"
    ],
    [
        0,
        "&erarr;"
    ],
    [
        0,
        "&simrarr;"
    ],
    [
        0,
        "&larrsim;"
    ],
    [
        0,
        "&rarrsim;"
    ],
    [
        0,
        "&rarrap;"
    ],
    [
        0,
        "&ltlarr;"
    ],
    [
        1,
        "&gtrarr;"
    ],
    [
        0,
        "&subrarr;"
    ],
    [
        1,
        "&suplarr;"
    ],
    [
        0,
        "&lfisht;"
    ],
    [
        0,
        "&rfisht;"
    ],
    [
        0,
        "&ufisht;"
    ],
    [
        0,
        "&dfisht;"
    ],
    [
        5,
        "&lopar;"
    ],
    [
        0,
        "&ropar;"
    ],
    [
        4,
        "&lbrke;"
    ],
    [
        0,
        "&rbrke;"
    ],
    [
        0,
        "&lbrkslu;"
    ],
    [
        0,
        "&rbrksld;"
    ],
    [
        0,
        "&lbrksld;"
    ],
    [
        0,
        "&rbrkslu;"
    ],
    [
        0,
        "&langd;"
    ],
    [
        0,
        "&rangd;"
    ],
    [
        0,
        "&lparlt;"
    ],
    [
        0,
        "&rpargt;"
    ],
    [
        0,
        "&gtlPar;"
    ],
    [
        0,
        "&ltrPar;"
    ],
    [
        3,
        "&vzigzag;"
    ],
    [
        1,
        "&vangrt;"
    ],
    [
        0,
        "&angrtvbd;"
    ],
    [
        6,
        "&ange;"
    ],
    [
        0,
        "&range;"
    ],
    [
        0,
        "&dwangle;"
    ],
    [
        0,
        "&uwangle;"
    ],
    [
        0,
        "&angmsdaa;"
    ],
    [
        0,
        "&angmsdab;"
    ],
    [
        0,
        "&angmsdac;"
    ],
    [
        0,
        "&angmsdad;"
    ],
    [
        0,
        "&angmsdae;"
    ],
    [
        0,
        "&angmsdaf;"
    ],
    [
        0,
        "&angmsdag;"
    ],
    [
        0,
        "&angmsdah;"
    ],
    [
        0,
        "&bemptyv;"
    ],
    [
        0,
        "&demptyv;"
    ],
    [
        0,
        "&cemptyv;"
    ],
    [
        0,
        "&raemptyv;"
    ],
    [
        0,
        "&laemptyv;"
    ],
    [
        0,
        "&ohbar;"
    ],
    [
        0,
        "&omid;"
    ],
    [
        0,
        "&opar;"
    ],
    [
        1,
        "&operp;"
    ],
    [
        1,
        "&olcross;"
    ],
    [
        0,
        "&odsold;"
    ],
    [
        1,
        "&olcir;"
    ],
    [
        0,
        "&ofcir;"
    ],
    [
        0,
        "&olt;"
    ],
    [
        0,
        "&ogt;"
    ],
    [
        0,
        "&cirscir;"
    ],
    [
        0,
        "&cirE;"
    ],
    [
        0,
        "&solb;"
    ],
    [
        0,
        "&bsolb;"
    ],
    [
        3,
        "&boxbox;"
    ],
    [
        3,
        "&trisb;"
    ],
    [
        0,
        "&rtriltri;"
    ],
    [
        0,
        {
            v: "&LeftTriangleBar;",
            n: 824,
            o: "&NotLeftTriangleBar;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleBar;",
            n: 824,
            o: "&NotRightTriangleBar;"
        }
    ],
    [
        11,
        "&iinfin;"
    ],
    [
        0,
        "&infintie;"
    ],
    [
        0,
        "&nvinfin;"
    ],
    [
        4,
        "&eparsl;"
    ],
    [
        0,
        "&smeparsl;"
    ],
    [
        0,
        "&eqvparsl;"
    ],
    [
        5,
        "&blacklozenge;"
    ],
    [
        8,
        "&RuleDelayed;"
    ],
    [
        1,
        "&dsol;"
    ],
    [
        9,
        "&bigodot;"
    ],
    [
        0,
        "&bigoplus;"
    ],
    [
        0,
        "&bigotimes;"
    ],
    [
        1,
        "&biguplus;"
    ],
    [
        1,
        "&bigsqcup;"
    ],
    [
        5,
        "&iiiint;"
    ],
    [
        0,
        "&fpartint;"
    ],
    [
        2,
        "&cirfnint;"
    ],
    [
        0,
        "&awint;"
    ],
    [
        0,
        "&rppolint;"
    ],
    [
        0,
        "&scpolint;"
    ],
    [
        0,
        "&npolint;"
    ],
    [
        0,
        "&pointint;"
    ],
    [
        0,
        "&quatint;"
    ],
    [
        0,
        "&intlarhk;"
    ],
    [
        10,
        "&pluscir;"
    ],
    [
        0,
        "&plusacir;"
    ],
    [
        0,
        "&simplus;"
    ],
    [
        0,
        "&plusdu;"
    ],
    [
        0,
        "&plussim;"
    ],
    [
        0,
        "&plustwo;"
    ],
    [
        1,
        "&mcomma;"
    ],
    [
        0,
        "&minusdu;"
    ],
    [
        2,
        "&loplus;"
    ],
    [
        0,
        "&roplus;"
    ],
    [
        0,
        "&Cross;"
    ],
    [
        0,
        "&timesd;"
    ],
    [
        0,
        "&timesbar;"
    ],
    [
        1,
        "&smashp;"
    ],
    [
        0,
        "&lotimes;"
    ],
    [
        0,
        "&rotimes;"
    ],
    [
        0,
        "&otimesas;"
    ],
    [
        0,
        "&Otimes;"
    ],
    [
        0,
        "&odiv;"
    ],
    [
        0,
        "&triplus;"
    ],
    [
        0,
        "&triminus;"
    ],
    [
        0,
        "&tritime;"
    ],
    [
        0,
        "&intprod;"
    ],
    [
        2,
        "&amalg;"
    ],
    [
        0,
        "&capdot;"
    ],
    [
        1,
        "&ncup;"
    ],
    [
        0,
        "&ncap;"
    ],
    [
        0,
        "&capand;"
    ],
    [
        0,
        "&cupor;"
    ],
    [
        0,
        "&cupcap;"
    ],
    [
        0,
        "&capcup;"
    ],
    [
        0,
        "&cupbrcap;"
    ],
    [
        0,
        "&capbrcup;"
    ],
    [
        0,
        "&cupcup;"
    ],
    [
        0,
        "&capcap;"
    ],
    [
        0,
        "&ccups;"
    ],
    [
        0,
        "&ccaps;"
    ],
    [
        2,
        "&ccupssm;"
    ],
    [
        2,
        "&And;"
    ],
    [
        0,
        "&Or;"
    ],
    [
        0,
        "&andand;"
    ],
    [
        0,
        "&oror;"
    ],
    [
        0,
        "&orslope;"
    ],
    [
        0,
        "&andslope;"
    ],
    [
        1,
        "&andv;"
    ],
    [
        0,
        "&orv;"
    ],
    [
        0,
        "&andd;"
    ],
    [
        0,
        "&ord;"
    ],
    [
        1,
        "&wedbar;"
    ],
    [
        6,
        "&sdote;"
    ],
    [
        3,
        "&simdot;"
    ],
    [
        2,
        {
            v: "&congdot;",
            n: 824,
            o: "&ncongdot;"
        }
    ],
    [
        0,
        "&easter;"
    ],
    [
        0,
        "&apacir;"
    ],
    [
        0,
        {
            v: "&apE;",
            n: 824,
            o: "&napE;"
        }
    ],
    [
        0,
        "&eplus;"
    ],
    [
        0,
        "&pluse;"
    ],
    [
        0,
        "&Esim;"
    ],
    [
        0,
        "&Colone;"
    ],
    [
        0,
        "&Equal;"
    ],
    [
        1,
        "&ddotseq;"
    ],
    [
        0,
        "&equivDD;"
    ],
    [
        0,
        "&ltcir;"
    ],
    [
        0,
        "&gtcir;"
    ],
    [
        0,
        "&ltquest;"
    ],
    [
        0,
        "&gtquest;"
    ],
    [
        0,
        {
            v: "&leqslant;",
            n: 824,
            o: "&nleqslant;"
        }
    ],
    [
        0,
        {
            v: "&geqslant;",
            n: 824,
            o: "&ngeqslant;"
        }
    ],
    [
        0,
        "&lesdot;"
    ],
    [
        0,
        "&gesdot;"
    ],
    [
        0,
        "&lesdoto;"
    ],
    [
        0,
        "&gesdoto;"
    ],
    [
        0,
        "&lesdotor;"
    ],
    [
        0,
        "&gesdotol;"
    ],
    [
        0,
        "&lap;"
    ],
    [
        0,
        "&gap;"
    ],
    [
        0,
        "&lne;"
    ],
    [
        0,
        "&gne;"
    ],
    [
        0,
        "&lnap;"
    ],
    [
        0,
        "&gnap;"
    ],
    [
        0,
        "&lEg;"
    ],
    [
        0,
        "&gEl;"
    ],
    [
        0,
        "&lsime;"
    ],
    [
        0,
        "&gsime;"
    ],
    [
        0,
        "&lsimg;"
    ],
    [
        0,
        "&gsiml;"
    ],
    [
        0,
        "&lgE;"
    ],
    [
        0,
        "&glE;"
    ],
    [
        0,
        "&lesges;"
    ],
    [
        0,
        "&gesles;"
    ],
    [
        0,
        "&els;"
    ],
    [
        0,
        "&egs;"
    ],
    [
        0,
        "&elsdot;"
    ],
    [
        0,
        "&egsdot;"
    ],
    [
        0,
        "&el;"
    ],
    [
        0,
        "&eg;"
    ],
    [
        2,
        "&siml;"
    ],
    [
        0,
        "&simg;"
    ],
    [
        0,
        "&simlE;"
    ],
    [
        0,
        "&simgE;"
    ],
    [
        0,
        {
            v: "&LessLess;",
            n: 824,
            o: "&NotNestedLessLess;"
        }
    ],
    [
        0,
        {
            v: "&GreaterGreater;",
            n: 824,
            o: "&NotNestedGreaterGreater;"
        }
    ],
    [
        1,
        "&glj;"
    ],
    [
        0,
        "&gla;"
    ],
    [
        0,
        "&ltcc;"
    ],
    [
        0,
        "&gtcc;"
    ],
    [
        0,
        "&lescc;"
    ],
    [
        0,
        "&gescc;"
    ],
    [
        0,
        "&smt;"
    ],
    [
        0,
        "&lat;"
    ],
    [
        0,
        {
            v: "&smte;",
            n: 65024,
            o: "&smtes;"
        }
    ],
    [
        0,
        {
            v: "&late;",
            n: 65024,
            o: "&lates;"
        }
    ],
    [
        0,
        "&bumpE;"
    ],
    [
        0,
        {
            v: "&PrecedesEqual;",
            n: 824,
            o: "&NotPrecedesEqual;"
        }
    ],
    [
        0,
        {
            v: "&sce;",
            n: 824,
            o: "&NotSucceedsEqual;"
        }
    ],
    [
        2,
        "&prE;"
    ],
    [
        0,
        "&scE;"
    ],
    [
        0,
        "&precneqq;"
    ],
    [
        0,
        "&scnE;"
    ],
    [
        0,
        "&prap;"
    ],
    [
        0,
        "&scap;"
    ],
    [
        0,
        "&precnapprox;"
    ],
    [
        0,
        "&scnap;"
    ],
    [
        0,
        "&Pr;"
    ],
    [
        0,
        "&Sc;"
    ],
    [
        0,
        "&subdot;"
    ],
    [
        0,
        "&supdot;"
    ],
    [
        0,
        "&subplus;"
    ],
    [
        0,
        "&supplus;"
    ],
    [
        0,
        "&submult;"
    ],
    [
        0,
        "&supmult;"
    ],
    [
        0,
        "&subedot;"
    ],
    [
        0,
        "&supedot;"
    ],
    [
        0,
        {
            v: "&subE;",
            n: 824,
            o: "&nsubE;"
        }
    ],
    [
        0,
        {
            v: "&supE;",
            n: 824,
            o: "&nsupE;"
        }
    ],
    [
        0,
        "&subsim;"
    ],
    [
        0,
        "&supsim;"
    ],
    [
        2,
        {
            v: "&subnE;",
            n: 65024,
            o: "&varsubsetneqq;"
        }
    ],
    [
        0,
        {
            v: "&supnE;",
            n: 65024,
            o: "&varsupsetneqq;"
        }
    ],
    [
        2,
        "&csub;"
    ],
    [
        0,
        "&csup;"
    ],
    [
        0,
        "&csube;"
    ],
    [
        0,
        "&csupe;"
    ],
    [
        0,
        "&subsup;"
    ],
    [
        0,
        "&supsub;"
    ],
    [
        0,
        "&subsub;"
    ],
    [
        0,
        "&supsup;"
    ],
    [
        0,
        "&suphsub;"
    ],
    [
        0,
        "&supdsub;"
    ],
    [
        0,
        "&forkv;"
    ],
    [
        0,
        "&topfork;"
    ],
    [
        0,
        "&mlcp;"
    ],
    [
        8,
        "&Dashv;"
    ],
    [
        1,
        "&Vdashl;"
    ],
    [
        0,
        "&Barv;"
    ],
    [
        0,
        "&vBar;"
    ],
    [
        0,
        "&vBarv;"
    ],
    [
        1,
        "&Vbar;"
    ],
    [
        0,
        "&Not;"
    ],
    [
        0,
        "&bNot;"
    ],
    [
        0,
        "&rnmid;"
    ],
    [
        0,
        "&cirmid;"
    ],
    [
        0,
        "&midcir;"
    ],
    [
        0,
        "&topcir;"
    ],
    [
        0,
        "&nhpar;"
    ],
    [
        0,
        "&parsim;"
    ],
    [
        9,
        {
            v: "&parsl;",
            n: 8421,
            o: "&nparsl;"
        }
    ],
    [
        44343,
        {
            n: new Map(/* #__PURE__ */ $5d17e1547aea90db$var$restoreDiff([
                [
                    56476,
                    "&Ascr;"
                ],
                [
                    1,
                    "&Cscr;"
                ],
                [
                    0,
                    "&Dscr;"
                ],
                [
                    2,
                    "&Gscr;"
                ],
                [
                    2,
                    "&Jscr;"
                ],
                [
                    0,
                    "&Kscr;"
                ],
                [
                    2,
                    "&Nscr;"
                ],
                [
                    0,
                    "&Oscr;"
                ],
                [
                    0,
                    "&Pscr;"
                ],
                [
                    0,
                    "&Qscr;"
                ],
                [
                    1,
                    "&Sscr;"
                ],
                [
                    0,
                    "&Tscr;"
                ],
                [
                    0,
                    "&Uscr;"
                ],
                [
                    0,
                    "&Vscr;"
                ],
                [
                    0,
                    "&Wscr;"
                ],
                [
                    0,
                    "&Xscr;"
                ],
                [
                    0,
                    "&Yscr;"
                ],
                [
                    0,
                    "&Zscr;"
                ],
                [
                    0,
                    "&ascr;"
                ],
                [
                    0,
                    "&bscr;"
                ],
                [
                    0,
                    "&cscr;"
                ],
                [
                    0,
                    "&dscr;"
                ],
                [
                    1,
                    "&fscr;"
                ],
                [
                    1,
                    "&hscr;"
                ],
                [
                    0,
                    "&iscr;"
                ],
                [
                    0,
                    "&jscr;"
                ],
                [
                    0,
                    "&kscr;"
                ],
                [
                    0,
                    "&lscr;"
                ],
                [
                    0,
                    "&mscr;"
                ],
                [
                    0,
                    "&nscr;"
                ],
                [
                    1,
                    "&pscr;"
                ],
                [
                    0,
                    "&qscr;"
                ],
                [
                    0,
                    "&rscr;"
                ],
                [
                    0,
                    "&sscr;"
                ],
                [
                    0,
                    "&tscr;"
                ],
                [
                    0,
                    "&uscr;"
                ],
                [
                    0,
                    "&vscr;"
                ],
                [
                    0,
                    "&wscr;"
                ],
                [
                    0,
                    "&xscr;"
                ],
                [
                    0,
                    "&yscr;"
                ],
                [
                    0,
                    "&zscr;"
                ],
                [
                    52,
                    "&Afr;"
                ],
                [
                    0,
                    "&Bfr;"
                ],
                [
                    1,
                    "&Dfr;"
                ],
                [
                    0,
                    "&Efr;"
                ],
                [
                    0,
                    "&Ffr;"
                ],
                [
                    0,
                    "&Gfr;"
                ],
                [
                    2,
                    "&Jfr;"
                ],
                [
                    0,
                    "&Kfr;"
                ],
                [
                    0,
                    "&Lfr;"
                ],
                [
                    0,
                    "&Mfr;"
                ],
                [
                    0,
                    "&Nfr;"
                ],
                [
                    0,
                    "&Ofr;"
                ],
                [
                    0,
                    "&Pfr;"
                ],
                [
                    0,
                    "&Qfr;"
                ],
                [
                    1,
                    "&Sfr;"
                ],
                [
                    0,
                    "&Tfr;"
                ],
                [
                    0,
                    "&Ufr;"
                ],
                [
                    0,
                    "&Vfr;"
                ],
                [
                    0,
                    "&Wfr;"
                ],
                [
                    0,
                    "&Xfr;"
                ],
                [
                    0,
                    "&Yfr;"
                ],
                [
                    1,
                    "&afr;"
                ],
                [
                    0,
                    "&bfr;"
                ],
                [
                    0,
                    "&cfr;"
                ],
                [
                    0,
                    "&dfr;"
                ],
                [
                    0,
                    "&efr;"
                ],
                [
                    0,
                    "&ffr;"
                ],
                [
                    0,
                    "&gfr;"
                ],
                [
                    0,
                    "&hfr;"
                ],
                [
                    0,
                    "&ifr;"
                ],
                [
                    0,
                    "&jfr;"
                ],
                [
                    0,
                    "&kfr;"
                ],
                [
                    0,
                    "&lfr;"
                ],
                [
                    0,
                    "&mfr;"
                ],
                [
                    0,
                    "&nfr;"
                ],
                [
                    0,
                    "&ofr;"
                ],
                [
                    0,
                    "&pfr;"
                ],
                [
                    0,
                    "&qfr;"
                ],
                [
                    0,
                    "&rfr;"
                ],
                [
                    0,
                    "&sfr;"
                ],
                [
                    0,
                    "&tfr;"
                ],
                [
                    0,
                    "&ufr;"
                ],
                [
                    0,
                    "&vfr;"
                ],
                [
                    0,
                    "&wfr;"
                ],
                [
                    0,
                    "&xfr;"
                ],
                [
                    0,
                    "&yfr;"
                ],
                [
                    0,
                    "&zfr;"
                ],
                [
                    0,
                    "&Aopf;"
                ],
                [
                    0,
                    "&Bopf;"
                ],
                [
                    1,
                    "&Dopf;"
                ],
                [
                    0,
                    "&Eopf;"
                ],
                [
                    0,
                    "&Fopf;"
                ],
                [
                    0,
                    "&Gopf;"
                ],
                [
                    1,
                    "&Iopf;"
                ],
                [
                    0,
                    "&Jopf;"
                ],
                [
                    0,
                    "&Kopf;"
                ],
                [
                    0,
                    "&Lopf;"
                ],
                [
                    0,
                    "&Mopf;"
                ],
                [
                    1,
                    "&Oopf;"
                ],
                [
                    3,
                    "&Sopf;"
                ],
                [
                    0,
                    "&Topf;"
                ],
                [
                    0,
                    "&Uopf;"
                ],
                [
                    0,
                    "&Vopf;"
                ],
                [
                    0,
                    "&Wopf;"
                ],
                [
                    0,
                    "&Xopf;"
                ],
                [
                    0,
                    "&Yopf;"
                ],
                [
                    1,
                    "&aopf;"
                ],
                [
                    0,
                    "&bopf;"
                ],
                [
                    0,
                    "&copf;"
                ],
                [
                    0,
                    "&dopf;"
                ],
                [
                    0,
                    "&eopf;"
                ],
                [
                    0,
                    "&fopf;"
                ],
                [
                    0,
                    "&gopf;"
                ],
                [
                    0,
                    "&hopf;"
                ],
                [
                    0,
                    "&iopf;"
                ],
                [
                    0,
                    "&jopf;"
                ],
                [
                    0,
                    "&kopf;"
                ],
                [
                    0,
                    "&lopf;"
                ],
                [
                    0,
                    "&mopf;"
                ],
                [
                    0,
                    "&nopf;"
                ],
                [
                    0,
                    "&oopf;"
                ],
                [
                    0,
                    "&popf;"
                ],
                [
                    0,
                    "&qopf;"
                ],
                [
                    0,
                    "&ropf;"
                ],
                [
                    0,
                    "&sopf;"
                ],
                [
                    0,
                    "&topf;"
                ],
                [
                    0,
                    "&uopf;"
                ],
                [
                    0,
                    "&vopf;"
                ],
                [
                    0,
                    "&wopf;"
                ],
                [
                    0,
                    "&xopf;"
                ],
                [
                    0,
                    "&yopf;"
                ],
                [
                    0,
                    "&zopf;"
                ]
            ]))
        }
    ],
    [
        8906,
        "&fflig;"
    ],
    [
        0,
        "&filig;"
    ],
    [
        0,
        "&fllig;"
    ],
    [
        0,
        "&ffilig;"
    ],
    [
        0,
        "&ffllig;"
    ]
]));

});

parcelRegister("h82ow", function(module, exports) {
$parcel$export(module.exports, "xmlReplacer", function () { return $c7850a825e7152b5$export$5699810ce3244ab8; });
$parcel$export(module.exports, "getCodePoint", function () { return $c7850a825e7152b5$export$e02688b8085d016b; });
$parcel$export(module.exports, "encodeXML", function () { return $c7850a825e7152b5$export$18855ec5be97da16; });
$parcel$export(module.exports, "escapeUTF8", function () { return $c7850a825e7152b5$export$9e081872deefdcb0; });
$parcel$export(module.exports, "escapeAttribute", function () { return $c7850a825e7152b5$export$30330f3d5eb70e11; });
$parcel$export(module.exports, "escapeText", function () { return $c7850a825e7152b5$export$96e6fc3a139b2555; });
const $c7850a825e7152b5$export$5699810ce3244ab8 = /["&'<>$\x80-\uFFFF]/g;
const $c7850a825e7152b5$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
const $c7850a825e7152b5$export$e02688b8085d016b = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? (str, index)=>str.codePointAt(index) : (c, index)=>(c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
function $c7850a825e7152b5$export$18855ec5be97da16(str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = $c7850a825e7152b5$export$5699810ce3244ab8.exec(str)) !== null){
        const i = match.index;
        const char = str.charCodeAt(i);
        const next = $c7850a825e7152b5$var$xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += `${str.substring(lastIdx, i)}&#x${$c7850a825e7152b5$export$e02688b8085d016b(str, i).toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = $c7850a825e7152b5$export$5699810ce3244ab8.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
const $c7850a825e7152b5$export$4e7f196112fea3c5 = $c7850a825e7152b5$export$18855ec5be97da16;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $c7850a825e7152b5$var$getEscaper(regex, map) {
    return function escape(data) {
        let match;
        let lastIdx = 0;
        let result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
const $c7850a825e7152b5$export$9e081872deefdcb0 = $c7850a825e7152b5$var$getEscaper(/[&<>'"]/g, $c7850a825e7152b5$var$xmlCodeMap);
const $c7850a825e7152b5$export$30330f3d5eb70e11 = $c7850a825e7152b5$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
const $c7850a825e7152b5$export$96e6fc3a139b2555 = $c7850a825e7152b5$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));

});




parcelRegister("3Y2pZ", function(module, exports) {
$parcel$export(module.exports, "parseLinkLabel", function () { return (parcelRequire("bgpoG")).default; });
$parcel$export(module.exports, "parseLinkDestination", function () { return (parcelRequire("9boXi")).default; });
$parcel$export(module.exports, "parseLinkTitle", function () { return (parcelRequire("itr7G")).default; });
// Just a shortcut for bulk export

var $bgpoG = parcelRequire("bgpoG");

var $9boXi = parcelRequire("9boXi");

var $itr7G = parcelRequire("itr7G");

});
parcelRegister("bgpoG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8334e3a97149f6e3$export$2e2bcd8739ae039; });
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
function $8334e3a97149f6e3$export$2e2bcd8739ae039(state, start, disableNested) {
    let level, found, marker, prevPos;
    const max = state.posMax;
    const oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    let labelEnd = -1;
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
}

});

parcelRegister("9boXi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6af87fc6742bfd0b$export$2e2bcd8739ae039; });
// Parse link destination
//

var $jAdKh = parcelRequire("jAdKh");
function $6af87fc6742bfd0b$export$2e2bcd8739ae039(str, start, max) {
    let code;
    let pos = start;
    const result = {
        ok: false,
        pos: 0,
        str: ''
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = (0, $jAdKh.unescapeAll)(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    let level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = (0, $jAdKh.unescapeAll)(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
}

});

parcelRegister("itr7G", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d72ff97d09f44719$export$2e2bcd8739ae039; });
// Parse link title
//

var $jAdKh = parcelRequire("jAdKh");
function $d72ff97d09f44719$export$2e2bcd8739ae039(str, start, max, prev_state) {
    let code;
    let pos = start;
    const state = {
        // if `true`, this is a valid link title
        ok: false,
        // if `true`, this link can be continued on the next line
        can_continue: false,
        // if `ok`, it's the position of the first character after the closing marker
        pos: 0,
        // if `ok`, it's the unescaped title
        str: '',
        // expected closing marker character code
        marker: 0
    };
    if (prev_state) {
        // this is a continuation of a previous parseLinkTitle call on the next line,
        // used in reference links only
        state.str = prev_state.str;
        state.marker = prev_state.marker;
    } else {
        if (pos >= max) return state;
        let marker = str.charCodeAt(pos);
        if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return state;
        start++;
        pos++;
        // if opening marker is "(", switch it to closing marker ")"
        if (marker === 0x28) marker = 0x29;
        state.marker = marker;
    }
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === state.marker) {
            state.pos = pos + 1;
            state.str += (0, $jAdKh.unescapeAll)(str.slice(start, pos));
            state.ok = true;
            return state;
        } else if (code === 0x28 /* ( */  && state.marker === 0x29 /* ) */ ) return state;
        else if (code === 0x5C /* \ */  && pos + 1 < max) pos++;
        pos++;
    }
    // no closing marker found, but this link title may continue on the next line (for references)
    state.can_continue = true;
    state.str += (0, $jAdKh.unescapeAll)(str.slice(start, pos));
    return state;
}

});


parcelRegister("dI9QD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9fb7060aa906cd84$export$2e2bcd8739ae039; });
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ 
var $jAdKh = parcelRequire("jAdKh");
const $9fb7060aa906cd84$var$default_rules = {};
$9fb7060aa906cd84$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return '<code' + slf.renderAttrs(token) + '>' + (0, $jAdKh.escapeHtml)(token.content) + '</code>';
};
$9fb7060aa906cd84$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return '<pre' + slf.renderAttrs(token) + '><code>' + (0, $jAdKh.escapeHtml)(tokens[idx].content) + '</code></pre>\n';
};
$9fb7060aa906cd84$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    const info = token.info ? (0, $jAdKh.unescapeAll)(token.info).trim() : '';
    let langName = '';
    let langAttrs = '';
    if (info) {
        const arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join('');
    }
    let highlighted;
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || (0, $jAdKh.escapeHtml)(token.content);
    else highlighted = (0, $jAdKh.escapeHtml)(token.content);
    if (highlighted.indexOf('<pre') === 0) return highlighted + '\n';
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        const i = token.attrIndex('class');
        const tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            'class',
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        const tmpToken = {
            attrs: tmpAttrs
        };
        return `<pre><code${slf.renderAttrs(tmpToken)}>${highlighted}</code></pre>\n`;
    }
    return `<pre><code${slf.renderAttrs(token)}>${highlighted}</code></pre>\n`;
};
$9fb7060aa906cd84$var$default_rules.image = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex('alt')][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$9fb7060aa906cd84$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
$9fb7060aa906cd84$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
};
$9fb7060aa906cd84$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return (0, $jAdKh.escapeHtml)(tokens[idx].content);
};
$9fb7060aa906cd84$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$9fb7060aa906cd84$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $9fb7060aa906cd84$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.mjs)
   * for more details and examples.
   **/ this.rules = (0, $jAdKh.assign)({}, $9fb7060aa906cd84$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $9fb7060aa906cd84$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    let i, l, result;
    if (!token.attrs) return '';
    result = '';
    for(i = 0, l = token.attrs.length; i < l; i++)result += ' ' + (0, $jAdKh.escapeHtml)(token.attrs[i][0]) + '="' + (0, $jAdKh.escapeHtml)(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $9fb7060aa906cd84$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    const token = tokens[idx];
    let result = '';
    // Tight list paragraphs
    if (token.hidden) return '';
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += '\n';
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? '</' : '<') + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += ' /';
    // Check if we need to add a newline after this tag
    let needLf = false;
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                const nextToken = tokens[idx + 1];
                if (nextToken.type === 'inline' || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? '>\n' : '>';
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $9fb7060aa906cd84$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    let result = '';
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $9fb7060aa906cd84$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    let result = '';
    for(let i = 0, len = tokens.length; i < len; i++)switch(tokens[i].type){
        case 'text':
            result += tokens[i].content;
            break;
        case 'image':
            result += this.renderInlineAsText(tokens[i].children, options, env);
            break;
        case 'html_inline':
        case 'html_block':
            result += tokens[i].content;
            break;
        case 'softbreak':
        case 'hardbreak':
            result += '\n';
            break;
        default:
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $9fb7060aa906cd84$var$Renderer.prototype.render = function(tokens, options, env) {
    let result = '';
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (type === 'inline') result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
var $9fb7060aa906cd84$export$2e2bcd8739ae039 = $9fb7060aa906cd84$var$Renderer;

});

parcelRegister("8zulA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $63d921ebf9b2b717$export$2e2bcd8739ae039; });
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ 
var $al4Wq = parcelRequire("al4Wq");

var $bFfe7 = parcelRequire("bFfe7");

var $4LCm3 = parcelRequire("4LCm3");

var $44RmA = parcelRequire("44RmA");

var $gcKrt = parcelRequire("gcKrt");

var $iRT9s = parcelRequire("iRT9s");

var $1K7Ml = parcelRequire("1K7Ml");

var $k0oTp = parcelRequire("k0oTp");

var $ccuZR = parcelRequire("ccuZR");
const $63d921ebf9b2b717$var$_rules = [
    [
        'normalize',
        (0, $4LCm3.default)
    ],
    [
        'block',
        (0, $44RmA.default)
    ],
    [
        'inline',
        (0, $gcKrt.default)
    ],
    [
        'linkify',
        (0, $iRT9s.default)
    ],
    [
        'replacements',
        (0, $1K7Ml.default)
    ],
    [
        'smartquotes',
        (0, $k0oTp.default)
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        'text_join',
        (0, $ccuZR.default)
    ]
];
/**
 * new Core()
 **/ function $63d921ebf9b2b717$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new (0, $al4Wq.default)();
    for(let i = 0; i < $63d921ebf9b2b717$var$_rules.length; i++)this.ruler.push($63d921ebf9b2b717$var$_rules[i][0], $63d921ebf9b2b717$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $63d921ebf9b2b717$var$Core.prototype.process = function(state) {
    const rules = this.ruler.getRules('');
    for(let i = 0, l = rules.length; i < l; i++)rules[i](state);
};
$63d921ebf9b2b717$var$Core.prototype.State = (0, $bFfe7.default);
var $63d921ebf9b2b717$export$2e2bcd8739ae039 = $63d921ebf9b2b717$var$Core;

});
parcelRegister("al4Wq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $786fb2d0e5829db3$export$2e2bcd8739ae039; });
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ /**
 * new Ruler()
 **/ function $786fb2d0e5829db3$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
// Helper methods, should not be used directly
// Find rule index by name
//
$786fb2d0e5829db3$var$Ruler.prototype.__find__ = function(name) {
    for(let i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$786fb2d0e5829db3$var$Ruler.prototype.__compile__ = function() {
    const self = this;
    const chains = [
        ''
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $786fb2d0e5829db3$var$Ruler.prototype.at = function(name, fn, options) {
    const index = this.__find__(name);
    const opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $786fb2d0e5829db3$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    const index = this.__find__(beforeName);
    const opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $786fb2d0e5829db3$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    const index = this.__find__(afterName);
    const opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $786fb2d0e5829db3$var$Ruler.prototype.push = function(ruleName, fn, options) {
    const opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $786fb2d0e5829db3$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and enable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $786fb2d0e5829db3$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $786fb2d0e5829db3$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and disable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $786fb2d0e5829db3$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
var $786fb2d0e5829db3$export$2e2bcd8739ae039 = $786fb2d0e5829db3$var$Ruler;

});

parcelRegister("bFfe7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $87df55bca0c16cbc$export$2e2bcd8739ae039; });
// Core state object
//

var $a6tQs = parcelRequire("a6tQs");
function $87df55bca0c16cbc$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md; // link to parser instance
}
// re-export Token class to use in core rules
$87df55bca0c16cbc$var$StateCore.prototype.Token = (0, $a6tQs.default);
var $87df55bca0c16cbc$export$2e2bcd8739ae039 = $87df55bca0c16cbc$var$StateCore;

});
parcelRegister("a6tQs", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $75b19d8960d6bda8$export$2e2bcd8739ae039; });
// Token class
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $75b19d8960d6bda8$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = '';
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = '';
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = '';
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $75b19d8960d6bda8$var$Token.prototype.attrIndex = function attrIndex(name) {
    if (!this.attrs) return -1;
    const attrs = this.attrs;
    for(let i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $75b19d8960d6bda8$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $75b19d8960d6bda8$var$Token.prototype.attrSet = function attrSet(name, value) {
    const idx = this.attrIndex(name);
    const attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $75b19d8960d6bda8$var$Token.prototype.attrGet = function attrGet(name) {
    const idx = this.attrIndex(name);
    let value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $75b19d8960d6bda8$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    const idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
};
var $75b19d8960d6bda8$export$2e2bcd8739ae039 = $75b19d8960d6bda8$var$Token;

});


parcelRegister("4LCm3", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $37894da5bf2ba83d$export$2e2bcd8739ae039; });
// Normalize input string
// https://spec.commonmark.org/0.29/#line-ending
const $37894da5bf2ba83d$var$NEWLINES_RE = /\r\n?|\n/g;
const $37894da5bf2ba83d$var$NULL_RE = /\0/g;
function $37894da5bf2ba83d$export$2e2bcd8739ae039(state) {
    let str;
    // Normalize newlines
    str = state.src.replace($37894da5bf2ba83d$var$NEWLINES_RE, '\n');
    // Replace NULL characters
    str = str.replace($37894da5bf2ba83d$var$NULL_RE, '\uFFFD');
    state.src = str;
}

});

parcelRegister("44RmA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2f80edf71af23fe3$export$2e2bcd8739ae039; });
function $2f80edf71af23fe3$export$2e2bcd8739ae039(state) {
    let token;
    if (state.inlineMode) {
        token = new state.Token('inline', '', 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
}

});

parcelRegister("gcKrt", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $bcc1cac35092a480$export$2e2bcd8739ae039; });
function $bcc1cac35092a480$export$2e2bcd8739ae039(state) {
    const tokens = state.tokens;
    // Parse inlines
    for(let i = 0, l = tokens.length; i < l; i++){
        const tok = tokens[i];
        if (tok.type === 'inline') state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
}

});

parcelRegister("iRT9s", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dbc7f5280c6133f0$export$2e2bcd8739ae039; });
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//

var $jAdKh = parcelRequire("jAdKh");
function $dbc7f5280c6133f0$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $dbc7f5280c6133f0$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $dbc7f5280c6133f0$export$2e2bcd8739ae039(state) {
    const blockTokens = state.tokens;
    if (!state.md.options.linkify) return;
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($dbc7f5280c6133f0$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($dbc7f5280c6133f0$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = state.md.linkify.match(text);
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === 'text_special') links = links.slice(1);
                for(let ln = 0; ln < links.length; ln++){
                    const url = links[ln].url;
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    const token_o = new state.Token('link_open', 'a', 1);
                    token_o.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token_o.level = level++;
                    token_o.markup = 'linkify';
                    token_o.info = 'auto';
                    nodes.push(token_o);
                    const token_t = new state.Token('text', '', 0);
                    token_t.content = urlText;
                    token_t.level = level;
                    nodes.push(token_t);
                    const token_c = new state.Token('link_close', 'a', -1);
                    token_c.level = --level;
                    token_c.markup = 'linkify';
                    token_c.info = 'auto';
                    nodes.push(token_c);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = (0, $jAdKh.arrayReplaceAt)(tokens, i, nodes);
            }
        }
    }
}

});

parcelRegister("1K7Ml", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $14501effb43464fc$export$2e2bcd8739ae039; });
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
const $14501effb43464fc$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
const $14501effb43464fc$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
const $14501effb43464fc$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
const $14501effb43464fc$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $14501effb43464fc$var$replaceFn(match, name) {
    return $14501effb43464fc$var$SCOPED_ABBR[name.toLowerCase()];
}
function $14501effb43464fc$var$replace_scoped(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) token.content = token.content.replace($14501effb43464fc$var$SCOPED_ABBR_RE, $14501effb43464fc$var$replaceFn);
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $14501effb43464fc$var$replace_rare(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) {
            if ($14501effb43464fc$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, '$1\u2014')// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, '$1\u2013').replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, '$1\u2013');
        }
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $14501effb43464fc$export$2e2bcd8739ae039(state) {
    let blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline') continue;
        if ($14501effb43464fc$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $14501effb43464fc$var$replace_scoped(state.tokens[blkIdx].children);
        if ($14501effb43464fc$var$RARE_RE.test(state.tokens[blkIdx].content)) $14501effb43464fc$var$replace_rare(state.tokens[blkIdx].children);
    }
}

});

parcelRegister("k0oTp", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e9071dec3c06a879$export$2e2bcd8739ae039; });
// Convert straight quotation marks to typographic ones
//

var $jAdKh = parcelRequire("jAdKh");
const $e9071dec3c06a879$var$QUOTE_TEST_RE = /['"]/;
const $e9071dec3c06a879$var$QUOTE_RE = /['"]/g;
const $e9071dec3c06a879$var$APOSTROPHE = '\u2019' /* ’ */ ;
function $e9071dec3c06a879$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $e9071dec3c06a879$var$process_inlines(tokens, state) {
    let j;
    const stack = [];
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        const thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== 'text') continue;
        let text = token.content;
        let pos = 0;
        let max = text.length;
        /* eslint no-labels:0,block-scoped-var:0 */ OUTER: while(pos < max){
            $e9071dec3c06a879$var$QUOTE_RE.lastIndex = pos;
            const t = $e9071dec3c06a879$var$QUOTE_RE.exec(text);
            if (!t) break;
            let canOpen = true;
            let canClose = true;
            pos = t.index + 1;
            const isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            let lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            let nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            const isLastPunctChar = (0, $jAdKh.isMdAsciiPunct)(lastChar) || (0, $jAdKh.isPunctChar)(String.fromCharCode(lastChar));
            const isNextPunctChar = (0, $jAdKh.isMdAsciiPunct)(nextChar) || (0, $jAdKh.isPunctChar)(String.fromCharCode(nextChar));
            const isLastWhiteSpace = (0, $jAdKh.isWhiteSpace)(lastChar);
            const isNextWhiteSpace = (0, $jAdKh.isWhiteSpace)(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $e9071dec3c06a879$var$replaceAt(token.content, t.index, $e9071dec3c06a879$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                let item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    let openQuote;
                    let closeQuote;
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $e9071dec3c06a879$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $e9071dec3c06a879$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $e9071dec3c06a879$var$replaceAt(token.content, t.index, $e9071dec3c06a879$var$APOSTROPHE);
        }
    }
}
function $e9071dec3c06a879$export$2e2bcd8739ae039(state) {
    /* eslint max-depth:0 */ if (!state.md.options.typographer) return;
    for(let blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline' || !$e9071dec3c06a879$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $e9071dec3c06a879$var$process_inlines(state.tokens[blkIdx].children, state);
    }
}

});

parcelRegister("ccuZR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8e1ea651f2ae58bf$export$2e2bcd8739ae039; });
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
function $8e1ea651f2ae58bf$export$2e2bcd8739ae039(state) {
    let curr, last;
    const blockTokens = state.tokens;
    const l = blockTokens.length;
    for(let j = 0; j < l; j++){
        if (blockTokens[j].type !== 'inline') continue;
        const tokens = blockTokens[j].children;
        const max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === 'text_special') tokens[curr].type = 'text';
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
}

});


parcelRegister("hORCU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cf90b44ae926287b$export$2e2bcd8739ae039; });
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ 
var $al4Wq = parcelRequire("al4Wq");

var $eb7ar = parcelRequire("eb7ar");

var $fkgtP = parcelRequire("fkgtP");

var $gHn7p = parcelRequire("gHn7p");

var $khfmv = parcelRequire("khfmv");

var $7mDQh = parcelRequire("7mDQh");

var $i3g95 = parcelRequire("i3g95");

var $9oXZR = parcelRequire("9oXZR");

var $edO9T = parcelRequire("edO9T");

var $dobwY = parcelRequire("dobwY");

var $dFmyD = parcelRequire("dFmyD");

var $qndlD = parcelRequire("qndlD");

var $jqVyi = parcelRequire("jqVyi");
const $cf90b44ae926287b$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        'table',
        (0, $fkgtP.default),
        [
            'paragraph',
            'reference'
        ]
    ],
    [
        'code',
        (0, $gHn7p.default)
    ],
    [
        'fence',
        (0, $khfmv.default),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'blockquote',
        (0, $7mDQh.default),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'hr',
        (0, $i3g95.default),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'list',
        (0, $9oXZR.default),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'reference',
        (0, $edO9T.default)
    ],
    [
        'html_block',
        (0, $dobwY.default),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'heading',
        (0, $dFmyD.default),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'lheading',
        (0, $qndlD.default)
    ],
    [
        'paragraph',
        (0, $jqVyi.default)
    ]
];
/**
 * new ParserBlock()
 **/ function $cf90b44ae926287b$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new (0, $al4Wq.default)();
    for(let i = 0; i < $cf90b44ae926287b$var$_rules.length; i++)this.ruler.push($cf90b44ae926287b$var$_rules[i][0], $cf90b44ae926287b$var$_rules[i][1], {
        alt: ($cf90b44ae926287b$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$cf90b44ae926287b$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    const rules = this.ruler.getRules('');
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    let line = startLine;
    let hasEmptyLines = false;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        const prevLine = state.line;
        let ok = false;
        for(let i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error('none of the block rules matched');
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $cf90b44ae926287b$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    if (!src) return;
    const state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};
$cf90b44ae926287b$var$ParserBlock.prototype.State = (0, $eb7ar.default);
var $cf90b44ae926287b$export$2e2bcd8739ae039 = $cf90b44ae926287b$var$ParserBlock;

});
parcelRegister("eb7ar", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a527a70da5807d06$export$2e2bcd8739ae039; });
// Parser state class

var $a6tQs = parcelRequire("a6tQs");

var $jAdKh = parcelRequire("jAdKh");
function $a527a70da5807d06$var$StateBlock(src, md, env, tokens) {
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = []; // line begin offsets for fast jumps
    this.eMarks = []; // line end offsets for fast jumps
    this.tShift = []; // offsets of the first non-space characters (tabs not expanded)
    this.sCount = []; // indents for each line (tabs expanded)
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.blkIndent = 0;
    this.line = 0; // line index in src
    this.lineMax = 0; // lines count
    this.tight = false; // loose/tight mode for lists
    this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)
    this.listIndent = -1; // indent of the current list block (-1 if there isn't any)
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = 'root';
    this.level = 0;
    // Create caches
    // Generate markers.
    const s = this.src;
    for(let start = 0, pos = 0, indent = 0, offset = 0, len = s.length, indent_found = false; pos < len; pos++){
        const ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ((0, $jAdKh.isSpace)(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1; // don't count last fake line
}
// Push new token to "stream".
//
$a527a70da5807d06$var$StateBlock.prototype.push = function(type, tag, nesting) {
    const token = new (0, $a6tQs.default)(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level--; // closing tag
    token.level = this.level;
    if (nesting > 0) this.level++; // opening tag
    this.tokens.push(token);
    return token;
};
$a527a70da5807d06$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$a527a70da5807d06$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(let max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$a527a70da5807d06$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    for(let max = this.src.length; pos < max; pos++){
        const ch = this.src.charCodeAt(pos);
        if (!(0, $jAdKh.isSpace)(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$a527a70da5807d06$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!(0, $jAdKh.isSpace)(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$a527a70da5807d06$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(let max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$a527a70da5807d06$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$a527a70da5807d06$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    if (begin >= end) return '';
    const queue = new Array(end - begin);
    for(let i = 0, line = begin; line < end; line++, i++){
        let lineIndent = 0;
        const lineStart = this.bMarks[line];
        let first = lineStart;
        let last;
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            const ch = this.src.charCodeAt(first);
            if ((0, $jAdKh.isSpace)(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join('');
};
// re-export Token class to use in block rules
$a527a70da5807d06$var$StateBlock.prototype.Token = (0, $a6tQs.default);
var $a527a70da5807d06$export$2e2bcd8739ae039 = $a527a70da5807d06$var$StateBlock;

});

parcelRegister("fkgtP", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b28581e56e6fcb61$export$2e2bcd8739ae039; });
// GFM table, https://github.github.com/gfm/#tables-extension-

var $jAdKh = parcelRequire("jAdKh");
// Limit the amount of empty autocompleted cells in a table,
// see https://github.com/markdown-it/markdown-it/issues/1000,
//
// Both pulldown-cmark and commonmark-hs limit the number of cells this way to ~200k.
// We set it to 65k, which can expand user input by a factor of x370
// (256x256 square is 1.8kB expanded into 650kB).
const $b28581e56e6fcb61$var$MAX_AUTOCOMPLETED_CELLS = 0x10000;
function $b28581e56e6fcb61$var$getLine(state, line) {
    const pos = state.bMarks[line] + state.tShift[line];
    const max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $b28581e56e6fcb61$var$escapedSplit(str) {
    const result = [];
    const max = str.length;
    let pos = 0;
    let ch = str.charCodeAt(pos);
    let isEscaped = false;
    let lastPos = 0;
    let current = '';
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = '';
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
function $b28581e56e6fcb61$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    let nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    let pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    const firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    const secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !(0, $jAdKh.isSpace)(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && (0, $jAdKh.isSpace)(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        const ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !(0, $jAdKh.isSpace)(ch)) return false;
        pos++;
    }
    let lineText = $b28581e56e6fcb61$var$getLine(state, startLine + 1);
    let columns = lineText.split('|');
    const aligns = [];
    for(let i = 0; i < columns.length; i++){
        const t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $b28581e56e6fcb61$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $b28581e56e6fcb61$var$escapedSplit(lineText);
    if (columns.length && columns[0] === '') columns.shift();
    if (columns.length && columns[columns.length - 1] === '') columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    const columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    const oldParentType = state.parentType;
    state.parentType = 'table';
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    const terminatorRules = state.md.block.ruler.getRules('blockquote');
    const token_to = state.push('table_open', 'table', 1);
    const tableLines = [
        startLine,
        0
    ];
    token_to.map = tableLines;
    const token_tho = state.push('thead_open', 'thead', 1);
    token_tho.map = [
        startLine,
        startLine + 1
    ];
    const token_htro = state.push('tr_open', 'tr', 1);
    token_htro.map = [
        startLine,
        startLine + 1
    ];
    for(let i = 0; i < columns.length; i++){
        const token_ho = state.push('th_open', 'th', 1);
        if (aligns[i]) token_ho.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        const token_il = state.push('inline', '', 0);
        token_il.content = columns[i].trim();
        token_il.children = [];
        state.push('th_close', 'th', -1);
    }
    state.push('tr_close', 'tr', -1);
    state.push('thead_close', 'thead', -1);
    let tbodyLines;
    let autocompletedCells = 0;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $b28581e56e6fcb61$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $b28581e56e6fcb61$var$escapedSplit(lineText);
        if (columns.length && columns[0] === '') columns.shift();
        if (columns.length && columns[columns.length - 1] === '') columns.pop();
        // note: autocomplete count can be negative if user specifies more columns than header,
        // but that does not affect intended use (which is limiting expansion)
        autocompletedCells += columnCount - columns.length;
        if (autocompletedCells > $b28581e56e6fcb61$var$MAX_AUTOCOMPLETED_CELLS) break;
        if (nextLine === startLine + 2) {
            const token_tbo = state.push('tbody_open', 'tbody', 1);
            token_tbo.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        const token_tro = state.push('tr_open', 'tr', 1);
        token_tro.map = [
            nextLine,
            nextLine + 1
        ];
        for(let i = 0; i < columnCount; i++){
            const token_tdo = state.push('td_open', 'td', 1);
            if (aligns[i]) token_tdo.attrs = [
                [
                    'style',
                    'text-align:' + aligns[i]
                ]
            ];
            const token_il = state.push('inline', '', 0);
            token_il.content = columns[i] ? columns[i].trim() : '';
            token_il.children = [];
            state.push('td_close', 'td', -1);
        }
        state.push('tr_close', 'tr', -1);
    }
    if (tbodyLines) {
        state.push('tbody_close', 'tbody', -1);
        tbodyLines[1] = nextLine;
    }
    state.push('table_close', 'table', -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
}

});

parcelRegister("gHn7p", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c2829857da05e0ed$export$2e2bcd8739ae039; });
// Code block (4 spaces padded)
function $c2829857da05e0ed$export$2e2bcd8739ae039(state, startLine, endLine /*, silent */ ) {
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    let nextLine = startLine + 1;
    let last = nextLine;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    const token = state.push('code_block', 'code', 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
    token.map = [
        startLine,
        state.line
    ];
    return true;
}

});

parcelRegister("khfmv", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ec314fc246d8e685$export$2e2bcd8739ae039; });
// fences (``` lang, ~~~ lang)
function $ec314fc246d8e685$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    const marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    let mem = pos;
    pos = state.skipChars(pos, marker);
    let len = pos - mem;
    if (len < 3) return false;
    const markup = state.src.slice(mem, pos);
    const params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    let nextLine = startLine;
    let haveEndMarker = false;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    const token = state.push('fence', 'code', 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
}

});

parcelRegister("7mDQh", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $55c97e4c426d244c$export$2e2bcd8739ae039; });
// Block quotes

var $jAdKh = parcelRequire("jAdKh");
function $55c97e4c426d244c$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    const oldLineMax = state.lineMax;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    const oldBMarks = [];
    const oldBSCount = [];
    const oldSCount = [];
    const oldTShift = [];
    const terminatorRules = state.md.block.ruler.getRules('blockquote');
    const oldParentType = state.parentType;
    state.parentType = 'blockquote';
    let lastLineEmpty = false;
    let nextLine;
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        const isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            let initial = state.sCount[nextLine] + 1;
            let spaceAfterMarker;
            let adjustTab;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            let offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                const ch = state.src.charCodeAt(pos);
                if ((0, $jAdKh.isSpace)(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    const oldIndent = state.blkIndent;
    state.blkIndent = 0;
    const token_o = state.push('blockquote_open', 'blockquote', 1);
    token_o.markup = '>';
    const lines = [
        startLine,
        0
    ];
    token_o.map = lines;
    state.md.block.tokenize(state, startLine, nextLine);
    const token_c = state.push('blockquote_close', 'blockquote', -1);
    token_c.markup = '>';
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(let i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
}

});

parcelRegister("i3g95", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $d24507f4d55c87ca$export$2e2bcd8739ae039; });
// Horizontal rule

var $jAdKh = parcelRequire("jAdKh");
function $d24507f4d55c87ca$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    const max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    let cnt = 1;
    while(pos < max){
        const ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !(0, $jAdKh.isSpace)(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    const token = state.push('hr', 'hr', 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
}

});

parcelRegister("9oXZR", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6d84e50bd0e54a4c$export$2e2bcd8739ae039; });
// Lists

var $jAdKh = parcelRequire("jAdKh");
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $6d84e50bd0e54a4c$var$skipBulletListMarker(state, startLine) {
    const max = state.eMarks[startLine];
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        const ch = state.src.charCodeAt(pos);
        if (!(0, $jAdKh.isSpace)(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $6d84e50bd0e54a4c$var$skipOrderedListMarker(state, startLine) {
    const start = state.bMarks[startLine] + state.tShift[startLine];
    const max = state.eMarks[startLine];
    let pos = start;
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    let ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!(0, $jAdKh.isSpace)(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $6d84e50bd0e54a4c$var$markTightParagraphs(state, idx) {
    const level = state.level + 2;
    for(let i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
function $6d84e50bd0e54a4c$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let max, pos, start, token;
    let nextLine = startLine;
    let tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    let isTerminatingParagraph = false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === 'paragraph') // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    let isOrdered;
    let markerValue;
    let posAfterMarker;
    if ((posAfterMarker = $6d84e50bd0e54a4c$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $6d84e50bd0e54a4c$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    const markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    const listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push('ordered_list_open', 'ol', 1);
        if (markerValue !== 1) token.attrs = [
            [
                'start',
                markerValue
            ]
        ];
    } else token = state.push('bullet_list_open', 'ul', 1);
    const listLines = [
        nextLine,
        0
    ];
    token.map = listLines;
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    let prevEmptyEnd = false;
    const terminatorRules = state.md.block.ruler.getRules('list');
    const oldParentType = state.parentType;
    state.parentType = 'list';
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        const initial = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        let offset = initial;
        while(pos < max){
            const ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        const contentStart = pos;
        let indentAfterMarker;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        const indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push('list_item_open', 'li', 1);
        token.markup = String.fromCharCode(markerCharCode);
        const itemLines = [
            nextLine,
            0
        ];
        token.map = itemLines;
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        const oldTight = state.tight;
        const oldTShift = state.tShift[nextLine];
        const oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        const oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push('list_item_close', 'li', -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $6d84e50bd0e54a4c$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $6d84e50bd0e54a4c$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push('ordered_list_close', 'ol', -1);
    else token = state.push('bullet_list_close', 'ul', -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $6d84e50bd0e54a4c$var$markTightParagraphs(state, listTokIdx);
    return true;
}

});

parcelRegister("edO9T", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a5a9300d8488e121$export$2e2bcd8739ae039; });

var $jAdKh = parcelRequire("jAdKh");
function $a5a9300d8488e121$export$2e2bcd8739ae039(state, startLine, _endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    let nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    function getNextLine(nextLine) {
        const endLine = state.lineMax;
        if (nextLine >= endLine || state.isEmpty(nextLine)) // empty line or end of input
        return null;
        let isContinuation = false;
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) isContinuation = true;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) isContinuation = true;
        if (!isContinuation) {
            const terminatorRules = state.md.block.ruler.getRules('reference');
            const oldParentType = state.parentType;
            state.parentType = 'reference';
            // Some tags can terminate paragraph without empty line.
            let terminate = false;
            for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
                terminate = true;
                break;
            }
            state.parentType = oldParentType;
            if (terminate) // terminated by another block
            return null;
        }
        const pos = state.bMarks[nextLine] + state.tShift[nextLine];
        const max = state.eMarks[nextLine];
        // max + 1 explicitly includes the newline
        return state.src.slice(pos, max + 1);
    }
    let str = state.src.slice(pos, max + 1);
    max = str.length;
    let labelEnd = -1;
    for(pos = 1; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) {
                const lineContent = getNextLine(nextLine);
                if (lineContent !== null) {
                    str += lineContent;
                    max = str.length;
                    nextLine++;
                }
            }
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if ((0, $jAdKh.isSpace)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    const destRes = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!destRes.ok) return false;
    const href = state.md.normalizeLink(destRes.str);
    if (!state.md.validateLink(href)) return false;
    pos = destRes.pos;
    // save cursor state, we could require to rollback later
    const destEndPos = pos;
    const destEndLineNo = nextLine;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    const start = pos;
    for(; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if ((0, $jAdKh.isSpace)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    let titleRes = state.md.helpers.parseLinkTitle(str, pos, max);
    while(titleRes.can_continue){
        const lineContent = getNextLine(nextLine);
        if (lineContent === null) break;
        str += lineContent;
        pos = max;
        max = str.length;
        nextLine++;
        titleRes = state.md.helpers.parseLinkTitle(str, pos, max, titleRes);
    }
    let title;
    if (pos < max && start !== pos && titleRes.ok) {
        title = titleRes.str;
        pos = titleRes.pos;
    } else {
        title = '';
        pos = destEndPos;
        nextLine = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        const ch = str.charCodeAt(pos);
        if (!(0, $jAdKh.isSpace)(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = '';
            pos = destEndPos;
            nextLine = destEndLineNo;
            while(pos < max){
                const ch = str.charCodeAt(pos);
                if (!(0, $jAdKh.isSpace)(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    const label = (0, $jAdKh.normalizeReference)(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /* istanbul ignore if */ if (silent) return true;
    if (typeof state.env.references === 'undefined') state.env.references = {};
    if (typeof state.env.references[label] === 'undefined') state.env.references[label] = {
        title: title,
        href: href
    };
    state.line = nextLine;
    return true;
}

});

parcelRegister("dobwY", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9bf6760f5493ee8c$export$2e2bcd8739ae039; });
// HTML block

var $c27B4 = parcelRequire("c27B4");

var $2lp07 = parcelRequire("2lp07");
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
const $9bf6760f5493ee8c$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp('^</?(' + (0, $c27B4.default).join('|') + ')(?=(\\s|/?>|$))', 'i'),
        /^$/,
        true
    ],
    [
        new RegExp((0, $2lp07.HTML_OPEN_CLOSE_TAG_RE).source + '\\s*$'),
        /^$/,
        false
    ]
];
function $9bf6760f5493ee8c$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    let lineText = state.src.slice(pos, max);
    let i = 0;
    for(; i < $9bf6760f5493ee8c$var$HTML_SEQUENCES.length; i++){
        if ($9bf6760f5493ee8c$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $9bf6760f5493ee8c$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $9bf6760f5493ee8c$var$HTML_SEQUENCES[i][2];
    let nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$9bf6760f5493ee8c$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($9bf6760f5493ee8c$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    const token = state.push('html_block', '', 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
}

});
parcelRegister("c27B4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8c2b90820c8dff74$export$2e2bcd8739ae039; });
// List of valid html blocks names, according to commonmark spec
// https://spec.commonmark.org/0.30/#html-blocks
var $8c2b90820c8dff74$export$2e2bcd8739ae039 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];

});

parcelRegister("2lp07", function(module, exports) {
$parcel$export(module.exports, "HTML_TAG_RE", function () { return $1b50ef9a86b1669d$export$6db61d2c3a16e419; });
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", function () { return $1b50ef9a86b1669d$export$cd48660d06f74639; });
// Regexps to match html elements
const $1b50ef9a86b1669d$var$attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
const $1b50ef9a86b1669d$var$unquoted = '[^"\'=<>`\\x00-\\x20]+';
const $1b50ef9a86b1669d$var$single_quoted = "'[^']*'";
const $1b50ef9a86b1669d$var$double_quoted = '"[^"]*"';
const $1b50ef9a86b1669d$var$attr_value = '(?:' + $1b50ef9a86b1669d$var$unquoted + '|' + $1b50ef9a86b1669d$var$single_quoted + '|' + $1b50ef9a86b1669d$var$double_quoted + ')';
const $1b50ef9a86b1669d$var$attribute = '(?:\\s+' + $1b50ef9a86b1669d$var$attr_name + '(?:\\s*=\\s*' + $1b50ef9a86b1669d$var$attr_value + ')?)';
const $1b50ef9a86b1669d$var$open_tag = '<[A-Za-z][A-Za-z0-9\\-]*' + $1b50ef9a86b1669d$var$attribute + '*\\s*\\/?>';
const $1b50ef9a86b1669d$var$close_tag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
const $1b50ef9a86b1669d$var$comment = '<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->';
const $1b50ef9a86b1669d$var$processing = '<[?][\\s\\S]*?[?]>';
const $1b50ef9a86b1669d$var$declaration = '<![A-Za-z][^>]*>';
const $1b50ef9a86b1669d$var$cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
const $1b50ef9a86b1669d$export$6db61d2c3a16e419 = new RegExp('^(?:' + $1b50ef9a86b1669d$var$open_tag + '|' + $1b50ef9a86b1669d$var$close_tag + '|' + $1b50ef9a86b1669d$var$comment + '|' + $1b50ef9a86b1669d$var$processing + '|' + $1b50ef9a86b1669d$var$declaration + '|' + $1b50ef9a86b1669d$var$cdata + ')');
const $1b50ef9a86b1669d$export$cd48660d06f74639 = new RegExp('^(?:' + $1b50ef9a86b1669d$var$open_tag + '|' + $1b50ef9a86b1669d$var$close_tag + ')');

});


parcelRegister("dFmyD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9f309a325f116786$export$2e2bcd8739ae039; });
// heading (#, ##, ...)

var $jAdKh = parcelRequire("jAdKh");
function $9f309a325f116786$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    let level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !(0, $jAdKh.isSpace)(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    const tmp = state.skipCharsBack(max, 0x23, pos) // #
    ;
    if (tmp > pos && (0, $jAdKh.isSpace)(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    const token_o = state.push('heading_open', 'h' + String(level), 1);
    token_o.markup = '########'.slice(0, level);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push('inline', '', 0);
    token_i.content = state.src.slice(pos, max).trim();
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    const token_c = state.push('heading_close', 'h' + String(level), -1);
    token_c.markup = '########'.slice(0, level);
    return true;
}

});

parcelRegister("qndlD", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $04f46fb260a30d10$export$2e2bcd8739ae039; });
// lheading (---, ===)
function $04f46fb260a30d10$export$2e2bcd8739ae039(state, startLine, endLine /*, silent */ ) {
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    const oldParentType = state.parentType;
    state.parentType = 'paragraph'; // use paragraph to match terminatorRules
    // jump line-by-line until empty one or EOF
    let level = 0;
    let marker;
    let nextLine = startLine + 1;
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            let pos = state.bMarks[nextLine] + state.tShift[nextLine];
            const max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    const token_o = state.push('heading_open', 'h' + String(level), 1);
    token_o.markup = String.fromCharCode(marker);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push('inline', '', 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line - 1
    ];
    token_i.children = [];
    const token_c = state.push('heading_close', 'h' + String(level), -1);
    token_c.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
}

});

parcelRegister("jqVyi", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e25d16aee9b013f2$export$2e2bcd8739ae039; });
// Paragraph
function $e25d16aee9b013f2$export$2e2bcd8739ae039(state, startLine, endLine) {
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    const oldParentType = state.parentType;
    let nextLine = startLine + 1;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    const token_o = state.push('paragraph_open', 'p', 1);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push('inline', '', 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
}

});


parcelRegister("8Bjz2", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6430f46f7c6d4a31$export$2e2bcd8739ae039; });
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ 
var $al4Wq = parcelRequire("al4Wq");

var $lbaoU = parcelRequire("lbaoU");

var $3B5Ot = parcelRequire("3B5Ot");

var $5bBHA = parcelRequire("5bBHA");

var $f7JCq = parcelRequire("f7JCq");

var $31cye = parcelRequire("31cye");

var $bpHE6 = parcelRequire("bpHE6");

var $5LJFE = parcelRequire("5LJFE");

var $cfwZG = parcelRequire("cfwZG");

var $8Lj6w = parcelRequire("8Lj6w");

var $77xCG = parcelRequire("77xCG");

var $iIWcd = parcelRequire("iIWcd");

var $h9Rs1 = parcelRequire("h9Rs1");

var $1k9Pg = parcelRequire("1k9Pg");

var $cY3lM = parcelRequire("cY3lM");

var $3YBjn = parcelRequire("3YBjn");
// Parser rules
const $6430f46f7c6d4a31$var$_rules = [
    [
        'text',
        (0, $3B5Ot.default)
    ],
    [
        'linkify',
        (0, $5bBHA.default)
    ],
    [
        'newline',
        (0, $f7JCq.default)
    ],
    [
        'escape',
        (0, $31cye.default)
    ],
    [
        'backticks',
        (0, $bpHE6.default)
    ],
    [
        'strikethrough',
        (0, $5LJFE.default).tokenize
    ],
    [
        'emphasis',
        (0, $cfwZG.default).tokenize
    ],
    [
        'link',
        (0, $8Lj6w.default)
    ],
    [
        'image',
        (0, $77xCG.default)
    ],
    [
        'autolink',
        (0, $iIWcd.default)
    ],
    [
        'html_inline',
        (0, $h9Rs1.default)
    ],
    [
        'entity',
        (0, $1k9Pg.default)
    ]
];
// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
const $6430f46f7c6d4a31$var$_rules2 = [
    [
        'balance_pairs',
        (0, $cY3lM.default)
    ],
    [
        'strikethrough',
        (0, $5LJFE.default).postProcess
    ],
    [
        'emphasis',
        (0, $cfwZG.default).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        'fragments_join',
        (0, $3YBjn.default)
    ]
];
/**
 * new ParserInline()
 **/ function $6430f46f7c6d4a31$var$ParserInline() {
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new (0, $al4Wq.default)();
    for(let i = 0; i < $6430f46f7c6d4a31$var$_rules.length; i++)this.ruler.push($6430f46f7c6d4a31$var$_rules[i][0], $6430f46f7c6d4a31$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new (0, $al4Wq.default)();
    for(let i = 0; i < $6430f46f7c6d4a31$var$_rules2.length; i++)this.ruler2.push($6430f46f7c6d4a31$var$_rules2[i][0], $6430f46f7c6d4a31$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$6430f46f7c6d4a31$var$ParserInline.prototype.skipToken = function(state) {
    const pos = state.pos;
    const rules = this.ruler.getRules('');
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    const cache = state.cache;
    if (typeof cache[pos] !== 'undefined') {
        state.pos = cache[pos];
        return;
    }
    let ok = false;
    if (state.level < maxNesting) for(let i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$6430f46f7c6d4a31$var$ParserInline.prototype.tokenize = function(state) {
    const rules = this.ruler.getRules('');
    const len = rules.length;
    const end = state.posMax;
    const maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        const prevPos = state.pos;
        let ok = false;
        if (state.level < maxNesting) for(let i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $6430f46f7c6d4a31$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    const state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    const rules = this.ruler2.getRules('');
    const len = rules.length;
    for(let i = 0; i < len; i++)rules[i](state);
};
$6430f46f7c6d4a31$var$ParserInline.prototype.State = (0, $lbaoU.default);
var $6430f46f7c6d4a31$export$2e2bcd8739ae039 = $6430f46f7c6d4a31$var$ParserInline;

});
parcelRegister("lbaoU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f6b2b172457a9c5f$export$2e2bcd8739ae039; });
// Inline parser state

var $a6tQs = parcelRequire("a6tQs");

var $jAdKh = parcelRequire("jAdKh");
function $f6b2b172457a9c5f$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = '';
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$f6b2b172457a9c5f$var$StateInline.prototype.pushPending = function() {
    const token = new (0, $a6tQs.default)('text', '', 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = '';
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$f6b2b172457a9c5f$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    const token = new (0, $a6tQs.default)(type, tag, nesting);
    let token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$f6b2b172457a9c5f$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    const max = this.posMax;
    const marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    const lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    let pos = start;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    const count = pos - start;
    // treat end of the line as a whitespace
    const nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    const isLastPunctChar = (0, $jAdKh.isMdAsciiPunct)(lastChar) || (0, $jAdKh.isPunctChar)(String.fromCharCode(lastChar));
    const isNextPunctChar = (0, $jAdKh.isMdAsciiPunct)(nextChar) || (0, $jAdKh.isPunctChar)(String.fromCharCode(nextChar));
    const isLastWhiteSpace = (0, $jAdKh.isWhiteSpace)(lastChar);
    const isNextWhiteSpace = (0, $jAdKh.isWhiteSpace)(nextChar);
    const left_flanking = !isNextWhiteSpace && (!isNextPunctChar || isLastWhiteSpace || isLastPunctChar);
    const right_flanking = !isLastWhiteSpace && (!isLastPunctChar || isNextWhiteSpace || isNextPunctChar);
    const can_open = left_flanking && (canSplitWord || !right_flanking || isLastPunctChar);
    const can_close = right_flanking && (canSplitWord || !left_flanking || isNextPunctChar);
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$f6b2b172457a9c5f$var$StateInline.prototype.Token = (0, $a6tQs.default);
var $f6b2b172457a9c5f$export$2e2bcd8739ae039 = $f6b2b172457a9c5f$var$StateInline;

});

parcelRegister("3B5Ot", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $29e95627682e68e6$export$2e2bcd8739ae039; });
// Skip text characters for text token, place those to pending buffer
// and increment current pos
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $29e95627682e68e6$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
function $29e95627682e68e6$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    while(pos < state.posMax && !$29e95627682e68e6$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
} // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParserInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
}; */ 

});

parcelRegister("5bBHA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3c6b39aab2e4725f$export$2e2bcd8739ae039; });
// Process links like https://example.org/
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
const $3c6b39aab2e4725f$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function $3c6b39aab2e4725f$export$2e2bcd8739ae039(state, silent) {
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    const pos = state.pos;
    const max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    const match = state.pending.match($3c6b39aab2e4725f$var$SCHEME_RE);
    if (!match) return false;
    const proto = match[1];
    const link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    let url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, '');
    const fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        const token_o = state.push('link_open', 'a', 1);
        token_o.attrs = [
            [
                'href',
                fullUrl
            ]
        ];
        token_o.markup = 'linkify';
        token_o.info = 'auto';
        const token_t = state.push('text', '', 0);
        token_t.content = state.md.normalizeLinkText(url);
        const token_c = state.push('link_close', 'a', -1);
        token_c.markup = 'linkify';
        token_c.info = 'auto';
    }
    state.pos += url.length - proto.length;
    return true;
}

});

parcelRegister("f7JCq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b02ae5663d7c397a$export$2e2bcd8739ae039; });
// Proceess '\n'

var $jAdKh = parcelRequire("jAdKh");
function $b02ae5663d7c397a$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    const max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                let ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push('hardbreak', 'br', 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && (0, $jAdKh.isSpace)(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
}

});

parcelRegister("31cye", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $232b337fe1dbc147$export$2e2bcd8739ae039; });
// Process escaped chars and hardbreaks

var $jAdKh = parcelRequire("jAdKh");
const $232b337fe1dbc147$var$ESCAPED = [];
for(let i = 0; i < 256; i++)$232b337fe1dbc147$var$ESCAPED.push(0);
'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function(ch) {
    $232b337fe1dbc147$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
function $232b337fe1dbc147$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    let ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push('hardbreak', 'br', 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!(0, $jAdKh.isSpace)(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    let escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        const ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    const origStr = '\\' + escapedStr;
    if (!silent) {
        const token = state.push('text_special', '', 0);
        if (ch1 < 256 && $232b337fe1dbc147$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = 'escape';
    }
    state.pos = pos + 1;
    return true;
}

});

parcelRegister("bpHE6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $84f3e2acbb3f477b$export$2e2bcd8739ae039; });
// Parse backticks
function $84f3e2acbb3f477b$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    const ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    const start = pos;
    pos++;
    const max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    const marker = state.src.slice(start, pos);
    const openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    let matchEnd = pos;
    let matchStart;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf('`', matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        const closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                const token = state.push('code_inline', 'code', 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, ' ').replace(/^ (.+) $/, '$1');
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
}

});

parcelRegister("5LJFE", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $4334c4ca8a565d37$export$2e2bcd8739ae039; });
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
function $4334c4ca8a565d37$var$strikethrough_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    const scanned = state.scanDelims(state.pos, true);
    let len = scanned.length;
    const ch = String.fromCharCode(marker);
    if (len < 2) return false;
    let token;
    if (len % 2) {
        token = state.push('text', '', 0);
        token.content = ch;
        len--;
    }
    for(let i = 0; i < len; i += 2){
        token = state.push('text', '', 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function $4334c4ca8a565d37$var$postProcess(state, delimiters) {
    let token;
    const loneMarkers = [];
    const max = delimiters.length;
    for(let i = 0; i < max; i++){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = 's_open';
        token.tag = 's';
        token.nesting = 1;
        token.markup = '~~';
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = 's_close';
        token.tag = 's';
        token.nesting = -1;
        token.markup = '~~';
        token.content = '';
        if (state.tokens[endDelim.token - 1].type === 'text' && state.tokens[endDelim.token - 1].content === '~') loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        const i = loneMarkers.pop();
        let j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === 's_close')j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function $4334c4ca8a565d37$var$strikethrough_postProcess(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $4334c4ca8a565d37$var$postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $4334c4ca8a565d37$var$postProcess(state, tokens_meta[curr].delimiters);
}
var $4334c4ca8a565d37$export$2e2bcd8739ae039 = {
    tokenize: $4334c4ca8a565d37$var$strikethrough_tokenize,
    postProcess: $4334c4ca8a565d37$var$strikethrough_postProcess
};

});

parcelRegister("cfwZG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $8eb07aabc8fb87e8$export$2e2bcd8739ae039; });
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
function $8eb07aabc8fb87e8$var$emphasis_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    const scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(let i = 0; i < scanned.length; i++){
        const token = state.push('text', '', 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            marker: // Char code of the starting marker (number).
            //
            marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function $8eb07aabc8fb87e8$var$postProcess(state, delimiters) {
    const max = delimiters.length;
    for(let i = max - 1; i >= 0; i--){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        const isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        const ch = String.fromCharCode(startDelim.marker);
        const token_o = state.tokens[startDelim.token];
        token_o.type = isStrong ? 'strong_open' : 'em_open';
        token_o.tag = isStrong ? 'strong' : 'em';
        token_o.nesting = 1;
        token_o.markup = isStrong ? ch + ch : ch;
        token_o.content = '';
        const token_c = state.tokens[endDelim.token];
        token_c.type = isStrong ? 'strong_close' : 'em_close';
        token_c.tag = isStrong ? 'strong' : 'em';
        token_c.nesting = -1;
        token_c.markup = isStrong ? ch + ch : ch;
        token_c.content = '';
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = '';
            state.tokens[delimiters[startDelim.end + 1].token].content = '';
            i--;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function $8eb07aabc8fb87e8$var$emphasis_post_process(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $8eb07aabc8fb87e8$var$postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $8eb07aabc8fb87e8$var$postProcess(state, tokens_meta[curr].delimiters);
}
var $8eb07aabc8fb87e8$export$2e2bcd8739ae039 = {
    tokenize: $8eb07aabc8fb87e8$var$emphasis_tokenize,
    postProcess: $8eb07aabc8fb87e8$var$emphasis_post_process
};

});

parcelRegister("8Lj6w", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $661188369ea2246a$export$2e2bcd8739ae039; });
// Process [link](<to> "stuff")

var $jAdKh = parcelRequire("jAdKh");
function $661188369ea2246a$export$2e2bcd8739ae039(state, silent) {
    let code, label, res, ref;
    let href = '';
    let title = '';
    let start = state.pos;
    let parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    const oldPos = state.pos;
    const max = state.posMax;
    const labelStart = state.pos + 1;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    let pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $jAdKh.isSpace)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, $jAdKh.isSpace)(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!(0, $jAdKh.isSpace)(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, $jAdKh.normalizeReference)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        const token_o = state.push('link_open', 'a', 1);
        const attrs = [
            [
                'href',
                href
            ]
        ];
        token_o.attrs = attrs;
        if (title) attrs.push([
            'title',
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        state.push('link_close', 'a', -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}

});

parcelRegister("77xCG", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $52f344a87a9da36b$export$2e2bcd8739ae039; });
// Process ![image](<src> "title")

var $jAdKh = parcelRequire("jAdKh");
function $52f344a87a9da36b$export$2e2bcd8739ae039(state, silent) {
    let code, content, label, pos, ref, res, title, start;
    let href = '';
    const oldPos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    const labelStart = state.pos + 2;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $jAdKh.isSpace)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $jAdKh.isSpace)(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, $jAdKh.isSpace)(code) && code !== 0x0A) break;
            }
        } else title = '';
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, $jAdKh.normalizeReference)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        const tokens = [];
        state.md.inline.parse(content, state.md, state.env, tokens);
        const token = state.push('image', 'img', 0);
        const attrs = [
            [
                'src',
                href
            ],
            [
                'alt',
                ''
            ]
        ];
        token.attrs = attrs;
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            'title',
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}

});

parcelRegister("iIWcd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $da197a960fbf31ba$export$2e2bcd8739ae039; });
// Process autolinks '<protocol:...>'
/* eslint max-len:0 */ const $da197a960fbf31ba$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
/* eslint-disable-next-line no-control-regex */ const $da197a960fbf31ba$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function $da197a960fbf31ba$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    const start = state.pos;
    const max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        const ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    const url = state.src.slice(start + 1, pos);
    if ($da197a960fbf31ba$var$AUTOLINK_RE.test(url)) {
        const fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push('link_open', 'a', 1);
            token_o.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token_o.markup = 'autolink';
            token_o.info = 'auto';
            const token_t = state.push('text', '', 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push('link_close', 'a', -1);
            token_c.markup = 'autolink';
            token_c.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($da197a960fbf31ba$var$EMAIL_RE.test(url)) {
        const fullUrl = state.md.normalizeLink('mailto:' + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push('link_open', 'a', 1);
            token_o.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token_o.markup = 'autolink';
            token_o.info = 'auto';
            const token_t = state.push('text', '', 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push('link_close', 'a', -1);
            token_c.markup = 'autolink';
            token_c.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
}

});

parcelRegister("h9Rs1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $c7dcbd307caee285$export$2e2bcd8739ae039; });
// Process html tags

var $2lp07 = parcelRequire("2lp07");
function $c7dcbd307caee285$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $c7dcbd307caee285$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $c7dcbd307caee285$var$isLetter(ch) {
    /* eslint no-bitwise:0 */ const lc = ch | 0x20 // to lower case
    ;
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
function $c7dcbd307caee285$export$2e2bcd8739ae039(state, silent) {
    if (!state.md.options.html) return false;
    // Check start
    const max = state.posMax;
    const pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    const ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$c7dcbd307caee285$var$isLetter(ch)) return false;
    const match = state.src.slice(pos).match((0, $2lp07.HTML_TAG_RE));
    if (!match) return false;
    if (!silent) {
        const token = state.push('html_inline', '', 0);
        token.content = match[0];
        if ($c7dcbd307caee285$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($c7dcbd307caee285$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
}

});

parcelRegister("1k9Pg", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0f6f47e5869f2b90$export$2e2bcd8739ae039; });
// Process html entity - &#123;, &#xAF;, &quot;, ...
parcelRequire("fyijY");
var $9i7QI = parcelRequire("9i7QI");

var $jAdKh = parcelRequire("jAdKh");
const $0f6f47e5869f2b90$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
const $0f6f47e5869f2b90$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
function $0f6f47e5869f2b90$export$2e2bcd8739ae039(state, silent) {
    const pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    const ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        const match = state.src.slice(pos).match($0f6f47e5869f2b90$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                const code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                const token = state.push('text_special', '', 0);
                token.content = (0, $jAdKh.isValidEntityCode)(code) ? (0, $jAdKh.fromCodePoint)(code) : (0, $jAdKh.fromCodePoint)(0xFFFD);
                token.markup = match[0];
                token.info = 'entity';
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        const match = state.src.slice(pos).match($0f6f47e5869f2b90$var$NAMED_RE);
        if (match) {
            const decoded = (0, $9i7QI.decodeHTML)(match[0]);
            if (decoded !== match[0]) {
                if (!silent) {
                    const token = state.push('text_special', '', 0);
                    token.content = decoded;
                    token.markup = match[0];
                    token.info = 'entity';
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
}

});

parcelRegister("cY3lM", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $970dafe9fd11b3b9$export$2e2bcd8739ae039; });
// For each opening emphasis-like marker find a matching closing one
//
function $970dafe9fd11b3b9$var$processDelimiters(delimiters) {
    const openersBottom = {};
    const max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    let headerIdx = 0;
    let lastTokenIdx = -2 // needs any value lower than -1
    ;
    const jumps = [];
    for(let closerIdx = 0; closerIdx < max; closerIdx++){
        const closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        /* eslint-disable-next-line no-prototype-builtins */ if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        const minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        let openerIdx = headerIdx - jumps[headerIdx] - 1;
        let newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            const opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                let isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    const lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
function $970dafe9fd11b3b9$export$2e2bcd8739ae039(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $970dafe9fd11b3b9$var$processDelimiters(state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $970dafe9fd11b3b9$var$processDelimiters(tokens_meta[curr].delimiters);
}

});

parcelRegister("3YBjn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2e53eafa15757cf6$export$2e2bcd8739ae039; });
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
function $2e53eafa15757cf6$export$2e2bcd8739ae039(state) {
    let curr, last;
    let level = 0;
    const tokens = state.tokens;
    const max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level--; // closing tag
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++; // opening tag
        if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
}

});


parcelRegister("bikvB", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $839148bf738493a5$export$2e2bcd8739ae039; });

var $jQKeV = parcelRequire("jQKeV");
//
// Helpers
//
// Merge objects
//
function $839148bf738493a5$var$assign(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $839148bf738493a5$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $839148bf738493a5$var$isString(obj) {
    return $839148bf738493a5$var$_class(obj) === '[object String]';
}
function $839148bf738493a5$var$isObject(obj) {
    return $839148bf738493a5$var$_class(obj) === '[object Object]';
}
function $839148bf738493a5$var$isRegExp(obj) {
    return $839148bf738493a5$var$_class(obj) === '[object RegExp]';
}
function $839148bf738493a5$var$isFunction(obj) {
    return $839148bf738493a5$var$_class(obj) === '[object Function]';
}
function $839148bf738493a5$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
//
const $839148bf738493a5$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $839148bf738493a5$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        /* eslint-disable-next-line no-prototype-builtins */ return acc || $839148bf738493a5$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
const $839148bf738493a5$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
/* eslint-disable-next-line max-len */ const $839148bf738493a5$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
const $839148bf738493a5$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
function $839148bf738493a5$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $839148bf738493a5$var$createValidator(re) {
    return function(text, pos) {
        const tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $839148bf738493a5$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}
// Schemas compiler. Build regexps.
//
function $839148bf738493a5$var$compile(self) {
    // Load & clone RE patterns.
    const re = self.re = (0, $jQKeV.default)(self.__opts__);
    // Define dynamic patterns
    const tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($839148bf738493a5$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    const aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        const val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        const compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($839148bf738493a5$var$isObject(val)) {
            if ($839148bf738493a5$var$isRegExp(val.validate)) compiled.validate = $839148bf738493a5$var$createValidator(val.validate);
            else if ($839148bf738493a5$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($839148bf738493a5$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $839148bf738493a5$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($839148bf738493a5$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $839148bf738493a5$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    const slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($839148bf738493a5$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.schema_at_start = RegExp('^' + self.re.schema_search.source, 'i');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $839148bf738493a5$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $839148bf738493a5$var$Match(self, shift) {
    const start = self.__index__;
    const end = self.__last_index__;
    const text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $839148bf738493a5$var$createMatch(self, shift) {
    const match = new $839148bf738493a5$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $839148bf738493a5$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $839148bf738493a5$var$LinkifyIt)) return new $839148bf738493a5$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($839148bf738493a5$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $839148bf738493a5$var$assign({}, $839148bf738493a5$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $839148bf738493a5$var$assign({}, $839148bf738493a5$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $839148bf738493a5$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $839148bf738493a5$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $839148bf738493a5$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $839148bf738493a5$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $839148bf738493a5$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $839148bf738493a5$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $839148bf738493a5$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    let m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $839148bf738493a5$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $839148bf738493a5$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $839148bf738493a5$var$LinkifyIt.prototype.match = function match(text) {
    const result = [];
    let shift = 0;
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($839148bf738493a5$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    let tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($839148bf738493a5$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $839148bf738493a5$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    const m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    const len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $839148bf738493a5$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $839148bf738493a5$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $839148bf738493a5$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $839148bf738493a5$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $839148bf738493a5$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $839148bf738493a5$var$LinkifyIt.prototype.onCompile = function onCompile() {};
var $839148bf738493a5$export$2e2bcd8739ae039 = $839148bf738493a5$var$LinkifyIt;

});
parcelRegister("jQKeV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e736bde30bd9de04$export$2e2bcd8739ae039; });
parcelRequire("8djVQ");
var $ioVOV = parcelRequire("ioVOV");
var $7ZsNi = parcelRequire("7ZsNi");
var $9GUSE = parcelRequire("9GUSE");
var $1GVtv = parcelRequire("1GVtv");
function $e736bde30bd9de04$export$2e2bcd8739ae039(opts) {
    const re = {};
    opts = opts || {};
    re.src_Any = (0, $ioVOV.default).source;
    re.src_Cc = (0, $7ZsNi.default).source;
    re.src_Z = (0, $1GVtv.default).source;
    re.src_P = (0, $9GUSE.default).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    const text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')' + '(?!' + (opts['---'] ? '-(?!--)|' : '-|') + '_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + // allow `I'm_king` if no pair found
    "\\'(?=" + re.src_pseudo_letter + '|[-])|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.{2,}[a-zA-Z0-9%/&]|' + '\\.(?!' + re.src_ZCc + '|[.]|$)|' + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + // allow `,,,` in paths
    ',(?!' + re.src_ZCc + '|$)|' + // allow `;` if not followed by space-like char
    ';(?!' + re.src_ZCc + '|$)|' + // allow `!!!` in paths, but not at the end
    '\\!+(?!' + re.src_ZCc + '|[!]|$)|' + '\\?(?!' + re.src_ZCc + '|[?]|$)' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /* _root */  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    //
    // Main rules
    //
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
}

});


parcelRegister("fEiZX", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b64954183418c786$export$2e2bcd8739ae039; });
'use strict';
/** Highest positive signed 32-bit float value */ const $b64954183418c786$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $b64954183418c786$var$base = 36;
const $b64954183418c786$var$tMin = 1;
const $b64954183418c786$var$tMax = 26;
const $b64954183418c786$var$skew = 38;
const $b64954183418c786$var$damp = 700;
const $b64954183418c786$var$initialBias = 72;
const $b64954183418c786$var$initialN = 128; // 0x80
const $b64954183418c786$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $b64954183418c786$var$regexPunycode = /^xn--/;
const $b64954183418c786$var$regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const $b64954183418c786$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $b64954183418c786$var$errors = {
    'overflow': 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
/** Convenience shortcuts */ const $b64954183418c786$var$baseMinusTMin = $b64954183418c786$var$base - $b64954183418c786$var$tMin;
const $b64954183418c786$var$floor = Math.floor;
const $b64954183418c786$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $b64954183418c786$var$error(type) {
    throw new RangeError($b64954183418c786$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $b64954183418c786$var$map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function $b64954183418c786$var$mapDomain(domain, callback) {
    const parts = domain.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace($b64954183418c786$var$regexSeparators, '\x2E');
    const labels = domain.split('.');
    const encoded = $b64954183418c786$var$map(labels, callback).join('.');
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $b64954183418c786$export$c1700176c90f250f(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $b64954183418c786$export$f999239d9b149395 = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $b64954183418c786$var$basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return $b64954183418c786$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $b64954183418c786$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $b64954183418c786$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $b64954183418c786$var$floor(delta / $b64954183418c786$var$damp) : delta >> 1;
    delta += $b64954183418c786$var$floor(delta / numPoints);
    for(; delta > $b64954183418c786$var$baseMinusTMin * $b64954183418c786$var$tMax >> 1; k += $b64954183418c786$var$base)delta = $b64954183418c786$var$floor(delta / $b64954183418c786$var$baseMinusTMin);
    return $b64954183418c786$var$floor(k + ($b64954183418c786$var$baseMinusTMin + 1) * delta / (delta + $b64954183418c786$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $b64954183418c786$export$2f872c0f2117be69 = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $b64954183418c786$var$initialN;
    let bias = $b64954183418c786$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($b64954183418c786$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $b64954183418c786$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = $b64954183418c786$var$base;; k += $b64954183418c786$var$base){
            if (index >= inputLength) $b64954183418c786$var$error('invalid-input');
            const digit = $b64954183418c786$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $b64954183418c786$var$base) $b64954183418c786$var$error('invalid-input');
            if (digit > $b64954183418c786$var$floor(($b64954183418c786$var$maxInt - i) / w)) $b64954183418c786$var$error('overflow');
            i += digit * w;
            const t = k <= bias ? $b64954183418c786$var$tMin : k >= bias + $b64954183418c786$var$tMax ? $b64954183418c786$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $b64954183418c786$var$base - t;
            if (w > $b64954183418c786$var$floor($b64954183418c786$var$maxInt / baseMinusT)) $b64954183418c786$var$error('overflow');
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $b64954183418c786$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($b64954183418c786$var$floor(i / out) > $b64954183418c786$var$maxInt - n) $b64954183418c786$var$error('overflow');
        n += $b64954183418c786$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $b64954183418c786$export$c564cdbbe6da493 = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $b64954183418c786$export$c1700176c90f250f(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = $b64954183418c786$var$initialN;
    let delta = 0;
    let bias = $b64954183418c786$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($b64954183418c786$var$stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($b64954183418c786$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $b64954183418c786$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $b64954183418c786$var$floor(($b64954183418c786$var$maxInt - delta) / handledCPCountPlusOne)) $b64954183418c786$var$error('overflow');
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $b64954183418c786$var$maxInt) $b64954183418c786$var$error('overflow');
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $b64954183418c786$var$base;; k += $b64954183418c786$var$base){
                    const t = k <= bias ? $b64954183418c786$var$tMin : k >= bias + $b64954183418c786$var$tMax ? $b64954183418c786$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $b64954183418c786$var$base - t;
                    output.push($b64954183418c786$var$stringFromCharCode($b64954183418c786$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $b64954183418c786$var$floor(qMinusT / baseMinusT);
                }
                output.push($b64954183418c786$var$stringFromCharCode($b64954183418c786$var$digitToBasic(q, 0)));
                bias = $b64954183418c786$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join('');
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $b64954183418c786$export$110c810e8727e62b = function(input) {
    return $b64954183418c786$var$mapDomain(input, function(string) {
        return $b64954183418c786$var$regexPunycode.test(string) ? $b64954183418c786$export$2f872c0f2117be69(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $b64954183418c786$export$69111c4ea6e0c4a0 = function(input) {
    return $b64954183418c786$var$mapDomain(input, function(string) {
        return $b64954183418c786$var$regexNonASCII.test(string) ? 'xn--' + $b64954183418c786$export$c564cdbbe6da493(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $b64954183418c786$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ 'version': '2.3.1',
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ 'ucs2': {
        'decode': $b64954183418c786$export$c1700176c90f250f,
        'encode': $b64954183418c786$export$f999239d9b149395
    },
    'decode': $b64954183418c786$export$2f872c0f2117be69,
    'encode': $b64954183418c786$export$c564cdbbe6da493,
    'toASCII': $b64954183418c786$export$69111c4ea6e0c4a0,
    'toUnicode': $b64954183418c786$export$110c810e8727e62b
};
var $b64954183418c786$export$2e2bcd8739ae039 = $b64954183418c786$var$punycode;

});

parcelRegister("hGp75", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cdf9d6e6ab0e2050$export$2e2bcd8739ae039; });
// markdown-it default options
var $cdf9d6e6ab0e2050$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: 'language-',
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 100
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRegister("3glcq", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $26034f75d61adf8b$export$2e2bcd8739ae039; });
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
var $26034f75d61adf8b$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: 'language-',
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'text'
            ],
            rules2: [
                'balance_pairs',
                'fragments_join'
            ]
        }
    }
};

});

parcelRegister("iZlew", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $dd2e64f709955416$export$2e2bcd8739ae039; });
// Commonmark default options
var $dd2e64f709955416$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: true,
        // Use '/' to close single tags (<br />)
        xhtmlOut: true,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: 'language-',
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'blockquote',
                'code',
                'fence',
                'heading',
                'hr',
                'html_block',
                'lheading',
                'list',
                'reference',
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'autolink',
                'backticks',
                'emphasis',
                'entity',
                'escape',
                'html_inline',
                'image',
                'link',
                'newline',
                'text'
            ],
            rules2: [
                'balance_pairs',
                'emphasis',
                'fragments_join'
            ]
        }
    }
};

});




parcelRegister("cl834", function(module, exports) {
$parcel$export(module.exports, "markdownItMedia", function () { return $8fbdb0749377b9f6$export$c8dcbd316b71f8cf; });

var $11tOd = parcelRequire("11tOd");

var $7CMz9 = parcelRequire("7CMz9");
function $8fbdb0749377b9f6$var$createRule() {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    var regx = /!\[([^\]]*)\]\(([^)]*?)\s*(?:"([^")]*)"\s*)?\)/g;
    var validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open',
        'blockquote_open'
    ];
    /**
   * This function looks for strings that matches ![description](url) inside Inline-tokens.
   * It will then split the Inline-token with content before and after the image, example:
   *
   * Input (tokens):
   *   paragraph_open
   *   inline - content: Hello ![](image.jpg) World!
   *   paragraph_close
   * Output (tokens):
   *   paragraph_open
   *   inline - content: Hello
   *   paragraph_close
   *   media_single_open
   *   media
   *   media_single_close
   *   paragraph_open
   *   inline - content: World!
   *   paragraph_close
   *
   * This is applied before the inline content is parsed, to ensure that the formatting of
   * remaining inline content (bold, links, etc.) is kept intact!
   */ return function media(State) {
        var getUrl = function getUrl(str) {
            var res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                var href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        var createMediaTokens = function createMediaTokens(url) {
            var alt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
            var mediaSingleOpen = new State.Token('media_single_open', '', 1);
            var media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ],
                [
                    'alt',
                    alt
                ]
            ];
            var mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        var createInlineTokens = function createInlineTokens(str, openingTokens, closingTokens) {
            if (!str || str.length === 0) return [];
            var inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [].concat((0, $7CMz9.default)(openingTokens), [
                inlineBefore
            ], (0, $7CMz9.default)(closingTokens));
        };
        var processedTokens = [];
        var newTokens = State.tokens.reduce(function(tokens, token, i, arr) {
            var matchAll = Array.from(token.content.matchAll(regx));
            if (token.type === 'inline' && matchAll.length) {
                var openingTokens = [];
                var cursor = i - 1;
                var previousToken = arr[cursor];
                var subTree = [];
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                var closingTokens = openingTokens.map(function(token) {
                    return new State.Token(token.type.replace('_open', '_close'), token.tag, -1);
                }).reverse();
                var inlineContentStack = token.content;
                matchAll.forEach(function(match, j) {
                    var _match = (0, $11tOd.default)(match, 3), matchString = _match[0], alt = _match[1], url = _match[2];
                    var start = inlineContentStack.indexOf(matchString);
                    var contentBefore = inlineContentStack.substr(0, start);
                    inlineContentStack = inlineContentStack.substr(start + matchString.length);
                    subTree = [].concat((0, $7CMz9.default)(subTree), (0, $7CMz9.default)(createInlineTokens(contentBefore, openingTokens, closingTokens)), (0, $7CMz9.default)(createMediaTokens(url, alt)));
                });
                if (inlineContentStack.length) subTree = [].concat((0, $7CMz9.default)(subTree), (0, $7CMz9.default)(createInlineTokens(inlineContentStack, openingTokens, closingTokens)));
                processedTokens = [].concat((0, $7CMz9.default)(processedTokens), (0, $7CMz9.default)(closingTokens.map(function(c) {
                    return c.type;
                })));
                tokens = [].concat((0, $7CMz9.default)(tokens.slice(0, cursor)), (0, $7CMz9.default)(subTree));
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
var $8fbdb0749377b9f6$export$c8dcbd316b71f8cf = function markdownItMedia(md) {
    md.core.ruler.before('inline', 'media', $8fbdb0749377b9f6$var$createRule());
};

});
parcelRegister("11tOd", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $0bed01e0e4f65b77$export$2e2bcd8739ae039; });

var $5o40i = parcelRequire("5o40i");

var $lcOPK = parcelRequire("lcOPK");

var $fnWgV = parcelRequire("fnWgV");

var $9llH1 = parcelRequire("9llH1");
function $0bed01e0e4f65b77$export$2e2bcd8739ae039(r, e) {
    return (0, $5o40i.default)(r) || (0, $lcOPK.default)(r, e) || (0, $fnWgV.default)(r, e) || (0, $9llH1.default)();
}

});
parcelRegister("5o40i", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3ec24cb277b59109$export$2e2bcd8739ae039; });
function $3ec24cb277b59109$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("lcOPK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f7022675b2445583$export$2e2bcd8739ae039; });
function $f7022675b2445583$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("fnWgV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b336349737665a9f$export$2e2bcd8739ae039; });

var $412Hy = parcelRequire("412Hy");
function $b336349737665a9f$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $412Hy.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $412Hy.default)(r, a) : void 0;
    }
}

});
parcelRegister("412Hy", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $2ec959e77e1f3095$export$2e2bcd8739ae039; });
function $2ec959e77e1f3095$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("9llH1", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6cd6e6f78c5cfdee$export$2e2bcd8739ae039; });
function $6cd6e6f78c5cfdee$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("7CMz9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $58d1c138dbe56cde$export$2e2bcd8739ae039; });

var $bKzD6 = parcelRequire("bKzD6");

var $2qxSo = parcelRequire("2qxSo");

var $fnWgV = parcelRequire("fnWgV");

var $77CAJ = parcelRequire("77CAJ");
function $58d1c138dbe56cde$export$2e2bcd8739ae039(r) {
    return (0, $bKzD6.default)(r) || (0, $2qxSo.default)(r) || (0, $fnWgV.default)(r) || (0, $77CAJ.default)();
}

});
parcelRegister("bKzD6", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $88dfa0e6e93f3fc5$export$2e2bcd8739ae039; });

var $412Hy = parcelRequire("412Hy");
function $88dfa0e6e93f3fc5$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $412Hy.default)(r);
}

});

parcelRegister("2qxSo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $1c48499687b52fb5$export$2e2bcd8739ae039; });
function $1c48499687b52fb5$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("77CAJ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $52f71f4dabf11089$export$2e2bcd8739ae039; });
function $52f71f4dabf11089$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRegister("d6iF4", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $989a4faae6b4435d$export$2e2bcd8739ae039; });
function $989a4faae6b4435d$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $989a4faae6b4435d$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $989a4faae6b4435d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $989a4faae6b4435d$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $989a4faae6b4435d$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $989a4faae6b4435d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $989a4faae6b4435d$var$CITATION_REGEX = /\[\^(\d+)\^\]/;
/**
 * This plugin is used to transform citations in markdown to status tokens
 * Citations are in the format [^1^], [^2^], etc.
 * The citations correspond to source references in the response:
 * If we have a response like:
 * "This is a citation[^5^]. This is another citation[^8^]. This is the final citation[^5^]." then the citations will be transformed to:
 * "This is a citation 1. This is another citation 2. This is the final citation 1."
 * We are reordering the citation from 1 2 3 on purpose
 */ var $989a4faae6b4435d$var$citation = function citation(state) {
    var tokens = [];
    var citationIndexMap = {};
    var currentIndex = 1;
    var _iterator = $989a4faae6b4435d$var$_createForOfIteratorHelper(state.tokens), _step;
    try {
        var _loop = function _loop() {
            var _token$children;
            var token = _step.value;
            var tokenChildren = [];
            if (token.type !== 'inline' || token.children && (token === null || token === void 0 || (_token$children = token.children) === null || _token$children === void 0 ? void 0 : _token$children.length) <= 0) {
                tokens.push(token);
                return 1; // continue
            }
            if (token.children) token.children.forEach(function(childToken) {
                if (childToken.type === 'text' && $989a4faae6b4435d$var$CITATION_REGEX.test(childToken.content)) {
                    /**
             * Example content: `Hello [^1^][^1^].`
             * `parts` will be ['Hello ', '1', '', '1', '.']
             */ var parts = childToken.content.split($989a4faae6b4435d$var$CITATION_REGEX);
                    var newChildren = [];
                    /**
             * we want to remove consecutive citation
             * e.g. `Hello [^1^][^1^]. How are you [^1^][^2^]`
             * should be transformed to `Hello 1. How are you 1 2`
             */ var lastCitation = null;
                    var isLastCitationDuplicate = false;
                    // only want to add space in the next part after citation
                    // if the last citation is valid
                    parts.forEach(function(part, index) {
                        if (index % 2 === 0) {
                            // this is a text part
                            /**
                 * if the last citation is a duplicate, and the text part is an empty string, we skip rendering the inbetween empty space
                 * So it doesn't end up rendering empty space that will end up with multi empty spaces
                 * because previous valid citation already added 1 empty space
                 *
                 * Example: For `[^1^][^1^]`
                 * it will be split into parts: ['', '1', '', '1', ''],
                 * This code will skip any rendering for the last empty string (index=4)
                 * Because the empty string at index=2 already added 1 empty space from the code below
                 */ if (isLastCitationDuplicate && part.trim() === '') return;
                            if (part.trim() !== '') /**
                   * if the text part is not an empty string, we want to reset the last citation
                   * because the text part is a valid text, and not a space between citations
                   * so that we can render citation again, even if the next number is the same as the last number
                   *
                   * Example:
                   * `[^1^] [^1^] Hello [^1^][^1^]` -> `1 Hello 1`
                   */ lastCitation = null;
                            var textToken = new state.Token('text', '', 0);
                            if (index === parts.length - 1) textToken.content = part;
                            else textToken.content = part + ' ';
                            textToken.block = false;
                            textToken.level = childToken.level;
                            newChildren.push(textToken);
                        } else {
                            // this is a citation part
                            // if the current citation is the same as the last citation, we skip rendering the citation, and mark it as a duplicate
                            if (part === lastCitation) {
                                isLastCitationDuplicate = true;
                                return;
                            } else {
                                // always reset the duplicate flag
                                isLastCitationDuplicate = false;
                                lastCitation = part;
                            }
                            var citationToken = new state.Token('status', '', 0);
                            citationToken.content = '';
                            citationToken.block = false;
                            citationToken.level = childToken.level;
                            var citationText = citationIndexMap[part] ? citationIndexMap[part].toString() : currentIndex.toString();
                            if (!citationIndexMap[part]) {
                                citationIndexMap[part] = currentIndex;
                                currentIndex++;
                            }
                            citationToken.attrs = [
                                [
                                    'color',
                                    'blue'
                                ],
                                [
                                    'text',
                                    citationText
                                ],
                                // localId is used to identify the citation token in the DOM
                                // this overrides the uuid that is normally used
                                [
                                    'localId',
                                    "citation-".concat(citationText)
                                ]
                            ];
                            citationToken.content = citationText;
                            newChildren.push(citationToken);
                        }
                    });
                    tokenChildren.push.apply(tokenChildren, newChildren);
                    return;
                }
                tokenChildren.push(childToken);
            });
            var filteredTokenChildren = tokenChildren.filter(function(childToken) {
                return childToken !== null;
            });
            token.children = filteredTokenChildren;
            tokens.push(token);
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            if (_loop()) continue;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    state.tokens = tokens;
    return;
};
var $989a4faae6b4435d$export$2e2bcd8739ae039 = function(md) {
    return md.core.ruler.push('citation', $989a4faae6b4435d$var$citation);
};

});

parcelRegister("l1YGC", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f4f8c40cc10f1210$export$2e2bcd8739ae039; });
function $f4f8c40cc10f1210$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $f4f8c40cc10f1210$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $f4f8c40cc10f1210$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f4f8c40cc10f1210$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f4f8c40cc10f1210$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f4f8c40cc10f1210$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $f4f8c40cc10f1210$var$SCULPTOR_REGEX = /\[\^(sculptor)\^\]/;
var $f4f8c40cc10f1210$var$dataSculptor = function dataSculptor(state) {
    var tokens = [];
    var _iterator = $f4f8c40cc10f1210$var$_createForOfIteratorHelper(state.tokens), _step;
    try {
        var _loop = function _loop() {
            var _token$children;
            var token = _step.value;
            var tokenChildren = [];
            if (token.type !== 'inline' || token.children && (token === null || token === void 0 || (_token$children = token.children) === null || _token$children === void 0 ? void 0 : _token$children.length) <= 0) {
                tokens.push(token);
                return 1; // continue
            }
            if (token.children) token.children.forEach(function(childToken) {
                if (childToken.type === 'text' && $f4f8c40cc10f1210$var$SCULPTOR_REGEX.test(childToken.content)) {
                    var citationToken = new state.Token('status', '', 0);
                    citationToken.content = '';
                    citationToken.block = false;
                    citationToken.level = childToken.level;
                    citationToken.attrs = [
                        [
                            'localId',
                            'data-sculptor'
                        ],
                        [
                            'text',
                            'data-sculptor'
                        ],
                        [
                            'color',
                            'blue'
                        ]
                    ];
                    var parts = childToken.content.split($f4f8c40cc10f1210$var$SCULPTOR_REGEX);
                    parts.forEach(function(part, index) {
                        if (index % 2 === 0) {
                            var textToken = new state.Token('text', '', 0);
                            textToken.content = part;
                            textToken.level = childToken.level;
                            tokenChildren.push(textToken);
                        } else tokenChildren.push(citationToken);
                    });
                    return;
                }
                tokenChildren.push(childToken);
            });
            var filteredTokenChildren = tokenChildren.filter(function(childToken) {
                return childToken !== null;
            });
            token.children = filteredTokenChildren;
            tokens.push(token);
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            if (_loop()) continue;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    state.tokens = tokens;
    return;
};
var $f4f8c40cc10f1210$export$2e2bcd8739ae039 = function(md) {
    return md.core.ruler.push('data-sculptor', $f4f8c40cc10f1210$var$dataSculptor);
};

});

parcelRegister("1o1tc", function(module, exports) {
$parcel$export(module.exports, "createLinkifyPlugin", function () { return $10292c37b68bb0b4$export$763ac077c9998026; });

var $dC0Ye = parcelRequire("dC0Ye");

var $dB7hx = parcelRequire("dB7hx");
// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
var $10292c37b68bb0b4$var$arrayReplaceAt = function arrayReplaceAt(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
var $10292c37b68bb0b4$var$isLinkOpen = function isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
};
var $10292c37b68bb0b4$var$isLinkClose = function isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
};
var $10292c37b68bb0b4$export$8cd7d1ec2e6808da = function createLinkify(_ref) {
    var findFilepaths = _ref.findFilepaths, isLinkInMatches = _ref.isLinkInMatches;
    return function(state) {
        var blockTokens = state.tokens;
        var linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($dC0Ye)))();
        for(var j = 0, l = blockTokens.length; j < l; j++){
            if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
            var tokens = blockTokens[j].children;
            var htmlLinkLevel = 0;
            // We scan from the end, to keep position when new tags added.
            // Use reversed logic in links start/end match
            for(var i = tokens.length - 1; i >= 0; i--){
                var currentToken = tokens[i];
                // Skip content of markdown links
                if (currentToken.type === 'link_close') {
                    i--;
                    while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                    continue;
                }
                // Skip content of html tag links
                if (currentToken.type === 'html_inline') {
                    if ($10292c37b68bb0b4$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                    if ($10292c37b68bb0b4$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
                }
                if (htmlLinkLevel > 0) continue;
                if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                    var _text = currentToken.content;
                    var links = (0, $dB7hx.linkifyMatch)(_text);
                    if (!links.length) links = linkify.match(_text) || [];
                    // Now split string to nodes
                    var nodes = [];
                    var level = currentToken.level;
                    var lastPos = 0;
                    var _filepaths = findFilepaths(_text);
                    for(var ln = 0; ln < links.length; ln++){
                        if (isLinkInMatches(links[ln].index, _filepaths)) continue;
                        var url = links[ln].url;
                        var fullUrl = state.md.normalizeLink(url);
                        if (!state.md.validateLink(fullUrl)) continue;
                        var urlText = links[ln].text;
                        // Linkifier might send raw hostnames like "example.com", where url
                        // starts with domain name. So we prepend http:// in those cases,
                        // and remove it afterwards.
                        //
                        if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                        else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                        else urlText = state.md.normalizeLinkText(urlText);
                        var pos = links[ln].index;
                        if (pos > lastPos) {
                            var _token = new state.Token('text', '', 0);
                            _token.content = _text.slice(lastPos, pos);
                            _token.level = level;
                            nodes.push(_token);
                        }
                        var token = new state.Token('link_open', 'a', 1);
                        token.attrs = [
                            [
                                'href',
                                fullUrl
                            ]
                        ];
                        token.level = level++;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        token = new state.Token('text', '', 0);
                        token.content = urlText;
                        token.level = level;
                        nodes.push(token);
                        token = new state.Token('link_close', 'a', -1);
                        token.level = --level;
                        token.markup = 'linkify';
                        token.info = 'auto';
                        nodes.push(token);
                        lastPos = links[ln].lastIndex;
                    }
                    if (lastPos < _text.length) {
                        var _token2 = new state.Token('text', '', 0);
                        _token2.content = _text.slice(lastPos);
                        _token2.level = level;
                        nodes.push(_token2);
                    }
                    // replace current node
                    blockTokens[j].children = tokens = $10292c37b68bb0b4$var$arrayReplaceAt(tokens, i, nodes);
                }
            }
        }
    };
};
var $10292c37b68bb0b4$export$763ac077c9998026 = function createLinkifyPlugin(params) {
    return function(md) {
        return md.core.ruler.push('custom-linkify', $10292c37b68bb0b4$export$8cd7d1ec2e6808da(params));
    };
};

});
parcelRegister("dC0Ye", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $9e8f93ab3663aa54$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $9e8f93ab3663aa54$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $9e8f93ab3663aa54$var$isString(obj) {
    return $9e8f93ab3663aa54$var$_class(obj) === '[object String]';
}
function $9e8f93ab3663aa54$var$isObject(obj) {
    return $9e8f93ab3663aa54$var$_class(obj) === '[object Object]';
}
function $9e8f93ab3663aa54$var$isRegExp(obj) {
    return $9e8f93ab3663aa54$var$_class(obj) === '[object RegExp]';
}
function $9e8f93ab3663aa54$var$isFunction(obj) {
    return $9e8f93ab3663aa54$var$_class(obj) === '[object Function]';
}
function $9e8f93ab3663aa54$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $9e8f93ab3663aa54$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $9e8f93ab3663aa54$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $9e8f93ab3663aa54$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $9e8f93ab3663aa54$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $9e8f93ab3663aa54$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $9e8f93ab3663aa54$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $9e8f93ab3663aa54$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $9e8f93ab3663aa54$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $9e8f93ab3663aa54$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $9e8f93ab3663aa54$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("01IZm"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($9e8f93ab3663aa54$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($9e8f93ab3663aa54$var$isObject(val)) {
            if ($9e8f93ab3663aa54$var$isRegExp(val.validate)) compiled.validate = $9e8f93ab3663aa54$var$createValidator(val.validate);
            else if ($9e8f93ab3663aa54$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($9e8f93ab3663aa54$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $9e8f93ab3663aa54$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($9e8f93ab3663aa54$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $9e8f93ab3663aa54$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($9e8f93ab3663aa54$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $9e8f93ab3663aa54$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $9e8f93ab3663aa54$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $9e8f93ab3663aa54$var$createMatch(self, shift) {
    var match = new $9e8f93ab3663aa54$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $9e8f93ab3663aa54$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $9e8f93ab3663aa54$var$LinkifyIt)) return new $9e8f93ab3663aa54$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($9e8f93ab3663aa54$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $9e8f93ab3663aa54$var$assign({}, $9e8f93ab3663aa54$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $9e8f93ab3663aa54$var$assign({}, $9e8f93ab3663aa54$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $9e8f93ab3663aa54$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $9e8f93ab3663aa54$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $9e8f93ab3663aa54$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $9e8f93ab3663aa54$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $9e8f93ab3663aa54$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $9e8f93ab3663aa54$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $9e8f93ab3663aa54$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $9e8f93ab3663aa54$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $9e8f93ab3663aa54$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $9e8f93ab3663aa54$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($9e8f93ab3663aa54$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($9e8f93ab3663aa54$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $9e8f93ab3663aa54$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $9e8f93ab3663aa54$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $9e8f93ab3663aa54$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $9e8f93ab3663aa54$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $9e8f93ab3663aa54$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $9e8f93ab3663aa54$var$LinkifyIt;

});
parcelRegister("01IZm", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("cESS3")).source;
    re.src_Cc = (parcelRequire("1ladB")).source;
    re.src_Z = (parcelRequire("aKpnB")).source;
    re.src_P = (parcelRequire("9R3PW")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + ').|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]).|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});



parcelRegister("hubVA", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $cbae7da3cc390d23$export$2e2bcd8739ae039; });

var $7CMz9 = parcelRequire("7CMz9");
/**
Note: This implementation was built by referencing Editor AI
packages/editor/editor-plugin-ai/src/prebuilt/content-transformers/markdown-to-pm/md/media-md-plugin.ts

Aside from a refactor, the key differences in logic are:
- Our regex is more specific, and will only match images that are not inside single backticks otherwise we'll see AI Mate render images surrounded by single backticks
*/ function $cbae7da3cc390d23$var$createRule() {
    // Match any images that aren't inside single backticks
    var mdImageRegex = RegExp("(?<!`)!\\[[^\\]]*\\]\\([^\\)]+\\)(?!`)", "g");
    var validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open'
    ];
    return function media(State) {
        var getUrl = function getUrl(str) {
            var res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                var href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        var createMediaTokens = function createMediaTokens(url) {
            var mediaSingleOpen = new State.Token('media_single_open', '', 1);
            var media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ]
            ];
            var mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        var createInlineTokens = function createInlineTokens(str, openingTokens, closingTokens) {
            if (!str || str.length === 0) return [];
            var inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [].concat((0, $7CMz9.default)(openingTokens), [
                inlineBefore
            ], (0, $7CMz9.default)(closingTokens));
        };
        var processedTokens = [];
        var newTokens = State.tokens.reduce(function(tokens, token, i, arr) {
            if (token.type === 'inline' && mdImageRegex.test(token.content)) {
                var openingTokens = [];
                var cursor = i - 1;
                var previousToken = arr[cursor];
                var subTree = [];
                // Loop backwards through the tokens until a valid parent token is found
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                // If the previous token is not a valid parent token, add it to the start of the opening tokens array
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                // Create closing tokens for each opening token and reverse the array
                var closingTokens = openingTokens.map(function(token) {
                    return new State.Token(token.type.replace('_open', '_close'), token.tag, -1);
                }).reverse();
                var matches = token.content.match(mdImageRegex);
                // Process all images in the inline token
                var inlineContentStack = token.content;
                matches.forEach(function(match) {
                    var start = inlineContentStack.indexOf(match);
                    var contentBefore = inlineContentStack.substring(0, start);
                    inlineContentStack = inlineContentStack.substring(start + match.length);
                    // Add the inline tokens and media tokens to the subtree
                    subTree = [].concat((0, $7CMz9.default)(subTree), (0, $7CMz9.default)(createInlineTokens(contentBefore, openingTokens, closingTokens)), (0, $7CMz9.default)(createMediaTokens(match)));
                });
                // If there is any remaining content in the stack, add the inline tokens to the subtree
                if (inlineContentStack.length) subTree = [].concat((0, $7CMz9.default)(subTree), (0, $7CMz9.default)(createInlineTokens(inlineContentStack, openingTokens, closingTokens)));
                processedTokens = [].concat((0, $7CMz9.default)(processedTokens), (0, $7CMz9.default)(closingTokens.map(function(c) {
                    return c.type;
                })));
                tokens = [].concat((0, $7CMz9.default)(tokens.slice(0, cursor)), (0, $7CMz9.default)(subTree));
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
var $cbae7da3cc390d23$export$2e2bcd8739ae039 = function(md) {
    md.core.ruler.before('inline', 'media', $cbae7da3cc390d23$var$createRule());
};

});

parcelRegister("lNotn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fde12860f08ebfc8$export$2e2bcd8739ae039; });
function $fde12860f08ebfc8$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $fde12860f08ebfc8$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $fde12860f08ebfc8$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $fde12860f08ebfc8$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $fde12860f08ebfc8$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $fde12860f08ebfc8$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
// Regex test is based on what's documented here:
// https://hello.atlassian.net/wiki/spaces/I/pages/1124693006/AAID+Format
var $fde12860f08ebfc8$var$isPeopleLink = function isPeopleLink(url) {
    return /^\/people\/[a-zA-Z0-9_\|\-\:]{1,128}$/g.test(url);
};
var $fde12860f08ebfc8$var$getAccountId = function getAccountId(url) {
    var match = url.match(/\/people\/([a-zA-Z0-9_\|\-\:]{1,128})/);
    return match ? match[1] : null;
};
var $fde12860f08ebfc8$var$mentionLinks = function mentionLinks(state) {
    var tokens = [];
    var _iterator = $fde12860f08ebfc8$var$_createForOfIteratorHelper(state.tokens), _step;
    try {
        var _loop = function _loop() {
            var _token$children;
            var token = _step.value;
            var tokenChildren = [];
            // We're only looking for inline children
            if (token.type !== 'inline' || token.children && (token === null || token === void 0 || (_token$children = token.children) === null || _token$children === void 0 ? void 0 : _token$children.length) <= 0) {
                tokens.push(token);
                return 1; // continue
            }
            if (token.children) token.children.forEach(function(childToken, i) {
                var _childToken$attrGet, _tokenChildren, _tokenChildren2;
                var url = (_childToken$attrGet = childToken.attrGet('href')) !== null && _childToken$attrGet !== void 0 ? _childToken$attrGet : '';
                var discardedToken = [
                    'link_close',
                    'text'
                ].includes(childToken.type) && [
                    (_tokenChildren = tokenChildren[i - 1]) === null || _tokenChildren === void 0 ? void 0 : _tokenChildren.type,
                    (_tokenChildren2 = tokenChildren[i - 2]) === null || _tokenChildren2 === void 0 ? void 0 : _tokenChildren2.type
                ].includes('mention');
                // Discarded tokens are preserved as `null` so index
                // cross-referencing between processed and raw tokens may
                // be preserved, however null are filtered out later.
                if (discardedToken) {
                    tokenChildren.push(null);
                    return;
                }
                if (childToken.type === 'link_open' && $fde12860f08ebfc8$var$isPeopleLink(url)) {
                    var _token$children$conte, _token$children2;
                    var mentionText = (_token$children$conte = (_token$children2 = token.children) === null || _token$children2 === void 0 || (_token$children2 = _token$children2[i + 1]) === null || _token$children2 === void 0 ? void 0 : _token$children2.content) !== null && _token$children$conte !== void 0 ? _token$children$conte : '';
                    var mentionToken = new state.Token('mention', '', 0);
                    mentionToken.content = '';
                    mentionToken.block = false;
                    mentionToken.level = childToken.level;
                    mentionToken.attrSet('id', "".concat($fde12860f08ebfc8$var$getAccountId(url)));
                    if (mentionText) mentionToken.attrSet('text', "@".concat(mentionText));
                    tokenChildren.push(mentionToken);
                    return;
                }
                tokenChildren.push(childToken);
            });
            var filteredTokenChildren = tokenChildren.filter(function(childToken) {
                return childToken !== null;
            });
            token.children = filteredTokenChildren;
            tokens.push(token);
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            if (_loop()) continue;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    state.tokens = tokens;
    return;
};
var $fde12860f08ebfc8$export$2e2bcd8739ae039 = function(md) {
    return md.core.ruler.push('mention', $fde12860f08ebfc8$var$mentionLinks);
};

});

parcelRegister("9Pv4k", function(module, exports) {
$parcel$export(module.exports, "createSmartLinksPlugin", function () { return $7280fa1321053f92$export$9625a798761643ac; });

var $7CMz9 = parcelRequire("7CMz9");

var $9Mgjd = parcelRequire("9Mgjd");
function $7280fa1321053f92$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $7280fa1321053f92$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $7280fa1321053f92$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7280fa1321053f92$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7280fa1321053f92$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $7280fa1321053f92$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $7280fa1321053f92$var$linkPatternStart = '\\bhttps?:\\/\\/(?:www\\.)?';
var $7280fa1321053f92$var$linkPatternEnd = '[^\\s\\]\\)]*';
// If we want to re-introduce canva support, please use the regex from this
// PR which was made redundant: https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/135407/commits/0fcf626f035396cfcb87153a4d8d4721c844b07a#platform%2Fpackages%2Fai-mate%2Fconversation-assistant%2Fsrc%2Fcommon%2Futils%2Fcontent-transformer%2Fmd-tokenizer%2Fmd-plugin-smartlink%2Findex.ts
// Right now the support is dropped in favour of supporting what the Canva Agent needs.
// It's likely first-class Enhanced Smart links  (e.g `(my canva link "smartCard-embed")[http://some.canva.link]`
// will be how we support this in the future
var $7280fa1321053f92$var$linkRegex = {
    youtube: "".concat($7280fa1321053f92$var$linkPatternStart, "youtube\\.com").concat($7280fa1321053f92$var$linkPatternEnd),
    youtubeShortUrl: "".concat($7280fa1321053f92$var$linkPatternStart, "youtu\\.be").concat($7280fa1321053f92$var$linkPatternEnd),
    loomVideo: "".concat($7280fa1321053f92$var$linkPatternStart, "loom\\.com\\/share\\/").concat($7280fa1321053f92$var$linkPatternEnd),
    figmaFile: "".concat($7280fa1321053f92$var$linkPatternStart, "figma\\.com\\/file\\/").concat($7280fa1321053f92$var$linkPatternEnd),
    confluenceWhiteboard: "".concat($7280fa1321053f92$var$linkPatternStart, ".*\\/wiki\\/spaces\\/.*\\/whiteboard\\/").concat($7280fa1321053f92$var$linkPatternEnd),
    googleDoc: "".concat($7280fa1321053f92$var$linkPatternStart, "docs\\.google\\.com\\/(document|presentation|spreadsheets)\\/d\\/").concat($7280fa1321053f92$var$linkPatternEnd),
    googleForm: "".concat($7280fa1321053f92$var$linkPatternStart, "docs\\.google\\.com\\/forms\\/d\\/").concat($7280fa1321053f92$var$linkPatternEnd),
    microsoftForm: "".concat($7280fa1321053f92$var$linkPatternStart, "forms\\.office\\.com\\/Pages\\/ResponsePage\\.aspx\\?id\\=").concat($7280fa1321053f92$var$linkPatternEnd),
    analyticsChart: "\\bhttps://[^.]+\\.(atlassian\\.net|jira-dev\\.com)/analytics/[^/]+/chart-".concat($7280fa1321053f92$var$linkPatternEnd)
};
var $7280fa1321053f92$var$supportedEmbedProviders = Object.values($7280fa1321053f92$var$linkRegex).join('|');
var $7280fa1321053f92$var$embedRegex = new RegExp($7280fa1321053f92$var$supportedEmbedProviders, 'g');
var $7280fa1321053f92$var$embedInlineRegex = [
    "".concat($7280fa1321053f92$var$linkPatternStart, "avp-rovo-skills\\.[-\\w]+.frontend.public.atl-paas.net/v1/chart[^\\s\\)]+").concat($7280fa1321053f92$var$linkPatternEnd)
];
var $7280fa1321053f92$var$createSmartLinks = function createSmartLinks(_ref) {
    var regexStorage = _ref.regexStorage;
    return function(state) {
        var _embedMatches;
        var tokens = [];
        var embedTokens = [];
        var embedMatches = [];
        var filteredTokens = [];
        var _iterator = $7280fa1321053f92$var$_createForOfIteratorHelper(state.tokens), _step;
        try {
            var _loop = function _loop() {
                var _token$content;
                var token = _step.value;
                var processedTokenChildren = [];
                embedMatches = [].concat((0, $7CMz9.default)(embedMatches), (0, $7CMz9.default)(new Set((_token$content = token.content) === null || _token$content === void 0 ? void 0 : _token$content.trim().match($7280fa1321053f92$var$embedRegex))));
                // Any block or embed Smart Card links will be in an "inline" token. If
                // the current token is anything other than "inline", or there's no child tokens
                // to process, then we add it to the list of tokens to keep and move forward
                if (token.type !== 'inline' || !token.children) {
                    tokens.push(token);
                    return 1; // continue
                }
                outputToken = new state.Token('inline', '', 0);
                var tokensToAppend = [
                    outputToken
                ];
                if (token.children) {
                    var discardUntilIndex = -1;
                    token.children.forEach(function(childToken, i) {
                        var _childToken$attrGet, _token$children;
                        var discardedToken = i <= discardUntilIndex && [
                            'link_close',
                            'text'
                        ].includes(childToken.type);
                        if (discardedToken) return;
                        var url = (_childToken$attrGet = childToken.attrGet('href')) !== null && _childToken$attrGet !== void 0 ? _childToken$attrGet : '';
                        var isInlineLink = url === ((_token$children = token.children) === null || _token$children === void 0 || (_token$children = _token$children[i + 1]) === null || _token$children === void 0 ? void 0 : _token$children.content);
                        if ((childToken === null || childToken === void 0 ? void 0 : childToken.type) === 'link_open' && ((0, $9Mgjd.isSupportedByLinkingPlatform)(url, regexStorage) || isInlineLink)) {
                            // Discard the next two tokens. We're now processing the opening node for a URL
                            // that will result in a new node that replaces it, therefore the subsequent link content and
                            // closing node are no longer needed
                            discardUntilIndex = i + 2;
                            if (token.level <= 1 && $7280fa1321053f92$var$embedInlineRegex.some(function(r) {
                                return url.match(r);
                            })) {
                                outputToken.children = processedTokenChildren;
                                tokensToAppend.push(new state.Token('paragraph_close', '', 0));
                                processedTokenChildren = [];
                                var embedToken = new state.Token('embedCard', '', 0);
                                embedToken.content = '';
                                embedToken.block = true;
                                embedToken.attrSet('url', url);
                                embedToken.attrSet('layout', 'center');
                                tokensToAppend.push(embedToken);
                                tokensToAppend.push(new state.Token('paragraph_open', '', 0));
                                outputToken = new state.Token('inline', '', 0);
                                tokensToAppend.push(outputToken);
                                return;
                            }
                            var cardToken = new state.Token('inlineCard', '', 0);
                            cardToken.content = '';
                            cardToken.block = false;
                            cardToken.level = childToken.level;
                            cardToken.attrSet('url', url);
                            processedTokenChildren.push(cardToken);
                            return;
                        }
                        processedTokenChildren.push(childToken);
                    });
                }
                outputToken.children = processedTokenChildren;
                var blockTokensWithContent = tokensToAppend.filter(function(t) {
                    var _t$children;
                    return t.type !== 'inline' || ((_t$children = t.children) === null || _t$children === void 0 ? void 0 : _t$children.length);
                });
                tokens.push.apply(tokens, (0, $7CMz9.default)(blockTokensWithContent));
            }, outputToken;
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                if (_loop()) continue;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        for(var i = 0; i < tokens.length; i++)if (i < tokens.length - 1 && tokens[i].type === 'paragraph_open' && tokens[i + 1].type === 'paragraph_close') i = i + 1;
        else filteredTokens.push(tokens[i]);
        if ((_embedMatches = embedMatches) !== null && _embedMatches !== void 0 && _embedMatches.length) (0, $7CMz9.default)(new Set(embedMatches)).forEach(function(match) {
            var embedToken = new state.Token('embedCard', '', 0);
            embedToken.content = '';
            embedToken.block = true;
            embedToken.attrSet('url', match);
            embedToken.attrSet('layout', 'center');
            embedTokens.push(embedToken);
        });
        state.tokens = [].concat(filteredTokens, embedTokens);
        return;
    };
};
var $7280fa1321053f92$export$9625a798761643ac = function createSmartLinksPlugin(params) {
    return function(md) {
        return md.core.ruler.push('inlineCard', $7280fa1321053f92$var$createSmartLinks(params));
    };
};

});
parcelRegister("9Mgjd", function(module, exports) {
$parcel$export(module.exports, "isSupportedByLinkingPlatform", function () { return $71e53f630dc5e5af$export$4b1056d02426889c; });

var $7CMz9 = parcelRequire("7CMz9");

var $a82E7 = parcelRequire("a82E7");

var $esAUd = parcelRequire("esAUd");

var $dWJ7u = parcelRequire("dWJ7u");

var $e7G1e = parcelRequire("e7G1e");
var $71e53f630dc5e5af$export$4b1056d02426889c = function isSupportedByLinkingPlatform(url, regexStorage) {
    var cachedProviderRegex = $71e53f630dc5e5af$export$90caa0c170ea581(regexStorage);
    if (!cachedProviderRegex.length || !url.length) return false;
    var regexPattern = new RegExp(cachedProviderRegex, 'g');
    return regexPattern.test(url);
};
var $71e53f630dc5e5af$export$90caa0c170ea581 = function getProviderRegexFromLs(regexStorage) {
    if (regexStorage.getItem((0, $e7G1e.LS_PROVIDER_KEY))) return JSON.parse("".concat(regexStorage.getItem((0, $e7G1e.LS_PROVIDER_KEY))));
    return '';
};
var $71e53f630dc5e5af$export$5af966b3aa3b1d83 = function setProviderRegexLs(regexStorage, providerRegex) {
    regexStorage === null || regexStorage === void 0 || regexStorage.setItem((0, $e7G1e.LS_PROVIDER_KEY), JSON.stringify(providerRegex));
};
var $71e53f630dc5e5af$export$d08c351b3b4e4934 = /*#__PURE__*/ function() {
    var _ref = (0, $a82E7.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($esAUd))).mark(function _callee(regexStorage, baseUrl) {
        var providerRegex;
        return (0, (/*@__PURE__*/$parcel$interopDefault($esAUd))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return $71e53f630dc5e5af$export$ab8eaff0f2d596bd(baseUrl);
                case 2:
                    providerRegex = _context.sent;
                    $71e53f630dc5e5af$export$5af966b3aa3b1d83(regexStorage, providerRegex);
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function hydrateLinkingPlatformCache(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();
var $71e53f630dc5e5af$export$b7ac97ae80c7eb5a = function reduceProviderRegex(data) {
    var sources = data.providers.reduce(function(acc, provider) {
        var providerSources = provider.patterns.map(function(pattern) {
            return pattern.source;
        });
        return [].concat((0, $7CMz9.default)(acc), (0, $7CMz9.default)(providerSources));
    }, []);
    return sources.join('|');
};
var $71e53f630dc5e5af$export$ab8eaff0f2d596bd = (0, $dWJ7u.default)(/*#__PURE__*/ (0, $a82E7.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($esAUd))).mark(function _callee2() {
    var baseUrl, response, data, _args2 = arguments;
    return (0, (/*@__PURE__*/$parcel$interopDefault($esAUd))).wrap(function _callee2$(_context2) {
        while(true)switch(_context2.prev = _context2.next){
            case 0:
                baseUrl = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '';
                _context2.prev = 1;
                _context2.next = 4;
                return fetch(baseUrl + (0, $e7G1e.PROVIDERS_API), {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        type: 'resolve'
                    })
                });
            case 4:
                response = _context2.sent;
                _context2.next = 7;
                return response.json();
            case 7:
                data = _context2.sent;
                return _context2.abrupt("return", !data ? '' : $71e53f630dc5e5af$export$b7ac97ae80c7eb5a(data));
            case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](1);
                return _context2.abrupt("return", '');
            case 14:
            case "end":
                return _context2.stop();
        }
    }, _callee2, null, [
        [
            1,
            11
        ]
    ]);
})));

});
parcelRegister("a82E7", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $75fcb42cea8c7756$export$2e2bcd8739ae039; });
function $75fcb42cea8c7756$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $75fcb42cea8c7756$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $75fcb42cea8c7756$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $75fcb42cea8c7756$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}

});

parcelRegister("esAUd", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $a8704eea2278a85c$var$runtime = (parcelRequire("8CTwP"))();
module.exports = $a8704eea2278a85c$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $a8704eea2278a85c$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $a8704eea2278a85c$var$runtime;
    else Function("r", "regeneratorRuntime = r")($a8704eea2278a85c$var$runtime);
}

});
parcelRegister("8CTwP", function(module, exports) {

var $aJdgT = parcelRequire("aJdgT");

var $jM7Jt = parcelRequire("jM7Jt");

var $govlt = parcelRequire("govlt");

var $4G0eq = parcelRequire("4G0eq");

var $kt5KI = parcelRequire("kt5KI");

var $1lrfx = parcelRequire("1lrfx");

var $5u4qL = parcelRequire("5u4qL");
function $647cf2218b980ae6$var$_regeneratorRuntime() {
    "use strict";
    var r = $jM7Jt(), e = r.m($647cf2218b980ae6$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $5u4qL(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $647cf2218b980ae6$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $aJdgT(r, e);
            },
            AsyncIterator: $kt5KI,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $4G0eq : $govlt)(a(r), e, t, o, u);
            },
            keys: $1lrfx,
            values: $5u4qL
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $647cf2218b980ae6$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aJdgT", function(module, exports) {
function $7cf866c6b89b743e$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $7cf866c6b89b743e$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("jM7Jt", function(module, exports) {

var $9yZlS = parcelRequire("9yZlS");
function $03b71ad4a597dc76$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $9yZlS(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($9yZlS(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $9yZlS(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $9yZlS(u, "constructor", GeneratorFunctionPrototype), $9yZlS(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $9yZlS(GeneratorFunctionPrototype, o, "GeneratorFunction"), $9yZlS(u), $9yZlS(u, o, "Generator"), $9yZlS(u, n, function() {
        return this;
    }), $9yZlS(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $03b71ad4a597dc76$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $03b71ad4a597dc76$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("9yZlS", function(module, exports) {
function $6f66e140db708363$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $6f66e140db708363$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        if (r) i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n;
        else {
            var o = function o(r, n) {
                $6f66e140db708363$var$_regeneratorDefine(e, r, function(e) {
                    return this._invoke(r, n, e);
                });
            };
            o("next", 0), o("throw", 1), o("return", 2);
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $6f66e140db708363$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $6f66e140db708363$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("govlt", function(module, exports) {

var $4G0eq = parcelRequire("4G0eq");
function $bef733be7495db5a$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $4G0eq(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $bef733be7495db5a$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("4G0eq", function(module, exports) {

var $jM7Jt = parcelRequire("jM7Jt");

var $kt5KI = parcelRequire("kt5KI");
function $367b43b07f5a31f2$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $kt5KI($jM7Jt().w(r, e, t, o), n || Promise);
}
module.exports = $367b43b07f5a31f2$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kt5KI", function(module, exports) {

var $aJdgT = parcelRequire("aJdgT");

var $9yZlS = parcelRequire("9yZlS");
function $ee6afa69f61191ad$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $aJdgT ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($9yZlS($ee6afa69f61191ad$var$AsyncIterator.prototype), $9yZlS($ee6afa69f61191ad$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $9yZlS(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $ee6afa69f61191ad$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("1lrfx", function(module, exports) {
function $0face3ce903781bc$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $0face3ce903781bc$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5u4qL", function(module, exports) {

var $detnK = parcelRequire("detnK");
var $3fe330e993184481$var$_typeof = $detnK.default;
function $3fe330e993184481$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($3fe330e993184481$var$_typeof(e) + " is not iterable");
}
module.exports = $3fe330e993184481$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("detnK", function(module, exports) {
function $9a235fd6667f6a4f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $9a235fd6667f6a4f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $9a235fd6667f6a4f$var$_typeof(o);
}
module.exports = $9a235fd6667f6a4f$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("e7G1e", function(module, exports) {
$parcel$export(module.exports, "PROVIDERS_API", function () { return $a4825037d35c848c$export$57ad190cdc563df3; });
$parcel$export(module.exports, "LS_PROVIDER_KEY", function () { return $a4825037d35c848c$export$56bec2f197c16818; });
var $a4825037d35c848c$export$57ad190cdc563df3 = "/gateway/api/object-resolver/providers";
var $a4825037d35c848c$export$56bec2f197c16818 = 'aiMateSmartLinkProviders';

});



parcelRegister("6oSt6", function(module, exports) {
$parcel$export(module.exports, "pmToMd", function () { return $4a8f3c3edb5162e4$export$cd54a56af01ba875; });
$parcel$export(module.exports, "mdToPmSchema", function () { return $4a8f3c3edb5162e4$export$eb83d753215c78a2; });
var $4a8f3c3edb5162e4$export$cd54a56af01ba875 = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
var $4a8f3c3edb5162e4$export$eb83d753215c78a2 = {
    blockquote: {
        block: 'blockquote'
    },
    paragraph: {
        block: 'paragraph'
    },
    em: {
        mark: 'em'
    },
    strong: {
        mark: 'strong'
    },
    link: {
        mark: 'link',
        attrs: function attrs(tok) {
            return {
                href: tok.attrGet('href'),
                title: tok.attrGet('title') || null
            };
        }
    },
    table: {
        block: 'table'
    },
    tr: {
        block: 'tableRow'
    },
    th: {
        block: 'tableHeader'
    },
    td: {
        block: 'tableCell'
    },
    s: {
        mark: 'strike'
    },
    task_list: {
        block: 'taskList'
    },
    task_item: {
        block: 'taskItem',
        attrs: function attrs(tok) {
            return {
                state: tok.meta
            };
        }
    },
    hr: {
        node: 'rule'
    },
    heading: {
        block: 'heading',
        attrs: function attrs(tok) {
            return {
                level: +tok.tag.slice(1)
            };
        }
    },
    softbreak: {
        node: 'hardBreak'
    },
    hardbreak: {
        node: 'hardBreak'
    },
    code_block: {
        block: 'codeBlock'
    },
    list_item: {
        block: 'listItem'
    },
    bullet_list: {
        block: 'bulletList'
    },
    code_inline: {
        mark: 'code'
    },
    ordered_list: {
        block: 'orderedList',
        attrs: function attrs(tok) {
            var order = +(tok.attrGet('order') || 1);
            return {
                order: order
            };
        }
    },
    fence: {
        block: 'codeBlock',
        // we trim any whitespaces around language definition
        attrs: function attrs(tok) {
            var _tok$info;
            return {
                language: ((_tok$info = tok.info) === null || _tok$info === void 0 ? void 0 : _tok$info.trim()) || null
            };
        }
    },
    image: {
        node: 'image',
        attrs: function attrs(_tok) {
            return {};
        }
    },
    media_single: {
        block: 'mediaSingle',
        attrs: function attrs() {
            return {};
        }
    },
    media: {
        node: 'media',
        attrs: function attrs(tok) {
            return {
                url: tok.attrGet('url'),
                type: 'external'
            };
        }
    },
    // Enable ADF SmartLinks, produced by our SmartLink MD plugin
    inlineCard: {
        node: 'inlineCard',
        attrs: function attrs(tok) {
            return {
                url: tok.attrGet('url')
            };
        }
    },
    blockCard: {
        node: 'blockCard',
        attrs: function attrs(tok) {
            return {
                url: tok.attrGet('url')
            };
        }
    },
    embedCard: {
        node: 'embedCard',
        attrs: function attrs(tok) {
            return {
                url: tok.attrGet('url')
            };
        }
    },
    // Enable ADF Mentions, produced by our Mentions MD plugin which converts /people links
    mention: {
        node: 'mention',
        attrs: function attrs(tok) {
            return {
                id: tok.attrGet('id'),
                text: tok.attrGet('text'),
                type: 'mention'
            };
        }
    },
    status: {
        node: 'status',
        attrs: function attrs(token) {
            return {
                text: token.attrGet('text'),
                color: token.attrGet('color'),
                localId: token.attrGet('localId')
            };
        }
    }
};

});

parcelRegister("eDDZa", function(module, exports) {
$parcel$export(module.exports, "filterSchemaMapping", function () { return $aa83b983c3f41387$export$155749302793c60c; });
$parcel$export(module.exports, "enableSchemaPlugins", function () { return $aa83b983c3f41387$export$a1cf9d9b96e16789; });

var $6oSt6 = parcelRequire("6oSt6");
var $aa83b983c3f41387$export$155749302793c60c = function filterSchemaMapping(schema, map) {
    return Object.keys(map).reduce(function(newMap, key) {
        var value = map[key];
        var block = value.block || value.node;
        var mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
};
var $aa83b983c3f41387$export$a1cf9d9b96e16789 = function enableSchemaPlugins(md, schema) {
    for(var k in 0, $6oSt6.pmToMd){
        var key = k;
        for(var i in (0, $6oSt6.pmToMd)[key]){
            var idx = i;
            if (schema[key][idx]) md.enable((0, $6oSt6.pmToMd)[key][idx]);
        }
    }
};

});



parcelRegister("icxGd", function(module, exports) {




















module.exports = Promise.all([
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("7JvVy")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("24dYI")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("6Q9o4")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("dy0Zy")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("hQjjs")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("9l0t7")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("9WEDO")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("gFcxC")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("7Q4ht")),
    (parcelRequire("1athW"))((parcelRequire("hwrhg")).resolve("cnEwY"))
]).then(()=>parcelRequire('7uSg7'));

});
parcelRegister("1athW", function(module, exports) {
"use strict";

var $1tHQt = parcelRequire("1tHQt");
module.exports = $1tHQt(function importModule(bundle) {
    return new Promise((resolve, reject)=>{
        // Add a global function to handle when the script loads.
        let globalName = `i${('' + Math.random()).slice(2)}`;
        $parcel$global[globalName] = (m)=>{
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        let cleanup = ()=>{
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        let script = document.createElement('script');
        script.async = true;
        script.type = 'module';
        script.charset = 'utf-8';
        script.textContent = `import * as m from '${bundle}'; ${globalName}(m);`;
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("1tHQt", function(module, exports) {
"use strict";
let $113a82a87c54a561$var$cachedBundles = {};
let $113a82a87c54a561$var$cachedPreloads = {};
let $113a82a87c54a561$var$cachedPrefetches = {};
function $113a82a87c54a561$var$getCache(type) {
    switch(type){
        case 'preload':
            return $113a82a87c54a561$var$cachedPreloads;
        case 'prefetch':
            return $113a82a87c54a561$var$cachedPrefetches;
        default:
            return $113a82a87c54a561$var$cachedBundles;
    }
}
module.exports = function cacheLoader(loader, type) {
    return function(bundle) {
        let cache = $113a82a87c54a561$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});


parcelRegister("hwrhg", function(module, exports) {
$parcel$export(module.exports, "register", function () { return $cc1a958bd304f822$export$6503ec6e8aabbaf; }, function (v) { return $cc1a958bd304f822$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $cc1a958bd304f822$export$f7ad0328861e2f03; }, function (v) { return $cc1a958bd304f822$export$f7ad0328861e2f03 = v; });
var $cc1a958bd304f822$export$6503ec6e8aabbaf;
var $cc1a958bd304f822$export$f7ad0328861e2f03;
"use strict";
var $cc1a958bd304f822$var$mapping = new Map();
function $cc1a958bd304f822$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$cc1a958bd304f822$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $cc1a958bd304f822$var$resolve(id) {
    var resolved = $cc1a958bd304f822$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$cc1a958bd304f822$export$6503ec6e8aabbaf = $cc1a958bd304f822$var$register;
$cc1a958bd304f822$export$f7ad0328861e2f03 = $cc1a958bd304f822$var$resolve;

});




parcelRegister("diVdn", function(module, exports) {
$parcel$export(module.exports, "AISummaryLoadingAnimation", function () { return $2d3789cef31ea748$export$3445570560693912; });
/* ai-summary-loading-animation.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $1AV7c = parcelRequire("1AV7c");

var $5qdCp = parcelRequire("5qdCp");
const $2d3789cef31ea748$export$3445570560693912 = ({ traceResponse: traceResponse })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx2vrvc _1wybdlk8 _syaz1fxt"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1AV7c.RovoIcon), {
                className: (0, $2jatx.default)([
                    "_12l2ftgi"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_vwz4gktf"
                ]),
                children: traceResponse
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qdCp.LoadingDotsAnimation), {})
        ]
    });
};
const $2d3789cef31ea748$var$aiSummaryLoadingAnimationWrapperStyle = null;

});
parcelRegister("1AV7c", function(module, exports) {
$parcel$export(module.exports, "RovoIcon", function () { return $4ecdb20147ef5aca$export$e23ae35269442b4f; });
// Copy of search-ai/src/v2/common/ui/assets/Rovo.svg

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $7VQPk = parcelRequire("7VQPk");
const $4ecdb20147ef5aca$export$e23ae35269442b4f = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", (0, $dPABA._)((0, $6ogO3._)({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M8.96666 0.28204C9.66095 -0.100922 10.5084 -0.0938864 11.197 0.303146L16.6126 3.42764L17.8968 4.16857C18.598 4.57283 19.032 5.32283 19.032 6.1308V13.8618C19.032 14.6729 18.6006 15.4196 17.8973 15.8237L12.8611 18.7293C12.8721 18.6984 12.8826 18.6672 12.8926 18.6358C12.9861 18.3462 13.0357 18.0401 13.0357 17.7272V9.99628C13.0357 8.93422 12.4704 7.95482 11.5484 7.425L10.6181 6.88854L7.79413 5.25997V2.26531C7.79413 2.02934 7.83064 1.79883 7.89972 1.58062C8.06955 1.05249 8.43078 0.595295 8.92495 0.309889L8.92645 0.309025C8.94061 0.300851 8.95409 0.291787 8.96666 0.28204Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M7.26173 1.27069L2.22547 4.17636C1.5222 4.5804 1.09082 5.32709 1.09082 6.13826V13.8692C1.09082 14.6772 1.52475 15.4271 2.22593 15.8314L3.42002 16.5203L8.9258 19.6969C9.61444 20.0939 10.4619 20.1009 11.1561 19.718C11.1687 19.7082 11.1821 19.6992 11.1963 19.6911C11.691 19.4058 12.0528 18.9485 12.2229 18.4201C12.2921 18.2017 12.3287 17.9709 12.3287 17.7347V14.7401L9.41444 13.0594L8.57469 12.5752C7.65284 12.0453 7.08715 11.0657 7.08715 10.0037V2.27277C7.08715 1.96035 7.13657 1.65469 7.2298 1.36539C7.23992 1.33362 7.25057 1.30205 7.26173 1.27069Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.41444 13.0594L3.42002 16.5203L2.22593 15.8314C1.52475 15.4271 1.09082 14.6772 1.09082 13.8692V6.13826C1.09082 5.32709 1.5222 4.5804 2.22547 4.17636L7.26173 1.27069C7.25057 1.30205 7.23992 1.33362 7.2298 1.36539C7.13657 1.65469 7.08715 1.96035 7.08715 2.27277V10.0037C7.08715 11.0657 7.65284 12.0453 8.57469 12.5752L9.41444 13.0594Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M10.6181 6.88854L7.79413 5.25997V2.26531C7.79413 2.02934 7.83064 1.79883 7.89972 1.58062C8.06955 1.05249 8.43078 0.595295 8.92495 0.309889L8.92645 0.309025C8.94061 0.300851 8.95409 0.291787 8.96666 0.28204C9.66095 -0.100922 10.5084 -0.0938864 11.197 0.303146L16.6126 3.42764L10.6181 6.88854Z",
                fill: "#FCA700"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.8968 4.16857L16.6126 3.42764L10.6181 6.88854L11.5484 7.425C12.4704 7.95482 13.0357 8.93422 13.0357 9.99628V17.7272C13.0357 18.0401 12.9861 18.3462 12.8926 18.6358C12.8826 18.6672 12.8721 18.6984 12.8611 18.7293L17.8973 15.8237C18.6006 15.4196 19.032 14.6729 19.032 13.8618V6.1308C19.032 5.32283 18.598 4.57283 17.8968 4.16857Z",
                fill: "#AF59E1"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.41444 13.0594L3.42002 16.5203L8.9258 19.6969C9.61444 20.0939 10.4619 20.1009 11.1561 19.718C11.1687 19.7082 11.1821 19.6992 11.1963 19.6911C11.691 19.4058 12.0528 18.9485 12.2229 18.4201C12.2921 18.2017 12.3287 17.9709 12.3287 17.7347V14.7401L9.41444 13.0594Z",
                fill: "#6A9A23"
            })
        ]
    }));
};

});

parcelRegister("5qdCp", function(module, exports) {
$parcel$export(module.exports, "LoadingDotsAnimation", function () { return $7fd063e3a7878559$export$32ef2855359d928d; });
// Copy of platform/packages/search/search-ai/src/ai-answer-dialog/ai-answer-loading/rovo-generating-animation.tsx

var $7VQPk = parcelRequire("7VQPk");
const $7fd063e3a7878559$export$32ef2855359d928d = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "14",
        height: "20",
        viewBox: "0 0 14 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                cx: "3",
                cy: "14",
                r: "1",
                fill: "#1F69DA",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("animate", {
                    attributeName: "opacity",
                    values: "0;1;1;1;",
                    dur: "0.8s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                cx: "7",
                cy: "14",
                r: "1",
                fill: "#C16CD4",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("animate", {
                    attributeName: "opacity",
                    values: "0;0;1;1;",
                    dur: "0.8s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                cx: "11",
                cy: "14",
                r: "1",
                fill: "#F5A117",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("animate", {
                    attributeName: "opacity",
                    values: "0;0;0;1;",
                    dur: "0.8s",
                    repeatCount: "indefinite",
                    begin: "0s"
                })
            })
        ]
    });
};

});


parcelRegister("1GQzX", function(module, exports) {
$parcel$export(module.exports, "AIAnswerSearchBorder", function () { return $f068296f4beee1cb$export$f2207ab910ac3fa8; });
/* styled.tsx generated by @compiled/babel-plugin v0.28.8 */ // Updated with Confluence prism border (color-blocked) animation

var $6ogO3 = parcelRequire("6ogO3");

var $dPABA = parcelRequire("dPABA");

var $aPnCa = parcelRequire("aPnCa");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
// Outer wrapper for glow effect
const $f068296f4beee1cb$var$GlowWrapper = /*#__PURE__*/ (0, $1oC0p.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $aPnCa._)(_param, [
        "as",
        "style"
    ]);
    const { isLoading: isLoading, isStreaming: isStreaming } = __cmplp, __cmpldp = (0, $aPnCa._)(__cmplp, [
        "isLoading",
        "isStreaming"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, (0, $dPABA._)((0, $6ogO3._)({}, __cmpldp), {
        style: (0, $dPABA._)((0, $6ogO3._)({}, __cmpls), {
            "--_51v2mw": (0, $6ZVlx.default)(__cmplp.isLoading || __cmplp.isStreaming ? "conic-gradient(from 39deg at 50% 50%, #FCA700 0deg, #FCA700 72.69129753112793deg, #6A9A23 72.72729814052582deg, #6A9A23 167.89464354515076deg, #1868DB 167.93063879013062deg, #1868DB 252.66713619232178deg, #AF59E0 252.7031421661377deg, #AF59E0 360deg)" : "transparent"),
            "--_ymerfz": (0, $6ZVlx.default)(__cmplp.isLoading || __cmplp.isStreaming ? "rotateGlow 2s linear infinite" : "none")
        }),
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c1txw _1bsb1osq _2rko1b66 _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _19pk14id _2hwx14id _otyr14id _18u014id _1reo15vq _18m915vq _1kt9b3bt _1mp41ui0 _kfgtqm50 _qnec1nxg _1aukjwcd _1cs8stnw _1g0v1m4m _rfx31b66 _1s6ky832 _16qqrnmq _1dbx1m5u _154p105o _aetrb3bt _18postnw _9v7aidpf _1bqq1mrw _16r21l2m _11fnglyw _1a4fagmp",
            __cmplp.className
        ])
    }));
});
const $f068296f4beee1cb$var$BorderWrapper = /*#__PURE__*/ (0, $1oC0p.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $aPnCa._)(_param, [
        "as",
        "style"
    ]);
    const { isLoading: isLoading, isStreaming: isStreaming } = __cmplp, __cmpldp = (0, $aPnCa._)(__cmplp, [
        "isLoading",
        "isStreaming"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, (0, $dPABA._)((0, $6ogO3._)({}, __cmpldp), {
        style: (0, $dPABA._)((0, $6ogO3._)({}, __cmpls), {
            "--_18md79h": (0, $6ZVlx.default)(__cmplp.isLoading || __cmplp.isStreaming ? "none" : `1px solid ${"var(--ds-border, #091E4224)"}`),
            "--_51v2mw": (0, $6ZVlx.default)(__cmplp.isLoading || __cmplp.isStreaming ? "conic-gradient(from 39deg at 50% 50%, #FCA700 0deg, #FCA700 72.69129753112793deg, #6A9A23 72.72729814052582deg, #6A9A23 167.89464354515076deg, #1868DB 167.93063879013062deg, #1868DB 252.66713619232178deg, #AF59E0 252.7031421661377deg, #AF59E0 360deg)" : "transparent"),
            "--_3cn0js": (0, $6ZVlx.default)(__cmplp.isLoading || __cmplp.isStreaming ? "rotateBorder 2s linear infinite" : "none")
        }),
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _kqswh2mm _2rko1b66 _bfhk1bhr _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _vchhusvi _1reo15vq _18m915vq _1pbykb7n _1bsb1osq _19it1un5 _1kt9b3bt _1mp41ui0 _kfgtqm50 _qnec1nxg _1aukjwcd _1cs8stnw _1g0v1m4m _rfx31b66 _1s6ky832 _16qquh9c _aetrb3bt _z0ai1hup _1qdg1hup _9v7at94y _18postnw _1bqq1mrw _14mj1b66 _1hfk1bhr _1a4fagmp",
            __cmplp.className
        ])
    }));
});
const $f068296f4beee1cb$export$f2207ab910ac3fa8 = ({ isLoading: isLoading, isStreaming: isStreaming, children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)($f068296f4beee1cb$var$GlowWrapper, {
        isLoading: isLoading,
        isStreaming: isStreaming,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)($f068296f4beee1cb$var$BorderWrapper, {
            isLoading: isLoading,
            isStreaming: isStreaming,
            children: children
        })
    });
};
const $f068296f4beee1cb$export$a550342571a01571 = /*#__PURE__*/ (0, $1oC0p.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $aPnCa._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, (0, $dPABA._)((0, $6ogO3._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _19pkpxbi _zulpu2gc _1bsb1osq",
            __cmplp.className
        ])
    }));
});
const $f068296f4beee1cb$export$90ec299a95f41a29 = /*#__PURE__*/ (0, $1oC0p.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $aPnCa._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, (0, $dPABA._)((0, $6ogO3._)({}, __cmplp), {
        style: (0, $dPABA._)((0, $6ogO3._)({}, __cmpls), {
            "--_1cfjque": (0, $6ZVlx.default)(__cmplp.width ? __cmplp.width : "100%"),
            "--_eop49q": (0, $6ZVlx.default)(__cmplp.height ? __cmplp.height : "16px")
        }),
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bsb1q4i _4t3iy8ug _2rkopd34 _11q71pw5 _y44v1sal",
            __cmplp.className
        ])
    }));
});
const $f068296f4beee1cb$export$b6aef1fd050b8edc = /*#__PURE__*/ (0, $1oC0p.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $aPnCa._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, (0, $dPABA._)((0, $6ogO3._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_1e0c1txw _4t3iucft _vchhusvi _ca0q1ejb _u5f31ejb _n3tdidpf _19bv1ejb",
            __cmplp.className
        ])
    }));
});
const $f068296f4beee1cb$export$636ea4c09615ceed = /*#__PURE__*/ (0, $1oC0p.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $aPnCa._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, (0, $dPABA._)((0, $6ogO3._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_18u0v77o _syaz1wmz _11c82smr",
            __cmplp.className
        ])
    }));
});
const $f068296f4beee1cb$export$d2b052e7b4be1756 = /*#__PURE__*/ (0, $1oC0p.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $aPnCa._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, (0, $dPABA._)((0, $6ogO3._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_80omtlke _1e0c1ule",
            __cmplp.className
        ])
    }));
});
const $f068296f4beee1cb$export$e1c22a2ee2645e36 = /*#__PURE__*/ (0, $1oC0p.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $aPnCa._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, (0, $dPABA._)((0, $6ogO3._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_1e0c1ule _t9ec1hke",
            __cmplp.className
        ])
    }));
});
const $f068296f4beee1cb$export$975a268f2c733e4 = /*#__PURE__*/ (0, $1oC0p.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $aPnCa._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, (0, $dPABA._)((0, $6ogO3._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_11q7axro _94n5idpf _1e0c1ule _4t3i1jfw _19pkidpf _2hwxt94y _otyridpf _18u0t94y _kqsw1if8",
            __cmplp.className
        ])
    }));
});
const $f068296f4beee1cb$export$f243da7eac28085c = /*#__PURE__*/ (0, $1oC0p.forwardRef)((_param, __cmplr)=>{
    var { as: C = "div", style: __cmpls } = _param, __cmplp = (0, $aPnCa._)(_param, [
        "as",
        "style"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)(C, (0, $dPABA._)((0, $6ogO3._)({}, __cmplp), {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1y6m _zulpu2gc _ca0qidpf _u5f31ejb _n3tdidpf _19bv1ejb",
            __cmplp.className
        ])
    }));
});

});


parcelRegister("fJkKo", function(module, exports) {
$parcel$export(module.exports, "SearchHelper", function () { return $794877e0f92b060f$export$3a4ead32446b35b2; });

var $cddhv = parcelRequire("cddhv");

var $l45jb = parcelRequire("l45jb");

var $1Q6XY = parcelRequire("1Q6XY");
const $794877e0f92b060f$var$ALGOLIA_APP_ID = "CU5KFWE75C";
const $794877e0f92b060f$var$ALGOLIA_SEARCH_API_KEY = "8cb0497a0549da256319b1b8178e5421";
const $794877e0f92b060f$var$INSIGHTS_URL = `https://insights.algolia.io/1/events`;
const $794877e0f92b060f$var$ATLASSIAN_APPS = [
    "jira",
    "confluence",
    "loom",
    "jira service management",
    "jira product discovery",
    "trello",
    "bitbucket",
    "customer service management",
    "statuspage",
    "rovo",
    "atlas",
    "compass",
    "sourcetree",
    "guard"
];
const $794877e0f92b060f$var$ATLASSIAN_COLLECTIONS = [
    "teamwork collection",
    "strategy collection",
    "service collection",
    "software collection"
];
const $794877e0f92b060f$var$ATLASSIAN_KEYWORDS = [
    "agile",
    "kanban",
    "scrum",
    "devops",
    "it service management",
    "project management",
    "roadmap",
    "git",
    "pricing",
    "cost",
    "billing",
    "atlassian intelligence",
    "statuspage",
    "marketplace",
    "templates",
    "gantt",
    "mcp",
    "tempo"
];
class $794877e0f92b060f$export$3a4ead32446b35b2 {
    init() {
        this.bindAllSearchEvents();
    }
    receiveUpdate(callback) {
        this.callback = callback;
    }
    bindAllSearchEvents() {
        const onSearchComplete = (results)=>{
            this.callback(results);
        };
        this.helper.on("result", function({ results: results }) {
            onSearchComplete(results);
        });
    }
    goToNextPage() {
        this.helper.nextPage();
        this.helper.search();
    }
    search() {
        this.helper.search();
    }
    async sendClickEvent({ objectId: objectId, position: position, queryId: queryId, userToken: userToken }) {
        const eventData = {
            events: [
                {
                    eventType: "click",
                    eventName: "Result clicked after search on search page",
                    index: this.searchIndex,
                    userToken: userToken,
                    objectIDs: [
                        objectId
                    ],
                    positions: [
                        position
                    ],
                    queryID: queryId
                }
            ]
        };
        try {
            const response = await fetch($794877e0f92b060f$var$INSIGHTS_URL, {
                method: "POST",
                headers: {
                    "X-Algolia-Application-Id": $794877e0f92b060f$var$ALGOLIA_APP_ID,
                    "X-Algolia-API-Key": $794877e0f92b060f$var$ALGOLIA_SEARCH_API_KEY,
                    "Content-Type": "text/plain;charset=UTF-8"
                },
                body: JSON.stringify(eventData)
            });
            if (!response.ok) throw new Error(`Error: Failed to send event to algolia : ${response.statusText}`);
        } catch (error) {
            console.error("Failed to send event to algolia:", error);
        }
    }
    removeFacet(facetKey) {
        this.helper.removeFacetRefinement(facetKey);
    }
    setFacet(facetKey, facet) {
        this.helper.removeFacetRefinement(facetKey);
        return this.helper.addFacetRefinement(facetKey, facet);
    }
    setQuery(params) {
        return this.helper.setQuery(params);
    }
    setQueryParameter(parameter, value) {
        // @ts-expect-error - restrictSearchableAttributes and other Algolia parameters
        return this.helper.setQueryParameter(parameter, value);
    }
    removeQueryParameter(parameter) {
        // @ts-expect-error - restrictSearchableAttributes and other Algolia parameters
        return this.helper.setQueryParameter(parameter, undefined);
    }
    /**
   * Get the named entity query for a specific parameter.
   * Extracts specific keywords from query if it's longer than 3 words.
   * This helps to improve search accuracy for named entities, instead of lot of filler words.
   */ getNamedEntityQuery(query) {
        const lowerCaseQuery = query.toLowerCase();
        const words = lowerCaseQuery.split(" ");
        if (words.length <= 3) return query;
        const namedEntities = [
            ...$794877e0f92b060f$var$ATLASSIAN_APPS,
            ...$794877e0f92b060f$var$ATLASSIAN_COLLECTIONS,
            ...$794877e0f92b060f$var$ATLASSIAN_KEYWORDS
        ];
        let returnQuery = undefined;
        for (const entity of namedEntities)if (lowerCaseQuery.includes(entity)) returnQuery ? returnQuery += " " + entity : returnQuery = entity;
        return returnQuery;
    }
    constructor(searchIndex, facets){
        this.searchIndex = searchIndex;
        const algoliaSearchClient = (0, $cddhv.default)($794877e0f92b060f$var$ALGOLIA_APP_ID, $794877e0f92b060f$var$ALGOLIA_SEARCH_API_KEY);
        const isAnalyticsEnabled = (0, $1Q6XY.shouldEnableAlgoliaAnalytics)();
        this.helper = (0, (/*@__PURE__*/$parcel$interopDefault($l45jb)))(algoliaSearchClient, this.searchIndex, {
            // @ts-ignore - facet functionality
            facets: facets,
            clickAnalytics: isAnalyticsEnabled,
            // enables click analytics
            attributesToRetrieve: [
                "url",
                "title",
                "description",
                "locale",
                "category",
                "objectID"
            ]
        });
        this.init();
    }
}

});
parcelRegister("l45jb", function(module, exports) {
'use strict';

var $3GvrD = parcelRequire("3GvrD");

var $gCDjz = parcelRequire("gCDjz");

var $BVx8G = parcelRequire("BVx8G");

var $ayZKS = parcelRequire("ayZKS");

var $iT6vY = parcelRequire("iT6vY");
/**
 * The algoliasearchHelper module is the function that will let its
 * contains everything needed to use the Algoliasearch
 * Helper. It is a also a function that instanciate the helper.
 * To use the helper, you also need the Algolia JS client v3.
 * @example
 * //using the UMD build
 * var client = algoliasearch('latency', '6be0576ff61c053d5f9a3225e2a90f76');
 * var helper = algoliasearchHelper(client, 'bestbuy', {
 *   facets: ['shipping'],
 *   disjunctiveFacets: ['category']
 * });
 * helper.on('result', function(event) {
 *   console.log(event.results);
 * });
 * helper
 *   .toggleFacetRefinement('category', 'Movies & TV Shows')
 *   .toggleFacetRefinement('shipping', 'Free shipping')
 *   .search();
 * @example
 * // The helper is an event emitter using the node API
 * helper.on('result', updateTheResults);
 * helper.once('result', updateTheResults);
 * helper.removeListener('result', updateTheResults);
 * helper.removeAllListeners('result');
 * @module algoliasearchHelper
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the name of the index to query
 * @param  {SearchParameters|object} opts an object defining the initial config of the search. It doesn't have to be a {SearchParameters}, just an object containing the properties you need from it.
 * @param {SearchResultsOptions|object} searchResultsOptions an object defining the options to use when creating the search results.
 * @return {AlgoliaSearchHelper} The helper instance
 */ function $f55e16d53d740cfc$var$algoliasearchHelper(client, index, opts, searchResultsOptions) {
    return new $3GvrD(client, index, opts, searchResultsOptions);
}

/**
 * The version currently used
 * @member module:algoliasearchHelper.version
 * @type {number}
 */ $f55e16d53d740cfc$var$algoliasearchHelper.version = (parcelRequire("hxPkP"));
/**
 * Constructor for the Helper.
 * @member module:algoliasearchHelper.AlgoliaSearchHelper
 * @type {AlgoliaSearchHelper}
 */ $f55e16d53d740cfc$var$algoliasearchHelper.AlgoliaSearchHelper = $3GvrD;
/**
 * Constructor for the object containing all the parameters of the search.
 * @member module:algoliasearchHelper.SearchParameters
 * @type {SearchParameters}
 */ $f55e16d53d740cfc$var$algoliasearchHelper.SearchParameters = $ayZKS;
/**
 * Constructor for the object containing all the parameters for Recommend.
 * @member module:algoliasearchHelper.RecommendParameters
 * @type {RecommendParameters}
 */ $f55e16d53d740cfc$var$algoliasearchHelper.RecommendParameters = $gCDjz;
/**
 * Constructor for the object containing the results of the search.
 * @member module:algoliasearchHelper.SearchResults
 * @type {SearchResults}
 */ $f55e16d53d740cfc$var$algoliasearchHelper.SearchResults = $iT6vY;
/**
 * Constructor for the object containing the results for Recommend.
 * @member module:algoliasearchHelper.RecommendResults
 * @type {RecommendResults}
 */ $f55e16d53d740cfc$var$algoliasearchHelper.RecommendResults = $BVx8G;
module.exports = $f55e16d53d740cfc$var$algoliasearchHelper;

});
parcelRegister("3GvrD", function(module, exports) {
'use strict';

var $29TQK = parcelRequire("29TQK");

var $4WfaU = parcelRequire("4WfaU");

var $gAun0 = parcelRequire("gAun0");
var $2aedaf985cc91b89$require$escapeFacetValue = $gAun0.escapeFacetValue;

var $4KG3Y = parcelRequire("4KG3Y");

var $9Ycfw = parcelRequire("9Ycfw");

var $gBL4g = parcelRequire("gBL4g");

var $f2mrx = parcelRequire("f2mrx");

var $gCDjz = parcelRequire("gCDjz");

var $BVx8G = parcelRequire("BVx8G");

var $4kZ5r = parcelRequire("4kZ5r");

var $ayZKS = parcelRequire("ayZKS");

var $iT6vY = parcelRequire("iT6vY");

var $gktCn = parcelRequire("gktCn");

var $hxPkP = parcelRequire("hxPkP");
/**
 * Event triggered when a parameter is set or updated
 * @event AlgoliaSearchHelper#event:change
 * @property {object} event
 * @property {SearchParameters} event.state the current parameters with the latest changes applied
 * @property {SearchResults} event.results the previous results received from Algolia. `null` before the first request
 * @example
 * helper.on('change', function(event) {
 *   console.log('The parameters have changed');
 * });
 */ /**
 * Event triggered when a main search is sent to Algolia
 * @event AlgoliaSearchHelper#event:search
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search
 * @property {SearchResults} event.results the results from the previous search. `null` if it is the first search.
 * @example
 * helper.on('search', function(event) {
 *   console.log('Search sent');
 * });
 */ /**
 * Event triggered when a search using `searchForFacetValues` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchForFacetValues
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @property {string} event.facet the facet searched into
 * @property {string} event.query the query used to search in the facets
 * @example
 * helper.on('searchForFacetValues', function(event) {
 *   console.log('searchForFacetValues sent');
 * });
 */ /**
 * Event triggered when a search using `searchOnce` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchOnce
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @example
 * helper.on('searchOnce', function(event) {
 *   console.log('searchOnce sent');
 * });
 */ /**
 * Event triggered when the results are retrieved from Algolia
 * @event AlgoliaSearchHelper#event:result
 * @property {object} event
 * @property {SearchResults} event.results the results received from Algolia
 * @property {SearchParameters} event.state the parameters used to query Algolia. Those might be different from the one in the helper instance (for example if the network is unreliable).
 * @example
 * helper.on('result', function(event) {
 *   console.log('Search results received');
 * });
 */ /**
 * Event triggered when Algolia sends back an error. For example, if an unknown parameter is
 * used, the error can be caught using this event.
 * @event AlgoliaSearchHelper#event:error
 * @property {object} event
 * @property {Error} event.error the error returned by the Algolia.
 * @example
 * helper.on('error', function(event) {
 *   console.log('Houston we got a problem.');
 * });
 */ /**
 * Event triggered when the queue of queries have been depleted (with any result or outdated queries)
 * @event AlgoliaSearchHelper#event:searchQueueEmpty
 * @example
 * helper.on('searchQueueEmpty', function() {
 *   console.log('No more search pending');
 *   // This is received before the result event if we're not expecting new results
 * });
 *
 * helper.search();
 */ /**
 * Initialize a new AlgoliaSearchHelper
 * @class
 * @classdesc The AlgoliaSearchHelper is a class that ease the management of the
 * search. It provides an event based interface for search callbacks:
 *  - change: when the internal search state is changed.
 *    This event contains a {@link SearchParameters} object and the
 *    {@link SearchResults} of the last result if any.
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 *  - error: when the response is an error. This event contains the error returned by the server.
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the index name to query
 * @param  {SearchParameters | object} options an object defining the initial
 * config of the search. It doesn't have to be a {SearchParameters},
 * just an object containing the properties you need from it.
 * @param {SearchResultsOptions|object} searchResultsOptions an object defining the options to use when creating the search results.
 */ function $2aedaf985cc91b89$var$AlgoliaSearchHelper(client, index, options, searchResultsOptions) {
    if (typeof client.addAlgoliaAgent === 'function') client.addAlgoliaAgent('JS Helper (' + $hxPkP + ')');
    this.setClient(client);
    var opts = options || {};
    opts.index = index;
    this.state = $ayZKS.make(opts);
    this.recommendState = new $gCDjz({
        params: opts.recommendState
    });
    this.lastResults = null;
    this.lastRecommendResults = null;
    this._queryId = 0;
    this._recommendQueryId = 0;
    this._lastQueryIdReceived = -1;
    this._lastRecommendQueryIdReceived = -1;
    this.derivedHelpers = [];
    this._currentNbQueries = 0;
    this._currentNbRecommendQueries = 0;
    this._searchResultsOptions = searchResultsOptions;
    this._recommendCache = {};
}
$4KG3Y($2aedaf985cc91b89$var$AlgoliaSearchHelper, $29TQK);
/**
 * Start the search with the parameters set in the state. When the
 * method is called, it triggers a `search` event. The results will
 * be available through the `result` event. If an error occurs, an
 * `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires search
 * @fires result
 * @fires error
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.search = function() {
    this._search({
        onlyWithDerivedHelpers: false
    });
    return this;
};
$2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.searchOnlyWithDerivedHelpers = function() {
    this._search({
        onlyWithDerivedHelpers: true
    });
    return this;
};
/**
 * Sends the recommendation queries set in the state. When the method is
 * called, it triggers a `fetch` event. The results will be available through
 * the `result` event. If an error occurs, an `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires fetch
 * @fires result
 * @fires error
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.recommend = function() {
    this._recommend();
    return this;
};
/**
 * Gets the search query parameters that would be sent to the Algolia Client
 * for the hits
 * @return {object} Query Parameters
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.getQuery = function() {
    var state = this.state;
    return $4kZ5r._getHitsSearchParams(state);
};
/**
 * Start a search using a modified version of the current state. This method does
 * not trigger the helper lifecycle and does not modify the state kept internally
 * by the helper. This second aspect means that the next search call will be the
 * same as a search call before calling searchOnce.
 * @param {object} options can contain all the parameters that can be set to SearchParameters
 * plus the index
 * @param {function} [cb] optional callback executed when the response from the
 * server is back.
 * @return {promise|undefined} if a callback is passed the method returns undefined
 * otherwise it returns a promise containing an object with two keys :
 *  - content with a SearchResults
 *  - state with the state used for the query as a SearchParameters
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the callback API
 * var state = helper.searchOnce({hitsPerPage: 1},
 *   function(error, content, state) {
 *     // if an error occurred it will be passed in error, otherwise its value is null
 *     // content contains the results formatted as a SearchResults
 *     // state is the instance of SearchParameters used for this search
 *   });
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the promise API
 * var state1 = helper.searchOnce({hitsPerPage: 1})
 *                 .then(promiseHandler);
 *
 * function promiseHandler(res) {
 *   // res contains
 *   // {
 *   //   content : SearchResults
 *   //   state   : SearchParameters (the one used for this specific search)
 *   // }
 * }
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.searchOnce = function(options, cb) {
    var tempState = !options ? this.state : this.state.setQueryParameters(options);
    var queries = $4kZ5r._getQueries(tempState.index, tempState);
    // eslint-disable-next-line consistent-this
    var self = this;
    this._currentNbQueries++;
    this.emit('searchOnce', {
        state: tempState
    });
    if (cb) {
        this.client.search(queries).then(function(content) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
            cb(null, new $iT6vY(tempState, content.results), tempState);
        }).catch(function(err) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
            cb(err, null, tempState);
        });
        return undefined;
    }
    return this.client.search(queries).then(function(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        return {
            content: new $iT6vY(tempState, content.results),
            state: tempState,
            _originalResponse: content
        };
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        throw e;
    });
};
/**
 * Start the search for answers with the parameters set in the state.
 * This method returns a promise.
 * @param {Object} options - the options for answers API call
 * @param {string[]} options.attributesForPrediction - Attributes to use for predictions. If empty, `searchableAttributes` is used instead.
 * @param {string[]} options.queryLanguages - The languages in the query. Currently only supports ['en'].
 * @param {number} options.nbHits - Maximum number of answers to retrieve from the Answers Engine. Cannot be greater than 1000.
 *
 * @return {promise} the answer results
 * @deprecated answers is deprecated and will be replaced with new initiatives
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.findAnswers = function(options) {
    // eslint-disable-next-line no-console
    console.warn('[algoliasearch-helper] answers is no longer supported');
    var state = this.state;
    var derivedHelper = this.derivedHelpers[0];
    if (!derivedHelper) return Promise.resolve([]);
    var derivedState = derivedHelper.getModifiedState(state);
    var data = $9Ycfw({
        attributesForPrediction: options.attributesForPrediction,
        nbHits: options.nbHits
    }, {
        params: $f2mrx($4kZ5r._getHitsSearchParams(derivedState), [
            'attributesToSnippet',
            'hitsPerPage',
            'restrictSearchableAttributes',
            'snippetEllipsisText'
        ])
    });
    var errorMessage = 'search for answers was called, but this client does not have a function client.initIndex(index).findAnswers';
    if (typeof this.client.initIndex !== 'function') throw new Error(errorMessage);
    var index = this.client.initIndex(derivedState.index);
    if (typeof index.findAnswers !== 'function') throw new Error(errorMessage);
    return index.findAnswers(derivedState.query, options.queryLanguages, data);
};
/**
 * Structure of each result when using
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * @typedef FacetSearchHit
 * @type {object}
 * @property {string} value the facet value
 * @property {string} highlighted the facet value highlighted with the query string
 * @property {number} count number of occurrence of this facet value
 * @property {boolean} isRefined true if the value is already refined
 */ /**
 * Structure of the data resolved by the
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * promise.
 * @typedef FacetSearchResult
 * @type {object}
 * @property {FacetSearchHit} facetHits the results for this search for facet values
 * @property {number} processingTimeMS time taken by the query inside the engine
 */ /**
 * Search for facet values based on an query and the name of a faceted attribute. This
 * triggers a search and will return a promise. On top of using the query, it also sends
 * the parameters from the state so that the search is narrowed down to only the possible values.
 *
 * See the description of [FacetSearchResult](reference.html#FacetSearchResult)
 * @param {string} facet the name of the faceted attribute
 * @param {string} query the string query for the search
 * @param {number} [maxFacetHits] the maximum number values returned. Should be > 0 and <= 100
 * @param {object} [userState] the set of custom parameters to use on top of the current state. Setting a property to `undefined` removes
 * it in the generated query.
 * @return {promise.<FacetSearchResult>} the results of the search
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.searchForFacetValues = function(facet, query, maxFacetHits, userState) {
    var clientHasSFFV = typeof this.client.searchForFacetValues === 'function';
    var clientHasInitIndex = typeof this.client.initIndex === 'function';
    if (!clientHasSFFV && !clientHasInitIndex && typeof this.client.search !== 'function') throw new Error('search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues');
    var state = this.state.setQueryParameters(userState || {});
    var isDisjunctive = state.isDisjunctiveFacet(facet);
    var algoliaQuery = $4kZ5r.getSearchForFacetQuery(facet, query, maxFacetHits, state);
    this._currentNbQueries++;
    // eslint-disable-next-line consistent-this
    var self = this;
    var searchForFacetValuesPromise;
    // newer algoliasearch ^3.27.1 - ~4.0.0
    if (clientHasSFFV) searchForFacetValuesPromise = this.client.searchForFacetValues([
        {
            indexName: state.index,
            params: algoliaQuery
        }
    ]);
    else if (clientHasInitIndex) searchForFacetValuesPromise = this.client.initIndex(state.index).searchForFacetValues(algoliaQuery);
    else {
        // @MAJOR only use client.search
        delete algoliaQuery.facetName;
        searchForFacetValuesPromise = this.client.search([
            {
                type: 'facet',
                facet: facet,
                indexName: state.index,
                params: algoliaQuery
            }
        ]).then(function processResponse(response) {
            return response.results[0];
        });
    }
    this.emit('searchForFacetValues', {
        state: state,
        facet: facet,
        query: query
    });
    return searchForFacetValuesPromise.then(function addIsRefined(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        content = Array.isArray(content) ? content[0] : content;
        content.facetHits.forEach(function(f) {
            f.escapedValue = $2aedaf985cc91b89$require$escapeFacetValue(f.value);
            f.isRefined = isDisjunctive ? state.isDisjunctiveFacetRefined(facet, f.escapedValue) : state.isFacetRefined(facet, f.escapedValue);
        });
        return content;
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        throw e;
    });
};
/**
 * Sets the text query used for the search.
 *
 * This method resets the current page to 0.
 * @param  {string} q the user query
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.setQuery = function(q) {
    this._change({
        state: this.state.resetPage().setQuery(q),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the types of refinements except tags. A string can be provided to remove
 * only the refinements of a specific attribute. For more advanced use case, you can
 * provide a function instead. This function should follow the
 * [clearCallback definition](#SearchParameters.clearCallback).
 *
 * This method resets the current page to 0.
 * @param {string} [name] optional name of the facet / attribute on which we want to remove all refinements
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * // Removing all the refinements
 * helper.clearRefinements().search();
 * @example
 * // Removing all the filters on a the category attribute.
 * helper.clearRefinements('category').search();
 * @example
 * // Removing only the exclude filters on the category facet.
 * helper.clearRefinements(function(value, attribute, type) {
 *   return type === 'exclude' && attribute === 'category';
 * }).search();
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.clearRefinements = function(name) {
    this._change({
        state: this.state.resetPage().clearRefinements(name),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the tag filters.
 *
 * This method resets the current page to 0.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.clearTags = function() {
    this._change({
        state: this.state.resetPage().clearTags(),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addDisjunctiveFacetRefinement}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addDisjunctiveRefine = function() {
    return this.addDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Adds a refinement on a hierarchical facet. It will throw
 * an exception if the facet is not defined or if the facet
 * is already refined.
 *
 * This method resets the current page to 0.
 * @param {string} facet the facet name
 * @param {string} path the hierarchical facet path
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is refined
 * @chainable
 * @fires change
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addHierarchicalFacetRefinement = function(facet, path) {
    this._change({
        state: this.state.resetPage().addHierarchicalFacetRefinement(facet, path),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} operator the operator of the filter
 * @param  {number} value the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().addNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetRefinement}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addRefine = function() {
    return this.addFacetRefinement.apply(this, arguments);
};
/**
 * Adds a an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().addExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetExclusion}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addExclude = function() {
    return this.addFacetExclusion.apply(this, arguments);
};
/**
 * Adds a tag filter with the `tag` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag the tag to add to the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addTag = function(tag) {
    this._change({
        state: this.state.resetPage().addTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a "frequently bought together" recommendation query.
 *
 * @param {FrequentlyBoughtTogetherQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addFrequentlyBoughtTogether = function(params) {
    this._recommendChange({
        state: this.recommendState.addFrequentlyBoughtTogether(params)
    });
    return this;
};
/**
 * Adds a "related products" recommendation query.
 *
 * @param {RelatedProductsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addRelatedProducts = function(params) {
    this._recommendChange({
        state: this.recommendState.addRelatedProducts(params)
    });
    return this;
};
/**
 * Adds a "trending items" recommendation query.
 *
 * @param {TrendingItemsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addTrendingItems = function(params) {
    this._recommendChange({
        state: this.recommendState.addTrendingItems(params)
    });
    return this;
};
/**
 * Adds a "trending facets" recommendation query.
 *
 * @param {TrendingFacetsQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addTrendingFacets = function(params) {
    this._recommendChange({
        state: this.recommendState.addTrendingFacets(params)
    });
    return this;
};
/**
 * Adds a "looking similar" recommendation query.
 *
 * @param {LookingSimilarQuery} params the parameters for the recommendation
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.addLookingSimilar = function(params) {
    this._recommendChange({
        state: this.recommendState.addLookingSimilar(params)
    });
    return this;
};
/**
 * Removes an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * Some parameters are optional, triggering different behavior:
 *  - if the value is not provided, then all the numeric value will be removed for the
 *  specified attribute/operator couple.
 *  - if the operator is not provided either, then all the numeric filter on this attribute
 *  will be removed.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} [operator] the operator of the filter
 * @param  {number} [value] the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().removeNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeDisjunctiveFacetRefinement}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeDisjunctiveRefine = function() {
    return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Removes the refinement set on a hierarchical facet.
 * @param {string} facet the facet name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is not refined
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeHierarchicalFacetRefinement = function(facet) {
    this._change({
        state: this.state.resetPage().removeHierarchicalFacetRefinement(facet),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetRefinement}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeRefine = function() {
    return this.removeFacetRefinement.apply(this, arguments);
};
/**
 * Removes an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetExclusion}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeExclude = function() {
    return this.removeFacetExclusion.apply(this, arguments);
};
/**
 * Removes a tag filter with the `tag` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove from the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeTag = function(tag) {
    this._change({
        state: this.state.resetPage().removeTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a "frequently bought together" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeFrequentlyBoughtTogether = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "related products" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeRelatedProducts = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "trending items" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeTrendingItems = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "trending facets" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeTrendingFacets = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Removes a "looking similar" recommendation query.
 *
 * @param {number} id identifier of the recommendation widget
 * @returns {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.removeLookingSimilar = function(id) {
    this._recommendChange({
        state: this.recommendState.removeParams(id)
    });
    return this;
};
/**
 * Adds or removes an exclusion filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.toggleFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleExcludeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetExclusion}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.toggleExclude = function() {
    return this.toggleFacetExclusion.apply(this, arguments);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 * @deprecated since version 2.19.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.toggleRefinement = function(facet, value) {
    return this.toggleFacetRefinement(facet, value);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.toggleFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.toggleRefine = function() {
    return this.toggleFacetRefinement.apply(this, arguments);
};
/**
 * Adds or removes a tag filter with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove or add
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.toggleTag = function(tag) {
    this._change({
        state: this.state.resetPage().toggleTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Increments the page number by one.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setPage(0).nextPage().getPage();
 * // returns 1
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.nextPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page + 1);
};
/**
 * Decrements the page number by one.
 * @fires change
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @example
 * helper.setPage(1).previousPage().getPage();
 * // returns 0
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.previousPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page - 1);
};
/**
 * @private
 * @param {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @fires change
 */ function $2aedaf985cc91b89$var$setCurrentPage(page) {
    if (page < 0) throw new Error('Page requested below 0.');
    this._change({
        state: this.state.setPage(page),
        isPageReset: false
    });
    return this;
}
/**
 * Change the current page
 * @deprecated
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.setCurrentPage = $2aedaf985cc91b89$var$setCurrentPage;
/**
 * Updates the current page.
 * @function
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.setPage = $2aedaf985cc91b89$var$setCurrentPage;
/**
 * Updates the name of the index that will be targeted by the query.
 *
 * This method resets the current page to 0.
 * @param {string} name the index name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.setIndex = function(name) {
    this._change({
        state: this.state.resetPage().setIndex(name),
        isPageReset: true
    });
    return this;
};
/**
 * Update a parameter of the search. This method reset the page
 *
 * The complete list of parameters is available on the
 * [Algolia website](https://www.algolia.com/doc/rest#query-an-index).
 * The most commonly used parameters have their own [shortcuts](#query-parameters-shortcuts)
 * or benefit from higher-level APIs (all the kind of filters and facets have their own API)
 *
 * This method resets the current page to 0.
 * @param {string} parameter name of the parameter to update
 * @param {any} value new value of the parameter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setQueryParameter('hitsPerPage', 20).search();
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.setQueryParameter = function(parameter, value) {
    this._change({
        state: this.state.resetPage().setQueryParameter(parameter, value),
        isPageReset: true
    });
    return this;
};
/**
 * Set the whole state (warning: will erase previous state)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.setState = function(newState) {
    this._change({
        state: $ayZKS.make(newState),
        isPageReset: false
    });
    return this;
};
/**
 * Override the current state without triggering a change event.
 * Do not use this method unless you know what you are doing. (see the example
 * for a legit use case)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @example
 *  helper.on('change', function(state){
 *    // In this function you might want to find a way to store the state in the url/history
 *    updateYourURL(state)
 *  })
 *  window.onpopstate = function(event){
 *    // This is naive though as you should check if the state is really defined etc.
 *    helper.overrideStateWithoutTriggeringChangeEvent(event.state).search()
 *  }
 * @chainable
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.overrideStateWithoutTriggeringChangeEvent = function(newState) {
    this.state = new $ayZKS(newState);
    return this;
};
/**
 * Check if an attribute has any numeric, conjunctive, disjunctive or hierarchical filters.
 * @param {string} attribute the name of the attribute
 * @return {boolean} true if the attribute is filtered by at least one value
 * @example
 * // hasRefinements works with numeric, conjunctive, disjunctive and hierarchical filters
 * helper.hasRefinements('price'); // false
 * helper.addNumericRefinement('price', '>', 100);
 * helper.hasRefinements('price'); // true
 *
 * helper.hasRefinements('color'); // false
 * helper.addFacetRefinement('color', 'blue');
 * helper.hasRefinements('color'); // true
 *
 * helper.hasRefinements('material'); // false
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * helper.hasRefinements('material'); // true
 *
 * helper.hasRefinements('categories'); // false
 * helper.toggleFacetRefinement('categories', 'kitchen > knife');
 * helper.hasRefinements('categories'); // true
 *
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.hasRefinements = function(attribute) {
    if ($gBL4g(this.state.getNumericRefinements(attribute))) return true;
    else if (this.state.isConjunctiveFacet(attribute)) return this.state.isFacetRefined(attribute);
    else if (this.state.isDisjunctiveFacet(attribute)) return this.state.isDisjunctiveFacetRefined(attribute);
    else if (this.state.isHierarchicalFacet(attribute)) return this.state.isHierarchicalFacetRefined(attribute);
    // there's currently no way to know that the user did call `addNumericRefinement` at some point
    // thus we cannot distinguish if there once was a numeric refinement that was cleared
    // so we will return false in every other situations to be consistent
    // while what we should do here is throw because we did not find the attribute in any type
    // of refinement
    return false;
};
/**
 * Check if a value is excluded for a specific faceted attribute. If the value
 * is omitted then the function checks if there is any excluding refinements.
 *
 * @param  {string}  facet name of the attribute for used for faceting
 * @param  {string}  [value] optional value. If passed will test that this value
 * is filtering the given facet.
 * @return {boolean} true if refined
 * @example
 * helper.isExcludeRefined('color'); // false
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // false
 *
 * helper.addFacetExclusion('color', 'red');
 *
 * helper.isExcludeRefined('color'); // true
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // true
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.isExcluded = function(facet, value) {
    return this.state.isExcludeRefined(facet, value);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasRefinements}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.isDisjunctiveRefined = function(facet, value) {
    return this.state.isDisjunctiveFacetRefined(facet, value);
};
/**
 * Check if the string is a currently filtering tag.
 * @param {string} tag tag to check
 * @return {boolean} true if the tag is currently refined
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.hasTag = function(tag) {
    return this.state.isTagRefined(tag);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasTag}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.isTagRefined = function() {
    return this.hasTagRefinements.apply(this, arguments);
};
/**
 * Get the name of the currently used index.
 * @return {string} name of the index
 * @example
 * helper.setIndex('highestPrice_products').getIndex();
 * // returns 'highestPrice_products'
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.getIndex = function() {
    return this.state.index;
};
function $2aedaf985cc91b89$var$getCurrentPage() {
    return this.state.page;
}
/**
 * Get the currently selected page
 * @deprecated
 * @return {number} the current page
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.getCurrentPage = $2aedaf985cc91b89$var$getCurrentPage;
/**
 * Get the currently selected page
 * @function
 * @return {number} the current page
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.getPage = $2aedaf985cc91b89$var$getCurrentPage;
/**
 * Get all the tags currently set to filters the results.
 *
 * @return {string[]} The list of tags currently set.
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.getTags = function() {
    return this.state.tagRefinements;
};
/**
 * Get the list of refinements for a given attribute. This method works with
 * conjunctive, disjunctive, excluding and numerical filters.
 *
 * See also SearchResults#getRefinements
 *
 * @param {string} facetName attribute name used for faceting
 * @return {Array.<FacetRefinement|NumericRefinement>} All Refinement are objects that contain a value, and
 * a type. Numeric also contains an operator.
 * @example
 * helper.addNumericRefinement('price', '>', 100);
 * helper.getRefinements('price');
 * // [
 * //   {
 * //     "value": [
 * //       100
 * //     ],
 * //     "operator": ">",
 * //     "type": "numeric"
 * //   }
 * // ]
 * @example
 * helper.addFacetRefinement('color', 'blue');
 * helper.addFacetExclusion('color', 'red');
 * helper.getRefinements('color');
 * // [
 * //   {
 * //     "value": "blue",
 * //     "type": "conjunctive"
 * //   },
 * //   {
 * //     "value": "red",
 * //     "type": "exclude"
 * //   }
 * // ]
 * @example
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * // [
 * //   {
 * //     "value": "plastic",
 * //     "type": "disjunctive"
 * //   }
 * // ]
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.getRefinements = function(facetName) {
    var refinements = [];
    if (this.state.isConjunctiveFacet(facetName)) {
        var conjRefinements = this.state.getConjunctiveRefinements(facetName);
        conjRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: 'conjunctive'
            });
        });
        var excludeRefinements = this.state.getExcludeRefinements(facetName);
        excludeRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: 'exclude'
            });
        });
    } else if (this.state.isDisjunctiveFacet(facetName)) {
        var disjunctiveRefinements = this.state.getDisjunctiveRefinements(facetName);
        disjunctiveRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: 'disjunctive'
            });
        });
    }
    var numericRefinements = this.state.getNumericRefinements(facetName);
    Object.keys(numericRefinements).forEach(function(operator) {
        var value = numericRefinements[operator];
        refinements.push({
            value: value,
            operator: operator,
            type: 'numeric'
        });
    });
    return refinements;
};
/**
 * Return the current refinement for the (attribute, operator)
 * @param {string} attribute attribute in the record
 * @param {string} operator operator applied on the refined values
 * @return {Array.<number|number[]>} refined values
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.getNumericRefinement = function(attribute, operator) {
    return this.state.getNumericRefinement(attribute, operator);
};
/**
 * Get the current breadcrumb for a hierarchical facet, as an array
 * @param  {string} facetName Hierarchical facet name
 * @return {array.<string>} the path as an array of string
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.getHierarchicalFacetBreadcrumb = function(facetName) {
    return this.state.getHierarchicalFacetBreadcrumb(facetName);
};
// /////////// PRIVATE
/**
 * Perform the underlying queries
 * @private
 * @param {object} options options for the query
 * @param {boolean} [options.onlyWithDerivedHelpers=false] if true, only the derived helpers will be queried
 * @return {undefined} does not return anything
 * @fires search
 * @fires result
 * @fires error
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype._search = function(options) {
    var state = this.state;
    var states = [];
    var mainQueries = [];
    if (!options.onlyWithDerivedHelpers) {
        mainQueries = $4kZ5r._getQueries(state.index, state);
        states.push({
            state: state,
            queriesCount: mainQueries.length,
            helper: this
        });
        this.emit('search', {
            state: state,
            results: this.lastResults
        });
    }
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedState = derivedHelper.getModifiedState(state);
        var derivedStateQueries = derivedState.index ? $4kZ5r._getQueries(derivedState.index, derivedState) : [];
        states.push({
            state: derivedState,
            queriesCount: derivedStateQueries.length,
            helper: derivedHelper
        });
        derivedHelper.emit('search', {
            state: derivedState,
            results: derivedHelper.lastResults
        });
        return derivedStateQueries;
    });
    var queries = Array.prototype.concat.apply(mainQueries, derivedQueries);
    var queryId = this._queryId++;
    this._currentNbQueries++;
    if (!queries.length) return Promise.resolve({
        results: []
    }).then(this._dispatchAlgoliaResponse.bind(this, states, queryId));
    try {
        this.client.search(queries).then(this._dispatchAlgoliaResponse.bind(this, states, queryId)).catch(this._dispatchAlgoliaError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit('error', {
            error: error
        });
    }
    return undefined;
};
$2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype._recommend = function() {
    var searchState = this.state;
    var recommendState = this.recommendState;
    var index = this.getIndex();
    var states = [
        {
            state: recommendState,
            index: index,
            helper: this
        }
    ];
    var ids = recommendState.params.map(function(param) {
        return param.$$id;
    });
    this.emit('fetch', {
        recommend: {
            state: recommendState,
            results: this.lastRecommendResults
        }
    });
    var cache = this._recommendCache;
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedIndex = derivedHelper.getModifiedState(searchState).index;
        if (!derivedIndex) return [];
        // Contrary to what is done when deriving the search state, we don't want to
        // provide the current recommend state to the derived helper, as it would
        // inherit unwanted queries. We instead provide an empty recommend state.
        var derivedState = derivedHelper.getModifiedRecommendState(new $gCDjz());
        states.push({
            state: derivedState,
            index: derivedIndex,
            helper: derivedHelper
        });
        ids = Array.prototype.concat.apply(ids, derivedState.params.map(function(param) {
            return param.$$id;
        }));
        derivedHelper.emit('fetch', {
            recommend: {
                state: derivedState,
                results: derivedHelper.lastRecommendResults
            }
        });
        return derivedState._buildQueries(derivedIndex, cache);
    });
    var queries = Array.prototype.concat.apply(this.recommendState._buildQueries(index, cache), derivedQueries);
    if (queries.length === 0) return;
    if (queries.length > 0 && typeof this.client.getRecommendations === 'undefined') {
        // eslint-disable-next-line no-console
        console.warn('Please update algoliasearch/lite to the latest version in order to use recommend widgets.');
        return;
    }
    var queryId = this._recommendQueryId++;
    this._currentNbRecommendQueries++;
    try {
        this.client.getRecommendations(queries).then(this._dispatchRecommendResponse.bind(this, queryId, states, ids)).catch(this._dispatchRecommendError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit('error', {
            error: error
        });
    }
    return;
};
/**
 * Transform the responses as sent by the server and transform them into a user
 * usable object that merge the results of all the batch requests. It will dispatch
 * over the different helper + derived helpers (when there are some).
 * @private
 * @param {array.<{SearchParameters, AlgoliaQueries, AlgoliaSearchHelper}>} states state used to generate the request
 * @param {number} queryId id of the current request
 * @param {object} content content of the response
 * @return {undefined}
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaResponse = function(states, queryId, content) {
    // eslint-disable-next-line consistent-this
    var self = this;
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    if (this._currentNbQueries === 0) this.emit('searchQueueEmpty');
    var results = content.results.slice();
    states.forEach(function(s) {
        var state = s.state;
        var queriesCount = s.queriesCount;
        var helper = s.helper;
        var specificResults = results.splice(0, queriesCount);
        if (!state.index) {
            helper.emit('result', {
                results: null,
                state: state
            });
            return;
        }
        helper.lastResults = new $iT6vY(state, specificResults, self._searchResultsOptions);
        helper.emit('result', {
            results: helper.lastResults,
            state: state
        });
    });
};
$2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype._dispatchRecommendResponse = function(queryId, states, ids, content) {
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastRecommendQueryIdReceived) // Outdated answer
    return;
    this._currentNbRecommendQueries -= queryId - this._lastRecommendQueryIdReceived;
    this._lastRecommendQueryIdReceived = queryId;
    if (this._currentNbRecommendQueries === 0) this.emit('recommendQueueEmpty');
    var cache = this._recommendCache;
    var idsMap = {};
    ids.filter(function(id) {
        return cache[id] === undefined;
    }).forEach(function(id, index) {
        if (!idsMap[id]) idsMap[id] = [];
        idsMap[id].push(index);
    });
    Object.keys(idsMap).forEach(function(id) {
        var indices = idsMap[id];
        var firstResult = content.results[indices[0]];
        if (indices.length === 1) {
            cache[id] = firstResult;
            return;
        }
        cache[id] = Object.assign({}, firstResult, {
            hits: $gktCn(indices.map(function(idx) {
                return content.results[idx].hits;
            }))
        });
    });
    var results = {};
    ids.forEach(function(id) {
        results[id] = cache[id];
    });
    states.forEach(function(s) {
        var state = s.state;
        var helper = s.helper;
        if (!s.index) {
            // eslint-disable-next-line no-warning-comments
            // TODO: emit "result" event when events for Recommend are implemented
            helper.emit('recommend:result', {
                results: null,
                state: state
            });
            return;
        }
        helper.lastRecommendResults = new $BVx8G(state, results);
        // eslint-disable-next-line no-warning-comments
        // TODO: emit "result" event when events for Recommend are implemented
        helper.emit('recommend:result', {
            recommend: {
                results: helper.lastRecommendResults,
                state: state
            }
        });
    });
};
$2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaError = function(queryId, error) {
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    this.emit('error', {
        error: error
    });
    if (this._currentNbQueries === 0) this.emit('searchQueueEmpty');
};
$2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype._dispatchRecommendError = function(queryId, error) {
    if (queryId < this._lastRecommendQueryIdReceived) // Outdated answer
    return;
    this._currentNbRecommendQueries -= queryId - this._lastRecommendQueryIdReceived;
    this._lastRecommendQueryIdReceived = queryId;
    this.emit('error', {
        error: error
    });
    if (this._currentNbRecommendQueries === 0) this.emit('recommendQueueEmpty');
};
$2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.containsRefinement = function(query, facetFilters, numericFilters, tagFilters) {
    return query || facetFilters.length !== 0 || numericFilters.length !== 0 || tagFilters.length !== 0;
};
/**
 * Test if there are some disjunctive refinements on the facet
 * @private
 * @param {string} facet the attribute to test
 * @return {boolean} true if there are refinements on this attribute
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype._hasDisjunctiveRefinements = function(facet) {
    return this.state.disjunctiveRefinements[facet] && this.state.disjunctiveRefinements[facet].length > 0;
};
$2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype._change = function(event) {
    var state = event.state;
    var isPageReset = event.isPageReset;
    if (state !== this.state) {
        this.state = state;
        this.emit('change', {
            state: this.state,
            results: this.lastResults,
            isPageReset: isPageReset
        });
    }
};
$2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype._recommendChange = function(event) {
    var state = event.state;
    if (state !== this.recommendState) {
        this.recommendState = state;
        // eslint-disable-next-line no-warning-comments
        // TODO: emit "change" event when events for Recommend are implemented
        this.emit('recommend:change', {
            search: {
                results: this.lastResults,
                state: this.state
            },
            recommend: {
                results: this.lastRecommendResults,
                state: this.recommendState
            }
        });
    }
};
/**
 * Clears the cache of the underlying Algolia client.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.clearCache = function() {
    if (this.client.clearCache) this.client.clearCache();
    return this;
};
/**
 * Updates the internal client instance. If the reference of the clients
 * are equal then no update is actually done.
 * @param  {AlgoliaSearch} newClient an AlgoliaSearch client
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.setClient = function(newClient) {
    if (this.client === newClient) return this;
    if (typeof newClient.addAlgoliaAgent === 'function') newClient.addAlgoliaAgent('JS Helper (' + $hxPkP + ')');
    this.client = newClient;
    return this;
};
/**
 * Gets the instance of the currently used client.
 * @return {AlgoliaSearch} the currently used client
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.getClient = function() {
    return this.client;
};
/**
 * Creates an derived instance of the Helper. A derived helper
 * is a way to request other indices synchronised with the lifecycle
 * of the main Helper. This mechanism uses the multiqueries feature
 * of Algolia to aggregate all the requests in a single network call.
 *
 * This method takes a function that is used to create a new SearchParameter
 * that will be used to create requests to Algolia. Those new requests
 * are created just before the `search` event. The signature of the function
 * is `SearchParameters -> SearchParameters`.
 *
 * This method returns a new DerivedHelper which is an EventEmitter
 * that fires the same `search`, `result` and `error` events. Those
 * events, however, will receive data specific to this DerivedHelper
 * and the SearchParameters that is returned by the call of the
 * parameter function.
 * @param {function} fn SearchParameters -> SearchParameters
 * @param {function} recommendFn RecommendParameters -> RecommendParameters
 * @return {DerivedHelper} a new DerivedHelper
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.derive = function(fn, recommendFn) {
    var derivedHelper = new $4WfaU(this, fn, recommendFn);
    this.derivedHelpers.push(derivedHelper);
    return derivedHelper;
};
/**
 * This method detaches a derived Helper from the main one. Prefer using the one from the
 * derived helper itself, to remove the event listeners too.
 * @private
 * @param  {DerivedHelper} derivedHelper the derived helper to detach
 * @return {undefined} nothing is returned
 * @throws Error
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.detachDerivedHelper = function(derivedHelper) {
    var pos = this.derivedHelpers.indexOf(derivedHelper);
    if (pos === -1) throw new Error('Derived helper already detached');
    this.derivedHelpers.splice(pos, 1);
};
/**
 * This method returns true if there is currently at least one on-going search.
 * @return {boolean} true if there is a search pending
 */ $2aedaf985cc91b89$var$AlgoliaSearchHelper.prototype.hasPendingRequests = function() {
    return this._currentNbQueries > 0;
};
/**
 * @typedef AlgoliaSearchHelper.NumericRefinement
 * @type {object}
 * @property {number[]} value the numbers that are used for filtering this attribute with
 * the operator specified.
 * @property {string} operator the faceting data: value, number of entries
 * @property {string} type will be 'numeric'
 */ /**
 * @typedef AlgoliaSearchHelper.FacetRefinement
 * @type {object}
 * @property {string} value the string use to filter the attribute
 * @property {string} type the type of filter: 'conjunctive', 'disjunctive', 'exclude'
 */ module.exports = $2aedaf985cc91b89$var$AlgoliaSearchHelper;

});
parcelRegister("29TQK", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
function $1927bea74447f76b$var$EventEmitter() {
    this._events = this._events || {};
    this._maxListeners = this._maxListeners || undefined;
}
module.exports = $1927bea74447f76b$var$EventEmitter;
// Backwards-compat with node 0.10.x
// EventEmitter.EventEmitter = EventEmitter;
$1927bea74447f76b$var$EventEmitter.prototype._events = undefined;
$1927bea74447f76b$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
$1927bea74447f76b$var$EventEmitter.defaultMaxListeners = 10;
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$1927bea74447f76b$var$EventEmitter.prototype.setMaxListeners = function(n) {
    if (!$1927bea74447f76b$var$isNumber(n) || n < 0 || isNaN(n)) throw TypeError('n must be a positive number');
    this._maxListeners = n;
    return this;
};
$1927bea74447f76b$var$EventEmitter.prototype.emit = function(type) {
    var er, handler, len, args, i, listeners;
    if (!this._events) this._events = {};
    // If there is no 'error' event listener then throw.
    if (type === 'error') {
        if (!this._events.error || $1927bea74447f76b$var$isObject(this._events.error) && !this._events.error.length) {
            er = arguments[1];
            if (er instanceof Error) throw er; // Unhandled 'error' event
            else {
                // At least give some kind of context to the user
                var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
                err.context = er;
                throw err;
            }
        }
    }
    handler = this._events[type];
    if ($1927bea74447f76b$var$isUndefined(handler)) return false;
    if ($1927bea74447f76b$var$isFunction(handler)) switch(arguments.length){
        // fast cases
        case 1:
            handler.call(this);
            break;
        case 2:
            handler.call(this, arguments[1]);
            break;
        case 3:
            handler.call(this, arguments[1], arguments[2]);
            break;
        // slower
        default:
            args = Array.prototype.slice.call(arguments, 1);
            handler.apply(this, args);
    }
    else if ($1927bea74447f76b$var$isObject(handler)) {
        args = Array.prototype.slice.call(arguments, 1);
        listeners = handler.slice();
        len = listeners.length;
        for(i = 0; i < len; i++)listeners[i].apply(this, args);
    }
    return true;
};
$1927bea74447f76b$var$EventEmitter.prototype.addListener = function(type, listener) {
    var m;
    if (!$1927bea74447f76b$var$isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events) this._events = {};
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (this._events.newListener) this.emit('newListener', type, $1927bea74447f76b$var$isFunction(listener.listener) ? listener.listener : listener);
    if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
    else if ($1927bea74447f76b$var$isObject(this._events[type])) // If we've already got an array, just append.
    this._events[type].push(listener);
    else // Adding the second element, need to change to array.
    this._events[type] = [
        this._events[type],
        listener
    ];
    // Check for listener leak
    if ($1927bea74447f76b$var$isObject(this._events[type]) && !this._events[type].warned) {
        if (!$1927bea74447f76b$var$isUndefined(this._maxListeners)) m = this._maxListeners;
        else m = $1927bea74447f76b$var$EventEmitter.defaultMaxListeners;
        if (m && m > 0 && this._events[type].length > m) {
            this._events[type].warned = true;
            console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[type].length);
            if (typeof console.trace === 'function') // not supported in IE 10
            console.trace();
        }
    }
    return this;
};
$1927bea74447f76b$var$EventEmitter.prototype.on = $1927bea74447f76b$var$EventEmitter.prototype.addListener;
$1927bea74447f76b$var$EventEmitter.prototype.once = function(type, listener) {
    if (!$1927bea74447f76b$var$isFunction(listener)) throw TypeError('listener must be a function');
    var fired = false;
    function g() {
        this.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(this, arguments);
        }
    }
    g.listener = listener;
    this.on(type, g);
    return this;
};
// emits a 'removeListener' event iff the listener was removed
$1927bea74447f76b$var$EventEmitter.prototype.removeListener = function(type, listener) {
    var list, position, length, i;
    if (!$1927bea74447f76b$var$isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events || !this._events[type]) return this;
    list = this._events[type];
    length = list.length;
    position = -1;
    if (list === listener || $1927bea74447f76b$var$isFunction(list.listener) && list.listener === listener) {
        delete this._events[type];
        if (this._events.removeListener) this.emit('removeListener', type, listener);
    } else if ($1927bea74447f76b$var$isObject(list)) {
        for(i = length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list.length = 0;
            delete this._events[type];
        } else list.splice(position, 1);
        if (this._events.removeListener) this.emit('removeListener', type, listener);
    }
    return this;
};
$1927bea74447f76b$var$EventEmitter.prototype.removeAllListeners = function(type) {
    var key, listeners;
    if (!this._events) return this;
    // not listening for removeListener, no need to emit
    if (!this._events.removeListener) {
        if (arguments.length === 0) this._events = {};
        else if (this._events[type]) delete this._events[type];
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        for(key in this._events){
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = {};
        return this;
    }
    listeners = this._events[type];
    if ($1927bea74447f76b$var$isFunction(listeners)) this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    while(listeners.length)this.removeListener(type, listeners[listeners.length - 1]);
    delete this._events[type];
    return this;
};
$1927bea74447f76b$var$EventEmitter.prototype.listeners = function(type) {
    var ret;
    if (!this._events || !this._events[type]) ret = [];
    else if ($1927bea74447f76b$var$isFunction(this._events[type])) ret = [
        this._events[type]
    ];
    else ret = this._events[type].slice();
    return ret;
};
$1927bea74447f76b$var$EventEmitter.prototype.listenerCount = function(type) {
    if (this._events) {
        var evlistener = this._events[type];
        if ($1927bea74447f76b$var$isFunction(evlistener)) return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
};
$1927bea74447f76b$var$EventEmitter.listenerCount = function(emitter, type) {
    return emitter.listenerCount(type);
};
function $1927bea74447f76b$var$isFunction(arg) {
    return typeof arg === 'function';
}
function $1927bea74447f76b$var$isNumber(arg) {
    return typeof arg === 'number';
}
function $1927bea74447f76b$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
function $1927bea74447f76b$var$isUndefined(arg) {
    return arg === void 0;
}

});

parcelRegister("4WfaU", function(module, exports) {
'use strict';

var $29TQK = parcelRequire("29TQK");

var $4KG3Y = parcelRequire("4KG3Y");
/**
 * A DerivedHelper is a way to create sub requests to
 * Algolia from a main helper.
 * @class
 * @classdesc The DerivedHelper provides an event based interface for search callbacks:
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 * @param {AlgoliaSearchHelper} mainHelper the main helper
 * @param {function} fn the function to create the derived state for search
 * @param {function} recommendFn the function to create the derived state for recommendations
 */ function $3988599e4fac3619$var$DerivedHelper(mainHelper, fn, recommendFn) {
    this.main = mainHelper;
    this.fn = fn;
    this.recommendFn = recommendFn;
    this.lastResults = null;
    this.lastRecommendResults = null;
}
$4KG3Y($3988599e4fac3619$var$DerivedHelper, $29TQK);
/**
 * Detach this helper from the main helper
 * @return {undefined}
 * @throws Error if the derived helper is already detached
 */ $3988599e4fac3619$var$DerivedHelper.prototype.detach = function() {
    this.removeAllListeners();
    this.main.detachDerivedHelper(this);
};
$3988599e4fac3619$var$DerivedHelper.prototype.getModifiedState = function(parameters) {
    return this.fn(parameters);
};
$3988599e4fac3619$var$DerivedHelper.prototype.getModifiedRecommendState = function(parameters) {
    return this.recommendFn(parameters);
};
module.exports = $3988599e4fac3619$var$DerivedHelper;

});
parcelRegister("4KG3Y", function(module, exports) {
'use strict';
function $375c162507ddaf02$var$inherits(ctor, superCtor) {
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
}
module.exports = $375c162507ddaf02$var$inherits;

});


parcelRegister("gAun0", function(module, exports) {
'use strict';
/**
 * Replaces a leading - with \-
 * @private
 * @param {any} value the facet value to replace
 * @returns {any} the escaped facet value or the value if it was not a string
 */ function $c13790fd71540d48$var$escapeFacetValue(value) {
    if (typeof value !== 'string') return value;
    return String(value).replace(/^-/, '\\-');
}
/**
 * Replaces a leading \- with -
 * @private
 * @param {any} value the escaped facet value
 * @returns {any} the unescaped facet value or the value if it was not a string
 */ function $c13790fd71540d48$var$unescapeFacetValue(value) {
    if (typeof value !== 'string') return value;
    return value.replace(/^\\-/, '-');
}
module.exports = {
    escapeFacetValue: $c13790fd71540d48$var$escapeFacetValue,
    unescapeFacetValue: $c13790fd71540d48$var$unescapeFacetValue
};

});

parcelRegister("9Ycfw", function(module, exports) {
'use strict';
function $74233823bdea52b1$var$clone(value) {
    if (typeof value === 'object' && value !== null) return $74233823bdea52b1$var$_merge(Array.isArray(value) ? [] : {}, value);
    return value;
}
function $74233823bdea52b1$var$isObjectOrArrayOrFunction(value) {
    return typeof value === 'function' || Array.isArray(value) || Object.prototype.toString.call(value) === '[object Object]';
}
function $74233823bdea52b1$var$_merge(target, source) {
    if (target === source) return target;
    // eslint-disable-next-line no-restricted-syntax
    for(var key in source){
        if (!Object.prototype.hasOwnProperty.call(source, key) || key === '__proto__' || key === 'constructor') continue;
        var sourceVal = source[key];
        var targetVal = target[key];
        if (typeof targetVal !== 'undefined' && typeof sourceVal === 'undefined') continue;
        if ($74233823bdea52b1$var$isObjectOrArrayOrFunction(targetVal) && $74233823bdea52b1$var$isObjectOrArrayOrFunction(sourceVal)) target[key] = $74233823bdea52b1$var$_merge(targetVal, sourceVal);
        else target[key] = $74233823bdea52b1$var$clone(sourceVal);
    }
    return target;
}
/**
 * This method is like Object.assign, but recursively merges own and inherited
 * enumerable keyed properties of source objects into the destination object.
 *
 * NOTE: this behaves like lodash/merge, but:
 * - does mutate functions if they are a source
 * - treats non-plain objects as plain
 * - does not work for circular objects
 * - treats sparse arrays as sparse
 * - does not convert Array-like objects (Arguments, NodeLists, etc.) to arrays
 *
 * @param {Object} target The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 */ function $74233823bdea52b1$var$merge(target) {
    if (!$74233823bdea52b1$var$isObjectOrArrayOrFunction(target)) target = {};
    for(var i = 1, l = arguments.length; i < l; i++){
        var source = arguments[i];
        if ($74233823bdea52b1$var$isObjectOrArrayOrFunction(source)) $74233823bdea52b1$var$_merge(target, source);
    }
    return target;
}
module.exports = $74233823bdea52b1$var$merge;

});

parcelRegister("gBL4g", function(module, exports) {
'use strict';
function $c1749cb5df59652a$var$objectHasKeys(obj) {
    return obj && Object.keys(obj).length > 0;
}
module.exports = $c1749cb5df59652a$var$objectHasKeys;

});

parcelRegister("f2mrx", function(module, exports) {
'use strict';
// https://github.com/babel/babel/blob/3aaafae053fa75febb3aa45d45b6f00646e30ba4/packages/babel-helpers/src/helpers.js#L604-L620
function $af2873aa3ca66e72$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source === null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key;
    var i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        // eslint-disable-next-line no-continue
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $af2873aa3ca66e72$var$_objectWithoutPropertiesLoose;

});

parcelRegister("gCDjz", function(module, exports) {
'use strict';
/**
 * RecommendParameters is the data structure that contains all the information
 * usable for getting recommendations from the Algolia API. It doesn't do the
 * search itself, nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It
 * will be provided when needed.
 * @constructor
 * @classdesc contains all the parameters for recommendations
 * @param {RecommendParametersOptions} opts the options to create the object
 */ function $c19eb1007683f876$var$RecommendParameters(opts) {
    opts = opts || {};
    this.params = opts.params || [];
}
$c19eb1007683f876$var$RecommendParameters.prototype = {
    constructor: $c19eb1007683f876$var$RecommendParameters,
    addParams: function(params) {
        var newParams = this.params.slice();
        newParams.push(params);
        return new $c19eb1007683f876$var$RecommendParameters({
            params: newParams
        });
    },
    removeParams: function(id) {
        return new $c19eb1007683f876$var$RecommendParameters({
            params: this.params.filter(function(param) {
                return param.$$id !== id;
            })
        });
    },
    addFrequentlyBoughtTogether: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: 'bought-together'
        }));
    },
    addRelatedProducts: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: 'related-products'
        }));
    },
    addTrendingItems: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: 'trending-items'
        }));
    },
    addTrendingFacets: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: 'trending-facets'
        }));
    },
    addLookingSimilar: function(params) {
        return this.addParams(Object.assign({}, params, {
            model: 'looking-similar'
        }));
    },
    _buildQueries: function(indexName, cache) {
        return this.params.filter(function(params) {
            return cache[params.$$id] === undefined;
        }).map(function(params) {
            var query = Object.assign({}, params, {
                indexName: indexName
            });
            delete query.$$id;
            return query;
        });
    }
};
module.exports = $c19eb1007683f876$var$RecommendParameters;

});

parcelRegister("BVx8G", function(module, exports) {
'use strict';
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {RecommendParameters} state state that led to the response
 * @param {Record<string,RecommendResultItem>} results the results from algolia client
 **/ function $072015c54d94a80e$var$RecommendResults(state, results) {
    this._state = state;
    this._rawResults = {};
    // eslint-disable-next-line consistent-this
    var self = this;
    state.params.forEach(function(param) {
        var id = param.$$id;
        self[id] = results[id];
        self._rawResults[id] = results[id];
    });
}
$072015c54d94a80e$var$RecommendResults.prototype = {
    constructor: $072015c54d94a80e$var$RecommendResults
};
module.exports = $072015c54d94a80e$var$RecommendResults;

});

parcelRegister("4kZ5r", function(module, exports) {
'use strict';

var $9Ycfw = parcelRequire("9Ycfw");
function $32886a435f64afcf$var$sortObject(obj) {
    return Object.keys(obj).sort().reduce(function(acc, curr) {
        acc[curr] = obj[curr];
        return acc;
    }, {});
}
var $32886a435f64afcf$var$requestBuilder = {
    /**
   * Get all the queries to send to the client, those queries can used directly
   * with the Algolia client.
   * @private
   * @param  {string} index The name of the index
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object[]} The queries
   */ _getQueries: function getQueries(index, state) {
        var queries = [];
        // One query for the hits
        queries.push({
            indexName: index,
            params: $32886a435f64afcf$var$requestBuilder._getHitsSearchParams(state)
        });
        // One for each disjunctive facets
        state.getRefinedDisjunctiveFacets().forEach(function(refinedFacet) {
            queries.push({
                indexName: index,
                params: $32886a435f64afcf$var$requestBuilder._getDisjunctiveFacetSearchParams(state, refinedFacet)
            });
        });
        // More to get the parent levels of the hierarchical facets when refined
        state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
            var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
            var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            // If we are deeper than level 0 (starting from `beer > IPA`)
            // we want to get all parent values
            if (currentRefinement.length > 0 && currentRefinement[0].split(separator).length > 1) {
                // We generate a map of the filters we will use for our facet values queries
                var filtersMap = currentRefinement[0].split(separator).slice(0, -1).reduce(function createFiltersMap(map, segment, level) {
                    return map.concat({
                        attribute: hierarchicalFacet.attributes[level],
                        value: level === 0 ? segment : [
                            map[map.length - 1].value,
                            segment
                        ].join(separator)
                    });
                }, []);
                filtersMap.forEach(function(filter, level) {
                    var params = $32886a435f64afcf$var$requestBuilder._getDisjunctiveFacetSearchParams(state, filter.attribute, level === 0);
                    // Keep facet filters unrelated to current hierarchical attributes
                    function hasHierarchicalFacetFilter(value) {
                        return hierarchicalFacet.attributes.some(function(attribute) {
                            return attribute === value.split(':')[0];
                        });
                    }
                    var filteredFacetFilters = (params.facetFilters || []).reduce(function(acc, facetFilter) {
                        if (Array.isArray(facetFilter)) {
                            var filtered = facetFilter.filter(function(filterValue) {
                                return !hasHierarchicalFacetFilter(filterValue);
                            });
                            if (filtered.length > 0) acc.push(filtered);
                        }
                        if (typeof facetFilter === 'string' && !hasHierarchicalFacetFilter(facetFilter)) acc.push(facetFilter);
                        return acc;
                    }, []);
                    var parent = filtersMap[level - 1];
                    if (level > 0) params.facetFilters = filteredFacetFilters.concat(parent.attribute + ':' + parent.value);
                    else params.facetFilters = filteredFacetFilters.length > 0 ? filteredFacetFilters : undefined;
                    queries.push({
                        indexName: index,
                        params: params
                    });
                });
            }
        });
        return queries;
    },
    /**
   * Build search parameters used to fetch hits
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object.<string, any>} The search parameters for hits
   */ _getHitsSearchParams: function(state) {
        var facets = state.facets.concat(state.disjunctiveFacets).concat($32886a435f64afcf$var$requestBuilder._getHitsHierarchicalFacetsAttributes(state)).sort();
        var facetFilters = $32886a435f64afcf$var$requestBuilder._getFacetFilters(state);
        var numericFilters = $32886a435f64afcf$var$requestBuilder._getNumericFilters(state);
        var tagFilters = $32886a435f64afcf$var$requestBuilder._getTagFilters(state);
        var additionalParams = {
            facets: facets.indexOf('*') > -1 ? [
                '*'
            ] : facets,
            tagFilters: tagFilters
        };
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        return $32886a435f64afcf$var$sortObject($9Ycfw({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Build search parameters used to fetch a disjunctive facet
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} facet the associated facet name
   * @param  {boolean} hierarchicalRootLevel ?? FIXME
   * @return {object} The search parameters for a disjunctive facet
   */ _getDisjunctiveFacetSearchParams: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = $32886a435f64afcf$var$requestBuilder._getFacetFilters(state, facet, hierarchicalRootLevel);
        var numericFilters = $32886a435f64afcf$var$requestBuilder._getNumericFilters(state, facet);
        var tagFilters = $32886a435f64afcf$var$requestBuilder._getTagFilters(state);
        var additionalParams = {
            hitsPerPage: 0,
            page: 0,
            analytics: false,
            clickAnalytics: false
        };
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        var hierarchicalFacet = state.getHierarchicalFacetByName(facet);
        if (hierarchicalFacet) additionalParams.facets = $32886a435f64afcf$var$requestBuilder._getDisjunctiveHierarchicalFacetAttribute(state, hierarchicalFacet, hierarchicalRootLevel);
        else additionalParams.facets = facet;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        return $32886a435f64afcf$var$sortObject($9Ycfw({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Return the numeric filters in an algolia request fashion
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @param {string} [facetName] the name of the attribute for which the filters should be excluded
   * @return {string[]} the numeric filters in the algolia format
   */ _getNumericFilters: function(state, facetName) {
        if (state.numericFilters) return state.numericFilters;
        var numericFilters = [];
        Object.keys(state.numericRefinements).forEach(function(attribute) {
            var operators = state.numericRefinements[attribute] || {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator] || [];
                if (facetName !== attribute) values.forEach(function(value) {
                    if (Array.isArray(value)) {
                        var vs = value.map(function(v) {
                            return attribute + operator + v;
                        });
                        numericFilters.push(vs);
                    } else numericFilters.push(attribute + operator + value);
                });
            });
        });
        return numericFilters;
    },
    /**
   * Return the tags filters depending on which format is used, either tagFilters or tagRefinements
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @return {string} Tag filters in a single string
   */ _getTagFilters: function(state) {
        if (state.tagFilters) return state.tagFilters;
        return state.tagRefinements.join(',');
    },
    /**
   * Build facetFilters parameter based on current refinements. The array returned
   * contains strings representing the facet filters in the algolia format.
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} [facet] if set, the current disjunctive facet
   * @param  {boolean} [hierarchicalRootLevel] ?? FIXME
   * @return {array.<string>} The facet filters in the algolia format
   */ _getFacetFilters: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = [];
        var facetsRefinements = state.facetsRefinements || {};
        Object.keys(facetsRefinements).sort().forEach(function(facetName) {
            var facetValues = facetsRefinements[facetName] || [];
            facetValues.slice().sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ':' + facetValue);
            });
        });
        var facetsExcludes = state.facetsExcludes || {};
        Object.keys(facetsExcludes).sort().forEach(function(facetName) {
            var facetValues = facetsExcludes[facetName] || [];
            facetValues.sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ':-' + facetValue);
            });
        });
        var disjunctiveFacetsRefinements = state.disjunctiveFacetsRefinements || {};
        Object.keys(disjunctiveFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = disjunctiveFacetsRefinements[facetName] || [];
            if (facetName === facet || !facetValues || facetValues.length === 0) return;
            var orFilters = [];
            facetValues.slice().sort().forEach(function(facetValue) {
                orFilters.push(facetName + ':' + facetValue);
            });
            facetFilters.push(orFilters);
        });
        var hierarchicalFacetsRefinements = state.hierarchicalFacetsRefinements || {};
        Object.keys(hierarchicalFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = hierarchicalFacetsRefinements[facetName] || [];
            var facetValue = facetValues[0];
            if (facetValue === undefined) return;
            var hierarchicalFacet = state.getHierarchicalFacetByName(facetName);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeToRefine;
            var attributesIndex;
            // we ask for parent facet values only when the `facet` is the current hierarchical facet
            if (facet === facetName) {
                // if we are at the root level already, no need to ask for facet values, we get them from
                // the hits query
                if (facetValue.indexOf(separator) === -1 || !rootPath && hierarchicalRootLevel === true || rootPath && rootPath.split(separator).length === facetValue.split(separator).length) return;
                if (!rootPath) {
                    attributesIndex = facetValue.split(separator).length - 2;
                    facetValue = facetValue.slice(0, facetValue.lastIndexOf(separator));
                } else {
                    attributesIndex = rootPath.split(separator).length - 1;
                    facetValue = rootPath;
                }
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            } else {
                attributesIndex = facetValue.split(separator).length - 1;
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            }
            if (attributeToRefine) facetFilters.push([
                attributeToRefine + ':' + facetValue
            ]);
        });
        return facetFilters;
    },
    _getHitsHierarchicalFacetsAttributes: function(state) {
        var out = [];
        return state.hierarchicalFacets.reduce(// ask for as much levels as there's hierarchical refinements
        function getHitsAttributesForHierarchicalFacet(allAttributes, hierarchicalFacet) {
            var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0];
            // if no refinement, ask for root level
            if (!hierarchicalRefinement) {
                allAttributes.push(hierarchicalFacet.attributes[0]);
                return allAttributes;
            }
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var level = hierarchicalRefinement.split(separator).length;
            var newAttributes = hierarchicalFacet.attributes.slice(0, level + 1);
            return allAttributes.concat(newAttributes);
        }, out);
    },
    _getDisjunctiveHierarchicalFacetAttribute: function(state, hierarchicalFacet, rootLevel) {
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        if (rootLevel === true) {
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeIndex = 0;
            if (rootPath) attributeIndex = rootPath.split(separator).length;
            return [
                hierarchicalFacet.attributes[attributeIndex]
            ];
        }
        var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0] || '';
        // if refinement is 'beers > IPA > Flying dog',
        // then we want `facets: ['beers > IPA']` as disjunctive facet (parent level values)
        var parentLevel = hierarchicalRefinement.split(separator).length - 1;
        return hierarchicalFacet.attributes.slice(0, parentLevel + 1);
    },
    getSearchForFacetQuery: function(facetName, query, maxFacetHits, state) {
        var stateForSearchForFacetValues = state.isDisjunctiveFacet(facetName) ? state.clearRefinements(facetName) : state;
        var searchForFacetSearchParameters = {
            facetQuery: query,
            facetName: facetName
        };
        if (typeof maxFacetHits === 'number') searchForFacetSearchParameters.maxFacetHits = maxFacetHits;
        return $32886a435f64afcf$var$sortObject($9Ycfw({}, $32886a435f64afcf$var$requestBuilder._getHitsSearchParams(stateForSearchForFacetValues), searchForFacetSearchParameters));
    }
};
module.exports = $32886a435f64afcf$var$requestBuilder;

});

parcelRegister("ayZKS", function(module, exports) {
'use strict';

var $lvlO6 = parcelRequire("lvlO6");

var $6M10t = parcelRequire("6M10t");

var $1BZHe = parcelRequire("1BZHe");

var $9Ycfw = parcelRequire("9Ycfw");

var $gBL4g = parcelRequire("gBL4g");

var $f2mrx = parcelRequire("f2mrx");

var $cOm0i = parcelRequire("cOm0i");

var $dTPhP = parcelRequire("dTPhP");

var $9vjgU = parcelRequire("9vjgU");
/**
 * isEqual, but only for numeric refinement values, possible values:
 * - 5
 * - [5]
 * - [[5]]
 * - [[5,5],[4]]
 * @param {any} a numeric refinement value
 * @param {any} b numeric refinement value
 * @return {boolean} true if the values are equal
 */ function $7b0cfb9bb8358820$var$isEqualNumericRefinement(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return a.length === b.length && a.every(function(el, i) {
        return $7b0cfb9bb8358820$var$isEqualNumericRefinement(b[i], el);
    });
    return a === b;
}
/**
 * like _.find but using deep equality to be able to use it
 * to find arrays.
 * @private
 * @param {any[]} array array to search into (elements are base or array of base)
 * @param {any} searchedValue the value we're looking for (base or array of base)
 * @return {any} the searched value or undefined
 */ function $7b0cfb9bb8358820$var$findArray(array, searchedValue) {
    return $6M10t(array, function(currentValue) {
        return $7b0cfb9bb8358820$var$isEqualNumericRefinement(currentValue, searchedValue);
    });
}
/**
 * The facet list is the structure used to store the list of values used to
 * filter a single attribute.
 * @typedef {string[]} SearchParameters.FacetList
 */ /**
 * Structure to store numeric filters with the operator as the key. The supported operators
 * are `=`, `>`, `<`, `>=`, `<=` and `!=`.
 * @typedef {Object.<string, Array.<number|number[]>>} SearchParameters.OperatorList
 */ /**
 * SearchParameters is the data structure that contains all the information
 * usable for making a search to Algolia API. It doesn't do the search itself,
 * nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It will
 * be provided when needed. This object is documented for reference as you'll
 * get it from events generated by the {@link AlgoliaSearchHelper}.
 * If need be, instantiate the Helper from the factory function {@link SearchParameters.make}
 * @constructor
 * @classdesc contains all the parameters of a search
 * @param {object|SearchParameters} newParameters existing parameters or partial object
 * for the properties of a new SearchParameters
 * @see SearchParameters.make
 * @example <caption>SearchParameters of the first query in
 *   <a href="http://demos.algolia.com/instant-search-demo/">the instant search demo</a></caption>
{
   "query": "",
   "disjunctiveFacets": [
      "customerReviewCount",
      "category",
      "salePrice_range",
      "manufacturer"
  ],
   "maxValuesPerFacet": 30,
   "page": 0,
   "hitsPerPage": 10,
   "facets": [
      "type",
      "shipping"
  ]
}
 */ function $7b0cfb9bb8358820$var$SearchParameters(newParameters) {
    var params = newParameters ? $7b0cfb9bb8358820$var$SearchParameters._parseNumbers(newParameters) : {};
    if (params.userToken !== undefined && !$dTPhP(params.userToken)) // eslint-disable-next-line no-console
    console.warn('[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}');
    /**
   * This attribute contains the list of all the conjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.facets = params.facets || [];
    /**
   * This attribute contains the list of all the disjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.disjunctiveFacets = params.disjunctiveFacets || [];
    /**
   * This attribute contains the list of all the hierarchical facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * Hierarchical facets are a sub type of disjunctive facets that
   * let you filter faceted attributes hierarchically.
   * @member {string[]|object[]}
   */ this.hierarchicalFacets = params.hierarchicalFacets || [];
    // Refinements
    /**
   * This attribute contains all the filters that need to be
   * applied on the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsRefinements = params.facetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * excluded from the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters excluded for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsExcludes = params.facetsExcludes || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the disjunctive facets. Each facet must be properly
   * defined in the `disjunctiveFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.disjunctiveFacetsRefinements = params.disjunctiveFacetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the numeric attributes.
   *
   * The key is the name of the attribute, and the value is the
   * filters to apply to this attribute.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `numericFilters` attribute.
   * @member {Object.<string, SearchParameters.OperatorList>}
   */ this.numericRefinements = params.numericRefinements || {};
    /**
   * This attribute contains all the tags used to refine the query.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `tagFilters` attribute.
   * @member {string[]}
   */ this.tagRefinements = params.tagRefinements || [];
    /**
   * This attribute contains all the filters that need to be
   * applied on the hierarchical facets. Each facet must be properly
   * defined in the `hierarchicalFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name. The FacetList values
   * are structured as a string that contain the values for each level
   * separated by the configured separator.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.hierarchicalFacetsRefinements = params.hierarchicalFacetsRefinements || {};
    // eslint-disable-next-line consistent-this
    var self = this;
    Object.keys(params).forEach(function(paramName) {
        var isKeyKnown = $7b0cfb9bb8358820$var$SearchParameters.PARAMETERS.indexOf(paramName) !== -1;
        var isValueDefined = params[paramName] !== undefined;
        if (!isKeyKnown && isValueDefined) self[paramName] = params[paramName];
    });
}
/**
 * List all the properties in SearchParameters and therefore all the known Algolia properties
 * This doesn't contain any beta/hidden features.
 * @private
 */ $7b0cfb9bb8358820$var$SearchParameters.PARAMETERS = Object.keys(new $7b0cfb9bb8358820$var$SearchParameters());
/**
 * @private
 * @param {object} partialState full or part of a state
 * @return {object} a new object with the number keys as number
 */ $7b0cfb9bb8358820$var$SearchParameters._parseNumbers = function(partialState) {
    // Do not parse numbers again in SearchParameters, they ought to be parsed already
    if (partialState instanceof $7b0cfb9bb8358820$var$SearchParameters) return partialState;
    var numbers = {};
    var numberKeys = [
        'aroundPrecision',
        'aroundRadius',
        'getRankingInfo',
        'minWordSizefor2Typos',
        'minWordSizefor1Typo',
        'page',
        'maxValuesPerFacet',
        'distinct',
        'minimumAroundRadius',
        'hitsPerPage',
        'minProximity'
    ];
    numberKeys.forEach(function(k) {
        var value = partialState[k];
        if (typeof value === 'string') {
            var parsedValue = parseFloat(value);
            // global isNaN is ok to use here, value is only number or NaN
            numbers[k] = isNaN(parsedValue) ? value : parsedValue;
        }
    });
    // there's two formats of insideBoundingBox, we need to parse
    // the one which is an array of float geo rectangles
    if (Array.isArray(partialState.insideBoundingBox)) numbers.insideBoundingBox = partialState.insideBoundingBox.map(function(geoRect) {
        if (Array.isArray(geoRect)) return geoRect.map(function(value) {
            return parseFloat(value);
        });
        return geoRect;
    });
    if (partialState.numericRefinements) {
        var numericRefinements = {};
        Object.keys(partialState.numericRefinements).forEach(function(attribute) {
            var operators = partialState.numericRefinements[attribute] || {};
            numericRefinements[attribute] = {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator];
                var parsedValues = values.map(function(v) {
                    if (Array.isArray(v)) return v.map(function(vPrime) {
                        if (typeof vPrime === 'string') return parseFloat(vPrime);
                        return vPrime;
                    });
                    else if (typeof v === 'string') return parseFloat(v);
                    return v;
                });
                numericRefinements[attribute][operator] = parsedValues;
            });
        });
        numbers.numericRefinements = numericRefinements;
    }
    return $9Ycfw(partialState, numbers);
};
/**
 * Factory for SearchParameters
 * @param {object|SearchParameters} newParameters existing parameters or partial
 * object for the properties of a new SearchParameters
 * @return {SearchParameters} frozen instance of SearchParameters
 */ $7b0cfb9bb8358820$var$SearchParameters.make = function makeSearchParameters(newParameters) {
    var instance = new $7b0cfb9bb8358820$var$SearchParameters(newParameters);
    var hierarchicalFacets = newParameters.hierarchicalFacets || [];
    hierarchicalFacets.forEach(function(facet) {
        if (facet.rootPath) {
            var currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length > 0 && currentRefinement[0].indexOf(facet.rootPath) !== 0) instance = instance.clearRefinements(facet.name);
            // get it again in case it has been cleared
            currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length === 0) instance = instance.toggleHierarchicalFacetRefinement(facet.name, facet.rootPath);
        }
    });
    return instance;
};
/**
 * Validates the new parameters based on the previous state
 * @param {SearchParameters} currentState the current state
 * @param {object|SearchParameters} parameters the new parameters to set
 * @return {Error|null} Error if the modification is invalid, null otherwise
 */ $7b0cfb9bb8358820$var$SearchParameters.validate = function(currentState, parameters) {
    var params = parameters || {};
    if (currentState.tagFilters && params.tagRefinements && params.tagRefinements.length > 0) return new Error("[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.");
    if (currentState.tagRefinements.length > 0 && params.tagFilters) return new Error("[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.");
    if (currentState.numericFilters && params.numericRefinements && $gBL4g(params.numericRefinements)) return new Error("[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    if ($gBL4g(currentState.numericRefinements) && params.numericFilters) return new Error("[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    return null;
};
$7b0cfb9bb8358820$var$SearchParameters.prototype = {
    constructor: $7b0cfb9bb8358820$var$SearchParameters,
    /**
   * Remove all refinements (disjunctive + conjunctive + excludes + numeric filters)
   * @method
   * @param {undefined|string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {SearchParameters} new instance with filters cleared
   */ clearRefinements: function clearRefinements(attribute) {
        var patch = {
            numericRefinements: this._clearNumericRefinements(attribute),
            facetsRefinements: $9vjgU.clearRefinement(this.facetsRefinements, attribute, 'conjunctiveFacet'),
            facetsExcludes: $9vjgU.clearRefinement(this.facetsExcludes, attribute, 'exclude'),
            disjunctiveFacetsRefinements: $9vjgU.clearRefinement(this.disjunctiveFacetsRefinements, attribute, 'disjunctiveFacet'),
            hierarchicalFacetsRefinements: $9vjgU.clearRefinement(this.hierarchicalFacetsRefinements, attribute, 'hierarchicalFacet')
        };
        if (patch.numericRefinements === this.numericRefinements && patch.facetsRefinements === this.facetsRefinements && patch.facetsExcludes === this.facetsExcludes && patch.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && patch.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements) return this;
        return this.setQueryParameters(patch);
    },
    /**
   * Remove all the refined tags from the SearchParameters
   * @method
   * @return {SearchParameters} new instance with tags cleared
   */ clearTags: function clearTags() {
        if (this.tagFilters === undefined && this.tagRefinements.length === 0) return this;
        return this.setQueryParameters({
            tagFilters: undefined,
            tagRefinements: []
        });
    },
    /**
   * Set the index.
   * @method
   * @param {string} index the index name
   * @return {SearchParameters} new instance
   */ setIndex: function setIndex(index) {
        if (index === this.index) return this;
        return this.setQueryParameters({
            index: index
        });
    },
    /**
   * Query setter
   * @method
   * @param {string} newQuery value for the new query
   * @return {SearchParameters} new instance
   */ setQuery: function setQuery(newQuery) {
        if (newQuery === this.query) return this;
        return this.setQueryParameters({
            query: newQuery
        });
    },
    /**
   * Page setter
   * @method
   * @param {number} newPage new page number
   * @return {SearchParameters} new instance
   */ setPage: function setPage(newPage) {
        if (newPage === this.page) return this;
        return this.setQueryParameters({
            page: newPage
        });
    },
    /**
   * Facets setter
   * The facets are the simple facets, used for conjunctive (and) faceting.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for conjunctive faceting
   * @return {SearchParameters} new instance
   */ setFacets: function setFacets(facets) {
        return this.setQueryParameters({
            facets: facets
        });
    },
    /**
   * Disjunctive facets setter
   * Change the list of disjunctive (or) facets the helper chan handle.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for disjunctive faceting
   * @return {SearchParameters} new instance
   */ setDisjunctiveFacets: function setDisjunctiveFacets(facets) {
        return this.setQueryParameters({
            disjunctiveFacets: facets
        });
    },
    /**
   * HitsPerPage setter
   * Hits per page represents the number of hits retrieved for this query
   * @method
   * @param {number} n number of hits retrieved per page of results
   * @return {SearchParameters} new instance
   */ setHitsPerPage: function setHitsPerPage(n) {
        if (this.hitsPerPage === n) return this;
        return this.setQueryParameters({
            hitsPerPage: n
        });
    },
    /**
   * typoTolerance setter
   * Set the value of typoTolerance
   * @method
   * @param {string} typoTolerance new value of typoTolerance ("true", "false", "min" or "strict")
   * @return {SearchParameters} new instance
   */ setTypoTolerance: function setTypoTolerance(typoTolerance) {
        if (this.typoTolerance === typoTolerance) return this;
        return this.setQueryParameters({
            typoTolerance: typoTolerance
        });
    },
    /**
   * Add a numeric filter for a given attribute
   * When value is an array, they are combined with OR
   * When value is a single value, it will combined with AND
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} operator operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number | number[]} value value of the filter
   * @return {SearchParameters} new instance
   * @example
   * // for price = 50 or 40
   * state.addNumericRefinement('price', '=', [50, 40]);
   * @example
   * // for size = 38 and 40
   * state.addNumericRefinement('size', '=', 38);
   * state.addNumericRefinement('size', '=', 40);
   */ addNumericRefinement: function(attribute, operator, value) {
        var val = $cOm0i(value);
        if (this.isNumericRefined(attribute, operator, val)) return this;
        var mod = $9Ycfw({}, this.numericRefinements);
        mod[attribute] = $9Ycfw({}, mod[attribute]);
        if (mod[attribute][operator]) {
            // Array copy
            mod[attribute][operator] = mod[attribute][operator].slice();
            // Add the element. Concat can't be used here because value can be an array.
            mod[attribute][operator].push(val);
        } else mod[attribute][operator] = [
            val
        ];
        return this.setQueryParameters({
            numericRefinements: mod
        });
    },
    /**
   * Get the list of conjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getConjunctiveRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsRefinements[facetName] || [];
    },
    /**
   * Get the list of disjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getDisjunctiveRefinements: function(facetName) {
        if (!this.isDisjunctiveFacet(facetName)) return [];
        return this.disjunctiveFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of hierarchical refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getHierarchicalRefinement: function(facetName) {
        // we send an array but we currently do not support multiple
        // hierarchicalRefinements for a hierarchicalFacet
        return this.hierarchicalFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of exclude refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getExcludeRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsExcludes[facetName] || [];
    },
    /**
   * Remove all the numeric filter for a given (attribute, operator)
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} [operator] operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number} [number] the value to be removed
   * @return {SearchParameters} new instance
   */ removeNumericRefinement: function(attribute, operator, number) {
        var paramValue = number;
        if (paramValue !== undefined) {
            if (!this.isNumericRefined(attribute, operator, paramValue)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator && $7b0cfb9bb8358820$var$isEqualNumericRefinement(value.val, $cOm0i(paramValue));
                })
            });
        } else if (operator !== undefined) {
            if (!this.isNumericRefined(attribute, operator)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator;
                })
            });
        }
        if (!this.isNumericRefined(attribute)) return this;
        return this.setQueryParameters({
            numericRefinements: this._clearNumericRefinements(function(value, key) {
                return key === attribute;
            })
        });
    },
    /**
   * Get the list of numeric refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {SearchParameters.OperatorList} list of refinements
   */ getNumericRefinements: function(facetName) {
        return this.numericRefinements[facetName] || {};
    },
    /**
   * Return the current refinement for the (attribute, operator)
   * @param {string} attribute attribute in the record
   * @param {string} operator operator applied on the refined values
   * @return {Array.<number|number[]>} refined values
   */ getNumericRefinement: function(attribute, operator) {
        return this.numericRefinements[attribute] && this.numericRefinements[attribute][operator];
    },
    /**
   * Clear numeric filters.
   * @method
   * @private
   * @param {string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {Object.<string, OperatorList>} new numeric refinements
   */ _clearNumericRefinements: function _clearNumericRefinements(attribute) {
        if (attribute === undefined) {
            if (!$gBL4g(this.numericRefinements)) return this.numericRefinements;
            return {};
        } else if (typeof attribute === 'string') return $f2mrx(this.numericRefinements, [
            attribute
        ]);
        else if (typeof attribute === 'function') {
            var hasChanged = false;
            var numericRefinements = this.numericRefinements;
            var newNumericRefinements = Object.keys(numericRefinements).reduce(function(memo, key) {
                var operators = numericRefinements[key];
                var operatorList = {};
                operators = operators || {};
                Object.keys(operators).forEach(function(operator) {
                    var values = operators[operator] || [];
                    var outValues = [];
                    values.forEach(function(value) {
                        var predicateResult = attribute({
                            val: value,
                            op: operator
                        }, key, 'numeric');
                        if (!predicateResult) outValues.push(value);
                    });
                    if (outValues.length !== values.length) hasChanged = true;
                    operatorList[operator] = outValues;
                });
                memo[key] = operatorList;
                return memo;
            }, {});
            if (hasChanged) return newNumericRefinements;
            return this.numericRefinements;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Add a facet to the facets attribute of the helper configuration, if it
   * isn't already present.
   * @method
   * @param {string} facet facet name to add
   * @return {SearchParameters} new instance
   */ addFacet: function addFacet(facet) {
        if (this.isConjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            facets: this.facets.concat([
                facet
            ])
        });
    },
    /**
   * Add a disjunctive facet to the disjunctiveFacets attribute of the helper
   * configuration, if it isn't already present.
   * @method
   * @param {string} facet disjunctive facet name to add
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacet: function addDisjunctiveFacet(facet) {
        if (this.isDisjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.concat([
                facet
            ])
        });
    },
    /**
   * Add a hierarchical facet to the hierarchicalFacets attribute of the helper
   * configuration.
   * @method
   * @param {object} hierarchicalFacet hierarchical facet to add
   * @return {SearchParameters} new instance
   * @throws will throw an error if a hierarchical facet with the same name was already declared
   */ addHierarchicalFacet: function addHierarchicalFacet(hierarchicalFacet) {
        if (this.isHierarchicalFacet(hierarchicalFacet.name)) throw new Error('Cannot declare two hierarchical facets with the same name: `' + hierarchicalFacet.name + '`');
        return this.setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.concat([
                hierarchicalFacet
            ])
        });
    },
    /**
   * Add a refinement on a "normal" facet
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addFacetRefinement: function addFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if ($9vjgU.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $9vjgU.addRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Exclude a value from a "normal" facet
   * @method
   * @param {string} facet attribute to apply the exclusion on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addExcludeRefinement: function addExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if ($9vjgU.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $9vjgU.addRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Adds a refinement on a disjunctive facet.
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacetRefinement: function addDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
        if ($9vjgU.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $9vjgU.addRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * addTagRefinement adds a tag to the list used to filter the results
   * @param {string} tag tag to be added
   * @return {SearchParameters} new instance
   */ addTagRefinement: function addTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.concat(tag)
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Remove a facet from the facets attribute of the helper configuration, if it
   * is present.
   * @method
   * @param {string} facet facet name to remove
   * @return {SearchParameters} new instance
   */ removeFacet: function removeFacet(facet) {
        if (!this.isConjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            facets: this.facets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a disjunctive facet from the disjunctiveFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet disjunctive facet name to remove
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacet: function removeDisjunctiveFacet(facet) {
        if (!this.isDisjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a hierarchical facet from the hierarchicalFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet hierarchical facet name to remove
   * @return {SearchParameters} new instance
   */ removeHierarchicalFacet: function removeHierarchicalFacet(facet) {
        if (!this.isHierarchicalFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.filter(function(f) {
                return f.name !== facet;
            })
        });
    },
    /**
   * Remove a refinement set on facet. If a value is provided, it will clear the
   * refinement for the given value, otherwise it will clear all the refinement
   * values for the faceted attribute.
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} [value] value used to filter
   * @return {SearchParameters} new instance
   */ removeFacetRefinement: function removeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if (!$9vjgU.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $9vjgU.removeRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Remove a negative refinement on a facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeExcludeRefinement: function removeExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if (!$9vjgU.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $9vjgU.removeRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Remove a refinement on a disjunctive facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacetRefinement: function removeDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
        if (!$9vjgU.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $9vjgU.removeRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Remove a tag from the list of tag refinements
   * @method
   * @param {string} tag the tag to remove
   * @return {SearchParameters} new instance
   */ removeTagRefinement: function removeTagRefinement(tag) {
        if (!this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.filter(function(t) {
                return t !== tag;
            })
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   * @deprecated since version 2.19.0, see {@link SearchParameters#toggleFacetRefinement}
   */ toggleRefinement: function toggleRefinement(facet, value) {
        return this.toggleFacetRefinement(facet, value);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   */ toggleFacetRefinement: function toggleFacetRefinement(facet, value) {
        if (this.isHierarchicalFacet(facet)) return this.toggleHierarchicalFacetRefinement(facet, value);
        else if (this.isConjunctiveFacet(facet)) return this.toggleConjunctiveFacetRefinement(facet, value);
        else if (this.isDisjunctiveFacet(facet)) return this.toggleDisjunctiveFacetRefinement(facet, value);
        throw new Error('Cannot refine the undeclared facet ' + facet + '; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets');
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleConjunctiveFacetRefinement: function toggleConjunctiveFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        return this.setQueryParameters({
            facetsRefinements: $9vjgU.toggleRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleExcludeFacetRefinement: function toggleExcludeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        return this.setQueryParameters({
            facetsExcludes: $9vjgU.toggleRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleDisjunctiveFacetRefinement: function toggleDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $9vjgU.toggleRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleHierarchicalFacetRefinement: function toggleHierarchicalFacetRefinement(facet, value) {
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + ' is not defined in the hierarchicalFacets attribute of the helper configuration');
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facet));
        var mod = {};
        var upOneOrMultipleLevel = this.hierarchicalFacetsRefinements[facet] !== undefined && this.hierarchicalFacetsRefinements[facet].length > 0 && // remove current refinement:
        // refinement was 'beer > IPA', call is toggleRefine('beer > IPA'), refinement should be `beer`
        (this.hierarchicalFacetsRefinements[facet][0] === value || // remove a parent refinement of the current refinement:
        //  - refinement was 'beer > IPA > Flying dog'
        //  - call is toggleRefine('beer > IPA')
        //  - refinement should be `beer`
        this.hierarchicalFacetsRefinements[facet][0].indexOf(value + separator) === 0);
        if (upOneOrMultipleLevel) {
            if (value.indexOf(separator) === -1) // go back to root level
            mod[facet] = [];
            else mod[facet] = [
                value.slice(0, value.lastIndexOf(separator))
            ];
        } else mod[facet] = [
            value
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $lvlO6({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Adds a refinement on a hierarchical facet.
   * @param {string} facet the facet name
   * @param {string} path the hierarchical facet path
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is refined
   */ addHierarchicalFacetRefinement: function(facet, path) {
        if (this.isHierarchicalFacetRefined(facet)) throw new Error(facet + ' is already refined.');
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + ' is not defined in the hierarchicalFacets attribute of the helper configuration.');
        var mod = {};
        mod[facet] = [
            path
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $lvlO6({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Removes the refinement set on a hierarchical facet.
   * @param {string} facet the facet name
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is not refined
   */ removeHierarchicalFacetRefinement: function(facet) {
        if (!this.isHierarchicalFacetRefined(facet)) return this;
        var mod = {};
        mod[facet] = [];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $lvlO6({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Switch the tag refinement
   * @method
   * @param {string} tag the tag to remove or add
   * @return {SearchParameters} new instance
   */ toggleTagRefinement: function toggleTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this.removeTagRefinement(tag);
        return this.addTagRefinement(tag);
    },
    /**
   * Test if the facet name is from one of the disjunctive facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a disjunctive facet
   */ isDisjunctiveFacet: function(facet) {
        return this.disjunctiveFacets.indexOf(facet) > -1;
    },
    /**
   * Test if the facet name is from one of the hierarchical facets
   * @method
   * @param {string} facetName facet name to test
   * @return {boolean} true if facetName is a hierarchical facet
   */ isHierarchicalFacet: function(facetName) {
        return this.getHierarchicalFacetByName(facetName) !== undefined;
    },
    /**
   * Test if the facet name is from one of the conjunctive/normal facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a conjunctive facet
   */ isConjunctiveFacet: function(facet) {
        return this.facets.indexOf(facet) > -1;
    },
    /**
   * Returns true if the facet is refined, either for a specific value or in
   * general.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value, optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isFacetRefined: function isFacetRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $9vjgU.isRefined(this.facetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains exclusions or if a specific value is
   * excluded.
   *
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} [value] optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isExcludeRefined: function isExcludeRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $9vjgU.isRefined(this.facetsExcludes, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isDisjunctiveFacetRefined: function isDisjunctiveFacetRefined(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) return false;
        return $9vjgU.isRefined(this.disjunctiveFacetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isHierarchicalFacetRefined: function isHierarchicalFacetRefined(facet, value) {
        if (!this.isHierarchicalFacet(facet)) return false;
        var refinements = this.getHierarchicalRefinement(facet);
        if (!value) return refinements.length > 0;
        return refinements.indexOf(value) !== -1;
    },
    /**
   * Test if the triple (attribute, operator, value) is already refined.
   * If only the attribute and the operator are provided, it tests if the
   * contains any refinement value.
   * @method
   * @param {string} attribute attribute for which the refinement is applied
   * @param {string} [operator] operator of the refinement
   * @param {string} [value] value of the refinement
   * @return {boolean} true if it is refined
   */ isNumericRefined: function isNumericRefined(attribute, operator, value) {
        if (value === undefined && operator === undefined) return Boolean(this.numericRefinements[attribute]);
        var isOperatorDefined = this.numericRefinements[attribute] && this.numericRefinements[attribute][operator] !== undefined;
        if (value === undefined || !isOperatorDefined) return isOperatorDefined;
        var parsedValue = $cOm0i(value);
        var isAttributeValueDefined = $7b0cfb9bb8358820$var$findArray(this.numericRefinements[attribute][operator], parsedValue) !== undefined;
        return isOperatorDefined && isAttributeValueDefined;
    },
    /**
   * Returns true if the tag refined, false otherwise
   * @method
   * @param {string} tag the tag to check
   * @return {boolean} true if tag is refined
   */ isTagRefined: function isTagRefined(tag) {
        return this.tagRefinements.indexOf(tag) !== -1;
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedDisjunctiveFacets: function getRefinedDisjunctiveFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        // attributes used for numeric filter can also be disjunctive
        var disjunctiveNumericRefinedFacets = $1BZHe(Object.keys(this.numericRefinements).filter(function(facet) {
            return Object.keys(self.numericRefinements[facet]).length > 0;
        }), this.disjunctiveFacets);
        return Object.keys(this.disjunctiveFacetsRefinements).filter(function(facet) {
            return self.disjunctiveFacetsRefinements[facet].length > 0;
        }).concat(disjunctiveNumericRefinedFacets).concat(this.getRefinedHierarchicalFacets()).sort();
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedHierarchicalFacets: function getRefinedHierarchicalFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        return $1BZHe(// enforce the order between the two arrays,
        // so that refinement name index === hierarchical facet index
        this.hierarchicalFacets.map(function(facet) {
            return facet.name;
        }), Object.keys(this.hierarchicalFacetsRefinements).filter(function(facet) {
            return self.hierarchicalFacetsRefinements[facet].length > 0;
        })).sort();
    },
    /**
   * Returned the list of all disjunctive facets not refined
   * @method
   * @return {string[]} returns the list of facets that are not refined
   */ getUnrefinedDisjunctiveFacets: function() {
        var refinedFacets = this.getRefinedDisjunctiveFacets();
        return this.disjunctiveFacets.filter(function(f) {
            return refinedFacets.indexOf(f) === -1;
        });
    },
    managedParameters: [
        'index',
        'facets',
        'disjunctiveFacets',
        'facetsRefinements',
        'hierarchicalFacets',
        'facetsExcludes',
        'disjunctiveFacetsRefinements',
        'numericRefinements',
        'tagRefinements',
        'hierarchicalFacetsRefinements'
    ],
    getQueryParams: function getQueryParams() {
        var managedParameters = this.managedParameters;
        var queryParams = {};
        // eslint-disable-next-line consistent-this
        var self = this;
        Object.keys(this).forEach(function(paramName) {
            var paramValue = self[paramName];
            if (managedParameters.indexOf(paramName) === -1 && paramValue !== undefined) queryParams[paramName] = paramValue;
        });
        return queryParams;
    },
    /**
   * Let the user set a specific value for a given parameter. Will return the
   * same instance if the parameter is invalid or if the value is the same as the
   * previous one.
   * @method
   * @param {string} parameter the parameter name
   * @param {any} value the value to be set, must be compliant with the definition
   * of the attribute on the object
   * @return {SearchParameters} the updated state
   */ setQueryParameter: function setParameter(parameter, value) {
        if (this[parameter] === value) return this;
        var modification = {};
        modification[parameter] = value;
        return this.setQueryParameters(modification);
    },
    /**
   * Let the user set any of the parameters with a plain object.
   * @method
   * @param {object} params all the keys and the values to be updated
   * @return {SearchParameters} a new updated instance
   */ setQueryParameters: function setQueryParameters(params) {
        if (!params) return this;
        var error = $7b0cfb9bb8358820$var$SearchParameters.validate(this, params);
        if (error) throw error;
        // eslint-disable-next-line consistent-this
        var self = this;
        var nextWithNumbers = $7b0cfb9bb8358820$var$SearchParameters._parseNumbers(params);
        var previousPlainObject = Object.keys(this).reduce(function(acc, key) {
            acc[key] = self[key];
            return acc;
        }, {});
        var nextPlainObject = Object.keys(nextWithNumbers).reduce(function(previous, key) {
            var isPreviousValueDefined = previous[key] !== undefined;
            var isNextValueDefined = nextWithNumbers[key] !== undefined;
            if (isPreviousValueDefined && !isNextValueDefined) return $f2mrx(previous, [
                key
            ]);
            if (isNextValueDefined) previous[key] = nextWithNumbers[key];
            return previous;
        }, previousPlainObject);
        return new this.constructor(nextPlainObject);
    },
    /**
   * Returns a new instance with the page reset. Two scenarios possible:
   * the page is omitted -> return the given instance
   * the page is set -> return a new instance with a page of 0
   * @return {SearchParameters} a new updated instance
   */ resetPage: function() {
        if (this.page === undefined) return this;
        return this.setPage(0);
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSortBy: function(hierarchicalFacet) {
        return hierarchicalFacet.sortBy || [
            'isRefined:desc',
            'name:asc'
        ];
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSeparator: function(hierarchicalFacet) {
        return hierarchicalFacet.separator || ' > ';
    },
    /**
   * Helper function to get the hierarchicalFacet prefix path or null
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.rootPath or null as default
   */ _getHierarchicalRootPath: function(hierarchicalFacet) {
        return hierarchicalFacet.rootPath || null;
    },
    /**
   * Helper function to check if we show the parent level of the hierarchicalFacet
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.showParentLevel or true as default
   */ _getHierarchicalShowParentLevel: function(hierarchicalFacet) {
        if (typeof hierarchicalFacet.showParentLevel === 'boolean') return hierarchicalFacet.showParentLevel;
        return true;
    },
    /**
   * Helper function to get the hierarchicalFacet by it's name
   * @param  {string} hierarchicalFacetName the hierarchicalFacet name
   * @return {object} a hierarchicalFacet
   */ getHierarchicalFacetByName: function(hierarchicalFacetName) {
        return $6M10t(this.hierarchicalFacets, function(f) {
            return f.name === hierarchicalFacetName;
        });
    },
    /**
   * Get the current breadcrumb for a hierarchical facet, as an array
   * @param  {string} facetName Hierarchical facet name
   * @return {array.<string>} the path as an array of string
   */ getHierarchicalFacetBreadcrumb: function(facetName) {
        if (!this.isHierarchicalFacet(facetName)) return [];
        var refinement = this.getHierarchicalRefinement(facetName)[0];
        if (!refinement) return [];
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facetName));
        var path = refinement.split(separator);
        return path.map(function(part) {
            return part.trim();
        });
    },
    toString: function() {
        return JSON.stringify(this, null, 2);
    }
};
/**
 * Callback used for clearRefinement method
 * @callback SearchParameters.clearCallback
 * @param {OperatorList|FacetList} value the value of the filter
 * @param {string} key the current attribute name
 * @param {string} type `numeric`, `disjunctiveFacet`, `conjunctiveFacet`, `hierarchicalFacet` or `exclude`
 * depending on the type of facet
 * @return {boolean} `true` if the element should be removed. `false` otherwise.
 */ module.exports = $7b0cfb9bb8358820$var$SearchParameters;

});
parcelRegister("lvlO6", function(module, exports) {
'use strict';
// NOTE: this behaves like lodash/defaults, but doesn't mutate the target
// it also preserve keys order
module.exports = function defaultsPure() {
    var sources = Array.prototype.slice.call(arguments);
    return sources.reduceRight(function(acc, source) {
        Object.keys(Object(source)).forEach(function(key) {
            if (source[key] === undefined) return;
            if (acc[key] !== undefined) // remove if already added, so that we can add it in correct order
            delete acc[key];
            acc[key] = source[key];
        });
        return acc;
    }, {});
};

});

parcelRegister("6M10t", function(module, exports) {
'use strict';
// @MAJOR can be replaced by native Array#find when we change support
module.exports = function find(array, comparator) {
    if (!Array.isArray(array)) return undefined;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return array[i];
    }
    return undefined;
};

});

parcelRegister("1BZHe", function(module, exports) {
'use strict';
function $12c91abf9cec5c80$var$intersection(arr1, arr2) {
    return arr1.filter(function(value, index) {
        return arr2.indexOf(value) > -1 && arr1.indexOf(value) === index /* skips duplicates */ ;
    });
}
module.exports = $12c91abf9cec5c80$var$intersection;

});

parcelRegister("cOm0i", function(module, exports) {
'use strict';
function $953b39058f46ab96$var$valToNumber(v) {
    if (typeof v === 'number') return v;
    else if (typeof v === 'string') return parseFloat(v);
    else if (Array.isArray(v)) return v.map($953b39058f46ab96$var$valToNumber);
    throw new Error('The value should be a number, a parsable string or an array of those.');
}
module.exports = $953b39058f46ab96$var$valToNumber;

});

parcelRegister("dTPhP", function(module, exports) {
'use strict';
module.exports = function isValidUserToken(userToken) {
    if (userToken === null) return false;
    return /^[a-zA-Z0-9_-]{1,64}$/.test(userToken);
};

});

parcelRegister("9vjgU", function(module, exports) {
'use strict';

var $lvlO6 = parcelRequire("lvlO6");

var $gBL4g = parcelRequire("gBL4g");

var $f2mrx = parcelRequire("f2mrx");
var $6eb5f54997bc1815$var$lib = {
    /**
   * Adds a refinement to a RefinementList
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement, if the value is not a string it will be converted
   * @return {RefinementList} a new and updated refinement list
   */ addRefinement: function addRefinement(refinementList, attribute, value) {
        if ($6eb5f54997bc1815$var$lib.isRefined(refinementList, attribute, value)) return refinementList;
        var valueAsString = '' + value;
        var facetRefinement = !refinementList[attribute] ? [
            valueAsString
        ] : refinementList[attribute].concat(valueAsString);
        var mod = {};
        mod[attribute] = facetRefinement;
        return $lvlO6({}, mod, refinementList);
    },
    /**
   * Removes refinement(s) for an attribute:
   *  - if the value is specified removes the refinement for the value on the attribute
   *  - if no value is specified removes all the refinements for this attribute
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} [value] the value of the refinement
   * @return {RefinementList} a new and updated refinement lst
   */ removeRefinement: function removeRefinement(refinementList, attribute, value) {
        if (value === undefined) // we use the "filter" form of clearRefinement, since it leaves empty values as-is
        // the form with a string will remove the attribute completely
        return $6eb5f54997bc1815$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f;
        });
        var valueAsString = '' + value;
        return $6eb5f54997bc1815$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f && valueAsString === v;
        });
    },
    /**
   * Toggles the refinement value for an attribute.
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement
   * @return {RefinementList} a new and updated list
   */ toggleRefinement: function toggleRefinement(refinementList, attribute, value) {
        if (value === undefined) throw new Error('toggleRefinement should be used with a value');
        if ($6eb5f54997bc1815$var$lib.isRefined(refinementList, attribute, value)) return $6eb5f54997bc1815$var$lib.removeRefinement(refinementList, attribute, value);
        return $6eb5f54997bc1815$var$lib.addRefinement(refinementList, attribute, value);
    },
    /**
   * Clear all or parts of a RefinementList. Depending on the arguments, three
   * kinds of behavior can happen:
   *  - if no attribute is provided: clears the whole list
   *  - if an attribute is provided as a string: clears the list for the specific attribute
   *  - if an attribute is provided as a function: discards the elements for which the function returns true
   * @param {RefinementList} refinementList the initial list
   * @param {string} [attribute] the attribute or function to discard
   * @param {string} [refinementType] optional parameter to give more context to the attribute function
   * @return {RefinementList} a new and updated refinement list
   */ clearRefinement: function clearRefinement(refinementList, attribute, refinementType) {
        if (attribute === undefined) {
            // return the same object if the list is already empty
            // this is mainly for tests, as it doesn't have much impact on performance
            if (!$gBL4g(refinementList)) return refinementList;
            return {};
        } else if (typeof attribute === 'string') return $f2mrx(refinementList, [
            attribute
        ]);
        else if (typeof attribute === 'function') {
            var hasChanged = false;
            var newRefinementList = Object.keys(refinementList).reduce(function(memo, key) {
                var values = refinementList[key] || [];
                var facetList = values.filter(function(value) {
                    return !attribute(value, key, refinementType);
                });
                if (facetList.length !== values.length) hasChanged = true;
                memo[key] = facetList;
                return memo;
            }, {});
            if (hasChanged) return newRefinementList;
            return refinementList;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Test if the refinement value is used for the attribute. If no refinement value
   * is provided, test if the refinementList contains any refinement for the
   * given attribute.
   * @param {RefinementList} refinementList the list of refinement
   * @param {string} attribute name of the attribute
   * @param {string} [refinementValue] value of the filter/refinement
   * @return {boolean} true if the attribute is refined, false otherwise
   */ isRefined: function isRefined(refinementList, attribute, refinementValue) {
        var containsRefinements = Boolean(refinementList[attribute]) && refinementList[attribute].length > 0;
        if (refinementValue === undefined || !containsRefinements) return containsRefinements;
        var refinementValueAsString = '' + refinementValue;
        return refinementList[attribute].indexOf(refinementValueAsString) !== -1;
    }
};
module.exports = $6eb5f54997bc1815$var$lib;

});


parcelRegister("iT6vY", function(module, exports) {
'use strict';

var $1M9rg = parcelRequire("1M9rg");

var $lvlO6 = parcelRequire("lvlO6");

var $gAun0 = parcelRequire("gAun0");

var $6M10t = parcelRequire("6M10t");

var $3Z29k = parcelRequire("3Z29k");

var $9dcSn = parcelRequire("9dcSn");

var $9Ycfw = parcelRequire("9Ycfw");

var $99J3D = parcelRequire("99J3D");
var $dc026abaa84ecadf$var$escapeFacetValue = $gAun0.escapeFacetValue;
var $dc026abaa84ecadf$var$unescapeFacetValue = $gAun0.unescapeFacetValue;

var $hvjOY = parcelRequire("hvjOY");
/**
 * @typedef SearchResults.Facet
 * @type {object}
 * @property {string} name name of the attribute in the record
 * @property {object} data the faceting data: value, number of entries
 * @property {object} stats undefined unless facet_stats is retrieved from algolia
 */ /**
 * @typedef SearchResults.HierarchicalFacet
 * @type {object}
 * @property {string} name name of the current value given the hierarchical level, trimmed.
 * If root node, you get the facet name
 * @property {number} count number of objects matching this hierarchical value
 * @property {string} path the current hierarchical value full path
 * @property {boolean} isRefined `true` if the current value was refined, `false` otherwise
 * @property {HierarchicalFacet[]} data sub values for the current level
 */ /**
 * @typedef SearchResults.FacetValue
 * @type {object}
 * @property {string} name the facet value itself
 * @property {number} count times this facet appears in the results
 * @property {boolean} isRefined is the facet currently selected
 * @property {boolean} isExcluded is the facet currently excluded (only for conjunctive facets)
 */ /**
 * @typedef Refinement
 * @type {object}
 * @property {string} type the type of filter used:
 * `numeric`, `facet`, `exclude`, `disjunctive`, `hierarchical`
 * @property {string} attributeName name of the attribute used for filtering
 * @property {string} name the value of the filter
 * @property {number} numericValue the value as a number. Only for numeric filters.
 * @property {string} operator the operator used. Only for numeric filters.
 * @property {number} count the number of computed hits for this filter. Only on facets.
 * @property {boolean} exhaustive if the count is exhaustive
 */ /**
 * Turn an array of attributes in an object of attributes with their position in the array as value
 * @param {string[]} attributes the list of attributes in the record
 * @return {object} the list of attributes indexed by attribute name
 */ function $dc026abaa84ecadf$var$getIndices(attributes) {
    var indices = {};
    attributes.forEach(function(val, idx) {
        indices[val] = idx;
    });
    return indices;
}
function $dc026abaa84ecadf$var$assignFacetStats(dest, facetStats, key) {
    if (facetStats && facetStats[key]) dest.stats = facetStats[key];
}
/**
 * @typedef {Object} HierarchicalFacet
 * @property {string} name
 * @property {string[]} attributes
 */ /**
 * @param {HierarchicalFacet[]} hierarchicalFacets All hierarchical facets
 * @param {string} hierarchicalAttributeName The name of the hierarchical attribute
 * @return {HierarchicalFacet} The hierarchical facet matching the attribute name
 */ function $dc026abaa84ecadf$var$findMatchingHierarchicalFacetFromAttributeName(hierarchicalFacets, hierarchicalAttributeName) {
    return $6M10t(hierarchicalFacets, function facetKeyMatchesAttribute(hierarchicalFacet) {
        var facetNames = hierarchicalFacet.attributes || [];
        return facetNames.indexOf(hierarchicalAttributeName) > -1;
    });
}
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {SearchParameters} state state that led to the response
 * @param {array.<object>} results the results from algolia client
 * @param {object} options options to control results content
 * @example <caption>SearchResults of the first query in
 * <a href="http://demos.algolia.com/instant-search-demo">the instant search demo</a></caption>
{
   "hitsPerPage": 10,
   "processingTimeMS": 2,
   "facets": [
      {
         "name": "type",
         "data": {
            "HardGood": 6627,
            "BlackTie": 550,
            "Music": 665,
            "Software": 131,
            "Game": 456,
            "Movie": 1571
         },
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "Free shipping": 5507
         },
         "name": "shipping"
      }
  ],
   "hits": [
      {
         "thumbnailImage": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_54x108_s.gif",
         "_highlightResult": {
            "shortDescription": {
               "matchLevel": "none",
               "value": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
               "matchedWords": []
            },
            "category": {
               "matchLevel": "none",
               "value": "Computer Security Software",
               "matchedWords": []
            },
            "manufacturer": {
               "matchedWords": [],
               "value": "Webroot",
               "matchLevel": "none"
            },
            "name": {
               "value": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
               "matchedWords": [],
               "matchLevel": "none"
            }
         },
         "image": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_105x210_sc.jpg",
         "shipping": "Free shipping",
         "bestSellingRank": 4,
         "shortDescription": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
         "url": "http://www.bestbuy.com/site/webroot-secureanywhere-internet-security-3-devi…d=1219060687969&skuId=1688832&cmp=RMX&ky=2d3GfEmNIzjA0vkzveHdZEBgpPCyMnLTJ",
         "name": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
         "category": "Computer Security Software",
         "salePrice_range": "1 - 50",
         "objectID": "1688832",
         "type": "Software",
         "customerReviewCount": 5980,
         "salePrice": 49.99,
         "manufacturer": "Webroot"
      },
      ....
  ],
   "nbHits": 10000,
   "disjunctiveFacets": [
      {
         "exhaustive": false,
         "data": {
            "5": 183,
            "12": 112,
            "7": 149,
            ...
         },
         "name": "customerReviewCount",
         "stats": {
            "max": 7461,
            "avg": 157.939,
            "min": 1
         }
      },
      {
         "data": {
            "Printer Ink": 142,
            "Wireless Speakers": 60,
            "Point & Shoot Cameras": 48,
            ...
         },
         "name": "category",
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "> 5000": 2,
            "1 - 50": 6524,
            "501 - 2000": 566,
            "201 - 500": 1501,
            "101 - 200": 1360,
            "2001 - 5000": 47
         },
         "name": "salePrice_range"
      },
      {
         "data": {
            "Dynex™": 202,
            "Insignia™": 230,
            "PNY": 72,
            ...
         },
         "name": "manufacturer",
         "exhaustive": false
      }
  ],
   "query": "",
   "nbPages": 100,
   "page": 0,
   "index": "bestbuy"
}
 **/ function $dc026abaa84ecadf$var$SearchResults(state, results, options) {
    var mainSubResponse = results[0];
    this._rawResults = results;
    // eslint-disable-next-line consistent-this
    var self = this;
    // https://www.algolia.com/doc/api-reference/api-methods/search/#response
    Object.keys(mainSubResponse).forEach(function(key) {
        self[key] = mainSubResponse[key];
    });
    // Make every key of the result options reachable from the instance
    var opts = $9Ycfw({
        persistHierarchicalRootCount: false
    }, options);
    Object.keys(opts).forEach(function(key) {
        self[key] = opts[key];
    });
    /**
   * query used to generate the results
   * @name query
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * The query as parsed by the engine given all the rules.
   * @name parsedQuery
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * all the records that match the search parameters. Each record is
   * augmented with a new attribute `_highlightResult`
   * which is an object keyed by attribute and with the following properties:
   * - `value` : the value of the facet highlighted (html)
   * - `matchLevel`: `full`, `partial` or `none`, depending on how the query terms match
   * @name hits
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * index where the results come from
   * @name index
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * number of hits per page requested
   * @name hitsPerPage
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of hits of this query on the index
   * @name nbHits
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of pages with respect to the number of hits per page and the total number of hits
   * @name nbPages
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * current page
   * @name page
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * The position if the position was guessed by IP.
   * @name aroundLatLng
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "48.8637,2.3615",
   */ /**
   * The radius computed by Algolia.
   * @name automaticRadius
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "126792922",
   */ /**
   * String identifying the server used to serve this request.
   *
   * getRankingInfo needs to be set to `true` for this to be returned
   *
   * @name serverUsed
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "c7-use-2.algolia.net",
   */ /**
   * Boolean that indicates if the computation of the counts did time out.
   * @deprecated
   * @name timeoutCounts
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Boolean that indicates if the computation of the hits did time out.
   * @deprecated
   * @name timeoutHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the counts of the facets is exhaustive
   * @name exhaustiveFacetsCount
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the number of hits is exhaustive
   * @name exhaustiveNbHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Contains the userData if they are set by a [query rule](https://www.algolia.com/doc/guides/query-rules/query-rules-overview/).
   * @name userData
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * queryID is the unique identifier of the query used to generate the current search results.
   * This value is only available if the `clickAnalytics` search parameter is set to `true`.
   * @name queryID
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * sum of the processing time of all the queries
   * @name processingTimeMS
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ this.processingTimeMS = results.reduce(function(sum, result) {
        return result.processingTimeMS === undefined ? sum : sum + result.processingTimeMS;
    }, 0);
    /**
   * disjunctive facets results
   * @member {SearchResults.Facet[]}
   */ this.disjunctiveFacets = [];
    /**
   * disjunctive facets results
   * @member {SearchResults.HierarchicalFacet[]}
   */ this.hierarchicalFacets = state.hierarchicalFacets.map(function initFutureTree() {
        return [];
    });
    /**
   * other facets results
   * @member {SearchResults.Facet[]}
   */ this.facets = [];
    var disjunctiveFacets = state.getRefinedDisjunctiveFacets();
    var facetsIndices = $dc026abaa84ecadf$var$getIndices(state.facets);
    var disjunctiveFacetsIndices = $dc026abaa84ecadf$var$getIndices(state.disjunctiveFacets);
    var nextDisjunctiveResult = 1;
    // Since we send request only for disjunctive facets that have been refined,
    // we get the facets information from the first, general, response.
    var mainFacets = mainSubResponse.facets || {};
    Object.keys(mainFacets).forEach(function(facetKey) {
        var facetValueObject = mainFacets[facetKey];
        var hierarchicalFacet = $dc026abaa84ecadf$var$findMatchingHierarchicalFacetFromAttributeName(state.hierarchicalFacets, facetKey);
        if (hierarchicalFacet) {
            // Place the hierarchicalFacet data at the correct index depending on
            // the attributes order that was defined at the helper initialization
            var facetIndex = hierarchicalFacet.attributes.indexOf(facetKey);
            var idxAttributeName = $3Z29k(state.hierarchicalFacets, function(f) {
                return f.name === hierarchicalFacet.name;
            });
            self.hierarchicalFacets[idxAttributeName][facetIndex] = {
                attribute: facetKey,
                data: facetValueObject,
                exhaustive: mainSubResponse.exhaustiveFacetsCount
            };
        } else {
            var isFacetDisjunctive = state.disjunctiveFacets.indexOf(facetKey) !== -1;
            var isFacetConjunctive = state.facets.indexOf(facetKey) !== -1;
            var position;
            if (isFacetDisjunctive) {
                position = disjunctiveFacetsIndices[facetKey];
                self.disjunctiveFacets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $dc026abaa84ecadf$var$assignFacetStats(self.disjunctiveFacets[position], mainSubResponse.facets_stats, facetKey);
            }
            if (isFacetConjunctive) {
                position = facetsIndices[facetKey];
                self.facets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $dc026abaa84ecadf$var$assignFacetStats(self.facets[position], mainSubResponse.facets_stats, facetKey);
            }
        }
    });
    // Make sure we do not keep holes within the hierarchical facets
    this.hierarchicalFacets = $1M9rg(this.hierarchicalFacets);
    // aggregate the refined disjunctive facets
    disjunctiveFacets.forEach(function(disjunctiveFacet) {
        var result = results[nextDisjunctiveResult];
        var facets = result && result.facets ? result.facets : {};
        var hierarchicalFacet = state.getHierarchicalFacetByName(disjunctiveFacet);
        // There should be only item in facets.
        Object.keys(facets).forEach(function(dfacet) {
            var facetResults = facets[dfacet];
            var position;
            if (hierarchicalFacet) {
                position = $3Z29k(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $3Z29k(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                self.hierarchicalFacets[position][attributeIndex].data = $9Ycfw({}, self.hierarchicalFacets[position][attributeIndex].data, facetResults);
            } else {
                position = disjunctiveFacetsIndices[dfacet];
                var dataFromMainRequest = mainSubResponse.facets && mainSubResponse.facets[dfacet] || {};
                self.disjunctiveFacets[position] = {
                    name: dfacet,
                    data: $lvlO6({}, facetResults, dataFromMainRequest),
                    exhaustive: result.exhaustiveFacetsCount
                };
                $dc026abaa84ecadf$var$assignFacetStats(self.disjunctiveFacets[position], result.facets_stats, dfacet);
                if (state.disjunctiveFacetsRefinements[dfacet]) state.disjunctiveFacetsRefinements[dfacet].forEach(function(refinementValue) {
                    // add the disjunctive refinements if it is no more retrieved
                    if (!self.disjunctiveFacets[position].data[refinementValue] && state.disjunctiveFacetsRefinements[dfacet].indexOf($dc026abaa84ecadf$var$unescapeFacetValue(refinementValue)) > -1) self.disjunctiveFacets[position].data[refinementValue] = 0;
                });
            }
        });
        nextDisjunctiveResult++;
    });
    // if we have some parent level values for hierarchical facets, merge them
    state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
        var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
        // if we are already at a root refinement (or no refinement at all), there is no
        // root level values request
        if (currentRefinement.length === 0 || currentRefinement[0].split(separator).length < 2) return;
        results.slice(nextDisjunctiveResult).forEach(function(result) {
            var facets = result && result.facets ? result.facets : {};
            Object.keys(facets).forEach(function(dfacet) {
                var facetResults = facets[dfacet];
                var position = $3Z29k(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $3Z29k(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                // when we always get root levels, if the hits refinement is `beers > IPA` (count: 5),
                // then the disjunctive values will be `beers` (count: 100),
                // but we do not want to display
                //   | beers (100)
                //     > IPA (5)
                // We want
                //   | beers (5)
                //     > IPA (5)
                // @MAJOR: remove this legacy behaviour in next major version
                var defaultData = {};
                if (currentRefinement.length > 0 && !self.persistHierarchicalRootCount) {
                    var root = currentRefinement[0].split(separator)[0];
                    defaultData[root] = self.hierarchicalFacets[position][attributeIndex].data[root];
                }
                self.hierarchicalFacets[position][attributeIndex].data = $lvlO6(defaultData, facetResults, self.hierarchicalFacets[position][attributeIndex].data);
            });
            nextDisjunctiveResult++;
        });
    });
    // add the excludes
    Object.keys(state.facetsExcludes).forEach(function(facetName) {
        var excludes = state.facetsExcludes[facetName];
        var position = facetsIndices[facetName];
        self.facets[position] = {
            name: facetName,
            data: mainFacets[facetName],
            exhaustive: mainSubResponse.exhaustiveFacetsCount
        };
        excludes.forEach(function(facetValue) {
            self.facets[position] = self.facets[position] || {
                name: facetName
            };
            self.facets[position].data = self.facets[position].data || {};
            self.facets[position].data[facetValue] = 0;
        });
    });
    /**
   * @type {Array}
   */ this.hierarchicalFacets = this.hierarchicalFacets.map($hvjOY(state));
    /**
   * @type {Array}
   */ this.facets = $1M9rg(this.facets);
    /**
   * @type {Array}
   */ this.disjunctiveFacets = $1M9rg(this.disjunctiveFacets);
    this._state = state;
}
/**
 * Get a facet object with its name
 * @deprecated
 * @param {string} name name of the faceted attribute
 * @return {SearchResults.Facet} the facet object
 */ $dc026abaa84ecadf$var$SearchResults.prototype.getFacetByName = function(name) {
    function predicate(facet) {
        return facet.name === name;
    }
    return $6M10t(this.facets, predicate) || $6M10t(this.disjunctiveFacets, predicate) || $6M10t(this.hierarchicalFacets, predicate);
};
/**
 * Get the facet values of a specified attribute from a SearchResults object.
 * @private
 * @param {SearchResults} results the search results to search in
 * @param {string} attribute name of the faceted attribute to search for
 * @return {array|object} facet values. For the hierarchical facets it is an object.
 */ function $dc026abaa84ecadf$var$extractNormalizedFacetValues(results, attribute) {
    function predicate(facet) {
        return facet.name === attribute;
    }
    if (results._state.isConjunctiveFacet(attribute)) {
        var facet = $6M10t(results.facets, predicate);
        if (!facet) return [];
        return Object.keys(facet.data).map(function(name) {
            var value = $dc026abaa84ecadf$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: facet.data[name],
                isRefined: results._state.isFacetRefined(attribute, value),
                isExcluded: results._state.isExcludeRefined(attribute, name)
            };
        });
    } else if (results._state.isDisjunctiveFacet(attribute)) {
        var disjunctiveFacet = $6M10t(results.disjunctiveFacets, predicate);
        if (!disjunctiveFacet) return [];
        return Object.keys(disjunctiveFacet.data).map(function(name) {
            var value = $dc026abaa84ecadf$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: disjunctiveFacet.data[name],
                isRefined: results._state.isDisjunctiveFacetRefined(attribute, value)
            };
        });
    } else if (results._state.isHierarchicalFacet(attribute)) {
        var hierarchicalFacetValues = $6M10t(results.hierarchicalFacets, predicate);
        if (!hierarchicalFacetValues) return hierarchicalFacetValues;
        var hierarchicalFacet = results._state.getHierarchicalFacetByName(attribute);
        var separator = results._state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = $dc026abaa84ecadf$var$unescapeFacetValue(results._state.getHierarchicalRefinement(attribute)[0] || '');
        if (currentRefinement.indexOf(hierarchicalFacet.rootPath) === 0) currentRefinement = currentRefinement.replace(hierarchicalFacet.rootPath + separator, '');
        var currentRefinementSplit = currentRefinement.split(separator);
        currentRefinementSplit.unshift(attribute);
        $dc026abaa84ecadf$var$setIsRefined(hierarchicalFacetValues, currentRefinementSplit, 0);
        return hierarchicalFacetValues;
    }
    return undefined;
}
/**
 * Set the isRefined of a hierarchical facet result based on the current state.
 * @param {SearchResults.HierarchicalFacet} item Hierarchical facet to fix
 * @param {string[]} currentRefinement array of parts of the current hierarchical refinement
 * @param {number} depth recursion depth in the currentRefinement
 * @return {undefined} function mutates the item
 */ function $dc026abaa84ecadf$var$setIsRefined(item, currentRefinement, depth) {
    item.isRefined = item.name === (currentRefinement[depth] && currentRefinement[depth].trim());
    if (item.data) item.data.forEach(function(child) {
        $dc026abaa84ecadf$var$setIsRefined(child, currentRefinement, depth + 1);
    });
}
/**
 * Sort nodes of a hierarchical or disjunctive facet results
 * @private
 * @param {function} sortFn sort function to apply
 * @param {HierarchicalFacet|Array} node node upon which we want to apply the sort
 * @param {string[]} names attribute names
 * @param {number} [level=0] current index in the names array
 * @return {HierarchicalFacet|Array} sorted node
 */ function $dc026abaa84ecadf$var$recSort(sortFn, node, names, level) {
    level = level || 0;
    if (Array.isArray(node)) return sortFn(node, names[level]);
    if (!node.data || node.data.length === 0) return node;
    var children = node.data.map(function(childNode) {
        return $dc026abaa84ecadf$var$recSort(sortFn, childNode, names, level + 1);
    });
    var sortedChildren = sortFn(children, names[level]);
    var newNode = $lvlO6({
        data: sortedChildren
    }, node);
    return newNode;
}
$dc026abaa84ecadf$var$SearchResults.DEFAULT_SORT = [
    'isRefined:desc',
    'count:desc',
    'name:asc'
];
function $dc026abaa84ecadf$var$vanillaSortFn(order, data) {
    return data.sort(order);
}
/**
 * @typedef FacetOrdering
 * @type {Object}
 * @property {string[]} [order]
 * @property {'count' | 'alpha' | 'hidden'} [sortRemainingBy]
 */ /**
 * Sorts facet arrays via their facet ordering
 * @param {Array} facetValues the values
 * @param {FacetOrdering} facetOrdering the ordering
 * @returns {Array} the sorted facet values
 */ function $dc026abaa84ecadf$var$sortViaFacetOrdering(facetValues, facetOrdering) {
    var orderedFacets = [];
    var remainingFacets = [];
    var order = facetOrdering.order || [];
    /**
   * an object with the keys being the values in order, the values their index:
   * ['one', 'two'] -> { one: 0, two: 1 }
   */ var reverseOrder = order.reduce(function(acc, name, i) {
        acc[name] = i;
        return acc;
    }, {});
    facetValues.forEach(function(item) {
        // hierarchical facets get sorted using their raw name
        var name = item.path || item.name;
        if (reverseOrder[name] !== undefined) orderedFacets[reverseOrder[name]] = item;
        else remainingFacets.push(item);
    });
    orderedFacets = orderedFacets.filter(function(facet) {
        return facet;
    });
    var sortRemainingBy = facetOrdering.sortRemainingBy;
    var ordering;
    if (sortRemainingBy === 'hidden') return orderedFacets;
    else if (sortRemainingBy === 'alpha') ordering = [
        [
            'path',
            'name'
        ],
        [
            'asc',
            'asc'
        ]
    ];
    else ordering = [
        [
            'count'
        ],
        [
            'desc'
        ]
    ];
    return orderedFacets.concat($99J3D(remainingFacets, ordering[0], ordering[1]));
}
/**
 * @param {SearchResults} results the search results class
 * @param {string} attribute the attribute to retrieve ordering of
 * @returns {FacetOrdering | undefined} the facet ordering
 */ function $dc026abaa84ecadf$var$getFacetOrdering(results, attribute) {
    return results.renderingContent && results.renderingContent.facetOrdering && results.renderingContent.facetOrdering.values && results.renderingContent.facetOrdering.values[attribute];
}
/**
 * Get a the list of values for a given facet attribute. Those values are sorted
 * refinement first, descending count (bigger value on top), and name ascending
 * (alphabetical order). The sort formula can overridden using either string based
 * predicates or a function.
 *
 * This method will return all the values returned by the Algolia engine plus all
 * the values already refined. This means that it can happen that the
 * `maxValuesPerFacet` [configuration](https://www.algolia.com/doc/rest-api/search#param-maxValuesPerFacet)
 * might not be respected if you have facet values that are already refined.
 * @param {string} attribute attribute name
 * @param {object} opts configuration options.
 * @param {boolean} [opts.facetOrdering]
 * Force the use of facetOrdering from the result if a sortBy is present. If
 * sortBy isn't present, facetOrdering will be used automatically.
 * @param {Array.<string> | function} opts.sortBy
 * When using strings, it consists of
 * the name of the [FacetValue](#SearchResults.FacetValue) or the
 * [HierarchicalFacet](#SearchResults.HierarchicalFacet) attributes with the
 * order (`asc` or `desc`). For example to order the value by count, the
 * argument would be `['count:asc']`.
 *
 * If only the attribute name is specified, the ordering defaults to the one
 * specified in the default value for this attribute.
 *
 * When not specified, the order is
 * ascending.  This parameter can also be a function which takes two facet
 * values and should return a number, 0 if equal, 1 if the first argument is
 * bigger or -1 otherwise.
 *
 * The default value for this attribute `['isRefined:desc', 'count:desc', 'name:asc']`
 * @return {FacetValue[]|HierarchicalFacet|undefined} depending on the type of facet of
 * the attribute requested (hierarchical, disjunctive or conjunctive)
 * @example
 * helper.on('result', function(event){
 *   //get values ordered only by name ascending using the string predicate
 *   event.results.getFacetValues('city', {sortBy: ['name:asc']});
 *   //get values  ordered only by count ascending using a function
 *   event.results.getFacetValues('city', {
 *     // this is equivalent to ['count:asc']
 *     sortBy: function(a, b) {
 *       if (a.count === b.count) return 0;
 *       if (a.count > b.count)   return 1;
 *       if (b.count > a.count)   return -1;
 *     }
 *   });
 * });
 */ $dc026abaa84ecadf$var$SearchResults.prototype.getFacetValues = function(attribute, opts) {
    var facetValues = $dc026abaa84ecadf$var$extractNormalizedFacetValues(this, attribute);
    if (!facetValues) return undefined;
    var options = $lvlO6({}, opts, {
        sortBy: $dc026abaa84ecadf$var$SearchResults.DEFAULT_SORT,
        // if no sortBy is given, attempt to sort based on facetOrdering
        // if it is given, we still allow to sort via facet ordering first
        facetOrdering: !(opts && opts.sortBy)
    });
    // eslint-disable-next-line consistent-this
    var results = this;
    var attributes;
    if (Array.isArray(facetValues)) attributes = [
        attribute
    ];
    else {
        var config = results._state.getHierarchicalFacetByName(facetValues.name);
        attributes = config.attributes;
    }
    return $dc026abaa84ecadf$var$recSort(function(data, facetName) {
        if (options.facetOrdering) {
            var facetOrdering = $dc026abaa84ecadf$var$getFacetOrdering(results, facetName);
            if (facetOrdering) return $dc026abaa84ecadf$var$sortViaFacetOrdering(data, facetOrdering);
        }
        if (Array.isArray(options.sortBy)) {
            var order = $9dcSn(options.sortBy, $dc026abaa84ecadf$var$SearchResults.DEFAULT_SORT);
            return $99J3D(data, order[0], order[1]);
        } else if (typeof options.sortBy === 'function') return $dc026abaa84ecadf$var$vanillaSortFn(options.sortBy, data);
        throw new Error("options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function");
    }, facetValues, attributes);
};
/**
 * Returns the facet stats if attribute is defined and the facet contains some.
 * Otherwise returns undefined.
 * @param {string} attribute name of the faceted attribute
 * @return {object} The stats of the facet
 */ $dc026abaa84ecadf$var$SearchResults.prototype.getFacetStats = function(attribute) {
    if (this._state.isConjunctiveFacet(attribute)) return $dc026abaa84ecadf$var$getFacetStatsIfAvailable(this.facets, attribute);
    else if (this._state.isDisjunctiveFacet(attribute)) return $dc026abaa84ecadf$var$getFacetStatsIfAvailable(this.disjunctiveFacets, attribute);
    return undefined;
};
/**
 * @typedef {Object} FacetListItem
 * @property {string} name
 */ /**
 * @param {FacetListItem[]} facetList (has more items, but enough for here)
 * @param {string} facetName The attribute to look for
 * @return {object|undefined} The stats of the facet
 */ function $dc026abaa84ecadf$var$getFacetStatsIfAvailable(facetList, facetName) {
    var data = $6M10t(facetList, function(facet) {
        return facet.name === facetName;
    });
    return data && data.stats;
}
/**
 * Returns all refinements for all filters + tags. It also provides
 * additional information: count and exhaustiveness for each filter.
 *
 * See the [refinement type](#Refinement) for an exhaustive view of the available
 * data.
 *
 * Note that for a numeric refinement, results are grouped per operator, this
 * means that it will return responses for operators which are empty.
 *
 * @return {Array.<Refinement>} all the refinements
 */ $dc026abaa84ecadf$var$SearchResults.prototype.getRefinements = function() {
    var state = this._state;
    // eslint-disable-next-line consistent-this
    var results = this;
    var res = [];
    Object.keys(state.facetsRefinements).forEach(function(attributeName) {
        state.facetsRefinements[attributeName].forEach(function(name) {
            res.push($dc026abaa84ecadf$var$getRefinement(state, 'facet', attributeName, name, results.facets));
        });
    });
    Object.keys(state.facetsExcludes).forEach(function(attributeName) {
        state.facetsExcludes[attributeName].forEach(function(name) {
            res.push($dc026abaa84ecadf$var$getRefinement(state, 'exclude', attributeName, name, results.facets));
        });
    });
    Object.keys(state.disjunctiveFacetsRefinements).forEach(function(attributeName) {
        state.disjunctiveFacetsRefinements[attributeName].forEach(function(name) {
            res.push($dc026abaa84ecadf$var$getRefinement(state, 'disjunctive', attributeName, name, results.disjunctiveFacets));
        });
    });
    Object.keys(state.hierarchicalFacetsRefinements).forEach(function(attributeName) {
        state.hierarchicalFacetsRefinements[attributeName].forEach(function(name) {
            res.push($dc026abaa84ecadf$var$getHierarchicalRefinement(state, attributeName, name, results.hierarchicalFacets));
        });
    });
    Object.keys(state.numericRefinements).forEach(function(attributeName) {
        var operators = state.numericRefinements[attributeName];
        Object.keys(operators).forEach(function(operator) {
            operators[operator].forEach(function(value) {
                res.push({
                    type: 'numeric',
                    attributeName: attributeName,
                    name: value,
                    numericValue: value,
                    operator: operator
                });
            });
        });
    });
    state.tagRefinements.forEach(function(name) {
        res.push({
            type: 'tag',
            attributeName: '_tags',
            name: name
        });
    });
    return res;
};
/**
 * @typedef {Object} Facet
 * @property {string} name
 * @property {Object} data
 * @property {boolean} exhaustive
 */ /**
 * @param {SearchParameters} state the current state
 * @param {string} type the type of the refinement
 * @param {string} attributeName The attribute of the facet
 * @param {*} name The name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {Refinement} the refinement
 */ function $dc026abaa84ecadf$var$getRefinement(state, type, attributeName, name, resultsFacets) {
    var facet = $6M10t(resultsFacets, function(f) {
        return f.name === attributeName;
    });
    var count = facet && facet.data && facet.data[name] ? facet.data[name] : 0;
    var exhaustive = facet && facet.exhaustive || false;
    return {
        type: type,
        attributeName: attributeName,
        name: name,
        count: count,
        exhaustive: exhaustive
    };
}
/**
 * @param {SearchParameters} state the current state
 * @param {string} attributeName the attribute of the hierarchical facet
 * @param {string} name the name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {HierarchicalFacet} the hierarchical facet
 */ function $dc026abaa84ecadf$var$getHierarchicalRefinement(state, attributeName, name, resultsFacets) {
    var facetDeclaration = state.getHierarchicalFacetByName(attributeName);
    var separator = state._getHierarchicalFacetSeparator(facetDeclaration);
    var split = name.split(separator);
    var rootFacet = $6M10t(resultsFacets, function(facet) {
        return facet.name === attributeName;
    });
    var facet = split.reduce(function(intermediateFacet, part) {
        var newFacet = intermediateFacet && $6M10t(intermediateFacet.data, function(f) {
            return f.name === part;
        });
        return newFacet !== undefined ? newFacet : intermediateFacet;
    }, rootFacet);
    var count = facet && facet.count || 0;
    var exhaustive = facet && facet.exhaustive || false;
    var path = facet && facet.path || '';
    return {
        type: 'hierarchical',
        attributeName: attributeName,
        name: path,
        count: count,
        exhaustive: exhaustive
    };
}
module.exports = $dc026abaa84ecadf$var$SearchResults;

});
parcelRegister("1M9rg", function(module, exports) {
'use strict';
module.exports = function compact(array) {
    if (!Array.isArray(array)) return [];
    return array.filter(Boolean);
};

});

parcelRegister("3Z29k", function(module, exports) {
'use strict';
// @MAJOR can be replaced by native Array#findIndex when we change support
module.exports = function find(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
};

});

parcelRegister("9dcSn", function(module, exports) {
'use strict';

var $6M10t = parcelRequire("6M10t");
/**
 * Transform sort format from user friendly notation to lodash format
 * @param {string[]} sortBy array of predicate of the form "attribute:order"
 * @param {string[]} [defaults] array of predicate of the form "attribute:order"
 * @return {array.<string[]>} array containing 2 elements : attributes, orders
 */ module.exports = function formatSort(sortBy, defaults) {
    var defaultInstructions = (defaults || []).map(function(sort) {
        return sort.split(':');
    });
    return sortBy.reduce(function preparePredicate(out, sort) {
        var sortInstruction = sort.split(':');
        var matchingDefault = $6M10t(defaultInstructions, function(defaultInstruction) {
            return defaultInstruction[0] === sortInstruction[0];
        });
        if (sortInstruction.length > 1 || !matchingDefault) {
            out[0].push(sortInstruction[0]);
            out[1].push(sortInstruction[1]);
            return out;
        }
        out[0].push(matchingDefault[0]);
        out[1].push(matchingDefault[1]);
        return out;
    }, [
        [],
        []
    ]);
};

});

parcelRegister("99J3D", function(module, exports) {
'use strict';
function $6aa7e7d427fde895$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined;
        var valIsNull = value === null;
        var othIsDefined = other !== undefined;
        var othIsNull = other === null;
        if (!othIsNull && value > other || valIsNull && othIsDefined || !valIsDefined) return 1;
        if (!valIsNull && value < other || othIsNull && valIsDefined || !othIsDefined) return -1;
    }
    return 0;
}
/**
 * @param {Array<object>} collection object with keys in attributes
 * @param {Array<string>} iteratees attributes
 * @param {Array<string>} orders asc | desc
 * @return {Array<object>} sorted collection
 */ function $6aa7e7d427fde895$var$orderBy(collection, iteratees, orders) {
    if (!Array.isArray(collection)) return [];
    if (!Array.isArray(orders)) orders = [];
    var result = collection.map(function(value, index) {
        return {
            criteria: iteratees.map(function(iteratee) {
                return value[iteratee];
            }),
            index: index,
            value: value
        };
    });
    result.sort(function comparer(object, other) {
        var index = -1;
        while(++index < object.criteria.length){
            var res = $6aa7e7d427fde895$var$compareAscending(object.criteria[index], other.criteria[index]);
            if (res) {
                if (index >= orders.length) return res;
                if (orders[index] === 'desc') return -res;
                return res;
            }
        }
        // This ensures a stable sort in V8 and other engines.
        // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
        return object.index - other.index;
    });
    return result.map(function(res) {
        return res.value;
    });
}
module.exports = $6aa7e7d427fde895$var$orderBy;

});

parcelRegister("hvjOY", function(module, exports) {
'use strict';
module.exports = $cbe4b4fac1c4e1bf$var$generateTrees;

var $gAun0 = parcelRequire("gAun0");

var $6M10t = parcelRequire("6M10t");

var $9dcSn = parcelRequire("9dcSn");

var $99J3D = parcelRequire("99J3D");
var $cbe4b4fac1c4e1bf$var$escapeFacetValue = $gAun0.escapeFacetValue;
var $cbe4b4fac1c4e1bf$var$unescapeFacetValue = $gAun0.unescapeFacetValue;
function $cbe4b4fac1c4e1bf$var$generateTrees(state) {
    return function generate(hierarchicalFacetResult, hierarchicalFacetIndex) {
        var hierarchicalFacet = state.hierarchicalFacets[hierarchicalFacetIndex];
        var hierarchicalFacetRefinement = state.hierarchicalFacetsRefinements[hierarchicalFacet.name] && state.hierarchicalFacetsRefinements[hierarchicalFacet.name][0] || '';
        var hierarchicalSeparator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var hierarchicalRootPath = state._getHierarchicalRootPath(hierarchicalFacet);
        var hierarchicalShowParentLevel = state._getHierarchicalShowParentLevel(hierarchicalFacet);
        var sortBy = $9dcSn(state._getHierarchicalFacetSortBy(hierarchicalFacet));
        var rootExhaustive = hierarchicalFacetResult.every(function(facetResult) {
            return facetResult.exhaustive;
        });
        var generateTreeFn = $cbe4b4fac1c4e1bf$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, hierarchicalFacetRefinement);
        var results = hierarchicalFacetResult;
        if (hierarchicalRootPath) results = hierarchicalFacetResult.slice(hierarchicalRootPath.split(hierarchicalSeparator).length);
        return results.reduce(generateTreeFn, {
            name: state.hierarchicalFacets[hierarchicalFacetIndex].name,
            count: null,
            isRefined: true,
            path: null,
            escapedValue: null,
            exhaustive: rootExhaustive,
            data: null
        });
    };
}
function $cbe4b4fac1c4e1bf$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, currentRefinement) {
    return function generateTree(hierarchicalTree, hierarchicalFacetResult, currentHierarchicalLevel) {
        var parent = hierarchicalTree;
        if (currentHierarchicalLevel > 0) {
            var level = 0;
            parent = hierarchicalTree;
            while(level < currentHierarchicalLevel){
                /**
         * @type {object[]]} hierarchical data
         */ var data = parent && Array.isArray(parent.data) ? parent.data : [];
                parent = $6M10t(data, function(subtree) {
                    return subtree.isRefined;
                });
                level++;
            }
        }
        // we found a refined parent, let's add current level data under it
        if (parent) {
            // filter values in case an object has multiple categories:
            //   {
            //     categories: {
            //       level0: ['beers', 'bières'],
            //       level1: ['beers > IPA', 'bières > Belges']
            //     }
            //   }
            //
            // If parent refinement is `beers`, then we do not want to have `bières > Belges`
            // showing up
            var picked = Object.keys(hierarchicalFacetResult.data).map(function(facetValue) {
                return [
                    facetValue,
                    hierarchicalFacetResult.data[facetValue]
                ];
            }).filter(function(tuple) {
                var facetValue = tuple[0];
                return $cbe4b4fac1c4e1bf$var$onlyMatchingTree(facetValue, parent.path || hierarchicalRootPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel);
            });
            parent.data = $99J3D(picked.map(function(tuple) {
                var facetValue = tuple[0];
                var facetCount = tuple[1];
                return $cbe4b4fac1c4e1bf$var$format(facetCount, facetValue, hierarchicalSeparator, $cbe4b4fac1c4e1bf$var$unescapeFacetValue(currentRefinement), hierarchicalFacetResult.exhaustive);
            }), sortBy[0], sortBy[1]);
        }
        return hierarchicalTree;
    };
}
// eslint-disable-next-line max-params
function $cbe4b4fac1c4e1bf$var$onlyMatchingTree(facetValue, parentPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel) {
    // we want the facetValue is a child of hierarchicalRootPath
    if (hierarchicalRootPath && (facetValue.indexOf(hierarchicalRootPath) !== 0 || hierarchicalRootPath === facetValue)) return false;
    // we always want root levels (only when there is no prefix path)
    return !hierarchicalRootPath && facetValue.indexOf(hierarchicalSeparator) === -1 || // if there is a rootPath, being root level mean 1 level under rootPath
    hierarchicalRootPath && facetValue.split(hierarchicalSeparator).length - hierarchicalRootPath.split(hierarchicalSeparator).length === 1 || // if current refinement is a root level and current facetValue is a root level,
    // keep the facetValue
    facetValue.indexOf(hierarchicalSeparator) === -1 && currentRefinement.indexOf(hierarchicalSeparator) === -1 || // currentRefinement is a child of the facet value
    currentRefinement.indexOf(facetValue) === 0 || // facetValue is a child of the current parent, add it
    facetValue.indexOf(parentPath + hierarchicalSeparator) === 0 && (hierarchicalShowParentLevel || facetValue.indexOf(currentRefinement) === 0);
}
function $cbe4b4fac1c4e1bf$var$format(facetCount, facetValue, hierarchicalSeparator, currentRefinement, exhaustive) {
    var parts = facetValue.split(hierarchicalSeparator);
    return {
        name: parts[parts.length - 1].trim(),
        path: facetValue,
        escapedValue: $cbe4b4fac1c4e1bf$var$escapeFacetValue(facetValue),
        count: facetCount,
        isRefined: currentRefinement === facetValue || currentRefinement.indexOf(facetValue + hierarchicalSeparator) === 0,
        exhaustive: exhaustive,
        data: null
    };
}

});


parcelRegister("gktCn", function(module, exports) {
'use strict';

var $6M10t = parcelRequire("6M10t");

var $hF4Jd = parcelRequire("hF4Jd");
function $be357d1a68401e51$var$getAverageIndices(indexTracker, nrOfObjs) {
    var avgIndices = [];
    Object.keys(indexTracker).forEach(function(key) {
        if (indexTracker[key].count < 2) indexTracker[key].indexSum += 100;
        avgIndices.push({
            objectID: key,
            avgOfIndices: indexTracker[key].indexSum / nrOfObjs
        });
    });
    return avgIndices.sort(function(a, b) {
        return a.avgOfIndices > b.avgOfIndices ? 1 : -1;
    });
}
function $be357d1a68401e51$var$sortAndMergeRecommendations(results) {
    var indexTracker = {};
    results.forEach(function(hits) {
        hits.forEach(function(hit, index) {
            if (!indexTracker[hit.objectID]) indexTracker[hit.objectID] = {
                indexSum: index,
                count: 1
            };
            else indexTracker[hit.objectID] = {
                indexSum: indexTracker[hit.objectID].indexSum + index,
                count: indexTracker[hit.objectID].count + 1
            };
        });
    });
    var sortedAverageIndices = $be357d1a68401e51$var$getAverageIndices(indexTracker, results.length);
    var finalOrder = sortedAverageIndices.reduce(function(orderedHits, avgIndexRef) {
        var result = $6M10t($hF4Jd(results), function(hit) {
            return hit.objectID === avgIndexRef.objectID;
        });
        return result ? orderedHits.concat(result) : orderedHits;
    }, []);
    return finalOrder;
}
module.exports = $be357d1a68401e51$var$sortAndMergeRecommendations;

});
parcelRegister("hF4Jd", function(module, exports) {
// @MAJOR: remove this function and use Array.prototype.flat
module.exports = function flat(arr) {
    return arr.reduce(function(acc, val) {
        return acc.concat(val);
    }, []);
};

});


parcelRegister("hxPkP", function(module, exports) {
'use strict';
module.exports = '3.21.0';

});




parcelRegister("5TJaP", function(module, exports) {
$parcel$export(module.exports, "Result", function () { return (parcelRequire("aLBZ0")).Result; });
parcelRequire("8Agh0");
parcelRequire("fJkKo");
parcelRequire("aLBZ0");

});
parcelRegister("aLBZ0", function(module, exports) {
$parcel$export(module.exports, "Result", function () { return $ecaa9cd46efbd293$export$8fdcabde73f49165; });
/* result.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $eY3N6 = parcelRequire("eY3N6");

var $bNzAT = parcelRequire("bNzAT");
const $ecaa9cd46efbd293$export$8fdcabde73f49165 = ({ index: index, title: title, description: description, href: href, objectId: objectId, queryId: queryId, onSearchLinkClick: onSearchLinkClick, isExperimentVariant: isExperimentVariant = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const decodeHtml = (html)=>{
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    };
    const handleSearchResultClick = (objectId, index, linkUrl, queryId)=>{
        onSearchLinkClick(objectId, index);
        createAnalyticsEvent({
            eventName: "searchResult",
            eventType: "ui",
            action: "clicked",
            actionSubject: "linkButton",
            actionSubjectId: "searchResults",
            source: "searchPage",
            eventContainer: "searchResults",
            attributes: {
                product: "search",
                objectId: objectId,
                linkUrl: linkUrl,
                rank: index,
                queryId: queryId
            }
        }).fire();
    };
    const isNonVariantFirstResult = !isExperimentVariant && index === 0;
    const isNonVariantOtherResult = !isExperimentVariant && index !== 0;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            isExperimentVariant && "_1bsb1osq _1rjcf6fq _1ilv7vkz _133i1crf",
            isNonVariantFirstResult && "_1rjc1ul9 _1bsb1osq _133io7ao",
            isNonVariantOtherResult && "_1rjc1ul9 _1bsb1osq _mqm2k7bd _133io7ao"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $bNzAT.default)("color.neutral.light0"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                "data-testid": `result-id-${index}`,
                href: href,
                onClick: (event)=>{
                    const relativeUrlPath = href.split("https://www.atlassian.com")[1] || href;
                    handleSearchResultClick(objectId, index + 1, href, queryId);
                    event.preventDefault();
                    window.location.href = relativeUrlPath;
                },
                className: (0, $2jatx.default)([
                    isExperimentVariant && "_syaz17la _179rokh7 _1e0c1o8l _30l31ep1 _10531q5l _vlg11368",
                    !isExperimentVariant && "_syaz17la _179rokh7 _1e0c1o8l _15em3pt6 _1053cm6p _yoqs1a2i"
                ]),
                style: {
                    "--_1r6llbg": (0, $6ZVlx.default)((0, $bNzAT.default)("color.primary.blue")),
                    "--_1pjqntz": (0, $6ZVlx.default)((0, $bNzAT.default)("color.extended.blue800")),
                    "--_jv9otz": (0, $6ZVlx.default)((0, $bNzAT.default)("color.extended.purple800")),
                    "--_5re7s0": (0, $6ZVlx.default)((0, $bNzAT.default)("color.extended.purple900")),
                    "--_1fb7i9d": (0, $6ZVlx.default)((0, $bNzAT.default)("color.primary.purple"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                    className: (0, $2jatx.default)([
                        isExperimentVariant && "_1mouidpf _1wyb1tcg _1cqsgktf _1bys1ou6",
                        !isExperimentVariant && "_1mouidpf _1wyb1k92 _1cqs1j6v"
                    ]),
                    children: decodeHtml(title)
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    isExperimentVariant && "_1e0c1ule _syaz18q9 _1wyb7vkz _vwz41tcg _1mou1ynf _1cqsdlk8 _1bysgktf",
                    !isExperimentVariant && "_1e0c1ule _syaz18q9 _1wybdlk8 _vwz4gktf _1mou1ynf"
                ]),
                style: {
                    "--_nmjf06": (0, $6ZVlx.default)((0, $bNzAT.default)("color.secondary.navy"))
                },
                children: decodeHtml(description)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    isExperimentVariant && "_1e0c1ule _syazmmjq _1wybdlk8 _vwz4gktf _slp31hna",
                    !isExperimentVariant && "_1e0c1ule _syazefi9 _1wyb1crf _vwz4gktf _sugaglyw"
                ]),
                style: {
                    "--_1ayut75": (0, $6ZVlx.default)((0, $bNzAT.default)("color.neutral.light500")),
                    "--_19aes6n": (0, $6ZVlx.default)((0, $bNzAT.default)("color.neutral.dark700"))
                },
                children: href
            })
        ]
    });
};
const $ecaa9cd46efbd293$var$resultContainerCss = null;
const $ecaa9cd46efbd293$var$resultContainerTopCss = null;
const $ecaa9cd46efbd293$var$variantResultContainerCss = null;
const $ecaa9cd46efbd293$var$resultLinkCss = null;
const $ecaa9cd46efbd293$var$variantResultLinkCss = null;
const $ecaa9cd46efbd293$var$variantResultLinkTextCss = null;
const $ecaa9cd46efbd293$var$resultLinkTextCss = null;
const $ecaa9cd46efbd293$var$variantResultDescriptionCss = null;
const $ecaa9cd46efbd293$var$resultDescriptionCss = null;
const $ecaa9cd46efbd293$var$variantResultUrlCss = null;
const $ecaa9cd46efbd293$var$resultUrlCss = null;

});





//# sourceMappingURL=index.99b20cf1.js.map
